webpackJsonp([1],{

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_App_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_glide_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_glide_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_glide_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_glide_js_dist_vue_glide_css__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_glide_js_dist_vue_glide_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_glide_js_dist_vue_glide_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_notification_service__ = __webpack_require__(80);























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_glide_js___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('spanishDate', function (value) {
    if (value == null) {
        return 'No definido';
    }
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(String(value)).format('DD/MM/YYYY');
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('spanishTime', function (value) {
    if (value == null) {
        return 'No definido';
    }
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(String(value)).format('hh:mm A');
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('spanishDateTime', function (value) {
    if (value == null) {
        return 'No definido';
    }
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(String(value)).format('DD/MM/YYYY - HH:mm');
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('cardinalityUpper', function (number) {
    switch (number) {
        case 1:

            return 'primera'.toUpperCase();
        case 2:

            return 'segunda'.toUpperCase();
        case 3:

            return 'tercera'.toUpperCase();

        default:
            return 'primera'.toUpperCase();
    }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('cardinality', function (number) {
    switch (number) {
        case 1:

            return 'primera';
        case 2:

            return 'segunda';
        case 3:

            return 'tercera';

        default:
            return 'primera';
    }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('currency', function (value) {
    return Number(Math.round(parseFloat(value) + 'e2') + 'e-2').toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_12__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_12__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_12__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_12__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('digitsonly', {
    bind: function bind(el, binding, vnode) {
        el.addEventListener('keydown', function (e) {

            if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 || e.keyCode === 65 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 67 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 88 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
                return;
            }

            if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('digitsonly-cellphone', {
    bind: function bind(el, binding, vnode) {
        el.addEventListener('keydown', function (e) {
            console.log("En digits only");
            console.log(e.keyCode);

            if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 || e.keyCode === 65 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 67 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 88 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
                return;
            }

            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57) && e.keyCode != 107) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('floatonly', {
    bind: function bind(el, binding, vnode) {
        el.addEventListener('keydown', function (e) {
            if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 || e.keyCode === 65 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 67 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 88 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
                return;
            }

            if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_axios___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
    mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_9__routes__["a" /* default */],
    linkExactActiveClass: 'active',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return savedPosition || {
            x: 0,
            y: 0
        };
    }
});

function nextFactory(context, middleware, index) {
    var subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) return context.next;

    return function () {
        context.next.apply(context, arguments);

        var nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    };
}

router.beforeEach(function (to, from, next) {
    console.log('Entrando a middleware');
    console.log(to.path);

    if (to.meta.middleware) {
        console.log('Encontro el middleware');

        var middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        var context = {
            from: from,
            next: next,
            router: router,
            to: to
        };
        var nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    }
    console.log('No encontro middleware');
    return next();
});


__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], router);

if (window.localStorage) {
    var localUserString = window.localStorage.getItem('user') || 'null';
    var localUser = JSON.parse(localUserString);
    console.log('Handle refreshes');

    console.log(localUser);

    if (localUser && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.user !== localUser) {

        console.log("Existe un User en el LocalStorage");

        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_USER', localUser);
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
        console.log("Vamos a traer notificaciones");

        __WEBPACK_IMPORTED_MODULE_16__services_notification_service__["a" /* notificationService */].getCurrentNotifications(localUser.attributes.profile.id, null);
    } else {
        console.log("No hay User en el LocalStorage");
    }
}

var eventBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#root',
    router: router,
    store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_13__components_App_vue___default.a);
    }
});

window.bugsnagClient = window.bugsnag('02fe1c2caaf5874c50b6ee19534f5932');
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]));

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commentsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var commentsService = {
  listCommentsByOrderId: function listCommentsByOrderId(orderId, callback) {
    var url = "https://backendbutiko.com" + '/api/comments/list-by-order/' + orderId;
    console.log(url);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      console.log(response.data);
      if (response.data.status) {
        var comments = response.data.body;
        callback(comments);
      } else {
        alert('Error de servicio');
      }
    }).catch(function (errors) {
      console.log(errors);
      console.log(errors.response);
      alert('Error de servidor');
      return;
    });
  },
  createComment: function createComment(commentData) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/comments/register';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, commentData).then(function (response) {
                if (response.data.status) {
                  var commentCreated = response.data.body;
                  console.log(commentCreated);

                  return true;
                } else {
                  alert('Error de servicio');
                  return false;
                }
              }).catch(function (errors) {
                console.log(errors);
                console.log(errors.response);
                alert('Error de conexión al servidor');
                return false;
              });

            case 3:
              res = _context.sent;
              return _context.abrupt('return', res);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updateComment: function updateComment(id, commentData) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/comments/' + id + '/update';
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, commentData).then(function (response) {
                if (response.data.status) {
                  var commentUpdated = response.data.body;
                  console.log('Comment updated:');

                  console.log(commentUpdated);

                  return true;
                } else {
                  alert('Error de servicio');
                  return false;
                }
              }).catch(function (errors) {
                console.log(errors);
                console.log(errors.response);
                alert('Error de conexión al servidor');
                return false;
              });

            case 3:
              res = _context2.sent;
              return _context2.abrupt('return', res);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  deleteComment: function deleteComment(id) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/comments/' + id + '/delete';
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(url, {}).then(function (response) {
                if (response.data.status) {
                  var deleteReponse = response.data.body;
                  console.log(deleteReponse);

                  return true;
                } else {
                  alert('Error de servicio');
                  return false;
                }
              }).catch(function (errors) {
                console.log(errors);
                console.log(errors.response);
                alert('Error de conexión al servidor');
                return false;
              });

            case 3:
              res = _context3.sent;
              return _context3.abrupt('return', res);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1906),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(609);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ 1760:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 338,
	"./af.js": 338,
	"./ar": 346,
	"./ar-dz": 339,
	"./ar-dz.js": 339,
	"./ar-kw": 340,
	"./ar-kw.js": 340,
	"./ar-ly": 341,
	"./ar-ly.js": 341,
	"./ar-ma": 342,
	"./ar-ma.js": 342,
	"./ar-ps": 343,
	"./ar-ps.js": 343,
	"./ar-sa": 344,
	"./ar-sa.js": 344,
	"./ar-tn": 345,
	"./ar-tn.js": 345,
	"./ar.js": 346,
	"./az": 347,
	"./az.js": 347,
	"./be": 348,
	"./be.js": 348,
	"./bg": 349,
	"./bg.js": 349,
	"./bm": 350,
	"./bm.js": 350,
	"./bn": 352,
	"./bn-bd": 351,
	"./bn-bd.js": 351,
	"./bn.js": 352,
	"./bo": 353,
	"./bo.js": 353,
	"./br": 354,
	"./br.js": 354,
	"./bs": 355,
	"./bs.js": 355,
	"./ca": 356,
	"./ca.js": 356,
	"./cs": 357,
	"./cs.js": 357,
	"./cv": 358,
	"./cv.js": 358,
	"./cy": 359,
	"./cy.js": 359,
	"./da": 360,
	"./da.js": 360,
	"./de": 363,
	"./de-at": 361,
	"./de-at.js": 361,
	"./de-ch": 362,
	"./de-ch.js": 362,
	"./de.js": 363,
	"./dv": 364,
	"./dv.js": 364,
	"./el": 365,
	"./el.js": 365,
	"./en-au": 366,
	"./en-au.js": 366,
	"./en-ca": 367,
	"./en-ca.js": 367,
	"./en-gb": 368,
	"./en-gb.js": 368,
	"./en-ie": 369,
	"./en-ie.js": 369,
	"./en-il": 370,
	"./en-il.js": 370,
	"./en-in": 371,
	"./en-in.js": 371,
	"./en-nz": 372,
	"./en-nz.js": 372,
	"./en-sg": 373,
	"./en-sg.js": 373,
	"./eo": 374,
	"./eo.js": 374,
	"./es": 378,
	"./es-do": 375,
	"./es-do.js": 375,
	"./es-mx": 376,
	"./es-mx.js": 376,
	"./es-us": 377,
	"./es-us.js": 377,
	"./es.js": 378,
	"./et": 379,
	"./et.js": 379,
	"./eu": 380,
	"./eu.js": 380,
	"./fa": 381,
	"./fa.js": 381,
	"./fi": 382,
	"./fi.js": 382,
	"./fil": 383,
	"./fil.js": 383,
	"./fo": 384,
	"./fo.js": 384,
	"./fr": 387,
	"./fr-ca": 385,
	"./fr-ca.js": 385,
	"./fr-ch": 386,
	"./fr-ch.js": 386,
	"./fr.js": 387,
	"./fy": 388,
	"./fy.js": 388,
	"./ga": 389,
	"./ga.js": 389,
	"./gd": 390,
	"./gd.js": 390,
	"./gl": 391,
	"./gl.js": 391,
	"./gom-deva": 392,
	"./gom-deva.js": 392,
	"./gom-latn": 393,
	"./gom-latn.js": 393,
	"./gu": 394,
	"./gu.js": 394,
	"./he": 395,
	"./he.js": 395,
	"./hi": 396,
	"./hi.js": 396,
	"./hr": 397,
	"./hr.js": 397,
	"./hu": 398,
	"./hu.js": 398,
	"./hy-am": 399,
	"./hy-am.js": 399,
	"./id": 400,
	"./id.js": 400,
	"./is": 401,
	"./is.js": 401,
	"./it": 403,
	"./it-ch": 402,
	"./it-ch.js": 402,
	"./it.js": 403,
	"./ja": 404,
	"./ja.js": 404,
	"./jv": 405,
	"./jv.js": 405,
	"./ka": 406,
	"./ka.js": 406,
	"./kk": 407,
	"./kk.js": 407,
	"./km": 408,
	"./km.js": 408,
	"./kn": 409,
	"./kn.js": 409,
	"./ko": 410,
	"./ko.js": 410,
	"./ku": 412,
	"./ku-kmr": 411,
	"./ku-kmr.js": 411,
	"./ku.js": 412,
	"./ky": 413,
	"./ky.js": 413,
	"./lb": 414,
	"./lb.js": 414,
	"./lo": 415,
	"./lo.js": 415,
	"./lt": 416,
	"./lt.js": 416,
	"./lv": 417,
	"./lv.js": 417,
	"./me": 418,
	"./me.js": 418,
	"./mi": 419,
	"./mi.js": 419,
	"./mk": 420,
	"./mk.js": 420,
	"./ml": 421,
	"./ml.js": 421,
	"./mn": 422,
	"./mn.js": 422,
	"./mr": 423,
	"./mr.js": 423,
	"./ms": 425,
	"./ms-my": 424,
	"./ms-my.js": 424,
	"./ms.js": 425,
	"./mt": 426,
	"./mt.js": 426,
	"./my": 427,
	"./my.js": 427,
	"./nb": 428,
	"./nb.js": 428,
	"./ne": 429,
	"./ne.js": 429,
	"./nl": 431,
	"./nl-be": 430,
	"./nl-be.js": 430,
	"./nl.js": 431,
	"./nn": 432,
	"./nn.js": 432,
	"./oc-lnc": 433,
	"./oc-lnc.js": 433,
	"./pa-in": 434,
	"./pa-in.js": 434,
	"./pl": 435,
	"./pl.js": 435,
	"./pt": 437,
	"./pt-br": 436,
	"./pt-br.js": 436,
	"./pt.js": 437,
	"./ro": 438,
	"./ro.js": 438,
	"./ru": 439,
	"./ru.js": 439,
	"./sd": 440,
	"./sd.js": 440,
	"./se": 441,
	"./se.js": 441,
	"./si": 442,
	"./si.js": 442,
	"./sk": 443,
	"./sk.js": 443,
	"./sl": 444,
	"./sl.js": 444,
	"./sq": 445,
	"./sq.js": 445,
	"./sr": 447,
	"./sr-cyrl": 446,
	"./sr-cyrl.js": 446,
	"./sr.js": 447,
	"./ss": 448,
	"./ss.js": 448,
	"./sv": 449,
	"./sv.js": 449,
	"./sw": 450,
	"./sw.js": 450,
	"./ta": 451,
	"./ta.js": 451,
	"./te": 452,
	"./te.js": 452,
	"./tet": 453,
	"./tet.js": 453,
	"./tg": 454,
	"./tg.js": 454,
	"./th": 455,
	"./th.js": 455,
	"./tk": 456,
	"./tk.js": 456,
	"./tl-ph": 457,
	"./tl-ph.js": 457,
	"./tlh": 458,
	"./tlh.js": 458,
	"./tr": 459,
	"./tr.js": 459,
	"./tzl": 460,
	"./tzl.js": 460,
	"./tzm": 462,
	"./tzm-latn": 461,
	"./tzm-latn.js": 461,
	"./tzm.js": 462,
	"./ug-cn": 463,
	"./ug-cn.js": 463,
	"./uk": 464,
	"./uk.js": 464,
	"./ur": 465,
	"./ur.js": 465,
	"./uz": 467,
	"./uz-latn": 466,
	"./uz-latn.js": 466,
	"./uz.js": 467,
	"./vi": 468,
	"./vi.js": 468,
	"./x-pseudo": 469,
	"./x-pseudo.js": 469,
	"./yo": 470,
	"./yo.js": 470,
	"./zh-cn": 471,
	"./zh-cn.js": 471,
	"./zh-hk": 472,
	"./zh-hk.js": 472,
	"./zh-mo": 473,
	"./zh-mo.js": 473,
	"./zh-tw": 474,
	"./zh-tw.js": 474
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1760;

/***/ }),

/***/ 1764:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI1MCIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+DQo8cGF0aCBkPSJNNDAuNTggNTUuMDFMNDAuNTYgNTUuMDNDNDAuMjkgNTQuNDQgNDAuMTIgNTMuNzcgNDAuMDUgNTMuMDNDNDAuMTIgNTMuNzYgNDAuMzEgNTQuNDIgNDAuNTggNTUuMDFaIiBmaWxsPSIjMjkyRDMyIi8+DQo8cGF0aCBkPSJNNDcgNDYuMzhDNDguMzE0NCA0Ni4zOCA0OS4zOCA0NS4zMTQ0IDQ5LjM4IDQ0QzQ5LjM4IDQyLjY4NTYgNDguMzE0NCA0MS42MiA0NyA0MS42MkM0NS42ODU2IDQxLjYyIDQ0LjYyIDQyLjY4NTYgNDQuNjIgNDRDNDQuNjIgNDUuMzE0NCA0NS42ODU2IDQ2LjM4IDQ3IDQ2LjM4WiIgZmlsbD0iIzI5MkQzMiIvPg0KPHBhdGggZD0iTTU0LjE5IDM4SDQ1LjgxQzQyLjE3IDM4IDQwIDQwLjE3IDQwIDQzLjgxVjUyLjE5QzQwIDUzLjI4IDQwLjE5IDU0LjIzIDQwLjU2IDU1LjAzQzQxLjQyIDU2LjkzIDQzLjI2IDU4IDQ1LjgxIDU4SDU0LjE5QzU3LjgzIDU4IDYwIDU1LjgzIDYwIDUyLjE5VjQ5LjlWNDMuODFDNjAgNDAuMTcgNTcuODMgMzggNTQuMTkgMzhaTTU4LjM3IDQ4LjVDNTcuNTkgNDcuODMgNTYuMzMgNDcuODMgNTUuNTUgNDguNUw1MS4zOSA1Mi4wN0M1MC42MSA1Mi43NCA0OS4zNSA1Mi43NCA0OC41NyA1Mi4wN0w0OC4yMyA1MS43OUM0Ny41MiA1MS4xNyA0Ni4zOSA1MS4xMSA0NS41OSA1MS42NUw0MS44NSA1NC4xNkM0MS42MyA1My42IDQxLjUgNTIuOTUgNDEuNSA1Mi4xOVY0My44MUM0MS41IDQwLjk5IDQyLjk5IDM5LjUgNDUuODEgMzkuNUg1NC4xOUM1Ny4wMSAzOS41IDU4LjUgNDAuOTkgNTguNSA0My44MVY0OC42MUw1OC4zNyA0OC41WiIgZmlsbD0iIzI5MkQzMiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(754)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1856),
  /* scopeId */
  "data-v-1bd16f06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1769:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(792)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1916),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1770:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(796)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1923),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(780)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1896),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1772:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1886),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1773:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1878),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1774:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1891),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1775:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1913),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1776:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(748)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1849),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(753)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1855),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1778:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(782)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1899),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1779:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(784)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1903),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1780:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1848),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1781:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(745)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1845),
  /* scopeId */
  "data-v-06f5863b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1782:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1859),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1783:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1784:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1905),
  /* scopeId */
  "data-v-9e3269fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1785:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1918),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1786:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(751)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1853),
  /* scopeId */
  "data-v-152c0f19",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1787:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(781)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1897),
  /* scopeId */
  "data-v-7f66ba39",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1788:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1864),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1789:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1879),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1790:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(794)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1920),
  /* scopeId */
  "data-v-e50e8d00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1791:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1883),
  /* scopeId */
  "data-v-5af1ecd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1792:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1844),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1793:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1858),
  /* scopeId */
  "data-v-2036e734",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1794:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(774)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1890),
  /* scopeId */
  "data-v-6c0f0841",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1795:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(789)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1911),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1796:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(747)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1847),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1797:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1798:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(755)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1857),
  /* scopeId */
  "data-v-2025dc60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1799:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1875),
  /* scopeId */
  "data-v-48d89552",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1800:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1880),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1801:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1888),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1802:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(778)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1894),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1803:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1867),
  /* scopeId */
  "data-v-36317afc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1804:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(767)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1877),
  /* scopeId */
  "data-v-4d9e98be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1805:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(773)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1889),
  /* scopeId */
  "data-v-650bb680",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1806:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1921),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1807:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(790)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1912),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1808:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(744)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1842),
  /* scopeId */
  "data-v-02c3f81e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1907),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1810:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(795)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1922),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1811:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1868),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1812:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1910),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1813:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(746)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1814:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(770)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1882),
  /* scopeId */
  "data-v-59ae1166",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1815:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1871),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1816:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(758)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1862),
  /* scopeId */
  "data-v-2cd685a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1817:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(750)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1852),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1818:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1881),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1819:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(777)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1893),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return servers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stats; });
/* unused harmony export timeline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var servers = [{
  name: 'www01',
  status: 'success',
  icon: 'globe',
  description: 'Web server that runs our sites'
}, {
  name: 'sql01',
  status: 'danger',
  icon: 'database',
  description: 'mySQL server used for reporting'
}, {
  name: 'mongoDB01',
  status: 'info',
  icon: 'file-code-o',
  description: 'Main DB server'
}, {
  name: 'ldap01',
  status: 'success',
  icon: 'key',
  description: 'Authentication server'
}, {
  name: 'mgmt01',
  status: 'success',
  icon: 'home',
  description: 'Management server with all tools'
}, {
  name: 'bkup01',
  status: 'warning',
  icon: 'backward',
  description: 'Backup server'
}];

var stats = [{
  header: '8390',
  text: 'Visitors'
}, {
  header: '30%',
  text: 'Referrals'
}, {
  header: '70%',
  text: 'Organic'
}];

var timeline = [{
  icon: 'fa-envelope',
  color: 'blue',
  title: 'Write short novel',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').fromNow(),
  body: 'Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle quora plaxo ideeli hulu weebly balihoo...',
  buttons: [{
    type: 'primary',
    message: 'Read more',
    href: 'https://github.com/misterGF/CoPilot',
    target: '_blank'
  }]
}, {
  icon: 'fa-user',
  color: 'yellow',
  title: 'Sarah Young accepted your friend request',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()('20150620', 'MMM Do YY').fromNow()
}, {
  icon: 'fa-camera',
  color: 'purple',
  title: 'Watch a youTube video',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()('20130620', 'YYYYMMDD').fromNow(),
  body: '<div class="embed-responsive embed-responsive-16by9"><iframe width="560" height="315" src="https://www.youtube.com/embed/8aGhZQkoFbQ" frameborder="0" allowfullscreen></iframe></div>'
}];

/***/ }),

/***/ 1820:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1925),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1821:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(757)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1860),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1822:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(783)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1901),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1823:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(788)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1908),
  /* scopeId */
  "data-v-a69b197e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1824:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(791)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1915),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1825:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1919),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1826:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(779)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1895),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1827:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(749)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1850),
  /* scopeId */
  "data-v-0e2f019e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1828:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1872),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1829:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(752)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1854),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return luggageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var luggageService = {
  listAllLuggageType: function listAllLuggageType(callback) {
    var url = "https://backendbutiko.com" + '/api/luggage/list-types';
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      var data = response.data.body.luggage_types_list;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  },
  addLuggageToShipment: function addLuggageToShipment(id, dataObject) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/boarding/' + id + '/add-luggage';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, dataObject).then(function (response) {
                var aux = new Object();
                aux = response.data.body;
                return aux;
              }).catch(function (error) {
                console.log(error);
                console.log(error.response.status);
                console.log(error.response);
                alert('error al agregar equipaje');
              });

            case 3:
              res = _context.sent;
              return _context.abrupt('return', res);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  deleteLuggageItem: function deleteLuggageItem(numeration, boardingId) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/luggage/' + numeration + '/delete/' + boardingId;

              console.log(url);

              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(url, {}).then(function (response) {
                console.log(response.data);
                return true;
              }).catch(function (error) {
                console.log(error);
                console.log(error.response.status);
                console.log(error.response);
                console.log('error al quitar equipaje');
                return false;
              });

            case 4:
              res = _context2.sent;
              return _context2.abrupt('return', res);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

/***/ }),

/***/ 1830:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1861),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1831:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(766)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1876),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1832:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1851),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1833:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1909),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1834:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1902),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1835:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1898),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1836:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(1900),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1837:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1843),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1838:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1869),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1839:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1924),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1840:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1885),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1841:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1887),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1842:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFullActive) ? _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1843:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes,
      "activeRoute": _vm.activeRoute
    }
  }), _vm._v(" "), (_vm.orderDataShow && _vm.orderDataShow.attributes.status >= 4) ? _c('div', [_c('div', {
    staticClass: "card-status-content"
  }, [_c('div', {
    staticClass: "card-status-block"
  }, [(_vm.orderDataShow.attributes.status == 5) ? _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.confirmArrivalPurchaseOrderToOrigin(_vm.id)
      }
    }
  }, [_vm._v("Confirmar correcta recepción")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.backToDetail()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-left"
  }), _vm._v("Volver al detalle")]), _vm._v(" "), (_vm.orderDataShow.attributes.status >= 1 && _vm.orderDataShow.attributes.status <= 3) ? _c('span', {
    staticClass: "btn statusInit"
  }, [_vm._v("Inicializando")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status >= 4 && _vm.orderDataShow.attributes.status <= 7) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("En proceso")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("Finalizado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10) ? _c('span', {
    staticClass: "btn statusCancel"
  }, [_vm._v("Cancelado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 1) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En re-evaluación inicial")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 2) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Re-evaluado esperando confirmación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 3) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Completando información de compra")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Comprado y en camino a dirección de origen")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Recibido en dirección de origen y en evaluación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Listo para embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 7) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Entregado correctamente")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled_reason_flag == 1) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por decisión propia")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por incidente en tracking")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled_reason_flag == 3) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por no autorizar reposición de items")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('div', {
    staticClass: "nm n-1"
  }, [_c('orderImportantInfo', {
    attrs: {
      "orderDataShow": _vm.orderDataShow,
      "fromDetail": false,
      "fromTracking": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-container"
  }, [(_vm.orderDataShow.attributes.status == 4 && _vm.orderDataShow.attributes.warning_expired_flag == 0) ? _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-content-container",
    attrs: {
      "id": "headingOne"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalNewTracking_flag
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalTypeReplacement_flag
    }
  }, [_vm._v("Generar incidencia")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()], 1)]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5 && _vm.orderDataShow.attributes.warning_expired_flag == 0) ? _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-content-container collapsed",
    attrs: {
      "id": "headingTwo"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalTypeReplacement_flag
    }
  }, [_vm._v("Generar incidencia")]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()], 1)]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-content-container",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-block"
  }, [(_vm.orderDataShow.attributes.warning_expired_flag == 0) ? _c('span', [_vm._v("Listo para embarcar")]) : (_vm.orderDataShow.attributes.warning_expired_flag == 1) ? _c('span', [_vm._v("Listo para embarcar con retraso")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [(_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseThree",
      "aria-labelledby": "headinThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4 && _vm.orderDataShow.attributes.warning_expired_flag == 1) ? _c('div', {
    staticClass: "card card-warning"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Generar incidencia")])], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5 && _vm.orderDataShow.attributes.warning_expired_flag == 1) ? _c('div', {
    staticClass: "card card-warning"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Generar incidencia")])], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && (_vm.orderDataShow.attributes.cancelled_reason_flag == 1 || _vm.orderDataShow.attributes.cancelled_reason_flag == 3)) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_vm._m(4), _vm._v(" "), _c('li', [(_vm.orderDataShow.attributes.cancelled_reason_flag == 1) ? _c('h1', [_vm._v("Cancelado por decision propia")]) : (_vm.orderDataShow.attributes.cancelled_reason_flag == 3) ? _c('h1', [_vm._v("Cancelado por no autorizar reposición de items")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2 &&
    _vm.orderDataShow.attributes.has_replacement_flag == false && _vm.orderDataShow.attributes.has_active_refund_flag == false && _vm.orderDataShow.attributes.trackingIncident.attributes.type == 1) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReplacement",
      modifiers: {
        "modalReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalReplacement_flag
    }
  }, [_vm._v("Generar reemplazo")])], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2 && _vm.orderDataShow.attributes.trackingIncident.attributes.type == 2) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.orderDataShow.attributes.has_active_refund_flag == true) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalRefund",
      modifiers: {
        "modalRefund": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Completar rembolso")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.has_replacement_flag == false && !_vm.orderDataShow.attributes.is_from_linio_flag && !_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.redirectToCreatePurchaseOrder
    }
  }, [_vm._v("Crear reemplazo")]) : (_vm.orderDataShow.attributes.has_replacement_flag == false && _vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.redirectToCreatePurchaseOrder
    }
  }, [_vm._v("Crear reemplazo (Es linio no deberia hacerlo)")]) : _vm._e()], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headinTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2 && _vm.orderDataShow.attributes.has_replacement_flag == 1) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), (_vm.orderDataShow.attributes.replacementPurchaseOrder) ? _c('li', [_c('h1', [_vm._v("\n                    Orden cancelada por reemplazo, ver\n                    "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.referenceToNewPurchaseOrder()
      }
    }
  }, [_vm._v("nueva orden aqui")])])]) : _vm._e()])])]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headinTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id != null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de cliente:")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_id) + " ")]) : ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id == null) || (_vm.orderDataShow.attributes.is_from_linio_flag)) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_dni != null ? _vm.orderDataShow.attributes.external_client_dni : 'No definido') + " ")]) : (!_vm.orderDataShow.attributes.is_from_grabr_flag && !_vm.orderDataShow.attributes.is_from_linio_flag && !_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(" " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes.document_number))]) : (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id != null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/users/' + _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id) + "\n                      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombres y apellidos:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_name))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.customer_first_name + " " + _vm.orderDataShow.attributes.linioOrder.attributes.customer_last_name))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_first_name + " " + _vm.orderDataShow.attributes.meliOrder.attributes.customer_last_name))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes.name + " " + _vm.orderDataShow.attributes.client.attributes.profile.attributes.surnames))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_nickname))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número telefónico:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_phone))]) : (_vm.orderDataShow.attributes.is_from_grabr_flag || _vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                    " + _vm._s(_vm.orderDataShow.attributes.external_client_cellphone != null ? _vm.orderDataShow.attributes.external_client_cellphone : 'No definido') + " ")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes.cellphone))])])])])])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseshipping",
      "aria-labelledby": "headingshipping"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de envío: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_id))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.shipping_id != null ? _vm.orderDataShow.attributes.linioOrder.attributes.shipping_id : 'No definido'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 1: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_address != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_address : 'No definido'))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.shipping_address != null ? _vm.orderDataShow.attributes.linioOrder.attributes.shipping_address : 'No definido'))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 2: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment : 'No definido'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_neighborhood != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_neighborhood : 'No definido'))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.shipping_neighborhood != null ? _vm.orderDataShow.attributes.linioOrder.attributes.shipping_neighborhood : 'No definido'))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_city != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_city : 'No definido'))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseorder",
      "aria-labelledby": "headingorder"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de chat en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.is_from_grabr_flag ? _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link : ''))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Grabr:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_purchase_link !== null ? _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_purchase_link : "No definido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Linio:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_purchase_link !== null ? _vm.orderDataShow.attributes.linioOrder.attributes.linio_purchase_link : "No definido"))])]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Mercado Libre:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.seller_sku !== null ? _vm.orderDataShow.attributes.meliOrder.attributes.seller_sku : "No de finido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Link de compra final:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.real_purchase_link !== null ? _vm.orderDataShow.attributes.real_purchase_link : 'No definido',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.real_purchase_link !== null ? _vm.orderDataShow.attributes.real_purchase_link : "No definido"))])])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de viaje en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/trips/' + _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.travel_number))])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.linio_account) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Linio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_account))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.meli_account) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Mercado Libre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_account))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.origin != undefined ? _vm.orderDataShow.attributes.origin.attributes.name : "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.destination != undefined ? _vm.orderDataShow.attributes.destination.attributes.name : "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada al origen:")]), _vm._v(" "), (_vm.orderDataShow.attributes.promised_origin_arrival_date != null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_origin_arrival_date)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("No definido")])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_origin_arrival_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_origin_arrival_date)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega prometida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_delivery_date)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_delivery_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_delivery_date)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.carrier_name != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Transportista:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.carrier_name))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.shopping_order_number != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shopping_order_number))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.tracking_number !== null ? _vm.orderDataShow.attributes.tracking_number : "No definido"))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsePago",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de aprobación:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_date_approved) + " ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_offer_date) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_method) + " ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.payment_method) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_type) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Monto de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price) + " ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price) + " ")]) : _vm._e()])])])])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Comentarios")])]) : _vm._e(), _vm._v(" "), (true) ? _c('div', {
    staticClass: "details-content"
  }, [(!(_vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.status == 10)) ? _c('div', {
    staticClass: "details-content-comments"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentContent),
      expression: "currentContent"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "maxlength": 1000,
      "rows": "1",
      "placeholder": "Deja tu comentario..."
    },
    domProps: {
      "value": (_vm.currentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.currentContent != '') ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round",
    on: {
      "click": _vm.createComment
    }
  }, [_vm._v("Enviar")])]) : _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round"
  }, [_vm._v("Enviar")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments), function(comment, index) {
    return _c('comment-component', {
      key: index,
      attrs: {
        "comment": comment,
        "orderCancelledFlag": _vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1
      },
      on: {
        "in-edition": _vm.disableEditComments,
        "cancel-edition": _vm.enableEditComments,
        "display-comments": _vm.displayComments,
        "comment-deleted": _vm.displayComments
      }
    })
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nm n-2",
    attrs: {
      "id": "fixedElement"
    }
  }, [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('div', {
    staticClass: "details-title-item"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', [_vm._v("Precio Grabr")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', [_vm._v("Precio linio")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', [_vm._v("Precio Mercado Libre")]) : _c('span', [_vm._v("Precio")]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ +" + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.totalPrice)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(14), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax)))])]) : (_vm.isDirect && _vm.orderDataShow.attributes.real_tax != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_tax)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(16), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee)))])]) : (_vm.isDirect && _vm.orderDataShow.attributes.real_shipping != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(17), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_shipping)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(18), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$" + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.debit)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [(_vm.orderDataShow.attributes.grabrOrder.attributes.debit_url != null) ? _c('a', {
    staticClass: "adeudo",
    attrs: {
      "href": _vm.orderDataShow.attributes.grabrOrder.attributes.debit_url,
      "target": "_blank"
    }
  }, [_vm._m(19)]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [(_vm.orderDataShow.attributes.linioOrder.attributes.debit_url != null) ? _c('a', {
    staticClass: "adeudo",
    attrs: {
      "href": _vm.orderDataShow.attributes.linioOrder.attributes.debit_url,
      "target": "_blank"
    }
  }, [_vm._m(20)]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comisión (9%)")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ -" + _vm._s(_vm._f("currency")(0.09 * _vm.totalPrice)))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Rebate Bruto")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ +" + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.rebate != null ? _vm.orderDataShow.attributes.meliOrder.attributes.rebate : 0)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comisión Rebate (9%)")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ -" + _vm._s(_vm._f("currency")(0.09 * _vm.orderDataShow.attributes.meliOrder.attributes.rebate)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("REBATE NETO")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.rebate - (0.09 * _vm.orderDataShow.attributes.meliOrder.attributes.rebate))))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('div', {
    staticClass: "details-title-item"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', [_vm._v("Total Grabr")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', [_vm._v("Total Linio")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', [_vm._v("Total Mercado Libre")]) : _c('span', [_vm._v("Total")]), _vm._v(" "), _vm._m(21)]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalPrice)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalMeli)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.totalPrice)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total comisiones")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalCommissions)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block summary-block-total details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee + _vm.orderDataShow.attributes.grabrOrder.attributes.debit)))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block summary-block-total details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price + _vm.orderDataShow.attributes.linioOrder.attributes.debit)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block summary-block-total details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalNeto)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payed == 1 && _vm.orderDataShow.attributes.status <= 7) ? _c('div', {
    staticClass: "details-title-container"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmPendientOrder()
      }
    }
  }, [_vm._v("Confirmar pago")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status <= 7) ? _c('div', {
    staticClass: "details-title-container"
  }, [_c('button', {
    staticClass: "btn btn-light",
    staticStyle: {
      "border-color": "red"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar orden")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmationDelete()
      }
    }
  }, [_vm._v("Eliminar orden")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "slider",
    attrs: {
      "id": "seguimiento"
    }
  }, _vm._l((_vm.seguimientoTrackin), function(trac) {
    return _c('div', {
      key: trac.eventId,
      staticClass: "slider_content"
    }, [(trac.status == 'DELIVERED') ? _c('img', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "src": "https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
      }
    }) : (trac.status == 'Processing at UPS Facility') ? _c('img', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "src": "https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
      }
    }) : _c('img', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "src": "https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
      }
    }), _vm._v("\n                  " + _vm._s(new Date(trac.datetime).toDateString()) + "\n                  "), _c('p', [_c('strong', [_vm._v(_vm._s(trac.status))]), _vm._v(", " + _vm._s(trac.location))])])
  }), 0)])])])]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "validacionmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-correcto text-center",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "cancelOrdermodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "cancelOrdermodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideCancelValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-no-correcto text-center"
  }, [_c('div', {
    staticClass: "cancel-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-edit",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideCancelValidation
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalNewTracking",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalNewTracking"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Evaluación del tracking")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalNewTracking
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha real de llegada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.realDateArrive),
      expression: "realDateArrive"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "name": "real_arrival_date",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.realDateArrive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realDateArrive = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('real_arrival_date')),
      expression: "errors.has('real_arrival_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('real_arrival_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso registrado")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightOrder),
      expression: "weightOrder"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "origin_order_weight",
      "aria-describedby": "email",
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.weightOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightOrder = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origin_order_weight')),
      expression: "errors.has('origin_order_weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('origin_order_weight')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidades de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.originWeightUnit),
      expression: "originWeightUnit"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "weight_units"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.originWeightUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.listUnits), function(units) {
    return _c('option', {
      key: units.id,
      domProps: {
        "value": units
      }
    }, [_vm._v(_vm._s(units.attributes.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_units')),
      expression: "errors.has('weight_units')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_units')))])]), _vm._v(" "), (!_vm.oldOrderNumber) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderNumber),
      expression: "newOrderNumber"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "minlength": "5",
      "name": "tracking_number",
      "aria-describedby": "email",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.newOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newOrderNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tracking_number')),
      expression: "errors.has('tracking_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tracking_number')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de control")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.controlNumber),
      expression: "controlNumber"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "controlNumber",
      "name": "control_number",
      "aria-describedby": "controlNumber",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.controlNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.controlNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('control_number')),
      expression: "errors.has('control_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('control_number')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.purchaseOrderEvaluation(_vm.id)
      }
    }
  }, [_vm._v("Guardar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalTypeReplacement",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalTypeReplacement"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Selecciona el tipo de incidencia")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalTypeReplacement
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalTypeReplacement_flag == true
      }),
      expression: "{required: this.modalTypeReplacement_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.storeType),
      expression: "storeType"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "incidence_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.orderDataShow.attributes.warning_expired_flag || !_vm.orderDataShow.attributes.warning_expired_flag) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Por retraso")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Por pérdida")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('incidence_type')),
      expression: "errors.has('incidence_type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('incidence_type')))]), _vm._v(" "), (_vm.storeType == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlTextarea1"
    }
  }, [_vm._v("Tipo de reemplazo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.storeType == 2
      }),
      expression: "{required: storeType==2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.replacementType),
      expression: "replacementType"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "tipo_reemplazo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.replacementType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "1"
    }
  }, [_vm._v("Misma tienda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Otra tienda")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tipo_reemplazo')),
      expression: "errors.has('tipo_reemplazo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo_reemplazo')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlTextarea1"
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalTypeReplacement_flag == true
      }),
      expression: "{required: this.modalTypeReplacement_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.descriptionIncidence),
      expression: "descriptionIncidence"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlTextarea1",
      "rows": "3",
      "name": "incidence_description"
    },
    domProps: {
      "value": (_vm.descriptionIncidence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descriptionIncidence = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('incidence_description')),
      expression: "errors.has('incidence_description')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('incidence_description')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateIncidence
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalReplacement",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalReplacement"
    },
    on: {
      "shown": _vm.inicialiceModalReplacement
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reemplazo")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReplacement
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag && this.modalNewTracking_flag
      }),
      expression: "{required: this.modalReplacement_flag && this.modalNewTracking_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "order_number",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.orderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('order_number')),
      expression: "errors.has('order_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('order_number')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trackingNumber),
      expression: "trackingNumber"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "tracking_number_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.trackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trackingNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tracking_number_replacement')),
      expression: "errors.has('tracking_number_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tracking_number_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag,
        url: true
      }),
      expression: "{required: this.modalReplacement_flag, url:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.purchaseLink),
      expression: "purchaseLink"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "purchase_link_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.purchaseLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchaseLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_link_replacement')),
      expression: "errors.has('purchase_link_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_link_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada al origen")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dateArriveOrigin),
      expression: "dateArriveOrigin"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "name": "arrival_date_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.dateArriveOrigin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateArriveOrigin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date_replacement')),
      expression: "errors.has('arrival_date_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Entrega prometida")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dateArriveClient),
      expression: "dateArriveClient"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "name": "arrival_date_client_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.dateArriveClient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateArriveClient = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date_client_replacement')),
      expression: "errors.has('arrival_date_client_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date_client_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRealPrice),
      expression: "newRealPrice"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newRealPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRealPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_real_price')),
      expression: "errors.has('new_real_price')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('new_real_price')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRealTax),
      expression: "newRealTax"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newRealTax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRealTax = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_real_tax')),
      expression: "errors.has('new_real_tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('new_real_tax')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRealShipping),
      expression: "newRealShipping"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newRealShipping)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRealShipping = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_real_shipping')),
      expression: "errors.has('new_real_shipping')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('new_real_shipping')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateReplacement
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalRefund",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalRefund"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reembolso")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalRefund
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Monto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mountNew),
      expression: "mountNew"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.mountNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mountNew = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de reembolso")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refundDate),
      expression: "refundDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.refundDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refundDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.completeRefund()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.endRefundByTrakingIncidentID(_vm.orderDataShow.attributes.trackingIncident.id)
      }
    }
  }, [_vm._v("Finalizar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationV2",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationV2"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar accion:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationV2
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.notfound()
      }
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Se cambiará el estado de la orden a cancelado, esta acción no es reversible.\n¿Estas seguro de completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmFormModal()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationDelete",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationDelete"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationDelete
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Se eliminará la orden de forma física, esta acción no es reversible.\n¿Estas seguro de completar esta acción?\n")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deletePurchaseOrder(_vm.id)
      }
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmationDelete()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Comprado y en camino a dirección de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Recibido y completando datos de recepción")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h1', [_vm._v("Oferta de compra retrasada")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Recicibido con retraso y completando datos de recepción")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidente en tracking: Retraso")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidente en tracking: Pérdida")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Detalles de la orden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del cliente")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingshipping",
      "data-toggle": "collapse",
      "data-target": "#collapseshipping",
      "aria-expanded": "false",
      "aria-controls": "collapseshipping"
    }
  }, [_c('span', [_vm._v("Datos de envío")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingorder",
      "data-toggle": "collapse",
      "data-target": "#collapseorder",
      "aria-expanded": "false",
      "aria-controls": "collapseorder"
    }
  }, [_c('span', [_vm._v("Datos de compra")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapsePago",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos de Pago")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Precio")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Impuesto Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Impuesto")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Impuesto")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Impuesto")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Recompensa Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Recompensa Grabr")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Costo de envío")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Costo de envío")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Adeudo")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Adeudo")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-lg btn-block btn-adeudo"
  }, [_vm._v("Pagar con"), _c('img', {
    staticClass: "paypal-img",
    attrs: {
      "src": "/static/img/paypal.svg",
      "height": "30",
      "alt": "USA flag"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-lg btn-block btn-adeudo"
  }, [_vm._v("Pagar con"), _c('img', {
    staticClass: "paypal-img",
    attrs: {
      "src": "/static/img/paypal.svg",
      "height": "30",
      "alt": "USA flag"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block details-summary-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#seguimiento",
      "aria-expanded": "false",
      "aria-controls": "seguimiento"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Seguimiento del Paquete")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}

/***/ }),

/***/ 1844:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.userInfo.messages), function(message) {
    return _c('message-item', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1845:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.cotiaciones), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('div', {
      staticClass: "image-table"
    }, [(data.img) ? _c('img', {
      attrs: {
        "src": data.img,
        "alt": "",
        "width": "180px",
        "height": "260px"
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(477),
        "alt": "",
        "width": "180px",
        "height": "260px"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.title))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_c('a', {
      attrs: {
        "href": data.url,
        "target": "_blank"
      }
    }, [_vm._v("url")])])])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPedidos
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "newOrder"
  }, [_c('div', {
    staticClass: "s"
  }, [_c('div', {
    staticClass: "bienvenido-admin"
  }, [_c('h2', [_vm._v("Bienvenido a Sendibox")]), _vm._v(" "), _c('p', [_vm._v("Ahora enviar y recibir es más fácil de lo que imaginas")]), _vm._v(" "), _c('div', {
    staticClass: "bienvenido-grid"
  }, [_c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-bag.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Tus órdenes")]), _vm._v(" "), _c('p', [_vm._v("Gestiona las órdenes de compra durante las 24/7.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(1)
      }
    }
  }, [_vm._v("Continuar")])])]), _vm._v(" "), _c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-ship.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Tus embarques")]), _vm._v(" "), _c('p', [_vm._v("Gestiona los embarques generados las 24/7.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(2)
      }
    }
  }, [_vm._v("Continuar")])])]), _vm._v(" "), _c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-profile.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Tu perfil")]), _vm._v(" "), _c('p', [_vm._v("Gestiona tu información personal.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit",
      "id": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(3)
      }
    }
  }, [_vm._v("Continuar")])])]), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-users.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Usuarios")]), _vm._v(" "), _c('p', [_vm._v("Gestiona los distintos usuarios y roles del sistema.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(4)
      }
    }
  }, [_vm._v("Continuar")])])]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1847:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "static/img/home.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")])])]), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/orders"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-bag.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Órdenes de compra")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/warehouse"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-bag.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Warehouse")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/categorys"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    staticStyle: {
      "font-size": "1.5rem"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/subpartida"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    staticStyle: {
      "font-size": "1.5rem"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Subpartida")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(12)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/shipments"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-ship.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Embarques")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/users"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-users.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuarios")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cotizaciones"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/cliente.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cotizaciones")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/Reclamaciones"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/information.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Reclamaciones")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/tableRebate"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/administrador.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Utils")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/credenciales"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/administrador.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Credenciales")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page inferior"
  }, [_vm._m(0), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tamanoLetra"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.buy : ""))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tamanoLetra"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.sale : ""))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tamanoLetra"
  }, [_vm._v("Compra:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "page tamanoLetra"
  }, [_vm._v("Venta:")])])
}]}

/***/ }),

/***/ 1848:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('modal-campaign')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n          Nuevo codigo\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.codigoCampa), function(data) {
    return _c('div', {
      key: data.id,
      staticClass: "u-row py-3",
      staticStyle: {
        "display": "grid"
      }
    }, [_c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v(_vm._s(data.code))]), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v("\n          " + _vm._s(data.description) + "\n        ")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": data.img,
        "alt": "",
        "width": "100"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v("USD " + _vm._s(data.amount))]), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v("4")]), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_c('span', {
      staticClass: "d-block mb-2"
    }, [_c('span', {
      staticClass: "d-block",
      staticStyle: {
        "opacity": "0.75",
        "font-weight": "600",
        "font-size": "12px"
      }
    }, [_vm._v("Fecha inicio")]), _vm._v("\n            " + _vm._s(data.start_date) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "d-block"
    }, [_c('span', {
      staticClass: "d-block",
      staticStyle: {
        "opacity": "0.75",
        "font-weight": "600",
        "font-size": "12px"
      }
    }, [_vm._v("Fecha expiración")]), _vm._v("\n            " + _vm._s(data.end_date) + "\n          ")])])])
  })], 2)]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-campaign"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createCode.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Agregar nuevo código")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-campaign')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Cantidad ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.max_amount),
      expression: "form.max_amount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.max_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "max_amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Monto ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amount),
      expression: "form.amount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Fecha inicio")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.start_date),
      expression: "form.start_date"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "start_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Fecha expiración")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.end_date),
      expression: "form.end_date"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "end_date", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "file",
      "name": "",
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar ingreso\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Campañas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-row u-row--header",
    staticStyle: {
      "display": "grid"
    }
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Código")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Imagen")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Monto")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Cantidad")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Fecha")])])
}]}

/***/ }),

/***/ 1849:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-container sendi-admin-entry"
  }, [_c('div', {
    staticClass: "d-content select-login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "f"
  }, [_c('div', {
    staticClass: "f-content",
    on: {
      "click": _vm.toAdminLogin
    }
  }, [_c('div', {
    staticClass: "h"
  }, [_c('div', {
    staticClass: "f-data-icon",
    attrs: {
      "id": "administrador"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "buttom-f text-center"
  }, [_c('button', {
    class: 'btn btn-primary  btn-block btn-round btn-welcome ',
    attrs: {
      "type": "button",
      "id": "admin-access",
      "aria-label": "Acceder como administrador"
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "f-content",
    on: {
      "click": _vm.toOperLogin
    }
  }, [_c('div', {
    staticClass: "h"
  }, [_c('div', {
    staticClass: "f-data-icon",
    attrs: {
      "id": "operador-envio"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "buttom-f text-center"
  }, [_c('button', {
    class: 'btn btn-primary  btn-block btn-round btn-welcome ',
    attrs: {
      "type": "button",
      "id": "operator-access",
      "aria-label": "Acceder como operador de envío o recepción"
    }
  }, [_vm._v("Continuar")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header text-center"
  }, [_c('span', {
    staticClass: "title-login"
  }, [_c('img', {
    staticClass: "logo-login",
    attrs: {
      "src": "/static/img/sendi-logo.png",
      "width": "400",
      "height": "78",
      "alt": "Sendi"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sendi-admin-title"
  }, [_vm._v("Portal de administración")]), _c('p', {
    staticClass: "sub-login"
  }, [_vm._v("Selecciona el tipo de usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-data-text"
  }, [_c('p', [_vm._v("Administrador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-data-text"
  }, [_c('p', [_vm._v("Operador de envío/recepción")])])
}]}

/***/ }),

/***/ 1850:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Codigo de Publicación:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicationCode),
      expression: "publicationCode"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "nameUSer"
    },
    domProps: {
      "value": (_vm.publicationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.verifiPubliCode()
      }
    }
  }, [_vm._v("Buscar")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "priceProduc"
    }
  }, [_c('div', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("S/. " + _vm._s(this.producPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "titleProduc"
    }
  }, [_c('div', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Titulo del Producto:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v(" " + _vm._s(this.producTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Monto de rebate")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.montoRebate),
      expression: "montoRebate"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "number",
      "aria-describedby": "nameUSer"
    },
    domProps: {
      "value": (_vm.montoRebate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.montoRebate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Intervalo de Fecha ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateTo),
      expression: "dateTo"
    }],
    staticClass: "form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "id": "date",
      "type": "date",
      "placeholder": "Fecha de To de Rebate",
      "onkeydown": "return false",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datefrom),
      expression: "datefrom"
    }],
    staticClass: "form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "id": "date2",
      "type": "date",
      "placeholder": "Fecha de From de Rebate",
      "onkeydown": "return false",
      "required": ""
    },
    domProps: {
      "value": (_vm.datefrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datefrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('p'), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.rebatePubli()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v("Aplicar")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Herramientas para Publicaciones de Mercado Libre")])])])
}]}

/***/ }),

/***/ 1851:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), (!_vm.dataOriginal) ? _c('div', {}) : _vm._e(), _vm._v(" "), (_vm.dataOriginal) ? _c('div', {
    staticClass: "step_container"
  }, [_c('ul', {
    staticClass: "progressbar"
  }, [_c('li', {
    class: {
      inprocess: _vm.state1 === 1, active: _vm.state2 === 1 || _vm.state2 === 2
    },
    attrs: {
      "id": "li1",
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(1)
      }
    }
  }, [_c('p', [_vm._v("Datos del embarque")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state2 === 1, active: _vm.state3 === 1 || _vm.state3 === 2 || _vm.dataLocal.dataShipment.status, disabled: _vm.state1 === 1 && !_vm.dataLocal.dataShipment.status
    },
    attrs: {
      "id": "li2"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(2)
      }
    }
  }, [_c('p', [_vm._v("Agregar equipaje")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state3 === 1, active: _vm.state4 === 1 || _vm.state2 === 1 || _vm.dataLocal.dataShipment.status, disabled: _vm.state1 === 1 && !_vm.dataLocal.dataShipment.status
    },
    attrs: {
      "id": "li3"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(3)
      }
    }
  }, [_c('p', [_vm._v("Agregar órdenes")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state4 === 1, active: _vm.dataLocal.dataOrder.status, disabled: (_vm.state1 === 1 || _vm.state2 === 1 || _vm.state3 === 1) && !_vm.dataLocal.dataOrder.status
    },
    attrs: {
      "id": "li4"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(4)
      }
    }
  }, [_c('p', [_vm._v("Embarcar")])])])]) : _vm._e(), _vm._v(" "), (_vm.dataOriginal) ? _c('div', [(_vm.state1 == 1) ? _c('form1', {
    attrs: {
      "idOperator": _vm.idOperator,
      "dataLocal": _vm.dataLocal
    },
    on: {
      "toNextForm": _vm.toSecondForm,
      "saveOk": _vm.setSaveOk
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state2 == 1) ? _c('form2', {
    attrs: {
      "id": _vm.dataOriginal.id,
      "dataLocal": _vm.dataLocal
    },
    on: {
      "toNextForm": _vm.toThirdForm,
      "updateListLuggage": _vm.updateListLuggage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state3 == 1) ? _c('form3', {
    attrs: {
      "id": _vm.dataOriginal.id,
      "dataLocal": _vm.dataLocal
    },
    on: {
      "go-toForm4": _vm.gotoForm4,
      "packages-saved": _vm.packagesSaved,
      "total-weight-updated": _vm.updateTotalWeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state4 == 1) ? _c('form4', {
    attrs: {
      "id": _vm.dataOriginal.id,
      "dataLocal": _vm.dataLocal,
      "totalWeightLb": _vm.totalWeightLb
    },
    on: {
      "toSendForm": _vm.toSendForm
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1852:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content pt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.reclamos), function(data) {
    return _c('tr', {
      key: data
    }, [_c('td', {
      staticStyle: {
        "max-width": "200px"
      }
    }, [_vm._v(_vm._s(data.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "180px"
      }
    }, [_vm._v(_vm._s(data.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.store_id === 1 ? 'SENDI' : 'ENVIOS USA'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.created_at))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'ReclamoDetails',
          params: {
            id: data.id
          }
        }
      }
    }, [_vm._v("Ver más")])], 1)])
  }), 0)])])]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrdersByPage
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex justify-content-between px-3"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title"
  }, [_vm._v("Reclamaciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "max-width": "200px"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Tienda")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 1853:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.saldo), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("EUP-" + _vm._s(data.id))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', [_vm._v(_vm._s(data.attributes.titleOperation) + " "), _c('br'), _c('br'), _vm._v("\n                " + _vm._s(data.attributes.descriptionOperation) + " "), _c('br'), _c('br'), _vm._v("\n\n                " + _vm._s(data.attributes.purchaseorder_id !== null ?
      "N° orden #" + data.attributes.purchaseorder_id :
      "") + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.pasarela))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(" " + _vm._s(data.attributes.date) + " "), _c('br')])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.amount))])])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPedidos
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1854:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "4fr 1fr",
      "gap": "1rem",
      "align-items": "start"
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('modal-wr')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n              Nuevo paquete\n            ")])]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_c('div', {
    staticClass: "u-row-wr u-row--header"
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Producto")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Warehouse")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Acciones")])]), _vm._v(" "), _vm._l((_vm.warehouseorder), function(data) {
    return _c('div', {
      key: data,
      staticClass: "u-row-wr"
    }, [_c('div', [(!_vm.isOrder) ? _c('button', {
      staticClass: "btn-paquete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openModal('modal-orden')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus"
    }), _vm._v(" "), _c('span', [_vm._v("Asociar orden")])]) : _c('article', {
      staticClass: "card-product"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "card-product__img",
      attrs: {
        "src": "https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8c2hvZXMlMjBuaWtlfGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("Nike shoes")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Nombres:")]), _vm._v("\n                        Jesus Gallardo\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código del cliente:")]), _vm._v("\n                        #123456789\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                        #12345\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje desde:")]), _vm._v("\n                        Miami, Estados Unidos\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje a:")]), _vm._v("\n                        Lima, Perú\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Número de orden:")]), _vm._v("\n                        #12345\n                      ")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "max-width": "30vw"
      }
    }, [(!_vm.isWr) ? _c('button', {
      staticClass: "btn-paquete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openModal('modal-wr')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus"
    }), _vm._v(" "), _c('span', [_vm._v("Nuevo paquete")])]) : [_c('vue-glide', {
      attrs: {
        "perView": 2
      }
    }, [_c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('vue-glide-slide', [_c('article', {
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              Jesus Gallardo\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              Lorem, ipsum dolor.\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                              #12345\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              100 "), _c('b', [_vm._v("kg")])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n                            ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#1EA9E4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n                              Ver fotos\n                            ")])])])])]), _vm._v(" "), _c('template', {
      slot: "control"
    }, [_c('button', {
      staticClass: "slider__btn slider__btn--prev",
      attrs: {
        "data-glide-dir": "<"
      }
    }, [_c('i', {
      staticClass: "fas fa-arrow-left"
    })]), _vm._v(" "), _c('button', {
      staticClass: "slider__btn slider__btn--next",
      attrs: {
        "data-glide-dir": ">"
      }
    }, [_c('i', {
      staticClass: "fas fa-arrow-right"
    })])])], 2)]], 2), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary mb-3 d-block mx-auto",
      attrs: {
        "disabled": data.attributes.warehouse_flag == 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-wr', data.id)
        }
      }
    }, [_vm._v("\n                  Registrar ingreso\n                ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary d-block mx-auto",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.limitchangePaquete(data.id)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(data.attributes.warehouse_flag == 0 ?
      "Items incompletos" :
      "Items completos") + "\n                ")])])])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wr-slider-vertical"
  }, [_c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])]), _vm._v(" "), _c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])]), _vm._v(" "), _c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])]), _vm._v(" "), _c('article', {
    staticClass: "card-product"
  }, [_c('div', {
    staticClass: "card-product__text"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "card-product__info"
  }, [_vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#1EA9E4",
      "font-weight": "600"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal('modal-fotos')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link mr-2"
  }), _vm._v("\n              Ver fotos\n            ")])])])])])]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrders
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-wr"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Datos del paquete")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-wr')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Consignatario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.consignee),
      expression: "formCreate.consignee"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Carrier ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.carrier),
      expression: "formCreate.carrier"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "carrier", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Tracking ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.tracking),
      expression: "formCreate.tracking"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.tracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "tracking", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Peso")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.weight),
      expression: "formCreate.weight"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Unidad de peso:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unidad),
      expression: "formCreate.unidad"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "unidad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 12
    }
  }, [_vm._v("Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 22
    }
  }, [_vm._v("Oz")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comentario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.comment),
      expression: "formCreate.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fotos del paquete")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": "",
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar ingreso\n        ")])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-orden"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    staticStyle: {
      "max-width": "95vw",
      "max-height": "80vh"
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Asociar orden")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-orden')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n                      " + _vm._s(option.label) + "\n                    ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getPurchaseOrdersByPage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect form-control",
    attrs: {
      "id": "checkboxes2"
    }
  }, [_c('div', {
    staticClass: "selectBox",
    on: {
      "click": _vm.showCheckboxes
    }
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "overSelect"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "checkboxes"
    }
  }, [_c('label', {
    staticClass: "check-filter",
    attrs: {
      "for": "one"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.statusFlag.todos),
      expression: "tableData.statusFlag.todos"
    }],
    staticClass: "checkbox-style box-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tableData.statusFlag.todos) ? _vm._i(_vm.tableData.statusFlag.todos, null) > -1 : (_vm.tableData.statusFlag.todos)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.tableData.statusFlag.todos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tableData.statusFlag, "todos", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tableData.statusFlag, "todos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tableData.statusFlag, "todos", $$c)
        }
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v("Todos\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "check-filter",
    attrs: {
      "for": "two"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.statusFlag.activos),
      expression: "tableData.statusFlag.activos"
    }],
    staticClass: "checkbox-style box-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tableData.statusFlag.activos) ? _vm._i(_vm.tableData.statusFlag.activos, null) > -1 : (_vm.tableData.statusFlag.activos)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.tableData.statusFlag.activos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tableData.statusFlag, "activos", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tableData.statusFlag, "activos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tableData.statusFlag, "activos", $$c)
        }
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v("Activos\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "check-filter",
    attrs: {
      "for": "three"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.statusFlag.cancelados),
      expression: "tableData.statusFlag.cancelados"
    }],
    staticClass: "checkbox-style box-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tableData.statusFlag.cancelados) ? _vm._i(_vm.tableData.statusFlag.cancelados, null) > -1 : (_vm.tableData.statusFlag.cancelados)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.tableData.statusFlag.cancelados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tableData.statusFlag, "cancelados", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tableData.statusFlag, "cancelados", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tableData.statusFlag, "cancelados", $$c)
        }
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v("Cancelados\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bloc filter-block-alone"
  }, [_c('label', [_vm._v("Tipo de orden:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "store", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all",
      "selected": ""
    }
  }, [_vm._v("Todo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sendi",
      "data-content": "<span class='badge badge-info'>Ofertas de Grabr</span>"
    }
  }, [_vm._v("\n                    Sendi\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enviosusa",
      "data-content": "<span class='badge badge-warning'>Ofertas no Grabr</span>"
    }
  }, [_vm._v("\n                    Envios Usa\n                  ")])])])]), _vm._v(" "), (_vm.tableData.order_type === 4) ? _c('div', {
    staticClass: "filter-bloc"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('form', {
    staticClass: "formulario",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [(this.valorRadioButton == true) ? _c('span', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inicio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inicio"
    }
  }, [_vm._v("Todo")])]) : (this.valorRadioButton == false) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "todo"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.tableData.store, null)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", null)
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "todo"
    }
  }, [_vm._v("Todo")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "electro"
    },
    domProps: {
      "value": 'electro',
      "checked": _vm._q(_vm.tableData.store, 'electro')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'electro')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "electro"
    }
  }, [_vm._v("Electro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "fashion"
    },
    domProps: {
      "value": 'fashion',
      "checked": _vm._q(_vm.tableData.store, 'fashion')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'fashion')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fashion"
    }
  }, [_vm._v("Fashion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "kids"
    },
    domProps: {
      "value": 'kids',
      "checked": _vm._q(_vm.tableData.store, 'kids')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'kids')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kids"
    }
  }, [_vm._v("Kids")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "home"
    },
    domProps: {
      "value": 'home',
      "checked": _vm._q(_vm.tableData.store, 'home')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'home')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "home"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "pets"
    },
    domProps: {
      "value": 'pets',
      "checked": _vm._q(_vm.tableData.store, 'pets')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'pets')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pets"
    }
  }, [_vm._v("Pets")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.purchaseOrders != null && _vm.purchaseOrders.length > 0) ? _c('tbody', _vm._l((_vm.diasRestantes), function(purchaseOrder) {
    return _c('router-link', {
      key: purchaseOrder.id,
      attrs: {
        "to": {
          name: 'show-purchase-order',
          params: {
            id: purchaseOrder.id,
            orderData: purchaseOrder
          },
        }
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "image-table"
    }, [(
      purchaseOrder.attributes.product_image_url == null &&
      purchaseOrder.attributes.is_from_meli_flag
    ) ? _c('img', {
      attrs: {
        "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png',
        "width": "180px",
        "height": "260px"
      }
    }) : (
      purchaseOrder.attributes.product_image_url == null &&
      purchaseOrder.attributes.is_from_linio_flag
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/linio-logo.png",
        "width": "180px",
        "height": "260px"
      }
    }) : (purchaseOrder.attributes.product_image_url) ? _c('img', {
      attrs: {
        "src": purchaseOrder.attributes.product_image_url,
        "width": "180px",
        "height": "260px"
      }
    }) : _c('img', {
      attrs: {
        "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png',
        "width": "180px",
        "height": "260px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "description-title"
    }, [_c('span', {
      staticClass: "description-title-principal"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.product_info))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "code-order system-code"
    }, [_vm._v("SB #" + _vm._s(purchaseOrder.id) + "\n                          ")]), _vm._v(" "), (purchaseOrder.attributes.is_from_linio_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                            #" + _vm._s(purchaseOrder.attributes.linioOrder.attributes.linio_order_id))]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                            #" + _vm._s(purchaseOrder.attributes.meliOrder.attributes.meli_order_id))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: purchaseOrder.attributes.status == 10 ?
        'bg-danger' :
        'bg-success'
    }, [_vm._v("\n                            " + _vm._s(purchaseOrder.attributes.status == 10 ? "Cancelada" : "Activa") + "\n                          ")]), _vm._v(" "), (purchaseOrder.attributes.type === 2) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.reference_link) ? _c('span', {
      staticClass: "badge badge-primary bg-primary"
    }, [_vm._v(_vm._s(_vm.getStore(purchaseOrder.attributes.reference_link)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary bg-secondary"
    }, [_vm._v("WR -" + _vm._s(purchaseOrder.attributes.warehouse_admin))])]), _vm._v(" "), (purchaseOrder.attributes.is_from_grabr_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-grabr"
    }, [_vm._v("Grabr")]), _vm._v(" "), _c('span', {
      staticClass: "code-order grabr-code",
      on: {
        "click": function($event) {
          return _vm.toGrabrDetail(
            purchaseOrder.attributes.grabrOrder.attributes
            .grabr_order_number
          )
        }
      }
    }, [_vm._v(_vm._s(purchaseOrder.attributes.grabrOrder.attributes
      .grabr_order_number))])]) : (purchaseOrder.attributes.is_from_linio_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-linio"
    }, [_vm._v("Linio")])]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-meli"
    }, [_vm._v("Mercado libre")]), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'electro'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-primary"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'kids'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store magenta"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'fashion'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store brown"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'home'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                          ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('span', {}, [_vm._v(_vm._s(purchaseOrder.attributes.product_specimens))])]), _vm._v(" "), (
      purchaseOrder.attributes.origin != undefined &&
      purchaseOrder.attributes.destination != undefined
    ) ? _c('td', [_c('div', {
      staticClass: "ruta-order-container"
    }, [_c('div', {
      staticClass: "ruta-order-block ruta-order-image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/ruta.svg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-block"
    }, [_c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.origin.attributes.name))])]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.destination_address))])])])])]) : _c('td', [_c('span', {
      staticClass: "ruta-order"
    }, [_vm._v("No se ha definido")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "order-tag-container"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-pago-status.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (purchaseOrder.attributes.payed === 1) ? _c('span', [_vm._v("PENDIENTE")]) : (purchaseOrder.attributes.payed === 2) ? _c('span', [_vm._v("EN PROCESO")]) : (purchaseOrder.attributes.payed === 3) ? _c('span', [_vm._v("CONFIRMADO")]) : (purchaseOrder.attributes.payed === 10) ? _c('span', [_vm._v("RECHAZADO\"")]) : (purchaseOrder.attributes.payed === 11) ? _c('span', [_vm._v("RECLAMADO")]) : (purchaseOrder.attributes.payed === 12) ? _c('span', [_vm._v("RETORNADO")]) : _vm._e()]), _vm._v(" "), _c('span', [_c('ul', [_c('li', [_c('span', [(purchaseOrder.attributes.payment_method_flag === 5) ? _c('span', [(purchaseOrder.attributes.payment_code === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.payment_code !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 2) ? _c('span', [(
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 3) ? _c('span', [(
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 4) ? _c('span', [(
      purchaseOrder.attributes.atm_payment.mp_payment_id ===
      null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.atm_payment.mp_payment_id !==
      null && purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 6) ? _c('span', [_vm._v("Pago con saldo")]) : _vm._e(), _vm._v("\n                                - Código")])]), _vm._v(" "), _c('li', [(purchaseOrder.attributes.voucher_link === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.voucher_link !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-3.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-2.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e(), _vm._v("\n                              - Voucher\n                            ")])])]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-tracking-statu.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 1
    ) ? _c('span', [_vm._v("\n                            EN REVISIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 2
    ) ? _c('span', [_vm._v("\n                            COMPRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 3
    ) ? _c('span', [_vm._v("\n                            PREPARANDO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 4
    ) ? _c('span', [_vm._v("\n                            LISTO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 5
    ) ? _c('span', [_vm._v("\n                            ENVIADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 6
    ) ? _c('span', [_vm._v("\n                            LISTO PARA ENTREGAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 7
    ) ? _c('span', [_vm._v("\n                            ENTREGADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 8
    ) ? _c('span', [_vm._v("\n                            SINIESTRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 9
    ) ? _c('span', [_vm._v("\n                            EN PROCESO DE DEVOLUCIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 10
    ) ? _c('span', [_vm._v("\n                            RETORNADO AL PROVEEDOR")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_c('span', {}, [(purchaseOrder.attributes.vouchers_usa.length !== 0) ? _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-1.svg",
        "width": "50",
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-2.svg",
        "width": "50",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('td', [_c('span', {}, [_vm._v(_vm._s(purchaseOrder.attributes.order_create_date))])]), _vm._v(" "), (purchaseOrder.attributes.hasOwnProperty('promised_delivery_date')) ? _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDate")(purchaseOrder.attributes.promised_delivery_date)))]), _vm._v(" "), _c('div', {
      staticClass: "daysLeft"
    }, [(purchaseOrder.resultado > 15) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.resultado) + " días")]) : _vm._e(), _vm._v(" "), (purchaseOrder.resultado > 10 && purchaseOrder.resultado <= 15) ? _c('span', {
      staticClass: "badge badge-primary bg-warning"
    }, [_vm._v("\n                          " + _vm._s(purchaseOrder.resultado) + " días\n                        ")]) : _vm._e(), _vm._v(" "), (purchaseOrder.resultado <= 10) ? _c('span', {
      staticClass: "badge badge-primary bg-danger"
    }, [(Math.sign(purchaseOrder.resultado) === 1) ? _c('span', [_vm._v(_vm._s(purchaseOrder.resultado) + " días\n                          ")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === -1) ? _c('span', [_vm._v("\n                            Retraso de\n                            " + _vm._s(Math.abs(purchaseOrder.resultado)) + " dias")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === 0) ? _c('span', [_vm._v("\n                            Retraso")]) : _vm._e()]) : _vm._e()])]) : _c('td', [_c('span', {}, [_vm._v("No definido")])])])])
  }), 1) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-fotos"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    staticStyle: {
      "max-width": "70vw",
      "width": "70vw"
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Fotos del producto")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-fotos')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _vm._m(33)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Warehouse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {}, [_c('label', [_vm._v("Buscar por:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between col-6 px-0",
    staticStyle: {
      "gap": ".75rem"
    }
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("Nombre de orden")]), _vm._v(" "), _c('option', [_vm._v("Número de orden")]), _vm._v(" "), _c('option', [_vm._v("Número de WR")])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("\n                Buscar\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-product__title"
  }, [_c('span', [_vm._v("#123456")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              Jesus Gallardo\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              Lorem, ipsum dolor.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n              #12345\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              100 "), _c('b', [_vm._v("kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remitente")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Órdenes de compra")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "kt-form__label"
  }, [_c('option', [_vm._v("Seleccionar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "1fr 1fr 1fr",
      "gap": "1rem"
    }
  }, [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 1855:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-start py-2 px-4"
  }, [_c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Recuperar Contraseña")]), _vm._v(" "), _c('p', [_vm._v("Ingresa el correo electrónico asociado a tu cuenta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group w-100"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": "getEmail"
    }
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "getEmail",
      "aria-describedby": "getEmail",
      "placeholder": "Ingresa tu email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary mt-4 btn-lg btn-block",
    attrs: {
      "to": "/correctpass"
    }
  }, [_vm._v("Continuar")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1856:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datetime-picker",
    style: ({
      width: _vm.width
    })
  }, [_c('input', {
    style: (_vm.styleObj),
    attrs: {
      "type": "text",
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "picker-wrap"
  }, [_c('table', {
    staticClass: "date-picker"
  }, [_c('thead', [_c('tr', {
    staticClass: "date-head"
  }, [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "btn-prev",
    on: {
      "click": function($event) {
        return _vm.yearClick(-1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "show-year"
  }, [_vm._v(_vm._s(_vm.now.getFullYear()))]), _vm._v(" "), _c('span', {
    staticClass: "btn-next",
    on: {
      "click": function($event) {
        return _vm.yearClick(1)
      }
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "btn-prev",
    on: {
      "click": function($event) {
        return _vm.monthClick(-1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "show-month"
  }, [_vm._v(_vm._s(_vm.months[_vm.now.getMonth()]))]), _vm._v(" "), _c('span', {
    staticClass: "btn-next",
    on: {
      "click": function($event) {
        return _vm.monthClick(1)
      }
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('tr', {
    staticClass: "date-days"
  }, _vm._l((_vm.days), function(day) {
    return _c('th', [_vm._v(_vm._s(day))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((6), function(i) {
    return _c('tr', _vm._l((7), function(j) {
      return _c('td', {
        class: _vm.date[i * 7 + j] && _vm.date[i * 7 + j].status,
        attrs: {
          "date": _vm.date[i * 7 + j] && _vm.date[i * 7 + j].date
        },
        on: {
          "click": function($event) {
            return _vm.pickDate(i * 7 + j)
          }
        }
      }, [_vm._v(_vm._s(_vm.date[i * 7 + j] && _vm.date[i * 7 + j].text))])
    }), 0)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1857:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu drop-edit",
    attrs: {
      "aria-labelledby": "dropdown"
    }
  }, [_c('div', {
    staticClass: "link-user"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "link-user-content"
  }, [_c('span', {
    staticClass: "link-user-content-name"
  }, [_vm._v(_vm._s(_vm.$store.state.user.attributes.profile.attributes.name) + " " + _vm._s(_vm.$store.state.user.attributes.profile.attributes.surnames))]), _vm._v(" "), (_vm.$store.state.user.type === 'Admin') ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Administrador general")]) : (_vm.$store.state.user.type === 'Operator' && _vm.$store.state.user.attributes.operator_type === 1) ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Operador de envío")]) : (_vm.$store.state.user.type === 'Operator' && _vm.$store.state.user.attributes.operator_type === 2) ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Operador de recepción")]) : (_vm.$store.state.user.type === 'Client') ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Cliente")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "link link-drop",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePaswood()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "img-nav",
    attrs: {
      "src": "/static/img/changePasswoord.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link link-drop",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('img', {
    staticClass: "img-nav",
    attrs: {
      "src": "/static/img/logout.svg",
      "alt": ""
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-avatar",
    attrs: {
      "id": "dropdown",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "user-circle"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/user/admin.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-online"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-user-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/user/admin.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-option"
  }, [_c('span', [_vm._v("Cambiar contraseña")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-option"
  }, [_c('span', [_vm._v("Cerrar sesion")])])
}]}

/***/ }),

/***/ 1858:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-item",
    on: {
      "click": _vm.readNotification
    }
  }, [_c('div', {
    staticClass: "notification-item-text notification-item-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.notification.data.title))]), _vm._v(" "), (_vm.readFlag) ? _c('div', {
    staticClass: "flag flag-yes"
  }, [_c('span', [_vm._v("Leido")])]) : _c('div', {
    staticClass: "flag flag-no"
  }, [_c('span', [_vm._v("No leido")])])]), _vm._v(" "), _c('span', {
    staticClass: "notification-item-text notification-item-msj"
  }, [_vm._v(_vm._s(_vm.notification.data.message))]), _vm._v(" "), _c('span', {
    staticClass: "notification-item-text notification-item-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.notification.data.sended_at.date)))])])
},staticRenderFns: []}

/***/ }),

/***/ 1859:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Codigo del cliente:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.codigo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dniNumber),
      expression: "dniNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.inputDisabled
    },
    domProps: {
      "value": (_vm.dniNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dniNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.inputChangeDisabled.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.inputDisabled ? "Quitar Disabled" : "Agregar Disabled") + "\n        ")]), _vm._v(" "), (_vm.inputDisabled === false) ? _c('button', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeNumberDni.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Cambiar número de DNI\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("E-mail de cuenta:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Estado de Verificado:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.varificado.verified ? 'Verificado' : 'Sin verificar'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Tipo de Registro:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.estado
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("URL DNI anterior -> Estado - " + _vm._s(_vm.credential.statuAnterior) + " : ("), _c('a', {
    attrs: {
      "href": _vm.credential.dniAnterior,
      "target": "_Blank"
    }
  }, [_vm._v("Revisar")]), _vm._v("\n          )")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: [
      (_vm.credential.statuAnterior === 1 ? '' : '') ||
      (_vm.credential.statuAnterior === 2 ? 'border border-warning' : '') ||
      (_vm.credential.statuAnterior === 3 ? 'border border-success' : '') ||
      (_vm.credential.statuAnterior === 4 ? 'border border-danger' : '') ],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.dniAnterior
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni.anterior),
      expression: "dni.anterior"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dni, "anterior", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeStatusDni(true)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 - El usuario no subio ningún archivo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2 - En espera para que el Admin verifique")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("3 - DNI anterior verificado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("4 - Archivo Rechazado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("URL DNI posterior -> Estado - " + _vm._s(_vm.credential.statuPosterior) + " : ("), _c('a', {
    attrs: {
      "href": _vm.credential.dniPosterior,
      "target": "_Blank"
    }
  }, [_vm._v("Revisar")]), _vm._v(")\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: [
      (_vm.credential.statuPosterior === 1 ? '' : '') ||
      (_vm.credential.statuPosterior === 2 ? 'border border-warning' : '') ||
      (_vm.credential.statuPosterior === 3 ? 'border border-success' : '') ||
      (_vm.credential.statuPosterior === 4 ? 'border border-danger' : '') ],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.credential.dniPosterior
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni.posterior),
      expression: "dni.posterior"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dni, "posterior", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeStatusDni(false)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 - El usuario no subio ningún archivo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2 - En espera para que el Admin verifique")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("3 - DNI posterior verificado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("4 - Archivo Rechazado")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1860:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('datepicker', {
    attrs: {
      "readonly": true,
      "format": "MMM/D/YYYY",
      "id": "dateInput",
      "width": "100%"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("With icons")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("With border indicator")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h4', [_vm._v("Select Options")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Inputs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Username",
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Email",
      "type": "email"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-success"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inputSuccess"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  }), _vm._v(" Input with success")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputSuccess",
      "placeholder": "Enter ...",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Help block with success")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-error"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inputError"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times-circle-o"
  }), _vm._v(" Input with error")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputError",
      "placeholder": "Enter ...",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Help block with error")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select")]), _vm._v(" "), _c('select', {
    staticClass: "form-control"
  }, [_c('option', [_vm._v("option 1")]), _vm._v(" "), _c('option', [_vm._v("option 2")]), _vm._v(" "), _c('option', [_vm._v("option 3")]), _vm._v(" "), _c('option', [_vm._v("option 4")]), _vm._v(" "), _c('option', [_vm._v("option 5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Multiple")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    }
  }, [_c('option', [_vm._v("option 1")]), _vm._v(" "), _c('option', [_vm._v("option 2")]), _vm._v(" "), _c('option', [_vm._v("option 3")]), _vm._v(" "), _c('option', [_vm._v("option 4")]), _vm._v(" "), _c('option', [_vm._v("option 5")])])])
}]}

/***/ }),

/***/ 1861:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes,
      "activeRoute": _vm.activeRoute
    }
  }), _vm._v(" "), (_vm.dataPackage) ? _c('div', [_c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Paquete " + _vm._s(_vm.dataPackage.attributes.package_name))]), _vm._v(" "), _c('div', {
    staticClass: "rr"
  }, [_c('a', {
    staticClass: "btn btn-clean btn-clean-white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-left"
  }), _vm._v("\n          Volver\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    staticClass: "detalle-inci"
  }, [_c('span', [_vm._v("Información del paquete")]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(" " + _vm._s(_vm.dataPackage.attributes.partial_weight))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_order))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_reposition))]), _vm._v(" "), (_vm.dataPackage.attributes.items_from_reposition > 0) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showRepositionItemsDetail
    }
  }, [_vm._v("\n              Ver detalles\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.number_of_items))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detalle-inci"
  }, [(_vm.dataPackage.attributes.evaluated == 1) ? _c('div', [_c('span', [_vm._v("Detalle de evaluación de paquete")]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.real_number_of_items))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.number_of_items_correct))])])]), _vm._v(" "), (_vm.dataPackage.attributes.incidents.length > 0) ? _c('div', {
    staticClass: "si-incidencias-container"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo mensaje-inci si-incidencias"
  }, [_c('h1', [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v("Se generaron "), _c('span', [_vm._v(_vm._s(_vm.dataPackage.attributes.incidents.length))]), _vm._v(" incidencias")])])]), _vm._v(" "), _vm._l((_vm.dataPackage.attributes.incidents), function(incident) {
    return _c('div', {}, [(incident.attributes.clusterable_type == 'different_quantity') ? _c('div', {
      staticClass: "inci-container"
    }, [_c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Descripción: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.description))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('h1', [_vm._v(" Déficit")]) : (incident.attributes.clusterable.attributes.delta_type == 2) ? _c('h1', [_vm._v("Exceso")]) : _c('h1', [_vm._v(" No definido")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Items correctos sobre totales en el paquete: ")]), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(incident.attributes.clusterable.attributes.correct_items + "/" + incident.attributes.clusterable.attributes.total_items))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v(" " + _vm._s(incident.attributes.clusterable.attributes.delta_type == 1 ? 'Ejemplares a reponer:' : 'Ejemplares en exceso') + " ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('div', [_c('h1', [_vm._v(" " + _vm._s(_vm.deficitItems))]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showDeficitIncidentItemsDetail(incident.id)
        }
      }
    }, [_vm._v("\n                        Ver detalles\n                      ")]) : _vm._e()]) : _c('div', [_c('p', [_vm._v(" " + _vm._s((parseInt(incident.attributes.clusterable.attributes.total_items) - parseInt(incident.attributes.clusterable.attributes.correct_items)) * (-1)))])])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'waste') ? _c('div', {
      staticClass: "inci-container"
    }, [_c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Descripción: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.description))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.correct_product_flag == 1) ? _c('h1', [_vm._v(" De merma del producto correcto")]) : _c('h1', [_vm._v(" De merma del producto equivocado")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Ejemplares:")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.wasted_items) + " ")])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'wrong') ? _c('div', {
      staticClass: "inci-container"
    }, [_c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Descripción: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.description))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.wasted_flag == 0) ? _c('h1', [_vm._v(" De producto equivocado sin merma")]) : _c('h1', [_vm._v(" De producto equivocado con merma")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Ejemplares: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.wrong_items))])])]) : _vm._e()])
  })], 2) : (_vm.dataPackage.attributes.incidents.length == 0) ? _c('div', [_vm._m(6)]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modalDetailItemsFail",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalDetailItemsFail"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Detalle de ejemplares del paquete actual repuestos en nuevos paquetes")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalDetailItemsFail
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_vm._l((_vm.deficitPackageRepositions), function(packageRepositionLevel) {
    return _c('div', [_c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("REPUESTOS POR  " + _vm._s(_vm._f("cardinalityUpper")(packageRepositionLevel.level)) + " VEZ ")])])]), _vm._v(" "), (packageRepositionLevel.packageReposition.attributes.packages_info_free_by != null && packageRepositionLevel.packageReposition.attributes.packages_info_free_by.length > 0) ? _c('div', _vm._l((packageRepositionLevel.packageReposition.attributes.packages_info_free_by), function(packageInfo) {
      return _c('div', [_c('hr'), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Paquete nuevo ")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_c('router-link', {
        attrs: {
          "to": {
            name: 'show-package',
            params: {
              id: packageInfo.attributes.id
            }
          }
        }
      }, [_vm._v(_vm._s(packageInfo.attributes.package_name))])], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Ejemplares repuestos")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_vm._v("\n                  " + _vm._s(packageInfo.attributes.free_detail.free_items))])])])])
    }), 0) : _c('div', [_c('p', [_vm._v("Aún no se han repuesto ejemplares")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez reemplazados")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(packageRepositionLevel.items_replaced))])])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez pendientes ")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(packageRepositionLevel.packageReposition.attributes.pendient_items))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Subtotal ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez  ")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(parseInt(packageRepositionLevel.packageReposition.attributes.pendient_items) + parseInt(packageRepositionLevel.items_replaced)))])])])])
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h4', [_vm._v("Total ejemplares a reponer en nuevos paquetes  ")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.deficitItems))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDetailItemsFail()
      }
    }
  }, [_vm._v("Cerrar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalDetailReposition",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalDetailReposition"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Detalle de ejemplares de otros paquetes repuestos en el paquete actual")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalDetailReposition
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_vm._l((_vm.packageRepositions), function(packageRepositionLevel) {
    return _c('div', [_c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("REPUESTOS POR  " + _vm._s(_vm._f("cardinalityUpper")(packageRepositionLevel.level)) + " VEZ ")])])]), _vm._v(" "), _vm._l((packageRepositionLevel.packageRepositions), function(packageReposition) {
      return _c('div', [_c('hr'), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Paquete de origen ")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_c('router-link', {
        attrs: {
          "to": {
            name: 'show-package',
            params: {
              id: packageReposition.attributes.package.id
            }
          }
        }
      }, [_vm._v(_vm._s(packageReposition.attributes.package.attributes.package_name))])], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Ejemplares repuestos")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_vm._v("\n                  " + _vm._s(packageReposition.attributes.free_detail.free_items))])])])])
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Subtotal ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez ")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(packageRepositionLevel.subtotal))])])])], 2)
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h4', [_vm._v("Total ejemplares de otros paquetes  ")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.dataPackage.attributes.items_from_reposition))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDetailReposition()
      }
    }
  }, [_vm._v("cerrar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Peso aproximado (lb):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Ejemplares originales:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Ejemplares de otros paquetes: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Ejemplares totales:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("N° items evaluados:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("N° items correctos:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo mensaje-inci no-incidencias"
  }, [_c('h1', [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v("No se generaron incidencias")])])])
}]}

/***/ }),

/***/ 1862:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Mi Perfil "), (_vm.typeUser === 'admin') ? _c('span', [_vm._v(" - Aministrador")]) : _c('span', [_vm._v(" - Operador")])])]), _vm._v(" "), (_vm.typeUser === 'admin') ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.editUser()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-edit"
  }), _vm._v("Editar Administrador")])], 1) : _c('div', {
    staticClass: "form-title-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.editOperator()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-edit"
  }), _vm._v("Editar Operador")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Nombre del Usuario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameUser),
      expression: "nameUser"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "nameUSer"
    },
    domProps: {
      "value": (_vm.nameUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameUser = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido del Usuario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastnameUser),
      expression: "lastnameUser"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "lastNameUSer"
    },
    domProps: {
      "value": (_vm.lastnameUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastnameUser = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Usuario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "userName"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo: ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genderUser),
      expression: "genderUser"
    }],
    staticClass: "custom-select form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "name": "sexo",
      "id": "gender",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.genderUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Femenino")])])])]), _vm._v(" "), (_vm.typeUser === 'operator') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'admin') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Usuario")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeUser),
      expression: "typeUser"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "typeUSer",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.typeUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.typeUser = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'operator') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Operador ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operadorType),
      expression: "operadorType"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "operadorType",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.operadorType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.operadorType = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'operator') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código de ciudad ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityId),
      expression: "cityId"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "cityId",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.cityId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cityId = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'admin') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Codigo del pais: ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codUser),
      expression: "codUser"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "celUSer"
    },
    domProps: {
      "value": (_vm.codUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codUser = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'admin') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Celular: ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.celUser),
      expression: "celUser"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "type": "tel",
      "maxlength": "9",
      "aria-describedby": "celUSer"
    },
    domProps: {
      "value": (_vm.celUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.celUser = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'admin') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fecha de Nacimiento: ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brithUser),
      expression: "brithUser"
    }],
    staticClass: "form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "id": "date",
      "type": "date",
      "placeholder": "Fecha de nacimiento",
      "onkeydown": "return false",
      "required": ""
    },
    domProps: {
      "value": (_vm.brithUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brithUser = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('p'), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.desactivar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-edit"
  }), _vm._v("Desactivar Cuenta")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1863:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.nombre + _vm.perfil.apellido + _vm.credential.codigo
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "11751 SW 103RD LN CODE 169",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Ciudad:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "MIAMI",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "Florida",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Código Postal:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "33186",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("País:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "Estados Unidos",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "(202) 977-3377",
      "disabled": ""
    }
  })])])
}]}

/***/ }),

/***/ 1864:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 1865:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [(_vm.afterSavePackages) ? _c('div', {
    staticClass: "flag"
  }, [(_vm.dataPackage.attributes.evaluated == 0) ? _c('p', {
    staticClass: "tag no-evaluado"
  }, [_vm._v("No evaluado")]) : _vm._e(), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 1) ? _c('p', {
    staticClass: "tag evaluado"
  }, [_vm._v("Evaluado")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [(_vm.dataPackage.attributes.purchaseOrder.attributes.product_image_url == null) ? _c('img', {
    attrs: {
      "src": 'https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png',
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.dataPackage.attributes.purchaseOrder.attributes.product_image_url,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "productCode"
  }, [_vm._v("#" + _vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.order_code + " - " + _vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.partial_weight) + " Kg")]), _vm._v(" "), _c('span', {
    staticClass: "productName product-truncate bold"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.product_info))]), _vm._v(" "), _c('span', [_vm._v("Cantidad: " + _vm._s(_vm.dataPackage.attributes.number_of_items))])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1866:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [(_vm.dataOrder.order_info.product_image_url == null) ? _c('img', {
    attrs: {
      "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'
    }
  }) : _c('img', {
    staticClass: "img-table",
    attrs: {
      "src": _vm.dataOrder.order_info.product_image_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [(isNaN(_vm.dataOrder.partial_price)) ? _c('span', [_c('span', {
    staticClass: "productName"
  }, [_vm._v("$ " + _vm._s(_vm.dataOrder.realPrice) + " ")])]) : (_vm.dataOrder.partial_price === 0) ? _c('span', [_c('span', {
    staticClass: "productName"
  }, [_vm._v("$ " + _vm._s(_vm.dataOrder.realPrice) + " ")])]) : _c('span', [_c('span', {
    staticStyle: {
      "text-decoration-line": "line-through",
      "color": "#716d68",
      "font-size": ".8em"
    }
  }, [_vm._v("$ " + _vm._s(_vm.dataOrder.realPrice))]), _vm._v(" "), (_vm.dataOrder.partial_price !== 0) ? _c('span', {
    staticStyle: {
      "color": "#716d68",
      "font-size": ".8em"
    }
  }, [_vm._v(" - $ " + _vm._s(_vm.dataOrder.partial_price))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v("#" + _vm._s(_vm.dataOrder.order_info.order_code))]), _vm._v(" "), _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataOrder.order_info.weight_kg) + " Kg")]), _vm._v(" "), _c('span', {
    staticClass: "productName product-truncate bold"
  }, [_vm._v(_vm._s(_vm.dataOrder.order_info.product_info))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "type": "text",
      "numeric": "",
      "min": 1,
      "max": _vm.dataOrder.order_info.product_specimens
    },
    domProps: {
      "value": _vm.dataOrder.number_of_items
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cantidad2"
  }, [(isNaN(_vm.dataOrder.partial_price)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updatePrice),
      expression: "updatePrice"
    }],
    staticClass: "num ctrl-num",
    staticStyle: {
      "width": "80px",
      "height": "40px"
    },
    attrs: {
      "placeholder": 0,
      "type": "text"
    },
    domProps: {
      "value": (_vm.updatePrice)
    },
    on: {
      "keydown": function($event) {
        return _vm.noPuntoComa($event)
      },
      "keypress": _vm.onlyNumber,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.updatePrice = $event.target.value
      }, function($event) {
        return _vm.updatePrecio($event.target.value)
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updatePrice),
      expression: "updatePrice"
    }],
    staticClass: "num ctrl-num",
    staticStyle: {
      "width": "80px",
      "height": "40px"
    },
    attrs: {
      "placeholder": _vm.dataOrder.partial_price,
      "type": "text"
    },
    domProps: {
      "value": (_vm.updatePrice)
    },
    on: {
      "keydown": function($event) {
        return _vm.noPuntoComa($event)
      },
      "keypress": _vm.onlyNumber,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.updatePrice = $event.target.value
      }, function($event) {
        return _vm.updatePrecio($event.target.value)
      }]
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proAdd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.alertQuitPackage
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1867:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control form-search",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n              " + _vm._s(option.label) + "\n            ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone filter-block-ship",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('label', [_vm._v("Estatus de DNI:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterStatusDni),
      expression: "tableData.filterStatusDni"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterStatusDni", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getUsers()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pendiente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Esperando revisión")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Verificado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Rechazado")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.users), function(user) {
    return _c('router-link', {
      key: user.id,
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: user.id
          },
        }
      }
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.userable.client_code) + "\n                "), _c('br'), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes.facebook_id
    ) ? _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v("Facebook\n                ")]) : (
      user.attributes.profile.attributes.userable.attributes.gmail_id
    ) ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Gmail")]) : _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v("Formulario")])])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.userable.attributes.store_id === 1 ?
      "Sendi" :
      "Envios"))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("\n                " + _vm._s(user.attributes.profile.attributes.document_number ?
      user.attributes.profile.attributes.document_number :
      "sin documento")), _c('br'), _vm._v(" "), _c('ul', {
      staticClass: "listStyle"
    }, [_c('li', [_c('img', {
      attrs: {
        "src": "/static/img/dni/anterior-dni.png",
        "width": "30"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: [
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 1 ?
          ' bg-secondary' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 2 ?
          ' bg-warning' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 3 ?
          ' bg-success' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 4 ?
          ' bg-danger' :
          '') ]
    }, [(
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 1
    ) ? _c('span', [_vm._v("Pendiente")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 2
    ) ? _c('span', [_vm._v("Esperando Revisión")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 3
    ) ? _c('span', [_vm._v("Verificado")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 4
    ) ? _c('span', [_vm._v("Rechazado")]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('img', {
      attrs: {
        "src": "/static/img/dni/posterior-dni.png",
        "width": "30"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: [
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 1 ?
          ' bg-secondary' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 2 ?
          ' bg-warning' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 3 ?
          ' bg-success' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 4 ?
          ' bg-danger' :
          '') ]
    }, [(
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 1
    ) ? _c('span', [_vm._v("Pendiente")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 2
    ) ? _c('span', [_vm._v("Esperando Revisión")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 3
    ) ? _c('span', [_vm._v("Verificado")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 4
    ) ? _c('span', [_vm._v("Rechazado")]) : _vm._e()])])])])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.email))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.name) + "\n                " + _vm._s(user.attributes.profile.attributes.surnames))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.country_code) + "\n                " + _vm._s(user.attributes.profile.attributes.cellphone ?
      user.attributes.profile.attributes.cellphone :
      "sin teléfono"))])])])])
  }), 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getUsers
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1868:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content pt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.cotizaciones), function(data) {
    return _c('tr', {
      key: data
    }, [_c('td', [(data.url === 'vacío') ? _c('a', {
      staticClass: "line-clamp-2"
    }, [_vm._v("\n                Precio : " + _vm._s(data.price) + " "), _c('br'), _vm._v("\n                Peso : " + _vm._s(data.weight) + "\n              ")]) : _c('a', {
      staticClass: "line-clamp-2 link",
      attrs: {
        "target": "_blank",
        "href": data.url
      }
    }, [_vm._v("\n                " + _vm._s(data.url) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "180px"
      }
    }, [_c('p', {
      staticClass: "user"
    }, [_vm._v("\n                " + _vm._s(data.id_order ? "Convertido en Orden" : "Simple cotización") + "\n              ")])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.id_order) + "\n            ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: data.idUsuario
          },
        },
        "target": "_Blank"
      }
    }, [_vm._v("\n                " + _vm._s(data.idUsuario))])], 1), _vm._v(" "), _c('td', [(data.idStore === 1) ? _c('span', [_vm._v("SENDI")]) : (data.idStore === 2) ? _c('span', [_vm._v("ENVIOS")]) : (data.idStore === null) ? _c('span', [_vm._v("\n                " + _vm._s(data.id_order) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.created_at))])])
  }), 0)])])]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrdersByPage
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex justify-content-between px-3"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title"
  }, [_vm._v("Cotizaciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Link cotizado")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("ID de la orden")]), _vm._v(" "), _c('th', [_vm._v("ID del usuario")]), _vm._v(" "), _c('th', [_vm._v("Store")]), _vm._v(" "), _c('th', [_vm._v("Fecha")])])])
}]}

/***/ }),

/***/ 1869:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "purchaseOrders"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-title-block form-title-principal",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("Usuarios")]), _vm._v(" "), _c('div', {
    staticClass: "form-title-block",
    staticStyle: {
      "margin-left": "79%"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Añadir Usuario\n                   ")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "modalReevaluation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalReevaluation"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkServer(_vm.typeUser)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Registro de Usuarios")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReevaluetion
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-tabs",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de usuario :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeUser),
      expression: "typeUser"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cliente"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "operador"
    }
  }, [_vm._v("Operador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("Administrador")])])]), _vm._v(" "), ((_vm.typeUser === 'cliente') || (_vm.typeUser === 'administrador') || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": 50,
      "id": "firstname",
      "aria-describedby": "firstname",
      "placeholder": "Ingrese el  nombre",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseName) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Apellido :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": 100,
      "id": "lastname",
      "aria-describedby": "lastname",
      "placeholder": "Ingrese el apellido",
      "required": ""
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseLast) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseLast))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateUser,
    attrs: {
      "type": "email",
      "id": "email",
      "aria-describedby": "email",
      "placeholder": "Ingresa el email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseUser) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUser))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Username :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateUserName,
    attrs: {
      "type": "text",
      "id": "username",
      "aria-describedby": "username",
      "placeholder": "Ingresa el username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseUserName) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUserName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.typeUser === 'cliente') || (_vm.typeUser === 'administrador') || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("DNI :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dni),
      expression: "dni"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dni",
      "aria-describedby": "dni",
      "placeholder": "Ingresa el DNI",
      "required": ""
    },
    domProps: {
      "value": (_vm.dni)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dni = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Teléfono :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone3",
      "aria-describedby": "phone",
      "placeholder": "Numero de teléfono",
      "required": ""
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responsePhone != '') ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePhone))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código de País :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country_code),
      expression: "country_code"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country_code = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listCountry), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.dial_code
      }
    }, [_vm._v(_vm._s(option.dial_code) + " - " + _vm._s(option.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), ((_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de operador :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operator_type),
      expression: "operator_type"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "id": "operator_type",
      "name": "operator_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operator_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Envio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Recepción")])])]) : _vm._e(), _vm._v(" "), ((_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar ciudad :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city_id),
      expression: "city_id"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "id": "city_id",
      "name": "city_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.city_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Miami")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Buenos Aires")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("Lima")])])]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Género :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sexo),
      expression: "sexo"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "id": "genre",
      "name": "sexo",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sexo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "true",
      "disabled": "disabled"
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Femenino")])]), _vm._v(" "), (_vm.responseGenre) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseGenre))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de nacimiento :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseDate) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseDate))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Ingrese la contraseña",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responsePass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePass))]) : _vm._e(), _vm._v(" "), (_vm.response2Pass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.response2Pass))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeUser === 'cliente' || _vm.typeUser === 'administrador' || (_vm.typeUser === 'operador')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Repita contraseña :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkPassword),
      expression: "checkPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password2",
      "placeholder": "Repita la contraseña",
      "required": ""
    },
    domProps: {
      "value": (_vm.checkPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseCheck) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseCheck))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.typeUser.length > 0) ? _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "id": "submit"
    }
  }, [_vm._v("Registrar Usuario")])]) : _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Registrar Usuario")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content",
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('form', {
    staticClass: "formulario2",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionUser),
      expression: "selectionUser"
    }],
    attrs: {
      "type": "radio",
      "id": "cli"
    },
    domProps: {
      "value": 'clientes',
      "checked": _vm._q(_vm.selectionUser, 'clientes')
    },
    on: {
      "change": function($event) {
        _vm.selectionUser = 'clientes'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cli"
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionUser),
      expression: "selectionUser"
    }],
    attrs: {
      "type": "radio",
      "id": "oper"
    },
    domProps: {
      "value": 'operadores',
      "checked": _vm._q(_vm.selectionUser, 'operadores')
    },
    on: {
      "change": function($event) {
        _vm.selectionUser = 'operadores'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "oper"
    }
  }, [_vm._v("Operadores")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionUser),
      expression: "selectionUser"
    }],
    attrs: {
      "type": "radio",
      "id": "admin"
    },
    domProps: {
      "value": 'administradores',
      "checked": _vm._q(_vm.selectionUser, 'administradores')
    },
    on: {
      "change": function($event) {
        _vm.selectionUser = 'administradores'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "admin"
    }
  }, [_vm._v("Administradores")])])])])])], 1), _vm._v(" "), _c('div', {}, [(_vm.selectionUser == 'clientes') ? _c('chart1') : _vm._e(), _vm._v(" "), (_vm.selectionUser == 'operadores') ? _c('chart2') : _vm._e(), _vm._v(" "), (_vm.selectionUser == 'administradores') ? _c('chart3') : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1870:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "flag"
  }, [(_vm.dataPackage.attributes.evaluated == 0) ? _c('p', {
    staticClass: "tag no-evaluado"
  }, [_vm._v("No evaluado")]) : _vm._e(), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 1) ? _c('p', {
    staticClass: "tag evaluado"
  }, [_vm._v("Evaluado")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "productCode bold"
  }, [_vm._v("#" + _vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.order_code + " - " + _vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.fromShipmentFlag && _vm.dataPackage.attributes.purchaseOrder.attributes.has_packages_with_reposition && _vm.dataPackage.attributes.has_reposition_generated && !_vm.dataPackage.attributes.order_reposition_evaluated) ? _c('span', [_vm._v("\n            Este paquete necesita de reposiciones, por lo que se debe autorizar su orden\n          ")]) : (_vm.fromShipmentFlag && _vm.dataPackage.attributes.purchaseOrder.attributes.has_packages_with_reposition && !_vm.dataPackage.attributes.has_reposition_generated && !_vm.dataPackage.attributes.order_reposition_evaluated) ? _c('span', [_vm._v("\n            Este paquete no necesita reposiciones, pero hay otros paquetes de la misma orden que sí lo necesitan\n          ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n          \n          Ejemplares originales: "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_order))]), _vm._v("\n          Ejemplares de reposición: "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_reposition))]), _vm._v("\n          Ejemplares totales: "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.number_of_items))])]), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 0) ? _c('div', {
    staticClass: "botones-evaluacion"
  }, [_c('div', [(_vm.dataPackage.attributes.evaluated == 0) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.evaluatePackage
    }
  }, [_vm._v("Evaluar")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 1) ? _c('div', {
    staticClass: "botones-evaluacion"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'show-package',
        params: {
          id: _vm.dataPackage.id
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Ver detalle")])])], 1) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalStatePackages",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalStatePackages"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ingresar datos de evaluación del paquete")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalStatePackages
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('span', {
    staticClass: "modal-subtitle"
  }, [_vm._v("Evaluación del paquete #" + _vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.order_code + " - " + _vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares exitosos ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state1),
      expression: "state1"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_1"
    },
    domProps: {
      "value": (_vm.state1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_1')),
      expression: "errors.has('state_1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_1')))]), _vm._v(" "), (_vm.deltaItems != null && parseInt(_vm.deltaItems) != 0) ? _c('span', [_vm._v(_vm._s(parseInt(_vm.deltaItems) > 0 ? "Hay un déficit de " + parseInt(_vm.deltaItems) + " items" : "Hay un exceso de " + parseInt(_vm.deltaItems) * (-1) + " items"))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares del producto correcto con desperfectos ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state2),
      expression: "state2"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_2"
    },
    domProps: {
      "value": (_vm.state2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_2')),
      expression: "errors.has('state_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_2')))]), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares de otro producto sin desperfectos ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state3),
      expression: "state3"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_3"
    },
    domProps: {
      "value": (_vm.state3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_3')),
      expression: "errors.has('state_3')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_3')))]), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares de otro producto con desperfectos  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state4),
      expression: "state4"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_4"
    },
    domProps: {
      "value": (_vm.state4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_4')),
      expression: "errors.has('state_4')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_4')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.askToSendEvaluation
    }
  }, [_vm._v("Evaluar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalIncidentsPackages",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalIncidentsPackages"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Evaluación del paquete # " + _vm._s(_vm.dataPackage.id) + " - " + _vm._s(_vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalIncidentsPackages
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [(_vm.listIncidents.length > 0) ? _c('div', [_c('div', {}, [_c('h5', [_vm._v("Incidencias generadas")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.listIncidents), function(incident) {
    return _c('div', {}, [_c('span', [_vm._v("Descripcion:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(incident.attributes.description))]), _vm._v(" "), (incident.attributes.clusterable_type == 'different_quantity') ? _c('div', {}, [_c('div', {}, [_c('span', [_vm._v("Ejemplares correctos sobre totales en el paquete: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.correct_items + "/" + incident.attributes.clusterable.attributes.total_items))]), _vm._v(" "), _c('span', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('span', [_vm._v(" Déficit")]) : (incident.attributes.clusterable.attributes.delta_type == 2) ? _c('span', [_vm._v("Exceso")]) : _c('span', [_vm._v(" No definido")])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'waste') ? _c('div', {}, [_c('div', {}, [(incident.attributes.clusterable.attributes.correct_product_flag == 1) ? _c('span', [_vm._v("Items mermados:")]) : _c('span', [_vm._v("Ejemplares mermados de otros productos:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.wasted_items))])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'wrong') ? _c('div', {}, [_c('div', {}, [(incident.attributes.clusterable.attributes.wasted_flag == 0) ? _c('span', [_vm._v("Ejemplares de otros productos no mermados:")]) : _c('span', [_vm._v("Ejemplares de otros productos mermados:")]), _vm._v(" "), _c('span', [_vm._v("\n                     " + _vm._s(incident.attributes.clusterable.attributes.wrong_items) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('hr')])
  })], 2) : (_vm.listIncidents.length == 0) ? _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('span', [_vm._v("No se generaron incidencias")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.hideModalIncidentsPackages()
      }
    }
  }, [_vm._v("Cerrar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendEvaluationData()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1871:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n              ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getPurchaseOrdersByPage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect form-control",
    attrs: {
      "id": "checkboxes2"
    }
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeEstado),
      expression: "typeEstado"
    }],
    staticClass: "kt-form__label",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeEstado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeEstadoListOrder(_vm.typeEstado)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Activos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Cancelados")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bloc filter-block-alone"
  }, [_c('label', [_vm._v("Canal de venta:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "store", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all",
      "selected": ""
    }
  }, [_vm._v("Todo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sendi",
      "data-content": "<span class='badge badge-info'>Ofertas de Grabr</span>"
    }
  }, [_vm._v("\n              Sendi\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enviosusa",
      "data-content": "<span class='badge badge-warning'>Ofertas no Grabr</span>"
    }
  }, [_vm._v("\n              Envios Usa\n            ")])])])]), _vm._v(" "), (_vm.tableData.order_type === 4) ? _c('div', {
    staticClass: "filter-bloc"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('form', {
    staticClass: "formulario",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [(this.valorRadioButton == true) ? _c('span', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inicio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inicio"
    }
  }, [_vm._v("Todo")])]) : (this.valorRadioButton == false) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "todo"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.tableData.store, null)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", null)
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "todo"
    }
  }, [_vm._v("Todo")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "electro"
    },
    domProps: {
      "value": 'electro',
      "checked": _vm._q(_vm.tableData.store, 'electro')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'electro')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "electro"
    }
  }, [_vm._v("Electro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "fashion"
    },
    domProps: {
      "value": 'fashion',
      "checked": _vm._q(_vm.tableData.store, 'fashion')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'fashion')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fashion"
    }
  }, [_vm._v("Fashion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "kids"
    },
    domProps: {
      "value": 'kids',
      "checked": _vm._q(_vm.tableData.store, 'kids')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'kids')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kids"
    }
  }, [_vm._v("Kids")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "home"
    },
    domProps: {
      "value": 'home',
      "checked": _vm._q(_vm.tableData.store, 'home')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'home')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "home"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.store),
      expression: "tableData.store"
    }],
    attrs: {
      "type": "radio",
      "id": "pets"
    },
    domProps: {
      "value": 'pets',
      "checked": _vm._q(_vm.tableData.store, 'pets')
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.tableData, "store", 'pets')
      }, function($event) {
        return _vm.getPurchaseOrdersByPage()
      }],
      "click": _vm.cambiarEstado
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pets"
    }
  }, [_vm._v("Pets")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.purchaseOrders != null && _vm.purchaseOrders.length > 0) ? _c('tbody', _vm._l((_vm.diasRestantes), function(purchaseOrder) {
    return _c('router-link', {
      key: purchaseOrder.id,
      attrs: {
        "to": {
          name: 'show-purchase-order',
          params: {
            id: purchaseOrder.id,
            orderData: purchaseOrder
          },
        }
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "image-table"
    }, [(purchaseOrder.attributes.product_image_url) ? _c('img', {
      attrs: {
        "src": purchaseOrder.attributes.product_image_url,
        "width": "180px",
        "height": "260px"
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(477),
        "width": "180px",
        "height": "260px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "description-title"
    }, [_c('span', {
      staticClass: "description-title-principal"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.product_info))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "code-order system-code"
    }, [_vm._v("QTY:" + _vm._s(purchaseOrder.attributes.product_specimens) + " | SB #" + _vm._s(purchaseOrder.id) + "\n                    ")]), _vm._v(" "), (purchaseOrder.attributes.is_from_linio_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                      #" + _vm._s(purchaseOrder.attributes.linioOrder.attributes.linio_order_id))]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('span', {
      staticClass: "code-order grabr-code"
    }, [_vm._v("\n                      #" + _vm._s(purchaseOrder.attributes.meliOrder.attributes.meli_order_id))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: purchaseOrder.attributes.status == 10 ?
        'bg-danger' :
        'bg-success'
    }, [_vm._v("\n                      " + _vm._s(purchaseOrder.attributes.status == 10 ? "Cancelada" : "Activa") + "\n                    ")]), _vm._v(" "), (purchaseOrder.attributes.type === 2) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.type === 2) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [(purchaseOrder.attributes.store === 'sendi') ? _c('span', [_vm._v("\n                        " + _vm._s(purchaseOrder.attributes.direct_type === 1 ? 'Courier' : 'Shopper') + "\n                      ")]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.store === 'enviosusa') ? _c('span', [_vm._v("\n                       " + _vm._s(purchaseOrder.attributes.direct_type === 1 ? 'Lite' : 'Premium') + "\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.reference_link) ? _c('span', {
      staticClass: "badge badge-primary bg-primary"
    }, [_vm._v(_vm._s(_vm.getStore(purchaseOrder.attributes.reference_link)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary bg-secondary"
    }, [_vm._v("WR -" + _vm._s(purchaseOrder.attributes.warehouse_admin))])]), _vm._v(" "), (purchaseOrder.attributes.is_from_grabr_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-grabr"
    }, [_vm._v("Grabr")]), _vm._v(" "), _c('span', {
      staticClass: "code-order grabr-code",
      on: {
        "click": function($event) {
          return _vm.toGrabrDetail(
            purchaseOrder.attributes.grabrOrder.attributes
            .grabr_order_number
          )
        }
      }
    }, [_vm._v(_vm._s(purchaseOrder.attributes.grabrOrder.attributes
      .grabr_order_number))])]) : (purchaseOrder.attributes.is_from_linio_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-linio"
    }, [_vm._v("Linio")])]) : (purchaseOrder.attributes.is_from_meli_flag) ? _c('div', {
      staticClass: "grabr-des"
    }, [_c('span', {
      staticClass: "badge badge-primary badge-meli"
    }, [_vm._v("Mercado libre")]), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'electro'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-primary"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'kids'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store magenta"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store ===
      'fashion'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store brown"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.attributes.meliOrder.attributes.store === 'home'
    ) ? _c('span', {
      staticClass: "badge badge-primary badge-store bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.attributes.meliOrder.attributes.store) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n                    Tracking: " + _vm._s(purchaseOrder.attributes.system_tracking_number) + "\n                  ")])])]), _vm._v(" "), (
      purchaseOrder.attributes.origin != undefined &&
      purchaseOrder.attributes.destination != undefined
    ) ? _c('td', [_c('div', {
      staticClass: "ruta-order-container"
    }, [_c('div', {
      staticClass: "ruta-order-block ruta-order-image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/ruta.svg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-block"
    }, [_c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.origin.attributes.name))])]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(purchaseOrder.attributes.destination_address))])])])])]) : _c('td', [_c('span', {
      staticClass: "ruta-order"
    }, [_vm._v("No se ha definido")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "order-tag-container"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-pago-status.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (purchaseOrder.attributes.payed === 1) ? _c('span', [_vm._v("PENDIENTE")]) : (purchaseOrder.attributes.payed === 2) ? _c('span', [_vm._v("EN PROCESO")]) : (purchaseOrder.attributes.payed === 3) ? _c('span', [_vm._v("CONFIRMADO")]) : (purchaseOrder.attributes.payed === 10) ? _c('span', [_vm._v("RECHAZADO\"")]) : (purchaseOrder.attributes.payed === 11) ? _c('span', [_vm._v("RECLAMADO")]) : (purchaseOrder.attributes.payed === 12) ? _c('span', [_vm._v("RETORNADO")]) : _vm._e()]), _vm._v(" "), _c('span', [_c('ul', [_c('li', [_c('span', [(purchaseOrder.attributes.payment_method_flag === 5) ? _c('span', [(purchaseOrder.attributes.payment_code === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.payment_code !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 2) ? _c('span', [(
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.paypalPayment.attributes
      .paypal_order_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 3) ? _c('span', [(
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id === null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.mercadopagoPayment.attributes
      .payment_id !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 4) ? _c('span', [(
      purchaseOrder.attributes.atm_payment.mp_payment_id ===
      null
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.atm_payment.mp_payment_id !==
      null && purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-2.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoCodigo-3.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (purchaseOrder.attributes.payment_method_flag === 6) ? _c('span', [_vm._v("Pago con saldo")]) : _vm._e(), _vm._v("\n                          - Código")])]), _vm._v(" "), _c('li', [(purchaseOrder.attributes.voucher_link === null) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-1.png",
        "width": "30",
        "alt": ""
      }
    }) : (
      purchaseOrder.attributes.voucher_link !== null &&
      purchaseOrder.attributes.payed !== 3
    ) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-3.png",
        "width": "30",
        "alt": ""
      }
    }) : (purchaseOrder.attributes.payed === 3) ? _c('img', {
      attrs: {
        "src": "/static/img/statuPagoIcon/PagoVaucher-2.png",
        "width": "30",
        "alt": ""
      }
    }) : _vm._e(), _vm._v("\n                        - Voucher\n                      ")])])]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": "/static/img/icon-tracking-statu.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v(" "), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 1
    ) ? _c('span', [_vm._v("\n                      EN REVISIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 2
    ) ? _c('span', [_vm._v("\n                      COMPRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 3
    ) ? _c('span', [_vm._v("\n                      PREPARANDO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 4
    ) ? _c('span', [_vm._v("\n                      LISTO PARA ENVIAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 5
    ) ? _c('span', [_vm._v("\n                      ENVIADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 6
    ) ? _c('span', [_vm._v("\n                      LISTO PARA ENTREGAR")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 7
    ) ? _c('span', [_vm._v("\n                      ENTREGADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 8
    ) ? _c('span', [_vm._v("\n                      SINIESTRADO")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 9
    ) ? _c('span', [_vm._v("\n                      EN PROCESO DE DEVOLUCIÓN")]) : _vm._e(), (
      purchaseOrder.attributes.order_tracking_details[
        purchaseOrder.attributes.order_tracking_details.length - 1
      ].attributes.status === 10
    ) ? _c('span', [_vm._v("\n                      RETORNADO AL PROVEEDOR")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_c('span', {}, [(purchaseOrder.attributes.vouchers_usa.length !== 0) ? _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-1.svg",
        "width": "50",
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/img/statuFactura/factura-2.svg",
        "width": "50",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('td', [_c('ul', [_c('li', [_vm._v("\n                    B:" + _vm._s(_vm._f("spanishDate")(purchaseOrder.attributes.order_create_date)) + "\n                  ")]), _vm._v(" "), (
      purchaseOrder.attributes.hasOwnProperty('promised_delivery_date')
    ) ? _c('li', [_c('span', [_vm._v("\n                      D:\n                      " + _vm._s(_vm._f("spanishDate")(purchaseOrder.attributes.promised_delivery_date)) + "\n                      |\n                      "), (purchaseOrder.resultado > 15) ? _c('span', {
      staticClass: "badge badge-primary bg-success"
    }, [_vm._v(_vm._s(purchaseOrder.resultado) + " días")]) : _vm._e(), _vm._v(" "), (
      purchaseOrder.resultado > 10 && purchaseOrder.resultado <= 15
    ) ? _c('span', {
      staticClass: "badge badge-primary bg-warning"
    }, [_vm._v("\n                        " + _vm._s(purchaseOrder.resultado) + " días\n                      ")]) : _vm._e(), _vm._v(" "), (purchaseOrder.resultado <= 10) ? _c('span', {
      staticClass: "badge badge-primary bg-danger"
    }, [(Math.sign(purchaseOrder.resultado) === 1) ? _c('span', [_vm._v(_vm._s(purchaseOrder.resultado) + " días\n                        ")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === -1) ? _c('span', [_vm._v("\n                          Retraso de\n                          " + _vm._s(Math.abs(purchaseOrder.resultado)) + " dias")]) : _vm._e(), _vm._v(" "), (Math.sign(purchaseOrder.resultado) === 0) ? _c('span', [_vm._v("\n                          Retraso")]) : _vm._e()]) : _vm._e()])]) : _c('li', [_vm._v("No definido")])])])])])
  }), 1) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrdersByPage
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "formmodal",
    attrs: {
      "id": "formmodal",
      "centered": "",
      "hide-footer": "",
      "hide-header": ""
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Nueva oferta de compra")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccione de donde proviene la oferta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grabr.id),
      expression: "grabr.id"
    }],
    staticClass: "form-control form-control-lg",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.grabr, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(6)) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n              Órdenes GRABR\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(7)) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("\n              Órdenes DIRECT\n            ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'add-purchase-order',
        params: {
          grabr: _vm.grabr,
          oldID: null
        },
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Continuar")])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Órdenes de compra")])])])
}]}

/***/ }),

/***/ 1872:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "4fr 1fr",
      "gap": "1rem",
      "align-items": "start"
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_c('div', {
    staticClass: "u-row-wr u-row--header"
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Producto")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Warehouse")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Acciones")])]), _vm._v(" "), _vm._l((_vm.warehouseorder), function(data) {
    return _c('div', {
      key: data,
      staticClass: "u-row-wr"
    }, [_c('div', [_c('article', {
      staticClass: "card-product"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      }
    }, [(data.attributes.product_image_url) ? _c('img', {
      staticClass: "card-product__img",
      attrs: {
        "src": data.attributes.product_image_url
      }
    }) : _c('img', {
      staticClass: "card-product__img",
      attrs: {
        "src": "https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v(_vm._s(data.attributes.product_info))]), _vm._v(" "), (data.attributes.reference_link) ? _c('a', {
      attrs: {
        "href": data.attributes.reference_link,
        "target": "_Blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Nombres:")]), _vm._v("\n                        " + _vm._s(data.attributes.client.attributes.profile.attributes.name) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(data.attributes.client.attributes.profile.attributes.surnames) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código del cliente:")]), _vm._v("\n                        " + _vm._s(data.attributes.client.attributes.profile.attributes.userable
      .client_code) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Código de Tracking:")]), _vm._v("\n                        " + _vm._s(data.attributes.system_tracking_number) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje desde:")]), _vm._v("\n                        " + _vm._s(data.attributes.origin.attributes.name) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Viaje a:")]), _vm._v("\n                        " + _vm._s(data.attributes.destination.attributes.name) + "\n                      ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Número de orden:")]), _vm._v("\n                        #" + _vm._s(data.id) + "\n                      ")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "max-width": "38vw"
      }
    }, [
      [_c('vue-glide', {
        attrs: {
          "perView": 2
        }
      }, [_vm._l((data.attributes.warehouse_packages), function(wr) {
        return _c('vue-glide-slide', {
          key: wr
        }, [_c('article', {
          staticClass: "card-product"
        }, [_c('div', {
          staticClass: "card-product__text"
        }, [_c('h3', {
          staticClass: "card-product__title"
        }, [_c('span', [_vm._v("#" + _vm._s(wr.attributes.code) + "-\n                              "), _c('a', {
          staticStyle: {
            "cursor": "pointer",
            "color": "blue"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.liberarWR(wr.attributes.code)
            }
          }
        }, [_vm._v("\n                                Liberar\n                              ")])]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fas fa-link"
        })])]), _vm._v(" "), _c('div', {
          staticClass: "card-product__info"
        }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              " + _vm._s(wr.attributes.remitter ?
          wr.attributes.remitter :
          "Sin remitente") + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n                              " + _vm._s(wr.attributes.consignee) + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n                              " + _vm._s(wr.attributes.remitter) + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n                              " + _vm._s(wr.attributes.carrier) + "\n                            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n                              " + _vm._s(wr.attributes.weight) + "\n                              "), _c('b', [_vm._v("\n                                " + _vm._s(wr.attributes.weight_unit.attributes.key_name))])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n                              " + _vm._s(wr.attributes.comment) + "\n                            ")]), _vm._v(" "), (wr.attributes.images) ? _c('a', {
          staticStyle: {
            "color": "#1ea9e4",
            "font-weight": "600"
          },
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.openModal('modal-fotos', null, wr.attributes.images)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-link mr-2"
        }), _vm._v("\n                              Ver fotos\n                            ")]) : _vm._e()])])])])
      }), _vm._v(" "), _c('template', {
        slot: "control"
      }, [_c('button', {
        staticClass: "slider__btn slider__btn--prev",
        attrs: {
          "data-glide-dir": "<"
        }
      }, [_c('i', {
        staticClass: "fas fa-arrow-left"
      })]), _vm._v(" "), _c('button', {
        staticClass: "slider__btn slider__btn--next",
        attrs: {
          "data-glide-dir": ">"
        }
      }, [_c('i', {
        staticClass: "fas fa-arrow-right"
      })])])], 2)]
    ], 2), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary mb-3 d-block mx-auto",
      attrs: {
        "disabled": data.attributes.warehouse_flag == 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-wr', data.id)
        }
      }
    }, [_vm._v("\n                  Registrar ingreso\n                ")]), _vm._v(" "), (data.attributes.warehouse_packages.length !== 0) ? _c('button', {
      staticClass: "btn d-block mx-auto",
      class: data.attributes.warehouse_flag == 0 ? 'btn-primary' : 'btn-success',
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.limitchangePaquete(data.id)
        }
      }
    }, [(data.attributes.warehouse_flag !== 0) ? _c('i', {
      staticClass: "fas fa-check pr-2 pt-1"
    }) : _vm._e(), _vm._v("\n                  " + _vm._s(data.attributes.warehouse_flag == 0 ?
      "Items incompletos" :
      "Items completos") + "\n                ")]) : _vm._e()])])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wr-slider-vertical"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    on: {
      "click": function($event) {
        return _vm.openModal('modal-wr')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n          Nuevo paquete\n        ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.wrSinAsignar), function(data) {
    return _c('article', {
      key: data,
      staticClass: "card-product"
    }, [_c('div', {
      staticClass: "card-product__text"
    }, [_c('h3', {
      staticClass: "card-product__title"
    }, [_c('span', [_vm._v(_vm._s(data.attributes.code))]), _vm._v(" -\n            "), _c('span', {
      staticStyle: {
        "color": "red",
        "cursor": "grab"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteWR(data)
        }
      }
    }, [_vm._v("Eliminar")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.copyCodeWr(data.attributes.code)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-product__info"
    }, [_c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              " + _vm._s(data.attributes.remitter ? data.attributes.remitter : "Sin remitente") + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Consignatario:")]), _vm._v("\n              " + _vm._s(data.attributes.consignee) + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Remitente:")]), _vm._v("\n              " + _vm._s(data.attributes.remitter) + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Carrier:")]), _vm._v("\n              " + _vm._s(data.attributes.carrier) + "\n            ")]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Peso:")]), _vm._v("\n              " + _vm._s(data.attributes.weight) + "\n              "), _c('b', [_vm._v(" " + _vm._s(data.attributes.weight_unit.attributes.key_name))])]), _vm._v(" "), _c('p', {}, [_c('span', {}, [_vm._v("Comentario:")]), _vm._v("\n              " + _vm._s(data.attributes.comment) + "\n            ")]), _vm._v(" "), (data.attributes.images) ? _c('a', {
      staticStyle: {
        "color": "#1ea9e4",
        "font-weight": "600"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal('modal-fotos', null, data.attributes.images)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-link mr-2"
    }), _vm._v("\n              Ver fotos\n            ")]) : _vm._e()])])])
  })], 2)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrders
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-fotos"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    staticStyle: {
      "max-width": "70vw",
      "width": "70vw"
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Fotos del producto")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-fotos')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gallery",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "1fr 1fr 1fr",
      "gap": "1rem"
    }
  }, _vm._l((_vm.wrFotos), function(image) {
    return _c('img', {
      key: image,
      staticClass: "product-image",
      attrs: {
        "src": image.url,
        "alt": ""
      }
    })
  }), 0)])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-wr"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Datos del paquete")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-wr')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remitente :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.remitter),
      expression: "formCreate.remitter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.remitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "remitter", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Destinatario :(Consignatario)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.consignee),
      expression: "formCreate.consignee"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Carrier :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.carrier),
      expression: "formCreate.carrier"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "carrier", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Tracking :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.tracking),
      expression: "formCreate.tracking"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.tracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "tracking", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Peso :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.weight),
      expression: "formCreate.weight"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Unidad de peso :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unidad),
      expression: "formCreate.unidad"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "unidad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 12
    }
  }, [_vm._v("Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 22
    }
  }, [_vm._v("Oz")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Comentario :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.comment),
      expression: "formCreate.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fotos del paquete :")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": "",
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar ingreso\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Warehouse")])])])])
}]}

/***/ }),

/***/ 1873:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('h3', [_vm._v("\n              Design some buttons\n              "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}

/***/ }),

/***/ 1874:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.filteredColumns), function(column) {
    return _c('th', {
      key: column.name,
      style: ('width:' + column.width + ';' + 'cursor:pointer;')
    }, [_c('span', {
      class: _vm.sortKey === column.name ? (_vm.sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting',
      on: {
        "click": function($event) {
          return _vm.$emit('sort', column.name)
        }
      }
    }, [_vm._v(_vm._s(column.label))])])
  }), 0)]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1875:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [(_vm.newCityDestiny || !this.dataLocal.dataShipment.status) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formItem"
  }, [(!this.dataLocal.dataShipment.status && _vm.currentUserRole == 'Admin') ? _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de envío")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCreatorOperator),
      expression: "newCreatorOperator"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destiny_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCreatorOperator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listSenderOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator
      }
    }, [_vm._v(_vm._s(operator.attributes.username))])
  })], 2), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('creator_operator')),
      expression: "errors.has('creator_operator')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('creator_operator')))]), _vm._v(" "), (_vm.origin_id !== 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Origen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.origin_id === 2) ? _c('input', {
    staticClass: "form-control block",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "value": "Miami",
      "readonly": "readonly"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.origin_id === 12) ? _c('input', {
    staticClass: "form-control block",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "value": "Buenos Aires",
      "readonly": "readonly"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.origin_id === 22) ? _c('input', {
    staticClass: "form-control block",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "value": "Lima",
      "readonly": "readonly"
    }
  }) : _vm._e()])]) : _vm._e()])]) : (this.dataLocal.dataShipment.status && _vm.currentUserRole == 'Admin') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de envío")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm.newCreatorOperator.attributes.username))])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityDestiny),
      expression: "newCityDestiny"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destiny_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityDestiny = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCities), function(cityOrigin) {
    return _c('option', {
      domProps: {
        "value": cityOrigin
      }
    }, [_vm._v(_vm._s(cityOrigin.attributes.name))])
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destiny_city')),
      expression: "errors.has('destiny_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destiny_city')))])])])]) : (this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm.newCityDestiny.attributes.name))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescription),
      expression: "newDescription"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "name": "description_shipment",
      "rows": "3",
      "cols": "70",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.newDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescription = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description_shipment')),
      expression: "errors.has('description_shipment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('description_shipment')))])])])]) : (this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block",
    model: {
      value: (_vm.newDescription),
      callback: function($$v) {
        _vm.newDescription = $$v
      },
      expression: "newDescription"
    }
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.description))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de salida")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateDeparture),
      expression: "newDateDeparture"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "name": "departure_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_date')),
      expression: "errors.has('departure_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_date')))])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha y hora de salida")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.newDateDeparture)))])])])]), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hora de salida")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourDeparture),
      expression: "newHourDeparture"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "time",
      "name": "departure_hour"
    },
    domProps: {
      "value": (_vm.newHourDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_hour')),
      expression: "errors.has('departure_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_hour')))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateArrival),
      expression: "newDateArrival"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "name": "arrival_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date')),
      expression: "errors.has('arrival_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date')))])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.newDateArrival)))])])])]), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hora de llegada")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourArrival),
      expression: "newHourArrival"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "time",
      "name": "arrival_hour"
    },
    domProps: {
      "value": (_vm.newHourArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_hour')),
      expression: "errors.has('arrival_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_hour')))])])])]) : _vm._e(), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de llegada")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRecieverOperator),
      expression: "newRecieverOperator"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "reciever_operator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newRecieverOperator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listOperatorReciever), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator
      }
    }, [_vm._v(_vm._s(operator.attributes.username) + " ")])
  })], 2), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reciever_operator')),
      expression: "errors.has('reciever_operator')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('reciever_operator')))])])])]) : _vm._e(), _vm._v(" "), (_vm.newRecieverOperator && this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Operador de llegada")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "form-control block"
  }, [_vm._v(_vm._s(_vm.newRecieverOperator.attributes.profile.attributes.name) + " " + _vm._s(_vm.newRecieverOperator.attributes.profile.attributes.surnames))])])])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!this.dataLocal.dataShipment.status) ? _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toNextForm
    }
  }, [_vm._v("Crear Embarque")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "validacionmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_vm._v("Continuar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formContent"
  }, [_c('h1', [_vm._v("Datos del embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Es el operador de envío al que se le asigna el embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Es la ciudad destino del embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Fecha de salida del vuelo del embarque desde la ciudad de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Hora de salida del vuelo del embarque desde la ciudad de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Fecha de llegada del vuelo del embarque a la ciudad destino")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha y hora de llegada "), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Hora de llegada del vuelo del embarque a la ciudad origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip"
  }, [_c('span', [_vm._v("Es el operador que está en el destino, al que se le asigna el embarque")])])
}]}

/***/ }),

/***/ 1876:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes,
      "activeRoute": _vm.activeRoute
    }
  }), _vm._v(" "), (_vm.orderDataShow) ? _c('div', [_c('div', {
    staticClass: "card-status-content"
  }, [_c('div', {
    staticClass: "card-status-block"
  }, [_c('button', {
    staticClass: "btn btn-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-left"
  }), _vm._v("Volver\n        ")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.status >= 1 && _vm.orderDataShow.attributes.status <= 3
  ) ? _c('span', {
    staticClass: "btn statusInit"
  }, [_vm._v("Inicializando")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status >= 4 && _vm.orderDataShow.attributes.status <= 7
  ) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("En proceso")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("Finalizado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10) ? _c('span', {
    staticClass: "btn statusCancel"
  }, [_vm._v("Cancelado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 1) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En re-evaluación inicial")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 2) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Re-evaluado esperando confirmación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 3) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Completando información de compra")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Comprado y en camino a dirección de origen")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Recibido en dirección de origen y en evaluación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Listo para embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 7) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Entregado correctamente")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled_reason_flag == 1
  ) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por decisión propia")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled_reason_flag == 2
  ) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por incidente en tracking")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled_reason_flag == 3
  ) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por no autorizar reposición de items")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('div', {
    staticClass: "nm n-1"
  }, [_c('div', {
    staticClass: "details-collapse"
  }, [_c('orderImportantInfo', {
    attrs: {
      "orderDataShow": _vm.orderDataShow,
      "fromDetail": true,
      "fromTracking": false
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  }), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 1 &&
    ((_vm.orderDataShow.attributes.is_from_grabr_flag &&
        _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 0) ||
      (_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 0) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 0))
  ) ? _c('div', {
    staticClass: "card card-standby collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.noEvaluationFlag
    }
  }, [_vm._v("Evaluar")])], 1)]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 2 &&
    ((_vm.orderDataShow.attributes.is_from_grabr_flag &&
        _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 3) ||
      (_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 3) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 3))
  ) ? _c('div', {
    staticClass: "card card-cancel collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.noEvaluationFlag
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    this.orderDataShow.attributes.grabrOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      this.orderDataShow.attributes.linioOrder.attributes
      .confirmation_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      this.orderDataShow.attributes.meliOrder.attributes
      .confirmation_flag != 0)
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : _vm._e()], 1)]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 2 &&
    ((_vm.orderDataShow.attributes.is_from_grabr_flag &&
        _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1) ||
      (_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1))
  ) ? _c('div', {
    staticClass: "card card-correct",
    attrs: {
      "id": "headingThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    this.orderDataShow.attributes.grabrOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    this.orderDataShow.attributes.linioOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    this.orderDataShow.attributes.meliOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : _vm._e(), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseThree",
      "aria-labelledby": "headingThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 2 &&
    ((_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 2) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 2))
  ) ? _c('div', {
    staticClass: "card card-standby card-wait collapsed",
    attrs: {
      "id": "headinFour",
      "data-toggle": "collapse",
      "data-target": "#collapsenFour",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "Forzar aprobación\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "Forzar aprobación\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "Forzar aprobación\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    this.orderDataShow.attributes.grabrOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    this.orderDataShow.attributes.linioOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    this.orderDataShow.attributes.meliOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : _vm._e(), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenFour",
      "aria-labelledby": "headingnFour",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4) ? _c('div', {
    staticClass: "card card-correct collapsed",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 2)) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 2))
  ) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 5 &&
    _vm.orderDataShow.attributes.warning_expired_flag == 0
  ) ? _c('div', {
    staticClass: "card card-correct",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 2)) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 2))
  ) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 5 &&
    _vm.orderDataShow.attributes.warning_expired_flag == 1
  ) ? _c('div', {
    staticClass: "card card-warning collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")])])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 5 &&
    _vm.orderDataShow.attributes.warning_expired_flag == 0
  ) ? _c('div', {
    staticClass: "card card-correct collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_vm._m(9), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('div', {
    staticClass: "card card-correct",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [(
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 2)) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 2))
  ) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled == 1
  ) ? _c('div', {
    staticClass: "card card-cancel collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_c('div', {
    staticClass: "card-content-block"
  }, [(_vm.orderDataShow.attributes.cancelled_reason_flag == 1) ? _c('span', [_vm._v("Cancelado por decision propia")]) : (_vm.orderDataShow.attributes.cancelled_reason_flag == 2) ? _c('span', [_vm._v("Cancelado por incidente en tracking")]) : (_vm.orderDataShow.attributes.cancelled_reason_flag == 3) ? _c('span', [_vm._v("Cancelado por no autorizar reposición de items")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.orderDataShow.attributes.type === 2) ? _c('span', [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation1",
      "aria-labelledby": "information1"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("N° de orden:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.id) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Estatus de orden:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.status !== 10 ?
      'button-success' :
      'button-outline',
    style: (_vm.orderDataShow.attributes.status !== 10 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status !== 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('activa')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.status !== 10 ?
    "Activado" :
    "Activar") + "\n                        "), (_vm.orderDataShow.attributes.status !== 10) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.status === 10 ?
      'button-success' :
      'button-outline',
    staticStyle: {
      "margin-left": "12px"
    },
    style: (_vm.orderDataShow.attributes.status === 10 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('cancelada')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.status === 10 ?
    "Cancelado" :
    "Cancelar") + "\n                        "), (_vm.orderDataShow.attributes.status === 10) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Canal de Venta:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 1 ?
    "Sendi" :
    "Envios") + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Servicio:")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 1
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.direct_type === 1 ?
    "Courier" :
    "Shopper") + "\n                    ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 2
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.direct_type === 1 ? "Lite" : "Premium") + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Factura Comercial:")]), _vm._v(" "), (_vm.orderDataShow.attributes.vouchers_usa.length === 0) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_c('li', [_vm._v("Sin Adjunto")]), _vm._v(" "), _c('li', [_c('input', {
    ref: "fileupload",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.factura
    }
  })])])]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_vm._l((_vm.orderDataShow.attributes
    .vouchers_usa), function(invoice, index) {
    return _c('li', {
      key: invoice
    }, [_c('a', {
      attrs: {
        "href": invoice.url,
        "target": "_blank"
      }
    }, [_vm._v("Ver Adjunto - " + _vm._s(index + 1) + "\n                          ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      style: (invoice.status === 0 ? 'color:#DD5385' : 'color:#3BC73B'),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.statusInvoice(invoice.url, index + 1, invoice.status)
        }
      }
    }, [_vm._v("-\n                            " + _vm._s(invoice.status === 0 ? "(Sin Aprobar)" : "(Aprobado)") + "\n                            -")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteInvoice(invoice.url, index + 1)
        }
      }
    }, [_vm._v("(Eliminar)")])])
  }), _vm._v(" "), _c('li', [_c('input', {
    ref: "fileupload",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.factura
    }
  })])], 2)])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 1
  ) ? _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Manifiesto:")]), _vm._v(" "), (_vm.orderDataShow.attributes.manifest.length === 0) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_c('li', [_vm._v("Sin Adjunto")]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.manifiestoFile
    }
  })])])]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_vm._l((_vm.orderDataShow.attributes.manifest), function(invoice, index) {
    return _c('li', {
      key: invoice
    }, [_c('a', {
      attrs: {
        "href": invoice.url,
        "target": "_blank"
      }
    }, [_vm._v("Ver Manifiesto - " + _vm._s(index + 1) + "\n                          ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      style: (invoice.status === 0 ? 'color:#DD5385' : 'color:#3BC73B'),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.statusManifiesto(invoice.url, index + 1, invoice.status)
        }
      }
    }, [_vm._v("-\n                            " + _vm._s(invoice.status === 0 ? "(Sin Aprobar)" : "(Aprobado)") + "\n                            -")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteManifiesto(invoice.url, index + 1)
        }
      }
    }, [_vm._v("(Eliminar)")])])
  }), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.manifiestoFile
    }
  })])], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.courier_type === 1 ?
      'button-success' :
      'button-outline',
    style: (_vm.orderDataShow.attributes.courier_type === 1 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.courier_type === 1 ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('aduana')
      }
    }
  }, [_vm._v("\n                        Aduana\n                        "), (_vm.orderDataShow.attributes.courier_type === 1) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.courier_type === 2 ?
      'button-success' :
      'button-outline',
    staticStyle: {
      "margin-left": "12px"
    },
    style: (_vm.orderDataShow.attributes.courier_type === 2 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.courier_type === 2 ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('pasajero')
      }
    }
  }, [_vm._v("\n                        Pasajero\n                        "), (_vm.orderDataShow.attributes.courier_type === 2) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Canal:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.channel === 'A' ?
      'button-success' :
      'button-outline',
    style: (_vm.orderDataShow.attributes.channel === 'A' ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.channel === 'A' ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('A')
      }
    }
  }, [_vm._v("\n                        Verde\n                        "), (_vm.orderDataShow.attributes.channel === 'A') ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.channel === 'B' ?
      'button-error' :
      'button-outline',
    staticStyle: {
      "margin-left": "12px"
    },
    style: (_vm.orderDataShow.attributes.channel === 'B' ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.channel === 'B' ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('B')
      }
    }
  }, [_vm._v("\n                        Rojo\n                        "), (_vm.orderDataShow.attributes.channel === 'B') ? _c('img', {
    attrs: {
      "src": "/static/img/error-icon.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de creación:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.order_create_date) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega prometida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.delivery_date) + "\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation2",
      "aria-labelledby": "information2"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .name) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .surnames) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .document_number) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .cellphone) + "\n                    ")])])]), _vm._v(" "), (_vm.orderDataShow.attributes.client.attributes.address !== null) ? _c('span', [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client.attributes.address.address) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Piso u Oficina:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.inner) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.reference) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.department) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.city) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.district) + "\n                      ")])])])]) : _c('span', [_vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Correo electrónico:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.email) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.validation.verified ?
    "Verificado" :
    "No Verificado") + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("DNI anterior:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes
    .document_face_state === 3 ?
    "Verificado " :
    "No Verificado ") + "\n                      "), (
    _vm.orderDataShow.attributes.client.attributes
    .document_face_url !== null
  ) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.client.attributes.document_face_url,
      "target": "Blank"
    }
  }, [_vm._v("\n                        - Ver imagen")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("DNI posterior:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes
    .document_seal_state === 3 ?
    "Verificado " :
    "No Verificado ") + "\n                      "), (
    _vm.orderDataShow.attributes.client.attributes
    .document_seal_url !== null
  ) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.client.attributes.document_seal_url,
      "target": "Blank"
    }
  }, [_vm._v("\n                        - Ver imagen")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de Usuario:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.client_code) + "\n                      -\n                      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UserDetail',
        params: {
          idUser: _vm.orderDataShow.attributes.client.id
        },
      },
      "target": "_blank"
    }
  }, [_vm._v("Ver perfil")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation3",
      "aria-labelledby": "information3"
    }
  }, [(_vm.orderDataShow.attributes.shipping_address) ? _c('span', [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.at_office_flag === 1 ?
    "Oficina" :
    "Domicilio") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .owner_name) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .owner_lastname) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .owner_document_number) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .telephone_number))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.address) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(" Piso u Oficina:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.inner) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.reference) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .department) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.city) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.district) + "\n                      ")])])])]) : _c('span', [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.at_office_flag === 1 ?
    "Oficina" :
    "Domicilio") + "\n                      ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation4",
      "aria-labelledby": "information4"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("Precio del producto:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("USD\n                      " + _vm._s((
    _vm.orderDataShow.attributes.real_price *
    _vm.orderDataShow.attributes.product_specimens
  ).toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("Shipping:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.real_shipping.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("Tax:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.real_tax.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro/Warehouse:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.warehouse) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete/Millas de vuelo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.flete_cost.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ad valorem/Recompensa:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.ad_valorem.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Igv/Recompensa:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.igv.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ipm/Recompensa:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.ipm.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tramite aduanero/Margen de servicio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.tramite_aduanero.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Envío nacional:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.national_shipping.toFixed(2)) + "\n                    ")])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.coupon_discount !== null &&
    _vm.orderDataShow.attributes.coupon_id !== null
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cupones:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.coupon_discount) + " - \"" + _vm._s(_vm.orderDataShow.attributes.coupon.attributes.code) + "\"\n                    ")])]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.coupon_discount !== null &&
    _vm.orderDataShow.attributes.coupon_id === null
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Campaña: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.coupon_discount) + " - \"" + _vm._s(_vm.orderDataShow.attributes.campaign.attributes.code) + "\"\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.balance_discount !== null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Balance:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.balance_discount) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Servicios Extras :")]), _vm._v(" "), (_vm.orderDataShow.attributes.services.length === 0) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      Sin servicios extras\n                    ")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', _vm._l((_vm.orderDataShow.attributes.services), function(data) {
    return _c('li', {
      key: data
    }, [_vm._v("\n                          " + _vm._s(data.name) + " - USD " + _vm._s(data.pivot.amount) + "\n                        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD\n                      " + _vm._s(_vm.orderDataShow.attributes.new_total_cost === null ?
    _vm.orderDataShow.attributes.total_cost.toFixed(2) :
    _vm.orderDataShow.attributes.new_total_cost.toFixed(2)) + "\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation5",
      "aria-labelledby": "information5"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Moneda:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.currency) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Monto Abonado:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.currency) + "\n                      " + _vm._s((
    _vm.orderDataShow.attributes.total_cost *
    _vm.orderDataShow.attributes.exchange
  ).toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, _vm._l((_vm.statusPayment), function(status) {
    return _c('span', {
      key: status
    }, [(_vm.orderDataShow.attributes.payed === status.id) ? _c('span', [_vm._v("\n                          " + _vm._s(status.text) + "\n                        ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [(_vm.orderDataShow.attributes.payment_method_flag === 4) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Pago Efectivo - " + _vm._s(_vm.orderDataShow.attributes.atm_payment.payment_code) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 6) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Saldo\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 5) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Transferencia\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 2) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Paypal\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 3) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Tarjeta\n                      ")]) : _vm._e()])]), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 4) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.atm_payment.mp_payment_id ?
    _vm.orderDataShow.attributes.atm_payment.mp_payment_id :
    "Sin código") + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 6) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      Realizo el pago con su saldo\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 5) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', {
    staticClass: "listStyle",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('ol', [_vm._v("\n                          " + _vm._s(_vm.orderDataShow.attributes.payment_code ?
    _vm.orderDataShow.attributes.payment_code :
    "Sin código") + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoTransferencia),
      expression: "codigoTransferencia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Código de referencia",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    domProps: {
      "value": (_vm.codigoTransferencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoTransferencia = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendVaucherComprobante(1)
      }
    }
  }, [_vm._v("\n                            Cambiar\n                          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 2) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.paypalPayment.attributes
    .paypal_authorization_id ?
    _vm.orderDataShow.attributes.paypalPayment.attributes
    .paypal_authorization_id :
    "Sin código") + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 3) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.mercadopagoPayment.attributes
    .payment_id ?
    _vm.orderDataShow.attributes.mercadopagoPayment.attributes
    .payment_id :
    "Sin código") + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comprobante de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.voucher_link === null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', {
    staticClass: "listStyle",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('ol', [_vm._v("\n                          Sin comprobante\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('input', {
    ref: "fileuploadComprobante",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.comprobante
    }
  })])])]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', {
    staticClass: "listStyle",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('ol', [_c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.voucher_link,
      "target": "_blank"
    }
  }, [_vm._v("Ver comprobante")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('input', {
    ref: "fileuploadComprobante",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.comprobante
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation6",
      "aria-labelledby": "information6"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("N° de tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.system_tracking_number) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status del tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.order_tracking_details[
    _vm.orderDataShow.attributes.order_tracking_details.length - 1
  ].attributes.status) + "\n                      -\n                      "), _vm._l((_vm.statusTracking), function(tracking) {
    return _c('span', {
      key: tracking
    }, [(
      tracking.id ===
      _vm.orderDataShow.attributes.order_tracking_details[
        _vm.orderDataShow.attributes.order_tracking_details.length - 1
      ].attributes.status
    ) ? _c('span', [_vm._v("\n                          " + _vm._s(tracking.text))]) : _vm._e()])
  })], 2)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.type !== 2) ? _c('span', [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [(
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes
    .client_grabr_id != null
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de cliente:")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_id) + "\n                    ")]) : (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes
      .client_grabr_id == null) ||
    _vm.orderDataShow.attributes.is_from_linio_flag
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_dni != null ?
    _vm.orderDataShow.attributes.external_client_dni :
    "No definido") + "\n                    ")]) : (
    !_vm.orderDataShow.attributes.is_from_grabr_flag &&
    !_vm.orderDataShow.attributes.is_from_linio_flag &&
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .document_number))]) : (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes
    .client_grabr_id != null
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/users/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id) + "\n                      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombres y apellidos:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_name))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .customer_first_name +
    " " +
    _vm.orderDataShow.attributes.linioOrder.attributes
    .customer_last_name))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .customer_first_name +
    " " +
    _vm.orderDataShow.attributes.meliOrder.attributes.customer_last_name))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .name +
    " " +
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .surnames))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_nickname))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número telefónico:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_phone))]) : (
    _vm.orderDataShow.attributes.is_from_grabr_flag ||
    _vm.orderDataShow.attributes.is_from_linio_flag ||
    _vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.external_client_cellphone != null ?
    _vm.orderDataShow.attributes.external_client_cellphone :
    "No definido") + "\n                    ")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .cellphone))])])])])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_linio_flag ||
    _vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseshipping",
      "aria-labelledby": "headingshipping"
    }
  }, [(_vm.orderDataShow.attributes.hasshipping) ? _c('div', {
    staticClass: "details-content-info"
  }, [(_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de envío: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_id))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 1: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_address != null ?
    _vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_address :
    "No definido"))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_address != null ?
    _vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_address :
    "No definido"))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 2: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment !=
    null ?
    _vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment :
    "No definido"))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_neighborhood != null ?
    _vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_neighborhood :
    "No definido"))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_neighborhood != null ?
    _vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_neighborhood :
    "No definido"))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_city !=
    null ?
    _vm.orderDataShow.attributes.meliOrder.attributes.shipping_city :
    "No definido"))])]) : _vm._e()]) : _c('div', {
    staticClass: "details-content-info"
  }, [_vm._m(21)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseorder",
      "aria-labelledby": "headingorder"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de chat en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.is_from_grabr_flag ?
    _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link :
    ""))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Grabr:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes
    .grabr_purchase_link !== null ?
    _vm.orderDataShow.attributes.grabrOrder.attributes
    .grabr_purchase_link :
    "No definido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Linio:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .linio_purchase_link !== null ?
    _vm.orderDataShow.attributes.linioOrder.attributes
    .linio_purchase_link :
    "No definido"))])]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Mercado Libre:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.seller_sku !==
    null ?
    _vm.orderDataShow.attributes.meliOrder.attributes.seller_sku :
    "No de finido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Link de compra final:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.real_purchase_link !== null ?
        _vm.orderDataShow.attributes.real_purchase_link :
        'No definido',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.real_purchase_link !== null ?
    _vm.orderDataShow.attributes.real_purchase_link :
    "No definido"))])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de viaje en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/trips/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.travel_number))])])]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account))])]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.linio_account
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Linio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_account))])]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.meli_account
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Mercado Libre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_account))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.origin != undefined ?
    _vm.orderDataShow.attributes.origin.attributes.name :
    "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.destination != undefined ?
    _vm.orderDataShow.attributes.destination.attributes.name :
    "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada al origen:")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.promised_origin_arrival_date != null
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_origin_arrival_date)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("No definido")])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_origin_arrival_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_origin_arrival_date)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega prometida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_delivery_date)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_delivery_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_delivery_date)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.carrier_name != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Transportista:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.carrier_name))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.shopping_order_number != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shopping_order_number))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.tracking_number !== null ?
    _vm.orderDataShow.attributes.tracking_number :
    "No definido"))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsePago",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de aprobación:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .payment_date_approved) + "\n                    ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_offer_date) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_method) + "\n                    ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.payment_method) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 4) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Pago Efectivo - " + _vm._s(_vm.orderDataShow.attributes.atm_payment.payment_code) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 6) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Saldo\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 5) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Transferencia\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 1) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Paypal\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 3) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tarjeta\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_type) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Monto de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/\n                      " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price) + "\n                    ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/\n                      " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.currency === "USD" ? "$ " : "S/ ") + "\n                      " + _vm._s((
    _vm.orderDataShow.attributes.total_cost *
    _vm.orderDataShow.attributes.exchange
  ).toFixed(2)) + "\n                    ")])])])])])])]) : _vm._e(), _vm._v(" "), _vm._m(24), _vm._v(" "), (true) ? _c('div', {
    staticClass: "details-content"
  }, [(
    !(
      _vm.orderDataShow.attributes.cancelled == 1 &&
      _vm.orderDataShow.attributes.status == 10
    )
  ) ? _c('div', {
    staticClass: "details-content-comments"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentContent),
      expression: "currentContent"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "maxlength": 1000,
      "disabled": !_vm.createCommentFlag,
      "rows": "1",
      "placeholder": "Deja tu comentario..."
    },
    domProps: {
      "value": (_vm.currentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.currentContent.length != 0) ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": _vm.createComment
    }
  }, [_vm._v("\n                  Enviar\n                ")])]) : _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    }
  }, [_vm._v("\n                  Enviar\n                ")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments), function(comment, index) {
    return _c('comment-component', {
      key: index,
      attrs: {
        "comment": comment,
        "orderCancelledFlag": _vm.orderDataShow.attributes.status == 10 &&
          _vm.orderDataShow.attributes.cancelled == 1,
        "order": _vm.orderDataShow
      },
      on: {
        "in-edition": _vm.disableEditComments,
        "cancel-edition": _vm.enableEditComments,
        "display-comments": _vm.displayComments,
        "comment-deleted": _vm.displayComments
      }
    })
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nm n-2",
    attrs: {
      "id": "fixedElement"
    }
  }, [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(25), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.noGravado))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(26), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.gravado))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(27), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.totalIgv))])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status del Pago :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagosStatus),
      expression: "pagosStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pagosStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeStatusPayment(_vm.pagosStatus)
      }]
    }
  }, _vm._l((_vm.statusPayment), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status.id,
        "selected": _vm.orderDataShow.attributes.payed === status.id
      }
    }, [_vm._v("\n                    " + _vm._s(status.text) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status del Tracking :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trakingStatus),
      expression: "trakingStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.pagosStatus !== 3 || _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trakingStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeStatusTracking(_vm.trakingStatus)
      }]
    }
  }, _vm._l((_vm.statusTracking), function(tracking) {
    return _c('option', {
      key: tracking,
      domProps: {
        "value": tracking.id,
        "selected": _vm.orderDataShow.attributes.order_tracking_details[
          _vm.orderDataShow.attributes.order_tracking_details.length - 1
        ].attributes.status === tracking.id
      }
    }, [_vm._v("\n                    " + _vm._s(tracking.text) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD1",
      "aria-labelledby": "informationD1"
    }
  }, [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Calcular:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "button"
    }
  }, [_vm._v("\n                      Calcular\n                    ")])])])])])])]), _vm._v(" "), [(
    _vm.servicioReturn &&
    (_vm.orderDataShow.attributes.order_tracking_details[
        _vm.orderDataShow.attributes.order_tracking_details.length - 1
      ].attributes.status === 9 ||
      _vm.orderDataShow.attributes.order_tracking_details[
        _vm.orderDataShow.attributes.order_tracking_details.length - 1
      ].attributes.status === 10) &&
    _vm.orderDataShow.attributes.payed === 3
  ) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "serviioReturn",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReturn",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReturn"
    }
  }, [_c('span', [_vm._v("Servicio Return")]), _vm._v(" "), (_vm.servicioReturn && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReturn",
      "aria-labelledby": "serviioReturn"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Adjunto:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileReturn
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('ul', _vm._l((_vm.orderDataShow.attributes.serviceReturn), function(data, index) {
    return _c('li', {
      key: data
    }, [_c('a', {
      attrs: {
        "href": data.url_return,
        "target": "_Blank"
      }
    }, [_vm._v("\n                        " + _vm._s(index === 0 ? "Etiqueta de devolución" : "Evidencia") + "\n                        "), (index !== 0) ? _c('span', [_vm._v("\n                          -\n                          " + _vm._s(index) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteFileReturn(data)
        }
      }
    }, [_vm._v("Eliminar")])])])
  }), 0)])])])]) : _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "serviioReturn",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReturn",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReturn"
    }
  }, [_c('span', [_vm._v("Servicio Return")]), _vm._v(" "), (_vm.servicioReturn && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReturn",
      "aria-labelledby": "serviioReturn"
    }
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('ul', _vm._l((_vm.orderDataShow.attributes.serviceReturn), function(data, index) {
    return _c('li', {
      key: data
    }, [_c('a', {
      attrs: {
        "href": data.url_return,
        "target": "_Blank"
      }
    }, [_vm._v("\n                        " + _vm._s(index === 0 ? "Etiqueta de devolución" : "Evidencia") + "\n                        "), (index !== 0) ? _c('span', [_vm._v("\n                          -\n                          " + _vm._s(index) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteFileReturn(data)
        }
      }
    }, [_vm._v("Eliminar")])])])
  }), 0)])])])])], _vm._v(" "), [(_vm.servicioCheckup) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "servicioCheckout",
      "data-toggle": "collapse",
      "data-target": "#clientServicioCheckout",
      "aria-expanded": "false",
      "aria-controls": "clientServicioCheckout"
    }
  }, [_c('span', [_vm._v("Servicio Checkup")]), _vm._v(" "), (_vm.servicioCheckup && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _vm._m(33)])]) : _vm._e()], _vm._v(" "), [(_vm.servicioReview && _vm.orderDataShow.attributes.payed === 3) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "servicioReview",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReview",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReview"
    }
  }, [_c('span', [_vm._v("Servicio Review")]), _vm._v(" "), (_vm.servicioReview && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReview",
      "aria-labelledby": "servicioReview"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Review:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [_vm._v("\n                    " + _vm._s(reviewD.from_admin === 0 ? reviewD.mesagge_review : ""))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Respuesta:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [(reviewD.from_admin !== 0) ? _c('span', [_vm._v("\n                      . " + _vm._s(reviewD.mesagge_review) + "\n                      "), (reviewD.url_review) ? _c('span', [_vm._v("\n                        - "), _c('a', {
      attrs: {
        "href": reviewD.url_review,
        "target": "_Blank"
      }
    }, [_vm._v("Documento")])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_vm._v("Responder:")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.RespuestaReview.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formReviewSer.respuesta),
      expression: "formReviewSer.respuesta"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Ingresar respuesta",
      "required": ""
    },
    domProps: {
      "value": (_vm.formReviewSer.respuesta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formReviewSer, "respuesta", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.subirArchivoReview
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      Mandar respuesta\n                    ")])])], 2)])])]) : _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "servicioReview",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReview",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReview"
    }
  }, [_c('span', [_vm._v("Servicio Review")]), _vm._v(" "), (_vm.servicioReview && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReview",
      "aria-labelledby": "servicioReview"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Review:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [_vm._v("\n                    " + _vm._s(reviewD.from_admin === 0 ? reviewD.mesagge_review : ""))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Respuesta:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [(reviewD.from_admin !== 0) ? _c('span', [_vm._v("\n                      . " + _vm._s(reviewD.mesagge_review) + "\n                      "), (reviewD.url_review) ? _c('span', [_vm._v("\n                        - "), _c('a', {
      attrs: {
        "href": reviewD.url_review,
        "target": "_Blank"
      }
    }, [_vm._v("Documento")])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_vm._v("Responder:")]), _vm._v(" "), _vm._m(34)], 2)])])])], _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientOrderReasign",
      "aria-labelledby": "Reasignar orden"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getUserSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group mt-3 w-100"
  }, [_c('label', [_vm._v("ID del usuario")]), _vm._v(" "), _c('div', {
    staticClass: "form-client"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.dni),
      expression: "search.dni"
    }],
    staticClass: "form-control d-block w-100 mb-3",
    attrs: {
      "type": "text",
      "maxlength": "8",
      "required": ""
    },
    domProps: {
      "value": (_vm.search.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "dni", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append w-100",
    attrs: {
      "id": "button-addon4"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit btn-subir d-block w-100",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                          Validar cliente\n                        ")])])])])]), _vm._v(" "), (_vm.search.result !== null) ? _c('div', [_c('p', {
    staticClass: "mx-0"
  }, [_vm._v("Resultado:")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "d-flex align-items-center mb-3",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeUserOrder.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-circle mr-3",
    staticStyle: {
      "font-size": "28px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(_vm.search.result.attributes.profile.attributes.name +
    " " +
    _vm.search.result.attributes.profile.attributes.surnames))])])])]) : _vm._e(), _vm._v(" "), (_vm.search.error) ? _c('div', [_vm._v("Cliente no existe en el sistema")]) : _vm._e()]), _vm._v(" "), (_vm.historyUser.length !== 0) ? _c('span', _vm._l((_vm.historyUser), function(history) {
    return _c('div', {
      key: history.id,
      staticClass: "mt-4",
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed pb-2 mb-3",
      staticStyle: {
        "border-bottom": "1px solid #ccc"
      },
      attrs: {
        "id": 'informationHistory' + history.id,
        "data-toggle": "collapse",
        "data-target": '#clientInformationHistory' + history.id,
        "aria-expanded": "false",
        "aria-controls": 'clientInformationHistory' + history.id
      }
    }, [_c('article', {
      staticClass: "p-0"
    }, [_c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Old Client Code:" + _vm._s(history.oldClientCode) + " -\n                        " + _vm._s(history.created_at) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformationHistory' + history.id,
        "aria-labelledby": 'informationHistory' + history.id
      }
    }, [_c('span', [_c('div', {}, [_c('div', {
      staticClass: "cursorNot details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("idOrder:")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(history.idOrder))])])])]), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "cursorPointer details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("oldClientCode:")]), _vm._v(" "), _c('span', {}, [_c('router-link', {
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: history.oldClientCode
          },
        },
        "target": "_Blank"
      }
    }, [_vm._v(_vm._s(history.oldClientCode))])], 1)])])]), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "cursorPointer details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("newClientCode:")]), _vm._v(" "), _c('span', {}, [_c('router-link', {
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: history.newClientCode
          },
        },
        "target": "_Blank"
      }
    }, [_vm._v(_vm._s(history.newClientCode))])], 1)])])]), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "cursorNot details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("status:")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(history.status))])])])])])])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "asociarWarehouse",
      "aria-labelledby": "Warehouse"
    }
  }, [_c('header', {
    staticClass: "switch"
  }, [_c('a', {
    staticClass: "switch__link",
    class: _vm.switchWR === 1 && 'switch__link--active',
    on: {
      "click": function($event) {
        return _vm.changeSiwtch(1)
      }
    }
  }, [_vm._v("\n                  Buscar WR\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "switch__link",
    class: _vm.switchWR === 2 && 'switch__link--active',
    on: {
      "click": function($event) {
        return _vm.changeSiwtch(2)
      }
    }
  }, [_vm._v("\n                  Crear WR\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "switch__bg--active",
    class: _vm.switchWR === 1 ? 'switch__bg--left' : 'switch__bg--right'
  })]), _vm._v(" "), (_vm.switchWR === 1) ? _c('div', {
    staticClass: "details-content-info"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Buscar WR")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('form', {
    staticClass: "w-100",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchWrehouse()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWR),
      expression: "searchWR"
    }],
    staticClass: "form-control mb-3",
    attrs: {
      "type": "text",
      "placeholder": "Ingrese código",
      "required": ""
    },
    domProps: {
      "value": (_vm.searchWR)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWR = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary d-block w-100",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                      Buscar\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.resultSearchWr) ? _c('div', {
    staticClass: "d-block mt-3",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "search",
      "data-toggle": "collapse",
      "data-target": "#clientsearch5",
      "aria-expanded": "false",
      "aria-controls": "clientsearch5"
    }
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.resultSearchWr.attributes.code) + " -\n                    "), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatePaquete(_vm.resultSearchWr.id)
      }
    }
  }, [_vm._v("asignar")])]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientsearch5",
      "aria-labelledby": "search"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('li', [_vm._v("\n                        " + _vm._s(_vm.resultSearchWr.attributes.purchase_order_id ?
    _vm.resultSearchWr.attributes.purchase_order_id :
    "Sin orden asignada") + "\n                      ")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.consignee))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.remitter))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.carrier))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.tracking))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.comment))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.weight))]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.resultSearchWr.attributes.weight_unit.attributes.key_name) + "\n                      ")]), _vm._v(" "), _vm._l((_vm.resultSearchWr.attributes.images), function(image, index) {
    return _c('li', {
      key: image
    }, [_c('a', {
      attrs: {
        "href": image.url,
        "target": "_Blank"
      }
    }, [_vm._v("Imagen - " + _vm._s(index + 1))])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.switchWR === 2) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Crear WR")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Remitente:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.remitter),
      expression: "formCreate.remitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.remitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "remitter", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destinatario (Consignatario):")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.consignee),
      expression: "formCreate.consignee"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Carrier:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.carrier),
      expression: "formCreate.carrier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "carrier", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.tracking),
      expression: "formCreate.tracking"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.tracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "tracking", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.weight),
      expression: "formCreate.weight"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "number",
      "name": "numero",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.formCreate.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Unidad de peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unidad),
      expression: "formCreate.unidad"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "unidad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 12
    }
  }, [_vm._v("Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 22
    }
  }, [_vm._v("Oz")])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comentario:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.comment),
      expression: "formCreate.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fotos del paquete:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "multiple": "",
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn btn-primary d-block w-100 mb-3",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10 ||
        _vm.orderDataShow.attributes.warehouse_flag == 1,
      "type": "submit"
    }
  }, [_vm._v("\n                    Guardar\n                  ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientWarehouse",
      "aria-labelledby": "Warehouse"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn d-block w-100",
    class: _vm.orderDataShow.attributes.warehouse_flag == 0 ?
      'btn-primary' :
      'btn-success',
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10 ||
        _vm.listWarehouse.length === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.limitchangePaquete()
      }
    }
  }, [(_vm.orderDataShow.attributes.warehouse_flag !== 0) ? _c('i', {
    staticClass: "fas fa-check pr-2 pt-1"
  }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.orderDataShow.attributes.warehouse_flag == 0 ?
    "Items incompletos" :
    "Items completos") + "\n                  ")])])]), _vm._v(" "), _vm._l((_vm.listWarehouse), function(data) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-top": "25px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'warehouse' + data.id,
        "data-toggle": "collapse",
        "data-target": '#clientwarehouse' + data.id,
        "aria-expanded": "false",
        "aria-controls": 'clientwarehouse' + data.id
      }
    }, [_c('span', [_vm._v("\n                    " + _vm._s(data.attributes.code) + "\n                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.liberarWR(data.attributes.code)
        }
      }
    }, [_vm._v("\n                      Liberar\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientwarehouse' + data.id,
        "aria-labelledby": 'warehouse' + data.id
      }
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(data.attributes.purchase_order_id))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.consignee))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.remitter))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.carrier))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.tracking))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.comment))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.weight))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.weight_unit.attributes.key_name))]), _vm._v(" "), _vm._l((data.attributes.images), function(image, index) {
      return _c('li', {
        key: image
      }, [_c('a', {
        attrs: {
          "href": image.url,
          "target": "_Blank"
        }
      }, [_vm._v("Imagen - " + _vm._s(index + 1))])])
    })], 2)])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationEntregaDeSendi",
      "aria-labelledby": "informationEntregaDeSendi"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveEntregaSendi.apply(null, arguments)
      }
    }
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entregaSendi.entrega),
      expression: "entregaSendi.entrega"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entregaSendi, "entrega", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Oficina"
    }
  }, [_vm._v("Oficina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dirección"
    }
  }, [_vm._v("Dirección")])])])]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entregaSendi.desciption),
      expression: "entregaSendi.desciption"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.entregaSendi.desciption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entregaSendi, "desciption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "required": ""
    },
    on: {
      "change": _vm.evidenciaSendi
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                          Guardar\n                        ")])])])]), _vm._v(" "), _vm._l((_vm.entregaSendiList), function(data, index) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-top": "25px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'entregaSendi' + data.id,
        "data-toggle": "collapse",
        "data-target": '#cliententregaSendi' + data.id,
        "aria-expanded": "false",
        "aria-controls": 'cliententregaSendi' + data.id
      }
    }, [_c('span', [_c('center', [_vm._v("\n                          Evidencias - " + _vm._s(index + 1) + " -\n                          "), _c('span', {
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteEntregaSendi(data.id)
        }
      }
    }, [_vm._v("Eliminar")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'cliententregaSendi' + data.id,
        "aria-labelledby": 'entregaSendi' + data.id
      }
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(data.delivery))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.description))]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": data.evidence,
        "target": "_Blank"
      }
    }, [_vm._v("Ver imagen")])])])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD31223",
      "aria-labelledby": "informationD31223"
    }
  }, [_c('form', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localInternacionalTracking.codigo),
      expression: "localInternacionalTracking.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "minlength": "5"
    },
    domProps: {
      "value": (_vm.localInternacionalTracking.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localInternacionalTracking, "codigo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localInternacionalTracking.type),
      expression: "localInternacionalTracking.type"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localInternacionalTracking, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.origin.attributes.name) + " -\n                        " + _vm._s(_vm.orderDataShow.attributes.destination.attributes.name) + "\n                      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.destination.attributes.name) + " -\n                        " + _vm._s(_vm.orderDataShow.attributes.origin.attributes.name) + "\n                      ")])])])]), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectTracking),
      expression: "selectTracking"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectTracking = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "L"
    }
  }, [_vm._v("Nacional Tracking")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "I"
    }
  }, [_vm._v("International Tracking")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTracking === 'L' ?
          _vm.createdLocalTracking() :
          _vm.createdInternationalTracking()
      }
    }
  }, [_vm._v("\n                        Guardar\n                      ")])])])])]), _vm._v(" "), (_vm.dataLocalTracking.length !== 0) ? _c('span', [_vm._v("NACIONAL")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataLocalTracking), function(data, index) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-bottom": "25px",
        "margin-top": "12px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'informationLocal' + index,
        "data-toggle": "collapse",
        "data-target": '#clientInformationLocal' + index,
        "aria-expanded": "false",
        "aria-controls": 'clientInformationLocal' + index
      }
    }, [_c('span', [_c('img', {
      attrs: {
        "src": "/static/img/olva.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v("\n                    " + _vm._s(data.data.general.remito) + "-\n                    " + _vm._s(data.data.type === 1 ? "Ida" : "Vuelta") + " -\n                    " + _vm._s(data.data.details[0].estado_tracking)), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.status !== 10) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteTrackingLocal(data.data.general.remito)
        }
      }
    }, [_vm._v("Eliminar")]) : _vm._e(), _vm._v("-"), (_vm.orderDataShow.attributes.status !== 10) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#5974bb"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeHiddenLocal(data.data.general.remito, data.data.hide)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(data.data.hide === 1 || data.data.hide === true ?
      "Ocultar" :
      "Mostrar"))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformationLocal' + index,
        "aria-labelledby": 'informationLocal' + index
      }
    }, [_vm._l((data.data.details), function(items) {
      return _c('div', {
        key: items
      }, [(items.estado_tracking == 'ENTREGADO') ? _c('img', {
        staticStyle: {
          "width": "10%"
        },
        attrs: {
          "src": "https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
        }
      }) : (items.estado_tracking == 'REGISTRADO') ? _c('img', {
        staticStyle: {
          "width": "10%"
        },
        attrs: {
          "src": "https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
        }
      }) : _c('img', {
        staticStyle: {
          "width": "10%"
        },
        attrs: {
          "src": "https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
        }
      }), _vm._v("\n                    " + _vm._s(items.fecha_creacion) + "\n                    "), _c('p', [_c('strong', [_vm._v(_vm._s(items.estado_tracking))]), _vm._v(", " + _vm._s(items.obs) + "\n                    ")])])
    }), _vm._v(" "), _vm._l((data.data.imagenes), function(images, index) {
      return _c('div', {
        key: images
      }, [_c('a', {
        attrs: {
          "href": images.url,
          "target": "_Blank"
        }
      }, [_vm._v("Imagen - " + _vm._s(index + 1))])])
    })], 2)])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD512",
      "aria-labelledby": "informationD512"
    }
  }, [(_vm.orderDataShow.attributes.status !== 10) ? _c('div', {
    staticClass: "details-content-info"
  }, _vm._l((_vm.orderDataShow.attributes
    .order_tracking_details), function(histTracking) {
    return _c('span', {
      key: histTracking,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteTackingStatus(histTracking.id, histTracking.attributes.status)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(histTracking.attributes.status) + " -\n                  "), _vm._l((_vm.statusTracking), function(tracking) {
      return _c('span', {
        key: tracking
      }, [(tracking.id === histTracking.attributes.status) ? _c('span', [_vm._v("\n                      " + _vm._s(tracking.text) + "\n                      "), _c('ul', [_c('li', [_vm._v(_vm._s(histTracking.attributes.date_time))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(histTracking.attributes.admin_name))])])]) : _vm._e()])
    }), _c('br')], 2)
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD5",
      "aria-labelledby": "informationD5"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.buscarViajero.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInputViajero),
      expression: "dataInputViajero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ingresar los datos del viajero a buscar",
      "required": ""
    },
    domProps: {
      "value": (_vm.dataInputViajero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInputViajero = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buscarViajeroCampo),
      expression: "buscarViajeroCampo"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.buscarViajeroCampo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Buscar por nombre del viajero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Buscar por còdigo del viajero")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                    Buscar Viajero\n                  ")])])]), _vm._v(" "), (_vm.orderDataShow.attributes.client_travel !== null) ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": 'information' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id,
      "data-toggle": "collapse",
      "data-target": '#clientInformation' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id,
      "aria-expanded": "false",
      "aria-controls": 'clientInformation' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.name +
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.surnames +
    " - " +
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.client_code) + "\n                    "), _c('br'), _vm._v("\n                    \"Viajero Elejido\"\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": 'clientInformation' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id,
      "aria-labelledby": 'information' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.name) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.surnames) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.document_number) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.cellphone) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.address :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Piso u Oficina:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.inner :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.reference :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.department :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.city :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.istrict :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Corro electrónico:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes.email) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "none" ?
    "Verificado" :
    "No Verificado") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Credencial Frontal:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "none" ||
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "seal" ?
    "Verificado" :
    "No Verificado") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Credencial trasera:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "none" ||
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "face" ?
    "Verificado" :
    "No Verificado") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de usuario:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.client_code) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Origen :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.origin) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.destination) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.arrival_date) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quitarViajero()
      }
    }
  }, [_vm._v("\n                      Quitar de la orden\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.dataViajeros.length !== 0) ? _c('span', _vm._l((_vm.dataViajeros), function(viajes) {
    return _c('div', {
      key: viajes.id,
      staticClass: "mt-4",
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed pb-2 mb-3",
      staticStyle: {
        "border-bottom": "1px solid #ccc"
      },
      attrs: {
        "id": 'information' + viajes.id,
        "data-toggle": "collapse",
        "data-target": '#clientInformation' + viajes.id,
        "aria-expanded": "false",
        "aria-controls": 'clientInformation' + viajes.id
      }
    }, [_c('article', {
      staticClass: "p-0"
    }, [_c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        " + _vm._s(viajes.attributes.client.attributes.profile.attributes.name) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .surnames) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        " + _vm._s(viajes.attributes.client.client_code) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Viaje Origen : " + _vm._s(viajes.attributes.origin) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Viaje Destino : " + _vm._s(viajes.attributes.destination) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Fecha Llegada : " + _vm._s(viajes.attributes.arrival_date) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformation' + viajes.id,
        "aria-labelledby": 'information' + viajes.id
      }
    }, [_c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Código:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v(_vm._s(viajes.attributes.client.id))])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .name) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .surnames) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .document_number) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .cellphone) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.address :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Piso u Oficina:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.inner :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.reference :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.department :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.city :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.district :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Corro electrónico:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.email) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.validation.miss ===
      "none" ?
      "Verificado" :
      "No Verificado") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Credencial Frontal:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.validation.miss ===
      "none" ||
      viajes.attributes.client.attributes.validation.miss ===
      "seal" ?
      "Verificado" :
      "No Verificado") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Credencial trasera:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.validation.miss ===
      "none" ||
      viajes.attributes.client.attributes.validation.miss ===
      "face" ?
      "Verificado" :
      "No Verificado") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Código de usuario:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .userable.client_code) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('button', {
      staticClass: "btn btn-primary form-control",
      attrs: {
        "disabled": _vm.orderDataShow.attributes.status === 10
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.asignarViajeroOrder(
            viajes.id,
            viajes.attributes.client.attributes.profile.attributes
            .userable.client_code
          )
        }
      }
    }, [_vm._v("\n                          Asignar VIajero\n                        ")])])])])])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(48), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD3",
      "aria-labelledby": "informationD3"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addInternationalShooper.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tienda de compra :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.tienda),
      expression: "interShooper.tienda"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.tienda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "tienda", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Enlace:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.enlace),
      expression: "interShooper.enlace"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.enlace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "enlace", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.precio),
      expression: "interShooper.precio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.precio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "precio", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.cantidad),
      expression: "interShooper.cantidad"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.cantidad)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "cantidad", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.peso),
      expression: "interShooper.peso"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.peso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "peso", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Order number:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.order),
      expression: "interShooper.order"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "order", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Invoice Details:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    ref: "invoice",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "file"
    },
    on: {
      "change": _vm.invoice
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                        Recopilar\n                      ")])])])])]), _vm._v(" "), _vm._l((_vm.dataInternationalShooper), function(data) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'informationD3' + data.id,
        "data-toggle": "collapse",
        "data-target": '#clientInformationD3' + data.id,
        "aria-expanded": "false",
        "aria-controls": 'clientInformationD3' + data.id
      }
    }, [_c('span', [_vm._v("International Shopper - " + _vm._s(data.tiendaCompra) + " "), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.status !== 10) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteInternationalShooper(data.id)
        }
      }
    }, [_vm._v("Eliminar")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformationD3' + data.id,
        "aria-labelledby": 'informationD3' + data.id
      }
    }, [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Tienda de compra :")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.tiendaCompra) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Enlace:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.enlace) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.precio) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Cantidad:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.cantidad) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.peso) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Order number:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.orderNumber) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Invoice Details:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [(data.invoiceDetails === null) ? _c('span', [_vm._v(" Sin Invoice ")]) : _c('span', [_c('a', {
      attrs: {
        "href": data.invoiceDetails,
        "target": "Blank"
      }
    }, [_vm._v("Ver Invoice")])])])])])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmationDelete()
      }
    }
  }, [_vm._v("\n            Eliminar orden\n          ")])])], 2)]), _vm._v(" "), _c('b-modal', {
    ref: "modalAuthorizeReposition",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalAuthorizeReposition"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Autorización de reposición del paquete\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalAuthorizeReposition
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n            ¿Desea autorizar la reposición de ejemplares de un paquete a otro en la\n            presente orden de compra?\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorizationOption),
      expression: "authorizationOption"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.authorizationOption, "1")
    },
    on: {
      "change": function($event) {
        _vm.authorizationOption = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorizationOption),
      expression: "authorizationOption"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.authorizationOption, "2")
    },
    on: {
      "change": function($event) {
        _vm.authorizationOption = "2"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("Opción elegida: " + _vm._s(_vm.authorizationOption))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.authorizeReposition
    }
  }, [_vm._v("Enviar decisión")])])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.reposition.attributes.used_items != null &&
    _vm.orderDataShow.attributes.reposition.attributes.used_items > 0
  ) ? _c('b-modal', {
    ref: "modalRepositionDetail",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalRepositionDetail"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Detalle de reposición")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('span', [_c('b', [_vm._v("Items totales en la reposición:\n              " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.used_items))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Items pendientes de reposición:\n            " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.pendient_items))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Items repuestos:\n            " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.used_items -
    _vm.orderDataShow.attributes.reposition.attributes.pendient_items))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.reposition.attributes.child_id != null) ? _c('p', [_vm._v("\n            Ver reposición de items nuevamente incidentados en reposición de ID:\n            " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.child_id) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', [_vm._v("Incidencias por cantidades menores a lo solicitado:")]), _vm._v(" "), _c('ul', _vm._l((_vm.packageRepositions), function(packageRepo) {
    return _c('li', {
      key: packageRepo.id
    }, [_c('span', [_vm._v("ID Paquete")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(packageRepo.package_id))]), _vm._v(" "), _c('span', [_vm._v("ID Incidente")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(packageRepo.attributes.different_quantity_incident.attributes
      .packageIncident.id) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("Items que debieron ser correctos")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(packageRepo.attributes.quantity +
      packageRepo.attributes.different_quantity_incident.attributes
      .correct_items) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("Items realmente correctos")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(packageRepo.attributes.different_quantity_incident.attributes
      .correct_items) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("Items en déficit")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(packageRepo.attributes.quantity))]), _vm._v(" "), _c('span', [_vm._v("Enlace a embarque que perteneció el paquete:")]), _vm._v(" "), _c('p', [_vm._v("\n                Enlace a embarque de ID\n                " + _vm._s(packageRepo.attributes.different_quantity_incident.attributes
      .packageIncident.attributes.package.attributes.boarding_id) + "\n              ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationReposition",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationReposition"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationReposition
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.authorizeReposition()
      }
    }
  }, [_vm._v("\n            Aceptar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmationReposition()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalReevaluation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalReevaluation"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Evaluación de la orden de compra\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReevaluetion
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-tab"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.flagFormEvaluetionPurchaseOrder != 'toFill') ? _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.controllSwithPurchaseOrder == 1
    },
    on: {
      "click": function($event) {
        return _vm.modalControllPurchaseOrder(2)
      }
    }
  }, [_vm._v("Datos web")]) : _vm._e(), _vm._v(" "), (_vm.flagFormEvaluetionPurchaseOrder == 'toFill') ? _c('p', {
    staticClass: "nav-link active"
  }, [_vm._v("\n                Datos web\n              ")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.flagFormEvaluetionPurchaseOrder != 'toFill') ? _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.controllSwithPurchaseOrder == 2
    },
    on: {
      "click": function($event) {
        return _vm.modalControllPurchaseOrder(2)
      }
    }
  }, [_vm._v("Datos reales")]) : _vm._e(), _vm._v(" "), (_vm.flagFormEvaluetionPurchaseOrder == 'toFill') ? _c('p', {
    staticClass: "nav-link inactive"
  }, [_vm._v("\n                Datos reales\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-tabs",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [(_vm.controllSwithPurchaseOrder == 1) ? _c('div', [(_vm.flagFormEvaluetionPurchaseOrder == 'toFill') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costGrabr),
      expression: "costGrabr"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "name": "precio_web",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.costGrabr)
    },
    on: {
      "keyup": function($event) {
        return _vm.setTaxGrabr()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.costGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('precio_web')),
      expression: "errors.has('precio_web')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("precio_web")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "390px"
    }
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "12px",
      "cursor": "pointer",
      "color": "cornflowerblue",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.resetImpuestoWeb
    }
  }, [_vm._v("(Limpiar campos)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.controllSwithPurchaseOrder == 1 &&
          this.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          this.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          this.controllSwithPurchaseOrder == 1 &&\n                          this.flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          this.readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.taxGrabr),
      expression: "taxGrabr"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "impuesto_web",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.taxGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('impuesto_web')),
      expression: "errors.has('impuesto_web')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("impuesto_web")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingGrabr),
      expression: "shippingGrabr"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "costo_envio_web"
    },
    domProps: {
      "value": (_vm.shippingGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('costo_envio_web')),
      expression: "errors.has('costo_envio_web')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("costo_envio_web")))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "form-group adeudo-cal"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_c('a', {
    staticClass: "adeudo-link",
    attrs: {
      "href": 'http://paypal.me/EnviosDeUsa/' +
        Number(
          Math.round(parseFloat(_vm.debitCalculated * 1.07) + 'e2') +
          'e-2'
        )
        .toFixed(2)
        .toString(),
      "target": "_blank"
    }
  }, [_vm._v("Adeudo calculado (USD) :\n                        " + _vm._s(Number(
    Math.round(parseFloat(_vm.debitCalculated) + "e2") + "e-2"
  ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidades de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.unitWeight),
      expression: "unitWeight"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "unidad_peso"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.unitWeight = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecciona la unidad")]), _vm._v(" "), _vm._l((_vm.listUnits), function(units) {
    return _c('option', {
      key: units.id,
      domProps: {
        "value": units
      }
    }, [_vm._v("\n                        " + _vm._s(units.attributes.name) + "\n                      ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unidad_peso')),
      expression: "errors.has('unidad_peso')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("unidad_peso")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso de la orden")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightGrabr),
      expression: "weightGrabr"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "name": "peso_orden",
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.weightGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('peso_orden')),
      expression: "errors.has('peso_orden')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("peso_orden")))])])]) : _vm._e(), _vm._v(" "), (_vm.flagFormEvaluetionPurchaseOrder == 'toShow') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costGrabr),
      expression: "costGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.costGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.costGrabr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxGrabr),
      expression: "taxGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.taxGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxGrabr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingGrabr),
      expression: "shippingGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.shippingGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingGrabr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidades de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitWeight.attributes.name),
      expression: "unitWeight.attributes.name"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unitWeight.attributes, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.unitWeight.attributes.name) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso de la orden")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weightGrabr),
      expression: "weightGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.weightGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightGrabr = $event.target.value
      }
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 2) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio real (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.CostReal),
      expression: "CostReal"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "name": "costo_real",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.CostReal)
    },
    on: {
      "keyup": function($event) {
        return _vm.setTaxReal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CostReal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('costo_real')),
      expression: "errors.has('costo_real')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("costo_real")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rewardFlag),
      expression: "rewardFlag"
    }],
    attrs: {
      "type": "checkbox",
      "id": "rewardFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.rewardFlag) ? _vm._i(_vm.rewardFlag, null) > -1 : (_vm.rewardFlag)
    },
    on: {
      "click": function($event) {
        return _vm.cambiarReward()
      },
      "change": function($event) {
        var $$a = _vm.rewardFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rewardFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rewardFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rewardFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "reward-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresar Reward / Discount")]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), (_vm.rewardFlag) ? _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Reward / Discount (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Reward / Discount (S/)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.rewardDiscount),
      expression: "rewardDiscount"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "id": "email",
      "name": "rewardDiscount",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.rewardDiscount)
    },
    on: {
      "keyup": function($event) {
        return _vm.setTaxReal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rewardDiscount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "310px"
    }
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto real (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto real (USD)")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "12px",
      "cursor": "pointer",
      "color": "cornflowerblue",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.resetImpuestoReal
    }
  }, [_vm._v("(Limpiar campos)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.TaxReal),
      expression: "TaxReal"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "id": "email",
      "name": "real_tax",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.TaxReal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TaxReal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('real_tax')),
      expression: "errors.has('real_tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("real_tax")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costos de envío real (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costos de envío real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingReal),
      expression: "shippingReal"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "id": "email",
      "name": "real_delivery_cost",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.shippingReal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingReal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('real_delivery_cost')),
      expression: "errors.has('real_delivery_cost')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("real_delivery_cost")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 &&
          _vm.orderDataShow.attributes.is_from_grabr_flag,
        url: true,
      }),
      expression: "{\n                      required:\n                        this.orderDataShow.attributes.status === 3 &&\n                        orderDataShow.attributes.is_from_grabr_flag,\n                      url: true,\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingLink),
      expression: "finalBuyingLink"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "link_compra_final",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.finalBuyingLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('a', {
    attrs: {
      "href": 'https://grabr.io/account/conversations/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Link chat de compra'),
      expression: "'Link chat de compra'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "hiper-eva btn-primary"
  }, [_c('i', {
    staticClass: "far fa-comment-dots"
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('a', {
    attrs: {
      "href": 'https://grabr.io/es/grabs/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Link orden de compra'),
      expression: "'Link orden de compra'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "hiper-eva btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-shopping-cart"
  })])]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 1) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.updateEvaluation
    }
  }, [_vm._v("\n            Guardar cambios\n          ")]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 2) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendEvaluation(_vm.id)
      }
    }
  }, [_vm._v("\n            Evaluar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 1) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.modalControllPurchaseOrder(1)
      }
    }
  }, [_vm._v("\n            Continuar\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalProcess",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalProcess"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Grabr\n          ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Linio\n          ")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Mercado Libre\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalProcess
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 &&
          _vm.orderDataShow.attributes.is_from_grabr_flag &&
          _vm.sendProcessFlag,
        url: this.orderDataShow.attributes.status === 3 &&
          _vm.orderDataShow.attributes.is_from_grabr_flag &&
          _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 &&\n                    orderDataShow.attributes.is_from_grabr_flag &&\n                    sendProcessFlag,\n                  url:\n                    this.orderDataShow.attributes.status === 3 &&\n                    orderDataShow.attributes.is_from_grabr_flag &&\n                    sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingLink),
      expression: "finalBuyingLink"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "link_compra_final",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.finalBuyingLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('link_compra_final')),
      expression: "errors.has('link_compra_final')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("link_compra_final")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingCode),
      expression: "finalBuyingCode"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "codigo_compra",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.finalBuyingCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codigo_compra')),
      expression: "errors.has('codigo_compra')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("codigo_compra")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.otherCarrierFlag) ? _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar Carrier")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.carrier),
      expression: "carrier"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "transportista"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carrier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.carrier_list), function(carrier, index) {
    return _c('option', {
      key: ("" + index),
      domProps: {
        "value": ("" + index)
      }
    }, [_vm._v("\n                    " + _vm._s(carrier.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), ( false) ? _c('a', {
    staticClass: "link-trans",
    attrs: {
      "href": _vm.carrier_list[_vm.carrier].url
    }
  }, [_vm._v(_vm._s(_vm.carrier_list[_vm.carrier].name))]) : _vm._e()]) : _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa el nombre del transportista")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierName),
      expression: "otherCarrierName"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "other_carrier_name",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.otherCarrierName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherCarrierName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierFlag),
      expression: "otherCarrierFlag"
    }],
    staticClass: "checkbox-style",
    attrs: {
      "type": "checkbox",
      "id": "otherCarrierFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.otherCarrierFlag) ? _vm._i(_vm.otherCarrierFlag, null) > -1 : (_vm.otherCarrierFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.otherCarrierFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.otherCarrierFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.otherCarrierFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.otherCarrierFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reward-label"
  }, [_vm._v("Otro transportista")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('transportista')),
      expression: "errors.has('transportista')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("transportista")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.numberTracking),
      expression: "numberTracking"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "numero_tracking",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.numberTracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberTracking = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numero_tracking')),
      expression: "errors.has('numero_tracking')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("numero_tracking")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada al origen")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postingDate),
      expression: "postingDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "name": "fecha_llegada_origen",
      "max": "2100-01-01",
      "min": "1900-01-01"
    },
    domProps: {
      "value": (_vm.postingDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postingDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fecha_llegada_origen')),
      expression: "errors.has('fecha_llegada_origen')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("fecha_llegada_origen")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar operador de envío")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operatorOrigin),
      expression: "operatorOrigin"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "operador_envio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operatorOrigin = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('operador_envio')),
      expression: "errors.has('operador_envio')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("operador_envio")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": !_vm.readyToSaveIncompleteData
    },
    on: {
      "click": _vm.updateIncompleOrderData
    }
  }, [_vm._v("\n            Guardar cambios\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "disabled": !_vm.readyToProcessIncompleteData
    },
    on: {
      "click": function($event) {
        return _vm.sendProcess(_vm.id)
      }
    }
  }, [_vm._v("\n            Procesar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalProcessNoGrabr",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalProcessNoGrabr"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Direct\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalProcessNoGrabr
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingCode),
      expression: "finalBuyingCode"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "codigo_compra"
    },
    domProps: {
      "value": (_vm.finalBuyingCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codigo_compra')),
      expression: "errors.has('codigo_compra')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("codigo_compra")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.otherCarrierFlag) ? _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar transportista")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.carrier),
      expression: "carrier"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "transportista"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carrier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.carrier_list), function(carrier, index) {
    return _c('option', {
      key: ("" + index),
      domProps: {
        "value": ("" + index)
      }
    }, [_vm._v("\n                    " + _vm._s(carrier.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), (_vm.carrier != '') ? _c('a', {
    staticClass: "link-trans",
    attrs: {
      "href": _vm.carrier_list[_vm.carrier].url,
      "target": "_blank"
    }
  }, [_vm._v("Enlace a " + _vm._s(_vm.carrier_list[_vm.carrier].name))]) : _vm._e()]) : _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa el nombre del transportista")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierName),
      expression: "otherCarrierName"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "other_carrier_name",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.otherCarrierName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherCarrierName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierFlag),
      expression: "otherCarrierFlag"
    }],
    staticClass: "checkbox-style",
    attrs: {
      "type": "checkbox",
      "id": "otherCarrierFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.otherCarrierFlag) ? _vm._i(_vm.otherCarrierFlag, null) > -1 : (_vm.otherCarrierFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.otherCarrierFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.otherCarrierFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.otherCarrierFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.otherCarrierFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reward-label"
  }, [_vm._v("Otro transportista")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('transportista')),
      expression: "errors.has('transportista')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("transportista")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.numberTracking),
      expression: "numberTracking"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "numero_tracking",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.numberTracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberTracking = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numero_tracking')),
      expression: "errors.has('numero_tracking')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("numero_tracking")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada al origen")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postingDate),
      expression: "postingDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "name": "fecha_llegada_origen",
      "max": "2100-01-01",
      "min": "1900-01-01"
    },
    domProps: {
      "value": (_vm.postingDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postingDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fecha_llegada_origen')),
      expression: "errors.has('fecha_llegada_origen')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("fecha_llegada_origen")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Entrega prometida")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sendingDate),
      expression: "sendingDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "name": "fecha_llegada_cliente",
      "max": "2100-01-01",
      "min": "1900-01-01"
    },
    domProps: {
      "value": (_vm.sendingDate)
    },
    on: {
      "change": _vm.validar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sendingDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fecha_llegada_cliente')),
      expression: "errors.has('fecha_llegada_cliente')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("fecha_llegada_cliente")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar operador de envío")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operatorOrigin),
      expression: "operatorOrigin"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "operador_envio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operatorOrigin = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('operador_envio')),
      expression: "errors.has('operador_envio')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("operador_envio")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": !_vm.readyToSaveIncompleteData
    },
    on: {
      "click": _vm.updateIncompleOrderData
    }
  }, [_vm._v("\n            Guardar cambios\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "disabled": !_vm.readyToProcessIncompleteData
    },
    on: {
      "click": function($event) {
        return _vm.sendProcess(_vm.id)
      }
    }
  }, [_vm._v("\n            Procesar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "validacionmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": "",
      "centered": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_vm._v("\n            Continuar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "cancelOrdermodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "cancelOrdermodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideCancelValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-no-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("\n              Se cambiará el estado de la orden a cancelado, esta acción no es\n              reversible. ¿Estas seguro de completar esta acción?\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelatePurchaseOrder(_vm.id)
      }
    }
  }, [_vm._v("\n            Confirmar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationDelete",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationDelete"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationDelete
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("\n              Se eliminará la orden de forma física, esta acción no es reversible.\n              ¿Estas seguro de completar esta acción?\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deletePurchaseOrder(_vm.id)
      }
    }
  }, [_vm._v("\n            Confirmar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmationDelete()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])]), _vm._v(" "), _c('div')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Oferta por evaluar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Oferta no aprobada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Oferta aprobada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Esperando revisión del administrador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Listo para el flujo de tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("En proceso de tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("En proceso de tracking con retraso")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-container"
  }, [_c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Recibido y completando datos de recepción")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Listo para embarcar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-separator"
  }, [_c('span', [_vm._v("Información de la orden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information1",
      "data-toggle": "collapse",
      "data-target": "#clientInformation1",
      "aria-expanded": "false",
      "aria-controls": "clientInformation1"
    }
  }, [_c('span', [_vm._v("Detalle de la orden")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information2",
      "data-toggle": "collapse",
      "data-target": "#clientInformation2",
      "aria-expanded": "false",
      "aria-controls": "clientInformation2"
    }
  }, [_c('span', [_vm._v("Detalle de la cuenta")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sin Dirección Registrada ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information3",
      "data-toggle": "collapse",
      "data-target": "#clientInformation3",
      "aria-expanded": "false",
      "aria-controls": "clientInformation3"
    }
  }, [_c('span', [_vm._v("Detalle de envío")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information4",
      "data-toggle": "collapse",
      "data-target": "#clientInformation4",
      "aria-expanded": "false",
      "aria-controls": "clientInformation4"
    }
  }, [_c('span', [_vm._v("Detalle del presupuesto")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information5",
      "data-toggle": "collapse",
      "data-target": "#clientInformation5",
      "aria-expanded": "false",
      "aria-controls": "clientInformation5"
    }
  }, [_c('span', [_vm._v("Detalle de Pago")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information6",
      "data-toggle": "collapse",
      "data-target": "#clientInformation6",
      "aria-expanded": "false",
      "aria-controls": "clientInformation6"
    }
  }, [_c('span', [_vm._v("Detalle de Tracking")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del cliente")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingshipping",
      "data-toggle": "collapse",
      "data-target": "#collapseshipping",
      "aria-expanded": "false",
      "aria-controls": "collapseshipping"
    }
  }, [_c('span', [_vm._v("Datos de envío")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de entrega: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Recojo en oficina")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingorder",
      "data-toggle": "collapse",
      "data-target": "#collapseorder",
      "aria-expanded": "false",
      "aria-controls": "collapseorder"
    }
  }, [_c('span', [_vm._v("Datos de compra")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapsePago",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos de Pago")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-separator"
  }, [_c('span', [_vm._v("Comentarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("No Gravado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v(" Gravado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("IGV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD1",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD1",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD1"
    }
  }, [_c('span', [_vm._v("Order Evaluation")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Adjunto:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "not-allowed"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "type": "file"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioCheckout",
      "aria-labelledby": "servicioCheckout"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Ingresar respuesta",
      "required": "",
      "readonly": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "not-allowed"
    }
  }, [_c('input', {
    staticStyle: {
      "margin-bottom": "20px",
      "pointer-events": "none"
    },
    attrs: {
      "type": "file"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-primary",
    staticStyle: {
      "cursor": "not-allowed"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                      Mandar respuesta\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "reasignarOrden",
      "data-toggle": "collapse",
      "data-target": "#clientOrderReasign",
      "aria-expanded": "false",
      "aria-controls": "clientOrderReasign"
    }
  }, [_c('span', [_vm._v("Reasignar orden")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "warehouseAsociar",
      "data-toggle": "collapse",
      "data-target": "#asociarWarehouse",
      "aria-expanded": "false",
      "aria-controls": "asociarWarehouse"
    }
  }, [_c('span', [_vm._v("Asociar Warehouse")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "warehouse",
      "data-toggle": "collapse",
      "data-target": "#clientWarehouse",
      "aria-expanded": "false",
      "aria-controls": "clientWarehouse"
    }
  }, [_c('span', [_vm._v("Warehouse")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationEntregaDeSendi",
      "data-toggle": "collapse",
      "data-target": "#clientInformationEntregaDeSendi",
      "aria-expanded": "false",
      "aria-controls": "clientInformationEntregaDeSendi"
    }
  }, [_c('span', [_vm._v("Entrega de Sendi")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Evidencia :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD31223",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD31223",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD31223"
    }
  }, [_c('span', [_vm._v("Tracking")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ruta :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD512",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD512",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD512"
    }
  }, [_c('span', [_vm._v("Historial de tracking")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD5",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD5",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD5"
    }
  }, [_c('span', [_vm._v("Asignar Viajero")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD3",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD3",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD3"
    }
  }, [_c('span', [_vm._v("International Shopper")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}

/***/ }),

/***/ 1877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control form-search",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n              " + _vm._s(option.label) + "\n            ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone filter-block-ship"
  }, [_c('label', [_vm._v("Tipo de operador:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.operatorType),
      expression: "tableData.operatorType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "operatorType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getUsers()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("envío")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("recepción")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.document_number))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.username))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.name) + " " + _vm._s(user.attributes.profile.attributes.surnames))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.city.attributes.name))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [(user.attributes.operator_type === 1) ? _c('span', {
      staticClass: "span-title"
    }, [_vm._v("Envìo")]) : (user.attributes.operator_type === 2) ? _c('span', {
      staticClass: "span-title"
    }, [_vm._v("Recepción")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.country_code) + " " + _vm._s(user.attributes.profile.attributes.cellphone))])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getUsers
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1878:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home\n          ")])])
}]}

/***/ }),

/***/ 1879:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar main-header"
  }, [_c('div', {
    staticClass: "wrap-header"
  }, [_c('div', {
    staticClass: "nav-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-icon"
  }, [_c('div', {
    staticClass: "nav-nuevo"
  }, [_c('notifications-menu'), _vm._v(" "), _c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-nav"
  }, [_c('span', {
    staticClass: "burguer-menu",
    attrs: {
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-sendibox",
    attrs: {
      "src": "/static/img/logo-login.png",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 1880:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLuggageCopy) ? _c('div', {}, [_c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formNew"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalSuitcase",
      modifiers: {
        "modalSuitcase": true
      }
    }],
    staticClass: "btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Añadir equipaje\n            ")])], 1)]), _vm._v(" "), (_vm.dataLuggageCopy.luggage_items != null && _vm.dataLuggageCopy.luggage_items.length != 0) ? _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', _vm._l((_vm.dataLuggageCopy.luggage_items), function(luggageItem) {
    return _c('li', [_c('cardAddLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      },
      on: {
        "delete-from-luggage-list": _vm.deleteFromLuggageList
      }
    })], 1)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.dataLuggageCopy.luggage_items == null || _vm.dataLuggageCopy.luggage_items.length == 0) ? _c('div', {
    staticClass: "emptyVitrina"
  }, [_c('p', [_vm._v("No has añadido equipaje")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeight)) + " kg")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    on: {
      "click": _vm.toNextForm
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalSuitcase",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalSuitcase"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de equipaje")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModalSuitcase
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de equipaje")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.typeLuggage),
      expression: "typeLuggage"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "type_luggage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeLuggage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listLuggageType), function(luggageType) {
    return _c('option', {
      domProps: {
        "value": luggageType
      }
    }, [_vm._v(_vm._s(_vm.luggageTypeTitle[luggageType.attributes.key]))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('type_luggage')),
      expression: "errors.has('type_luggage')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('type_luggage')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2'),
      expression: "'required|decimal:2'"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightLuggage),
      expression: "weightLuggage"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "name": "weight_luggage",
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.weightLuggage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightLuggage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_luggage')),
      expression: "errors.has('weight_luggage')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_luggage')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidad de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightUnitLuggage),
      expression: "weightUnitLuggage"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "weight_unit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.weightUnitLuggage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listWeightUnit), function(weughtUnit) {
    return _c('option', {
      domProps: {
        "value": weughtUnit
      }
    }, [_vm._v(_vm._s(weughtUnit.attributes.name))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_unit')),
      expression: "errors.has('weight_unit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_unit')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.descriptionLuggage),
      expression: "descriptionLuggage"
    }],
    staticClass: "form-control null",
    attrs: {
      "name": "description_luggage",
      "rows": "3",
      "cols": "70",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.descriptionLuggage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descriptionLuggage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description_luggage')),
      expression: "errors.has('description_luggage')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('description_luggage')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewLuggage
    }
  }, [_vm._v("Continuar")])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Equipaje")])])
}]}

/***/ }),

/***/ 1881:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content py-4"
  }, [_c('div', {
    staticClass: "row px-3"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title col-12"
  }, [_vm._v("Datos del usuario")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Nombre y apellidos: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.name))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("DNI: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.document))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Direccion: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.direction))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Teléfono: ")]), _vm._v(_vm._s(_vm.detalleReclamo.phone))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("E-mail: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.email))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Fecha de reclamo: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.created_at))])]), _vm._v(" "), _c('div', {
    staticClass: "row px-3 pt-4"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title col-12"
  }, [_vm._v("Cuéntanos que pasó...")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Tipo de reclamo:  ")]), _vm._v("\n        " + _vm._s(_vm.detalleReclamo.type) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Servicio o producto del reclamo:  ")]), _vm._v("\n         " + _vm._s(_vm.detalleReclamo.store_id === 1 ? 'SENDI' : 'ENVIOS USA') + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("¿Cuál fué el problema?")]), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("\n           " + _vm._s(_vm.detalleReclamo.problem) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("¿Qué solución esperas?")]), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("\n           " + _vm._s(_vm.detalleReclamo.solution) + "\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1882:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ID: " + _vm._s(this.id))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Amount:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountRebate),
      expression: "amountRebate"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "number",
      "aria-describedby": "nameUSer"
    },
    domProps: {
      "value": (_vm.amountRebate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amountRebate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Codigo de Publicación:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicationCode),
      expression: "publicationCode"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "nameUSer"
    },
    domProps: {
      "value": (_vm.publicationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicationCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Intervalo de Fecha ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateTo),
      expression: "dateTo"
    }],
    staticClass: "form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "id": "date",
      "type": "date",
      "placeholder": "To",
      "onkeydown": "return false",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datefrom),
      expression: "datefrom"
    }],
    staticClass: "form-control login__input sen-form-input-with-tooltip",
    attrs: {
      "id": "date2",
      "type": "date",
      "placeholder": "From",
      "onkeydown": "return false",
      "required": ""
    },
    domProps: {
      "value": (_vm.datefrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datefrom = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.editRebate()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v("Editar")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-secunday",
    on: {
      "click": function($event) {
        return _vm.deleteRebate()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  }), _vm._v("Eliminar")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Editar Rebate Seleccionado")])])])
}]}

/***/ }),

/***/ 1883:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message.body))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1884:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header"
  }, [_c('span', {
    staticClass: "kt-subheader__title"
  }, [_vm._v(_vm._s(_vm.nameSection) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "kt-subheader__breadcrumbs"
  }, [_c('router-link', {
    staticClass: "kt-subheader__breadcrumbs-home",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  })]), _vm._v(" "), _vm._l((_vm.listRoutes), function(route) {
    return _c('div', {
      staticClass: "bread-new"
    }, [_c('span', {
      staticClass: "kt-subheader__breadcrumbs-separator"
    }), _vm._v(" "), (!route.idRoute) ? _c('router-link', {
      staticClass: "kt-subheader__breadcrumbs-link",
      attrs: {
        "to": {
          name: route.nameRoute
        }
      }
    }, [_vm._v(_vm._s(route.titleRoute))]) : _vm._e(), _vm._v(" "), (route.idRoute) ? _c('router-link', {
      staticClass: "kt-subheader__breadcrumbs-link",
      attrs: {
        "to": {
          name: route.nameRoute,
          params: {
            id: route.idRoute
          }
        }
      }
    }, [_vm._v(_vm._s(route.titleRoute))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.activeRoute) ? _c('span', {
    staticClass: "bread-new"
  }, [_c('span', {
    staticClass: "kt-subheader__breadcrumbs-separator"
  }), _vm._v(" "), _c('span', {
    staticClass: "kt-subheader__breadcrumbs-link route-none"
  }, [_vm._v(_vm._s(_vm.activeRoute))])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1885:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.colorClass]
  }, [_c('i', {
    class: _vm.iconClasses
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1886:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkServer.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "login-create"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateName,
    attrs: {
      "type": "text",
      "maxlength": 50,
      "id": "firstname",
      "aria-describedby": "firstname",
      "placeholder": "Ingresa tu nombre",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.responseName) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateLast,
    attrs: {
      "type": "text",
      "maxlength": 100,
      "id": "lastname",
      "aria-describedby": "lastname",
      "placeholder": "Ingresa tus apellidos",
      "required": ""
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.responseLast) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseLast))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateUser,
    attrs: {
      "type": "email",
      "id": "email",
      "aria-describedby": "email",
      "placeholder": "Ingresa tu email",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.responseUser) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUser))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip' + _vm.validatePhone,
    attrs: {
      "type": "tel",
      "maxlength": 9,
      "id": "phone",
      "aria-describedby": "phone",
      "placeholder": "Numero de telefono",
      "required": ""
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.responsePhone != '') ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePhone))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sexo),
      expression: "sexo"
    }],
    class: 'custom-select form-control login__input sen-form-input-with-tooltip ' + _vm.validateGenre,
    attrs: {
      "name": "sexo",
      "id": "genre",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sexo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Femenino")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.responseGenre) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseGenre))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateDate,
    attrs: {
      "id": "date",
      "type": "date",
      "placeholder": "Fecha de nacimiento",
      "onkeydown": "return false",
      "required": ""
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.responseDate) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseDate))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validatePass,
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Contraseña",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.responsePass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePass))]) : _vm._e(), _vm._v(" "), (_vm.response2Pass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.response2Pass))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkPassword),
      expression: "checkPassword"
    }],
    class: 'form-control login__input sen-form-input-with-tooltip ' + _vm.validateCheck,
    attrs: {
      "type": "password",
      "id": "password2",
      "placeholder": "Repita contraseña",
      "required": ""
    },
    domProps: {
      "value": (_vm.checkPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.responseCheck) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseCheck))]) : _vm._e()]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary mt-4 btn-lg btn-block btn-round  ' + _vm.loading,
    attrs: {
      "type": "submit",
      "id": "submit"
    }
  }, [_vm._v("Continuar")])]), _vm._v(" "), (_vm.response) ? _c('div', [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sen-tooltip sen-tooltip-create"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])
}]}

/***/ }),

/***/ 1887:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['info-box', _vm.colorClass]
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    class: _vm.iconClasses
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.description))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1888:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-order"
  }, [_c('div', {
    staticClass: "form_container form-flex"
  }, [_c('div', {
    staticClass: "container-order"
  }, [_c('div', {
    staticClass: "chooseOrder order-block"
  }, [_c('div', {
    staticClass: "vitrina-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterValue),
      expression: "filterValue"
    }],
    staticClass: "form-control col-md-4",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.filterValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipaje),
      expression: "equipaje"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.equipaje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar equipaje")]), _vm._v(" "), _vm._l((_vm.dataLocal.dataLuggage.luggage_items), function(luggageItem) {
    return _c('option', {
      domProps: {
        "value": luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration
      }
    }, [_vm._v(_vm._s(luggageItem.attributes.luggage_type.attributes.name.charAt(0).toUpperCase() + luggageItem.attributes.luggage_type.attributes.name.slice(1)) + " -  " + _vm._s(luggageItem.numeration))])
  })], 2)])]), _vm._v(" "), (_vm.availableOrders.length <= 0) ? _c('div', [_c('span', {
    staticClass: "page-stats no-orders"
  }, [_vm._v("No cuenta con órdenes disponibles para este embarque")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', _vm._l((_vm.items), function(order) {
    return (order.attributes.available_items_to_package > 0) ? _c('li', {
      key: order.id
    }, [_c('cardListOrders', {
      attrs: {
        "currentOrder": order,
        "stock": order.attributes.available_items_to_package,
        "dataLocal": _vm.dataLocal,
        "equipaje": _vm.equipaje,
        "totalWeightKg": _vm.totalWeightKg
      },
      on: {
        "add-package": _vm.addPackage
      }
    })], 1) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "resumeOrder order-block"
  }, [_c('div', {
    staticClass: "vitrina-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tu embarque")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "30px"
    },
    on: {
      "click": _vm.openAcordion
    }
  }, [_vm._v(_vm._s(_vm.isShowAll ? 'Cerrar todo' : 'Abrir todo'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeightKg.toFixed(2))) + " Kg")])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.savePackages
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.form4
    }
  }, [_vm._v("Continuar")])], 1)]), _vm._v(" "), _vm._l((_vm.dataLocal.dataLuggage.luggage_items), function(luggageItem) {
    return _c('div', [_c('div', {
      ref: "parentAcoordition",
      refInFor: true,
      staticClass: "card panel-group",
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": "headingclient",
        "data-toggle": "collapse",
        "data-target": '#collapseclient' + luggageItem.numeration,
        "aria-expanded": "false",
        "aria-controls": 'collapseclient' + luggageItem.numeration
      }
    }, [_c('span', [_vm._v(_vm._s(luggageItem.attributes.luggage_type.attributes.name.charAt(0).toUpperCase() + luggageItem.attributes.luggage_type.attributes.name.slice(1)) + " -  " + _vm._s(luggageItem.numeration))]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      class: _vm.isShowAll ? 'collapse show' : 'collapse',
      attrs: {
        "id": 'collapseclient' + luggageItem.numeration,
        "aria-labelledby": "headingclient"
      }
    }, [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "resumen-type"
    }, [_c('div', {
      staticClass: "vitrinaContainer"
    }, [_c('div', {
      staticClass: "vitrina"
    }, [_c('ul', _vm._l((_vm.packagesToSave), function(addedPackage) {
      return (luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration === addedPackage.equipaje) ? _c('li', [_c('cardDeleteOrders', {
        attrs: {
          "dataOrder": addedPackage
        },
        on: {
          "quit-package": _vm.quitPackage
        }
      })], 1) : _vm._e()
    }), 0)])])])])]), _vm._v(" "), _vm._l((_vm.sumaTotalPeso), function(suma) {
      return (luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration === suma.tipo) ? _c('div', {
        staticClass: "text-right"
      }, [_c('div', {
        staticClass: "sumaPeso"
      }, [(typeof(suma.sumaPeso) === 'undefined') ? _c('span', [_vm._v(" " + _vm._s(luggageItem.attributes.weight) + " Kg")]) : _c('span', [_vm._v(_vm._s(suma.sumaPeso.toFixed(2)) + " Kg")])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.sumaTotalPrecio), function(suma2) {
      return (luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration === suma2.tipo) ? _c('div', {
        staticClass: "text-right",
        staticStyle: {
          "margin-right": "300px"
        }
      }, [_c('div', {
        staticClass: "sumaPrecio"
      }, [(typeof(suma2.precio) === 'undefined') ? _c('span', [_vm._v(" $ 0")]) : _c('span', [_vm._v("$ " + _vm._s(suma2.precio.toFixed(2)))])])]) : _vm._e()
    })], 2)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "formContent",
    staticStyle: {
      "margin-left": "460px"
    }
  }, [_c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeightKg.toFixed(2))) + " Kg")])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.savePackages
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.form4
    }
  }, [_vm._v("Continuar")])], 1)])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tus órdenes")])])
}]}

/***/ }),

/***/ 1889:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control form-search",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v(_vm._s(option.label))])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_c('span', [_vm._v(_vm._s(user.attributes.profile.attributes.document_number))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(user.attributes.username))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(user.attributes.profile.attributes.name) + " " + _vm._s(user.attributes.profile.attributes.surnames))])]), _vm._v(" "), _c('td', [(user.attributes.profile.attributes.gender === 'M') ? _c('span', [_vm._v("Masculino")]) : _vm._e(), (user.attributes.profile.attributes.gender === 'F') ? _c('span', [_vm._v("Femenino")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(user.attributes.profile.attributes.country_code) + " " + _vm._s(user.attributes.profile.attributes.cellphone))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(user.attributes.profile.attributes.birthdate))])]), _vm._v(" "), _c('td', {
      staticClass: "action-column"
    }, [_c('button', {
      staticClass: "action-btn delete",
      on: {
        "click": function($event) {
          return _vm.editPassword(user.id)
        }
      }
    }, [_c('img', {
      staticClass: "img-nav",
      attrs: {
        "src": "/static/img/cambiarPassw.svg",
        "alt": "Cambiar contraseña"
      }
    })])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getUsers
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1890:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (typeof(_vm.notifications.data) != 'undefined') ? _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "icon-avatar",
    attrs: {
      "id": "dropdown",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "img-nav",
    attrs: {
      "src": "/static/img/notification.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notification-cant"
  }, [_c('span', [_vm._v(_vm._s(_vm.unreadCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu drop-edit",
    attrs: {
      "aria-labelledby": "dropdown"
    }
  }, [_c('div', {
    staticClass: "notification-item-container"
  }, [_c('div', {
    staticClass: "notification-content"
  }, _vm._l((_vm.notifications.data), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      },
      on: {
        "readSuccess": _vm.discountReadNotification
      }
    })
  }), 1), _vm._v(" "), (!_vm.notifications.data.length) ? _c('div', {
    staticClass: "no-notifications"
  }, [_c('span', [_vm._v("No tienes nuevas notificaciones")])]) : (_vm.nextNotificationsUrl != null) ? _c('div', {
    staticClass: "notification-more",
    on: {
      "click": _vm.getMoreNotifications
    }
  }, [_c('span', [_vm._v("Ver más")])]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1891:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-container sendi-admin-entry"
  }, [_c('div', {
    staticClass: "d-content"
  }, [_c('div', {
    staticClass: "login-header text-center"
  }, [_c('button', {
    staticClass: "return-login",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/flecha.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Volver")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    class: _vm.tipologin,
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "form-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "form-login"
    }
  }, [_c('router-view')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-login"
  }, [_c('img', {
    staticClass: "logo-login",
    attrs: {
      "src": "/static/img/sendi-logo.png",
      "width": "400",
      "height": "78",
      "alt": "Sendi"
    }
  })])
}]}

/***/ }),

/***/ 1892:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderDataShow.attributes.is_from_grabr_flag || _vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "card-body"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "msj-inversion"
  }, [_c('span', [_vm._v("Inviertes " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)) + "\n    y ganas " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost))) + ".\n    Un  " + _vm._s(_vm._f("currency")((((_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)))) + "% respecto a tu inversión.")])]) : (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "msj-inversion"
  }, [_c('span', [_vm._v("Inviertes " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)) + "\n    y ganas " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + _vm.orderDataShow.attributes.linioOrder.attributes.debit - (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost))) + ".\n    Un  " + _vm._s(_vm._f("currency")((((_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + _vm.orderDataShow.attributes.linioOrder.attributes.debit - (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)))) + "% respecto a tu inversión.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content-details-container"
  }, [_c('div', {
    staticClass: "card-content-details-block"
  }, [_c('div', {
    staticClass: "card-content-details"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos sugeridos por web de Grabr")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos sugeridos por web de Linio")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos sugeridos por web de Meli")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked)))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ 0")])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ 0")])]) : (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ 0")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tax")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Shipping")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web)))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Adeudo")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.debit)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fob (Subtotal)")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked + _vm.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked + _vm.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked + _vm.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked + _vm.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web)))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_security_cost)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_security_cost)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_flete_cost)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_flete_cost)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("CIF (Subtotal 2)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.cif)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("CIF (Subtotal 2)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.cif)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (
        'Ad Valorem: $ ' + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem +
        '\nIGV: $ ' + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv +
        '\nIPM: $ ' + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm),
      expression: "\n              'Ad Valorem: $ ' + orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem +\n              '\\nIGV: $ ' + orderDataShow.attributes.linioOrder.attributes.linio_igv +\n              '\\nIPM: $ ' + orderDataShow.attributes.linioOrder.attributes.linio_ipm",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Impuestos")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (
        'Ad Valorem: $ ' + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem +
        '\nIGV: $ ' + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv +
        '\nIPM: $ ' + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm),
      expression: "\n              'Ad Valorem: $ ' + orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem +\n              '\\nIGV: $ ' + orderDataShow.attributes.meliOrder.attributes.meli_igv +\n              '\\nIPM: $ ' + orderDataShow.attributes.meliOrder.attributes.meli_ipm",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Impuestos")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Guía: $8.00' + '\nIGV: $1.44'),
      expression: "'Guía: $8.00' + '\\nIGV: $1.44'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Trámite Aduanero")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.customsProcedureConstant))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Costo Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.cif + (_vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm) + _vm.customsProcedureConstant)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Costo Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.cif + (_vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm) + _vm.customsProcedureConstant)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.web_total_cost)) * 100) / (_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee + _vm.orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat((( orderDataShow.attributes.evaluation_info.attributes.grabr_total + orderDataShow.attributes.grabrOrder.attributes.debit - (orderDataShow.attributes.evaluation_info.attributes.web_total_cost))*100)/(orderDataShow.attributes.grabrOrder.attributes.grabr_price+orderDataShow.attributes.grabrOrder.attributes.grabr_tax+orderDataShow.attributes.grabrOrder.attributes.grabr_fee + orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.web_total_cost))))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total +
          _vm.orderDataShow.attributes.linioOrder.attributes.debit -
          (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.web_total_cost)) * 100) /
        (_vm.orderDataShow.attributes.linioOrder.attributes.linio_price +
          _vm.orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.linio_evaluation_info.attributes.linio_total +\n              orderDataShow.attributes.linioOrder.attributes.debit -\n              (orderDataShow.attributes.linio_evaluation_info.attributes.web_total_cost))*100)\n              /(orderDataShow.attributes.linioOrder.attributes.linio_price\n              + orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("\n              Utilidad\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price - (_vm.orderDataShow.attributes.linioOrder.attributes.cif + (_vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm) + _vm.customsProcedureConstant))))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.meli_evaluation_info.attributes.meli_total +
          _vm.orderDataShow.attributes.meliOrder.attributes.debit -
          (_vm.orderDataShow.attributes.meli_evaluation_info.attributes.web_total_cost)) * 100) /
        (_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar +
          _vm.orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.meli_evaluation_info.attributes.meli_total +\n              orderDataShow.attributes.meliOrder.attributes.debit -\n              (orderDataShow.attributes.meli_evaluation_info.attributes.web_total_cost))*100)\n              /(orderDataShow.attributes.meliOrder.attributes.meli_price_dollar\n              + orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("\n              Utilidad\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar - (_vm.orderDataShow.attributes.meliOrder.attributes.cif + (_vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm) + _vm.customsProcedureConstant))))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item summary-block-total"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.web_total_cost)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_dollar)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar)))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-details-block"
  }, [_c('div', {
    staticClass: "card-content-details"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_price)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.reward_discount)))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.reward_discount)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.reward_discount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_tax)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_shipping)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fob (Subtotal)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.fob)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.securityCost)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete")]), _vm._v(" "), (!this.costingMethodFlag) ? _c('div', [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.fleteCost)))])]) : _c('div', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fleteCost),
      expression: "fleteCost"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null",
    domProps: {
      "value": (_vm.fleteCost)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updatePurchaseOrder.apply(null, arguments)
      }, function($event) {
        return _vm.calculated()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fleteCost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("CIF (Subtotal 2)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.cif)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Ad Valorem: $ ' + _vm.adValorem +
        '\nIGV: $ ' + _vm.igv +
        '\nIPM: $ ' + _vm.ipm),
      expression: "'Ad Valorem: $ ' + adValorem +\n                                    '\\nIGV: $ ' + igv +\n                                    '\\nIPM: $ ' + ipm",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Impuestos")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.adValorem + _vm.igv + _vm.ipm)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Guía: $8.00' + '\nIGV: $1.44'),
      expression: "'Guía: $8.00' + '\\nIGV: $1.44'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Trámite Aduanero")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.customsProcedure)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Costo Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.costoTotal)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee + _vm.orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.evaluation_info.attributes.grabr_total + orderDataShow.attributes.grabrOrder.attributes.debit - (orderDataShow.attributes.evaluation_info.attributes.real_total_cost))*100)/(orderDataShow.attributes.grabrOrder.attributes.grabr_price+orderDataShow.attributes.grabrOrder.attributes.grabr_tax+orderDataShow.attributes.grabrOrder.attributes.grabr_fee + orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost))))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + _vm.orderDataShow.attributes.linioOrder.attributes.debit - (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.linioOrder.attributes.linio_price + _vm.orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + orderDataShow.attributes.linioOrder.attributes.debit - (orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost))*100)/(orderDataShow.attributes.linioOrder.attributes.linio_price + orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_dollar - (_vm.cif + (_vm.adValorem + _vm.igv + _vm.ipm) + _vm.customsProcedure))))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.meli_evaluation_info.attributes.meli_total + _vm.orderDataShow.attributes.meliOrder.attributes.debit - (_vm.orderDataShow.attributes.meli_evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar + _vm.orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.meli_evaluation_info.attributes.meli_total + orderDataShow.attributes.meliOrder.attributes.debit - (orderDataShow.attributes.meli_evaluation_info.attributes.real_total_cost))*100)/(orderDataShow.attributes.meliOrder.attributes.meli_price_dollar + orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar - (_vm.cif + (_vm.adValorem + _vm.igv + _vm.ipm) + _vm.customsProcedure))))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item summary-block-total"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_dollar)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar)))]) : _vm._e()])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block details-summary-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos reales")])])
}]}

/***/ }),

/***/ 1893:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Repos")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Github Repos")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', [_vm._v("\n        Found an error\n      ")]) : _c('div', _vm._l((_vm.response), function(repo) {
    return (_vm.response) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "box box-widget widget-user"
    }, [_c('div', {
      staticClass: "widget-user-header bg-aqua-active text-center"
    }, [_c('h3', {
      staticClass: "widget-user-username center-text"
    }, [_vm._v(_vm._s(repo.name))])]), _vm._v(" "), _c('div', {
      staticClass: "widget-user-image"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": repo.owner.avatar_url,
        "alt": "repo.owner.login + ' Avatar'"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-footer"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4 border-right"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(repo.stargazers_count))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v("Star")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 border-right"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('a', {
      attrs: {
        "href": repo.owner.html_url,
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Visit")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(repo.forks_count))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v("Forks")])])])])])])]) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1894:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina vitrinaSuitcase"
  }, [_c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.description))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.destination.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Operador de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.reciever_operator.attributes.username))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de salida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataLocal.dataShipment.arrival_date)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataLocal.dataShipment.departure_date)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient2",
      "aria-labelledby": "headingclient2"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataLocal.dataLuggage.luggage_items), function(luggageItem) {
    return _c('li', [_c('cardDetailLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      }
    })], 1)
  }), 0)])])])])])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient3",
      "aria-labelledby": "headingclient3"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    class: _vm.sortedClass('equipaje'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('equipaje')
      }
    }
  }, [_vm._v("Equipaje")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('numeroOrden'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('numeroOrden')
      }
    }
  }, [_vm._v("Número de Orden")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('cantidad'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('cantidad')
      }
    }
  }, [_vm._v("Cantidad")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('precioDeclarado'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('precioDeclarado')
      }
    }
  }, [_vm._v("Precio Declarado")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('peso'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('peso')
      }
    }
  }, [_vm._v("Peso")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedItems), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.equipaje))]), _vm._v(" "), _c('td', [_vm._v("#" + _vm._s(item.numeroOrden) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cantidad))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(item.precioDeclarado) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.peso) + " Kg")])])
  }), 0)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeightLb)) + " Kg")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showModalConfirmation
    }
  }, [_vm._v("Despachar embarque")])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toSendForm()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Resumen del embarque")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del embarque")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient2",
      "data-toggle": "collapse",
      "data-target": "#collapseclient2",
      "aria-expanded": "false",
      "aria-controls": "collapseclient2"
    }
  }, [_c('span', [_vm._v("Detalles de equipaje")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient3",
      "data-toggle": "collapse",
      "data-target": "#collapseclient3",
      "aria-expanded": "false",
      "aria-controls": "collapseclient3"
    }
  }, [_c('span', [_vm._v("Detalle de paquetes")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}

/***/ }),

/***/ 1895:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {}, [_c('h2', {
    staticClass: "bold mb-5"
  }, [_vm._v("Account")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.perfil.avatar === null) ? _c('img', {
    staticClass: "rounded-circle mr-5",
    attrs: {
      "src": __webpack_require__(1764)
    }
  }) : _c('img', {
    staticClass: "rounded-circle mr-5",
    attrs: {
      "src": _vm.perfil.avatar,
      "width": "200px",
      "height": "150px"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "bold mb-2"
  }, [_vm._v(_vm._s(_vm.perfil.nombre))]), _vm._v(" "), _c('p', {
    staticClass: "m-0 text-muted"
  }, [_vm._v(_vm._s(_vm.perfil.apellido))]), _vm._v(" "), _c('span', {
    staticClass: "badge badge-primary",
    class: _vm.perfil.store === 2 ? 'bg-danger' : ' bg-primary'
  }, [_vm._v("\n          " + _vm._s(_vm.perfil.store === 2 ? "Envios" : " Sendi"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 1 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 1
      }
    }
  }, [_vm._v("\n      Perfil\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 2 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 2
      }
    }
  }, [_vm._v("\n      Saldo\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 3 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 3
      }
    }
  }, [_vm._v("\n      Pedidos\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 4 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 4
      }
    }
  }, [_vm._v("\n      Direcciones\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 5 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 5
      }
    }
  }, [_vm._v("\n      Credenciales\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 6 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 6
      }
    }
  }, [_vm._v("\n      Cotizaciones\n    ")]), _vm._v(" "), (_vm.perfil.store === 2) ? _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 7 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 7
      }
    }
  }, [_vm._v("\n      Viajes\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn mr-2",
    class: _vm.section === 8 ? 'btn-primary' : 'btn-secondary',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.section = 8
      }
    }
  }, [_vm._v("\n      Influencer\n    ")])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), (_vm.section === 2) ? _c('button', {
    staticClass: "btn d-block ml-auto mb-4 btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('modal-operacion')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n    Agregar operación\n  ")]) : _vm._e(), _vm._v(" "), (_vm.section === 1) ? _c('PerfilComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser,
      "direction": _vm.direction,
      "perfil": _vm.perfil
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 2) ? _c('SaldoComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 3) ? _c('PedidoComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 4) ? _c('DirectionComponent', {
    attrs: {
      "perfil": _vm.perfil,
      "credential": _vm.credential
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 5) ? _c('CredentialComponent', {
    attrs: {
      "credential": _vm.credential,
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 6) ? _c('CotizacionComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 7) ? _c('ViajeComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser,
      "travelSquad": _vm.travel_squad
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section === 8) ? _c('button', {
    staticClass: "d-block mb-4 ml-auto",
    class: _vm.influencerFlag === 1 ? 'btn btn-danger' : 'btn btn-primary',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeFlagInfluencer(_vm.influencerFlag === 1 ? 0 : 1)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.influencerFlag === 1 ? "Desactivar Influencer" : "Activar Influencer") + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.section === 8) ? _c('CodigoComponent', {
    attrs: {
      "idUser": _vm.$route.params.idUser
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-operacion"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addSaldoUser()
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Agregar operación")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-operacion')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Titulo de la operación")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saldo.title),
      expression: "saldo.title"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.saldo.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saldo, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción de la operación")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saldo.description),
      expression: "saldo.description"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.saldo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saldo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-8 pl-0"
  }, [_c('label', [_vm._v("Monto de la operacion")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saldo.monto),
      expression: "saldo.monto"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.saldo.monto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saldo, "monto", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar operación\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1896:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/restorepassword",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "far fa-check-circle customCheck"
  }), _vm._v(" "), _c('h2', {
    staticClass: "p-2 font-weight-bold"
  }, [_vm._v("¡Se ha enviado el correo correctamente!")]), _vm._v(" "), _c('p', {
    staticClass: "px-4"
  }, [_vm._v("Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1897:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [(_vm.travel_squad === 1) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.unactivateSquad()
      }
    }
  }, [_vm._v("Desactivar Travel Squad")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.activateSquad()
      }
    }
  }, [_vm._v("Activar Travel Squad")])]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.viajes), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.origin))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.destination))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(" " + _vm._s(data.arrival_date))])])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getViajes
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1898:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), (_vm.dataShipment && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "status-content"
  }, [_c('div', {
    staticClass: "tag-content"
  }, [(_vm.dataShipment.attributes.status >= 1 && _vm.dataShipment.attributes.status <= 3) ? _c('span', {
    staticClass: "badge badge-primary badge-grabr"
  }, [_vm._v("Procesamiento en origen")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status >= 5 && _vm.dataShipment.attributes.status <= 7) ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-success"
  }, [_vm._v("Procesamiento en destino")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 4) ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-danger"
  }, [_vm._v("Stand-by")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 1) ? _c('p', [_vm._v("En direccion origen")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 2) ? _c('p', [_vm._v("Camino a aeropuerto")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 3) ? _c('p', [_vm._v("Vuelo al destino en curso")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 5) ? _c('p', [_vm._v("En aeropuerto del destino")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 6) ? _c('p', [_vm._v("En evaluación")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 7) ? _c('p', [_vm._v("Evaluación finalizada")]) : _vm._e()]), _vm._v(" "), (_vm.dataShipment.attributes.status == 5 && _vm.$store.state.user.attributes.permissions_keys.includes(18)) ? _c('div', {
    staticClass: "rr"
  }, [(_vm.dataOrderCopy != null && _vm.dataOrderCopy.length != 0) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.beginEvaluationPackages
    }
  }, [_vm._v("Iniciar evaluación de  paquetes")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 2) ? _c('div', {
    staticClass: "rr"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(17)) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showModalReprogramation
    }
  }, [_vm._v("Reprogramar")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(13)) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmDepartureShipment
    }
  }, [_vm._v("Confirmar despegue")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 3) ? _c('div', {
    staticClass: "rr"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(16)) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmArrivalShipment
    }
  }, [_vm._v("Confirmar llegada")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Embarque # " + _vm._s(_vm.dataShipment.id))])]), _vm._v(" "), _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [(_vm.dataShipment) ? _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataShipment.attributes.description))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataShipment.attributes.destination.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Operador de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataShipment.attributes.reciever_operator.attributes.username))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.departure_date)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de salida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.arrival_date)))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient2",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [(_vm.dataLuggageCopy.length > 0) ? _c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataLuggageCopy), function(luggageItem) {
    return _c('li', [_c('cardDetailLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      }
    })], 1)
  }), 0)]) : _c('div', {
    staticClass: "vitrina"
  }, [_c('p', [_vm._v("No hay equipajes asignados")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient3",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [(_vm.dataOrderCopy.length > 0) ? _c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataOrderCopy), function(package) {
    return _c('li', [_c('cardPackage', {
      attrs: {
        "afterSavePackages": true,
        "dataPackage": package
      }
    })], 1)
  }), 0)]) : _c('div', {
    staticClass: "vitrina"
  }, [_c('p', [_vm._v("No hay paquetes asignados")])])])])])])])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalReprogramation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalReprogramation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Reprogramación de embarque ")])]), _vm._v(" "), _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReprogramation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Nueva fecha de salida"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateDeparture),
      expression: "newDateDeparture"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "name": "departure_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_date')),
      expression: "errors.has('departure_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva hora de salida"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourDeparture),
      expression: "newHourDeparture"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "time",
      "name": "departure_hour"
    },
    domProps: {
      "value": (_vm.newHourDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_hour')),
      expression: "errors.has('departure_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_hour')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva fecha de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateArrival),
      expression: "newDateArrival"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "name": "arrival_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date')),
      expression: "errors.has('arrival_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva hora de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourArrival),
      expression: "newHourArrival"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "time",
      "name": "arrival_hour"
    },
    domProps: {
      "value": (_vm.newHourArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_hour')),
      expression: "errors.has('arrival_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrivaldeparture_hour')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reprogramateShipment
    }
  }, [_vm._v("Reprogramar embarque")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del embarque")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient2",
      "aria-expanded": "false",
      "aria-controls": "collapseclient2"
    }
  }, [_c('span', [_vm._v("Detalles de equipaje")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient3",
      "aria-expanded": "false",
      "aria-controls": "collapseclient3"
    }
  }, [_c('span', [_vm._v("Paquetes")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}

/***/ }),

/***/ 1899:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "far fa-check-circle customCheck"
  }), _vm._v(" "), _c('h2', {
    staticClass: "p-2 font-weight-bold"
  }, [_vm._v("¡Se ha restablecido la contraseña!")]), _vm._v(" "), _c('p', {
    staticClass: "px-4"
  }, [_vm._v("Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.")])])
}]}

/***/ }),

/***/ 1900:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newBoat"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Añadir equipaje\r\n              ")])], 1)]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "form-order"
  }, [_c('div', {
    staticClass: "form_container form-flex"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-test text-title formResume"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_vm._m(9), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn-primary"
  }, [_vm._v("Guardar")])], 1)]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "purchaseOrders"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(16), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalNewUser"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Crear nuevo usuario\r\n            ")])], 1) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-content"
  }, [_c('span', {
    staticClass: "statusInit"
  }, [_vm._v("Inicializando")]), _vm._v(" "), _c('span', {
    staticClass: "statusProgress"
  }, [_vm._v("En proceso")]), _vm._v(" "), _c('span', {
    staticClass: "statusCancel"
  }, [_vm._v("Cancelado")]), _vm._v(" "), _c('p', [_vm._v("En re-evaluación inicial")]), _vm._v(" "), _c('p', [_vm._v("Re-evaluado esperando confirmación")]), _vm._v(" "), _c('p', [_vm._v("Re-evaluado esperando confirmación")]), _vm._v(" "), _c('p', [_vm._v("Completando información de compra")]), _vm._v(" "), _c('p', [_vm._v("Comprado y en camino a dirección de origen")]), _vm._v(" "), _c('p', [_vm._v("Recibido en dirección de origen y en evaluación")]), _vm._v(" "), _c('p', [_vm._v("Listo para embarque")]), _vm._v(" "), _c('p', [_vm._v("En proceso de embarque")]), _vm._v(" "), _c('p', [_vm._v("Entregado correctamente")]), _vm._v(" "), _c('p', [_vm._v("Cancelado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-titulo text-title"
  }, [_c('h1', [_vm._v("Orden de compra #B56764-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step_container"
  }, [_c('ul', {
    staticClass: "progressbar"
  }, [_c('li', {
    staticClass: "inprocess",
    attrs: {
      "id": "li1",
      "href": "#"
    }
  }, [_c('p', [_vm._v("Datos del embarque")])]), _vm._v(" "), _c('li', {
    staticClass: "disabled",
    attrs: {
      "id": "li2"
    }
  }, [_c('p', [_vm._v("Agregar equipaje")])]), _vm._v(" "), _c('li', {
    staticClass: "disabled",
    attrs: {
      "id": "li3"
    }
  }, [_c('p', [_vm._v("Agregar órdenes")])]), _vm._v(" "), _c('li', {
    staticClass: "disabled",
    attrs: {
      "id": "li4"
    }
  }, [_c('p', [_vm._v("Embarcar")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', [_c('h1', [_vm._v("Datos del embarque")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Destino")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Miami")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control null",
    attrs: {
      "rows": "3",
      "cols": "70"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de salida"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "max": "2100-12-31"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "max": "2100-12-31"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', [_c('h1', [_vm._v("Datos del equipaje")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de equipaje")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Maleta")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control null",
    attrs: {
      "rows": "3",
      "cols": "70"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Equipaje")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-login text-title formResume"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina vitrinaSuitcase"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productSuitcase"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "emptyVitrina"
  }, [_c('p', [_vm._v("No has añadido equipaje")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v("10 kg")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-test text-title formResume"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tus órdenes")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-order"
  }, [_c('div', {
    staticClass: "chooseOrder"
  }, [_c('div', {
    staticClass: "filter-search",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "text",
      "placeholder": "Buscar..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tu embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v("10 kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-order"
  }, [_c('div', {
    staticClass: "resumeOrder"
  }, [_c('div', {
    staticClass: "filter-search",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "text",
      "placeholder": "Buscar..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Resumen del embarque")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-login text-title formResume"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina vitrinaSuitcase"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v("10 kg")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newTracking"
    }
  }, [_c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Comprado y en camino a dirección de origen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Evaluar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Recibido y completando datos de recpeción")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Listo para embarcar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newTracking-SameStore"
    }
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta de compra demorada")]), _vm._v(" "), _c('h2', [_vm._v("Oferta de compra demorada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTypeReplacement"
    }
  }, [_vm._v("Generar incidencia")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidencia")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalReplacement"
    }
  }, [_vm._v("Generar reemplazo")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Orden cancelada por reemplazo, ver "), _c('span', [_vm._v("nueva orden aqui")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newTracking-OtherStore"
    }
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta de compra demorada")]), _vm._v(" "), _c('h2', [_vm._v("Oferta de compra demorada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTypeReplacement"
    }
  }, [_vm._v("Generar incidencia")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidencia")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalRefund"
    }
  }, [_vm._v("Informacion de reembolso")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "/tasks"
    }
  }, [_vm._v("Generar reemplazo")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Orden cancelada por reemplazo, ver "), _c('span', [_vm._v("nueva orden aqui")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "testOrder"
    }
  }, [_c('div', {
    staticClass: "card card-standby"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta por evaluar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Evaluar")])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta no aprobada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalExtraInfo"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta aprobada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalExtraInfo"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-standby card-wait"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinFive",
      "data-toggle": "collapse",
      "data-target": "#collapsenFive",
      "aria-expanded": "true",
      "aria-controls": "collapseFive"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Esperando revision del administrador")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalExtraInfo"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenFive",
      "aria-labelledby": "headingnFive",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Lista de usuarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "filter-search"
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-status"
  }, [_c('select', {
    staticClass: "form-control form-filter"
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Operador de envío")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Operador de recepcion")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-edit is-bordered data-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nombre del usuario")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Fecha de creacion")]), _vm._v(" "), _c('th', [_vm._v("Ultima actualizacion")]), _vm._v(" "), _c('th', [_vm._v("Accion")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Jose Catillo")]), _vm._v(" "), _c('td', [_vm._v("Administrador")]), _vm._v(" "), _c('td', [_vm._v("22/34/2019")]), _vm._v(" "), _c('td', [_vm._v("22/34/2019")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "dropdown show"
  }, [_c('button', {
    staticClass: "btn-icon btn-icon-only btn btn-danger btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-trash-alt"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-icon btn-icon-only btn btn-warning btn-sm",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalEditUser"
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "userContent"
  }, [_c('div', {
    staticClass: "userCard"
  }, [_c('div', {
    staticClass: "author"
  }, [_c('img', {
    staticClass: "avatar border-gray",
    attrs: {
      "src": "https://demos.creative-tim.com/now-ui-dashboard/assets/img/mike.jpg",
      "alt": "..."
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("Jose Castillo")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\r\n                      Administrador\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "user-details"
  }, [_c('div', {
    staticClass: "row-details"
  }, [_c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("ID o DNI")]), _vm._v(" "), _c('span', [_vm._v("98768954")])]), _vm._v(" "), _c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("Telefono")]), _vm._v(" "), _c('span', [_vm._v("+51 921 276 643")])])]), _vm._v(" "), _c('div', {
    staticClass: "row-details"
  }, [_c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("Correo")]), _vm._v(" "), _c('span', [_vm._v("erick.22@gmail.com")])]), _vm._v(" "), _c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("Tipo")]), _vm._v(" "), _c('span', [_vm._v("Administrador")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form_container userForm"
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Datos de usuario")])])]), _vm._v(" "), _c('div', {
    staticClass: "formItem"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "Jose Castillo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Correo electronico"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "josecastillo@gmail.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ID o DNI"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "45678908"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pais"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "Peru"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Zip code"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "5566"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Guardar")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-image"
  }, [_c('div', {
    staticClass: "image-order"
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-title text-title"
  }, [_c('h1', [_vm._v("Apple iPhone 7 Plus Factory desbloqueado CDMA/GSM teléfono inteligente")]), _vm._v(" "), _c('p', [_vm._v("Oferta genera de"), _c('span', {
    staticClass: "order-type"
  }, [_vm._v("Grabr")])]), _vm._v(" "), _c('p', [_vm._v("Cantidad"), _c('span', {
    staticClass: "order-cant"
  }, [_vm._v("1")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Detalles de la orden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingSeven",
      "data-toggle": "collapse",
      "data-target": "#collapseseven",
      "aria-expanded": "false",
      "aria-controls": "collapseSeven"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos de reembolso")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSeven",
      "aria-labelledby": "headingSeven",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingFour",
      "data-toggle": "collapse",
      "data-target": "#collapseFour",
      "aria-expanded": "false",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos del cliente")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseFour",
      "aria-labelledby": "headingFour",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingFive",
      "data-toggle": "collapse",
      "data-target": "#collapseFive",
      "aria-expanded": "false",
      "aria-controls": "collapseFive"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos del artículo")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseFive",
      "aria-labelledby": "headingFive",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingSix",
      "data-toggle": "collapse",
      "data-target": "#collapseSix",
      "aria-expanded": "false",
      "aria-controls": "collapseSix"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos de compra")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSix",
      "aria-labelledby": "headingSix",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Historial Comentarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comentarios-buttom"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Escribe tu comentari"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "Nombre",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])]), _vm._v(" "), _c('div', {
    staticClass: "text-title comments-subtitle"
  }, [_c('h1', [_vm._v("Ultimos comentarios")])]), _vm._v(" "), _c('div', {
    staticClass: "comments-block"
  }, [_c('ul', {
    staticClass: "comments-list"
  }, [_c('li', {
    staticClass: "comments-group"
  }, [_c('div', {
    staticClass: "comments-item"
  }, [_c('div', {
    staticClass: "comments-icon"
  }, [_c('i', {
    staticClass: "fas fa-comment-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "comments-message"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\r\n                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\r\n                  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\r\n                  consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\r\n                  cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\r\n                  proident, sunt in culpa qui officia deserunt mollit anim id est laborum.")]), _vm._v(" "), _c('span', {
    staticClass: "comments-message"
  }, [_vm._v("Raquel Leaño 26/2/2019 16:20")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNewTracking",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Estado de la orden")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha real de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso de la orden"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Numero de la orden"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "exampleCheck1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "exampleCheck1"
    }
  }, [_vm._v("Usar el nro de tracking original: "), _c('span', [_vm._v("34TGBH56")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalTypeReplacement",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Selecciona el tipo de incidencia")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "1"
    }
  }, [_vm._v("Misma tienda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Otra tienda")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlTextarea1"
    }
  }, [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlTextarea1",
      "rows": "3"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalReplacement",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reemplazo")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Numero de orden"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Numero de tracking"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de salida aproximada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de entrada aproximada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalRefund",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reembolso")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Monto"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de reembolso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalTest",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Evaluación de la orden de compra")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "home-tab",
      "data-toggle": "tab",
      "href": "#home",
      "role": "tab",
      "aria-controls": "home",
      "aria-selected": "true"
    }
  }, [_vm._v("Datos de Grabr")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "profile-tab",
      "data-toggle": "tab",
      "href": "#profile",
      "role": "tab",
      "aria-controls": "profile",
      "aria-selected": "false"
    }
  }, [_vm._v("Datos reales")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "home",
      "role": "tabpanel",
      "aria-labelledby": "home-tab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuestos"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "profile",
      "role": "tabpanel",
      "aria-labelledby": "profile-tab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuestos"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costos de envío"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefono"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalExtraInfo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de compra de adicional")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra (Final)"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Codigo de compra (Final)"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nro.de tracking"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de envío esperada (Final)"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "selectOperator"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "1"
    }
  }, [_vm._v("Jose Perez")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Luis Rodriguez")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalSuitcase",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de equipaje")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de equipaje")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Maleta")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripcion"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control null",
    attrs: {
      "rows": "3",
      "cols": "70"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalEditUser",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de usuario")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Correo electronico"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNewUser",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de usuario")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Operador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cliente")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
}]}

/***/ }),

/***/ 1901:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('nueva-subpartida')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n            Nueva Subpartida\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_c('div', {
    staticClass: "u-row-sub u-row--header"
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("ID")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Name")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Ad_Valorem")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("ISC")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("IGV")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("IPM")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Sobretasa")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Unit")])]), _vm._v(" "), _vm._l((_vm.subPartidaList), function(data) {
    return _c('div', {
      key: data,
      staticClass: "u-row-sub align-items-center"
    }, [_c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.id))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.name))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.ad_valorem))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.isc))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.igv))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.ipm))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.seguro))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.sobretasa))]), _vm._v(" "), _c('p', {
      staticClass: "sub-content"
    }, [_vm._v(_vm._s(data.unit))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-success mb-2",
      on: {
        "click": function($event) {
          return _vm.openModal('editar-subpartida', data)
        }
      }
    }, [_vm._v("\n                Editar\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteSubPartida(data.id)
        }
      }
    }, [_vm._v("\n                Eliminar\n              ")])])])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getSubPartidas
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "nueva-subpartida"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createSubPartida.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Nueva subpartida")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('nueva-subpartida')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.name),
      expression: "formCreate.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-4 pl-0"
  }, [_c('label', [_vm._v("Ad_valorem")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.ad_valorem),
      expression: "formCreate.ad_valorem"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.ad_valorem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "ad_valorem", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-4"
  }, [_c('label', [_vm._v("ISC")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.isc),
      expression: "formCreate.isc"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.isc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "isc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-4 pr-0"
  }, [_c('label', [_vm._v("IGV")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.igv),
      expression: "formCreate.igv"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.igv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "igv", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("IPM")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.ipm),
      expression: "formCreate.ipm"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.ipm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "ipm", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Seguro")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.seguro),
      expression: "formCreate.seguro"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.seguro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "seguro", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Sobretasa")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.sobretasa),
      expression: "formCreate.sobretasa"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.sobretasa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "sobretasa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Unit")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unit),
      expression: "formCreate.unit"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "unit", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar subpartida\n        ")])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "editar-subpartida"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.EditSubPartida.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Editar subpartida")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('editar-subpartida')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.name),
      expression: "formCreate.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-4 pl-0"
  }, [_c('label', [_vm._v("Ad_valorem")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.ad_valorem),
      expression: "formCreate.ad_valorem"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.ad_valorem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "ad_valorem", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-4"
  }, [_c('label', [_vm._v("ISC")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.isc),
      expression: "formCreate.isc"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.isc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "isc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-4 pr-0"
  }, [_c('label', [_vm._v("IGV")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.igv),
      expression: "formCreate.igv"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.igv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "igv", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("IPM")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.ipm),
      expression: "formCreate.ipm"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.ipm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "ipm", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Seguro")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.seguro),
      expression: "formCreate.seguro"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.seguro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "seguro", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Sobretasa")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.sobretasa),
      expression: "formCreate.sobretasa"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "step": "any",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.sobretasa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "sobretasa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Unit")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unit),
      expression: "formCreate.unit"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "unit", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createSubPartida.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Editar subpartida\n        ")])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "confirm-delete"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-end"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('confirm-delete')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('h5', {
    staticClass: "px-4 mt-3 mb-4"
  }, [_vm._v("¿Seguro que desas eliminar esta subpartida?")]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-1",
    on: {
      "click": function($event) {
        return _vm.closeModal('confirm-delete')
      }
    }
  }, [_vm._v("\n            Eliminar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ml-1",
    on: {
      "click": function($event) {
        return _vm.closeModal('confirm-delete')
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Subpartida")])])
}]}

/***/ }),

/***/ 1902:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-title-block"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(15)) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'shipments-create'
      }
    }
  }, [_vm._v("Nuevo Embarque")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v(_vm._s(option.label))])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getBoardings()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone filter-block-ship"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.status),
      expression: "tableData.status"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getBoardings()
      }]
    }
  }, _vm._l((_vm.statusGroupArray), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(_vm.statusGroupArray[index]))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.boardings != null && _vm.boardings.length > 0) ? _c('tbody', _vm._l((_vm.boardings), function(boarding) {
    return _c('tr', {
      key: boarding.id,
      on: {
        "click": function($event) {
          return _vm.toEditShipmentView(boarding.id, boarding.attributes.status)
        }
      }
    }, [_c('td', [_c('span', [_vm._v(_vm._s(boarding.id))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ruta-order-container"
    }, [_c('div', {
      staticClass: "ruta-order-block ruta-order-image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/ruta.svg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-block"
    }, [_c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(boarding.attributes.origin.attributes.name))])]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(boarding.attributes.destination.attributes.name))])])])])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDateTime")(boarding.attributes.departure_date)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDateTime")(boarding.attributes.arrival_date)))])]), _vm._v(" "), _c('td', [_c('span', [_c('div', {
      staticClass: "order-tag-container"
    }, [(boarding.attributes.status >= 1 && boarding.attributes.status <= 3) ? _c('span', {
      staticClass: "order-tag order-init"
    }, [_vm._v(_vm._s(_vm.statusGroupArray[10]))]) : (boarding.attributes.status >= 5 && boarding.attributes.status <= 7) ? _c('span', {
      staticClass: "order-tag order-process"
    }, [_vm._v(_vm._s(_vm.statusGroupArray[20]))]) : (boarding.attributes.status == 4) ? _c('span', {
      staticClass: "order-tag order-cancel"
    }, [_vm._v(_vm._s(_vm.statusGroupArray[30]))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "order-tag order-message"
    }, [_vm._v(_vm._s(_vm.boardingStatusArray[boarding.attributes.status]))])])])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDateTime")(boarding.attributes.updated_at.date)))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "bpadding": "0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "150px"
      }
    }, [_c('span', [_vm._v("Paquetes : " + _vm._s(boarding.attributes.packages_total) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Ordenes : " + _vm._s(boarding.attributes.purchaseorder_total) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Peso : " + _vm._s(boarding.attributes.boarding_weight) + " Kg")]), _c('br')])])])
  }), 0) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getBoardings
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Embarques")])])
}]}

/***/ }),

/***/ 1903:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-start py-2 px-4"
  }, [_c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Restablecer Contraseña")]), _vm._v(" "), _c('p', [_vm._v("Cambia tu contraseña")]), _vm._v(" "), _c('div', {
    staticClass: "form-group w-100"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": "getPass"
    }
  }, [_vm._v("Nueva Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newpassword),
      expression: "newpassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "getPass",
      "aria-describedby": "getPass",
      "placeholder": "*************"
    },
    domProps: {
      "value": (_vm.newpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newpassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group w-100"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": "getPass2"
    }
  }, [_vm._v("Repetir Nueva Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifypassword),
      expression: "verifypassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "getPass2",
      "aria-describedby": "getPass2",
      "placeholder": "*************"
    },
    domProps: {
      "value": (_vm.verifypassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifypassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary mt-4 btn-lg btn-block",
    attrs: {
      "to": "/confirmpass"
    }
  }, [_vm._v("Continuar")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1904:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loaderFull', {
    attrs: {
      "isFullActive": true
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1905:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.pedido), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'show-purchase-order',
          params: {
            id: data.id
          },
        }
      }
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.id))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.product_info))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("F. compra: "), _c('br'), _vm._v(" " + _vm._s(data.attributes.order_create_date) + " "), _c('br'), _vm._v(" F. entrega: "), _c('br'), _vm._v(_vm._s(data.attributes.promised_delivery_date))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("Pago: "), _c('br'), _vm._v(" Pendiente "), _c('br'), _vm._v(" Tracking: "), _c('br'), _vm._v(" Pendientes")])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.currency) + "\n                  " + _vm._s((data.attributes.total_cost * data.attributes.exchange).toFixed(2)))])])])])], 1)
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPedidos
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1906:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productSuitcase"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_vm._m(0), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 1) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/mSQZTM9/maleta-De-Mano.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 2) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/CJhVtQ0/maleta.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 3) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/pZYJLpy/mochila.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 4) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/K6T2hWp/box.png",
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.luggage_type.attributes.name + ' -' + _vm.dataLuggage.numeration) + "  ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.weight) + " Kg")])]), _vm._v(" "), _c('h3', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.description))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])])
}]}

/***/ }),

/***/ 1907:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Access")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Where our users are coming from.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "pad box-pane-right bg-green",
    staticStyle: {
      "min-height": "400px"
    }
  }, _vm._l((_vm.stats), function(stat) {
    return _c('div', {
      staticClass: "description-block margin-bottom"
    }, [_vm._m(2, true), _vm._v(" "), _c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(stat.header))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(stat.text))])])
  }), 0)])])])]), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.css"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Visitors Report")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "id": "world-map-markers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "data-color": "#fff"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-3x"
  })])
}]}

/***/ }),

/***/ 1908:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.gotoPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Nuevo Rebate")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getrebateOrders()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [_c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.rebateOrders != null && _vm.rebateOrders.length > 0) ? _c('tbody', _vm._l((_vm.rebateOrders), function(rebateOrder) {
    return _c('router-link', {
      key: rebateOrder.id,
      attrs: {
        "to": {
          name: 'EditRebate',
          params: {
            id: rebateOrder.id,
            orderData: rebateOrder
          }
        }
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('span', [_vm._v(_vm._s(rebateOrder.product_title))])])]), _vm._v(" "), _c('td', [_c('span', {}, [_vm._v(_vm._s(rebateOrder.amount))])]), _vm._v(" "), _c('td', [_c('div', {}, [_c('span', [_vm._v(_vm._s(rebateOrder.publication_code))])])]), _vm._v(" "), _c('td', [_c('div', {}, [_c('span', [_vm._v(_vm._s(rebateOrder.from))])])]), _vm._v(" "), _c('td', [_c('div', {}, [_c('span', {}, [_vm._v(_vm._s(rebateOrder.to))])])]), _vm._v(" "), _c('td', [_c('div', {}, [_c('span', {}, [_vm._v(_vm._s(rebateOrder.product_price))])])])])])
  }), 1) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Tabla de Rebate")])])
}]}

/***/ }),

/***/ 1909:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), (!_vm.dataShipment) ? _c('circle-spin') : _vm._e(), _vm._v(" "), (_vm.dataShipment) ? _c('div', [_c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Evaluación de embarque # " + _vm._s(_vm.dataShipment.id))])]), _vm._v(" "), _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseFour",
      "aria-labelledby": "headingFour",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title form-none"
  }, [(_vm.dataShipment) ? _c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataShipment.attributes.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataShipment.attributes.destination.attributes.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataShipment.attributes.reciever_operator.attributes.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.arrival_date)))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.departure_date)))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSix",
      "aria-labelledby": "headingSix",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataLuggageCopy), function(luggageItem) {
    return _c('li', [_c('cardDetailLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      }
    })], 1)
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataOrderCopy), function(orderItem) {
    return _c('li', [_c('cardEvaluateOrders', {
      attrs: {
        "dataPackage": orderItem,
        "fromShipmentFlag": true
      },
      on: {
        "refresh": _vm.updateData
      }
    })], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.readyToFinish
    },
    on: {
      "click": _vm.showModalConfirmation
    }
  }, [_vm._v("Terminar evaluación")])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.endEvaluationPackages()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingFour",
      "data-toggle": "collapse",
      "data-target": "#collapseFour",
      "aria-expanded": "false",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos del embarque")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Descripción")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Destino")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Operador de llegada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Fecha de salida")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Fecha de llegada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingSix",
      "data-toggle": "collapse",
      "data-target": "#collapseSix",
      "aria-expanded": "false",
      "aria-controls": "collapseSix"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Detalles de equipaje")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Paquetes")])])])
}]}

/***/ }),

/***/ 1910:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {}, [_c('div', [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("API Keys")]), _vm._v(" "), _vm._l((_vm.ApiKeys), function(data) {
    return _c('span', {
      key: data
    }, [_c('form', {
      staticClass: "row px-0 mx-0"
    }, [_c('div', {
      staticClass: "col-6 mb-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "mb-2 d-block",
      attrs: {
        "for": "firstName"
      }
    }, [_vm._v(_vm._s(data.attributes.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.apiObject[data.attributes.name]),
        expression: "apiObject[data.attributes.name]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.apiObject[data.attributes.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.apiObject, data.attributes.name, $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-lg btn-round",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.updateKeyValue(data, _vm.apiObject[data.attributes.name])
        }
      }
    }, [_vm._v("\n          Actualizar Key - " + _vm._s(data.attributes.name) + "\n        ")])])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1911:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1912:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentOrder.attributes.product_specimens))])]), _vm._v(" "), _c('div', {
    staticClass: "info2"
  }, [_c('p', [_vm._v(_vm._s(_vm.setCounterItems))])]), _vm._v(" "), _c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [(_vm.currentOrder.attributes.warning_expired_flag == 1) ? _c('p', {
    staticClass: "tag"
  }, [_vm._v("Con retraso")]) : (_vm.currentOrder.attributes.warning_expired_flag == 0 && _vm.currentOrder.attributes.items_to_replace > 0) ? _c('p', {
    staticClass: "tag"
  }, [_vm._v("A reponer")]) : _vm._e()]), _vm._v(" "), (_vm.currentOrder.attributes.product_image_url == null) ? _c('img', {
    attrs: {
      "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'
    }
  }) : _c('img', {
    staticClass: "img-table",
    attrs: {
      "src": _vm.currentOrder.attributes.product_image_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "productName"
  }, [_vm._v("$ " + _vm._s(_vm.currentOrder.attributes.real_price))]), _vm._v(" "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v("#" + _vm._s(_vm.currentOrder.attributes.order_code))]), _vm._v(" "), _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.currentOrder.attributes.weight_kg) + " Kg")]), _vm._v(" "), _c('span', {
    staticClass: "productName product-truncate bold"
  }, [_vm._v(_vm._s(_vm.currentOrder.attributes.product_info))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setCounterItems),
      expression: "setCounterItems"
    }],
    staticClass: "num ctrl-num",
    attrs: {
      "type": "number",
      "onkeydown": "return false",
      "min": 1,
      "max": _vm.currentOrder.attributes.available_items_to_package
    },
    domProps: {
      "value": (_vm.setCounterItems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.setCounterItems = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.equipaje === '') ? _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.alertAddPackage
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]) : _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.alertAddPackage
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1913:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "login-sub text-center"
  }, [(this.$route.params.id == 'admin') ? _c('h1', {
    staticClass: "sendi-admin-login-title"
  }, [_vm._v("Acceso de administradores")]) : _vm._e(), _vm._v(" "), (this.$route.params.id == 'oper') ? _c('h1', {
    staticClass: "sendi-admin-login-title"
  }, [_vm._v("Acceso de operadores")]) : _vm._e(), _vm._v(" "), (this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper') ? _c('h1', {
    staticClass: "sendi-admin-login-title"
  }, [_vm._v("Acceso de clientes")]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [(this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Contraseña),
      expression: "Contraseña"
    }],
    class: 'form-control login__input ' + _vm.validationUser,
    attrs: {
      "type": "email",
      "id": "email",
      "autocomplete": "username",
      "placeholder": "Correo electrónico",
      "aria-label": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.Contraseña)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Contraseña = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: 'form-control login__input ' + _vm.validationUser,
    attrs: {
      "type": "text",
      "id": "email",
      "autocomplete": "username",
      "placeholder": "Tu usuario",
      "aria-label": "Usuario"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseUser) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUser))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: 'form-control login__input ' + _vm.validationPass,
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Tu contraseña",
      "aria-label": "Contraseña",
      "autocomplete": "current-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responsePass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePass))]) : _vm._e(), _vm._v(" "), (this.$route.params.id == 'admin' || this.$route.params.id == 'oper') ? _c('router-link', {
    staticClass: "registerAnchor account",
    attrs: {
      "to": '/login/' + this.$route.params.id + '/changepassword'
    }
  }, [_vm._v("¿Olvidaste tu contraseña?")]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-block btn-round ' + _vm.loading,
    attrs: {
      "type": "submit",
      "id": "submit"
    }
  }, [_vm._v("Continuar")]), _vm._v(" "), (this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper') ? _c('div', {}) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-word"
  })]), _vm._v(" "), (_vm.response) ? _c('div', [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1914:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination.total > 0) ? _c('b-pagination', {
    attrs: {
      "total-rows": this.pagination.total,
      "per-page": _vm.pagination.perPage,
      "aria-controls": "my-table"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1915:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Simple")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Striped Full Width Table")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Task")]), _vm._v(" "), _c('th', [_vm._v("Progress")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Label")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1.")]), _vm._v(" "), _c('td', [_vm._v("Update software")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    staticStyle: {
      "width": "55%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-red"
  }, [_vm._v("55%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2.")]), _vm._v(" "), _c('td', [_vm._v("Clean database")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    staticStyle: {
      "width": "70%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-yellow"
  }, [_vm._v("70%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3.")]), _vm._v(" "), _c('td', [_vm._v("Cron job running")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary",
    staticStyle: {
      "width": "30%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-light-blue"
  }, [_vm._v("30%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4.")]), _vm._v(" "), _c('td', [_vm._v("Fix and squish bugs")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-green"
  }, [_vm._v("90%")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Data tables")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Data Table With Full Features")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "167px"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Rendering engine")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "aria-label": "Platform(s): activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Platform(s)")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "142px"
    },
    attrs: {
      "aria-label": "Engine version: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Engine version")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "101px"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("CSS grade")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Blink")]), _vm._v(" "), _c('td', [_vm._v("Iridium  54.0")]), _vm._v(" "), _c('td', [_vm._v("GNU/Linux")]), _vm._v(" "), _c('td', [_vm._v("54")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 1.0")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 1.5")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 2.0")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 3.0")]), _vm._v(" "), _c('td', [_vm._v("Win 2k+ / OSX.3+")]), _vm._v(" "), _c('td', [_vm._v("1.9")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Camino 1.0")]), _vm._v(" "), _c('td', [_vm._v("OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Camino 1.5")]), _vm._v(" "), _c('td', [_vm._v("OSX.3+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape 7.2")]), _vm._v(" "), _c('td', [_vm._v("Win 95+ / Mac OS 8.6-9.2")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape Browser 8")]), _vm._v(" "), _c('td', [_vm._v("Win 98SE+")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape Navigator 9")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Mozilla 1.0")]), _vm._v(" "), _c('td', [_vm._v("Win 95+ / OSX.1+")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("A")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Rendering engine")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Platform(s)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Engine version")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("CSS grade")])])])])])])])])])])])])
}]}

/***/ }),

/***/ 1916:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1917:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-order"
  }, [(_vm.orderDataShow.attributes.type === 2) ? _c('div', {
    staticClass: "details-order-block details-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.orderDataShow.attributes.product_image_url === null) ? _c('img', {
    attrs: {
      "src": "/static/img/icon/caja.svg",
      "width": "180px",
      "height": "260px"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.orderDataShow.attributes.product_image_url,
      "width": "180px",
      "height": "260px"
    }
  })]) : _c('div', {
    staticClass: "details-order-block details-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [(
    _vm.orderDataShow.attributes.product_image_url == null &&
    _vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('img', {
    attrs: {
      "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png',
      "width": "180px",
      "height": "260px"
    }
  }) : (
    _vm.orderDataShow.attributes.product_image_url == null &&
    _vm.orderDataShow.attributes.is_from_linio_flag
  ) ? _c('img', {
    attrs: {
      "src": "/static/img/linio-logo.png",
      "width": "180px",
      "height": "260px"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.orderDataShow.attributes.product_image_url,
      "width": "180px",
      "height": "260px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.sku))])]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.type === 2) ? _c('div', {
    staticClass: "details-order-block details-info"
  }, [_c('div', {
    staticClass: "details-title"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "title-order mr-5"
  }, [_vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.product_info)), (_vm.orderDataShow.attributes.reference_link !== null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.reference_link,
      "target": "_Blank"
    }
  }, [_vm._v("\n                - "), _c('img', {
    attrs: {
      "src": "/static/img/icon/icon-url.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b', {
    staticClass: "d-block ml-auto"
  }, [_vm._v(" #" + _vm._s(_vm.orderDataShow.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.product_specimens))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio Referencial :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.real_price))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.weight_kg) + " Kg")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Categoría :")]), _vm._v(" "), (_vm.orderDataShow.attributes.mp_category_key !== null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.category.attributes.key)), _c('br'), _vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.category.attributes.name)), _c('br'), _vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.category.attributes.margin) + "\n            ")]) : _c('span', {
    staticClass: "details-title-item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.description === null ?
    "Sin descripción" :
    _vm.orderDataShow.attributes.description))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Variaciones :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.variations === null ?
    "Sin variaciones" :
    _vm.orderDataShow.attributes.variations))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Packing :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusIsPackage),
      expression: "statusIsPackage"
    }],
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusIsPackage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatusIsPackage]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    },
    domProps: {
      "selected": _vm.orderDataShow.attributes.isPackage === _vm.statusIsPackage
    }
  }, [_vm._v("\n                  SI\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "selected": _vm.orderDataShow.attributes.isPackage === _vm.statusIsPackage
    }
  }, [_vm._v("\n                  NO\n                ")])])])])])])]) : _c('div', {
    staticClass: "details-order-block details-info"
  }, [_c('div', {
    staticClass: "details-title"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {}, [_c('span', {
    staticClass: "title-order"
  }, [_vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.product_info)), (_vm.orderDataShow.attributes.type === 2) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.reference_link,
      "target": "_Blank"
    }
  }, [_vm._v("\n                - "), _c('img', {
    attrs: {
      "src": "/static/img/icon/icon-url.svg",
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "order-type"
  }, [_c('span', {
    staticClass: "code-order system-code"
  }, [_vm._v("\n                SB # " + _vm._s(_vm.orderDataShow.attributes.order_code))]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', [_c('span', {
    staticClass: "code-order-container"
  }, [_c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://grabr.io/es/grabs/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Codigo del Partner'),
      expression: "'Codigo del Partner'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v("#" + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes
    .grabr_order_number) + "\n                    ")])])])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', [_vm._m(1)]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [(!_vm.editDescriptionFlag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDataShow.attributes.description != null ?
    _vm.orderDataShow.attributes.description :
    "Sin descripción"))]), _vm._v(" "), (
    _vm.fromDetail &&
    _vm.orderDataShow.attributes.status != 10 &&
    _vm.orderDataShow.attributes.cancelled == 0
  ) ? _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.editDescription
    }
  }, [_vm._v("Editar"), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "input-group input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "details-title-item",
    attrs: {
      "disabled": _vm.description != _vm.descriptionRealValue
    },
    on: {
      "click": _vm.updateDescription
    }
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.cancelEditDescription
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tienda: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store) ? _c('span', {
    staticClass: "tag-grabr"
  }, [(_vm.orderDataShow.attributes.meliOrder.attributes.store === 'electro') ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-primary"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store === 'fashion') ? _c('span', {
    staticClass: "badge badge-dark badge-store brown"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store === 'kids') ? _c('span', {
    staticClass: "badge badge-dark badge-store magenta"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store === 'home') ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-success"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e()]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("No definido")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de orden:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.meliOrder.attributes.meli_order_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código del partner'),
      expression: "'Código del partner'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_order_id))])])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de orden:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linioOrder.attributes.linio_order_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código del partner'),
      expression: "'Código del partner'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_order_id))])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de publicación:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.meliOrder.attributes.publication_code_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código de publicación'),
      expression: "'Código de publicación'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.publication_code))])])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de publicación:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'http://www.linio.com.pe/' +
        _vm.orderDataShow.attributes.linioOrder.attributes.linio_publication_code +
        '.html',
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('ID de la orden'),
      expression: "'ID de la orden'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_publication_code))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [(!_vm.editPackagedFlag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Empaque")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.packaged == null ?
    "Sin especificar" :
    _vm.orderDataShow.attributes.packaged == 1 ?
    "Sí" :
    "No"))]), _vm._v(" "), (
    _vm.fromDetail &&
    _vm.orderDataShow.attributes.status != 10 &&
    _vm.orderDataShow.attributes.cancelled == 0 &&
    !_vm.orderDataShow.attributes.is_from_linio_flag
  ) ? _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.editPackaged
    }
  }, [_vm._v("Editar"), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _vm._e()])]) : _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "input-group input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packaged),
      expression: "packaged"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "packaged"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packaged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin especificar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "details-title-item",
    attrs: {
      "disabled": _vm.packaged != _vm.packagedRealValue
    },
    on: {
      "click": _vm.updatePackaged
    }
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.cancelEditPackaged
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad entregada")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.product_specimens_delivered))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.product_specimens))])]), _vm._v(" "), (!_vm.editCostingMethodFlag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Met. costeo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.costing_method == 1 ?
    "PESO (7usd/kg)" :
    _vm.orderDataShow.attributes.costing_method == 2 ?
    "TRAVELER" :
    _vm.orderDataShow.attributes.costing_method == 3 ?
    "ALTERNATIVO" :
    "No definido"))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.weight_kg != null ?
    _vm.orderDataShow.attributes.weight_kg + " kg" :
    "No definido"))]), _vm._v(" "), (_vm.orderDataShow.attributes.status == 2) ? _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.editCostingMethod
    }
  }, [_vm._v("Editar"), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _vm._e()])]) : _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "input-group input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costingMethod),
      expression: "costingMethod"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "costingMethod"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.costingMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeCostingMethod]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Peso (7usd/kg)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Traveler")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Alternativo")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "details-title-item",
    attrs: {
      "disabled": _vm.costingMethod != _vm.costingMethodRealValue
    },
    on: {
      "click": _vm.updateCostingMethod
    }
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.cancelEditCostingMethod
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tag-grabr"
  }, [_c('span', {
    staticClass: "badge badge-primary badge-grabr"
  }, [_vm._v("Grabr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "code-order-container"
  }, [_c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-grabr"
  }, [_c('span', {
    staticClass: "badge badge-primary badge-linio"
  }, [_vm._v("Linio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "code-order-container"
  }, [_c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-grabr"
  }, [_c('span', {
    staticClass: "badge badge-primary badge-meli"
  }, [_vm._v("Mercado Libre")])])])
}]}

/***/ }),

/***/ 1918:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.nombre
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.apellido
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.telefono
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Url Avatar")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.avatar
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Store")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.store === 1 ? 'Sendi' : 'Envios'
    }
  })])])]), _vm._v(" "), _c('div', {}, [_c('div', [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("Dirección de facturación")]), _vm._v(" "), _c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Dirección")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.direction
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Piso")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.piso
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Referencia")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.referencia
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Departamento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.departamento
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Provincia")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.provincia
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Distrito")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.distrito
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pt-0 d-flex justify-content-between align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getDeleteUser.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Eliminar usuario\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("Delete Your Account")]), _vm._v(" "), _c('p', {
    staticClass: "m-0 text-muted"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit "), _c('br'), _vm._v("\n        ut aliquam, purus sit amet luctus venenatis, lectus "), _c('br'), _vm._v("\n        magna fringilla urna, porttitor\n      ")])])
}]}

/***/ }),

/***/ 1919:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.grabr) ? _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step_container"
  }, [_c('ul', {
    staticClass: "progressbar progress-new"
  }, [_c('li', {
    class: {
      inprocess: _vm.state1 === 1, active: _vm.state2 === 1 || _vm.state2 === 2
    },
    attrs: {
      "id": "li1",
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(1)
      }
    }
  }, [_c('p', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state2 === 1, active: _vm.state3 === 1 || _vm.state3 === 2, disabled: _vm.state1 === 1
    },
    attrs: {
      "id": "li2"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(2)
      }
    }
  }, [_c('p', [_vm._v("Datos del artículo")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state3 === 1, active: _vm.state4 === 1, disabled: _vm.state2 === 1 || _vm.state1 === 1
    },
    attrs: {
      "id": "li3"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(3)
      }
    }
  }, [_c('p', [_vm._v("Datos de compra")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state4 === 1, disabled: _vm.state1 === 1 || _vm.state2 === 1 || _vm.state3 === 1
    },
    attrs: {
      "id": "li4"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(4)
      }
    }
  }, [_c('p', [_vm._v("Resumen")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info"
  }, [(_vm.state1 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombres y apellidos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'is-danger': _vm.errors.has('fullname')
    },
    attrs: {
      "type": "text",
      "name": "fullname",
      "aria-describedby": "email",
      "maxlength": 100
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fullname')),
      expression: "errors.has('fullname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('fullname')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de documento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeId),
      expression: "typeId"
    }],
    staticClass: "form-control form-control-lg",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cleanDocumentNumbers]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("DNI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Id cliente")])])])]), _vm._v(" "), (_vm.typeId == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de documento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberId),
      expression: "numberId"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "document_number",
      "minlength": 8,
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.numberId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('document_number')),
      expression: "errors.has('document_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('document_number')))])])]) : _vm._e(), _vm._v(" "), (_vm.typeId == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Id del cliente")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idClient),
      expression: "idClient"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Id client",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.idClient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idClient = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Id client')),
      expression: "errors.has('Id client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Id client')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de celular")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberPhone),
      expression: "numberPhone"
    }, {
      name: "digitsonly-cellphone",
      rawName: "v-digitsonly-cellphone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone_number",
      "aria-describedby": "email",
      "minlength": 9,
      "maxlength": 15
    },
    domProps: {
      "value": (_vm.numberPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone_number')),
      expression: "errors.has('phone_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateFirstFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de documento")]), _vm._v(" "), _c('div', {
    staticClass: "form-client"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true && this.userValidated
      }),
      expression: "{required: true && this.userValidated}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userFinding),
      expression: "userFinding"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Nombre",
      "name": "document_number_nograbr",
      "aria-describedby": "email",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.userFinding)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userFinding = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append",
    attrs: {
      "id": "button-addon4"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit btn-subir",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.validateUserById(_vm.userFinding, _vm.setUserChoosed)
      }
    }
  }, [_vm._v("Validar cliente")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('document_number_nograbr')),
      expression: "errors.has('document_number_nograbr')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('document_number_nograbr')))])]), _vm._v(" "), _c('div', {
    staticClass: "validacion-cliente",
    class: {
      'validacion-cliente-no-encontrado': _vm.mesageVerifUser == 'Cliente no existe en el sistema', 'validacion-cliente-encontrado': _vm.mesageVerifUser != 'Cliente no existe en el sistema' && _vm.mesageVerifUser != ''
    }
  }, [_c('span', [_vm._v(_vm._s(this.mesageVerifUser))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateFistFormV2
    }
  }, [_vm._v("Continuar")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state2 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen del artículo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "block-image"
  }, [_c('div', {
    staticClass: "imageProduct"
  }, [_c('img', {
    attrs: {
      "src": _vm.newImageProduct
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-content"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "data_image",
      "type": "file",
      "accept": "image/x-png, image/jpeg"
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newImageName),
      expression: "newImageName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "id": "product_image",
      "name": "product_image"
    },
    domProps: {
      "value": (_vm.newImageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newImageName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_image')),
      expression: "errors.has('product_image')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_image')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empaque")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packaged),
      expression: "packaged"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "packaged"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packaged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin especificar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de orden de compra")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNumbOrder),
      expression: "newNumbOrder"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "purchase_order_number",
      "aria-describedby": "email",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.newNumbOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNumbOrder = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_order_number')),
      expression: "errors.has('purchase_order_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_order_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre del producto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInfoProduct),
      expression: "newInfoProduct"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "product_information",
      "aria-describedby": "email",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.newInfoProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newInfoProduct = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_information')),
      expression: "errors.has('product_information')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_information')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Descripción del producto (Opcional)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescriptionProduct),
      expression: "newDescriptionProduct"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "product_description_optional",
      "aria-describedby": "email",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.newDescriptionProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescriptionProduct = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de ejemplares")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newStockProduct),
      expression: "newStockProduct"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "number_of_items_1",
      "aria-describedby": "email",
      "maxlength": 5
    },
    domProps: {
      "value": (_vm.newStockProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newStockProduct = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('number_of_items_1')),
      expression: "errors.has('number_of_items_1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('number_of_items_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de chat en Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newLinkChat),
      expression: "newLinkChat"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "purchase_chat_link",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newLinkChat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLinkChat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_chat_link')),
      expression: "errors.has('purchase_chat_link')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_chat_link')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fecha de asignación al viajero")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateOffer),
      expression: "newDateOffer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "purchase_order_date",
      "aria-describedby": "email",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateOffer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateOffer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_order_date')),
      expression: "errors.has('purchase_order_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_order_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateSecondFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen del artículo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "block-image"
  }, [_c('div', {
    staticClass: "imageProduct"
  }, [_c('img', {
    attrs: {
      "src": _vm.newImageProductV2
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-content"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "data_image",
      "type": "file",
      "accept": "image/x-png, image/jpeg"
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newImageName),
      expression: "newImageName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "id": "product_image",
      "name": "product_image"
    },
    domProps: {
      "value": (_vm.newImageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newImageName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_image')),
      expression: "errors.has('product_image')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_image')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empaque")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packaged),
      expression: "packaged"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "packaged"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packaged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin especificar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre del producto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newInfoProductV2),
      expression: "newInfoProductV2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "product_information_2",
      "aria-describedby": "email",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.newInfoProductV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newInfoProductV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_information_2')),
      expression: "errors.has('product_information_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_information_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción del producto (Opcional)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescriptionProductV2),
      expression: "newDescriptionProductV2"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.newDescriptionProductV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescriptionProductV2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de ejemplares")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newStockProductV2),
      expression: "newStockProductV2"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "number_of_items_2",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newStockProductV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newStockProductV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('number_of_items_2')),
      expression: "errors.has('number_of_items_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('number_of_items_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Peso de la orden")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newWeight),
      expression: "newWeight"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "order_weight_2",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('order_weight_2')),
      expression: "errors.has('order_weight_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('order_weight_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidades de peso")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.unitWeight),
      expression: "unitWeight"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "weight_units_2"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.unitWeight = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.listUnits), function(units) {
    return _c('option', {
      key: units.id,
      domProps: {
        "value": units
      }
    }, [_vm._v(_vm._s(units.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_units_2')),
      expression: "errors.has('weight_units_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_units_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateSecondFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state3 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Precio (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCost),
      expression: "newCost"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "price",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newCost)
    },
    on: {
      "keyup": function($event) {
        return _vm.setNewTax()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('price')),
      expression: "errors.has('price')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('price')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Impuesto (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newTax),
      expression: "newTax"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tax",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newTax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTax = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tax')),
      expression: "errors.has('tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tax')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fee (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCostPost),
      expression: "newCostPost"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fee",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newCostPost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCostPost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fee')),
      expression: "errors.has('fee')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('fee')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de viaje")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.travelNumber),
      expression: "travelNumber"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "travel_number",
      "minlength": 1,
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.travelNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.travelNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('travel_number')),
      expression: "errors.has('travel_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('travel_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cuenta Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.grabrAccount),
      expression: "grabrAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grabr_account",
      "aria-describedby": "email",
      "maxlength": 50
    },
    domProps: {
      "value": (_vm.grabrAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grabrAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('grabr_account')),
      expression: "errors.has('grabr_account')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('grabr_account')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Link de compra propuesta en Grabr (Opcional)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newLinkBuying),
      expression: "newLinkBuying"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "purchase_link_optional",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newLinkBuying)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLinkBuying = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_link_optional')),
      expression: "errors.has('purchase_link_optional')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_link_optional')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de origen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityIni),
      expression: "newCityIni"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "origin_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityIni = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityOrigin), function(cityOrigin) {
    return _c('option', {
      key: cityOrigin.id,
      domProps: {
        "value": cityOrigin
      }
    }, [_vm._v(_vm._s(cityOrigin.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origin_city')),
      expression: "errors.has('origin_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('origin_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityEnd),
      expression: "newCityEnd"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destination_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityEnd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityDestiny), function(cityDestiny) {
    return _c('option', {
      key: cityDestiny.id,
      domProps: {
        "value": cityDestiny
      }
    }, [_vm._v(_vm._s(cityDestiny.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destination_city')),
      expression: "errors.has('destination_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destination_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fecha de posible entrega")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDatePromise),
      expression: "newDatePromise"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "possible_delivery_date",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newDatePromise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDatePromise = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('possible_delivery_date')),
      expression: "errors.has('possible_delivery_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('possible_delivery_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateThirdFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Precio (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCostV2),
      expression: "newCostV2"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Nombre",
      "name": "price",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newCostV2)
    },
    on: {
      "keyup": function($event) {
        return _vm.setNewTax()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCostV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('price')),
      expression: "errors.has('price')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('price')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "250px"
    }
  }, [_c('label', [_vm._v("Impuesto (USD)")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "12px",
      "cursor": "pointer",
      "color": "cornflowerblue",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.resetImpuesto
    }
  }, [_vm._v("(Limpiar campos)")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newTaxV2),
      expression: "newTaxV2"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "tax",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newTaxV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTaxV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tax')),
      expression: "errors.has('tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tax')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Costo de envío (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCostPostV2),
      expression: "newCostPostV2"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "shipping_cost",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newCostPostV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCostPostV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipping_cost')),
      expression: "errors.has('shipping_cost')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('shipping_cost')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Link de compra " + _vm._s(_vm.grabr.id == 1 ? '(Opcional)' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2,
        url: true
      }),
      expression: "{required:grabr.id == 2,url:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newLinkBuyingV2),
      expression: "newLinkBuyingV2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "aria-describedby": "email",
      "name": "purchase_link",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.newLinkBuyingV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLinkBuyingV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_link')),
      expression: "errors.has('purchase_link')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_link')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de origen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityIni),
      expression: "newCityIni"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "origin_city"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityIni = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filtrar]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityOrigin), function(cityOrigin) {
    return _c('option', {
      key: cityOrigin.id,
      domProps: {
        "value": cityOrigin
      }
    }, [_vm._v(_vm._s(cityOrigin.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origin_city')),
      expression: "errors.has('origin_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('origin_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityEnd),
      expression: "newCityEnd"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destination_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityEnd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityDestinyFilter), function(cityDestiny) {
    return _c('option', {
      key: cityDestiny.id,
      domProps: {
        "value": cityDestiny
      }
    }, [_vm._v(_vm._s(cityDestiny.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destination_city')),
      expression: "errors.has('destination_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destination_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateThirdFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state4 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Nombres y apellidos:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newName))])]), _vm._v(" "), (_vm.typeId == 1) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de documento:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.numberId))])]) : _vm._e(), _vm._v(" "), (_vm.typeId == 2) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("ID del cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.idClient))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número telefónico:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.numberPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Empaque:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.packaged == 1 ? "Sin especificar" : (_vm.packaged == 2 ? "Sí" : "No")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newNumbOrder))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Título de la orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newInfoProduct))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Descripción del producto:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newDescriptionProduct))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de ejemplares:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newStockProduct))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Nro. de chat Grabr;")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkChat
    }
  }, [_vm._v(_vm._s(_vm.newLinkChat))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Fecha de orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.newDateOffer)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCost))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Impuesto (USD):")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newTax) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Fee (USD):")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newCostPost) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [(_vm.grabr.id == 1) ? _c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Link de compra propuesta en Grabr:")]) : _c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Link de compra:")]), _vm._v(" "), (_vm.grabr.id == 1 && _vm.newLinkBuying != null && _vm.newLinkBuying != '') ? _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkBuying
    }
  }, [_vm._v(_vm._s(_vm.newLinkBuying))])]) : (_vm.grabr.id == 2 && _vm.newLinkBuyingV2 != null && _vm.newLinkBuyingV2 != '') ? _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkBuyingV2
    }
  }, [_vm._v(_vm._s(_vm.newLinkBuyingV2))])]) : _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v("No definido")])]), _vm._v(" "), (_vm.travelNumber != null) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de viaje:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.travelNumber))])]) : _vm._e(), _vm._v(" "), (_vm.grabrAccount != null) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Cuenta en Grabr")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.grabrAccount))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityIni.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityEnd.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Fecha de posible entrega:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.newDatePromise)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendCompleteForm
    }
  }, [_vm._v("Crear orden Grabr")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de documento:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.userValidated.attributes.profile.attributes.document_number))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Nombre del cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.userValidated.attributes.profile.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Apellido del cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.userValidated.attributes.profile.attributes.surnames))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Empaque:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.packaged == 1 ? "Sin especificar" : (_vm.packaged == 2 ? "Sí" : "No")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Título de la orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newInfoProductV2))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Descripción del producto:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newDescriptionProductV2))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de ejemplares:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newStockProductV2))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Peso de la orden:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newWeight) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Unidad de medida del peso:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.unitWeight.attributes.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Precio real:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newCostV2) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Impuesto real:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newTaxV2) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v("Costo de envío real:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newCostPostV2) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Link real de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkBuyingV2
    }
  }, [_vm._v(_vm._s(_vm.newLinkBuyingV2))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityIni.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityEnd.attributes.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendCompleteForm
    }
  }, [_vm._v("Crear orden Direct")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "validacionmodal",
      "centered": ""
    },
    on: {
      "hide": function($event) {
        return _vm.toNextView()
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Continuar")])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del artículo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data_image"
    }
  }, [_c('span', {
    staticClass: "btn btn-primary"
  }, [_c('img', {
    staticClass: "logo-sendibox",
    attrs: {
      "src": "/static/img/camara.svg",
      "alt": ""
    }
  }), _vm._v("Seleccionar imagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del artículo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data_image"
    }
  }, [_c('span', {
    staticClass: "btn btn-primary"
  }, [_c('img', {
    staticClass: "logo-sendibox",
    attrs: {
      "src": "/static/img/camara.svg",
      "alt": ""
    }
  }), _vm._v("Seleccionar imagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Datos de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Resumen de la orden de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v("Datos del artículo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Datos de compra:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Resumen de la orden de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', [_vm._v("Datos del artículo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-resume-subtitle"
  }, [_c('span', [_vm._v("Datos de compra")])])
}]}

/***/ }),

/***/ 1920:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 1921:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productSuitcase"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.luggage_type.attributes.name) + " - " + _vm._s(_vm.dataLuggage.numeration))])])]), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_vm._m(0), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 1) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/mSQZTM9/maleta-De-Mano.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 2) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/CJhVtQ0/maleta.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 3) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/pZYJLpy/mochila.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 4) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/K6T2hWp/box.png",
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.weight) + " kg")])]), _vm._v(" "), _c('h3', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.description) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.quitLuggageItem
    }
  }, [_vm._v("Quitar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])])
}]}

/***/ }),

/***/ 1922:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('nueva-categoria')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n            Nueva Categoria\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row px-3 mb-4"
  }, [_c('form', {
    staticClass: "d-flex col-8 px-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control col-10",
    attrs: {
      "type": "search",
      "placeholder": "Buscar categoria"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger col-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success col-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Buscar")])]), _vm._v(" "), _c('div', {
    staticClass: "offset-2"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-2",
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("Exportar a Excel")])]), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_c('div', {
    staticClass: "u-row-cat u-row--header"
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("ID")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Key")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Nombre de Categoria")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Margen de ganancia")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Subpartida")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Path")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Acciones")])]), _vm._v(" "), _vm._l((_vm.listCategory), function(data) {
    return _c('div', {
      key: data,
      staticClass: "u-row-cat"
    }, [_c('p', {
      staticClass: "cat-content"
    }, [_vm._v(_vm._s(data.id))]), _vm._v(" "), _c('p', {
      staticClass: "cat-content"
    }, [_vm._v(_vm._s(data.key))]), _vm._v(" "), _c('p', {
      staticClass: "cat-content"
    }, [_vm._v(_vm._s(data.name))]), _vm._v(" "), _c('p', {
      staticClass: "cat-content"
    }, [_vm._v(_vm._s(data.margin))]), _vm._v(" "), _c('p', {
      staticClass: "cat-content"
    }, [_vm._v(_vm._s(data.subpartida))]), _vm._v(" "), _c('p', {
      staticClass: "cat-content"
    }, [_vm._v(_vm._s(data.path))]), _vm._v(" "), _c('div', {
      staticClass: "cat-content"
    }, [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.openModal('editar-categoria', data)
        }
      }
    }, [_vm._v("\n                Editar\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteCategory(data.id)
        }
      }
    }, [_vm._v("\n                Eliminar\n              ")])])])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getCategoriasWithFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "nueva-categoria"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createCategory.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Nueva categoria")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('nueva-categoria')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Key")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.key),
      expression: "formCreate.key"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "key", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre de categoria")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.name),
      expression: "formCreate.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Margen de ganancia")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.margin),
      expression: "formCreate.margin"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.margin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "margin", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-3"
  }, [_vm._v("Subpartida")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.subpartida),
      expression: "formCreate.subpartida"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "subpartida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subPartidaList), function(data) {
    return _c('option', {
      key: data,
      domProps: {
        "value": data.id
      }
    }, [_vm._v("\n              " + _vm._s(data.id) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar categoria\n        ")])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "editar-categoria"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCategory.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Editar categoria")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('editar-categoria')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Key")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.key),
      expression: "formCreate.key"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "key", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre de categoria")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.name),
      expression: "formCreate.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Margen de ganancia")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.margin),
      expression: "formCreate.margin"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "step": "any",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.margin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "margin", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-3"
  }, [_vm._v("Subpartida")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.subpartida),
      expression: "formCreate.subpartida"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "subpartida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subPartidaList), function(data) {
    return _c('option', {
      key: data,
      domProps: {
        "value": data.id
      }
    }, [_vm._v("\n              " + _vm._s(data.id) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Editar categoria\n        ")])])])]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "confirm-delete"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-end"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('confirm-delete')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('h5', {
    staticClass: "px-4 mt-3 mb-4"
  }, [_vm._v("¿Seguro que desas eliminar esta categoria?")]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-1",
    on: {
      "click": function($event) {
        return _vm.closeModal('confirm-delete')
      }
    }
  }, [_vm._v("\n            Eliminar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ml-1",
    on: {
      "click": function($event) {
        return _vm.closeModal('confirm-delete')
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Categorias")])])
}]}

/***/ }),

/***/ 1923:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "far fa-check-circle customCheck"
  }), _vm._v(" "), _c('h2', {
    staticClass: "p-2 font-weight-bold"
  }, [_vm._v("¡Se ha creado correctamente!")]), _vm._v(" "), _c('p', {
    staticClass: "px-4"
  }, [_vm._v("Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.")]), _vm._v(" "), _c('router-link', {
    staticClass: "font-weight-bold back",
    attrs: {
      "to": "/login/client"
    }
  }, [_vm._v("Ingresar")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['alert', 'alert-' + _vm.type, {
      'alert-dismissible': _vm.dismissible
    }]
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _c('h4', [_c('i', {
    class: ['icon', _vm.iconClasses]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1925:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Environment")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.servers) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.servers), function(server) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      class: 'box box-' + server.status
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('i', {
      class: 'fa fa-' + server.icon + ' fa-2x'
    }), _vm._v(" "), _c('h3', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(server.name))])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('span', [_vm._v(_vm._s(server.description))])])])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1926:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-item"
  }, [(_vm.ownComment) ? _c('div', {
    staticClass: "message send"
  }, [_c('div', {
    staticClass: "mesagge-all"
  }, [_c('div', {
    staticClass: "message-avatar"
  }), _vm._v(" "), (!_vm.editCommentFlag) ? _c('div', {
    staticClass: "message-block"
  }, [_c('span', {
    staticClass: "message-title"
  }, [_vm._v(_vm._s(_vm.comment.attributes.writer.attributes.name) + "\n          " + _vm._s(_vm.comment.attributes.writer.attributes.surnames))]), _vm._v(" "), _c('span', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.comment.attributes.content) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "metadata-time"
  }, [_vm._v(_vm._s(_vm._f("spanishTime")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-rol"
  }, [_vm._v("\n            " + _vm._s(_vm.comment.attributes.writer.attributes.userable_type == "admin" ?
    "Administrador general" :
    _vm.comment.attributes.writer.attributes.userable_type == "client" ?
    "Cliente" :
    _vm.comment.attributes.writer.attributes.userable.attributes
    .operator_type == 1 ?
    "Operador de envío" :
    "Operador de recepción") + "\n          ")])]), _vm._v(" "), (_vm.order.attributes.status !== 10) ? _c('span', {
    staticClass: "edit-box edit-comment",
    on: {
      "click": function($event) {
        return _vm.editComment(_vm.comment.id)
      }
    }
  }, [_vm._v("\n          Editar\n          "), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _c('span', {
    staticClass: "edit-box edit-comment"
  }, [_vm._v("\n          Editar\n          "), _c('i', {
    staticClass: "fas fa-edit"
  })]), _vm._v(" "), (_vm.order.attributes.status !== 10) ? _c('span', {
    staticClass: "edit-box delete-comment",
    on: {
      "click": function($event) {
        return _vm.deleteComment(_vm.comment.id)
      }
    }
  }, [_vm._v("\n          Eliminar\n          "), _c('i', {
    staticClass: "fas fa-times"
  })]) : _c('span', {
    staticClass: "edit-box delete-comment"
  }, [_vm._v("\n          Eliminar\n          "), _c('i', {
    staticClass: "fas fa-times"
  })])]) : _c('div', {
    staticClass: "message-block"
  }, [_c('div', {
    staticClass: "form-group input-edit-comment"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Edita tu comentario")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContent),
      expression: "newContent"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "maxlength": 1000
    },
    domProps: {
      "value": (_vm.newContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [(_vm.oldContent != _vm.newContent) ? _c('span', {
    staticClass: "edit-box",
    on: {
      "click": function($event) {
        return _vm.updateComment(_vm.comment.id)
      }
    }
  }, [_vm._v("Guardar cambios")]) : _c('span', {
    staticClass: "edit-box"
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "edit-box",
    on: {
      "click": _vm.cancelEditComment
    }
  }, [_vm._v("Cancelar "), _c('i', {
    staticClass: "fas fa-times"
  })])])])])]) : (_vm.otherComment) ? _c('div', {
    staticClass: "message received"
  }, [_c('div', {
    staticClass: "mesagge-all"
  }, [_c('div', {
    staticClass: "message-avatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "message-block"
  }, [_c('span', {
    staticClass: "message-title"
  }, [_vm._v(_vm._s(_vm.comment.attributes.writer.attributes.name) + "\n          " + _vm._s(_vm.comment.attributes.writer.attributes.surnames))]), _vm._v(" "), _c('span', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.comment.attributes.content))]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "metadata-time"
  }, [_vm._v(_vm._s(_vm._f("spanishTime")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-rol"
  }, [_vm._v("\n            " + _vm._s(_vm.comment.attributes.writer.attributes.userable_type == "admin" ?
    "Administrador general" :
    _vm.comment.attributes.writer.attributes.userable_type == "client" ?
    "Cliente" :
    _vm.comment.attributes.writer.attributes.userable.attributes
    .operator_type == 1 ?
    "Operador de envío" :
    "Operador de recepción") + "\n          ")])])])])]) : (_vm.systemComment) ? _c('div', {
    staticClass: "message system"
  }, [_c('div', {
    staticClass: "mesagge-all"
  }, [_c('span', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.comment.attributes.content) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "metadata-time"
  }, [_vm._v(_vm._s(_vm._f("spanishTime")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.comment.attributes.updated_at.date)))]), _vm._v(" "), _c('span', {
    staticClass: "metadata-rol"
  }, [_vm._v("Mensaje del sistema")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(772)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1884),
  /* scopeId */
  "data-v-5b0b3d66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1914),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1874),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*! DataTables 1.13.11
 * ©2008-2024 SpryMedia Ltd - datatables.net/license
 */



// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;


var DataTable = function ( selector, options )
{
	// Check if called with a window or jQuery object for DOM less applications
	// This is for backwards compatibility
	if (DataTable.factory(selector, options)) {
		return DataTable;
	}

	// When creating with `new`, create a new DataTable, returning the API instance
	if (this instanceof DataTable) {
		return $(selector).DataTable(options);
	}
	else {
		// Argument switching
		options = selector;
	}

	/**
	 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
	 * return the resulting jQuery object.
	 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
	 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
	 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
	 *    criterion ("applied") or all TR elements (i.e. no filter).
	 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
	 *    Can be either 'current', whereby the current sorting of the table is used, or
	 *    'original' whereby the original order the data was read into the table is used.
	 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
	 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
	 *    'current' and filter is 'applied', regardless of what they might be given as.
	 *  @returns {object} jQuery object, filtered by the given selector.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Highlight every second row
	 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
	 *    } );
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Filter to rows with 'Webkit' in them, add a background colour and then
	 *      // remove the filter, thus highlighting the 'Webkit' rows only.
	 *      oTable.fnFilter('Webkit');
	 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
	 *      oTable.fnFilter('');
	 *    } );
	 */
	this.$ = function ( sSelector, oOpts )
	{
		return this.api(true).$( sSelector, oOpts );
	};
	
	
	/**
	 * Almost identical to $ in operation, but in this case returns the data for the matched
	 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
	 * rather than any descendants, so the data can be obtained for the row/cell. If matching
	 * rows are found, the data returned is the original data array/object that was used to
	 * create the row (or a generated array if from a DOM source).
	 *
	 * This method is often useful in-combination with $ where both functions are given the
	 * same parameters and the array indexes will match identically.
	 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
	 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
	 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
	 *    criterion ("applied") or all elements (i.e. no filter).
	 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
	 *    Can be either 'current', whereby the current sorting of the table is used, or
	 *    'original' whereby the original order the data was read into the table is used.
	 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
	 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
	 *    'current' and filter is 'applied', regardless of what they might be given as.
	 *  @returns {array} Data for the matched elements. If any elements, as a result of the
	 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
	 *    entry in the array.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Get the data from the first row in the table
	 *      var data = oTable._('tr:first');
	 *
	 *      // Do something useful with the data
	 *      alert( "First cell is: "+data[0] );
	 *    } );
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Filter to 'Webkit' and get all data for
	 *      oTable.fnFilter('Webkit');
	 *      var data = oTable._('tr', {"search": "applied"});
	 *
	 *      // Do something with the data
	 *      alert( data.length+" rows matched the search" );
	 *    } );
	 */
	this._ = function ( sSelector, oOpts )
	{
		return this.api(true).rows( sSelector, oOpts ).data();
	};
	
	
	/**
	 * Create a DataTables Api instance, with the currently selected tables for
	 * the Api's context.
	 * @param {boolean} [traditional=false] Set the API instance's context to be
	 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
	 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
	 *   or if all tables captured in the jQuery object should be used.
	 * @return {DataTables.Api}
	 */
	this.api = function ( traditional )
	{
		return traditional ?
			new _Api(
				_fnSettingsFromNode( this[ _ext.iApiIndex ] )
			) :
			new _Api( this );
	};
	
	
	/**
	 * Add a single new row or multiple rows of data to the table. Please note
	 * that this is suitable for client-side processing only - if you are using
	 * server-side processing (i.e. "bServerSide": true), then to add data, you
	 * must add it to the data source, i.e. the server-side, through an Ajax call.
	 *  @param {array|object} data The data to be added to the table. This can be:
	 *    <ul>
	 *      <li>1D array of data - add a single row with the data provided</li>
	 *      <li>2D array of arrays - add multiple rows in a single call</li>
	 *      <li>object - data object when using <i>mData</i></li>
	 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
	 *    </ul>
	 *  @param {bool} [redraw=true] redraw the table or not
	 *  @returns {array} An array of integers, representing the list of indexes in
	 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
	 *    the table.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    // Global var for counter
	 *    var giCount = 2;
	 *
	 *    $(document).ready(function() {
	 *      $('#example').dataTable();
	 *    } );
	 *
	 *    function fnClickAddRow() {
	 *      $('#example').dataTable().fnAddData( [
	 *        giCount+".1",
	 *        giCount+".2",
	 *        giCount+".3",
	 *        giCount+".4" ]
	 *      );
	 *
	 *      giCount++;
	 *    }
	 */
	this.fnAddData = function( data, redraw )
	{
		var api = this.api( true );
	
		/* Check if we want to add multiple rows or not */
		var rows = Array.isArray(data) && ( Array.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
			api.rows.add( data ) :
			api.row.add( data );
	
		if ( redraw === undefined || redraw ) {
			api.draw();
		}
	
		return rows.flatten().toArray();
	};
	
	
	/**
	 * This function will make DataTables recalculate the column sizes, based on the data
	 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
	 * through the sWidth parameter). This can be useful when the width of the table's
	 * parent element changes (for example a window resize).
	 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "bPaginate": false
	 *      } );
	 *
	 *      $(window).on('resize', function () {
	 *        oTable.fnAdjustColumnSizing();
	 *      } );
	 *    } );
	 */
	this.fnAdjustColumnSizing = function ( bRedraw )
	{
		var api = this.api( true ).columns.adjust();
		var settings = api.settings()[0];
		var scroll = settings.oScroll;
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw( false );
		}
		else if ( scroll.sX !== "" || scroll.sY !== "" ) {
			/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
			_fnScrollDraw( settings );
		}
	};
	
	
	/**
	 * Quickly and simply clear a table
	 *  @param {bool} [bRedraw=true] redraw the table or not
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
	 *      oTable.fnClearTable();
	 *    } );
	 */
	this.fnClearTable = function( bRedraw )
	{
		var api = this.api( true ).clear();
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw();
		}
	};
	
	
	/**
	 * The exact opposite of 'opening' a row, this function will close any rows which
	 * are currently 'open'.
	 *  @param {node} nTr the table row to 'close'
	 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable;
	 *
	 *      // 'open' an information row when a row is clicked on
	 *      $('#example tbody tr').click( function () {
	 *        if ( oTable.fnIsOpen(this) ) {
	 *          oTable.fnClose( this );
	 *        } else {
	 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	 *        }
	 *      } );
	 *
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnClose = function( nTr )
	{
		this.api( true ).row( nTr ).child.hide();
	};
	
	
	/**
	 * Remove a row for the table
	 *  @param {mixed} target The index of the row from aoData to be deleted, or
	 *    the TR element you want to delete
	 *  @param {function|null} [callBack] Callback function
	 *  @param {bool} [redraw=true] Redraw the table or not
	 *  @returns {array} The row that was deleted
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Immediately remove the first row
	 *      oTable.fnDeleteRow( 0 );
	 *    } );
	 */
	this.fnDeleteRow = function( target, callback, redraw )
	{
		var api = this.api( true );
		var rows = api.rows( target );
		var settings = rows.settings()[0];
		var data = settings.aoData[ rows[0][0] ];
	
		rows.remove();
	
		if ( callback ) {
			callback.call( this, settings, data );
		}
	
		if ( redraw === undefined || redraw ) {
			api.draw();
		}
	
		return data;
	};
	
	
	/**
	 * Restore the table to it's original state in the DOM by removing all of DataTables
	 * enhancements, alterations to the DOM structure of the table and event listeners.
	 *  @param {boolean} [remove=false] Completely remove the table from the DOM
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
	 *      var oTable = $('#example').dataTable();
	 *      oTable.fnDestroy();
	 *    } );
	 */
	this.fnDestroy = function ( remove )
	{
		this.api( true ).destroy( remove );
	};
	
	
	/**
	 * Redraw the table
	 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
	 *      oTable.fnDraw();
	 *    } );
	 */
	this.fnDraw = function( complete )
	{
		// Note that this isn't an exact match to the old call to _fnDraw - it takes
		// into account the new data, but can hold position.
		this.api( true ).draw( complete );
	};
	
	
	/**
	 * Filter the input based on data
	 *  @param {string} sInput String to filter the table on
	 *  @param {int|null} [iColumn] Column to limit filtering to
	 *  @param {bool} [bRegex=false] Treat as regular expression or not
	 *  @param {bool} [bSmart=true] Perform smart filtering or not
	 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
	 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Sometime later - filter...
	 *      oTable.fnFilter( 'test string' );
	 *    } );
	 */
	this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
	{
		var api = this.api( true );
	
		if ( iColumn === null || iColumn === undefined ) {
			api.search( sInput, bRegex, bSmart, bCaseInsensitive );
		}
		else {
			api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
		}
	
		api.draw();
	};
	
	
	/**
	 * Get the data for the whole table, an individual row or an individual cell based on the
	 * provided parameters.
	 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
	 *    a TR node then the data source for the whole row will be returned. If given as a
	 *    TD/TH cell node then iCol will be automatically calculated and the data for the
	 *    cell returned. If given as an integer, then this is treated as the aoData internal
	 *    data index for the row (see fnGetPosition) and the data for that row used.
	 *  @param {int} [col] Optional column index that you want the data of.
	 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
	 *    returned. If mRow is defined, just data for that row, and is iCol is
	 *    defined, only data for the designated cell is returned.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    // Row data
	 *    $(document).ready(function() {
	 *      oTable = $('#example').dataTable();
	 *
	 *      oTable.$('tr').click( function () {
	 *        var data = oTable.fnGetData( this );
	 *        // ... do something with the array / object of data for the row
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Individual cell data
	 *    $(document).ready(function() {
	 *      oTable = $('#example').dataTable();
	 *
	 *      oTable.$('td').click( function () {
	 *        var sData = oTable.fnGetData( this );
	 *        alert( 'The cell clicked on had the value of '+sData );
	 *      } );
	 *    } );
	 */
	this.fnGetData = function( src, col )
	{
		var api = this.api( true );
	
		if ( src !== undefined ) {
			var type = src.nodeName ? src.nodeName.toLowerCase() : '';
	
			return col !== undefined || type == 'td' || type == 'th' ?
				api.cell( src, col ).data() :
				api.row( src ).data() || null;
		}
	
		return api.data().toArray();
	};
	
	
	/**
	 * Get an array of the TR nodes that are used in the table's body. Note that you will
	 * typically want to use the '$' API method in preference to this as it is more
	 * flexible.
	 *  @param {int} [iRow] Optional row index for the TR element you want
	 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
	 *    in the table's body, or iRow is defined, just the TR element requested.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Get the nodes from the table
	 *      var nNodes = oTable.fnGetNodes( );
	 *    } );
	 */
	this.fnGetNodes = function( iRow )
	{
		var api = this.api( true );
	
		return iRow !== undefined ?
			api.row( iRow ).node() :
			api.rows().nodes().flatten().toArray();
	};
	
	
	/**
	 * Get the array indexes of a particular cell from it's DOM element
	 * and column index including hidden columns
	 *  @param {node} node this can either be a TR, TD or TH in the table's body
	 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
	 *    if given as a cell, an array of [row index, column index (visible),
	 *    column index (all)] is given.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      $('#example tbody td').click( function () {
	 *        // Get the position of the current data from the node
	 *        var aPos = oTable.fnGetPosition( this );
	 *
	 *        // Get the data array for this row
	 *        var aData = oTable.fnGetData( aPos[0] );
	 *
	 *        // Update the data array and return the value
	 *        aData[ aPos[1] ] = 'clicked';
	 *        this.innerHTML = 'clicked';
	 *      } );
	 *
	 *      // Init DataTables
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnGetPosition = function( node )
	{
		var api = this.api( true );
		var nodeName = node.nodeName.toUpperCase();
	
		if ( nodeName == 'TR' ) {
			return api.row( node ).index();
		}
		else if ( nodeName == 'TD' || nodeName == 'TH' ) {
			var cell = api.cell( node ).index();
	
			return [
				cell.row,
				cell.columnVisible,
				cell.column
			];
		}
		return null;
	};
	
	
	/**
	 * Check to see if a row is 'open' or not.
	 *  @param {node} nTr the table row to check
	 *  @returns {boolean} true if the row is currently open, false otherwise
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable;
	 *
	 *      // 'open' an information row when a row is clicked on
	 *      $('#example tbody tr').click( function () {
	 *        if ( oTable.fnIsOpen(this) ) {
	 *          oTable.fnClose( this );
	 *        } else {
	 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	 *        }
	 *      } );
	 *
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnIsOpen = function( nTr )
	{
		return this.api( true ).row( nTr ).child.isShown();
	};
	
	
	/**
	 * This function will place a new row directly after a row which is currently
	 * on display on the page, with the HTML contents that is passed into the
	 * function. This can be used, for example, to ask for confirmation that a
	 * particular record should be deleted.
	 *  @param {node} nTr The table row to 'open'
	 *  @param {string|node|jQuery} mHtml The HTML to put into the row
	 *  @param {string} sClass Class to give the new TD cell
	 *  @returns {node} The row opened. Note that if the table row passed in as the
	 *    first parameter, is not found in the table, this method will silently
	 *    return.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable;
	 *
	 *      // 'open' an information row when a row is clicked on
	 *      $('#example tbody tr').click( function () {
	 *        if ( oTable.fnIsOpen(this) ) {
	 *          oTable.fnClose( this );
	 *        } else {
	 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	 *        }
	 *      } );
	 *
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnOpen = function( nTr, mHtml, sClass )
	{
		return this.api( true )
			.row( nTr )
			.child( mHtml, sClass )
			.show()
			.child()[0];
	};
	
	
	/**
	 * Change the pagination - provides the internal logic for pagination in a simple API
	 * function. With this function you can have a DataTables table go to the next,
	 * previous, first or last pages.
	 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
	 *    or page number to jump to (integer), note that page 0 is the first page.
	 *  @param {bool} [bRedraw=true] Redraw the table or not
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      oTable.fnPageChange( 'next' );
	 *    } );
	 */
	this.fnPageChange = function ( mAction, bRedraw )
	{
		var api = this.api( true ).page( mAction );
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw(false);
		}
	};
	
	
	/**
	 * Show a particular column
	 *  @param {int} iCol The column whose display should be changed
	 *  @param {bool} bShow Show (true) or hide (false) the column
	 *  @param {bool} [bRedraw=true] Redraw the table or not
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Hide the second column after initialisation
	 *      oTable.fnSetColumnVis( 1, false );
	 *    } );
	 */
	this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
	{
		var api = this.api( true ).column( iCol ).visible( bShow );
	
		if ( bRedraw === undefined || bRedraw ) {
			api.columns.adjust().draw();
		}
	};
	
	
	/**
	 * Get the settings for a particular table for external manipulation
	 *  @returns {object} DataTables settings object. See
	 *    {@link DataTable.models.oSettings}
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      var oSettings = oTable.fnSettings();
	 *
	 *      // Show an example parameter from the settings
	 *      alert( oSettings._iDisplayStart );
	 *    } );
	 */
	this.fnSettings = function()
	{
		return _fnSettingsFromNode( this[_ext.iApiIndex] );
	};
	
	
	/**
	 * Sort the table by a particular column
	 *  @param {int} iCol the data index to sort on. Note that this will not match the
	 *    'display index' if you have hidden data entries
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Sort immediately with columns 0 and 1
	 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
	 *    } );
	 */
	this.fnSort = function( aaSort )
	{
		this.api( true ).order( aaSort ).draw();
	};
	
	
	/**
	 * Attach a sort listener to an element for a given column
	 *  @param {node} nNode the element to attach the sort listener to
	 *  @param {int} iColumn the column that a click on this node will sort on
	 *  @param {function} [fnCallback] callback function when sort is run
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Sort on column 1, when 'sorter' is clicked on
	 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
	 *    } );
	 */
	this.fnSortListener = function( nNode, iColumn, fnCallback )
	{
		this.api( true ).order.listener( nNode, iColumn, fnCallback );
	};
	
	
	/**
	 * Update a table cell or row - this method will accept either a single value to
	 * update the cell with, an array of values with one element for each column or
	 * an object in the same format as the original data source. The function is
	 * self-referencing in order to make the multi column updates easier.
	 *  @param {object|array|string} mData Data to update the cell/row with
	 *  @param {node|int} mRow TR element you want to update or the aoData index
	 *  @param {int} [iColumn] The column to update, give as null or undefined to
	 *    update a whole row.
	 *  @param {bool} [bRedraw=true] Redraw the table or not
	 *  @param {bool} [bAction=true] Perform pre-draw actions or not
	 *  @returns {int} 0 on success, 1 on error
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
	 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
	 *    } );
	 */
	this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
	{
		var api = this.api( true );
	
		if ( iColumn === undefined || iColumn === null ) {
			api.row( mRow ).data( mData );
		}
		else {
			api.cell( mRow, iColumn ).data( mData );
		}
	
		if ( bAction === undefined || bAction ) {
			api.columns.adjust();
		}
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw();
		}
		return 0;
	};
	
	
	/**
	 * Provide a common method for plug-ins to check the version of DataTables being used, in order
	 * to ensure compatibility.
	 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
	 *    formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
	 *    version, or false if this version of DataTales is not suitable
	 *  @method
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
	 *    } );
	 */
	this.fnVersionCheck = _ext.fnVersionCheck;
	

	var _that = this;
	var emptyInit = options === undefined;
	var len = this.length;

	if ( emptyInit ) {
		options = {};
	}

	this.oApi = this.internal = _ext.internal;

	// Extend with old style plug-in API methods
	for ( var fn in DataTable.ext.internal ) {
		if ( fn ) {
			this[fn] = _fnExternApiFunc(fn);
		}
	}

	this.each(function() {
		// For each initialisation we want to give it a clean initialisation
		// object that can be bashed around
		var o = {};
		var oInit = len > 1 ? // optimisation for single table case
			_fnExtend( o, options, true ) :
			options;

		/*global oInit,_that,emptyInit*/
		var i=0, iLen, j, jLen, k, kLen;
		var sId = this.getAttribute( 'id' );
		var bInitHandedOff = false;
		var defaults = DataTable.defaults;
		var $this = $(this);
		
		
		/* Sanity check */
		if ( this.nodeName.toLowerCase() != 'table' )
		{
			_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
			return;
		}
		
		/* Backwards compatibility for the defaults */
		_fnCompatOpts( defaults );
		_fnCompatCols( defaults.column );
		
		/* Convert the camel-case defaults to Hungarian */
		_fnCamelToHungarian( defaults, defaults, true );
		_fnCamelToHungarian( defaults.column, defaults.column, true );
		
		/* Setting up the initialisation object */
		_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ), true );
		
		
		
		/* Check to see if we are re-initialising a table */
		var allSettings = DataTable.settings;
		for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
		{
			var s = allSettings[i];
		
			/* Base check on table node */
			if (
				s.nTable == this ||
				(s.nTHead && s.nTHead.parentNode == this) ||
				(s.nTFoot && s.nTFoot.parentNode == this)
			) {
				var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
				var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
		
				if ( emptyInit || bRetrieve )
				{
					return s.oInstance;
				}
				else if ( bDestroy )
				{
					s.oInstance.fnDestroy();
					break;
				}
				else
				{
					_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
					return;
				}
			}
		
			/* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */
			if ( s.sTableId == this.id )
			{
				allSettings.splice( i, 1 );
				break;
			}
		}
		
		/* Ensure the table has an ID - required for accessibility */
		if ( sId === null || sId === "" )
		{
			sId = "DataTables_Table_"+(DataTable.ext._unique++);
			this.id = sId;
		}
		
		/* Create the settings object for this table and set some of the default parameters */
		var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
			"sDestroyWidth": $this[0].style.width,
			"sInstance":     sId,
			"sTableId":      sId
		} );
		oSettings.nTable = this;
		oSettings.oApi   = _that.internal;
		oSettings.oInit  = oInit;
		
		allSettings.push( oSettings );
		
		// Need to add the instance after the instance after the settings object has been added
		// to the settings array, so we can self reference the table instance if more than one
		oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
		
		// Backwards compatibility, before we apply all the defaults
		_fnCompatOpts( oInit );
		_fnLanguageCompat( oInit.oLanguage );
		
		// If the length menu is given, but the init display length is not, use the length menu
		if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
		{
			oInit.iDisplayLength = Array.isArray( oInit.aLengthMenu[0] ) ?
				oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
		}
		
		// Apply the defaults and init options to make a single init object will all
		// options defined from defaults and instance options.
		oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
		
		
		// Map the initialisation options onto the settings object
		_fnMap( oSettings.oFeatures, oInit, [
			"bPaginate",
			"bLengthChange",
			"bFilter",
			"bSort",
			"bSortMulti",
			"bInfo",
			"bProcessing",
			"bAutoWidth",
			"bSortClasses",
			"bServerSide",
			"bDeferRender"
		] );
		_fnMap( oSettings, oInit, [
			"asStripeClasses",
			"ajax",
			"fnServerData",
			"fnFormatNumber",
			"sServerMethod",
			"aaSorting",
			"aaSortingFixed",
			"aLengthMenu",
			"sPaginationType",
			"sAjaxSource",
			"sAjaxDataProp",
			"iStateDuration",
			"sDom",
			"bSortCellsTop",
			"iTabIndex",
			"fnStateLoadCallback",
			"fnStateSaveCallback",
			"renderer",
			"searchDelay",
			"rowId",
			[ "iCookieDuration", "iStateDuration" ], // backwards compat
			[ "oSearch", "oPreviousSearch" ],
			[ "aoSearchCols", "aoPreSearchCols" ],
			[ "iDisplayLength", "_iDisplayLength" ]
		] );
		_fnMap( oSettings.oScroll, oInit, [
			[ "sScrollX", "sX" ],
			[ "sScrollXInner", "sXInner" ],
			[ "sScrollY", "sY" ],
			[ "bScrollCollapse", "bCollapse" ]
		] );
		_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
		
		/* Callback functions which are array driven */
		_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
		_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
		_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
		_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
		_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
		_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
		_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
		_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
		_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
		_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
		_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
		
		oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
		
		/* Browser support detection */
		_fnBrowserDetect( oSettings );
		
		var oClasses = oSettings.oClasses;
		
		$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
		$this.addClass( oClasses.sTable );
		
		
		if ( oSettings.iInitDisplayStart === undefined )
		{
			/* Display start point, taking into account the save saving */
			oSettings.iInitDisplayStart = oInit.iDisplayStart;
			oSettings._iDisplayStart = oInit.iDisplayStart;
		}
		
		if ( oInit.iDeferLoading !== null )
		{
			oSettings.bDeferLoading = true;
			var tmp = Array.isArray( oInit.iDeferLoading );
			oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
			oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
		}
		
		/* Language definitions */
		var oLanguage = oSettings.oLanguage;
		$.extend( true, oLanguage, oInit.oLanguage );
		
		if ( oLanguage.sUrl )
		{
			/* Get the language definitions from a file - because this Ajax call makes the language
			 * get async to the remainder of this function we use bInitHandedOff to indicate that
			 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
			 */
			$.ajax( {
				dataType: 'json',
				url: oLanguage.sUrl,
				success: function ( json ) {
					_fnCamelToHungarian( defaults.oLanguage, json );
					_fnLanguageCompat( json );
					$.extend( true, oLanguage, json, oSettings.oInit.oLanguage );
		
					_fnCallbackFire( oSettings, null, 'i18n', [oSettings]);
					_fnInitialise( oSettings );
				},
				error: function () {
					// Error occurred loading language file, continue on as best we can
					_fnInitialise( oSettings );
				}
			} );
			bInitHandedOff = true;
		}
		else {
			_fnCallbackFire( oSettings, null, 'i18n', [oSettings]);
		}
		
		/*
		 * Stripes
		 */
		if ( oInit.asStripeClasses === null )
		{
			oSettings.asStripeClasses =[
				oClasses.sStripeOdd,
				oClasses.sStripeEven
			];
		}
		
		/* Remove row stripe classes if they are already on the table row */
		var stripeClasses = oSettings.asStripeClasses;
		var rowOne = $this.children('tbody').find('tr').eq(0);
		if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
			return rowOne.hasClass(el);
		} ) ) !== -1 ) {
			$('tbody tr', this).removeClass( stripeClasses.join(' ') );
			oSettings.asDestroyStripes = stripeClasses.slice();
		}
		
		/*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */
		var anThs = [];
		var aoColumnsInit;
		var nThead = this.getElementsByTagName('thead');
		if ( nThead.length !== 0 )
		{
			_fnDetectHeader( oSettings.aoHeader, nThead[0] );
			anThs = _fnGetUniqueThs( oSettings );
		}
		
		/* If not given a column array, generate one with nulls */
		if ( oInit.aoColumns === null )
		{
			aoColumnsInit = [];
			for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
			{
				aoColumnsInit.push( null );
			}
		}
		else
		{
			aoColumnsInit = oInit.aoColumns;
		}
		
		/* Add the columns */
		for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
		{
			_fnAddColumn( oSettings, anThs ? anThs[i] : null );
		}
		
		/* Apply the column definitions */
		_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
			_fnColumnOptions( oSettings, iCol, oDef );
		} );
		
		/* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */
		if ( rowOne.length ) {
			var a = function ( cell, name ) {
				return cell.getAttribute( 'data-'+name ) !== null ? name : null;
			};
		
			$( rowOne[0] ).children('th, td').each( function (i, cell) {
				var col = oSettings.aoColumns[i];
		
				if (! col) {
					_fnLog( oSettings, 0, 'Incorrect column count', 18 );
				}
		
				if ( col.mData === i ) {
					var sort = a( cell, 'sort' ) || a( cell, 'order' );
					var filter = a( cell, 'filter' ) || a( cell, 'search' );
		
					if ( sort !== null || filter !== null ) {
						col.mData = {
							_:      i+'.display',
							sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
							type:   sort !== null   ? i+'.@data-'+sort   : undefined,
							filter: filter !== null ? i+'.@data-'+filter : undefined
						};
						col._isArrayHost = true;
		
						_fnColumnOptions( oSettings, i );
					}
				}
			} );
		}
		
		var features = oSettings.oFeatures;
		var loadedInit = function () {
			/*
			 * Sorting
			 * @todo For modularisation (1.11) this needs to do into a sort start up handler
			 */
		
			// If aaSorting is not defined, then we use the first indicator in asSorting
			// in case that has been altered, so the default sort reflects that option
			if ( oInit.aaSorting === undefined ) {
				var sorting = oSettings.aaSorting;
				for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
					sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
				}
			}
		
			/* Do a first pass on the sorting classes (allows any size changes to be taken into
			 * account, and also will apply sorting disabled classes if disabled
			 */
			_fnSortingClasses( oSettings );
		
			if ( features.bSort ) {
				_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
					if ( oSettings.bSorted ) {
						var aSort = _fnSortFlatten( oSettings );
						var sortedColumns = {};
		
						$.each( aSort, function (i, val) {
							sortedColumns[ val.src ] = val.dir;
						} );
		
						_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
						_fnSortAria( oSettings );
					}
				} );
			}
		
			_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
				if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
					_fnSortingClasses( oSettings );
				}
			}, 'sc' );
		
		
			/*
			 * Final init
			 * Cache the header, body and footer as required, creating them if needed
			 */
		
			// Work around for Webkit bug 83867 - store the caption-side before removing from doc
			var captions = $this.children('caption').each( function () {
				this._captionSide = $(this).css('caption-side');
			} );
		
			var thead = $this.children('thead');
			if ( thead.length === 0 ) {
				thead = $('<thead/>').appendTo($this);
			}
			oSettings.nTHead = thead[0];
		
			var tbody = $this.children('tbody');
			if ( tbody.length === 0 ) {
				tbody = $('<tbody/>').insertAfter(thead);
			}
			oSettings.nTBody = tbody[0];
		
			var tfoot = $this.children('tfoot');
			if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
				// If we are a scrolling table, and no footer has been given, then we need to create
				// a tfoot element for the caption element to be appended to
				tfoot = $('<tfoot/>').appendTo($this);
			}
		
			if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
				$this.addClass( oClasses.sNoFooter );
			}
			else if ( tfoot.length > 0 ) {
				oSettings.nTFoot = tfoot[0];
				_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
			}
		
			/* Check if there is data passing into the constructor */
			if ( oInit.aaData ) {
				for ( i=0 ; i<oInit.aaData.length ; i++ ) {
					_fnAddData( oSettings, oInit.aaData[ i ] );
				}
			}
			else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
				/* Grab the data from the page - only do this when deferred loading or no Ajax
				 * source since there is no point in reading the DOM data if we are then going
				 * to replace it with Ajax data
				 */
				_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
			}
		
			/* Copy the data index array */
			oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
		
			/* Initialisation complete - table can be drawn */
			oSettings.bInitialised = true;
		
			/* Check if we need to initialise the table (it might not have been handed off to the
			 * language processor)
			 */
			if ( bInitHandedOff === false ) {
				_fnInitialise( oSettings );
			}
		};
		
		/* Must be done after everything which can be overridden by the state saving! */
		_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
		
		if ( oInit.bStateSave )
		{
			features.bStateSave = true;
			_fnLoadState( oSettings, oInit, loadedInit );
		}
		else {
			loadedInit();
		}
		
	} );
	_that = null;
	return this;
};


/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */


// Defined else where
//  _selector_run
//  _selector_opts
//  _selector_first
//  _selector_row_indexes

var _ext; // DataTable.ext
var _Api; // DataTable.Api
var _api_register; // DataTable.Api.register
var _api_registerPlural; // DataTable.Api.registerPlural

var _re_dic = {};
var _re_new_lines = /[\r\n\u2028]/g;
var _re_html = /<.*?>/g;

// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;

// Escape regular expression special characters
var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );

// https://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var _re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;


var _empty = function ( d ) {
	return !d || d === true || d === '-' ? true : false;
};


var _intVal = function ( s ) {
	var integer = parseInt( s, 10 );
	return !isNaN(integer) && isFinite(s) ? integer : null;
};

// Convert from a formatted number with characters other than `.` as the
// decimal place, to a Javascript number
var _numToDecimal = function ( num, decimalPoint ) {
	// Cache created regular expressions for speed as this function is called often
	if ( ! _re_dic[ decimalPoint ] ) {
		_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
	}
	return typeof num === 'string' && decimalPoint !== '.' ?
		num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
		num;
};


var _isNumber = function ( d, decimalPoint, formatted ) {
	var type = typeof d;
	var strType = type === 'string';

	if ( type === 'number' || type === 'bigint') {
		return true;
	}

	// If empty return immediately so there must be a number if it is a
	// formatted string (this stops the string "k", or "kr", etc being detected
	// as a formatted number for currency
	if ( _empty( d ) ) {
		return true;
	}

	if ( decimalPoint && strType ) {
		d = _numToDecimal( d, decimalPoint );
	}

	if ( formatted && strType ) {
		d = d.replace( _re_formatted_numeric, '' );
	}

	return !isNaN( parseFloat(d) ) && isFinite( d );
};


// A string without HTML in it can be considered to be HTML still
var _isHtml = function ( d ) {
	return _empty( d ) || typeof d === 'string';
};


var _htmlNumeric = function ( d, decimalPoint, formatted ) {
	if ( _empty( d ) ) {
		return true;
	}

	var html = _isHtml( d );
	return ! html ?
		null :
		_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
			true :
			null;
};


var _pluck = function ( a, prop, prop2 ) {
	var out = [];
	var i=0, ien=a.length;

	// Could have the test in the loop for slightly smaller code, but speed
	// is essential here
	if ( prop2 !== undefined ) {
		for ( ; i<ien ; i++ ) {
			if ( a[i] && a[i][ prop ] ) {
				out.push( a[i][ prop ][ prop2 ] );
			}
		}
	}
	else {
		for ( ; i<ien ; i++ ) {
			if ( a[i] ) {
				out.push( a[i][ prop ] );
			}
		}
	}

	return out;
};


// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var _pluck_order = function ( a, order, prop, prop2 )
{
	var out = [];
	var i=0, ien=order.length;

	// Could have the test in the loop for slightly smaller code, but speed
	// is essential here
	if ( prop2 !== undefined ) {
		for ( ; i<ien ; i++ ) {
			if ( a[ order[i] ][ prop ] ) {
				out.push( a[ order[i] ][ prop ][ prop2 ] );
			}
		}
	}
	else {
		for ( ; i<ien ; i++ ) {
			out.push( a[ order[i] ][ prop ] );
		}
	}

	return out;
};


var _range = function ( len, start )
{
	var out = [];
	var end;

	if ( start === undefined ) {
		start = 0;
		end = len;
	}
	else {
		end = start;
		start = len;
	}

	for ( var i=start ; i<end ; i++ ) {
		out.push( i );
	}

	return out;
};


var _removeEmpty = function ( a )
{
	var out = [];

	for ( var i=0, ien=a.length ; i<ien ; i++ ) {
		if ( a[i] ) { // careful - will remove all falsy values!
			out.push( a[i] );
		}
	}

	return out;
};


var _stripHtml = function ( d ) {
	return d
		.replace( _re_html, '' ) // Complete tags
		.replace(/<script/i, ''); // Safety for incomplete script tag
};


/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */
var _areAllUnique = function ( src ) {
	if ( src.length < 2 ) {
		return true;
	}

	var sorted = src.slice().sort();
	var last = sorted[0];

	for ( var i=1, ien=sorted.length ; i<ien ; i++ ) {
		if ( sorted[i] === last ) {
			return false;
		}

		last = sorted[i];
	}

	return true;
};


/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */
var _unique = function ( src )
{
	if ( _areAllUnique( src ) ) {
		return src.slice();
	}

	// A faster unique method is to use object keys to identify used values,
	// but this doesn't work with arrays or objects, which we must also
	// consider. See jsperf.com/compare-array-unique-versions/4 for more
	// information.
	var
		out = [],
		val,
		i, ien=src.length,
		j, k=0;

	again: for ( i=0 ; i<ien ; i++ ) {
		val = src[i];

		for ( j=0 ; j<k ; j++ ) {
			if ( out[j] === val ) {
				continue again;
			}
		}

		out.push( val );
		k++;
	}

	return out;
};

// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var _flatten = function (out, val) {
	if (Array.isArray(val)) {
		for (var i=0 ; i<val.length ; i++) {
			_flatten(out, val[i]);
		}
	}
	else {
		out.push(val);
	}
  
	return out;
}

var _includes = function (search, start) {
	if (start === undefined) {
		start = 0;
	}

	return this.indexOf(search, start) !== -1;	
};

// Array.isArray polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
if (! Array.isArray) {
    Array.isArray = function(arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

if (! Array.prototype.includes) {
	Array.prototype.includes = _includes;
}

// .trim() polyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

if (! String.prototype.includes) {
	String.prototype.includes = _includes;
}

/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */
DataTable.util = {
	/**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */
	throttle: function ( fn, freq ) {
		var
			frequency = freq !== undefined ? freq : 200,
			last,
			timer;

		return function () {
			var
				that = this,
				now  = +new Date(),
				args = arguments;

			if ( last && now < last + frequency ) {
				clearTimeout( timer );

				timer = setTimeout( function () {
					last = undefined;
					fn.apply( that, args );
				}, frequency );
			}
			else {
				last = now;
				fn.apply( that, args );
			}
		};
	},


	/**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */
	escapeRegex: function ( val ) {
		return val.replace( _re_escape_regex, '\\$1' );
	},

	/**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */
	set: function ( source ) {
		if ( $.isPlainObject( source ) ) {
			/* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */
			return DataTable.util.set( source._ );
		}
		else if ( source === null ) {
			// Nothing to do when the data source is null
			return function () {};
		}
		else if ( typeof source === 'function' ) {
			return function (data, val, meta) {
				source( data, 'set', val, meta );
			};
		}
		else if ( typeof source === 'string' && (source.indexOf('.') !== -1 ||
				  source.indexOf('[') !== -1 || source.indexOf('(') !== -1) )
		{
			// Like the get, we need to get data from a nested object
			var setData = function (data, val, src) {
				var a = _fnSplitObjNotation( src ), b;
				var aLast = a[a.length-1];
				var arrayNotation, funcNotation, o, innerSrc;
	
				for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ ) {
					// Protect against prototype pollution
					if (a[i] === '__proto__' || a[i] === 'constructor') {
						throw new Error('Cannot set prototype values');
					}
	
					// Check if we are dealing with an array notation request
					arrayNotation = a[i].match(__reArray);
					funcNotation = a[i].match(__reFn);
	
					if ( arrayNotation ) {
						a[i] = a[i].replace(__reArray, '');
						data[ a[i] ] = [];
	
						// Get the remainder of the nested object to set so we can recurse
						b = a.slice();
						b.splice( 0, i+1 );
						innerSrc = b.join('.');
	
						// Traverse each entry in the array setting the properties requested
						if ( Array.isArray( val ) ) {
							for ( var j=0, jLen=val.length ; j<jLen ; j++ ) {
								o = {};
								setData( o, val[j], innerSrc );
								data[ a[i] ].push( o );
							}
						}
						else {
							// We've been asked to save data to an array, but it
							// isn't array data to be saved. Best that can be done
							// is to just save the value.
							data[ a[i] ] = val;
						}
	
						// The inner call to setData has already traversed through the remainder
						// of the source and has set the data, thus we can exit here
						return;
					}
					else if ( funcNotation ) {
						// Function call
						a[i] = a[i].replace(__reFn, '');
						data = data[ a[i] ]( val );
					}
	
					// If the nested object doesn't currently exist - since we are
					// trying to set the value - create it
					if ( data[ a[i] ] === null || data[ a[i] ] === undefined ) {
						data[ a[i] ] = {};
					}
					data = data[ a[i] ];
				}
	
				// Last item in the input - i.e, the actual set
				if ( aLast.match(__reFn ) ) {
					// Function call
					data = data[ aLast.replace(__reFn, '') ]( val );
				}
				else {
					// If array notation is used, we just want to strip it and use the property name
					// and assign the value. If it isn't used, then we get the result we want anyway
					data[ aLast.replace(__reArray, '') ] = val;
				}
			};
	
			return function (data, val) { // meta is also passed in, but not used
				return setData( data, val, source );
			};
		}
		else {
			// Array or flat object mapping
			return function (data, val) { // meta is also passed in, but not used
				data[source] = val;
			};
		}
	},

	/**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */
	get: function ( source ) {
		if ( $.isPlainObject( source ) ) {
			// Build an object of get functions, and wrap them in a single call
			var o = {};
			$.each( source, function (key, val) {
				if ( val ) {
					o[key] = DataTable.util.get( val );
				}
			} );
	
			return function (data, type, row, meta) {
				var t = o[type] || o._;
				return t !== undefined ?
					t(data, type, row, meta) :
					data;
			};
		}
		else if ( source === null ) {
			// Give an empty string for rendering / sorting etc
			return function (data) { // type, row and meta also passed, but not used
				return data;
			};
		}
		else if ( typeof source === 'function' ) {
			return function (data, type, row, meta) {
				return source( data, type, row, meta );
			};
		}
		else if ( typeof source === 'string' && (source.indexOf('.') !== -1 ||
				  source.indexOf('[') !== -1 || source.indexOf('(') !== -1) )
		{
			/* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */
			var fetchData = function (data, type, src) {
				var arrayNotation, funcNotation, out, innerSrc;
	
				if ( src !== "" ) {
					var a = _fnSplitObjNotation( src );
	
					for ( var i=0, iLen=a.length ; i<iLen ; i++ ) {
						// Check if we are dealing with special notation
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
	
						if ( arrayNotation ) {
							// Array notation
							a[i] = a[i].replace(__reArray, '');
	
							// Condition allows simply [] to be passed in
							if ( a[i] !== "" ) {
								data = data[ a[i] ];
							}
							out = [];
	
							// Get the remainder of the nested object to get
							a.splice( 0, i+1 );
							innerSrc = a.join('.');
	
							// Traverse each entry in the array getting the properties requested
							if ( Array.isArray( data ) ) {
								for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
									out.push( fetchData( data[j], type, innerSrc ) );
								}
							}
	
							// If a string is given in between the array notation indicators, that
							// is used to join the strings together, otherwise an array is returned
							var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
							data = (join==="") ? out : out.join(join);
	
							// The inner call to fetchData has already traversed through the remainder
							// of the source requested, so we exit from the loop
							break;
						}
						else if ( funcNotation ) {
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]();
							continue;
						}
	
						if (data === null || data[ a[i] ] === null) {
							return null;
						}
						else if ( data === undefined || data[ a[i] ] === undefined ) {
							return undefined;
						}

						data = data[ a[i] ];
					}
				}
	
				return data;
			};
	
			return function (data, type) { // row and meta also passed, but not used
				return fetchData( data, type, source );
			};
		}
		else {
			// Array or flat object mapping
			return function (data, type) { // row and meta also passed, but not used
				return data[source];
			};
		}
	}
};



/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */
function _fnHungarianMap ( o )
{
	var
		hungarian = 'a aa ai ao as b fn i m o s ',
		match,
		newKey,
		map = {};

	$.each( o, function (key, val) {
		match = key.match(/^([^A-Z]+?)([A-Z])/);

		if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
		{
			newKey = key.replace( match[0], match[2].toLowerCase() );
			map[ newKey ] = key;

			if ( match[1] === 'o' )
			{
				_fnHungarianMap( o[key] );
			}
		}
	} );

	o._hungarianMap = map;
}


/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */
function _fnCamelToHungarian ( src, user, force )
{
	if ( ! src._hungarianMap ) {
		_fnHungarianMap( src );
	}

	var hungarianKey;

	$.each( user, function (key, val) {
		hungarianKey = src._hungarianMap[ key ];

		if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
		{
			// For objects, we need to buzz down into the object to copy parameters
			if ( hungarianKey.charAt(0) === 'o' )
			{
				// Copy the camelCase options over to the hungarian
				if ( ! user[ hungarianKey ] ) {
					user[ hungarianKey ] = {};
				}
				$.extend( true, user[hungarianKey], user[key] );

				_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
			}
			else {
				user[hungarianKey] = user[ key ];
			}
		}
	} );
}


/**
 * Language compatibility - when certain options are given, and others aren't, we
 * need to duplicate the values over, in order to provide backwards compatibility
 * with older language files.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnLanguageCompat( lang )
{
	// Note the use of the Hungarian notation for the parameters in this method as
	// this is called after the mapping of camelCase to Hungarian
	var defaults = DataTable.defaults.oLanguage;

	// Default mapping
	var defaultDecimal = defaults.sDecimal;
	if ( defaultDecimal ) {
		_addNumericSort( defaultDecimal );
	}

	if ( lang ) {
		var zeroRecords = lang.sZeroRecords;

		// Backwards compatibility - if there is no sEmptyTable given, then use the same as
		// sZeroRecords - assuming that is given.
		if ( ! lang.sEmptyTable && zeroRecords &&
			defaults.sEmptyTable === "No data available in table" )
		{
			_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
		}

		// Likewise with loading records
		if ( ! lang.sLoadingRecords && zeroRecords &&
			defaults.sLoadingRecords === "Loading..." )
		{
			_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
		}

		// Old parameter name of the thousands separator mapped onto the new
		if ( lang.sInfoThousands ) {
			lang.sThousands = lang.sInfoThousands;
		}

		var decimal = lang.sDecimal;
		if ( decimal && defaultDecimal !== decimal ) {
			_addNumericSort( decimal );
		}
	}
}


/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */
var _fnCompatMap = function ( o, knew, old ) {
	if ( o[ knew ] !== undefined ) {
		o[ old ] = o[ knew ];
	}
};


/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */
function _fnCompatOpts ( init )
{
	_fnCompatMap( init, 'ordering',      'bSort' );
	_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
	_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
	_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
	_fnCompatMap( init, 'order',         'aaSorting' );
	_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
	_fnCompatMap( init, 'paging',        'bPaginate' );
	_fnCompatMap( init, 'pagingType',    'sPaginationType' );
	_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
	_fnCompatMap( init, 'searching',     'bFilter' );

	// Boolean initialisation of x-scrolling
	if ( typeof init.sScrollX === 'boolean' ) {
		init.sScrollX = init.sScrollX ? '100%' : '';
	}
	if ( typeof init.scrollX === 'boolean' ) {
		init.scrollX = init.scrollX ? '100%' : '';
	}

	// Column search objects are in an array, so it needs to be converted
	// element by element
	var searchCols = init.aoSearchCols;

	if ( searchCols ) {
		for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
			if ( searchCols[i] ) {
				_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
			}
		}
	}
}


/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */
function _fnCompatCols ( init )
{
	_fnCompatMap( init, 'orderable',     'bSortable' );
	_fnCompatMap( init, 'orderData',     'aDataSort' );
	_fnCompatMap( init, 'orderSequence', 'asSorting' );
	_fnCompatMap( init, 'orderDataType', 'sortDataType' );

	// orderData can be given as an integer
	var dataSort = init.aDataSort;
	if ( typeof dataSort === 'number' && ! Array.isArray( dataSort ) ) {
		init.aDataSort = [ dataSort ];
	}
}


/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnBrowserDetect( settings )
{
	// We don't need to do this every time DataTables is constructed, the values
	// calculated are specific to the browser and OS configuration which we
	// don't expect to change between initialisations
	if ( ! DataTable.__browser ) {
		var browser = {};
		DataTable.__browser = browser;

		// Scrolling feature / quirks detection
		var n = $('<div/>')
			.css( {
				position: 'fixed',
				top: 0,
				left: $(window).scrollLeft()*-1, // allow for scrolling
				height: 1,
				width: 1,
				overflow: 'hidden'
			} )
			.append(
				$('<div/>')
					.css( {
						position: 'absolute',
						top: 1,
						left: 1,
						width: 100,
						overflow: 'scroll'
					} )
					.append(
						$('<div/>')
							.css( {
								width: '100%',
								height: 10
							} )
					)
			)
			.appendTo( 'body' );

		var outer = n.children();
		var inner = outer.children();

		// Numbers below, in order, are:
		// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
		//
		// IE6 XP:                           100 100 100  83
		// IE7 Vista:                        100 100 100  83
		// IE 8+ Windows:                     83  83 100  83
		// Evergreen Windows:                 83  83 100  83
		// Evergreen Mac with scrollbars:     85  85 100  85
		// Evergreen Mac without scrollbars: 100 100 100 100

		// Get scrollbar width
		browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;

		// IE6/7 will oversize a width 100% element inside a scrolling element, to
		// include the width of the scrollbar, while other browsers ensure the inner
		// element is contained without forcing scrolling
		browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;

		// In rtl text layout, some browsers (most, but not all) will place the
		// scrollbar on the left, rather than the right.
		browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;

		// IE8- don't provide height and width for getBoundingClientRect
		browser.bBounding = n[0].getBoundingClientRect().width ? true : false;

		n.remove();
	}

	$.extend( settings.oBrowser, DataTable.__browser );
	settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
}


/**
 * Array.prototype reduce[Right] method, used for browsers which don't support
 * JS 1.6. Done this way to reduce code size, since we iterate either way
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnReduce ( that, fn, init, start, end, inc )
{
	var
		i = start,
		value,
		isSet = false;

	if ( init !== undefined ) {
		value = init;
		isSet = true;
	}

	while ( i !== end ) {
		if ( ! that.hasOwnProperty(i) ) {
			continue;
		}

		value = isSet ?
			fn( value, that[i], i, that ) :
			that[i];

		isSet = true;
		i += inc;
	}

	return value;
}

/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @param {node} nTh The th element for this column
 *  @memberof DataTable#oApi
 */
function _fnAddColumn( oSettings, nTh )
{
	// Add column to aoColumns array
	var oDefaults = DataTable.defaults.column;
	var iCol = oSettings.aoColumns.length;
	var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
		"nTh": nTh ? nTh : document.createElement('th'),
		"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
		"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
		"mData": oDefaults.mData ? oDefaults.mData : iCol,
		idx: iCol
	} );
	oSettings.aoColumns.push( oCol );

	// Add search object for column specific search. Note that the `searchCols[ iCol ]`
	// passed into extend can be undefined. This allows the user to give a default
	// with only some of the parameters defined, and also not give a default
	var searchCols = oSettings.aoPreSearchCols;
	searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );

	// Use the default column options function to initialise classes etc
	_fnColumnOptions( oSettings, iCol, $(nTh).data() );
}


/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */
function _fnColumnOptions( oSettings, iCol, oOptions )
{
	var oCol = oSettings.aoColumns[ iCol ];
	var oClasses = oSettings.oClasses;
	var th = $(oCol.nTh);

	// Try to get width information from the DOM. We can't get it from CSS
	// as we'd need to parse the CSS stylesheet. `width` option can override
	if ( ! oCol.sWidthOrig ) {
		// Width attribute
		oCol.sWidthOrig = th.attr('width') || null;

		// Style attribute
		var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
		if ( t ) {
			oCol.sWidthOrig = t[1];
		}
	}

	/* User specified column options */
	if ( oOptions !== undefined && oOptions !== null )
	{
		// Backwards compatibility
		_fnCompatCols( oOptions );

		// Map camel case parameters to their Hungarian counterparts
		_fnCamelToHungarian( DataTable.defaults.column, oOptions, true );

		/* Backwards compatibility for mDataProp */
		if ( oOptions.mDataProp !== undefined && !oOptions.mData )
		{
			oOptions.mData = oOptions.mDataProp;
		}

		if ( oOptions.sType )
		{
			oCol._sManualType = oOptions.sType;
		}

		// `class` is a reserved word in Javascript, so we need to provide
		// the ability to use a valid name for the camel case input
		if ( oOptions.className && ! oOptions.sClass )
		{
			oOptions.sClass = oOptions.className;
		}
		if ( oOptions.sClass ) {
			th.addClass( oOptions.sClass );
		}

		var origClass = oCol.sClass;

		$.extend( oCol, oOptions );
		_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );

		// Merge class from previously defined classes with this one, rather than just
		// overwriting it in the extend above
		if (origClass !== oCol.sClass) {
			oCol.sClass = origClass + ' ' + oCol.sClass;
		}

		/* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */
		if ( oOptions.iDataSort !== undefined )
		{
			oCol.aDataSort = [ oOptions.iDataSort ];
		}
		_fnMap( oCol, oOptions, "aDataSort" );

		// Fall back to the aria-label attribute on the table header if no ariaTitle is
		// provided.
		if (! oCol.ariaTitle) {
			oCol.ariaTitle = th.attr("aria-label");
		}
	}

	/* Cache the data get and set functions for speed */
	var mDataSrc = oCol.mData;
	var mData = _fnGetObjectDataFn( mDataSrc );
	var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;

	var attrTest = function( src ) {
		return typeof src === 'string' && src.indexOf('@') !== -1;
	};
	oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
		attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
	);
	oCol._setter = null;

	oCol.fnGetData = function (rowData, type, meta) {
		var innerData = mData( rowData, type, undefined, meta );

		return mRender && type ?
			mRender( innerData, type, rowData, meta ) :
			innerData;
	};
	oCol.fnSetData = function ( rowData, val, meta ) {
		return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
	};

	// Indicate if DataTables should read DOM data as an object or array
	// Used in _fnGetRowElements
	if ( typeof mDataSrc !== 'number' && ! oCol._isArrayHost ) {
		oSettings._rowReadObject = true;
	}

	/* Feature sorting overrides column specific when off */
	if ( !oSettings.oFeatures.bSort )
	{
		oCol.bSortable = false;
		th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
	}

	/* Check that the class assignment is correct for sorting */
	var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
	var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
	if ( !oCol.bSortable || (!bAsc && !bDesc) )
	{
		oCol.sSortingClass = oClasses.sSortableNone;
		oCol.sSortingClassJUI = "";
	}
	else if ( bAsc && !bDesc )
	{
		oCol.sSortingClass = oClasses.sSortableAsc;
		oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
	}
	else if ( !bAsc && bDesc )
	{
		oCol.sSortingClass = oClasses.sSortableDesc;
		oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
	}
	else
	{
		oCol.sSortingClass = oClasses.sSortable;
		oCol.sSortingClassJUI = oClasses.sSortJUI;
	}
}


/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnAdjustColumnSizing ( settings )
{
	/* Not interested in doing column width calculation if auto-width is disabled */
	if ( settings.oFeatures.bAutoWidth !== false )
	{
		var columns = settings.aoColumns;

		_fnCalculateColumnWidths( settings );
		for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
		{
			columns[i].nTh.style.width = columns[i].sWidth;
		}
	}

	var scroll = settings.oScroll;
	if ( scroll.sY !== '' || scroll.sX !== '')
	{
		_fnScrollDraw( settings );
	}

	_fnCallbackFire( settings, null, 'column-sizing', [settings] );
}


/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */
function _fnVisibleToColumnIndex( oSettings, iMatch )
{
	var aiVis = _fnGetColumns( oSettings, 'bVisible' );

	return typeof aiVis[iMatch] === 'number' ?
		aiVis[iMatch] :
		null;
}


/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */
function _fnColumnIndexToVisible( oSettings, iMatch )
{
	var aiVis = _fnGetColumns( oSettings, 'bVisible' );
	var iPos = $.inArray( iMatch, aiVis );

	return iPos !== -1 ? iPos : null;
}


/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */
function _fnVisbleColumns( oSettings )
{
	var vis = 0;

	// No reduce in IE8, use a loop for now
	$.each( oSettings.aoColumns, function ( i, col ) {
		if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
			vis++;
		}
	} );

	return vis;
}


/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */
function _fnGetColumns( oSettings, sParam )
{
	var a = [];

	$.map( oSettings.aoColumns, function(val, i) {
		if ( val[sParam] ) {
			a.push( i );
		}
	} );

	return a;
}


/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnColumnTypes ( settings )
{
	var columns = settings.aoColumns;
	var data = settings.aoData;
	var types = DataTable.ext.type.detect;
	var i, ien, j, jen, k, ken;
	var col, cell, detectedType, cache;

	// For each column, spin over the 
	for ( i=0, ien=columns.length ; i<ien ; i++ ) {
		col = columns[i];
		cache = [];

		if ( ! col.sType && col._sManualType ) {
			col.sType = col._sManualType;
		}
		else if ( ! col.sType ) {
			for ( j=0, jen=types.length ; j<jen ; j++ ) {
				for ( k=0, ken=data.length ; k<ken ; k++ ) {
					// Use a cache array so we only need to get the type data
					// from the formatter once (when using multiple detectors)
					if ( cache[k] === undefined ) {
						cache[k] = _fnGetCellData( settings, k, i, 'type' );
					}

					detectedType = types[j]( cache[k], settings );

					// If null, then this type can't apply to this column, so
					// rather than testing all cells, break out. There is an
					// exception for the last type which is `html`. We need to
					// scan all rows since it is possible to mix string and HTML
					// types
					if ( ! detectedType && j !== types.length-1 ) {
						break;
					}

					// Only a single match is needed for html type since it is
					// bottom of the pile and very similar to string - but it
					// must not be empty
					if ( detectedType === 'html' && ! _empty(cache[k]) ) {
						break;
					}
				}

				// Type is valid for all data points in the column - use this
				// type
				if ( detectedType ) {
					col.sType = detectedType;
					break;
				}
			}

			// Fall back - if no type was detected, always use string
			if ( ! col.sType ) {
				col.sType = 'string';
			}
		}
	}
}


/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */
function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
{
	var i, iLen, j, jLen, k, kLen, def;
	var columns = oSettings.aoColumns;

	// Column definitions with aTargets
	if ( aoColDefs )
	{
		/* Loop over the definitions array - loop in reverse so first instance has priority */
		for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
		{
			def = aoColDefs[i];

			/* Each definition can target multiple columns, as it is an array */
			var aTargets = def.target !== undefined
				? def.target
				: def.targets !== undefined
					? def.targets
					: def.aTargets;

			if ( ! Array.isArray( aTargets ) )
			{
				aTargets = [ aTargets ];
			}

			for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
			{
				if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
				{
					/* Add columns that we don't yet know about */
					while( columns.length <= aTargets[j] )
					{
						_fnAddColumn( oSettings );
					}

					/* Integer, basic index */
					fn( aTargets[j], def );
				}
				else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
				{
					/* Negative integer, right to left column counting */
					fn( columns.length+aTargets[j], def );
				}
				else if ( typeof aTargets[j] === 'string' )
				{
					/* Class name matching on TH element */
					for ( k=0, kLen=columns.length ; k<kLen ; k++ )
					{
						if ( aTargets[j] == "_all" ||
						     $(columns[k].nTh).hasClass( aTargets[j] ) )
						{
							fn( k, def );
						}
					}
				}
			}
		}
	}

	// Statically defined columns array
	if ( aoCols )
	{
		for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
		{
			fn( i, aoCols[i] );
		}
	}
}

/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a Javascript source, rather than a
 * DOM source.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aData data array to be added
 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */
function _fnAddData ( oSettings, aDataIn, nTr, anTds )
{
	/* Create the object for storing information about this new row */
	var iRow = oSettings.aoData.length;
	var oData = $.extend( true, {}, DataTable.models.oRow, {
		src: nTr ? 'dom' : 'data',
		idx: iRow
	} );

	oData._aData = aDataIn;
	oSettings.aoData.push( oData );

	/* Create the cells */
	var nTd, sThisType;
	var columns = oSettings.aoColumns;

	// Invalidate the column types as the new data needs to be revalidated
	for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
	{
		columns[i].sType = null;
	}

	/* Add to the display array */
	oSettings.aiDisplayMaster.push( iRow );

	var id = oSettings.rowIdFn( aDataIn );
	if ( id !== undefined ) {
		oSettings.aIds[ id ] = oData;
	}

	/* Create the DOM information, or register it if already present */
	if ( nTr || ! oSettings.oFeatures.bDeferRender )
	{
		_fnCreateTr( oSettings, iRow, nTr, anTds );
	}

	return iRow;
}


/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */
function _fnAddTr( settings, trs )
{
	var row;

	// Allow an individual node to be passed in
	if ( ! (trs instanceof $) ) {
		trs = $(trs);
	}

	return trs.map( function (i, el) {
		row = _fnGetRowElements( settings, el );
		return _fnAddData( settings, row.data, el, row.cells );
	} );
}


/**
 * Take a TR element and convert it to an index in aoData
 *  @param {object} oSettings dataTables settings object
 *  @param {node} n the TR element to find
 *  @returns {int} index if the node is found, null if not
 *  @memberof DataTable#oApi
 */
function _fnNodeToDataIndex( oSettings, n )
{
	return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
}


/**
 * Take a TD element and convert it into a column data index (not the visible index)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow The row number the TD/TH can be found in
 *  @param {node} n The TD/TH element to find
 *  @returns {int} index if the node is found, -1 if not
 *  @memberof DataTable#oApi
 */
function _fnNodeToColumnIndex( oSettings, iRow, n )
{
	return $.inArray( n, oSettings.aoData[ iRow ].anCells );
}


/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */
function _fnGetCellData( settings, rowIdx, colIdx, type )
{
	if (type === 'search') {
		type = 'filter';
	}
	else if (type === 'order') {
		type = 'sort';
	}

	var draw           = settings.iDraw;
	var col            = settings.aoColumns[colIdx];
	var rowData        = settings.aoData[rowIdx]._aData;
	var defaultContent = col.sDefaultContent;
	var cellData       = col.fnGetData( rowData, type, {
		settings: settings,
		row:      rowIdx,
		col:      colIdx
	} );

	if ( cellData === undefined ) {
		if ( settings.iDrawError != draw && defaultContent === null ) {
			_fnLog( settings, 0, "Requested unknown parameter "+
				(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
				" for row "+rowIdx+", column "+colIdx, 4 );
			settings.iDrawError = draw;
		}
		return defaultContent;
	}

	// When the data source is null and a specific data type is requested (i.e.
	// not the original data), we can use default column data
	if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
		cellData = defaultContent;
	}
	else if ( typeof cellData === 'function' ) {
		// If the data source is a function, then we run it and use the return,
		// executing in the scope of the data object (for instances)
		return cellData.call( rowData );
	}

	if ( cellData === null && type === 'display' ) {
		return '';
	}

	if ( type === 'filter' ) {
		var fomatters = DataTable.ext.type.search;

		if ( fomatters[ col.sType ] ) {
			cellData = fomatters[ col.sType ]( cellData );
		}
	}

	return cellData;
}


/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */
function _fnSetCellData( settings, rowIdx, colIdx, val )
{
	var col     = settings.aoColumns[colIdx];
	var rowData = settings.aoData[rowIdx]._aData;

	col.fnSetData( rowData, val, {
		settings: settings,
		row:      rowIdx,
		col:      colIdx
	}  );
}


// Private variable that is used to match action syntax in the data property object
var __reArray = /\[.*?\]$/;
var __reFn = /\(\)$/;

/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */
function _fnSplitObjNotation( str )
{
	return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
		return s.replace(/\\\./g, '.');
	} );
}


/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */
var _fnGetObjectDataFn = DataTable.util.get;


/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */
var _fnSetObjectDataFn = DataTable.util.set;


/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */
function _fnGetDataMaster ( settings )
{
	return _pluck( settings.aoData, '_aData' );
}


/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnClearTable( settings )
{
	settings.aoData.length = 0;
	settings.aiDisplayMaster.length = 0;
	settings.aiDisplay.length = 0;
	settings.aIds = {};
}


 /**
 * Take an array of integers (index array) and remove a target integer (value - not
 * the key!)
 *  @param {array} a Index array to target
 *  @param {int} iTarget value to find
 *  @memberof DataTable#oApi
 */
function _fnDeleteIndex( a, iTarget, splice )
{
	var iTargetIndex = -1;

	for ( var i=0, iLen=a.length ; i<iLen ; i++ )
	{
		if ( a[i] == iTarget )
		{
			iTargetIndex = i;
		}
		else if ( a[i] > iTarget )
		{
			a[i]--;
		}
	}

	if ( iTargetIndex != -1 && splice === undefined )
	{
		a.splice( iTargetIndex, 1 );
	}
}


/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */
function _fnInvalidate( settings, rowIdx, src, colIdx )
{
	var row = settings.aoData[ rowIdx ];
	var i, ien;
	var cellWrite = function ( cell, col ) {
		// This is very frustrating, but in IE if you just write directly
		// to innerHTML, and elements that are overwritten are GC'ed,
		// even if there is a reference to them elsewhere
		while ( cell.childNodes.length ) {
			cell.removeChild( cell.firstChild );
		}

		cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
	};

	// Are we reading last data from DOM or the data object?
	if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
		// Read the data from the DOM
		row._aData = _fnGetRowElements(
				settings, row, colIdx, colIdx === undefined ? undefined : row._aData
			)
			.data;
	}
	else {
		// Reading from data object, update the DOM
		var cells = row.anCells;

		if ( cells ) {
			if ( colIdx !== undefined ) {
				cellWrite( cells[colIdx], colIdx );
			}
			else {
				for ( i=0, ien=cells.length ; i<ien ; i++ ) {
					cellWrite( cells[i], i );
				}
			}
		}
	}

	// For both row and cell invalidation, the cached data for sorting and
	// filtering is nulled out
	row._aSortData = null;
	row._aFilterData = null;

	// Invalidate the type for a specific column (if given) or all columns since
	// the data might have changed
	var cols = settings.aoColumns;
	if ( colIdx !== undefined ) {
		cols[ colIdx ].sType = null;
	}
	else {
		for ( i=0, ien=cols.length ; i<ien ; i++ ) {
			cols[i].sType = null;
		}

		// Update DataTables special `DT_*` attributes for the row
		_fnRowAttributes( settings, row );
	}
}


/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */
function _fnGetRowElements( settings, row, colIdx, d )
{
	var
		tds = [],
		td = row.firstChild,
		name, col, o, i=0, contents,
		columns = settings.aoColumns,
		objectRead = settings._rowReadObject;

	// Allow the data object to be passed in, or construct
	d = d !== undefined ?
		d :
		objectRead ?
			{} :
			[];

	var attr = function ( str, td  ) {
		if ( typeof str === 'string' ) {
			var idx = str.indexOf('@');

			if ( idx !== -1 ) {
				var attr = str.substring( idx+1 );
				var setter = _fnSetObjectDataFn( str );
				setter( d, td.getAttribute( attr ) );
			}
		}
	};

	// Read data from a cell and store into the data object
	var cellProcess = function ( cell ) {
		if ( colIdx === undefined || colIdx === i ) {
			col = columns[i];
			contents = (cell.innerHTML).trim();

			if ( col && col._bAttrSrc ) {
				var setter = _fnSetObjectDataFn( col.mData._ );
				setter( d, contents );

				attr( col.mData.sort, cell );
				attr( col.mData.type, cell );
				attr( col.mData.filter, cell );
			}
			else {
				// Depending on the `data` option for the columns the data can
				// be read to either an object or an array.
				if ( objectRead ) {
					if ( ! col._setter ) {
						// Cache the setter function
						col._setter = _fnSetObjectDataFn( col.mData );
					}
					col._setter( d, contents );
				}
				else {
					d[i] = contents;
				}
			}
		}

		i++;
	};

	if ( td ) {
		// `tr` element was passed in
		while ( td ) {
			name = td.nodeName.toUpperCase();

			if ( name == "TD" || name == "TH" ) {
				cellProcess( td );
				tds.push( td );
			}

			td = td.nextSibling;
		}
	}
	else {
		// Existing row object passed in
		tds = row.anCells;

		for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
			cellProcess( tds[j] );
		}
	}

	// Read the ID from the DOM if present
	var rowNode = row.firstChild ? row : row.nTr;

	if ( rowNode ) {
		var id = rowNode.getAttribute( 'id' );

		if ( id ) {
			_fnSetObjectDataFn( settings.rowId )( d, id );
		}
	}

	return {
		data: d,
		cells: tds
	};
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */
function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
{
	var
		row = oSettings.aoData[iRow],
		rowData = row._aData,
		cells = [],
		nTr, nTd, oCol,
		i, iLen, create;

	if ( row.nTr === null )
	{
		nTr = nTrIn || document.createElement('tr');

		row.nTr = nTr;
		row.anCells = cells;

		/* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */
		nTr._DT_RowIndex = iRow;

		/* Special parameters can be given by the data source to be used on the row */
		_fnRowAttributes( oSettings, row );

		/* Process each column */
		for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
		{
			oCol = oSettings.aoColumns[i];
			create = nTrIn ? false : true;

			nTd = create ? document.createElement( oCol.sCellType ) : anTds[i];

			if (! nTd) {
				_fnLog( oSettings, 0, 'Incorrect column count', 18 );
			}

			nTd._DT_CellIndex = {
				row: iRow,
				column: i
			};
			
			cells.push( nTd );

			// Need to create the HTML if new, or if a rendering function is defined
			if ( create || ((oCol.mRender || oCol.mData !== i) &&
				 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
			)) {
				nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
			}

			/* Add user defined class */
			if ( oCol.sClass )
			{
				nTd.className += ' '+oCol.sClass;
			}

			// Visibility - add or remove as required
			if ( oCol.bVisible && ! nTrIn )
			{
				nTr.appendChild( nTd );
			}
			else if ( ! oCol.bVisible && nTrIn )
			{
				nTd.parentNode.removeChild( nTd );
			}

			if ( oCol.fnCreatedCell )
			{
				oCol.fnCreatedCell.call( oSettings.oInstance,
					nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
				);
			}
		}

		_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow, cells] );
	}
}


/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */
function _fnRowAttributes( settings, row )
{
	var tr = row.nTr;
	var data = row._aData;

	if ( tr ) {
		var id = settings.rowIdFn( data );

		if ( id ) {
			tr.id = id;
		}

		if ( data.DT_RowClass ) {
			// Remove any classes added by DT_RowClass before
			var a = data.DT_RowClass.split(' ');
			row.__rowc = row.__rowc ?
				_unique( row.__rowc.concat( a ) ) :
				a;

			$(tr)
				.removeClass( row.__rowc.join(' ') )
				.addClass( data.DT_RowClass );
		}

		if ( data.DT_RowAttr ) {
			$(tr).attr( data.DT_RowAttr );
		}

		if ( data.DT_RowData ) {
			$(tr).data( data.DT_RowData );
		}
	}
}


/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnBuildHead( oSettings )
{
	var i, ien, cell, row, column;
	var thead = oSettings.nTHead;
	var tfoot = oSettings.nTFoot;
	var createHeader = $('th, td', thead).length === 0;
	var classes = oSettings.oClasses;
	var columns = oSettings.aoColumns;

	if ( createHeader ) {
		row = $('<tr/>').appendTo( thead );
	}

	for ( i=0, ien=columns.length ; i<ien ; i++ ) {
		column = columns[i];
		cell = $( column.nTh ).addClass( column.sClass );

		if ( createHeader ) {
			cell.appendTo( row );
		}

		// 1.11 move into sorting
		if ( oSettings.oFeatures.bSort ) {
			cell.addClass( column.sSortingClass );

			if ( column.bSortable !== false ) {
				cell
					.attr( 'tabindex', oSettings.iTabIndex )
					.attr( 'aria-controls', oSettings.sTableId );

				_fnSortAttachListener( oSettings, column.nTh, i );
			}
		}

		if ( column.sTitle != cell[0].innerHTML ) {
			cell.html( column.sTitle );
		}

		_fnRenderer( oSettings, 'header' )(
			oSettings, cell, column, classes
		);
	}

	if ( createHeader ) {
		_fnDetectHeader( oSettings.aoHeader, thead );
	}

	/* Deal with the footer - add classes if required */
	$(thead).children('tr').children('th, td').addClass( classes.sHeaderTH );
	$(tfoot).children('tr').children('th, td').addClass( classes.sFooterTH );

	// Cache the footer cells. Note that we only take the cells from the first
	// row in the footer. If there is more than one row the user wants to
	// interact with, they need to use the table().foot() method. Note also this
	// allows cells to be used for multiple columns using colspan
	if ( tfoot !== null ) {
		var cells = oSettings.aoFooter[0];

		for ( i=0, ien=cells.length ; i<ien ; i++ ) {
			column = columns[i];

			if (column) {
				column.nTf = cells[i].cell;
	
				if ( column.sClass ) {
					$(column.nTf).addClass( column.sClass );
				}
			}
			else {
				_fnLog( oSettings, 0, 'Incorrect column count', 18 );
			}
		}
	}
}


/**
 * Draw the header (or footer) element based on the column visibility states. The
 * methodology here is to use the layout array from _fnDetectHeader, modified for
 * the instantaneous column visibility, to construct the new layout. The grid is
 * traversed over cell at a time in a rows x columns grid fashion, although each
 * cell insert can cover multiple elements in the grid - which is tracks using the
 * aApplied array. Cell inserts in the grid will only occur where there isn't
 * already a cell in that position.
 *  @param {object} oSettings dataTables settings object
 *  @param array {objects} aoSource Layout array from _fnDetectHeader
 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
 *  @memberof DataTable#oApi
 */
function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
{
	var i, iLen, j, jLen, k, kLen, n, nLocalTr;
	var aoLocal = [];
	var aApplied = [];
	var iColumns = oSettings.aoColumns.length;
	var iRowspan, iColspan;

	if ( ! aoSource )
	{
		return;
	}

	if (  bIncludeHidden === undefined )
	{
		bIncludeHidden = false;
	}

	/* Make a copy of the master layout array, but without the visible columns in it */
	for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
	{
		aoLocal[i] = aoSource[i].slice();
		aoLocal[i].nTr = aoSource[i].nTr;

		/* Remove any columns which are currently hidden */
		for ( j=iColumns-1 ; j>=0 ; j-- )
		{
			if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
			{
				aoLocal[i].splice( j, 1 );
			}
		}

		/* Prep the applied array - it needs an element for each row */
		aApplied.push( [] );
	}

	for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
	{
		nLocalTr = aoLocal[i].nTr;

		/* All cells are going to be replaced, so empty out the row */
		if ( nLocalTr )
		{
			while( (n = nLocalTr.firstChild) )
			{
				nLocalTr.removeChild( n );
			}
		}

		for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
		{
			iRowspan = 1;
			iColspan = 1;

			/* Check to see if there is already a cell (row/colspan) covering our target
			 * insert point. If there is, then there is nothing to do.
			 */
			if ( aApplied[i][j] === undefined )
			{
				nLocalTr.appendChild( aoLocal[i][j].cell );
				aApplied[i][j] = 1;

				/* Expand the cell to cover as many rows as needed */
				while ( aoLocal[i+iRowspan] !== undefined &&
				        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
				{
					aApplied[i+iRowspan][j] = 1;
					iRowspan++;
				}

				/* Expand the cell to cover as many columns as needed */
				while ( aoLocal[i][j+iColspan] !== undefined &&
				        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
				{
					/* Must update the applied array over the rows for the columns */
					for ( k=0 ; k<iRowspan ; k++ )
					{
						aApplied[i+k][j+iColspan] = 1;
					}
					iColspan++;
				}

				/* Do the actual expansion in the DOM */
				$(aoLocal[i][j].cell)
					.attr('rowspan', iRowspan)
					.attr('colspan', iColspan);
			}
		}
	}
}


/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */
function _fnDraw( oSettings, ajaxComplete )
{
	// Allow for state saving and a custom start position
	_fnStart( oSettings );

	/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
	var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
	if ( $.inArray( false, aPreDraw ) !== -1 )
	{
		_fnProcessingDisplay( oSettings, false );
		return;
	}

	var anRows = [];
	var iRowCount = 0;
	var asStripeClasses = oSettings.asStripeClasses;
	var iStripes = asStripeClasses.length;
	var oLang = oSettings.oLanguage;
	var bServerSide = _fnDataSource( oSettings ) == 'ssp';
	var aiDisplay = oSettings.aiDisplay;
	var iDisplayStart = oSettings._iDisplayStart;
	var iDisplayEnd = oSettings.fnDisplayEnd();

	oSettings.bDrawing = true;

	/* Server-side processing draw intercept */
	if ( oSettings.bDeferLoading )
	{
		oSettings.bDeferLoading = false;
		oSettings.iDraw++;
		_fnProcessingDisplay( oSettings, false );
	}
	else if ( !bServerSide )
	{
		oSettings.iDraw++;
	}
	else if ( !oSettings.bDestroying && !ajaxComplete)
	{
		_fnAjaxUpdate( oSettings );
		return;
	}

	if ( aiDisplay.length !== 0 )
	{
		var iStart = bServerSide ? 0 : iDisplayStart;
		var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;

		for ( var j=iStart ; j<iEnd ; j++ )
		{
			var iDataIndex = aiDisplay[j];
			var aoData = oSettings.aoData[ iDataIndex ];
			if ( aoData.nTr === null )
			{
				_fnCreateTr( oSettings, iDataIndex );
			}

			var nRow = aoData.nTr;

			/* Remove the old striping classes and then add the new one */
			if ( iStripes !== 0 )
			{
				var sStripe = asStripeClasses[ iRowCount % iStripes ];
				if ( aoData._sRowStripe != sStripe )
				{
					$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
					aoData._sRowStripe = sStripe;
				}
			}

			// Row callback functions - might want to manipulate the row
			// iRowCount and j are not currently documented. Are they at all
			// useful?
			_fnCallbackFire( oSettings, 'aoRowCallback', null,
				[nRow, aoData._aData, iRowCount, j, iDataIndex] );

			anRows.push( nRow );
			iRowCount++;
		}
	}
	else
	{
		/* Table is empty - create a row with an empty message in it */
		var sZero = oLang.sZeroRecords;
		if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
		{
			sZero = oLang.sLoadingRecords;
		}
		else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
		{
			sZero = oLang.sEmptyTable;
		}

		anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
			.append( $('<td />', {
				'valign':  'top',
				'colSpan': _fnVisbleColumns( oSettings ),
				'class':   oSettings.oClasses.sRowEmpty
			} ).html( sZero ) )[0];
	}

	/* Header and footer callbacks */
	_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
		_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );

	_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
		_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );

	var body = $(oSettings.nTBody);

	body.children().detach();
	body.append( $(anRows) );

	/* Call all required callback functions for the end of a draw */
	_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );

	/* Draw is complete, sorting and filtering must be as well */
	oSettings.bSorted = false;
	oSettings.bFiltered = false;
	oSettings.bDrawing = false;
}


/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */
function _fnReDraw( settings, holdPosition )
{
	var
		features = settings.oFeatures,
		sort     = features.bSort,
		filter   = features.bFilter;

	if ( sort ) {
		_fnSort( settings );
	}

	if ( filter ) {
		_fnFilterComplete( settings, settings.oPreviousSearch );
	}
	else {
		// No filtering, so we want to just use the display master
		settings.aiDisplay = settings.aiDisplayMaster.slice();
	}

	if ( holdPosition !== true ) {
		settings._iDisplayStart = 0;
	}

	// Let any modules know about the draw hold position state (used by
	// scrolling internally)
	settings._drawHold = holdPosition;

	_fnDraw( settings );

	settings._drawHold = false;
}


/**
 * Add the options to the page HTML for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnAddOptionsHtml ( oSettings )
{
	var classes = oSettings.oClasses;
	var table = $(oSettings.nTable);
	var holding = $('<div/>').insertBefore( table ); // Holding element for speed
	var features = oSettings.oFeatures;

	// All DataTables are wrapped in a div
	var insert = $('<div/>', {
		id:      oSettings.sTableId+'_wrapper',
		'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
	} );

	oSettings.nHolding = holding[0];
	oSettings.nTableWrapper = insert[0];
	oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;

	/* Loop over the user set positioning and place the elements as needed */
	var aDom = oSettings.sDom.split('');
	var featureNode, cOption, nNewNode, cNext, sAttr, j;
	for ( var i=0 ; i<aDom.length ; i++ )
	{
		featureNode = null;
		cOption = aDom[i];

		if ( cOption == '<' )
		{
			/* New container div */
			nNewNode = $('<div/>')[0];

			/* Check to see if we should append an id and/or a class name to the container */
			cNext = aDom[i+1];
			if ( cNext == "'" || cNext == '"' )
			{
				sAttr = "";
				j = 2;
				while ( aDom[i+j] != cNext )
				{
					sAttr += aDom[i+j];
					j++;
				}

				/* Replace jQuery UI constants @todo depreciated */
				if ( sAttr == "H" )
				{
					sAttr = classes.sJUIHeader;
				}
				else if ( sAttr == "F" )
				{
					sAttr = classes.sJUIFooter;
				}

				/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */
				if ( sAttr.indexOf('.') != -1 )
				{
					var aSplit = sAttr.split('.');
					nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
					nNewNode.className = aSplit[1];
				}
				else if ( sAttr.charAt(0) == "#" )
				{
					nNewNode.id = sAttr.substr(1, sAttr.length-1);
				}
				else
				{
					nNewNode.className = sAttr;
				}

				i += j; /* Move along the position array */
			}

			insert.append( nNewNode );
			insert = $(nNewNode);
		}
		else if ( cOption == '>' )
		{
			/* End container div */
			insert = insert.parent();
		}
		// @todo Move options into their own plugins?
		else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
		{
			/* Length */
			featureNode = _fnFeatureHtmlLength( oSettings );
		}
		else if ( cOption == 'f' && features.bFilter )
		{
			/* Filter */
			featureNode = _fnFeatureHtmlFilter( oSettings );
		}
		else if ( cOption == 'r' && features.bProcessing )
		{
			/* pRocessing */
			featureNode = _fnFeatureHtmlProcessing( oSettings );
		}
		else if ( cOption == 't' )
		{
			/* Table */
			featureNode = _fnFeatureHtmlTable( oSettings );
		}
		else if ( cOption ==  'i' && features.bInfo )
		{
			/* Info */
			featureNode = _fnFeatureHtmlInfo( oSettings );
		}
		else if ( cOption == 'p' && features.bPaginate )
		{
			/* Pagination */
			featureNode = _fnFeatureHtmlPaginate( oSettings );
		}
		else if ( DataTable.ext.feature.length !== 0 )
		{
			/* Plug-in features */
			var aoFeatures = DataTable.ext.feature;
			for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
			{
				if ( cOption == aoFeatures[k].cFeature )
				{
					featureNode = aoFeatures[k].fnInit( oSettings );
					break;
				}
			}
		}

		/* Add to the 2D features array */
		if ( featureNode )
		{
			var aanFeatures = oSettings.aanFeatures;

			if ( ! aanFeatures[cOption] )
			{
				aanFeatures[cOption] = [];
			}

			aanFeatures[cOption].push( featureNode );
			insert.append( featureNode );
		}
	}

	/* Built our DOM structure - replace the holding div with what we want */
	holding.replaceWith( insert );
	oSettings.nHolding = null;
}


/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell that that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param array {object} aLayout Array to store the calculated layout in
 *  @param {node} nThead The header/footer element for the table
 *  @memberof DataTable#oApi
 */
function _fnDetectHeader ( aLayout, nThead )
{
	var nTrs = $(nThead).children('tr');
	var nTr, nCell;
	var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
	var bUnique;
	var fnShiftCol = function ( a, i, j ) {
		var k = a[i];
                while ( k[j] ) {
			j++;
		}
		return j;
	};

	aLayout.splice( 0, aLayout.length );

	/* We know how many rows there are in the layout - so prep it */
	for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
	{
		aLayout.push( [] );
	}

	/* Calculate a layout array */
	for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
	{
		nTr = nTrs[i];
		iColumn = 0;

		/* For every cell in the row... */
		nCell = nTr.firstChild;
		while ( nCell ) {
			if ( nCell.nodeName.toUpperCase() == "TD" ||
			     nCell.nodeName.toUpperCase() == "TH" )
			{
				/* Get the col and rowspan attributes from the DOM and sanitise them */
				iColspan = nCell.getAttribute('colspan') * 1;
				iRowspan = nCell.getAttribute('rowspan') * 1;
				iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
				iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;

				/* There might be colspan cells already in this row, so shift our target
				 * accordingly
				 */
				iColShifted = fnShiftCol( aLayout, i, iColumn );

				/* Cache calculation for unique columns */
				bUnique = iColspan === 1 ? true : false;

				/* If there is col / rowspan, copy the information into the layout grid */
				for ( l=0 ; l<iColspan ; l++ )
				{
					for ( k=0 ; k<iRowspan ; k++ )
					{
						aLayout[i+k][iColShifted+l] = {
							"cell": nCell,
							"unique": bUnique
						};
						aLayout[i+k].nTr = nTr;
					}
				}
			}
			nCell = nCell.nextSibling;
		}
	}
}


/**
 * Get an array of unique th elements, one for each column
 *  @param {object} oSettings dataTables settings object
 *  @param {node} nHeader automatically detect the layout from this node - optional
 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
 *  @returns array {node} aReturn list of unique th's
 *  @memberof DataTable#oApi
 */
function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
{
	var aReturn = [];
	if ( !aLayout )
	{
		aLayout = oSettings.aoHeader;
		if ( nHeader )
		{
			aLayout = [];
			_fnDetectHeader( aLayout, nHeader );
		}
	}

	for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
	{
		for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
		{
			if ( aLayout[i][j].unique &&
				 (!aReturn[j] || !oSettings.bSortCellsTop) )
			{
				aReturn[j] = aLayout[i][j].cell;
			}
		}
	}

	return aReturn;
}

/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */
function _fnStart( oSettings )
{
	var bServerSide = _fnDataSource( oSettings ) == 'ssp';
	var iInitDisplayStart = oSettings.iInitDisplayStart;

	// Check and see if we have an initial draw position from state saving
	if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
	{
		oSettings._iDisplayStart = bServerSide ?
			iInitDisplayStart :
			iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
				0 :
				iInitDisplayStart;

		oSettings.iInitDisplayStart = -1;
	}
}

/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */
function _fnBuildAjax( oSettings, data, fn )
{
	// Compatibility with 1.9-, allow fnServerData and event to manipulate
	_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );

	// Convert to object based for 1.10+ if using the old array scheme which can
	// come from server-side processing or serverParams
	if ( data && Array.isArray(data) ) {
		var tmp = {};
		var rbracket = /(.*?)\[\]$/;

		$.each( data, function (key, val) {
			var match = val.name.match(rbracket);

			if ( match ) {
				// Support for arrays
				var name = match[0];

				if ( ! tmp[ name ] ) {
					tmp[ name ] = [];
				}
				tmp[ name ].push( val.value );
			}
			else {
				tmp[val.name] = val.value;
			}
		} );
		data = tmp;
	}

	var ajaxData;
	var ajax = oSettings.ajax;
	var instance = oSettings.oInstance;
	var callback = function ( json ) {
		var status = oSettings.jqXHR
			? oSettings.jqXHR.status
			: null;

		if ( json === null || (typeof status === 'number' && status == 204 ) ) {
			json = {};
			_fnAjaxDataSrc( oSettings, json, [] );
		}

		var error = json.error || json.sError;
		if ( error ) {
			_fnLog( oSettings, 0, error );
		}

		oSettings.json = json;

		_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
		fn( json );
	};

	if ( $.isPlainObject( ajax ) && ajax.data )
	{
		ajaxData = ajax.data;

		var newData = typeof ajaxData === 'function' ?
			ajaxData( data, oSettings ) :  // fn can manipulate data or return
			ajaxData;                      // an object object or array to merge

		// If the function returned something, use that alone
		data = typeof ajaxData === 'function' && newData ?
			newData :
			$.extend( true, data, newData );

		// Remove the data property as we've resolved it already and don't want
		// jQuery to do it again (it is restored at the end of the function)
		delete ajax.data;
	}

	var baseAjax = {
		"data": data,
		"success": callback,
		"dataType": "json",
		"cache": false,
		"type": oSettings.sServerMethod,
		"error": function (xhr, error, thrown) {
			var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );

			if ( $.inArray( true, ret ) === -1 ) {
				if ( error == "parsererror" ) {
					_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
				}
				else if ( xhr.readyState === 4 ) {
					_fnLog( oSettings, 0, 'Ajax error', 7 );
				}
			}

			_fnProcessingDisplay( oSettings, false );
		}
	};

	// Store the data submitted for the API
	oSettings.oAjaxData = data;

	// Allow plug-ins and external processes to modify the data
	_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );

	if ( oSettings.fnServerData )
	{
		// DataTables 1.9- compatibility
		oSettings.fnServerData.call( instance,
			oSettings.sAjaxSource,
			$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
				return { name: key, value: val };
			} ),
			callback,
			oSettings
		);
	}
	else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
	{
		// DataTables 1.9- compatibility
		oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
			url: ajax || oSettings.sAjaxSource
		} ) );
	}
	else if ( typeof ajax === 'function' )
	{
		// Is a function - let the caller define what needs to be done
		oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
	}
	else
	{
		// Object to extend the base settings
		oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );

		// Restore for next time around
		ajax.data = ajaxData;
	}
}


/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */
function _fnAjaxUpdate( settings )
{
	settings.iDraw++;
	_fnProcessingDisplay( settings, true );

	// Keep track of drawHold state to handle scrolling after the Ajax call
	var drawHold = settings._drawHold;

	_fnBuildAjax(
		settings,
		_fnAjaxParameters( settings ),
		function(json) {
			settings._drawHold = drawHold;
			_fnAjaxUpdateDraw( settings, json );
			settings._drawHold = false;
		}
	);
}


/**
 * Build up the parameters in an object needed for a server-side processing
 * request. Note that this is basically done twice, is different ways - a modern
 * method which is used by default in DataTables 1.10 which uses objects and
 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
 * the sAjaxSource option is used in the initialisation, or the legacyAjax
 * option is set.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */
function _fnAjaxParameters( settings )
{
	var
		columns = settings.aoColumns,
		columnCount = columns.length,
		features = settings.oFeatures,
		preSearch = settings.oPreviousSearch,
		preColSearch = settings.aoPreSearchCols,
		i, data = [], dataProp, column, columnSearch,
		sort = _fnSortFlatten( settings ),
		displayStart = settings._iDisplayStart,
		displayLength = features.bPaginate !== false ?
			settings._iDisplayLength :
			-1;

	var param = function ( name, value ) {
		data.push( { 'name': name, 'value': value } );
	};

	// DataTables 1.9- compatible method
	param( 'sEcho',          settings.iDraw );
	param( 'iColumns',       columnCount );
	param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
	param( 'iDisplayStart',  displayStart );
	param( 'iDisplayLength', displayLength );

	// DataTables 1.10+ method
	var d = {
		draw:    settings.iDraw,
		columns: [],
		order:   [],
		start:   displayStart,
		length:  displayLength,
		search:  {
			value: preSearch.sSearch,
			regex: preSearch.bRegex
		}
	};

	for ( i=0 ; i<columnCount ; i++ ) {
		column = columns[i];
		columnSearch = preColSearch[i];
		dataProp = typeof column.mData=="function" ? 'function' : column.mData ;

		d.columns.push( {
			data:       dataProp,
			name:       column.sName,
			searchable: column.bSearchable,
			orderable:  column.bSortable,
			search:     {
				value: columnSearch.sSearch,
				regex: columnSearch.bRegex
			}
		} );

		param( "mDataProp_"+i, dataProp );

		if ( features.bFilter ) {
			param( 'sSearch_'+i,     columnSearch.sSearch );
			param( 'bRegex_'+i,      columnSearch.bRegex );
			param( 'bSearchable_'+i, column.bSearchable );
		}

		if ( features.bSort ) {
			param( 'bSortable_'+i, column.bSortable );
		}
	}

	if ( features.bFilter ) {
		param( 'sSearch', preSearch.sSearch );
		param( 'bRegex', preSearch.bRegex );
	}

	if ( features.bSort ) {
		$.each( sort, function ( i, val ) {
			d.order.push( { column: val.col, dir: val.dir } );

			param( 'iSortCol_'+i, val.col );
			param( 'sSortDir_'+i, val.dir );
		} );

		param( 'iSortingCols', sort.length );
	}

	// If the legacy.ajax parameter is null, then we automatically decide which
	// form to use, based on sAjaxSource
	var legacy = DataTable.ext.legacy.ajax;
	if ( legacy === null ) {
		return settings.sAjaxSource ? data : d;
	}

	// Otherwise, if legacy has been specified then we use that to decide on the
	// form
	return legacy ? data : d;
}


/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */
function _fnAjaxUpdateDraw ( settings, json )
{
	// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
	// Support both
	var compat = function ( old, modern ) {
		return json[old] !== undefined ? json[old] : json[modern];
	};

	var data = _fnAjaxDataSrc( settings, json );
	var draw            = compat( 'sEcho',                'draw' );
	var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
	var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );

	if ( draw !== undefined ) {
		// Protect against out of sequence returns
		if ( draw*1 < settings.iDraw ) {
			return;
		}
		settings.iDraw = draw * 1;
	}

	// No data in returned object, so rather than an array, we show an empty table
	if ( ! data ) {
		data = [];
	}

	_fnClearTable( settings );
	settings._iRecordsTotal   = parseInt(recordsTotal, 10);
	settings._iRecordsDisplay = parseInt(recordsFiltered, 10);

	for ( var i=0, ien=data.length ; i<ien ; i++ ) {
		_fnAddData( settings, data[i] );
	}
	settings.aiDisplay = settings.aiDisplayMaster.slice();

	_fnDraw( settings, true );

	if ( ! settings._bInitComplete ) {
		_fnInitComplete( settings, json );
	}

	_fnProcessingDisplay( settings, false );
}


/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} oSettings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */
 function _fnAjaxDataSrc ( oSettings, json, write )
 {
	var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
		oSettings.ajax.dataSrc :
		oSettings.sAjaxDataProp; // Compatibility with 1.9-.

	if ( ! write ) {
		if ( dataSrc === 'data' ) {
			// If the default, then we still want to support the old style, and safely ignore
			// it if possible
			return json.aaData || json[dataSrc];
		}

		return dataSrc !== "" ?
			_fnGetObjectDataFn( dataSrc )( json ) :
			json;
	}

	// set
	_fnSetObjectDataFn( dataSrc )( json, write );
}

/**
 * Generate the node required for filtering text
 *  @returns {node} Filter control element
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlFilter ( settings )
{
	var classes = settings.oClasses;
	var tableId = settings.sTableId;
	var language = settings.oLanguage;
	var previousSearch = settings.oPreviousSearch;
	var features = settings.aanFeatures;
	var input = '<input type="search" class="'+classes.sFilterInput+'"/>';

	var str = language.sSearch;
	str = str.match(/_INPUT_/) ?
		str.replace('_INPUT_', input) :
		str+input;

	var filter = $('<div/>', {
			'id': ! features.f ? tableId+'_filter' : null,
			'class': classes.sFilter
		} )
		.append( $('<label/>' ).append( str ) );

	var searchFn = function(event) {
		/* Update all other filter input elements for the new display */
		var n = features.f;
		var val = !this.value ? "" : this.value; // mental IE8 fix :-(
		if(previousSearch['return'] && event.key !== "Enter") {
			return;
		}
		/* Now do the filter */
		if ( val != previousSearch.sSearch ) {
			_fnFilterComplete( settings, {
				"sSearch": val,
				"bRegex": previousSearch.bRegex,
				"bSmart": previousSearch.bSmart ,
				"bCaseInsensitive": previousSearch.bCaseInsensitive,
				"return": previousSearch['return']
			} );

			// Need to redraw, without resorting
			settings._iDisplayStart = 0;
			_fnDraw( settings );
		}
	};

	var searchDelay = settings.searchDelay !== null ?
		settings.searchDelay :
		_fnDataSource( settings ) === 'ssp' ?
			400 :
			0;

	var jqFilter = $('input', filter)
		.val( previousSearch.sSearch )
		.attr( 'placeholder', language.sSearchPlaceholder )
		.on(
			'keyup.DT search.DT input.DT paste.DT cut.DT',
			searchDelay ?
				_fnThrottle( searchFn, searchDelay ) :
				searchFn
		)
		.on( 'mouseup.DT', function(e) {
			// Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
			// on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
			// checks the value to see if it has changed. In other browsers it won't have.
			setTimeout( function () {
				searchFn.call(jqFilter[0], e);
			}, 10);
		} )
		.on( 'keypress.DT', function(e) {
			/* Prevent form submission */
			if ( e.keyCode == 13 ) {
				return false;
			}
		} )
		.attr('aria-controls', tableId);

	// Update the input elements whenever the table is filtered
	$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
		if ( settings === s ) {
			// IE9 throws an 'unknown error' if document.activeElement is used
			// inside an iframe or frame...
			try {
				if ( jqFilter[0] !== document.activeElement ) {
					jqFilter.val( previousSearch.sSearch );
				}
			}
			catch ( e ) {}
		}
	} );

	return filter[0];
}


/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oSearch search information
 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
 *  @memberof DataTable#oApi
 */
function _fnFilterComplete ( oSettings, oInput, iForce )
{
	var oPrevSearch = oSettings.oPreviousSearch;
	var aoPrevSearch = oSettings.aoPreSearchCols;
	var fnSaveFilter = function ( oFilter ) {
		/* Save the filtering values */
		oPrevSearch.sSearch = oFilter.sSearch;
		oPrevSearch.bRegex = oFilter.bRegex;
		oPrevSearch.bSmart = oFilter.bSmart;
		oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
		oPrevSearch['return'] = oFilter['return'];
	};
	var fnRegex = function ( o ) {
		// Backwards compatibility with the bEscapeRegex option
		return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
	};

	// Resolve any column types that are unknown due to addition or invalidation
	// @todo As per sort - can this be moved into an event handler?
	_fnColumnTypes( oSettings );

	/* In server-side processing all filtering is done by the server, so no point hanging around here */
	if ( _fnDataSource( oSettings ) != 'ssp' )
	{
		/* Global filter */
		_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
		fnSaveFilter( oInput );

		/* Now do the individual column filter */
		for ( var i=0 ; i<aoPrevSearch.length ; i++ )
		{
			_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
				aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
		}

		/* Custom filtering */
		_fnFilterCustom( oSettings );
	}
	else
	{
		fnSaveFilter( oInput );
	}

	/* Tell the draw function we have been filtering */
	oSettings.bFiltered = true;
	_fnCallbackFire( oSettings, null, 'search', [oSettings] );
}


/**
 * Apply custom filtering functions
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnFilterCustom( settings )
{
	var filters = DataTable.ext.search;
	var displayRows = settings.aiDisplay;
	var row, rowIdx;

	for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
		var rows = [];

		// Loop over each row and see if it should be included
		for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
			rowIdx = displayRows[ j ];
			row = settings.aoData[ rowIdx ];

			if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
				rows.push( rowIdx );
			}
		}

		// So the array reference doesn't break set the results into the
		// existing array
		displayRows.length = 0;
		$.merge( displayRows, rows );
	}
}


/**
 * Filter the table on a per-column basis
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sInput string to filter on
 *  @param {int} iColumn column to filter
 *  @param {bool} bRegex treat search string as a regular expression or not
 *  @param {bool} bSmart use smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @memberof DataTable#oApi
 */
function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
{
	if ( searchStr === '' ) {
		return;
	}

	var data;
	var out = [];
	var display = settings.aiDisplay;
	var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );

	for ( var i=0 ; i<display.length ; i++ ) {
		data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];

		if ( rpSearch.test( data ) ) {
			out.push( display[i] );
		}
	}

	settings.aiDisplay = out;
}


/**
 * Filter the data table based on user input and draw the table
 *  @param {object} settings dataTables settings object
 *  @param {string} input string to filter on
 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
 *  @param {bool} regex treat as a regular expression or not
 *  @param {bool} smart perform smart filtering or not
 *  @param {bool} caseInsensitive Do case insensitive matching or not
 *  @memberof DataTable#oApi
 */
function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
{
	var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
	var prevSearch = settings.oPreviousSearch.sSearch;
	var displayMaster = settings.aiDisplayMaster;
	var display, invalidated, i;
	var filtered = [];

	// Need to take account of custom filtering functions - always filter
	if ( DataTable.ext.search.length !== 0 ) {
		force = true;
	}

	// Check if any of the rows were invalidated
	invalidated = _fnFilterData( settings );

	// If the input is blank - we just want the full data set
	if ( input.length <= 0 ) {
		settings.aiDisplay = displayMaster.slice();
	}
	else {
		// New search - start from the master array
		if ( invalidated ||
			 force ||
			 regex ||
			 prevSearch.length > input.length ||
			 input.indexOf(prevSearch) !== 0 ||
			 settings.bSorted // On resort, the display master needs to be
			                  // re-filtered since indexes will have changed
		) {
			settings.aiDisplay = displayMaster.slice();
		}

		// Search the display array
		display = settings.aiDisplay;

		for ( i=0 ; i<display.length ; i++ ) {
			if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
				filtered.push( display[i] );
			}
		}

		settings.aiDisplay = filtered;
	}
}


/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */
function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
{
	search = regex ?
		search :
		_fnEscapeRegex( search );
	
	if ( smart ) {
		/* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. So this is what we want to
		 * generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */
		var a = $.map( search.match( /["\u201C][^"\u201D]+["\u201D]|[^ ]+/g ) || [''], function ( word ) {
			if ( word.charAt(0) === '"' ) {
				var m = word.match( /^"(.*)"$/ );
				word = m ? m[1] : word;
			}
			else if ( word.charAt(0) === '\u201C' ) {
				var m = word.match( /^\u201C(.*)\u201D$/ );
				word = m ? m[1] : word;
			}

			return word.replace('"', '');
		} );

		search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
	}

	return new RegExp( search, caseInsensitive ? 'i' : '' );
}


/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */
var _fnEscapeRegex = DataTable.util.escapeRegex;

var __filter_div = $('<div>')[0];
var __filter_div_textContent = __filter_div.textContent !== undefined;

// Update the filtering data for each row if needed (by invalidation or first run)
function _fnFilterData ( settings )
{
	var columns = settings.aoColumns;
	var column;
	var i, j, ien, jen, filterData, cellData, row;
	var wasInvalidated = false;

	for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
		row = settings.aoData[i];

		if ( ! row._aFilterData ) {
			filterData = [];

			for ( j=0, jen=columns.length ; j<jen ; j++ ) {
				column = columns[j];

				if ( column.bSearchable ) {
					cellData = _fnGetCellData( settings, i, j, 'filter' );

					// Search in DataTables 1.10 is string based. In 1.11 this
					// should be altered to also allow strict type checking.
					if ( cellData === null ) {
						cellData = '';
					}

					if ( typeof cellData !== 'string' && cellData.toString ) {
						cellData = cellData.toString();
					}
				}
				else {
					cellData = '';
				}

				// If it looks like there is an HTML entity in the string,
				// attempt to decode it so sorting works as expected. Note that
				// we could use a single line of jQuery to do this, but the DOM
				// method used here is much faster https://jsperf.com/html-decode
				if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
					__filter_div.innerHTML = cellData;
					cellData = __filter_div_textContent ?
						__filter_div.textContent :
						__filter_div.innerText;
				}

				if ( cellData.replace ) {
					cellData = cellData.replace(/[\r\n\u2028]/g, '');
				}

				filterData.push( cellData );
			}

			row._aFilterData = filterData;
			row._sFilterRow = filterData.join('  ');
			wasInvalidated = true;
		}
	}

	return wasInvalidated;
}


/**
 * Convert from the internal Hungarian notation to camelCase for external
 * interaction
 *  @param {object} obj Object to convert
 *  @returns {object} Inverted object
 *  @memberof DataTable#oApi
 */
function _fnSearchToCamel ( obj )
{
	return {
		search:          obj.sSearch,
		smart:           obj.bSmart,
		regex:           obj.bRegex,
		caseInsensitive: obj.bCaseInsensitive
	};
}



/**
 * Convert from camelCase notation to the internal Hungarian. We could use the
 * Hungarian convert function here, but this is cleaner
 *  @param {object} obj Object to convert
 *  @returns {object} Inverted object
 *  @memberof DataTable#oApi
 */
function _fnSearchToHung ( obj )
{
	return {
		sSearch:          obj.search,
		bSmart:           obj.smart,
		bRegex:           obj.regex,
		bCaseInsensitive: obj.caseInsensitive
	};
}

/**
 * Generate the node required for the info display
 *  @param {object} oSettings dataTables settings object
 *  @returns {node} Information element
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlInfo ( settings )
{
	var
		tid = settings.sTableId,
		nodes = settings.aanFeatures.i,
		n = $('<div/>', {
			'class': settings.oClasses.sInfo,
			'id': ! nodes ? tid+'_info' : null
		} );

	if ( ! nodes ) {
		// Update display on each draw
		settings.aoDrawCallback.push( {
			"fn": _fnUpdateInfo,
			"sName": "information"
		} );

		n
			.attr( 'role', 'status' )
			.attr( 'aria-live', 'polite' );

		// Table is described by our info div
		$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
	}

	return n[0];
}


/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnUpdateInfo ( settings )
{
	/* Show information about the table */
	var nodes = settings.aanFeatures.i;
	if ( nodes.length === 0 ) {
		return;
	}

	var
		lang  = settings.oLanguage,
		start = settings._iDisplayStart+1,
		end   = settings.fnDisplayEnd(),
		max   = settings.fnRecordsTotal(),
		total = settings.fnRecordsDisplay(),
		out   = total ?
			lang.sInfo :
			lang.sInfoEmpty;

	if ( total !== max ) {
		/* Record set after filtering */
		out += ' ' + lang.sInfoFiltered;
	}

	// Convert the macros
	out += lang.sInfoPostFix;
	out = _fnInfoMacros( settings, out );

	var callback = lang.fnInfoCallback;
	if ( callback !== null ) {
		out = callback.call( settings.oInstance,
			settings, start, end, max, total, out
		);
	}

	$(nodes).html( out );
}


function _fnInfoMacros ( settings, str )
{
	// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
	// internally
	var
		formatter  = settings.fnFormatNumber,
		start      = settings._iDisplayStart+1,
		len        = settings._iDisplayLength,
		vis        = settings.fnRecordsDisplay(),
		all        = len === -1;

	return str.
		replace(/_START_/g, formatter.call( settings, start ) ).
		replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
		replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
		replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
		replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
		replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
}



/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnInitialise ( settings )
{
	var i, iLen, iAjaxStart=settings.iInitDisplayStart;
	var columns = settings.aoColumns, column;
	var features = settings.oFeatures;
	var deferLoading = settings.bDeferLoading; // value modified by the draw

	/* Ensure that the table data is fully initialised */
	if ( ! settings.bInitialised ) {
		setTimeout( function(){ _fnInitialise( settings ); }, 200 );
		return;
	}

	/* Show the display HTML options */
	_fnAddOptionsHtml( settings );

	/* Build and draw the header / footer for the table */
	_fnBuildHead( settings );
	_fnDrawHead( settings, settings.aoHeader );
	_fnDrawHead( settings, settings.aoFooter );

	/* Okay to show that something is going on now */
	_fnProcessingDisplay( settings, true );

	/* Calculate sizes for columns */
	if ( features.bAutoWidth ) {
		_fnCalculateColumnWidths( settings );
	}

	for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
		column = columns[i];

		if ( column.sWidth ) {
			column.nTh.style.width = _fnStringToCss( column.sWidth );
		}
	}

	_fnCallbackFire( settings, null, 'preInit', [settings] );

	// If there is default sorting required - let's do it. The sort function
	// will do the drawing for us. Otherwise we draw the table regardless of the
	// Ajax source - this allows the table to look initialised for Ajax sourcing
	// data (show 'loading' message possibly)
	_fnReDraw( settings );

	// Server-side processing init complete is done by _fnAjaxUpdateDraw
	var dataSrc = _fnDataSource( settings );
	if ( dataSrc != 'ssp' || deferLoading ) {
		// if there is an ajax source load the data
		if ( dataSrc == 'ajax' ) {
			_fnBuildAjax( settings, [], function(json) {
				var aData = _fnAjaxDataSrc( settings, json );

				// Got the data - add it to the table
				for ( i=0 ; i<aData.length ; i++ ) {
					_fnAddData( settings, aData[i] );
				}

				// Reset the init display for cookie saving. We've already done
				// a filter, and therefore cleared it before. So we need to make
				// it appear 'fresh'
				settings.iInitDisplayStart = iAjaxStart;

				_fnReDraw( settings );

				_fnProcessingDisplay( settings, false );
				_fnInitComplete( settings, json );
			}, settings );
		}
		else {
			_fnProcessingDisplay( settings, false );
			_fnInitComplete( settings );
		}
	}
}


/**
 * Draw the table for the first time, adding all required features
 *  @param {object} oSettings dataTables settings object
 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
 *    with client-side processing (optional)
 *  @memberof DataTable#oApi
 */
function _fnInitComplete ( settings, json )
{
	settings._bInitComplete = true;

	// When data was added after the initialisation (data or Ajax) we need to
	// calculate the column sizing
	if ( json || settings.oInit.aaData ) {
		_fnAdjustColumnSizing( settings );
	}

	_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
	_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
}


function _fnLengthChange ( settings, val )
{
	var len = parseInt( val, 10 );
	settings._iDisplayLength = len;

	_fnLengthOverflow( settings );

	// Fire length change event
	_fnCallbackFire( settings, null, 'length', [settings, len] );
}


/**
 * Generate the node required for user display length changing
 *  @param {object} settings dataTables settings object
 *  @returns {node} Display length feature node
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlLength ( settings )
{
	var
		classes  = settings.oClasses,
		tableId  = settings.sTableId,
		menu     = settings.aLengthMenu,
		d2       = Array.isArray( menu[0] ),
		lengths  = d2 ? menu[0] : menu,
		language = d2 ? menu[1] : menu;

	var select = $('<select/>', {
		'name':          tableId+'_length',
		'aria-controls': tableId,
		'class':         classes.sLengthSelect
	} );

	for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
		select[0][ i ] = new Option(
			typeof language[i] === 'number' ?
				settings.fnFormatNumber( language[i] ) :
				language[i],
			lengths[i]
		);
	}

	var div = $('<div><label/></div>').addClass( classes.sLength );
	if ( ! settings.aanFeatures.l ) {
		div[0].id = tableId+'_length';
	}

	div.children().append(
		settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
	);

	// Can't use `select` variable as user might provide their own and the
	// reference is broken by the use of outerHTML
	$('select', div)
		.val( settings._iDisplayLength )
		.on( 'change.DT', function(e) {
			_fnLengthChange( settings, $(this).val() );
			_fnDraw( settings );
		} );

	// Update node value whenever anything changes the table's length
	$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
		if ( settings === s ) {
			$('select', div).val( len );
		}
	} );

	return div[0];
}



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Note that most of the paging logic is done in
 * DataTable.ext.pager
 */

/**
 * Generate the node required for default pagination
 *  @param {object} oSettings dataTables settings object
 *  @returns {node} Pagination feature node
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlPaginate ( settings )
{
	var
		type   = settings.sPaginationType,
		plugin = DataTable.ext.pager[ type ],
		modern = typeof plugin === 'function',
		redraw = function( settings ) {
			_fnDraw( settings );
		},
		node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
		features = settings.aanFeatures;

	if ( ! modern ) {
		plugin.fnInit( settings, node, redraw );
	}

	/* Add a draw callback for the pagination on first instance, to update the paging display */
	if ( ! features.p )
	{
		node.id = settings.sTableId+'_paginate';

		settings.aoDrawCallback.push( {
			"fn": function( settings ) {
				if ( modern ) {
					var
						start      = settings._iDisplayStart,
						len        = settings._iDisplayLength,
						visRecords = settings.fnRecordsDisplay(),
						all        = len === -1,
						page = all ? 0 : Math.ceil( start / len ),
						pages = all ? 1 : Math.ceil( visRecords / len ),
						buttons = plugin(page, pages),
						i, ien;

					for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
						_fnRenderer( settings, 'pageButton' )(
							settings, features.p[i], i, buttons, page, pages
						);
					}
				}
				else {
					plugin.fnUpdate( settings, redraw );
				}
			},
			"sName": "pagination"
		} );
	}

	return node;
}


/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */
function _fnPageChange ( settings, action, redraw )
{
	var
		start     = settings._iDisplayStart,
		len       = settings._iDisplayLength,
		records   = settings.fnRecordsDisplay();

	if ( records === 0 || len === -1 )
	{
		start = 0;
	}
	else if ( typeof action === "number" )
	{
		start = action * len;

		if ( start > records )
		{
			start = 0;
		}
	}
	else if ( action == "first" )
	{
		start = 0;
	}
	else if ( action == "previous" )
	{
		start = len >= 0 ?
			start - len :
			0;

		if ( start < 0 )
		{
		  start = 0;
		}
	}
	else if ( action == "next" )
	{
		if ( start + len < records )
		{
			start += len;
		}
	}
	else if ( action == "last" )
	{
		start = Math.floor( (records-1) / len) * len;
	}
	else
	{
		_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
	}

	var changed = settings._iDisplayStart !== start;
	settings._iDisplayStart = start;

	if ( changed ) {
		_fnCallbackFire( settings, null, 'page', [settings] );

		if ( redraw ) {
			_fnDraw( settings );
		}
	}
	else {
		// No change event - paging was called, but no change
		_fnCallbackFire( settings, null, 'page-nc', [settings] );
	}

	return changed;
}



/**
 * Generate the node required for the processing node
 *  @param {object} settings dataTables settings object
 *  @returns {node} Processing element
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlProcessing ( settings )
{
	return $('<div/>', {
			'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
			'class': settings.oClasses.sProcessing,
			'role': 'status'
		} )
		.html( settings.oLanguage.sProcessing )
		.append('<div><div></div><div></div><div></div><div></div></div>')
		.insertBefore( settings.nTable )[0];
}


/**
 * Display or hide the processing indicator
 *  @param {object} settings dataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 *  @memberof DataTable#oApi
 */
function _fnProcessingDisplay ( settings, show )
{
	if ( settings.oFeatures.bProcessing ) {
		$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
	}

	_fnCallbackFire( settings, null, 'processing', [settings, show] );
}

/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlTable ( settings )
{
	var table = $(settings.nTable);

	// Scrolling from here on in
	var scroll = settings.oScroll;

	if ( scroll.sX === '' && scroll.sY === '' ) {
		return settings.nTable;
	}

	var scrollX = scroll.sX;
	var scrollY = scroll.sY;
	var classes = settings.oClasses;
	var caption = table.children('caption');
	var captionSide = caption.length ? caption[0]._captionSide : null;
	var headerClone = $( table[0].cloneNode(false) );
	var footerClone = $( table[0].cloneNode(false) );
	var footer = table.children('tfoot');
	var _div = '<div/>';
	var size = function ( s ) {
		return !s ? null : _fnStringToCss( s );
	};

	if ( ! footer.length ) {
		footer = null;
	}

	/*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */
	var scroller = $( _div, { 'class': classes.sScrollWrapper } )
		.append(
			$(_div, { 'class': classes.sScrollHead } )
				.css( {
					overflow: 'hidden',
					position: 'relative',
					border: 0,
					width: scrollX ? size(scrollX) : '100%'
				} )
				.append(
					$(_div, { 'class': classes.sScrollHeadInner } )
						.css( {
							'box-sizing': 'content-box',
							width: scroll.sXInner || '100%'
						} )
						.append(
							headerClone
								.removeAttr('id')
								.css( 'margin-left', 0 )
								.append( captionSide === 'top' ? caption : null )
								.append(
									table.children('thead')
								)
						)
				)
		)
		.append(
			$(_div, { 'class': classes.sScrollBody } )
				.css( {
					position: 'relative',
					overflow: 'auto',
					width: size( scrollX )
				} )
				.append( table )
		);

	if ( footer ) {
		scroller.append(
			$(_div, { 'class': classes.sScrollFoot } )
				.css( {
					overflow: 'hidden',
					border: 0,
					width: scrollX ? size(scrollX) : '100%'
				} )
				.append(
					$(_div, { 'class': classes.sScrollFootInner } )
						.append(
							footerClone
								.removeAttr('id')
								.css( 'margin-left', 0 )
								.append( captionSide === 'bottom' ? caption : null )
								.append(
									table.children('tfoot')
								)
						)
				)
		);
	}

	var children = scroller.children();
	var scrollHead = children[0];
	var scrollBody = children[1];
	var scrollFoot = footer ? children[2] : null;

	// When the body is scrolled, then we also want to scroll the headers
	if ( scrollX ) {
		$(scrollBody).on( 'scroll.DT', function (e) {
			var scrollLeft = this.scrollLeft;

			scrollHead.scrollLeft = scrollLeft;

			if ( footer ) {
				scrollFoot.scrollLeft = scrollLeft;
			}
		} );
	}

	$(scrollBody).css('max-height', scrollY);
	if (! scroll.bCollapse) {
		$(scrollBody).css('height', scrollY);
	}

	settings.nScrollHead = scrollHead;
	settings.nScrollBody = scrollBody;
	settings.nScrollFoot = scrollFoot;

	// On redraw - align columns
	settings.aoDrawCallback.push( {
		"fn": _fnScrollDraw,
		"sName": "scrolling"
	} );

	return scroller[0];
}



/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Take live measurements from the DOM
 *   3. Apply the measurements to align the columns
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnScrollDraw ( settings )
{
	// Given that this is such a monster function, a lot of variables are use
	// to try and keep the minimised size as small as possible
	var
		scroll         = settings.oScroll,
		scrollX        = scroll.sX,
		scrollXInner   = scroll.sXInner,
		scrollY        = scroll.sY,
		barWidth       = scroll.iBarWidth,
		divHeader      = $(settings.nScrollHead),
		divHeaderStyle = divHeader[0].style,
		divHeaderInner = divHeader.children('div'),
		divHeaderInnerStyle = divHeaderInner[0].style,
		divHeaderTable = divHeaderInner.children('table'),
		divBodyEl      = settings.nScrollBody,
		divBody        = $(divBodyEl),
		divBodyStyle   = divBodyEl.style,
		divFooter      = $(settings.nScrollFoot),
		divFooterInner = divFooter.children('div'),
		divFooterTable = divFooterInner.children('table'),
		header         = $(settings.nTHead),
		table          = $(settings.nTable),
		tableEl        = table[0],
		tableStyle     = tableEl.style,
		footer         = settings.nTFoot ? $(settings.nTFoot) : null,
		browser        = settings.oBrowser,
		ie67           = browser.bScrollOversize,
		dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
		headerTrgEls, footerTrgEls,
		headerSrcEls, footerSrcEls,
		headerCopy, footerCopy,
		headerWidths=[], footerWidths=[],
		headerContent=[], footerContent=[],
		idx, correction, sanityWidth,
		zeroOut = function(nSizer) {
			var style = nSizer.style;
			style.paddingTop = "0";
			style.paddingBottom = "0";
			style.borderTopWidth = "0";
			style.borderBottomWidth = "0";
			style.height = 0;
		};

	// If the scrollbar visibility has changed from the last draw, we need to
	// adjust the column sizes as the table width will have changed to account
	// for the scrollbar
	var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
	
	if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
		settings.scrollBarVis = scrollBarVis;
		_fnAdjustColumnSizing( settings );
		return; // adjust column sizing will call this function again
	}
	else {
		settings.scrollBarVis = scrollBarVis;
	}

	/*
	 * 1. Re-create the table inside the scrolling div
	 */

	// Remove the old minimised thead and tfoot elements in the inner table
	table.children('thead, tfoot').remove();

	if ( footer ) {
		footerCopy = footer.clone().prependTo( table );
		footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
		footerSrcEls = footerCopy.find('tr');
		footerCopy.find('[id]').removeAttr('id');
	}

	// Clone the current header and footer elements and then place it into the inner table
	headerCopy = header.clone().prependTo( table );
	headerTrgEls = header.find('tr'); // original header is in its own table
	headerSrcEls = headerCopy.find('tr');
	headerCopy.find('th, td').removeAttr('tabindex');
	headerCopy.find('[id]').removeAttr('id');


	/*
	 * 2. Take live measurements from the DOM - do not alter the DOM itself!
	 */

	// Remove old sizing and apply the calculated column widths
	// Get the unique column headers in the newly created (cloned) header. We want to apply the
	// calculated sizes to this header
	if ( ! scrollX )
	{
		divBodyStyle.width = '100%';
		divHeader[0].style.width = '100%';
	}

	$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
		idx = _fnVisibleToColumnIndex( settings, i );
		el.style.width = settings.aoColumns[idx].sWidth;
	} );

	if ( footer ) {
		_fnApplyToChildren( function(n) {
			n.style.width = "";
		}, footerSrcEls );
	}

	// Size the table as a whole
	sanityWidth = table.outerWidth();
	if ( scrollX === "" ) {
		// No x scrolling
		tableStyle.width = "100%";

		// IE7 will make the width of the table when 100% include the scrollbar
		// - which is shouldn't. When there is a scrollbar we need to take this
		// into account.
		if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
			divBody.css('overflow-y') == "scroll")
		) {
			tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
		}

		// Recalculate the sanity width
		sanityWidth = table.outerWidth();
	}
	else if ( scrollXInner !== "" ) {
		// legacy x scroll inner has been given - use it
		tableStyle.width = _fnStringToCss(scrollXInner);

		// Recalculate the sanity width
		sanityWidth = table.outerWidth();
	}

	// Hidden header should have zero height, so remove padding and borders. Then
	// set the width based on the real headers

	// Apply all styles in one pass
	_fnApplyToChildren( zeroOut, headerSrcEls );

	// Read all widths in next pass
	_fnApplyToChildren( function(nSizer) {
		var style = window.getComputedStyle ?
			window.getComputedStyle(nSizer).width :
			_fnStringToCss( $(nSizer).width() );

		headerContent.push( nSizer.innerHTML );
		headerWidths.push( style );
	}, headerSrcEls );

	// Apply all widths in final pass
	_fnApplyToChildren( function(nToSize, i) {
		nToSize.style.width = headerWidths[i];
	}, headerTrgEls );

	$(headerSrcEls).css('height', 0);

	/* Same again with the footer if we have one */
	if ( footer )
	{
		_fnApplyToChildren( zeroOut, footerSrcEls );

		_fnApplyToChildren( function(nSizer) {
			footerContent.push( nSizer.innerHTML );
			footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
		}, footerSrcEls );

		_fnApplyToChildren( function(nToSize, i) {
			nToSize.style.width = footerWidths[i];
		}, footerTrgEls );

		$(footerSrcEls).height(0);
	}


	/*
	 * 3. Apply the measurements
	 */

	// "Hide" the header and footer that we used for the sizing. We need to keep
	// the content of the cell so that the width applied to the header and body
	// both match, but we want to hide it completely. We want to also fix their
	// width to what they currently are
	_fnApplyToChildren( function(nSizer, i) {
		nSizer.innerHTML = '<div class="dataTables_sizing">'+headerContent[i]+'</div>';
		nSizer.childNodes[0].style.height = "0";
		nSizer.childNodes[0].style.overflow = "hidden";
		nSizer.style.width = headerWidths[i];
	}, headerSrcEls );

	if ( footer )
	{
		_fnApplyToChildren( function(nSizer, i) {
			nSizer.innerHTML = '<div class="dataTables_sizing">'+footerContent[i]+'</div>';
			nSizer.childNodes[0].style.height = "0";
			nSizer.childNodes[0].style.overflow = "hidden";
			nSizer.style.width = footerWidths[i];
		}, footerSrcEls );
	}

	// Sanity check that the table is of a sensible width. If not then we are going to get
	// misalignment - try to prevent this by not allowing the table to shrink below its min width
	if ( Math.round(table.outerWidth()) < Math.round(sanityWidth) )
	{
		// The min width depends upon if we have a vertical scrollbar visible or not */
		correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
			divBody.css('overflow-y') == "scroll")) ?
				sanityWidth+barWidth :
				sanityWidth;

		// IE6/7 are a law unto themselves...
		if ( ie67 && (divBodyEl.scrollHeight >
			divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
		) {
			tableStyle.width = _fnStringToCss( correction-barWidth );
		}

		// And give the user a warning that we've stopped the table getting too small
		if ( scrollX === "" || scrollXInner !== "" ) {
			_fnLog( settings, 1, 'Possible column misalignment', 6 );
		}
	}
	else
	{
		correction = '100%';
	}

	// Apply to the container elements
	divBodyStyle.width = _fnStringToCss( correction );
	divHeaderStyle.width = _fnStringToCss( correction );

	if ( footer ) {
		settings.nScrollFoot.style.width = _fnStringToCss( correction );
	}


	/*
	 * 4. Clean up
	 */
	if ( ! scrollY ) {
		/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
		 * the scrollbar height from the visible display, rather than adding it on. We need to
		 * set the height in order to sort this. Don't want to do it in any other browsers.
		 */
		if ( ie67 ) {
			divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
		}
	}

	/* Finally set the width's of the header and footer tables */
	var iOuterWidth = table.outerWidth();
	divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
	divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );

	// Figure out if there are scrollbar present - if so then we need a the header and footer to
	// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
	var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
	var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
	divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";

	if ( footer ) {
		divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
		divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
		divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
	}

	// Correct DOM ordering for colgroup - comes before the thead
	table.children('colgroup').insertBefore( table.children('thead') );

	/* Adjust the position of the header in case we loose the y-scrollbar */
	divBody.trigger('scroll');

	// If sorting or filtering has occurred, jump the scrolling back to the top
	// only if we aren't holding the position
	if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
		divBodyEl.scrollTop = 0;
	}
}



/**
 * Apply a given function to the display child nodes of an element array (typically
 * TD children of TR rows
 *  @param {function} fn Method to apply to the objects
 *  @param array {nodes} an1 List of elements to look through for display children
 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
 *  @memberof DataTable#oApi
 */
function _fnApplyToChildren( fn, an1, an2 )
{
	var index=0, i=0, iLen=an1.length;
	var nNode1, nNode2;

	while ( i < iLen ) {
		nNode1 = an1[i].firstChild;
		nNode2 = an2 ? an2[i].firstChild : null;

		while ( nNode1 ) {
			if ( nNode1.nodeType === 1 ) {
				if ( an2 ) {
					fn( nNode1, nNode2, index );
				}
				else {
					fn( nNode1, index );
				}

				index++;
			}

			nNode1 = nNode1.nextSibling;
			nNode2 = an2 ? nNode2.nextSibling : null;
		}

		i++;
	}
}



var __re_html_remove = /<.*?>/g;


/**
 * Calculate the width of columns for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnCalculateColumnWidths ( oSettings )
{
	var
		table = oSettings.nTable,
		columns = oSettings.aoColumns,
		scroll = oSettings.oScroll,
		scrollY = scroll.sY,
		scrollX = scroll.sX,
		scrollXInner = scroll.sXInner,
		columnCount = columns.length,
		visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
		headerCells = $('th', oSettings.nTHead),
		tableWidthAttr = table.getAttribute('width'), // from DOM element
		tableContainer = table.parentNode,
		userInputs = false,
		i, column, columnIdx, width, outerWidth,
		browser = oSettings.oBrowser,
		ie67 = browser.bScrollOversize;

	var styleWidth = table.style.width;
	if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
		tableWidthAttr = styleWidth;
	}

	/* Convert any user input sizes into pixel sizes */
	var sizes = _fnConvertToWidth(_pluck(columns, 'sWidthOrig'), tableContainer);

	for ( i=0 ; i<visibleColumns.length ; i++ ) {
		column = columns[ visibleColumns[i] ];

		if ( column.sWidth !== null ) {
			column.sWidth = sizes[i];

			userInputs = true;
		}
	}

	/* If the number of columns in the DOM equals the number that we have to
	 * process in DataTables, then we can use the offsets that are created by
	 * the web- browser. No custom sizes can be set in order for this to happen,
	 * nor scrolling used
	 */
	if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
	     columnCount == _fnVisbleColumns( oSettings ) &&
	     columnCount == headerCells.length
	) {
		for ( i=0 ; i<columnCount ; i++ ) {
			var colIdx = _fnVisibleToColumnIndex( oSettings, i );

			if ( colIdx !== null ) {
				columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
			}
		}
	}
	else
	{
		// Otherwise construct a single row, worst case, table with the widest
		// node in the data, assign any user defined widths, then insert it into
		// the DOM and allow the browser to do all the hard work of calculating
		// table widths
		var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
			.css( 'visibility', 'hidden' )
			.removeAttr( 'id' );

		// Clean up the table body
		tmpTable.find('tbody tr').remove();
		var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );

		// Clone the table header and footer - we can't use the header / footer
		// from the cloned table, since if scrolling is active, the table's
		// real header and footer are contained in different table tags
		tmpTable.find('thead, tfoot').remove();
		tmpTable
			.append( $(oSettings.nTHead).clone() )
			.append( $(oSettings.nTFoot).clone() );

		// Remove any assigned widths from the footer (from scrolling)
		tmpTable.find('tfoot th, tfoot td').css('width', '');

		// Apply custom sizing to the cloned header
		headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );

		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			column = columns[ visibleColumns[i] ];

			headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
				_fnStringToCss( column.sWidthOrig ) :
				'';

			// For scrollX we need to force the column width otherwise the
			// browser will collapse it. If this width is smaller than the
			// width the column requires, then it will have no effect
			if ( column.sWidthOrig && scrollX ) {
				$( headerCells[i] ).append( $('<div/>').css( {
					width: column.sWidthOrig,
					margin: 0,
					padding: 0,
					border: 0,
					height: 1
				} ) );
			}
		}

		// Find the widest cell for each column and put it into the table
		if ( oSettings.aoData.length ) {
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				columnIdx = visibleColumns[i];
				column = columns[ columnIdx ];

				$( _fnGetWidestNode( oSettings, columnIdx ) )
					.clone( false )
					.append( column.sContentPadding )
					.appendTo( tr );
			}
		}

		// Tidy the temporary table - remove name attributes so there aren't
		// duplicated in the dom (radio elements for example)
		$('[name]', tmpTable).removeAttr('name');

		// Table has been built, attach to the document so we can work with it.
		// A holding element is used, positioned at the top of the container
		// with minimal height, so it has no effect on if the container scrolls
		// or not. Otherwise it might trigger scrolling when it actually isn't
		// needed
		var holder = $('<div/>').css( scrollX || scrollY ?
				{
					position: 'absolute',
					top: 0,
					left: 0,
					height: 1,
					right: 0,
					overflow: 'hidden'
				} :
				{}
			)
			.append( tmpTable )
			.appendTo( tableContainer );

		// When scrolling (X or Y) we want to set the width of the table as 
		// appropriate. However, when not scrolling leave the table width as it
		// is. This results in slightly different, but I think correct behaviour
		if ( scrollX && scrollXInner ) {
			tmpTable.width( scrollXInner );
		}
		else if ( scrollX ) {
			tmpTable.css( 'width', 'auto' );
			tmpTable.removeAttr('width');

			// If there is no width attribute or style, then allow the table to
			// collapse
			if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
				tmpTable.width( tableContainer.clientWidth );
			}
		}
		else if ( scrollY ) {
			tmpTable.width( tableContainer.clientWidth );
		}
		else if ( tableWidthAttr ) {
			tmpTable.width( tableWidthAttr );
		}

		// Get the width of each column in the constructed table - we need to
		// know the inner width (so it can be assigned to the other table's
		// cells) and the outer width so we can calculate the full width of the
		// table. This is safe since DataTables requires a unique cell for each
		// column, but if ever a header can span multiple columns, this will
		// need to be modified.
		var total = 0;
		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			var cell = $(headerCells[i]);
			var border = cell.outerWidth() - cell.width();

			// Use getBounding... where possible (not IE8-) because it can give
			// sub-pixel accuracy, which we then want to round up!
			var bounding = browser.bBounding ?
				Math.ceil( headerCells[i].getBoundingClientRect().width ) :
				cell.outerWidth();

			// Total is tracked to remove any sub-pixel errors as the outerWidth
			// of the table might not equal the total given here (IE!).
			total += bounding;

			// Width for each column to use
			columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
		}

		table.style.width = _fnStringToCss( total );

		// Finished with the table - ditch it
		holder.remove();
	}

	// If there is a width attr, we want to attach an event listener which
	// allows the table sizing to automatically adjust when the window is
	// resized. Use the width attr rather than CSS, since we can't know if the
	// CSS is a relative value or absolute - DOM read is always px.
	if ( tableWidthAttr ) {
		table.style.width = _fnStringToCss( tableWidthAttr );
	}

	if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
		var bindResize = function () {
			$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
				_fnAdjustColumnSizing( oSettings );
			} ) );
		};

		// IE6/7 will crash if we bind a resize event handler on page load.
		// To be removed in 1.11 which drops IE6/7 support
		if ( ie67 ) {
			setTimeout( bindResize, 1000 );
		}
		else {
			bindResize();
		}

		oSettings._reszEvt = true;
	}
}


/**
 * Throttle the calls to a function. Arguments and context are maintained for
 * the throttled function
 *  @param {function} fn Function to be called
 *  @param {int} [freq=200] call frequency in mS
 *  @returns {function} wrapped function
 *  @memberof DataTable#oApi
 */
var _fnThrottle = DataTable.util.throttle;


/**
 * Convert a set of CSS units width to pixels (e.g. 2em)
 *  @param {string[]} widths widths to be converted
 *  @param {node} parent parent to get the with for (required for relative widths) - optional
 *  @returns {int[]} widths in pixels
 *  @memberof DataTable#oApi
 */
function _fnConvertToWidth ( widths, parent )
{
	var els = [];
	var results = [];

	// Add the elements in a single loop so we only need to reflow once
	for (var i=0 ; i<widths.length ; i++) {
		if (widths[i]) {
			els.push(
				$('<div/>')
					.css( 'width', _fnStringToCss( widths[i] ) )
					.appendTo( parent || document.body )
			)
		}
		else {
			els.push(null);
		}
	}

	// Get the sizes (will reflow once)
	for (var i=0 ; i<widths.length ; i++) {
		results.push(els[i] ? els[i][0].offsetWidth : null);
	}

	// Tidy
	$(els).remove();

	return results;
}


/**
 * Get the widest node
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {node} widest table node
 *  @memberof DataTable#oApi
 */
function _fnGetWidestNode( settings, colIdx )
{
	var idx = _fnGetMaxLenString( settings, colIdx );
	if ( idx < 0 ) {
		return null;
	}

	var data = settings.aoData[ idx ];
	return ! data.nTr ? // Might not have been created when deferred rendering
		$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
		data.anCells[ colIdx ];
}


/**
 * Get the maximum strlen for each data column
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string} max string length for each column
 *  @memberof DataTable#oApi
 */
function _fnGetMaxLenString( settings, colIdx )
{
	var s, max=-1, maxIdx = -1;

	for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
		s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
		s = s.replace( __re_html_remove, '' );
		s = s.replace( /&nbsp;/g, ' ' );

		if ( s.length > max ) {
			max = s.length;
			maxIdx = i;
		}
	}

	return maxIdx;
}


/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */
function _fnStringToCss( s )
{
	if ( s === null ) {
		return '0px';
	}

	if ( typeof s == 'number' ) {
		return s < 0 ?
			'0px' :
			s+'px';
	}

	// Check it has a unit character already
	return s.match(/\d$/) ?
		s+'px' :
		s;
}



function _fnSortFlatten ( settings )
{
	var
		i, iLen, k, kLen,
		aSort = [],
		aiOrig = [],
		aoColumns = settings.aoColumns,
		aDataSort, iCol, sType, srcCol,
		fixed = settings.aaSortingFixed,
		fixedObj = $.isPlainObject( fixed ),
		nestedSort = [],
		add = function ( a ) {
			if ( a.length && ! Array.isArray( a[0] ) ) {
				// 1D array
				nestedSort.push( a );
			}
			else {
				// 2D array
				$.merge( nestedSort, a );
			}
		};

	// Build the sort array, with pre-fix and post-fix options if they have been
	// specified
	if ( Array.isArray( fixed ) ) {
		add( fixed );
	}

	if ( fixedObj && fixed.pre ) {
		add( fixed.pre );
	}

	add( settings.aaSorting );

	if (fixedObj && fixed.post ) {
		add( fixed.post );
	}

	for ( i=0 ; i<nestedSort.length ; i++ )
	{
		srcCol = nestedSort[i][0];
		aDataSort = aoColumns[ srcCol ].aDataSort;

		for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
		{
			iCol = aDataSort[k];
			sType = aoColumns[ iCol ].sType || 'string';

			if ( nestedSort[i]._idx === undefined ) {
				nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
			}

			aSort.push( {
				src:       srcCol,
				col:       iCol,
				dir:       nestedSort[i][1],
				index:     nestedSort[i]._idx,
				type:      sType,
				formatter: DataTable.ext.type.order[ sType+"-pre" ]
			} );
		}
	}

	return aSort;
}

/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 *  @todo This really needs split up!
 */
function _fnSort ( oSettings )
{
	var
		i, ien, iLen, j, jLen, k, kLen,
		sDataType, nTh,
		aiOrig = [],
		oExtSort = DataTable.ext.type.order,
		aoData = oSettings.aoData,
		aoColumns = oSettings.aoColumns,
		aDataSort, data, iCol, sType, oSort,
		formatters = 0,
		sortCol,
		displayMaster = oSettings.aiDisplayMaster,
		aSort;

	// Resolve any column types that are unknown due to addition or invalidation
	// @todo Can this be moved into a 'data-ready' handler which is called when
	//   data is going to be used in the table?
	_fnColumnTypes( oSettings );

	aSort = _fnSortFlatten( oSettings );

	for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
		sortCol = aSort[i];

		// Track if we can use the fast sort algorithm
		if ( sortCol.formatter ) {
			formatters++;
		}

		// Load the data needed for the sort, for each cell
		_fnSortData( oSettings, sortCol.col );
	}

	/* No sorting required if server-side or no sorting array */
	if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
	{
		// Create a value - key array of the current row positions such that we can use their
		// current position during the sort, if values match, in order to perform stable sorting
		for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
			aiOrig[ displayMaster[i] ] = i;
		}

		/* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on it's own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var iTest;
		 *    iTest = oSort['string-asc']('data11', 'data12');
		 *      if (iTest !== 0)
		 *        return iTest;
		 *    iTest = oSort['numeric-desc']('data21', 'data22');
		 *    if (iTest !== 0)
		 *      return iTest;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 *
		 * Note - I know it seems excessive to have two sorting methods, but the first is around
		 * 15% faster, so the second is only maintained for backwards compatibility with sorting
		 * methods which do not have a pre-sort formatting function.
		 */
		if ( formatters === aSort.length ) {
			// All sort types have formatting functions
			displayMaster.sort( function ( a, b ) {
				var
					x, y, k, test, sort,
					len=aSort.length,
					dataA = aoData[a]._aSortData,
					dataB = aoData[b]._aSortData;

				for ( k=0 ; k<len ; k++ ) {
					sort = aSort[k];

					x = dataA[ sort.col ];
					y = dataB[ sort.col ];

					test = x<y ? -1 : x>y ? 1 : 0;
					if ( test !== 0 ) {
						return sort.dir === 'asc' ? test : -test;
					}
				}

				x = aiOrig[a];
				y = aiOrig[b];
				return x<y ? -1 : x>y ? 1 : 0;
			} );
		}
		else {
			// Depreciated - remove in 1.11 (providing a plug-in option)
			// Not all sort types have formatting methods, so we have to call their sorting
			// methods.
			displayMaster.sort( function ( a, b ) {
				var
					x, y, k, l, test, sort, fn,
					len=aSort.length,
					dataA = aoData[a]._aSortData,
					dataB = aoData[b]._aSortData;

				for ( k=0 ; k<len ; k++ ) {
					sort = aSort[k];

					x = dataA[ sort.col ];
					y = dataB[ sort.col ];

					fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
					test = fn( x, y );
					if ( test !== 0 ) {
						return test;
					}
				}

				x = aiOrig[a];
				y = aiOrig[b];
				return x<y ? -1 : x>y ? 1 : 0;
			} );
		}
	}

	/* Tell the draw function that we have sorted the data */
	oSettings.bSorted = true;
}


function _fnSortAria ( settings )
{
	var label;
	var nextSort;
	var columns = settings.aoColumns;
	var aSort = _fnSortFlatten( settings );
	var oAria = settings.oLanguage.oAria;

	// ARIA attributes - need to loop all columns, to update all (removing old
	// attributes as needed)
	for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
	{
		var col = columns[i];
		var asSorting = col.asSorting;
		var sTitle = col.ariaTitle || col.sTitle.replace( /<.*?>/g, "" );
		var th = col.nTh;

		// IE7 is throwing an error when setting these properties with jQuery's
		// attr() and removeAttr() methods...
		th.removeAttribute('aria-sort');

		/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
		if ( col.bSortable ) {
			if ( aSort.length > 0 && aSort[0].col == i ) {
				th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
				nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
			}
			else {
				nextSort = asSorting[0];
			}

			label = sTitle + ( nextSort === "asc" ?
				oAria.sSortAscending :
				oAria.sSortDescending
			);
		}
		else {
			label = sTitle;
		}

		th.setAttribute('aria-label', label);
	}
}


/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {boolean} [append=false] Append the requested sort to the existing
 *    sort if true (i.e. multi-column sort)
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */
function _fnSortListener ( settings, colIdx, append, callback )
{
	var col = settings.aoColumns[ colIdx ];
	var sorting = settings.aaSorting;
	var asSorting = col.asSorting;
	var nextSortIdx;
	var next = function ( a, overflow ) {
		var idx = a._idx;
		if ( idx === undefined ) {
			idx = $.inArray( a[1], asSorting );
		}

		return idx+1 < asSorting.length ?
			idx+1 :
			overflow ?
				null :
				0;
	};

	// Convert to 2D array if needed
	if ( typeof sorting[0] === 'number' ) {
		sorting = settings.aaSorting = [ sorting ];
	}

	// If appending the sort then we are multi-column sorting
	if ( append && settings.oFeatures.bSortMulti ) {
		// Are we already doing some kind of sort on this column?
		var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );

		if ( sortIdx !== -1 ) {
			// Yes, modify the sort
			nextSortIdx = next( sorting[sortIdx], true );

			if ( nextSortIdx === null && sorting.length === 1 ) {
				nextSortIdx = 0; // can't remove sorting completely
			}

			if ( nextSortIdx === null ) {
				sorting.splice( sortIdx, 1 );
			}
			else {
				sorting[sortIdx][1] = asSorting[ nextSortIdx ];
				sorting[sortIdx]._idx = nextSortIdx;
			}
		}
		else {
			// No sort on this column yet
			sorting.push( [ colIdx, asSorting[0], 0 ] );
			sorting[sorting.length-1]._idx = 0;
		}
	}
	else if ( sorting.length && sorting[0][0] == colIdx ) {
		// Single column - already sorting on this column, modify the sort
		nextSortIdx = next( sorting[0] );

		sorting.length = 1;
		sorting[0][1] = asSorting[ nextSortIdx ];
		sorting[0]._idx = nextSortIdx;
	}
	else {
		// Single column - sort only on this column
		sorting.length = 0;
		sorting.push( [ colIdx, asSorting[0] ] );
		sorting[0]._idx = 0;
	}

	// Run the sort by calling a full redraw
	_fnReDraw( settings );

	// callback used for async user interaction
	if ( typeof callback == 'function' ) {
		callback( settings );
	}
}


/**
 * Attach a sort handler (click) to a node
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */
function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
{
	var col = settings.aoColumns[ colIdx ];

	_fnBindAction( attachTo, {}, function (e) {
		/* If the column is not sortable - don't to anything */
		if ( col.bSortable === false ) {
			return;
		}

		// If processing is enabled use a timeout to allow the processing
		// display to be shown - otherwise to it synchronously
		if ( settings.oFeatures.bProcessing ) {
			_fnProcessingDisplay( settings, true );

			setTimeout( function() {
				_fnSortListener( settings, colIdx, e.shiftKey, callback );

				// In server-side processing, the draw callback will remove the
				// processing display
				if ( _fnDataSource( settings ) !== 'ssp' ) {
					_fnProcessingDisplay( settings, false );
				}
			}, 0 );
		}
		else {
			_fnSortListener( settings, colIdx, e.shiftKey, callback );
		}
	} );
}


/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnSortingClasses( settings )
{
	var oldSort = settings.aLastSort;
	var sortClass = settings.oClasses.sSortColumn;
	var sort = _fnSortFlatten( settings );
	var features = settings.oFeatures;
	var i, ien, colIdx;

	if ( features.bSort && features.bSortClasses ) {
		// Remove old sorting classes
		for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
			colIdx = oldSort[i].src;

			// Remove column sorting
			$( _pluck( settings.aoData, 'anCells', colIdx ) )
				.removeClass( sortClass + (i<2 ? i+1 : 3) );
		}

		// Add new column sorting
		for ( i=0, ien=sort.length ; i<ien ; i++ ) {
			colIdx = sort[i].src;

			$( _pluck( settings.aoData, 'anCells', colIdx ) )
				.addClass( sortClass + (i<2 ? i+1 : 3) );
		}
	}

	settings.aLastSort = sort;
}


// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function _fnSortData( settings, idx )
{
	// Custom sorting function - provided by the sort data type
	var column = settings.aoColumns[ idx ];
	var customSort = DataTable.ext.order[ column.sSortDataType ];
	var customData;

	if ( customSort ) {
		customData = customSort.call( settings.oInstance, settings, idx,
			_fnColumnIndexToVisible( settings, idx )
		);
	}

	// Use / populate cache
	var row, cellData;
	var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];

	for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
		row = settings.aoData[i];

		if ( ! row._aSortData ) {
			row._aSortData = [];
		}

		if ( ! row._aSortData[idx] || customSort ) {
			cellData = customSort ?
				customData[i] : // If there was a custom sort function, use data from there
				_fnGetCellData( settings, i, idx, 'sort' );

			row._aSortData[ idx ] = formatter ?
				formatter( cellData ) :
				cellData;
		}
	}
}



/**
 * Save the state of a table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnSaveState ( settings )
{
	if (settings._bLoadingState) {
		return;
	}

	/* Store the interesting variables */
	var state = {
		time:    +new Date(),
		start:   settings._iDisplayStart,
		length:  settings._iDisplayLength,
		order:   $.extend( true, [], settings.aaSorting ),
		search:  _fnSearchToCamel( settings.oPreviousSearch ),
		columns: $.map( settings.aoColumns, function ( col, i ) {
			return {
				visible: col.bVisible,
				search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
			};
		} )
	};

	settings.oSavedState = state;
	_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
	
	if ( settings.oFeatures.bStateSave && !settings.bDestroying )
	{
		settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
	}	
}


/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */
function _fnLoadState ( settings, oInit, callback )
{
	if ( ! settings.oFeatures.bStateSave ) {
		callback();
		return;
	}

	var loaded = function(state) {
		_fnImplementState(settings, state, callback);
	}

	var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );

	if ( state !== undefined ) {
		_fnImplementState( settings, state, callback );
	}
	// otherwise, wait for the loaded callback to be executed

	return true;
}

function _fnImplementState ( settings, s, callback) {
	var i, ien;
	var columns = settings.aoColumns;
	settings._bLoadingState = true;

	// When StateRestore was introduced the state could now be implemented at any time
	// Not just initialisation. To do this an api instance is required in some places
	var api = settings._bInitComplete ? new DataTable.Api(settings) : null;

	if ( ! s || ! s.time ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Allow custom and plug-in manipulation functions to alter the saved data set and
	// cancelling of loading by returning false
	var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s] );
	if ( $.inArray( false, abStateLoad ) !== -1 ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Reject old data
	var duration = settings.iStateDuration;
	if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Number of columns have changed - all bets are off, no restore of settings
	if ( s.columns && columns.length !== s.columns.length ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Store the saved state so it might be accessed at any time
	settings.oLoadedState = $.extend( true, {}, s );

	// Page Length
	if ( s.length !== undefined ) {
		// If already initialised just set the value directly so that the select element is also updated
		if (api) {
			api.page.len(s.length)
		}
		else {
			settings._iDisplayLength   = s.length;
		}
	}

	// Restore key features - todo - for 1.11 this needs to be done by
	// subscribed events
	if ( s.start !== undefined ) {
		if(api === null) {
			settings._iDisplayStart    = s.start;
			settings.iInitDisplayStart = s.start;
		}
		else {
			_fnPageChange(settings, s.start/settings._iDisplayLength);
		}
	}

	// Order
	if ( s.order !== undefined ) {
		settings.aaSorting = [];
		$.each( s.order, function ( i, col ) {
			settings.aaSorting.push( col[0] >= columns.length ?
				[ 0, col[1] ] :
				col
			);
		} );
	}

	// Search
	if ( s.search !== undefined ) {
		$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
	}

	// Columns
	if ( s.columns ) {
		for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
			var col = s.columns[i];

			// Visibility
			if ( col.visible !== undefined ) {
				// If the api is defined, the table has been initialised so we need to use it rather than internal settings
				if (api) {
					// Don't redraw the columns on every iteration of this loop, we will do this at the end instead
					api.column(i).visible(col.visible, false);
				}
				else {
					columns[i].bVisible = col.visible;
				}
			}

			// Search
			if ( col.search !== undefined ) {
				$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
			}
		}
		
		// If the api is defined then we need to adjust the columns once the visibility has been changed
		if (api) {
			api.columns.adjust();
		}
	}

	settings._bLoadingState = false;
	_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, s] );
	callback();
};


/**
 * Return the settings object for a particular table
 *  @param {node} table table we are using as a dataTable
 *  @returns {object} Settings object - or null if not found
 *  @memberof DataTable#oApi
 */
function _fnSettingsFromNode ( table )
{
	var settings = DataTable.settings;
	var idx = $.inArray( table, _pluck( settings, 'nTable' ) );

	return idx !== -1 ?
		settings[ idx ] :
		null;
}


/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */
function _fnLog( settings, level, msg, tn )
{
	msg = 'DataTables warning: '+
		(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;

	if ( tn ) {
		msg += '. For more information about this error, please see '+
		'https://datatables.net/tn/'+tn;
	}

	if ( ! level  ) {
		// Backwards compatibility pre 1.10
		var ext = DataTable.ext;
		var type = ext.sErrMode || ext.errMode;

		if ( settings ) {
			_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
		}

		if ( type == 'alert' ) {
			alert( msg );
		}
		else if ( type == 'throw' ) {
			throw new Error(msg);
		}
		else if ( typeof type == 'function' ) {
			type( settings, tn, msg );
		}
	}
	else if ( window.console && console.log ) {
		console.log( msg );
	}
}


/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */
function _fnMap( ret, src, name, mappedName )
{
	if ( Array.isArray( name ) ) {
		$.each( name, function (i, val) {
			if ( Array.isArray( val ) ) {
				_fnMap( ret, src, val[0], val[1] );
			}
			else {
				_fnMap( ret, src, val );
			}
		} );

		return;
	}

	if ( mappedName === undefined ) {
		mappedName = name;
	}

	if ( src[name] !== undefined ) {
		ret[mappedName] = src[name];
	}
}


/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */
function _fnExtend( out, extender, breakRefs )
{
	var val;

	for ( var prop in extender ) {
		if ( extender.hasOwnProperty(prop) ) {
			val = extender[prop];

			if ( $.isPlainObject( val ) ) {
				if ( ! $.isPlainObject( out[prop] ) ) {
					out[prop] = {};
				}
				$.extend( true, out[prop], val );
			}
			else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val) ) {
				out[prop] = val.slice();
			}
			else {
				out[prop] = val;
			}
		}
	}

	return out;
}


/**
 * Bind an event handers to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object} oData Data object to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */
function _fnBindAction( n, oData, fn )
{
	$(n)
		.on( 'click.DT', oData, function (e) {
				$(n).trigger('blur'); // Remove focus outline for mouse users
				fn(e);
			} )
		.on( 'keypress.DT', oData, function (e){
				if ( e.which === 13 ) {
					e.preventDefault();
					fn(e);
				}
			} )
		.on( 'selectstart.DT', function () {
				/* Take the brutal approach to cancelling text selection */
				return false;
			} );
}


/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @param {string} sName Identifying name for the callback (i.e. a label)
 *  @memberof DataTable#oApi
 */
function _fnCallbackReg( oSettings, sStore, fn, sName )
{
	if ( fn )
	{
		oSettings[sStore].push( {
			"fn": fn,
			"sName": sName
		} );
	}
}


/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @memberof DataTable#oApi
 */
function _fnCallbackFire( settings, callbackArr, eventName, args )
{
	var ret = [];

	if ( callbackArr ) {
		ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
			return val.fn.apply( settings.oInstance, args );
		} );
	}

	if ( eventName !== null ) {
		var e = $.Event( eventName+'.dt' );
		var table = $(settings.nTable);

		table.trigger( e, args );

		// If not yet attached to the document, trigger the event
		// on the body directly to sort of simulate the bubble
		if (table.parents('body').length === 0) {
			$('body').trigger( e, args );
		}

		ret.push( e.result );
	}

	return ret;
}


function _fnLengthOverflow ( settings )
{
	var
		start = settings._iDisplayStart,
		end = settings.fnDisplayEnd(),
		len = settings._iDisplayLength;

	/* If we have space to show extra rows (backing up from the end point - then do so */
	if ( start >= end )
	{
		start = end - len;
	}

	// Keep the start record on the current page
	start -= (start % len);

	if ( len === -1 || start < 0 )
	{
		start = 0;
	}

	settings._iDisplayStart = start;
}


function _fnRenderer( settings, type )
{
	var renderer = settings.renderer;
	var host = DataTable.ext.renderer[type];

	if ( $.isPlainObject( renderer ) && renderer[type] ) {
		// Specific renderer for this type. If available use it, otherwise use
		// the default.
		return host[renderer[type]] || host._;
	}
	else if ( typeof renderer === 'string' ) {
		// Common renderer - if there is one available for this type use it,
		// otherwise use the default
		return host[renderer] || host._;
	}

	// Use the default
	return host._;
}


/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */
function _fnDataSource ( settings )
{
	if ( settings.oFeatures.bServerSide ) {
		return 'ssp';
	}
	else if ( settings.ajax || settings.sAjaxSource ) {
		return 'ajax';
	}
	return 'dom';
}




/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */
var __apiStruct = [];


/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */
var __arrayProto = Array.prototype;


/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */
var _toSettings = function ( mixed )
{
	var idx, jq;
	var settings = DataTable.settings;
	var tables = $.map( settings, function (el, i) {
		return el.nTable;
	} );

	if ( ! mixed ) {
		return [];
	}
	else if ( mixed.nTable && mixed.oApi ) {
		// DataTables settings object
		return [ mixed ];
	}
	else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
		// Table node
		idx = $.inArray( mixed, tables );
		return idx !== -1 ? [ settings[idx] ] : null;
	}
	else if ( mixed && typeof mixed.settings === 'function' ) {
		return mixed.settings().toArray();
	}
	else if ( typeof mixed === 'string' ) {
		// jQuery selector
		jq = $(mixed);
	}
	else if ( mixed instanceof $ ) {
		// jQuery object (also DataTables instance)
		jq = mixed;
	}

	if ( jq ) {
		return jq.map( function(i) {
			idx = $.inArray( this, tables );
			return idx !== -1 ? settings[idx] : null;
		} ).toArray();
	}
};


/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
 */
_Api = function ( context, data )
{
	if ( ! (this instanceof _Api) ) {
		return new _Api( context, data );
	}

	var settings = [];
	var ctxSettings = function ( o ) {
		var a = _toSettings( o );
		if ( a ) {
			settings.push.apply( settings, a );
		}
	};

	if ( Array.isArray( context ) ) {
		for ( var i=0, ien=context.length ; i<ien ; i++ ) {
			ctxSettings( context[i] );
		}
	}
	else {
		ctxSettings( context );
	}

	// Remove duplicates
	this.context = _unique( settings );

	// Initial data
	if ( data ) {
		$.merge( this, data );
	}

	// selector
	this.selector = {
		rows: null,
		cols: null,
		opts: null
	};

	_Api.extend( this, this, __apiStruct );
};

DataTable.Api = _Api;

// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$.extend( _Api.prototype, {
	any: function ()
	{
		return this.count() !== 0;
	},


	concat:  __arrayProto.concat,


	context: [], // array of table settings objects


	count: function ()
	{
		return this.flatten().length;
	},


	each: function ( fn )
	{
		for ( var i=0, ien=this.length ; i<ien; i++ ) {
			fn.call( this, this[i], i, this );
		}

		return this;
	},


	eq: function ( idx )
	{
		var ctx = this.context;

		return ctx.length > idx ?
			new _Api( ctx[idx], this[idx] ) :
			null;
	},


	filter: function ( fn )
	{
		var a = [];

		if ( __arrayProto.filter ) {
			a = __arrayProto.filter.call( this, fn, this );
		}
		else {
			// Compatibility for browsers without EMCA-252-5 (JS 1.6)
			for ( var i=0, ien=this.length ; i<ien ; i++ ) {
				if ( fn.call( this, this[i], i, this ) ) {
					a.push( this[i] );
				}
			}
		}

		return new _Api( this.context, a );
	},


	flatten: function ()
	{
		var a = [];
		return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
	},


	join:    __arrayProto.join,


	indexOf: __arrayProto.indexOf || function (obj, start)
	{
		for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
			if ( this[i] === obj ) {
				return i;
			}
		}
		return -1;
	},

	iterator: function ( flatten, type, fn, alwaysNew ) {
		var
			a = [], ret,
			i, ien, j, jen,
			context = this.context,
			rows, items, item,
			selector = this.selector;

		// Argument shifting
		if ( typeof flatten === 'string' ) {
			alwaysNew = fn;
			fn = type;
			type = flatten;
			flatten = false;
		}

		for ( i=0, ien=context.length ; i<ien ; i++ ) {
			var apiInst = new _Api( context[i] );

			if ( type === 'table' ) {
				ret = fn.call( apiInst, context[i], i );

				if ( ret !== undefined ) {
					a.push( ret );
				}
			}
			else if ( type === 'columns' || type === 'rows' ) {
				// this has same length as context - one entry for each table
				ret = fn.call( apiInst, context[i], this[i], i );

				if ( ret !== undefined ) {
					a.push( ret );
				}
			}
			else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
				// columns and rows share the same structure.
				// 'this' is an array of column indexes for each context
				items = this[i];

				if ( type === 'column-rows' ) {
					rows = _selector_row_indexes( context[i], selector.opts );
				}

				for ( j=0, jen=items.length ; j<jen ; j++ ) {
					item = items[j];

					if ( type === 'cell' ) {
						ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
					}
					else {
						ret = fn.call( apiInst, context[i], item, i, j, rows );
					}

					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
			}
		}

		if ( a.length || alwaysNew ) {
			var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
			var apiSelector = api.selector;
			apiSelector.rows = selector.rows;
			apiSelector.cols = selector.cols;
			apiSelector.opts = selector.opts;
			return api;
		}
		return this;
	},


	lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
	{
		// Bit cheeky...
		return this.indexOf.apply( this.toArray.reverse(), arguments );
	},


	length:  0,


	map: function ( fn )
	{
		var a = [];

		if ( __arrayProto.map ) {
			a = __arrayProto.map.call( this, fn, this );
		}
		else {
			// Compatibility for browsers without EMCA-252-5 (JS 1.6)
			for ( var i=0, ien=this.length ; i<ien ; i++ ) {
				a.push( fn.call( this, this[i], i ) );
			}
		}

		return new _Api( this.context, a );
	},


	pluck: function ( prop )
	{
		var fn = DataTable.util.get(prop);

		return this.map( function ( el ) {
			return fn(el);
		} );
	},

	pop:     __arrayProto.pop,


	push:    __arrayProto.push,


	// Does not return an API instance
	reduce: __arrayProto.reduce || function ( fn, init )
	{
		return _fnReduce( this, fn, init, 0, this.length, 1 );
	},


	reduceRight: __arrayProto.reduceRight || function ( fn, init )
	{
		return _fnReduce( this, fn, init, this.length-1, -1, -1 );
	},


	reverse: __arrayProto.reverse,


	// Object with rows, columns and opts
	selector: null,


	shift:   __arrayProto.shift,


	slice: function () {
		return new _Api( this.context, this );
	},


	sort:    __arrayProto.sort, // ? name - order?


	splice:  __arrayProto.splice,


	toArray: function ()
	{
		return __arrayProto.slice.call( this );
	},


	to$: function ()
	{
		return $( this );
	},


	toJQuery: function ()
	{
		return $( this );
	},


	unique: function ()
	{
		return new _Api( this.context, _unique(this) );
	},


	unshift: __arrayProto.unshift
} );


_Api.extend = function ( scope, obj, ext )
{
	// Only extend API instances and static properties of the API
	if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
		return;
	}

	var
		i, ien,
		struct,
		methodScoping = function ( scope, fn, struc ) {
			return function () {
				var ret = fn.apply( scope, arguments );

				// Method extension
				_Api.extend( ret, ret, struc.methodExt );
				return ret;
			};
		};

	for ( i=0, ien=ext.length ; i<ien ; i++ ) {
		struct = ext[i];

		// Value
		obj[ struct.name ] = struct.type === 'function' ?
			methodScoping( scope, struct.val, struct ) :
			struct.type === 'object' ?
				{} :
				struct.val;

		obj[ struct.name ].__dt_wrapper = true;

		// Property extension
		_Api.extend( scope, obj[ struct.name ], struct.propExt );
	}
};


// @todo - Is there need for an augment function?
// _Api.augment = function ( inst, name )
// {
// 	// Find src object in the structure from the name
// 	var parts = name.split('.');

// 	_Api.extend( inst, obj );
// };


//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]

_Api.register = _api_register = function ( name, val )
{
	if ( Array.isArray( name ) ) {
		for ( var j=0, jen=name.length ; j<jen ; j++ ) {
			_Api.register( name[j], val );
		}
		return;
	}

	var
		i, ien,
		heir = name.split('.'),
		struct = __apiStruct,
		key, method;

	var find = function ( src, name ) {
		for ( var i=0, ien=src.length ; i<ien ; i++ ) {
			if ( src[i].name === name ) {
				return src[i];
			}
		}
		return null;
	};

	for ( i=0, ien=heir.length ; i<ien ; i++ ) {
		method = heir[i].indexOf('()') !== -1;
		key = method ?
			heir[i].replace('()', '') :
			heir[i];

		var src = find( struct, key );
		if ( ! src ) {
			src = {
				name:      key,
				val:       {},
				methodExt: [],
				propExt:   [],
				type:      'object'
			};
			struct.push( src );
		}

		if ( i === ien-1 ) {
			src.val = val;
			src.type = typeof val === 'function' ?
				'function' :
				$.isPlainObject( val ) ?
					'object' :
					'other';
		}
		else {
			struct = method ?
				src.methodExt :
				src.propExt;
		}
	}
};

_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
	_Api.register( pluralName, val );

	_Api.register( singularName, function () {
		var ret = val.apply( this, arguments );

		if ( ret === this ) {
			// Returned item is the API instance that was passed in, return it
			return this;
		}
		else if ( ret instanceof _Api ) {
			// New API instance returned, want the value from the first item
			// in the returned array for the singular result.
			return ret.length ?
				Array.isArray( ret[0] ) ?
					new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
					ret[0] :
				undefined;
		}

		// Non-API return - just fire it back
		return ret;
	} );
};


/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */
var __table_selector = function ( selector, a )
{
	if ( Array.isArray(selector) ) {
		return $.map( selector, function (item) {
			return __table_selector(item, a);
		} );
	}

	// Integer is used to pick out a table by index
	if ( typeof selector === 'number' ) {
		return [ a[ selector ] ];
	}

	// Perform a jQuery selector on the table nodes
	var nodes = $.map( a, function (el, i) {
		return el.nTable;
	} );

	return $(nodes)
		.filter( selector )
		.map( function (i) {
			// Need to translate back from the table node to the settings
			var idx = $.inArray( this, nodes );
			return a[ idx ];
		} )
		.toArray();
};



/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */
_api_register( 'tables()', function ( selector ) {
	// A new instance is created if there was a selector specified
	return selector !== undefined && selector !== null ?
		new _Api( __table_selector( selector, this.context ) ) :
		this;
} );


_api_register( 'table()', function ( selector ) {
	var tables = this.tables( selector );
	var ctx = tables.context;

	// Truncate to the first matched table
	return ctx.length ?
		new _Api( ctx[0] ) :
		tables;
} );


_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTable;
	}, 1 );
} );


_api_registerPlural( 'tables().body()', 'table().body()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTBody;
	}, 1 );
} );


_api_registerPlural( 'tables().header()', 'table().header()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTHead;
	}, 1 );
} );


_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTFoot;
	}, 1 );
} );


_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTableWrapper;
	}, 1 );
} );



/**
 * Redraw the tables in the current context.
 */
_api_register( 'draw()', function ( paging ) {
	return this.iterator( 'table', function ( settings ) {
		if ( paging === 'page' ) {
			_fnDraw( settings );
		}
		else {
			if ( typeof paging === 'string' ) {
				paging = paging === 'full-hold' ?
					false :
					true;
			}

			_fnReDraw( settings, paging===false );
		}
	} );
} );



/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 *//**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */
_api_register( 'page()', function ( action ) {
	if ( action === undefined ) {
		return this.page.info().page; // not an expensive call
	}

	// else, have an action to take on all tables
	return this.iterator( 'table', function ( settings ) {
		_fnPageChange( settings, action );
	} );
} );


/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */
_api_register( 'page.info()', function ( action ) {
	if ( this.context.length === 0 ) {
		return undefined;
	}

	var
		settings   = this.context[0],
		start      = settings._iDisplayStart,
		len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
		visRecords = settings.fnRecordsDisplay(),
		all        = len === -1;

	return {
		"page":           all ? 0 : Math.floor( start / len ),
		"pages":          all ? 1 : Math.ceil( visRecords / len ),
		"start":          start,
		"end":            settings.fnDisplayEnd(),
		"length":         len,
		"recordsTotal":   settings.fnRecordsTotal(),
		"recordsDisplay": visRecords,
		"serverSide":     _fnDataSource( settings ) === 'ssp'
	};
} );


/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 *//**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */
_api_register( 'page.len()', function ( len ) {
	// Note that we can't call this function 'length()' because `length`
	// is a Javascript property of functions which defines how many arguments
	// the function expects.
	if ( len === undefined ) {
		return this.context.length !== 0 ?
			this.context[0]._iDisplayLength :
			undefined;
	}

	// else, set the page length
	return this.iterator( 'table', function ( settings ) {
		_fnLengthChange( settings, len );
	} );
} );



var __reload = function ( settings, holdPosition, callback ) {
	// Use the draw event to trigger a callback
	if ( callback ) {
		var api = new _Api( settings );

		api.one( 'draw', function () {
			callback( api.ajax.json() );
		} );
	}

	if ( _fnDataSource( settings ) == 'ssp' ) {
		_fnReDraw( settings, holdPosition );
	}
	else {
		_fnProcessingDisplay( settings, true );

		// Cancel an existing request
		var xhr = settings.jqXHR;
		if ( xhr && xhr.readyState !== 4 ) {
			xhr.abort();
		}

		// Trigger xhr
		_fnBuildAjax( settings, [], function( json ) {
			_fnClearTable( settings );

			var data = _fnAjaxDataSrc( settings, json );
			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				_fnAddData( settings, data[i] );
			}

			_fnReDraw( settings, holdPosition );
			_fnProcessingDisplay( settings, false );
		} );
	}
};


/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */
_api_register( 'ajax.json()', function () {
	var ctx = this.context;

	if ( ctx.length > 0 ) {
		return ctx[0].json;
	}

	// else return undefined;
} );


/**
 * Get the data submitted in the last Ajax request
 */
_api_register( 'ajax.params()', function () {
	var ctx = this.context;

	if ( ctx.length > 0 ) {
		return ctx[0].oAjaxData;
	}

	// else return undefined;
} );


/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */
_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
	return this.iterator( 'table', function (settings) {
		__reload( settings, resetPaging===false, callback );
	} );
} );


/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 *//**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */
_api_register( 'ajax.url()', function ( url ) {
	var ctx = this.context;

	if ( url === undefined ) {
		// get
		if ( ctx.length === 0 ) {
			return undefined;
		}
		ctx = ctx[0];

		return ctx.ajax ?
			$.isPlainObject( ctx.ajax ) ?
				ctx.ajax.url :
				ctx.ajax :
			ctx.sAjaxSource;
	}

	// set
	return this.iterator( 'table', function ( settings ) {
		if ( $.isPlainObject( settings.ajax ) ) {
			settings.ajax.url = url;
		}
		else {
			settings.ajax = url;
		}
		// No need to consider sAjaxSource here since DataTables gives priority
		// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
		// value of `sAjaxSource` redundant.
	} );
} );


/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */
_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
	// Same as a reload, but makes sense to present it for easy access after a
	// url change
	return this.iterator( 'table', function ( ctx ) {
		__reload( ctx, resetPaging===false, callback );
	} );
} );




var _selector_run = function ( type, selector, selectFn, settings, opts )
{
	var
		out = [], res,
		a, i, ien, j, jen,
		selectorType = typeof selector;

	// Can't just check for isArray here, as an API or jQuery instance might be
	// given with their array like look
	if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
		selector = [ selector ];
	}

	for ( i=0, ien=selector.length ; i<ien ; i++ ) {
		// Only split on simple strings - complex expressions will be jQuery selectors
		a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
			selector[i].split(',') :
			[ selector[i] ];

		for ( j=0, jen=a.length ; j<jen ; j++ ) {
			res = selectFn( typeof a[j] === 'string' ? (a[j]).trim() : a[j] );

			if ( res && res.length ) {
				out = out.concat( res );
			}
		}
	}

	// selector extensions
	var ext = _ext.selector[ type ];
	if ( ext.length ) {
		for ( i=0, ien=ext.length ; i<ien ; i++ ) {
			out = ext[i]( settings, opts, out );
		}
	}

	return _unique( out );
};


var _selector_opts = function ( opts )
{
	if ( ! opts ) {
		opts = {};
	}

	// Backwards compatibility for 1.9- which used the terminology filter rather
	// than search
	if ( opts.filter && opts.search === undefined ) {
		opts.search = opts.filter;
	}

	return $.extend( {
		search: 'none',
		order: 'current',
		page: 'all'
	}, opts );
};


var _selector_first = function ( inst )
{
	// Reduce the API instance to the first item found
	for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
		if ( inst[i].length > 0 ) {
			// Assign the first element to the first item in the instance
			// and truncate the instance and context
			inst[0] = inst[i];
			inst[0].length = 1;
			inst.length = 1;
			inst.context = [ inst.context[i] ];

			return inst;
		}
	}

	// Not found - return an empty instance
	inst.length = 0;
	return inst;
};


var _selector_row_indexes = function ( settings, opts )
{
	var
		i, ien, tmp, a=[],
		displayFiltered = settings.aiDisplay,
		displayMaster = settings.aiDisplayMaster;

	var
		search = opts.search,  // none, applied, removed
		order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
		page   = opts.page;    // all, current

	if ( _fnDataSource( settings ) == 'ssp' ) {
		// In server-side processing mode, most options are irrelevant since
		// rows not shown don't exist and the index order is the applied order
		// Removed is a special case - for consistency just return an empty
		// array
		return search === 'removed' ?
			[] :
			_range( 0, displayMaster.length );
	}
	else if ( page == 'current' ) {
		// Current page implies that order=current and filter=applied, since it is
		// fairly senseless otherwise, regardless of what order and search actually
		// are
		for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
			a.push( displayFiltered[i] );
		}
	}
	else if ( order == 'current' || order == 'applied' ) {
		if ( search == 'none') {
			a = displayMaster.slice();
		}
		else if ( search == 'applied' ) {
			a = displayFiltered.slice();
		}
		else if ( search == 'removed' ) {
			// O(n+m) solution by creating a hash map
			var displayFilteredMap = {};

			for ( var i=0, ien=displayFiltered.length ; i<ien ; i++ ) {
				displayFilteredMap[displayFiltered[i]] = null;
			}

			a = $.map( displayMaster, function (el) {
				return ! displayFilteredMap.hasOwnProperty(el) ?
					el :
					null;
			} );
		}
	}
	else if ( order == 'index' || order == 'original' ) {
		for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			if ( search == 'none' ) {
				a.push( i );
			}
			else { // applied | removed
				tmp = $.inArray( i, displayFiltered );

				if ((tmp === -1 && search == 'removed') ||
					(tmp >= 0   && search == 'applied') )
				{
					a.push( i );
				}
			}
		}
	}

	return a;
};


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */
var __row_selector = function ( settings, selector, opts )
{
	var rows;
	var run = function ( sel ) {
		var selInt = _intVal( sel );
		var i, ien;
		var aoData = settings.aoData;

		// Short cut - selector is a number and no options provided (default is
		// all records, so no need to check if the index is in there, since it
		// must be - dev error if the index doesn't exist).
		if ( selInt !== null && ! opts ) {
			return [ selInt ];
		}

		if ( ! rows ) {
			rows = _selector_row_indexes( settings, opts );
		}

		if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
			// Selector - integer
			return [ selInt ];
		}
		else if ( sel === null || sel === undefined || sel === '' ) {
			// Selector - none
			return rows;
		}

		// Selector - function
		if ( typeof sel === 'function' ) {
			return $.map( rows, function (idx) {
				var row = aoData[ idx ];
				return sel( idx, row._aData, row.nTr ) ? idx : null;
			} );
		}

		// Selector - node
		if ( sel.nodeName ) {
			var rowIdx = sel._DT_RowIndex;  // Property added by DT for fast lookup
			var cellIdx = sel._DT_CellIndex;

			if ( rowIdx !== undefined ) {
				// Make sure that the row is actually still present in the table
				return aoData[ rowIdx ] && aoData[ rowIdx ].nTr === sel ?
					[ rowIdx ] :
					[];
			}
			else if ( cellIdx ) {
				return aoData[ cellIdx.row ] && aoData[ cellIdx.row ].nTr === sel.parentNode ?
					[ cellIdx.row ] :
					[];
			}
			else {
				var host = $(sel).closest('*[data-dt-row]');
				return host.length ?
					[ host.data('dt-row') ] :
					[];
			}
		}

		// ID selector. Want to always be able to select rows by id, regardless
		// of if the tr element has been created or not, so can't rely upon
		// jQuery here - hence a custom implementation. This does not match
		// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
		// but to select it using a CSS selector engine (like Sizzle or
		// querySelect) it would need to need to be escaped for some characters.
		// DataTables simplifies this for row selectors since you can select
		// only a row. A # indicates an id any anything that follows is the id -
		// unescaped.
		if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
			// get row index from id
			var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
			if ( rowObj !== undefined ) {
				return [ rowObj.idx ];
			}

			// need to fall through to jQuery in case there is DOM id that
			// matches
		}
		
		// Get nodes in the order from the `rows` array with null values removed
		var nodes = _removeEmpty(
			_pluck_order( settings.aoData, rows, 'nTr' )
		);

		// Selector - jQuery selector string, array of nodes or jQuery object/
		// As jQuery's .filter() allows jQuery objects to be passed in filter,
		// it also allows arrays, so this will cope with all three options
		return $(nodes)
			.filter( sel )
			.map( function () {
				return this._DT_RowIndex;
			} )
			.toArray();
	};

	return _selector_run( 'row', selector, run, settings, opts );
};


_api_register( 'rows()', function ( selector, opts ) {
	// argument shifting
	if ( selector === undefined ) {
		selector = '';
	}
	else if ( $.isPlainObject( selector ) ) {
		opts = selector;
		selector = '';
	}

	opts = _selector_opts( opts );

	var inst = this.iterator( 'table', function ( settings ) {
		return __row_selector( settings, selector, opts );
	}, 1 );

	// Want argument shifting here and in __row_selector?
	inst.selector.rows = selector;
	inst.selector.opts = opts;

	return inst;
} );

_api_register( 'rows().nodes()', function () {
	return this.iterator( 'row', function ( settings, row ) {
		return settings.aoData[ row ].nTr || undefined;
	}, 1 );
} );

_api_register( 'rows().data()', function () {
	return this.iterator( true, 'rows', function ( settings, rows ) {
		return _pluck_order( settings.aoData, rows, '_aData' );
	}, 1 );
} );

_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
	return this.iterator( 'row', function ( settings, row ) {
		var r = settings.aoData[ row ];
		return type === 'search' ? r._aFilterData : r._aSortData;
	}, 1 );
} );

_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
	return this.iterator( 'row', function ( settings, row ) {
		_fnInvalidate( settings, row, src );
	} );
} );

_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
	return this.iterator( 'row', function ( settings, row ) {
		return row;
	}, 1 );
} );

_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
	var a = [];
	var context = this.context;

	// `iterator` will drop undefined values, but in this case we want them
	for ( var i=0, ien=context.length ; i<ien ; i++ ) {
		for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
			var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
			a.push( (hash === true ? '#' : '' )+ id );
		}
	}

	return new _Api( context, a );
} );

_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
	var that = this;

	this.iterator( 'row', function ( settings, row, thatIdx ) {
		var data = settings.aoData;
		var rowData = data[ row ];
		var i, ien, j, jen;
		var loopRow, loopCells;

		data.splice( row, 1 );

		// Update the cached indexes
		for ( i=0, ien=data.length ; i<ien ; i++ ) {
			loopRow = data[i];
			loopCells = loopRow.anCells;

			// Rows
			if ( loopRow.nTr !== null ) {
				loopRow.nTr._DT_RowIndex = i;
			}

			// Cells
			if ( loopCells !== null ) {
				for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
					loopCells[j]._DT_CellIndex.row = i;
				}
			}
		}

		// Delete from the display arrays
		_fnDeleteIndex( settings.aiDisplayMaster, row );
		_fnDeleteIndex( settings.aiDisplay, row );
		_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes

		// For server-side processing tables - subtract the deleted row from the count
		if ( settings._iRecordsDisplay > 0 ) {
			settings._iRecordsDisplay--;
		}

		// Check for an 'overflow' they case for displaying the table
		_fnLengthOverflow( settings );

		// Remove the row's ID reference if there is one
		var id = settings.rowIdFn( rowData._aData );
		if ( id !== undefined ) {
			delete settings.aIds[ id ];
		}
	} );

	this.iterator( 'table', function ( settings ) {
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			settings.aoData[i].idx = i;
		}
	} );

	return this;
} );


_api_register( 'rows.add()', function ( rows ) {
	var newRows = this.iterator( 'table', function ( settings ) {
			var row, i, ien;
			var out = [];

			for ( i=0, ien=rows.length ; i<ien ; i++ ) {
				row = rows[i];

				if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
					out.push( _fnAddTr( settings, row )[0] );
				}
				else {
					out.push( _fnAddData( settings, row ) );
				}
			}

			return out;
		}, 1 );

	// Return an Api.rows() extended instance, so rows().nodes() etc can be used
	var modRows = this.rows( -1 );
	modRows.pop();
	$.merge( modRows, newRows );

	return modRows;
} );





/**
 *
 */
_api_register( 'row()', function ( selector, opts ) {
	return _selector_first( this.rows( selector, opts ) );
} );


_api_register( 'row().data()', function ( data ) {
	var ctx = this.context;

	if ( data === undefined ) {
		// Get
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ]._aData :
			undefined;
	}

	// Set
	var row = ctx[0].aoData[ this[0] ];
	row._aData = data;

	// If the DOM has an id, and the data source is an array
	if ( Array.isArray( data ) && row.nTr && row.nTr.id ) {
		_fnSetObjectDataFn( ctx[0].rowId )( data, row.nTr.id );
	}

	// Automatically invalidate
	_fnInvalidate( ctx[0], this[0], 'data' );

	return this;
} );


_api_register( 'row().node()', function () {
	var ctx = this.context;

	return ctx.length && this.length ?
		ctx[0].aoData[ this[0] ].nTr || null :
		null;
} );


_api_register( 'row.add()', function ( row ) {
	// Allow a jQuery object to be passed in - only a single row is added from
	// it though - the first element in the set
	if ( row instanceof $ && row.length ) {
		row = row[0];
	}

	var rows = this.iterator( 'table', function ( settings ) {
		if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
			return _fnAddTr( settings, row )[0];
		}
		return _fnAddData( settings, row );
	} );

	// Return an Api.rows() extended instance, with the newly added row selected
	return this.row( rows[0] );
} );


$(document).on('plugin-init.dt', function (e, context) {
	var api = new _Api( context );
	var namespace = 'on-plugin-init';
	var stateSaveParamsEvent = 'stateSaveParams.' + namespace;
	var destroyEvent = 'destroy. ' + namespace;

	api.on( stateSaveParamsEvent, function ( e, settings, d ) {
		// This could be more compact with the API, but it is a lot faster as a simple
		// internal loop
		var idFn = settings.rowIdFn;
		var data = settings.aoData;
		var ids = [];

		for (var i=0 ; i<data.length ; i++) {
			if (data[i]._detailsShow) {
				ids.push( '#' + idFn(data[i]._aData) );
			}
		}

		d.childRows = ids;
	});

	api.on( destroyEvent, function () {
		api.off(stateSaveParamsEvent + ' ' + destroyEvent);
	});

	var loaded = api.state.loaded();

	if ( loaded && loaded.childRows ) {
		api
			.rows( $.map(loaded.childRows, function (id){
				return id.replace(/:/g, '\\:')
			}) )
			.every( function () {
				_fnCallbackFire( context, null, 'requestChild', [ this ] )
			});
	}
});

var __details_add = function ( ctx, row, data, klass )
{
	// Convert to array of TR elements
	var rows = [];
	var addRow = function ( r, k ) {
		// Recursion to allow for arrays of jQuery objects
		if ( Array.isArray( r ) || r instanceof $ ) {
			for ( var i=0, ien=r.length ; i<ien ; i++ ) {
				addRow( r[i], k );
			}
			return;
		}

		// If we get a TR element, then just add it directly - up to the dev
		// to add the correct number of columns etc
		if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
			rows.push( r );
		}
		else {
			// Otherwise create a row with a wrapper
			var created = $('<tr><td></td></tr>').addClass( k );
			$('td', created)
				.addClass( k )
				.html( r )
				[0].colSpan = _fnVisbleColumns( ctx );

			rows.push( created[0] );
		}
	};

	addRow( data, klass );

	if ( row._details ) {
		row._details.detach();
	}

	row._details = $(rows);

	// If the children were already shown, that state should be retained
	if ( row._detailsShow ) {
		row._details.insertAfter( row.nTr );
	}
};


// Make state saving of child row details async to allow them to be batch processed
var __details_state = DataTable.util.throttle(
	function (ctx) {
		_fnSaveState( ctx[0] )
	},
	500
);


var __details_remove = function ( api, idx )
{
	var ctx = api.context;

	if ( ctx.length ) {
		var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];

		if ( row && row._details ) {
			row._details.remove();

			row._detailsShow = undefined;
			row._details = undefined;
			$( row.nTr ).removeClass( 'dt-hasChild' );
			__details_state( ctx );
		}
	}
};


var __details_display = function ( api, show ) {
	var ctx = api.context;

	if ( ctx.length && api.length ) {
		var row = ctx[0].aoData[ api[0] ];

		if ( row._details ) {
			row._detailsShow = show;

			if ( show ) {
				row._details.insertAfter( row.nTr );
				$( row.nTr ).addClass( 'dt-hasChild' );
			}
			else {
				row._details.detach();
				$( row.nTr ).removeClass( 'dt-hasChild' );
			}

			_fnCallbackFire( ctx[0], null, 'childRow', [ show, api.row( api[0] ) ] )

			__details_events( ctx[0] );
			__details_state( ctx );
		}
	}
};


var __details_events = function ( settings )
{
	var api = new _Api( settings );
	var namespace = '.dt.DT_details';
	var drawEvent = 'draw'+namespace;
	var colvisEvent = 'column-sizing'+namespace;
	var destroyEvent = 'destroy'+namespace;
	var data = settings.aoData;

	api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );

	if ( _pluck( data, '_details' ).length > 0 ) {
		// On each draw, insert the required elements into the document
		api.on( drawEvent, function ( e, ctx ) {
			if ( settings !== ctx ) {
				return;
			}

			api.rows( {page:'current'} ).eq(0).each( function (idx) {
				// Internal data grab
				var row = data[ idx ];

				if ( row._detailsShow ) {
					row._details.insertAfter( row.nTr );
				}
			} );
		} );

		// Column visibility change - update the colspan
		api.on( colvisEvent, function ( e, ctx, idx, vis ) {
			if ( settings !== ctx ) {
				return;
			}

			// Update the colspan for the details rows (note, only if it already has
			// a colspan)
			var row, visible = _fnVisbleColumns( ctx );

			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				row = data[i];

				if ( row._details ) {
					row._details.each(function () {
						var el = $(this).children('td');

						if (el.length == 1) {
							el.attr('colspan', visible);
						}
					});
				}
			}
		} );

		// Table destroyed - nuke any child rows
		api.on( destroyEvent, function ( e, ctx ) {
			if ( settings !== ctx ) {
				return;
			}

			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				if ( data[i]._details ) {
					__details_remove( api, i );
				}
			}
		} );
	}
};

// Strings for the method names to help minification
var _emp = '';
var _child_obj = _emp+'row().child';
var _child_mth = _child_obj+'()';

// data can be:
//  tr
//  string
//  jQuery or array of any of the above
_api_register( _child_mth, function ( data, klass ) {
	var ctx = this.context;

	if ( data === undefined ) {
		// get
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ]._details :
			undefined;
	}
	else if ( data === true ) {
		// show
		this.child.show();
	}
	else if ( data === false ) {
		// remove
		__details_remove( this );
	}
	else if ( ctx.length && this.length ) {
		// set
		__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
	}

	return this;
} );


_api_register( [
	_child_obj+'.show()',
	_child_mth+'.show()' // only when `child()` was called with parameters (without
], function ( show ) {   // it returns an object and this method is not executed)
	__details_display( this, true );
	return this;
} );


_api_register( [
	_child_obj+'.hide()',
	_child_mth+'.hide()' // only when `child()` was called with parameters (without
], function () {         // it returns an object and this method is not executed)
	__details_display( this, false );
	return this;
} );


_api_register( [
	_child_obj+'.remove()',
	_child_mth+'.remove()' // only when `child()` was called with parameters (without
], function () {           // it returns an object and this method is not executed)
	__details_remove( this );
	return this;
} );


_api_register( _child_obj+'.isShown()', function () {
	var ctx = this.context;

	if ( ctx.length && this.length ) {
		// _detailsShown as false or undefined will fall through to return false
		return ctx[0].aoData[ this[0] ]._detailsShow || false;
	}
	return false;
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */

// can be an array of these items, comma separated list, or an array of comma
// separated lists

var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;


// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var __columnData = function ( settings, column, r1, r2, rows ) {
	var a = [];
	for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
		a.push( _fnGetCellData( settings, rows[row], column ) );
	}
	return a;
};


var __column_selector = function ( settings, selector, opts )
{
	var
		columns = settings.aoColumns,
		names = _pluck( columns, 'sName' ),
		nodes = _pluck( columns, 'nTh' );

	var run = function ( s ) {
		var selInt = _intVal( s );

		// Selector - all
		if ( s === '' ) {
			return _range( columns.length );
		}

		// Selector - index
		if ( selInt !== null ) {
			return [ selInt >= 0 ?
				selInt : // Count from left
				columns.length + selInt // Count from right (+ because its a negative value)
			];
		}

		// Selector = function
		if ( typeof s === 'function' ) {
			var rows = _selector_row_indexes( settings, opts );

			return $.map( columns, function (col, idx) {
				return s(
						idx,
						__columnData( settings, idx, 0, 0, rows ),
						nodes[ idx ]
					) ? idx : null;
			} );
		}

		// jQuery or string selector
		var match = typeof s === 'string' ?
			s.match( __re_column_selector ) :
			'';

		if ( match ) {
			switch( match[2] ) {
				case 'visIdx':
				case 'visible':
					var idx = parseInt( match[1], 10 );
					// Visible index given, convert to column index
					if ( idx < 0 ) {
						// Counting from the right
						var visColumns = $.map( columns, function (col,i) {
							return col.bVisible ? i : null;
						} );
						return [ visColumns[ visColumns.length + idx ] ];
					}
					// Counting from the left
					return [ _fnVisibleToColumnIndex( settings, idx ) ];

				case 'name':
					// match by name. `names` is column index complete and in order
					return $.map( names, function (name, i) {
						return name === match[1] ? i : null;
					} );

				default:
					return [];
			}
		}

		// Cell in the table body
		if ( s.nodeName && s._DT_CellIndex ) {
			return [ s._DT_CellIndex.column ];
		}

		// jQuery selector on the TH elements for the columns
		var jqResult = $( nodes )
			.filter( s )
			.map( function () {
				return $.inArray( this, nodes ); // `nodes` is column index complete and in order
			} )
			.toArray();

		if ( jqResult.length || ! s.nodeName ) {
			return jqResult;
		}

		// Otherwise a node which might have a `dt-column` data attribute, or be
		// a child or such an element
		var host = $(s).closest('*[data-dt-column]');
		return host.length ?
			[ host.data('dt-column') ] :
			[];
	};

	return _selector_run( 'column', selector, run, settings, opts );
};


var __setColumnVis = function ( settings, column, vis ) {
	var
		cols = settings.aoColumns,
		col  = cols[ column ],
		data = settings.aoData,
		row, cells, i, ien, tr;

	// Get
	if ( vis === undefined ) {
		return col.bVisible;
	}

	// Set
	// No change
	if ( col.bVisible === vis ) {
		return;
	}

	if ( vis ) {
		// Insert column
		// Need to decide if we should use appendChild or insertBefore
		var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );

		for ( i=0, ien=data.length ; i<ien ; i++ ) {
			tr = data[i].nTr;
			cells = data[i].anCells;

			if ( tr ) {
				// insertBefore can act like appendChild if 2nd arg is null
				tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
			}
		}
	}
	else {
		// Remove column
		$( _pluck( settings.aoData, 'anCells', column ) ).detach();
	}

	// Common actions
	col.bVisible = vis;
};


_api_register( 'columns()', function ( selector, opts ) {
	// argument shifting
	if ( selector === undefined ) {
		selector = '';
	}
	else if ( $.isPlainObject( selector ) ) {
		opts = selector;
		selector = '';
	}

	opts = _selector_opts( opts );

	var inst = this.iterator( 'table', function ( settings ) {
		return __column_selector( settings, selector, opts );
	}, 1 );

	// Want argument shifting here and in _row_selector?
	inst.selector.cols = selector;
	inst.selector.opts = opts;

	return inst;
} );

_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
	return this.iterator( 'column', function ( settings, column ) {
		return settings.aoColumns[column].nTh;
	}, 1 );
} );

_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
	return this.iterator( 'column', function ( settings, column ) {
		return settings.aoColumns[column].nTf;
	}, 1 );
} );

_api_registerPlural( 'columns().data()', 'column().data()', function () {
	return this.iterator( 'column-rows', __columnData, 1 );
} );

_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
	return this.iterator( 'column', function ( settings, column ) {
		return settings.aoColumns[column].mData;
	}, 1 );
} );

_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
	return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
		return _pluck_order( settings.aoData, rows,
			type === 'search' ? '_aFilterData' : '_aSortData', column
		);
	}, 1 );
} );

_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
	return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
		return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
	}, 1 );
} );

_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
	var that = this;
	var ret = this.iterator( 'column', function ( settings, column ) {
		if ( vis === undefined ) {
			return settings.aoColumns[ column ].bVisible;
		} // else
		__setColumnVis( settings, column, vis );
	} );

	// Group the column visibility changes
	if ( vis !== undefined ) {
		this.iterator( 'table', function ( settings ) {
			// Redraw the header after changes
			_fnDrawHead( settings, settings.aoHeader );
			_fnDrawHead( settings, settings.aoFooter );
	
			// Update colspan for no records display. Child rows and extensions will use their own
			// listeners to do this - only need to update the empty table item here
			if ( ! settings.aiDisplay.length ) {
				$(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
			}
	
			_fnSaveState( settings );

			// Second loop once the first is done for events
			that.iterator( 'column', function ( settings, column ) {
				_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
			} );

			if ( calc === undefined || calc ) {
				that.columns.adjust();
			}
		});
	}

	return ret;
} );

_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
	return this.iterator( 'column', function ( settings, column ) {
		return type === 'visible' ?
			_fnColumnIndexToVisible( settings, column ) :
			column;
	}, 1 );
} );

_api_register( 'columns.adjust()', function () {
	return this.iterator( 'table', function ( settings ) {
		_fnAdjustColumnSizing( settings );
	}, 1 );
} );

_api_register( 'column.index()', function ( type, idx ) {
	if ( this.context.length !== 0 ) {
		var ctx = this.context[0];

		if ( type === 'fromVisible' || type === 'toData' ) {
			return _fnVisibleToColumnIndex( ctx, idx );
		}
		else if ( type === 'fromData' || type === 'toVisible' ) {
			return _fnColumnIndexToVisible( ctx, idx );
		}
	}
} );

_api_register( 'column()', function ( selector, opts ) {
	return _selector_first( this.columns( selector, opts ) );
} );

var __cell_selector = function ( settings, selector, opts )
{
	var data = settings.aoData;
	var rows = _selector_row_indexes( settings, opts );
	var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
	var allCells = $(_flatten( [], cells ));
	var row;
	var columns = settings.aoColumns.length;
	var a, i, ien, j, o, host;

	var run = function ( s ) {
		var fnSelector = typeof s === 'function';

		if ( s === null || s === undefined || fnSelector ) {
			// All cells and function selectors
			a = [];

			for ( i=0, ien=rows.length ; i<ien ; i++ ) {
				row = rows[i];

				for ( j=0 ; j<columns ; j++ ) {
					o = {
						row: row,
						column: j
					};

					if ( fnSelector ) {
						// Selector - function
						host = data[ row ];

						if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
							a.push( o );
						}
					}
					else {
						// Selector - all
						a.push( o );
					}
				}
			}

			return a;
		}
		
		// Selector - index
		if ( $.isPlainObject( s ) ) {
			// Valid cell index and its in the array of selectable rows
			return s.column !== undefined && s.row !== undefined && $.inArray( s.row, rows ) !== -1 ?
				[s] :
				[];
		}

		// Selector - jQuery filtered cells
		var jqResult = allCells
			.filter( s )
			.map( function (i, el) {
				return { // use a new object, in case someone changes the values
					row:    el._DT_CellIndex.row,
					column: el._DT_CellIndex.column
 				};
			} )
			.toArray();

		if ( jqResult.length || ! s.nodeName ) {
			return jqResult;
		}

		// Otherwise the selector is a node, and there is one last option - the
		// element might be a child of an element which has dt-row and dt-column
		// data attributes
		host = $(s).closest('*[data-dt-row]');
		return host.length ?
			[ {
				row: host.data('dt-row'),
				column: host.data('dt-column')
			} ] :
			[];
	};

	return _selector_run( 'cell', selector, run, settings, opts );
};




_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
	// Argument shifting
	if ( $.isPlainObject( rowSelector ) ) {
		// Indexes
		if ( rowSelector.row === undefined ) {
			// Selector options in first parameter
			opts = rowSelector;
			rowSelector = null;
		}
		else {
			// Cell index objects in first parameter
			opts = columnSelector;
			columnSelector = null;
		}
	}
	if ( $.isPlainObject( columnSelector ) ) {
		opts = columnSelector;
		columnSelector = null;
	}

	// Cell selector
	if ( columnSelector === null || columnSelector === undefined ) {
		return this.iterator( 'table', function ( settings ) {
			return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
		} );
	}

	// The default built in options need to apply to row and columns
	var internalOpts = opts ? {
		page: opts.page,
		order: opts.order,
		search: opts.search
	} : {};

	// Row + column selector
	var columns = this.columns( columnSelector, internalOpts );
	var rows = this.rows( rowSelector, internalOpts );
	var i, ien, j, jen;

	var cellsNoOpts = this.iterator( 'table', function ( settings, idx ) {
		var a = [];

		for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
			for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
				a.push( {
					row:    rows[idx][i],
					column: columns[idx][j]
				} );
			}
		}

		return a;
	}, 1 );

	// There is currently only one extension which uses a cell selector extension
	// It is a _major_ performance drag to run this if it isn't needed, so this is
	// an extension specific check at the moment
	var cells = opts && opts.selected ?
		this.cells( cellsNoOpts, opts ) :
		cellsNoOpts;

	$.extend( cells.selector, {
		cols: columnSelector,
		rows: rowSelector,
		opts: opts
	} );

	return cells;
} );


_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
	return this.iterator( 'cell', function ( settings, row, column ) {
		var data = settings.aoData[ row ];

		return data && data.anCells ?
			data.anCells[ column ] :
			undefined;
	}, 1 );
} );


_api_register( 'cells().data()', function () {
	return this.iterator( 'cell', function ( settings, row, column ) {
		return _fnGetCellData( settings, row, column );
	}, 1 );
} );


_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
	type = type === 'search' ? '_aFilterData' : '_aSortData';

	return this.iterator( 'cell', function ( settings, row, column ) {
		return settings.aoData[ row ][ type ][ column ];
	}, 1 );
} );


_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
	return this.iterator( 'cell', function ( settings, row, column ) {
		return _fnGetCellData( settings, row, column, type );
	}, 1 );
} );


_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
	return this.iterator( 'cell', function ( settings, row, column ) {
		return {
			row: row,
			column: column,
			columnVisible: _fnColumnIndexToVisible( settings, column )
		};
	}, 1 );
} );


_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
	return this.iterator( 'cell', function ( settings, row, column ) {
		_fnInvalidate( settings, row, src, column );
	} );
} );



_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
	return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
} );


_api_register( 'cell().data()', function ( data ) {
	var ctx = this.context;
	var cell = this[0];

	if ( data === undefined ) {
		// Get
		return ctx.length && cell.length ?
			_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
			undefined;
	}

	// Set
	_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
	_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );

	return this;
} );



/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 *//**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 *//**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 *//**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */
_api_register( 'order()', function ( order, dir ) {
	var ctx = this.context;

	if ( order === undefined ) {
		// get
		return ctx.length !== 0 ?
			ctx[0].aaSorting :
			undefined;
	}

	// set
	if ( typeof order === 'number' ) {
		// Simple column / direction passed in
		order = [ [ order, dir ] ];
	}
	else if ( order.length && ! Array.isArray( order[0] ) ) {
		// Arguments passed in (list of 1D arrays)
		order = Array.prototype.slice.call( arguments );
	}
	// otherwise a 2D array was passed in

	return this.iterator( 'table', function ( settings ) {
		settings.aaSorting = order.slice();
	} );
} );


/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */
_api_register( 'order.listener()', function ( node, column, callback ) {
	return this.iterator( 'table', function ( settings ) {
		_fnSortAttachListener( settings, node, column, callback );
	} );
} );


_api_register( 'order.fixed()', function ( set ) {
	if ( ! set ) {
		var ctx = this.context;
		var fixed = ctx.length ?
			ctx[0].aaSortingFixed :
			undefined;

		return Array.isArray( fixed ) ?
			{ pre: fixed } :
			fixed;
	}

	return this.iterator( 'table', function ( settings ) {
		settings.aaSortingFixed = $.extend( true, {}, set );
	} );
} );


// Order by the selected column(s)
_api_register( [
	'columns().order()',
	'column().order()'
], function ( dir ) {
	var that = this;

	return this.iterator( 'table', function ( settings, i ) {
		var sort = [];

		$.each( that[i], function (j, col) {
			sort.push( [ col, dir ] );
		} );

		settings.aaSorting = sort;
	} );
} );



_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
	var ctx = this.context;

	if ( input === undefined ) {
		// get
		return ctx.length !== 0 ?
			ctx[0].oPreviousSearch.sSearch :
			undefined;
	}

	// set
	return this.iterator( 'table', function ( settings ) {
		if ( ! settings.oFeatures.bFilter ) {
			return;
		}

		_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
			"sSearch": input+"",
			"bRegex":  regex === null ? false : regex,
			"bSmart":  smart === null ? true  : smart,
			"bCaseInsensitive": caseInsen === null ? true : caseInsen
		} ), 1 );
	} );
} );


_api_registerPlural(
	'columns().search()',
	'column().search()',
	function ( input, regex, smart, caseInsen ) {
		return this.iterator( 'column', function ( settings, column ) {
			var preSearch = settings.aoPreSearchCols;

			if ( input === undefined ) {
				// get
				return preSearch[ column ].sSearch;
			}

			// set
			if ( ! settings.oFeatures.bFilter ) {
				return;
			}

			$.extend( preSearch[ column ], {
				"sSearch": input+"",
				"bRegex":  regex === null ? false : regex,
				"bSmart":  smart === null ? true  : smart,
				"bCaseInsensitive": caseInsen === null ? true : caseInsen
			} );

			_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
		} );
	}
);

/*
 * State API methods
 */

_api_register( 'state()', function () {
	return this.context.length ?
		this.context[0].oSavedState :
		null;
} );


_api_register( 'state.clear()', function () {
	return this.iterator( 'table', function ( settings ) {
		// Save an empty object
		settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
	} );
} );


_api_register( 'state.loaded()', function () {
	return this.context.length ?
		this.context[0].oLoadedState :
		null;
} );


_api_register( 'state.save()', function () {
	return this.iterator( 'table', function ( settings ) {
		_fnSaveState( settings );
	} );
} );



/**
 * Set the jQuery or window object to be used by DataTables
 *
 * @param {*} module Library / container object
 * @param {string} [type] Library or container type `lib`, `win` or `datetime`.
 *   If not provided, automatic detection is attempted.
 */
DataTable.use = function (module, type) {
	if (type === 'lib' || module.fn) {
		$ = module;
	}
	else if (type == 'win' || module.document) {
		window = module;
		document = module.document;
	}
	else if (type === 'datetime' || module.type === 'DateTime') {
		DataTable.DateTime = module;
	}
}

/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */
DataTable.factory = function (root, jq) {
	var is = false;

	// Test if the first parameter is a window object
	if (root && root.document) {
		window = root;
		document = root.document;
	}

	// Test if the second parameter is a jQuery object
	if (jq && jq.fn && jq.fn.jquery) {
		$ = jq;
		is = true;
	}

	return is;
}

/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */
DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
{
	var aThis = DataTable.version.split('.');
	var aThat = version.split('.');
	var iThis, iThat;

	for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
		iThis = parseInt( aThis[i], 10 ) || 0;
		iThat = parseInt( aThat[i], 10 ) || 0;

		// Parts are the same, keep comparing
		if (iThis === iThat) {
			continue;
		}

		// Parts are different, return immediately
		return iThis > iThat;
	}

	return true;
};


/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */
DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
{
	var t = $(table).get(0);
	var is = false;

	if ( table instanceof DataTable.Api ) {
		return true;
	}

	$.each( DataTable.settings, function (i, o) {
		var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
		var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;

		if ( o.nTable === t || head === t || foot === t ) {
			is = true;
		}
	} );

	return is;
};


/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */
DataTable.tables = DataTable.fnTables = function ( visible )
{
	var api = false;

	if ( $.isPlainObject( visible ) ) {
		api = visible.api;
		visible = visible.visible;
	}

	var a = $.map( DataTable.settings, function (o) {
		if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
			return o.nTable;
		}
	} );

	return api ?
		new _Api( a ) :
		a;
};


/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */
DataTable.camelToHungarian = _fnCamelToHungarian;



/**
 *
 */
_api_register( '$()', function ( selector, opts ) {
	var
		rows   = this.rows( opts ).nodes(), // Get all rows
		jqRows = $(rows);

	return $( [].concat(
		jqRows.filter( selector ).toArray(),
		jqRows.find( selector ).toArray()
	) );
} );


// jQuery functions to operate on the tables
$.each( [ 'on', 'one', 'off' ], function (i, key) {
	_api_register( key+'()', function ( /* event, handler */ ) {
		var args = Array.prototype.slice.call(arguments);

		// Add the `dt` namespace automatically if it isn't already present
		args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
			return ! e.match(/\.dt\b/) ?
				e+'.dt' :
				e;
			} ).join( ' ' );

		var inst = $( this.tables().nodes() );
		inst[key].apply( inst, args );
		return this;
	} );
} );


_api_register( 'clear()', function () {
	return this.iterator( 'table', function ( settings ) {
		_fnClearTable( settings );
	} );
} );


_api_register( 'settings()', function () {
	return new _Api( this.context, this.context );
} );


_api_register( 'init()', function () {
	var ctx = this.context;
	return ctx.length ? ctx[0].oInit : null;
} );


_api_register( 'data()', function () {
	return this.iterator( 'table', function ( settings ) {
		return _pluck( settings.aoData, '_aData' );
	} ).flatten();
} );


_api_register( 'destroy()', function ( remove ) {
	remove = remove || false;

	return this.iterator( 'table', function ( settings ) {
		var classes   = settings.oClasses;
		var table     = settings.nTable;
		var tbody     = settings.nTBody;
		var thead     = settings.nTHead;
		var tfoot     = settings.nTFoot;
		var jqTable   = $(table);
		var jqTbody   = $(tbody);
		var jqWrapper = $(settings.nTableWrapper);
		var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
		var i, ien;

		// Flag to note that the table is currently being destroyed - no action
		// should be taken
		settings.bDestroying = true;

		// Fire off the destroy callbacks for plug-ins etc
		_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );

		// If not being removed from the document, make all columns visible
		if ( ! remove ) {
			new _Api( settings ).columns().visible( true );
		}

		// Blitz all `DT` namespaced events (these are internal events, the
		// lowercase, `dt` events are user subscribed and they are responsible
		// for removing them
		jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
		$(window).off('.DT-'+settings.sInstance);

		// When scrolling we had to break the table up - restore it
		if ( table != thead.parentNode ) {
			jqTable.children('thead').detach();
			jqTable.append( thead );
		}

		if ( tfoot && table != tfoot.parentNode ) {
			jqTable.children('tfoot').detach();
			jqTable.append( tfoot );
		}

		settings.aaSorting = [];
		settings.aaSortingFixed = [];
		_fnSortingClasses( settings );

		$( rows ).removeClass( settings.asStripeClasses.join(' ') );

		$('th, td', thead).removeClass( classes.sSortable+' '+
			classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
		);

		// Add the TR elements back into the table in their original order
		jqTbody.children().detach();
		jqTbody.append( rows );

		var orig = settings.nTableWrapper.parentNode;

		// Remove the DataTables generated nodes, events and classes
		var removedMethod = remove ? 'remove' : 'detach';
		jqTable[ removedMethod ]();
		jqWrapper[ removedMethod ]();

		// If we need to reattach the table to the document
		if ( ! remove && orig ) {
			// insertBefore acts like appendChild if !arg[1]
			orig.insertBefore( table, settings.nTableReinsertBefore );

			// Restore the width of the original table - was read from the style property,
			// so we can restore directly to that
			jqTable
				.css( 'width', settings.sDestroyWidth )
				.removeClass( classes.sTable );

			// If the were originally stripe classes - then we add them back here.
			// Note this is not fool proof (for example if not all rows had stripe
			// classes - but it's a good effort without getting carried away
			ien = settings.asDestroyStripes.length;

			if ( ien ) {
				jqTbody.children().each( function (i) {
					$(this).addClass( settings.asDestroyStripes[i % ien] );
				} );
			}
		}

		/* Remove the settings object from the settings array */
		var idx = $.inArray( settings, DataTable.settings );
		if ( idx !== -1 ) {
			DataTable.settings.splice( idx, 1 );
		}
	} );
} );


// Add the `every()` method for rows, columns and cells in a compact form
$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
	_api_register( type+'s().every()', function ( fn ) {
		var opts = this.selector.opts;
		var api = this;

		return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
			// Rows and columns:
			//  arg1 - index
			//  arg2 - table counter
			//  arg3 - loop counter
			//  arg4 - undefined
			// Cells:
			//  arg1 - row index
			//  arg2 - column index
			//  arg3 - table counter
			//  arg4 - loop counter
			fn.call(
				api[ type ](
					arg1,
					type==='cell' ? arg2 : opts,
					type==='cell' ? opts : undefined
				),
				arg1, arg2, arg3, arg4
			);
		} );
	} );
} );


// i18n method for extensions to be able to use the language object from the
// DataTable
_api_register( 'i18n()', function ( token, def, plural ) {
	var ctx = this.context[0];
	var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );

	if ( resolved === undefined ) {
		resolved = def;
	}

	if ( plural !== undefined && $.isPlainObject( resolved ) ) {
		resolved = resolved[ plural ] !== undefined ?
			resolved[ plural ] :
			resolved._;
	}

	return typeof resolved === 'string'
		? resolved.replace( '%d', plural ) // nb: plural might be undefined,
		: resolved;
} );
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See https://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */
DataTable.version = "1.13.11";

/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */
DataTable.settings = [];

/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */
DataTable.models = {};



/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */
DataTable.models.oSearch = {
	/**
	 * Flag to indicate if the filtering should be case insensitive or not
	 *  @type boolean
	 *  @default true
	 */
	"bCaseInsensitive": true,

	/**
	 * Applied search term
	 *  @type string
	 *  @default <i>Empty string</i>
	 */
	"sSearch": "",

	/**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 *  @type boolean
	 *  @default false
	 */
	"bRegex": false,

	/**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 *  @type boolean
	 *  @default true
	 */
	"bSmart": true,

	/**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 *  @type boolean
	 *  @default false
	 */
	"return": false
};




/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */
DataTable.models.oRow = {
	/**
	 * TR element for the row
	 *  @type node
	 *  @default null
	 */
	"nTr": null,

	/**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 *  @type array nodes
	 *  @default []
	 */
	"anCells": null,

	/**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 *  @type array|object
	 *  @default []
	 */
	"_aData": [],

	/**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 *  @type array
	 *  @default null
	 *  @private
	 */
	"_aSortData": null,

	/**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 *  @type array
	 *  @default null
	 *  @private
	 */
	"_aFilterData": null,

	/**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 *  @type array
	 *  @default null
	 *  @private
	 */
	"_sFilterRow": null,

	/**
	 * Cache of the class name that DataTables has applied to the row, so we
	 * can quickly look at this variable rather than needing to do a DOM check
	 * on className for the nTr property.
	 *  @type string
	 *  @default <i>Empty string</i>
	 *  @private
	 */
	"_sRowStripe": "",

	/**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 *  @type string
	 *  @default null
	 *  @private
	 */
	"src": null,

	/**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 *  @type integer
	 *  @default -1
	 *  @private
	 */
	"idx": -1
};


/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */
DataTable.models.oColumn = {
	/**
	 * Column index. This could be worked out on-the-fly with $.inArray, but it
	 * is faster to just hold it as a variable
	 *  @type integer
	 *  @default null
	 */
	"idx": null,

	/**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 *  @type array
	 */
	"aDataSort": null,

	/**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 *  @type array
	 */
	"asSorting": null,

	/**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 *  @type boolean
	 */
	"bSearchable": null,

	/**
	 * Flag to indicate if the column is sortable or not.
	 *  @type boolean
	 */
	"bSortable": null,

	/**
	 * Flag to indicate if the column is currently visible in the table or not
	 *  @type boolean
	 */
	"bVisible": null,

	/**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 *  @type string
	 *  @default null
	 *  @private
	 */
	"_sManualType": null,

	/**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 *  @type boolean
	 *  @default false
	 *  @private
	 */
	"_bAttrSrc": false,

	/**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 *  @type function
	 *  @param {element} nTd The TD node that has been created
	 *  @param {*} sData The Data for the cell
	 *  @param {array|object} oData The data for the whole row
	 *  @param {int} iRow The row index for the aoData data store
	 *  @default null
	 */
	"fnCreatedCell": null,

	/**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 *  @type function
	 *  @param {array|object} oData The data array/object for the array
	 *    (i.e. aoData[]._aData)
	 *  @param {string} sSpecific The specific data type you want to get -
	 *    'display', 'type' 'filter' 'sort'
	 *  @returns {*} The data for the cell from the given row's data
	 *  @default null
	 */
	"fnGetData": null,

	/**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 *  @type function
	 *  @param {array|object} oData The data array/object for the array
	 *    (i.e. aoData[]._aData)
	 *  @param {*} sValue Value to set
	 *  @default null
	 */
	"fnSetData": null,

	/**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 *  @type function|int|string|null
	 *  @default null
	 */
	"mData": null,

	/**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 *  @type function|int|string|null
	 *  @default null
	 */
	"mRender": null,

	/**
	 * Unique header TH/TD element for this column - this is what the sorting
	 * listener is attached to (if sorting is enabled.)
	 *  @type node
	 *  @default null
	 */
	"nTh": null,

	/**
	 * Unique footer TH/TD element for this column (if there is one). Not used
	 * in DataTables as such, but can be used for plug-ins to reference the
	 * footer for each column.
	 *  @type node
	 *  @default null
	 */
	"nTf": null,

	/**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 *  @type string
	 *  @default null
	 */
	"sClass": null,

	/**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 *  @type string
	 */
	"sContentPadding": null,

	/**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 *  @type string
	 *  @default null
	 */
	"sDefaultContent": null,

	/**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 *  @type string
	 */
	"sName": null,

	/**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 *  @type string
	 *  @default std
	 */
	"sSortDataType": 'std',

	/**
	 * Class to be applied to the header element when sorting on this column
	 *  @type string
	 *  @default null
	 */
	"sSortingClass": null,

	/**
	 * Class to be applied to the header element when sorting on this column -
	 * when jQuery UI theming is used.
	 *  @type string
	 *  @default null
	 */
	"sSortingClassJUI": null,

	/**
	 * Title of the column - what is seen in the TH element (nTh).
	 *  @type string
	 */
	"sTitle": null,

	/**
	 * Column sorting and filtering type
	 *  @type string
	 *  @default null
	 */
	"sType": null,

	/**
	 * Width of the column
	 *  @type string
	 *  @default null
	 */
	"sWidth": null,

	/**
	 * Width of the column when it was first "encountered"
	 *  @type string
	 *  @default null
	 */
	"sWidthOrig": null
};


/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a Javascript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */

/**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */
DataTable.defaults = {
	/**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in Javascript, for
	 * example with a custom Ajax call.
	 *  @type array
	 *  @default null
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.data
	 *
	 *  @example
	 *    // Using a 2D array data source
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "data": [
	 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
	 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
	 *        ],
	 *        "columns": [
	 *          { "title": "Engine" },
	 *          { "title": "Browser" },
	 *          { "title": "Platform" },
	 *          { "title": "Version" },
	 *          { "title": "Grade" }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using an array of objects as a data source (`data`)
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "data": [
	 *          {
	 *            "engine":   "Trident",
	 *            "browser":  "Internet Explorer 4.0",
	 *            "platform": "Win 95+",
	 *            "version":  4,
	 *            "grade":    "X"
	 *          },
	 *          {
	 *            "engine":   "Trident",
	 *            "browser":  "Internet Explorer 5.0",
	 *            "platform": "Win 95+",
	 *            "version":  5,
	 *            "grade":    "C"
	 *          }
	 *        ],
	 *        "columns": [
	 *          { "title": "Engine",   "data": "engine" },
	 *          { "title": "Browser",  "data": "browser" },
	 *          { "title": "Platform", "data": "platform" },
	 *          { "title": "Version",  "data": "version" },
	 *          { "title": "Grade",    "data": "grade" }
	 *        ]
	 *      } );
	 *    } );
	 */
	"aaData": null,


	/**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 *  @type array
	 *  @default [[0,'asc']]
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.order
	 *
	 *  @example
	 *    // Sort by 3rd column first, and then 4th column
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "order": [[2,'asc'], [3,'desc']]
	 *      } );
	 *    } );
	 *
	 *    // No initial sorting
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "order": []
	 *      } );
	 *    } );
	 */
	"aaSorting": [[0,'asc']],


	/**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 *  @type array
	 *  @default null
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.orderFixed
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "orderFixed": [[0,'asc']]
	 *      } );
	 *    } )
	 */
	"aaSortingFixed": [],


	/**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use Javascript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table. This supersedes `sAjaxDataProp` from
	 *   DataTables 1.9-.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 *
	 * Note that this supersedes `fnServerData` from DataTables 1.9-.
	 *
	 *  @type string|object|function
	 *  @default null
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.ajax
	 *  @since 1.10.0
	 *
	 * @example
	 *   // Get JSON data from a file via Ajax.
	 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
	 *   $('#example').dataTable( {
	 *     "ajax": "data.json"
	 *   } );
	 *
	 * @example
	 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
	 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "dataSrc": "tableData"
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
	 *   // from a plain array rather than an array in an object
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "dataSrc": ""
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Manipulate the data returned from the server - add a link to data
	 *   // (note this can, should, be done using `render` for the column - this
	 *   // is just a simple example of how the data can be manipulated).
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "dataSrc": function ( json ) {
	 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
	 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
	 *         }
	 *         return json;
	 *       }
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Add data to the request
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "data": function ( d ) {
	 *         return {
	 *           "extra_search": $('#extra').val()
	 *         };
	 *       }
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Send request as POST
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "type": "POST"
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Get the data from localStorage (could interface with a form for
	 *   // adding, editing and removing rows).
	 *   $('#example').dataTable( {
	 *     "ajax": function (data, callback, settings) {
	 *       callback(
	 *         JSON.parse( localStorage.getItem('dataTablesData') )
	 *       );
	 *     }
	 *   } );
	 */
	"ajax": null,


	/**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 *  @type array
	 *  @default [ 10, 25, 50, 100 ]
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.lengthMenu
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
	 *      } );
	 *    } );
	 */
	"aLengthMenu": [ 10, 25, 50, 100 ],


	/**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 *  @member
	 *
	 *  @name DataTable.defaults.column
	 */
	"aoColumns": null,

	/**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 *  @member
	 *
	 *  @name DataTable.defaults.columnDefs
	 */
	"aoColumnDefs": null,


	/**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 *  @type array
	 *  @default []
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.searchCols
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "searchCols": [
	 *          null,
	 *          { "search": "My filter" },
	 *          null,
	 *          { "search": "^[0-9]", "escapeRegex": false }
	 *        ]
	 *      } );
	 *    } )
	 */
	"aoSearchCols": [],


	/**
	 * An array of CSS classes that should be applied to displayed rows. This
	 * array may be of any length, and DataTables will apply each class
	 * sequentially, looping when required.
	 *  @type array
	 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
	 *    options</i>
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.stripeClasses
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
	 *      } );
	 *    } )
	 */
	"asStripeClasses": null,


	/**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.autoWidth
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "autoWidth": false
	 *      } );
	 *    } );
	 */
	"bAutoWidth": true,


	/**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.deferRender
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajax": "sources/arrays.txt",
	 *        "deferRender": true
	 *      } );
	 *    } );
	 */
	"bDeferRender": false,


	/**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.destroy
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "srollY": "200px",
	 *        "paginate": false
	 *      } );
	 *
	 *      // Some time later....
	 *      $('#example').dataTable( {
	 *        "filter": false,
	 *        "destroy": true
	 *      } );
	 *    } );
	 */
	"bDestroy": false,


	/**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.searching
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "searching": false
	 *      } );
	 *    } );
	 */
	"bFilter": true,


	/**
	 * Enable or disable the table information display. This shows information
	 * about the data that is currently visible on the page, including information
	 * about filtered data if that action is being performed.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.info
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "info": false
	 *      } );
	 *    } );
	 */
	"bInfo": true,


	/**
	 * Allows the end user to select the size of a formatted page from a select
	 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.lengthChange
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "lengthChange": false
	 *      } );
	 *    } );
	 */
	"bLengthChange": true,


	/**
	 * Enable or disable pagination.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.paging
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "paging": false
	 *      } );
	 *    } );
	 */
	"bPaginate": true,


	/**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.processing
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "processing": true
	 *      } );
	 *    } );
	 */
	"bProcessing": false,


	/**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.retrieve
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      initTable();
	 *      tableActions();
	 *    } );
	 *
	 *    function initTable ()
	 *    {
	 *      return $('#example').dataTable( {
	 *        "scrollY": "200px",
	 *        "paginate": false,
	 *        "retrieve": true
	 *      } );
	 *    }
	 *
	 *    function tableActions ()
	 *    {
	 *      var table = initTable();
	 *      // perform API operations with oTable
	 *    }
	 */
	"bRetrieve": false,


	/**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.scrollCollapse
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollY": "200",
	 *        "scrollCollapse": true
	 *      } );
	 *    } );
	 */
	"bScrollCollapse": false,


	/**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverSide
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "serverSide": true,
	 *        "ajax": "xhr.php"
	 *      } );
	 *    } );
	 */
	"bServerSide": false,


	/**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.ordering
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "ordering": false
	 *      } );
	 *    } );
	 */
	"bSort": true,


	/**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.orderMulti
	 *
	 *  @example
	 *    // Disable multiple column sorting ability
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "orderMulti": false
	 *      } );
	 *    } );
	 */
	"bSortMulti": true,


	/**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.orderCellsTop
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "orderCellsTop": true
	 *      } );
	 *    } );
	 */
	"bSortCellsTop": false,


	/**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.orderClasses
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "orderClasses": false
	 *      } );
	 *    } );
	 */
	"bSortClasses": true,


	/**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display display will match what thy had previously set up.
	 *
	 * Due to the use of `localStorage` the default state saving is not supported
	 * in IE6 or 7. If state saving is required in those browsers, use
	 * `stateSaveCallback` to provide a storage solution such as cookies.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.stateSave
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "stateSave": true
	 *      } );
	 *    } );
	 */
	"bStateSave": false,


	/**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 *  @type function
	 *  @param {node} row "TR" element for the current row
	 *  @param {array} data Raw data array for this row
	 *  @param {int} dataIndex The index of this row in the internal aoData array
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.createdRow
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "createdRow": function( row, data, dataIndex ) {
	 *          // Bold the grade for all 'A' grade browsers
	 *          if ( data[4] == "A" )
	 *          {
	 *            $('td:eq(4)', row).html( '<b>A</b>' );
	 *          }
	 *        }
	 *      } );
	 *    } );
	 */
	"fnCreatedRow": null,


	/**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.drawCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "drawCallback": function( settings ) {
	 *          alert( 'DataTables has redrawn the table' );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnDrawCallback": null,


	/**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 *  @type function
	 *  @param {node} foot "TR" element for the footer
	 *  @param {array} data Full table data (as derived from the original HTML)
	 *  @param {int} start Index for the current display starting point in the
	 *    display array
	 *  @param {int} end Index for the current display ending point in the
	 *    display array
	 *  @param {array int} display Index array to translate the visual position
	 *    to the full data array
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.footerCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "footerCallback": function( tfoot, data, start, end, display ) {
	 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
	 *        }
	 *      } );
	 *    } )
	 */
	"fnFooterCallback": null,


	/**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 *  @type function
	 *  @member
	 *  @param {int} toFormat number to be formatted
	 *  @returns {string} formatted string for DataTables to show the number
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.formatNumber
	 *
	 *  @example
	 *    // Format a number using a single quote for the separator (note that
	 *    // this can also be done with the language.thousands option)
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "formatNumber": function ( toFormat ) {
	 *          return toFormat.toString().replace(
	 *            /\B(?=(\d{3})+(?!\d))/g, "'"
	 *          );
	 *        };
	 *      } );
	 *    } );
	 */
	"fnFormatNumber": function ( toFormat ) {
		return toFormat.toString().replace(
			/\B(?=(\d{3})+(?!\d))/g,
			this.oLanguage.sThousands
		);
	},


	/**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 *  @type function
	 *  @param {node} head "TR" element for the header
	 *  @param {array} data Full table data (as derived from the original HTML)
	 *  @param {int} start Index for the current display starting point in the
	 *    display array
	 *  @param {int} end Index for the current display ending point in the
	 *    display array
	 *  @param {array int} display Index array to translate the visual position
	 *    to the full data array
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.headerCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "fheaderCallback": function( head, data, start, end, display ) {
	 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
	 *        }
	 *      } );
	 *    } )
	 */
	"fnHeaderCallback": null,


	/**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 *  @type function
	 *  @param {object} oSettings DataTables settings object
	 *  @param {int} start Starting position in data for the draw
	 *  @param {int} end End position in data for the draw
	 *  @param {int} max Total number of rows in the table (regardless of
	 *    filtering)
	 *  @param {int} total Total number of rows in the data set, after filtering
	 *  @param {string} pre The string that DataTables has formatted using it's
	 *    own rules
	 *  @returns {string} The string to be displayed in the information element.
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.infoCallback
	 *
	 *  @example
	 *    $('#example').dataTable( {
	 *      "infoCallback": function( settings, start, end, max, total, pre ) {
	 *        return start +" to "+ end;
	 *      }
	 *    } );
	 */
	"fnInfoCallback": null,


	/**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} json The JSON object request from the server - only
	 *    present if client-side Ajax sourced data is used
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.initComplete
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "initComplete": function(settings, json) {
	 *          alert( 'DataTables has finished its initialisation.' );
	 *        }
	 *      } );
	 *    } )
	 */
	"fnInitComplete": null,


	/**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @returns {boolean} False will cancel the draw, anything else (including no
	 *    return) will allow it to complete.
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.preDrawCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "preDrawCallback": function( settings ) {
	 *          if ( $('#test').val() == 1 ) {
	 *            return false;
	 *          }
	 *        }
	 *      } );
	 *    } );
	 */
	"fnPreDrawCallback": null,


	/**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 *  @type function
	 *  @param {node} row "TR" element for the current row
	 *  @param {array} data Raw data array for this row
	 *  @param {int} displayIndex The display index for the current table draw
	 *  @param {int} displayIndexFull The index of the data in the full list of
	 *    rows (after filtering)
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.rowCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
	 *          // Bold the grade for all 'A' grade browsers
	 *          if ( data[4] == "A" ) {
	 *            $('td:eq(4)', row).html( '<b>A</b>' );
	 *          }
	 *        }
	 *      } );
	 *    } );
	 */
	"fnRowCallback": null,


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * This parameter allows you to override the default function which obtains
	 * the data from the server so something more suitable for your application.
	 * For example you could use POST data, or pull information from a Gears or
	 * AIR database.
	 *  @type function
	 *  @member
	 *  @param {string} source HTTP source to obtain the data from (`ajax`)
	 *  @param {array} data A key/value pair object containing the data to send
	 *    to the server
	 *  @param {function} callback to be called on completion of the data get
	 *    process that will draw the data on the page.
	 *  @param {object} settings DataTables settings object
	 *
	 *  @dtopt Callbacks
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverData
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"fnServerData": null,


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 *  It is often useful to send extra data to the server when making an Ajax
	 * request - for example custom filtering information, and this callback
	 * function makes it trivial to send extra information to the server. The
	 * passed in parameter is the data set that has been constructed by
	 * DataTables, and you can add to this or modify it as you require.
	 *  @type function
	 *  @param {array} data Data array (array of objects which are name/value
	 *    pairs) that has been constructed by DataTables and will be sent to the
	 *    server. In the case of Ajax sourced data with server-side processing
	 *    this will be an empty array, for server-side processing there will be a
	 *    significant number of parameters!
	 *  @returns {undefined} Ensure that you modify the data array passed in,
	 *    as this is passed by reference.
	 *
	 *  @dtopt Callbacks
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverParams
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"fnServerParams": null,


	/**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 *  @type function
	 *  @member
	 *  @param {object} settings DataTables settings object
	 *  @param {object} callback Callback that can be executed when done. It
	 *    should be passed the loaded state object.
	 *  @return {object} The DataTables state object to be loaded
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateLoadCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoadCallback": function (settings, callback) {
	 *          $.ajax( {
	 *            "url": "/state_load",
	 *            "dataType": "json",
	 *            "success": function (json) {
	 *              callback( json );
	 *            }
	 *          } );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateLoadCallback": function ( settings ) {
		try {
			return JSON.parse(
				(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
					'DataTables_'+settings.sInstance+'_'+location.pathname
				)
			);
		} catch (e) {
			return {};
		}
	},


	/**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object that is to be loaded
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateLoadParams
	 *
	 *  @example
	 *    // Remove a saved filter, so filtering is never loaded
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoadParams": function (settings, data) {
	 *          data.oSearch.sSearch = "";
	 *        }
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Disallow state loading by returning false
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoadParams": function (settings, data) {
	 *          return false;
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateLoadParams": null,


	/**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object that was loaded
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateLoaded
	 *
	 *  @example
	 *    // Show an alert with the filtering value that was saved
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoaded": function (settings, data) {
	 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateLoaded": null,


	/**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 *  @type function
	 *  @member
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object to be saved
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateSaveCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateSaveCallback": function (settings, data) {
	 *          // Send an Ajax request to the server with the state object
	 *          $.ajax( {
	 *            "url": "/state_save",
	 *            "data": data,
	 *            "dataType": "json",
	 *            "method": "POST"
	 *            "success": function () {}
	 *          } );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateSaveCallback": function ( settings, data ) {
		try {
			(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
				'DataTables_'+settings.sInstance+'_'+location.pathname,
				JSON.stringify( data )
			);
		} catch (e) {}
	},


	/**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object to be saved
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateSaveParams
	 *
	 *  @example
	 *    // Remove a saved filter, so filtering is never saved
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateSaveParams": function (settings, data) {
	 *          data.oSearch.sSearch = "";
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateSaveParams": null,


	/**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 *  @type int
	 *  @default 7200 <i>(2 hours)</i>
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.stateDuration
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateDuration": 60*60*24; // 1 day
	 *      } );
	 *    } )
	 */
	"iStateDuration": 7200,


	/**
	 * When enabled DataTables will not make a request to the server for the first
	 * page draw - rather it will use the data already on the page (no sorting etc
	 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
	 * is used to indicate that deferred loading is required, but it is also used
	 * to tell DataTables how many records there are in the full table (allowing
	 * the information element and pagination to be displayed correctly). In the case
	 * where a filtering is applied to the table on initial load, this can be
	 * indicated by giving the parameter as an array, where the first element is
	 * the number of records available after filtering and the second element is the
	 * number of records without filtering (allowing the table information element
	 * to be shown correctly).
	 *  @type int | array
	 *  @default null
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.deferLoading
	 *
	 *  @example
	 *    // 57 records available in the table, no filtering applied
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "serverSide": true,
	 *        "ajax": "scripts/server_processing.php",
	 *        "deferLoading": 57
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "serverSide": true,
	 *        "ajax": "scripts/server_processing.php",
	 *        "deferLoading": [ 57, 100 ],
	 *        "search": {
	 *          "search": "my_filter"
	 *        }
	 *      } );
	 *    } );
	 */
	"iDeferLoading": null,


	/**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 *  @type int
	 *  @default 10
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.pageLength
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "pageLength": 50
	 *      } );
	 *    } )
	 */
	"iDisplayLength": 10,


	/**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 *  @type int
	 *  @default 0
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.displayStart
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "displayStart": 20
	 *      } );
	 *    } )
	 */
	"iDisplayStart": 0,


	/**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 *  @type int
	 *  @default 0
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.tabIndex
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "tabIndex": 1
	 *      } );
	 *    } );
	 */
	"iTabIndex": 0,


	/**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 *  @namespace
	 *  @name DataTable.defaults.classes
	 */
	"oClasses": {},


	/**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 *  @namespace
	 *  @name DataTable.defaults.language
	 */
	"oLanguage": {
		/**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 *  @namespace
		 *  @name DataTable.defaults.language.aria
		 */
		"oAria": {
			/**
			 * ARIA label that is added to the table headers when the column may be
			 * sorted ascending by activing the column (click or return when focused).
			 * Note that the column header is prefixed to this string.
			 *  @type string
			 *  @default : activate to sort column ascending
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.aria.sortAscending
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "aria": {
			 *            "sortAscending": " - click/return to sort ascending"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sSortAscending": ": activate to sort column ascending",

			/**
			 * ARIA label that is added to the table headers when the column may be
			 * sorted descending by activing the column (click or return when focused).
			 * Note that the column header is prefixed to this string.
			 *  @type string
			 *  @default : activate to sort column ascending
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.aria.sortDescending
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "aria": {
			 *            "sortDescending": " - click/return to sort descending"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sSortDescending": ": activate to sort column descending"
		},

		/**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 *  @namespace
		 *  @name DataTable.defaults.language.paginate
		 */
		"oPaginate": {
			/**
			 * Text to use when using the 'full_numbers' type of pagination for the
			 * button to take the user to the first page.
			 *  @type string
			 *  @default First
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.first
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "first": "First page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sFirst": "First",


			/**
			 * Text to use when using the 'full_numbers' type of pagination for the
			 * button to take the user to the last page.
			 *  @type string
			 *  @default Last
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.last
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "last": "Last page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sLast": "Last",


			/**
			 * Text to use for the 'next' pagination button (to take the user to the
			 * next page).
			 *  @type string
			 *  @default Next
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.next
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "next": "Next page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sNext": "Next",


			/**
			 * Text to use for the 'previous' pagination button (to take the user to
			 * the previous page).
			 *  @type string
			 *  @default Previous
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.previous
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "previous": "Previous page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sPrevious": "Previous"
		},

		/**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 *  @type string
		 *  @default No data available in table
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.emptyTable
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "emptyTable": "No data available in table"
		 *        }
		 *      } );
		 *    } );
		 */
		"sEmptyTable": "No data available in table",


		/**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 *
		 *  @type string
		 *  @default Showing _START_ to _END_ of _TOTAL_ entries
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.info
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "info": "Showing page _PAGE_ of _PAGES_"
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",


		/**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 *  @type string
		 *  @default Showing 0 to 0 of 0 entries
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.infoEmpty
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "infoEmpty": "No entries to show"
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfoEmpty": "Showing 0 to 0 of 0 entries",


		/**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 *  @type string
		 *  @default (filtered from _MAX_ total entries)
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.infoFiltered
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "infoFiltered": " - filtering from _MAX_ records"
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfoFiltered": "(filtered from _MAX_ total entries)",


		/**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.infoPostFix
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "infoPostFix": "All records shown are derived from real information."
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfoPostFix": "",


		/**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.decimal
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "decimal": ","
		 *          "thousands": "."
		 *        }
		 *      } );
		 *    } );
		 */
		"sDecimal": "",


		/**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 *  @type string
		 *  @default ,
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.thousands
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "thousands": "'"
		 *        }
		 *      } );
		 *    } );
		 */
		"sThousands": ",",


		/**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 *  @type string
		 *  @default Show _MENU_ entries
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.lengthMenu
		 *
		 *  @example
		 *    // Language change only
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "lengthMenu": "Display _MENU_ records"
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Language and options change
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "lengthMenu": 'Display <select>'+
		 *            '<option value="10">10</option>'+
		 *            '<option value="20">20</option>'+
		 *            '<option value="30">30</option>'+
		 *            '<option value="40">40</option>'+
		 *            '<option value="50">50</option>'+
		 *            '<option value="-1">All</option>'+
		 *            '</select> records'
		 *        }
		 *      } );
		 *    } );
		 */
		"sLengthMenu": "Show _MENU_ entries",


		/**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 *  @type string
		 *  @default Loading...
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.loadingRecords
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "loadingRecords": "Please wait - loading..."
		 *        }
		 *      } );
		 *    } );
		 */
		"sLoadingRecords": "Loading...",


		/**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 *  @type string
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.processing
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "processing": "DataTables is currently busy"
		 *        }
		 *      } );
		 *    } );
		 */
		"sProcessing": "",


		/**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 *  @type string
		 *  @default Search:
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.search
		 *
		 *  @example
		 *    // Input text box will be appended at the end automatically
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "search": "Filter records:"
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Specify where the filter should appear
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "search": "Apply filter _INPUT_ to table"
		 *        }
		 *      } );
		 *    } );
		 */
		"sSearch": "Search:",


		/**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */
		"sSearchPlaceholder": "",


		/**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 *  @type string
		 *  @default <i>Empty string - i.e. disabled</i>
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.url
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "url": "https://www.sprymedia.co.uk/dataTables/lang.txt"
		 *        }
		 *      } );
		 *    } );
		 */
		"sUrl": "",


		/**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 *  @type string
		 *  @default No matching records found
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.zeroRecords
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "zeroRecords": "No records to display"
		 *        }
		 *      } );
		 *    } );
		 */
		"sZeroRecords": "No matching records found"
	},


	/**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 *  @namespace
	 *  @extends DataTable.models.oSearch
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.search
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "search": {"search": "Initial search"}
	 *      } );
	 *    } )
	 */
	"oSearch": $.extend( {}, DataTable.models.oSearch ),


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * By default DataTables will look for the property `data` (or `aaData` for
	 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
	 * source or for server-side processing - this parameter allows that
	 * property to be changed. You can use Javascript dotted object notation to
	 * get a data source for multiple levels of nesting.
	 *  @type string
	 *  @default data
	 *
	 *  @dtopt Options
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.ajaxDataProp
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"sAjaxDataProp": "data",


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * You can instruct DataTables to load data from an external
	 * source using this parameter (use aData if you want to pass data in you
	 * already have). Simply provide a url a JSON object can be obtained from.
	 *  @type string
	 *  @default null
	 *
	 *  @dtopt Options
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.ajaxSource
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"sAjaxSource": null,


	/**
	 * This initialisation variable allows you to specify exactly where in the
	 * DOM you want DataTables to inject the various controls it adds to the page
	 * (for example you might want the pagination controls at the top of the
	 * table). DIV elements (with or without a custom class) can also be added to
	 * aid styling. The follow syntax is used:
	 *   <ul>
	 *     <li>The following options are allowed:
	 *       <ul>
	 *         <li>'l' - Length changing</li>
	 *         <li>'f' - Filtering input</li>
	 *         <li>'t' - The table!</li>
	 *         <li>'i' - Information</li>
	 *         <li>'p' - Pagination</li>
	 *         <li>'r' - pRocessing</li>
	 *       </ul>
	 *     </li>
	 *     <li>The following constants are allowed:
	 *       <ul>
	 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
	 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
	 *       </ul>
	 *     </li>
	 *     <li>The following syntax is expected:
	 *       <ul>
	 *         <li>'&lt;' and '&gt;' - div elements</li>
	 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
	 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
	 *       </ul>
	 *     </li>
	 *     <li>Examples:
	 *       <ul>
	 *         <li>'&lt;"wrapper"flipt&gt;'</li>
	 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
	 *       </ul>
	 *     </li>
	 *   </ul>
	 *  @type string
	 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
	 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.dom
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
	 *      } );
	 *    } );
	 */
	"sDom": "lfrtip",


	/**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 *  @type integer
	 *  @default 0
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.searchDelay
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "searchDelay": 200
	 *      } );
	 *    } )
	 */
	"searchDelay": null,


	/**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 *  
	 * Further methods can be added using {@link DataTable.ext.oPagination}.
	 *  @type string
	 *  @default simple_numbers
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.pagingType
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "pagingType": "full_numbers"
	 *      } );
	 *    } )
	 */
	"sPaginationType": "simple_numbers",


	/**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 *  @type boolean|string
	 *  @default <i>blank string - i.e. disabled</i>
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.scrollX
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollX": true,
	 *        "scrollCollapse": true
	 *      } );
	 *    } );
	 */
	"sScrollX": "",


	/**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 *  @type string
	 *  @default <i>blank string - i.e. disabled</i>
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.scrollXInner
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollX": "100%",
	 *        "scrollXInner": "110%"
	 *      } );
	 *    } );
	 */
	"sScrollXInner": "",


	/**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 *  @type string
	 *  @default <i>blank string - i.e. disabled</i>
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.scrollY
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollY": "200px",
	 *        "paginate": false
	 *      } );
	 *    } );
	 */
	"sScrollY": "",


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 *  @type string
	 *  @default GET
	 *
	 *  @dtopt Options
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverMethod
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"sServerMethod": "GET",


	/**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 *  @type string|object
	 *  @default null
	 *
	 *  @name DataTable.defaults.renderer
	 *
	 */
	"renderer": null,


	/**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 *  @type string
	 *  @default DT_RowId
	 *
	 *  @name DataTable.defaults.rowId
	 */
	"rowId": "DT_RowId"
};

_fnHungarianMap( DataTable.defaults );



/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */

/**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */
DataTable.defaults.column = {
	/**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 *  @type array|int
	 *  @default null <i>Takes the value of the column index automatically</i>
	 *
	 *  @name DataTable.defaults.column.orderData
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
	 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
	 *          { "orderData": 2, "targets": [ 2 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "orderData": [ 0, 1 ] },
	 *          { "orderData": [ 1, 0 ] },
	 *          { "orderData": 2 },
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"aDataSort": null,
	"iDataSort": -1,


	/**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 *  @type array
	 *  @default [ 'asc', 'desc' ]
	 *
	 *  @name DataTable.defaults.column.orderSequence
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
	 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
	 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          { "orderSequence": [ "asc" ] },
	 *          { "orderSequence": [ "desc", "asc", "asc" ] },
	 *          { "orderSequence": [ "desc" ] },
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"asSorting": [ 'asc', 'desc' ],


	/**
	 * Enable or disable filtering on the data in this column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @name DataTable.defaults.column.searchable
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "searchable": false, "targets": [ 0 ] }
	 *        ] } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "searchable": false },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ] } );
	 *    } );
	 */
	"bSearchable": true,


	/**
	 * Enable or disable ordering on this column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @name DataTable.defaults.column.orderable
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderable": false, "targets": [ 0 ] }
	 *        ] } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "orderable": false },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ] } );
	 *    } );
	 */
	"bSortable": true,


	/**
	 * Enable or disable the display of this column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @name DataTable.defaults.column.visible
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "visible": false, "targets": [ 0 ] }
	 *        ] } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "visible": false },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ] } );
	 *    } );
	 */
	"bVisible": true,


	/**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 *  @type function
	 *  @param {element} td The TD node that has been created
	 *  @param {*} cellData The Data for the cell
	 *  @param {array|object} rowData The data for the whole row
	 *  @param {int} row The row index for the aoData data store
	 *  @param {int} col The column index for aoColumns
	 *
	 *  @name DataTable.defaults.column.createdCell
	 *  @dtopt Columns
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [3],
	 *          "createdCell": function (td, cellData, rowData, row, col) {
	 *            if ( cellData == "1.7" ) {
	 *              $(td).css('color', 'blue')
	 *            }
	 *          }
	 *        } ]
	 *      });
	 *    } );
	 */
	"fnCreatedCell": null,


	/**
	 * This parameter has been replaced by `data` in DataTables to ensure naming
	 * consistency. `dataProp` can still be used, as there is backwards
	 * compatibility in DataTables for this option, but it is strongly
	 * recommended that you use `data` in preference to `dataProp`.
	 *  @name DataTable.defaults.column.dataProp
	 */


	/**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 *
	 *  @type string|int|function|null
	 *  @default null <i>Use automatically calculated column index</i>
	 *
	 *  @name DataTable.defaults.column.data
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Read table data from objects
	 *    // JSON structure for each row:
	 *    //   {
	 *    //      "engine": {value},
	 *    //      "browser": {value},
	 *    //      "platform": {value},
	 *    //      "version": {value},
	 *    //      "grade": {value}
	 *    //   }
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajaxSource": "sources/objects.txt",
	 *        "columns": [
	 *          { "data": "engine" },
	 *          { "data": "browser" },
	 *          { "data": "platform" },
	 *          { "data": "version" },
	 *          { "data": "grade" }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Read information from deeply nested objects
	 *    // JSON structure for each row:
	 *    //   {
	 *    //      "engine": {value},
	 *    //      "browser": {value},
	 *    //      "platform": {
	 *    //         "inner": {value}
	 *    //      },
	 *    //      "details": [
	 *    //         {value}, {value}
	 *    //      ]
	 *    //   }
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajaxSource": "sources/deep.txt",
	 *        "columns": [
	 *          { "data": "engine" },
	 *          { "data": "browser" },
	 *          { "data": "platform.inner" },
	 *          { "data": "details.0" },
	 *          { "data": "details.1" }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `data` as a function to provide different information for
	 *    // sorting, filtering and display. In this case, currency (price)
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": function ( source, type, val ) {
	 *            if (type === 'set') {
	 *              source.price = val;
	 *              // Store the computed display and filter values for efficiency
	 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
	 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
	 *              return;
	 *            }
	 *            else if (type === 'display') {
	 *              return source.price_display;
	 *            }
	 *            else if (type === 'filter') {
	 *              return source.price_filter;
	 *            }
	 *            // 'sort', 'type' and undefined all just use the integer
	 *            return source.price;
	 *          }
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using default content
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": null,
	 *          "defaultContent": "Click to edit"
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using array notation - outputting a list from an array
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": "name[, ]"
	 *        } ]
	 *      } );
	 *    } );
	 *
	 */
	"mData": null,


	/**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 *
	 *  @type string|int|function|object|null
	 *  @default null Use the data source value.
	 *
	 *  @name DataTable.defaults.column.render
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Create a comma separated list from an array of objects
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajaxSource": "sources/deep.txt",
	 *        "columns": [
	 *          { "data": "engine" },
	 *          { "data": "browser" },
	 *          {
	 *            "data": "platform",
	 *            "render": "[, ].name"
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Execute a function to obtain data
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": null, // Use the full data source object for the renderer's source
	 *          "render": "browserName()"
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // As an object, extracting different data for the different types
	 *    // This would be used with a data source such as:
	 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
	 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
	 *    // (which has both forms) is used for filtering for if a user inputs either format, while
	 *    // the formatted phone number is the one that is shown in the table.
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": null, // Use the full data source object for the renderer's source
	 *          "render": {
	 *            "_": "phone",
	 *            "filter": "phone_filter",
	 *            "display": "phone_display"
	 *          }
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Use as a function to create a link from the data source
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": "download_link",
	 *          "render": function ( data, type, full ) {
	 *            return '<a href="'+data+'">Download</a>';
	 *          }
	 *        } ]
	 *      } );
	 *    } );
	 */
	"mRender": null,


	/**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 *  @type string
	 *  @default td
	 *
	 *  @name DataTable.defaults.column.cellType
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Make the first column use TH cells
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "cellType": "th"
	 *        } ]
	 *      } );
	 *    } );
	 */
	"sCellType": "td",


	/**
	 * Class to give to each cell in this column.
	 *  @type string
	 *  @default <i>Empty string</i>
	 *
	 *  @name DataTable.defaults.column.class
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "class": "my_class", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "class": "my_class" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sClass": "",

	/**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 *  @type string
	 *  @default <i>Empty string<i>
	 *
	 *  @name DataTable.defaults.column.contentPadding
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          null,
	 *          null,
	 *          {
	 *            "contentPadding": "mmm"
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sContentPadding": "",


	/**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 *  @type string
	 *  @default null
	 *
	 *  @name DataTable.defaults.column.defaultContent
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          {
	 *            "data": null,
	 *            "defaultContent": "Edit",
	 *            "targets": [ -1 ]
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          null,
	 *          null,
	 *          {
	 *            "data": null,
	 *            "defaultContent": "Edit"
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sDefaultContent": null,


	/**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 *  @type string
	 *  @default <i>Empty string</i>
	 *
	 *  @name DataTable.defaults.column.name
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "name": "engine", "targets": [ 0 ] },
	 *          { "name": "browser", "targets": [ 1 ] },
	 *          { "name": "platform", "targets": [ 2 ] },
	 *          { "name": "version", "targets": [ 3 ] },
	 *          { "name": "grade", "targets": [ 4 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "name": "engine" },
	 *          { "name": "browser" },
	 *          { "name": "platform" },
	 *          { "name": "version" },
	 *          { "name": "grade" }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sName": "",


	/**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 *  @type string
	 *  @default std
	 *
	 *  @name DataTable.defaults.column.orderDataType
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
	 *          { "type": "numeric", "targets": [ 3 ] },
	 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
	 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          null,
	 *          { "orderDataType": "dom-text" },
	 *          { "orderDataType": "dom-text", "type": "numeric" },
	 *          { "orderDataType": "dom-select" },
	 *          { "orderDataType": "dom-checkbox" }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sSortDataType": "std",


	/**
	 * The title of this column.
	 *  @type string
	 *  @default null <i>Derived from the 'TH' value for this column in the
	 *    original HTML table.</i>
	 *
	 *  @name DataTable.defaults.column.title
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "title": "My column title", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "title": "My column title" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sTitle": null,


	/**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by Javascript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 *  @type string
	 *  @default null <i>Auto-detected from raw data</i>
	 *
	 *  @name DataTable.defaults.column.type
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "type": "html", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "type": "html" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sType": null,


	/**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 *  @type string
	 *  @default null <i>Automatic</i>
	 *
	 *  @name DataTable.defaults.column.width
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "width": "20%", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "width": "20%" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sWidth": null
};

_fnHungarianMap( DataTable.defaults.column );



/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 *  @namespace
 *  @todo Really should attach the settings object to individual instances so we
 *    don't need to create new instances on each $().dataTable() call (if the
 *    table already exists). It would also save passing oSettings around and
 *    into every single function. However, this is a very significant
 *    architecture change for DataTables and will almost certainly break
 *    backwards compatibility with older installations. This is something that
 *    will be done in 2.0.
 */
DataTable.models.oSettings = {
	/**
	 * Primary features of DataTables and their enablement state.
	 *  @namespace
	 */
	"oFeatures": {

		/**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bAutoWidth": null,

		/**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and Javascript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bDeferRender": null,

		/**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bFilter": null,

		/**
		 * Table information element (the 'Showing x of y records' div) enable
		 * flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bInfo": null,

		/**
		 * Present a user control allowing the end user to change the page size
		 * when pagination is enabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bLengthChange": null,

		/**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bPaginate": null,

		/**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bProcessing": null,

		/**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bServerSide": null,

		/**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSort": null,

		/**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortMulti": null,

		/**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortClasses": null,

		/**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bStateSave": null
	},


	/**
	 * Scrolling settings for a table.
	 *  @namespace
	 */
	"oScroll": {
		/**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bCollapse": null,

		/**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 *  @type int
		 *  @default 0
		 */
		"iBarWidth": 0,

		/**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sX": null,

		/**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @deprecated
		 */
		"sXInner": null,

		/**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sY": null
	},

	/**
	 * Language information for the table.
	 *  @namespace
	 *  @extends DataTable.defaults.oLanguage
	 */
	"oLanguage": {
		/**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 *  @type function
		 *  @default null
		 */
		"fnInfoCallback": null
	},

	/**
	 * Browser support parameters
	 *  @namespace
	 */
	"oBrowser": {
		/**
		 * Indicate if the browser incorrectly calculates width:100% inside a
		 * scrolling element (IE6/7)
		 *  @type boolean
		 *  @default false
		 */
		"bScrollOversize": false,

		/**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 *  @type boolean
		 *  @default false
		 */
		"bScrollbarLeft": false,

		/**
		 * Flag for if `getBoundingClientRect` is fully supported or not
		 *  @type boolean
		 *  @default false
		 */
		"bBounding": false,

		/**
		 * Browser scrollbar width
		 *  @type integer
		 *  @default 0
		 */
		"barWidth": 0
	},


	"ajax": null,


	/**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 *  @type array
	 *  @default []
	 */
	"aanFeatures": [],

	/**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 *  @type array
	 *  @default []
	 */
	"aoData": [],

	/**
	 * Array of indexes which are in the current display (after filtering etc)
	 *  @type array
	 *  @default []
	 */
	"aiDisplay": [],

	/**
	 * Array of indexes for display - no filtering
	 *  @type array
	 *  @default []
	 */
	"aiDisplayMaster": [],

	/**
	 * Map of row ids to data indexes
	 *  @type object
	 *  @default {}
	 */
	"aIds": {},

	/**
	 * Store information about each column that is in use
	 *  @type array
	 *  @default []
	 */
	"aoColumns": [],

	/**
	 * Store information about the table's header
	 *  @type array
	 *  @default []
	 */
	"aoHeader": [],

	/**
	 * Store information about the table's footer
	 *  @type array
	 *  @default []
	 */
	"aoFooter": [],

	/**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @namespace
	 *  @extends DataTable.models.oSearch
	 */
	"oPreviousSearch": {},

	/**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 *  @type array
	 *  @default []
	 */
	"aoPreSearchCols": [],

	/**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @todo These inner arrays should really be objects
	 */
	"aaSorting": null,

	/**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @default []
	 */
	"aaSortingFixed": [],

	/**
	 * Classes to use for the striping of a table.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @default []
	 */
	"asStripeClasses": null,

	/**
	 * If restoring a table - we should restore its striping classes as well
	 *  @type array
	 *  @default []
	 */
	"asDestroyStripes": [],

	/**
	 * If restoring a table - we should restore its width
	 *  @type int
	 *  @default 0
	 */
	"sDestroyWidth": 0,

	/**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 *  @type array
	 *  @default []
	 */
	"aoRowCallback": [],

	/**
	 * Callback functions for the header on each draw.
	 *  @type array
	 *  @default []
	 */
	"aoHeaderCallback": [],

	/**
	 * Callback function for the footer on each draw.
	 *  @type array
	 *  @default []
	 */
	"aoFooterCallback": [],

	/**
	 * Array of callback functions for draw callback functions
	 *  @type array
	 *  @default []
	 */
	"aoDrawCallback": [],

	/**
	 * Array of callback functions for row created function
	 *  @type array
	 *  @default []
	 */
	"aoRowCreatedCallback": [],

	/**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 *  @type array
	 *  @default []
	 */
	"aoPreDrawCallback": [],

	/**
	 * Callback functions for when the table has been initialised.
	 *  @type array
	 *  @default []
	 */
	"aoInitComplete": [],


	/**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 *  @type array
	 *  @default []
	 */
	"aoStateSaveParams": [],

	/**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 *  @type array
	 *  @default []
	 */
	"aoStateLoadParams": [],

	/**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 *  @type array
	 *  @default []
	 */
	"aoStateLoaded": [],

	/**
	 * Cache the table ID for quick access
	 *  @type string
	 *  @default <i>Empty string</i>
	 */
	"sTableId": "",

	/**
	 * The TABLE node for the main table
	 *  @type node
	 *  @default null
	 */
	"nTable": null,

	/**
	 * Permanent ref to the thead element
	 *  @type node
	 *  @default null
	 */
	"nTHead": null,

	/**
	 * Permanent ref to the tfoot element - if it exists
	 *  @type node
	 *  @default null
	 */
	"nTFoot": null,

	/**
	 * Permanent ref to the tbody element
	 *  @type node
	 *  @default null
	 */
	"nTBody": null,

	/**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 *  @type node
	 *  @default null
	 */
	"nTableWrapper": null,

	/**
	 * Indicate if when using server-side processing the loading of data
	 * should be deferred until the second draw.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type boolean
	 *  @default false
	 */
	"bDeferLoading": false,

	/**
	 * Indicate if all required information has been read in
	 *  @type boolean
	 *  @default false
	 */
	"bInitialised": false,

	/**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 *  @type array
	 *  @default []
	 */
	"aoOpenRows": [],

	/**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 *  @default null
	 */
	"sDom": null,

	/**
	 * Search delay (in mS)
	 *  @type integer
	 *  @default null
	 */
	"searchDelay": null,

	/**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 *  @default two_button
	 */
	"sPaginationType": "two_button",

	/**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type int
	 *  @default 0
	 */
	"iStateDuration": 0,

	/**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 *  @type array
	 *  @default []
	 */
	"aoStateSave": [],

	/**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 *  @type array
	 *  @default []
	 */
	"aoStateLoad": [],

	/**
	 * State that was saved. Useful for back reference
	 *  @type object
	 *  @default null
	 */
	"oSavedState": null,

	/**
	 * State that was loaded. Useful for back reference
	 *  @type object
	 *  @default null
	 */
	"oLoadedState": null,

	/**
	 * Source url for AJAX data for the table.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 *  @default null
	 */
	"sAjaxSource": null,

	/**
	 * Property from a given object from which to read the table data from. This
	 * can be an empty string (when not server-side processing), in which case
	 * it is  assumed an an array is given directly.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 */
	"sAjaxDataProp": null,

	/**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 *  @type object
	 *  @default null
	 */
	"jqXHR": null,

	/**
	 * JSON returned from the server in the last Ajax request
	 *  @type object
	 *  @default undefined
	 */
	"json": undefined,

	/**
	 * Data submitted as part of the last Ajax request
	 *  @type object
	 *  @default undefined
	 */
	"oAjaxData": undefined,

	/**
	 * Function to get the server-side data.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type function
	 */
	"fnServerData": null,

	/**
	 * Functions which are called prior to sending an Ajax request so extra
	 * parameters can easily be sent to the server
	 *  @type array
	 *  @default []
	 */
	"aoServerParams": [],

	/**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 */
	"sServerMethod": null,

	/**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type function
	 */
	"fnFormatNumber": null,

	/**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @default []
	 */
	"aLengthMenu": null,

	/**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 *  @type int
	 *  @default 0
	 */
	"iDraw": 0,

	/**
	 * Indicate if a redraw is being done - useful for Ajax
	 *  @type boolean
	 *  @default false
	 */
	"bDrawing": false,

	/**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 *  @type int
	 *  @default -1
	 */
	"iDrawError": -1,

	/**
	 * Paging display length
	 *  @type int
	 *  @default 10
	 */
	"_iDisplayLength": 10,

	/**
	 * Paging start point - aiDisplay index
	 *  @type int
	 *  @default 0
	 */
	"_iDisplayStart": 0,

	/**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 *  @type int
	 *  @default 0
	 *  @private
	 */
	"_iRecordsTotal": 0,

	/**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 *  @type boolean
	 *  @default 0
	 *  @private
	 */
	"_iRecordsDisplay": 0,

	/**
	 * The classes to use for the table
	 *  @type object
	 *  @default {}
	 */
	"oClasses": {},

	/**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @type boolean
	 *  @default false
	 *  @deprecated
	 */
	"bFiltered": false,

	/**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @type boolean
	 *  @default false
	 *  @deprecated
	 */
	"bSorted": false,

	/**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column, if the top one (true) or bottom one (false)
	 * should be used for sorting / title by DataTables.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type boolean
	 */
	"bSortCellsTop": null,

	/**
	 * Initialisation object that is used for the table
	 *  @type object
	 *  @default null
	 */
	"oInit": null,

	/**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 *  @type array
	 *  @default []
	 */
	"aoDestroyCallback": [],


	/**
	 * Get the number of records in the current record set, before filtering
	 *  @type function
	 */
	"fnRecordsTotal": function ()
	{
		return _fnDataSource( this ) == 'ssp' ?
			this._iRecordsTotal * 1 :
			this.aiDisplayMaster.length;
	},

	/**
	 * Get the number of records in the current record set, after filtering
	 *  @type function
	 */
	"fnRecordsDisplay": function ()
	{
		return _fnDataSource( this ) == 'ssp' ?
			this._iRecordsDisplay * 1 :
			this.aiDisplay.length;
	},

	/**
	 * Get the display end point - aiDisplay index
	 *  @type function
	 */
	"fnDisplayEnd": function ()
	{
		var
			len      = this._iDisplayLength,
			start    = this._iDisplayStart,
			calc     = start + len,
			records  = this.aiDisplay.length,
			features = this.oFeatures,
			paginate = features.bPaginate;

		if ( features.bServerSide ) {
			return paginate === false || len === -1 ?
				start + records :
				Math.min( start+len, this._iRecordsDisplay );
		}
		else {
			return ! paginate || calc>records || len===-1 ?
				records :
				calc;
		}
	},

	/**
	 * The DataTables object for this table
	 *  @type object
	 *  @default null
	 */
	"oInstance": null,

	/**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 *  @type string
	 *  @default null
	 */
	"sInstance": null,

	/**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */
	"iTabIndex": 0,

	/**
	 * DIV container for the footer scrolling table if scrolling
	 */
	"nScrollHead": null,

	/**
	 * DIV container for the footer scrolling table if scrolling
	 */
	"nScrollFoot": null,

	/**
	 * Last applied sort
	 *  @type array
	 *  @default []
	 */
	"aLastSort": [],

	/**
	 * Stored plug-in instances
	 *  @type object
	 *  @default {}
	 */
	"oPlugins": {},

	/**
	 * Function used to get a row's id from the row's data
	 *  @type function
	 *  @default null
	 */
	"rowIdFn": null,

	/**
	 * Data location where to store a row's id
	 *  @type string
	 *  @default null
	 */
	"rowId": null
};

/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */


/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */
DataTable.ext = _ext = {
	/**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */
	buttons: {},


	/**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */
	classes: {},


	/**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */
	builder: "-source-",


	/**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */
	errMode: "alert",


	/**
	 * Feature plug-ins.
	 * 
	 * This is an array of objects which describe the feature plug-ins that are
	 * available to DataTables. These feature plug-ins are then available for
	 * use through the `dom` initialisation option.
	 * 
	 * Each feature plug-in is described by an object which must have the
	 * following properties:
	 * 
	 * * `fnInit` - function that is used to initialise the plug-in,
	 * * `cFeature` - a character so the feature can be enabled by the `dom`
	 *   instillation option. This is case sensitive.
	 *
	 * The `fnInit` function has the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 *
	 * And the following return is expected:
	 * 
	 * * {node|null} The element which contains your feature. Note that the
	 *   return may also be void if your plug-in does not require to inject any
	 *   DOM elements into DataTables control (`dom`) - for example this might
	 *   be useful when developing a plug-in which allows table control via
	 *   keyboard entry
	 *
	 *  @type array
	 *
	 *  @example
	 *    $.fn.dataTable.ext.features.push( {
	 *      "fnInit": function( oSettings ) {
	 *        return new TableTools( { "oDTSettings": oSettings } );
	 *      },
	 *      "cFeature": "T"
	 *    } );
	 */
	feature: [],


	/**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */
	search: [],


	/**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */
	selector: {
		cell: [],
		column: [],
		row: []
	},


	/**
	 * Internal functions, exposed for used in plug-ins.
	 * 
	 * Please note that you should not need to use the internal methods for
	 * anything other than a plug-in (and even then, try to avoid if possible).
	 * The internal function may change between releases.
	 *
	 *  @type object
	 *  @default {}
	 */
	internal: {},


	/**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */
	legacy: {
		/**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */
		ajax: null
	},


	/**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */
	pager: {},


	renderer: {
		pageButton: {},
		header: {}
	},


	/**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */
	order: {},


	/**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */
	type: {
		/**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */
		detect: [],


		/**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */
		search: {},


		/**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing Javascript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */
		order: {}
	},

	/**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */
	_unique: 0,


	//
	// Depreciated
	// The following properties are retained for backwards compatibility only.
	// The should not be used in new projects and will be removed in a future
	// version
	//

	/**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */
	fnVersionCheck: DataTable.fnVersionCheck,


	/**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */
	iApiIndex: 0,


	/**
	 * jQuery UI class container
	 *  @type object
	 *  @deprecated Since v1.10
	 */
	oJUIClasses: {},


	/**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */
	sVersion: DataTable.version
};


//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$.extend( _ext, {
	afnFiltering: _ext.search,
	aTypes:       _ext.type.detect,
	ofnSearch:    _ext.type.search,
	oSort:        _ext.type.order,
	afnSortData:  _ext.order,
	aoFeatures:   _ext.feature,
	oApi:         _ext.internal,
	oStdClasses:  _ext.classes,
	oPagination:  _ext.pager
} );


$.extend( DataTable.ext.classes, {
	"sTable": "dataTable",
	"sNoFooter": "no-footer",

	/* Paging buttons */
	"sPageButton": "paginate_button",
	"sPageButtonActive": "current",
	"sPageButtonDisabled": "disabled",

	/* Striping classes */
	"sStripeOdd": "odd",
	"sStripeEven": "even",

	/* Empty row */
	"sRowEmpty": "dataTables_empty",

	/* Features */
	"sWrapper": "dataTables_wrapper",
	"sFilter": "dataTables_filter",
	"sInfo": "dataTables_info",
	"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
	"sLength": "dataTables_length",
	"sProcessing": "dataTables_processing",

	/* Sorting */
	"sSortAsc": "sorting_asc",
	"sSortDesc": "sorting_desc",
	"sSortable": "sorting", /* Sortable in both directions */
	"sSortableAsc": "sorting_desc_disabled",
	"sSortableDesc": "sorting_asc_disabled",
	"sSortableNone": "sorting_disabled",
	"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */

	/* Filtering */
	"sFilterInput": "",

	/* Page length */
	"sLengthSelect": "",

	/* Scrolling */
	"sScrollWrapper": "dataTables_scroll",
	"sScrollHead": "dataTables_scrollHead",
	"sScrollHeadInner": "dataTables_scrollHeadInner",
	"sScrollBody": "dataTables_scrollBody",
	"sScrollFoot": "dataTables_scrollFoot",
	"sScrollFootInner": "dataTables_scrollFootInner",

	/* Misc */
	"sHeaderTH": "",
	"sFooterTH": "",

	// Deprecated
	"sSortJUIAsc": "",
	"sSortJUIDesc": "",
	"sSortJUI": "",
	"sSortJUIAscAllowed": "",
	"sSortJUIDescAllowed": "",
	"sSortJUIWrapper": "",
	"sSortIcon": "",
	"sJUIHeader": "",
	"sJUIFooter": ""
} );


var extPagination = DataTable.ext.pager;

function _numbers ( page, pages ) {
	var
		numbers = [],
		buttons = extPagination.numbers_length,
		half = Math.floor( buttons / 2 ),
		i = 1;

	if ( pages <= buttons ) {
		numbers = _range( 0, pages );
	}
	else if ( page <= half ) {
		numbers = _range( 0, buttons-2 );
		numbers.push( 'ellipsis' );
		numbers.push( pages-1 );
	}
	else if ( page >= pages - 1 - half ) {
		numbers = _range( pages-(buttons-2), pages );
		numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
		numbers.splice( 0, 0, 0 );
	}
	else {
		numbers = _range( page-half+2, page+half-1 );
		numbers.push( 'ellipsis' );
		numbers.push( pages-1 );
		numbers.splice( 0, 0, 'ellipsis' );
		numbers.splice( 0, 0, 0 );
	}

	numbers.DT_el = 'span';
	return numbers;
}


$.extend( extPagination, {
	simple: function ( page, pages ) {
		return [ 'previous', 'next' ];
	},

	full: function ( page, pages ) {
		return [  'first', 'previous', 'next', 'last' ];
	},

	numbers: function ( page, pages ) {
		return [ _numbers(page, pages) ];
	},

	simple_numbers: function ( page, pages ) {
		return [ 'previous', _numbers(page, pages), 'next' ];
	},

	full_numbers: function ( page, pages ) {
		return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
	},
	
	first_last_numbers: function (page, pages) {
 		return ['first', _numbers(page, pages), 'last'];
 	},

	// For testing and plug-ins to use
	_numbers: _numbers,

	// Number of number buttons (including ellipsis) to show. _Must be odd!_
	numbers_length: 7
} );


$.extend( true, DataTable.ext.renderer, {
	pageButton: {
		_: function ( settings, host, idx, buttons, page, pages ) {
			var classes = settings.oClasses;
			var lang = settings.oLanguage.oPaginate;
			var aria = settings.oLanguage.oAria.paginate || {};
			var btnDisplay, btnClass;

			var attach = function( container, buttons ) {
				var i, ien, node, button;
				var disabledClass = classes.sPageButtonDisabled;
				var clickHandler = function ( e ) {
					_fnPageChange( settings, e.data.action, true );
				};

				for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
					button = buttons[i];

					if ( Array.isArray( button ) ) {
						var inner = $( '<'+(button.DT_el || 'div')+'/>' )
							.appendTo( container );
						attach( inner, button );
					}
					else {
						var disabled = false;

						btnDisplay = null;
						btnClass = button;

						switch ( button ) {
							case 'ellipsis':
								container.append('<span class="ellipsis">&#x2026;</span>');
								break;

							case 'first':
								btnDisplay = lang.sFirst;

								if ( page === 0 ) {
									disabled = true;
								}
								break;

							case 'previous':
								btnDisplay = lang.sPrevious;

								if ( page === 0 ) {
									disabled = true;
								}
								break;

							case 'next':
								btnDisplay = lang.sNext;

								if ( pages === 0 || page === pages-1 ) {
									disabled = true;
								}
								break;

							case 'last':
								btnDisplay = lang.sLast;

								if ( pages === 0 || page === pages-1 ) {
									disabled = true;
								}
								break;

							default:
								btnDisplay = settings.fnFormatNumber( button + 1 );
								btnClass = page === button ?
									classes.sPageButtonActive : '';
								break;
						}

						if ( btnDisplay !== null ) {
							var tag = settings.oInit.pagingTag || 'a';

							if (disabled) {
								btnClass += ' ' + disabledClass;
							}

							node = $('<'+tag+'>', {
									'class': classes.sPageButton+' '+btnClass,
									'aria-controls': settings.sTableId,
									'aria-disabled': disabled ? 'true' : null,
									'aria-label': aria[ button ],
									'role': 'link',
									'aria-current': btnClass === classes.sPageButtonActive ? 'page' : null,
									'data-dt-idx': button,
									'tabindex': disabled ? -1 : settings.iTabIndex,
									'id': idx === 0 && typeof button === 'string' ?
										settings.sTableId +'_'+ button :
										null
								} )
								.html( btnDisplay )
								.appendTo( container );

							_fnBindAction(
								node, {action: button}, clickHandler
							);
						}
					}
				}
			};

			// IE9 throws an 'unknown error' if document.activeElement is used
			// inside an iframe or frame. Try / catch the error. Not good for
			// accessibility, but neither are frames.
			var activeEl;

			try {
				// Because this approach is destroying and recreating the paging
				// elements, focus is lost on the select button which is bad for
				// accessibility. So we want to restore focus once the draw has
				// completed
				activeEl = $(host).find(document.activeElement).data('dt-idx');
			}
			catch (e) {}

			attach( $(host).empty(), buttons );

			if ( activeEl !== undefined ) {
				$(host).find( '[data-dt-idx='+activeEl+']' ).trigger('focus');
			}
		}
	}
} );



// Built in type detection. See model.ext.aTypes for information about
// what is required from this methods.
$.extend( DataTable.ext.type.detect, [
	// Plain numbers - first since V8 detects some plain numbers as dates
	// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _isNumber( d, decimal ) ? 'num'+decimal : null;
	},

	// Dates (only those recognised by the browser's Date.parse)
	function ( d, settings )
	{
		// V8 tries _very_ hard to make a string passed into `Date.parse()`
		// valid, so we need to use a regex to restrict date formats. Use a
		// plug-in for anything other than ISO8601 style strings
		if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
			return null;
		}
		var parsed = Date.parse(d);
		return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
	},

	// Formatted numbers
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
	},

	// HTML numeric
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
	},

	// HTML numeric, formatted
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
	},

	// HTML (this is strict checking - there must be html)
	function ( d, settings )
	{
		return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
			'html' : null;
	}
] );



// Filter formatting functions. See model.ext.ofnSearch for information about
// what is required from these methods.
// 
// Note that additional search methods are added for the html numbers and
// html formatted numbers by `_addNumericSort()` when we know what the decimal
// place is


$.extend( DataTable.ext.type.search, {
	html: function ( data ) {
		return _empty(data) ?
			data :
			typeof data === 'string' ?
				data
					.replace( _re_new_lines, " " )
					.replace( _re_html, "" ) :
				'';
	},

	string: function ( data ) {
		return _empty(data) ?
			data :
			typeof data === 'string' ?
				data.replace( _re_new_lines, " " ) :
				data;
	}
} );



var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
	if ( d !== 0 && (!d || d === '-') ) {
		return -Infinity;
	}
	
	var type = typeof d;

	if (type === 'number' || type === 'bigint') {
		return d;
	}

	// If a decimal place other than `.` is used, it needs to be given to the
	// function so we can detect it and replace with a `.` which is the only
	// decimal place Javascript recognises - it is not locale aware.
	if ( decimalPlace ) {
		d = _numToDecimal( d, decimalPlace );
	}

	if ( d.replace ) {
		if ( re1 ) {
			d = d.replace( re1, '' );
		}

		if ( re2 ) {
			d = d.replace( re2, '' );
		}
	}

	return d * 1;
};


// Add the numeric 'deformatting' functions for sorting and search. This is done
// in a function to provide an easy ability for the language options to add
// additional methods if a non-period decimal place is used.
function _addNumericSort ( decimalPlace ) {
	$.each(
		{
			// Plain numbers
			"num": function ( d ) {
				return __numericReplace( d, decimalPlace );
			},

			// Formatted numbers
			"num-fmt": function ( d ) {
				return __numericReplace( d, decimalPlace, _re_formatted_numeric );
			},

			// HTML numeric
			"html-num": function ( d ) {
				return __numericReplace( d, decimalPlace, _re_html );
			},

			// HTML numeric, formatted
			"html-num-fmt": function ( d ) {
				return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
			}
		},
		function ( key, fn ) {
			// Add the ordering method
			_ext.type.order[ key+decimalPlace+'-pre' ] = fn;

			// For HTML types add a search formatter that will strip the HTML
			if ( key.match(/^html\-/) ) {
				_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
			}
		}
	);
}


// Default sort methods
$.extend( _ext.type.order, {
	// Dates
	"date-pre": function ( d ) {
		var ts = Date.parse( d );
		return isNaN(ts) ? -Infinity : ts;
	},

	// html
	"html-pre": function ( a ) {
		return _empty(a) ?
			'' :
			a.replace ?
				a.replace( /<.*?>/g, "" ).toLowerCase() :
				a+'';
	},

	// string
	"string-pre": function ( a ) {
		// This is a little complex, but faster than always calling toString,
		// https://jsperf.com/tostring-v-check
		return _empty(a) ?
			'' :
			typeof a === 'string' ?
				a.toLowerCase() :
				! a.toString ?
					'' :
					a.toString();
	},

	// string-asc and -desc are retained only for compatibility with the old
	// sort methods
	"string-asc": function ( x, y ) {
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	},

	"string-desc": function ( x, y ) {
		return ((x < y) ? 1 : ((x > y) ? -1 : 0));
	}
} );


// Numeric sorting types - order doesn't matter here
_addNumericSort( '' );


$.extend( true, DataTable.ext.renderer, {
	header: {
		_: function ( settings, cell, column, classes ) {
			// No additional mark-up required
			// Attach a sort listener to update on sort - note that using the
			// `DT` namespace will allow the event to be removed automatically
			// on destroy, while the `dt` namespaced event is the one we are
			// listening for
			$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
				if ( settings !== ctx ) { // need to check this this is the host
					return;               // table, not a nested one
				}

				var colIdx = column.idx;

				cell
					.removeClass(
						classes.sSortAsc +' '+
						classes.sSortDesc
					)
					.addClass( columns[ colIdx ] == 'asc' ?
						classes.sSortAsc : columns[ colIdx ] == 'desc' ?
							classes.sSortDesc :
							column.sSortingClass
					);
			} );
		},

		jqueryui: function ( settings, cell, column, classes ) {
			$('<div/>')
				.addClass( classes.sSortJUIWrapper )
				.append( cell.contents() )
				.append( $('<span/>')
					.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
				)
				.appendTo( cell );

			// Attach a sort listener to update on sort
			$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
				if ( settings !== ctx ) {
					return;
				}

				var colIdx = column.idx;

				cell
					.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
					.addClass( columns[ colIdx ] == 'asc' ?
						classes.sSortAsc : columns[ colIdx ] == 'desc' ?
							classes.sSortDesc :
							column.sSortingClass
					);

				cell
					.find( 'span.'+classes.sSortIcon )
					.removeClass(
						classes.sSortJUIAsc +" "+
						classes.sSortJUIDesc +" "+
						classes.sSortJUI +" "+
						classes.sSortJUIAscAllowed +" "+
						classes.sSortJUIDescAllowed
					)
					.addClass( columns[ colIdx ] == 'asc' ?
						classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
							classes.sSortJUIDesc :
							column.sSortingClassJUI
					);
			} );
		}
	}
} );

/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */

var __htmlEscapeEntities = function ( d ) {
	if (Array.isArray(d)) {
		d = d.join(',');
	}

	return typeof d === 'string' ?
		d
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;') :
		d;
};

// Common logic for moment, luxon or a date action
function __mld( dt, momentFn, luxonFn, dateFn, arg1 ) {
	if (window.moment) {
		return dt[momentFn]( arg1 );
	}
	else if (window.luxon) {
		return dt[luxonFn]( arg1 );
	}
	
	return dateFn ? dt[dateFn]( arg1 ) : dt;
}


var __mlWarning = false;
function __mldObj (d, format, locale) {
	var dt;

	if (window.moment) {
		dt = window.moment.utc( d, format, locale, true );

		if (! dt.isValid()) {
			return null;
		}
	}
	else if (window.luxon) {
		dt = format && typeof d === 'string'
			? window.luxon.DateTime.fromFormat( d, format )
			: window.luxon.DateTime.fromISO( d );

		if (! dt.isValid) {
			return null;
		}

		dt.setLocale(locale);
	}
	else if (! format) {
		// No format given, must be ISO
		dt = new Date(d);
	}
	else {
		if (! __mlWarning) {
			alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
		}

		__mlWarning = true;
	}

	return dt;
}

// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function __mlHelper (localeString) {
	return function ( from, to, locale, def ) {
		// Luxon and Moment support
		// Argument shifting
		if ( arguments.length === 0 ) {
			locale = 'en';
			to = null; // means toLocaleString
			from = null; // means iso8601
		}
		else if ( arguments.length === 1 ) {
			locale = 'en';
			to = from;
			from = null;
		}
		else if ( arguments.length === 2 ) {
			locale = to;
			to = from;
			from = null;
		}

		var typeName = 'datetime-' + to;

		// Add type detection and sorting specific to this date format - we need to be able to identify
		// date type columns as such, rather than as numbers in extensions. Hence the need for this.
		if (! DataTable.ext.type.order[typeName]) {
			// The renderer will give the value to type detect as the type!
			DataTable.ext.type.detect.unshift(function (d) {
				return d === typeName ? typeName : false;
			});

			// The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
			// `valueOf` which gives milliseconds epoch
			DataTable.ext.type.order[typeName + '-asc'] = function (a, b) {
				var x = a.valueOf();
				var y = b.valueOf();

				return x === y
					? 0
					: x < y
						? -1
						: 1;
			}

			DataTable.ext.type.order[typeName + '-desc'] = function (a, b) {
				var x = a.valueOf();
				var y = b.valueOf();

				return x === y
					? 0
					: x > y
						? -1
						: 1;
			}
		}
	
		return function ( d, type ) {
			// Allow for a default value
			if (d === null || d === undefined) {
				if (def === '--now') {
					// We treat everything as UTC further down, so no changes are
					// made, as such need to get the local date / time as if it were
					// UTC
					var local = new Date();
					d = new Date( Date.UTC(
						local.getFullYear(), local.getMonth(), local.getDate(),
						local.getHours(), local.getMinutes(), local.getSeconds()
					) );
				}
				else {
					d = '';
				}
			}

			if (type === 'type') {
				// Typing uses the type name for fast matching
				return typeName;
			}

			if (d === '') {
				return type !== 'sort'
					? ''
					: __mldObj('0000-01-01 00:00:00', null, locale);
			}

			// Shortcut. If `from` and `to` are the same, we are using the renderer to
			// format for ordering, not display - its already in the display format.
			if ( to !== null && from === to && type !== 'sort' && type !== 'type' && ! (d instanceof Date) ) {
				return d;
			}

			var dt = __mldObj(d, from, locale);

			if (dt === null) {
				return d;
			}

			if (type === 'sort') {
				return dt;
			}
			
			var formatted = to === null
				? __mld(dt, 'toDate', 'toJSDate', '')[localeString]()
				: __mld(dt, 'format', 'toFormat', 'toISOString', to);

			// XSS protection
			return type === 'display' ?
				__htmlEscapeEntities( formatted ) :
				formatted;
		};
	}
}

// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var __thousands = ',';
var __decimal = '.';

if (window.Intl !== undefined) {
	try {
		var num = new Intl.NumberFormat().formatToParts(100000.1);
	
		for (var i=0 ; i<num.length ; i++) {
			if (num[i].type === 'group') {
				__thousands = num[i].value;
			}
			else if (num[i].type === 'decimal') {
				__decimal = num[i].value;
			}
		}
	}
	catch (e) {
		// noop
	}
}

// Formatted date time detection - use by declaring the formats you are going to use
DataTable.datetime = function ( format, locale ) {
	var typeName = 'datetime-detect-' + format;

	if (! locale) {
		locale = 'en';
	}

	if (! DataTable.ext.type.order[typeName]) {
		DataTable.ext.type.detect.unshift(function (d) {
			var dt = __mldObj(d, format, locale);
			return d === '' || dt ? typeName : false;
		});

		DataTable.ext.type.order[typeName + '-pre'] = function (d) {
			return __mldObj(d, format, locale) || 0;
		}
	}
}

/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */
DataTable.render = {
	date: __mlHelper('toLocaleDateString'),
	datetime: __mlHelper('toLocaleString'),
	time: __mlHelper('toLocaleTimeString'),
	number: function ( thousands, decimal, precision, prefix, postfix ) {
		// Auto locale detection
		if (thousands === null || thousands === undefined) {
			thousands = __thousands;
		}

		if (decimal === null || decimal === undefined) {
			decimal = __decimal;
		}

		return {
			display: function ( d ) {
				if ( typeof d !== 'number' && typeof d !== 'string' ) {
					return d;
				}

				if (d === '' || d === null) {
					return d;
				}

				var negative = d < 0 ? '-' : '';
				var flo = parseFloat( d );

				// If NaN then there isn't much formatting that we can do - just
				// return immediately, escaping any HTML (this was supposed to
				// be a number after all)
				if ( isNaN( flo ) ) {
					return __htmlEscapeEntities( d );
				}

				flo = flo.toFixed( precision );
				d = Math.abs( flo );

				var intPart = parseInt( d, 10 );
				var floatPart = precision ?
					decimal+(d - intPart).toFixed( precision ).substring( 2 ):
					'';

				// If zero, then can't have a negative prefix
				if (intPart === 0 && parseFloat(floatPart) === 0) {
					negative = '';
				}

				return negative + (prefix||'') +
					intPart.toString().replace(
						/\B(?=(\d{3})+(?!\d))/g, thousands
					) +
					floatPart +
					(postfix||'');
			}
		};
	},

	text: function () {
		return {
			display: __htmlEscapeEntities,
			filter: __htmlEscapeEntities
		};
	}
};


/*
 * This is really a good bit rubbish this method of exposing the internal methods
 * publicly... - To be fixed in 2.0 using methods on the prototype
 */


/**
 * Create a wrapper function for exporting an internal functions to an external API.
 *  @param {string} fn API function name
 *  @returns {function} wrapped function
 *  @memberof DataTable#internal
 */
function _fnExternApiFunc (fn)
{
	return function() {
		var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
			Array.prototype.slice.call(arguments)
		);
		return DataTable.ext.internal[fn].apply( this, args );
	};
}


/**
 * Reference to internal functions for use by plug-in developers. Note that
 * these methods are references to internal functions and are considered to be
 * private. If you use these methods, be aware that they are liable to change
 * between versions.
 *  @namespace
 */
$.extend( DataTable.ext.internal, {
	_fnExternApiFunc: _fnExternApiFunc,
	_fnBuildAjax: _fnBuildAjax,
	_fnAjaxUpdate: _fnAjaxUpdate,
	_fnAjaxParameters: _fnAjaxParameters,
	_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
	_fnAjaxDataSrc: _fnAjaxDataSrc,
	_fnAddColumn: _fnAddColumn,
	_fnColumnOptions: _fnColumnOptions,
	_fnAdjustColumnSizing: _fnAdjustColumnSizing,
	_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
	_fnColumnIndexToVisible: _fnColumnIndexToVisible,
	_fnVisbleColumns: _fnVisbleColumns,
	_fnGetColumns: _fnGetColumns,
	_fnColumnTypes: _fnColumnTypes,
	_fnApplyColumnDefs: _fnApplyColumnDefs,
	_fnHungarianMap: _fnHungarianMap,
	_fnCamelToHungarian: _fnCamelToHungarian,
	_fnLanguageCompat: _fnLanguageCompat,
	_fnBrowserDetect: _fnBrowserDetect,
	_fnAddData: _fnAddData,
	_fnAddTr: _fnAddTr,
	_fnNodeToDataIndex: _fnNodeToDataIndex,
	_fnNodeToColumnIndex: _fnNodeToColumnIndex,
	_fnGetCellData: _fnGetCellData,
	_fnSetCellData: _fnSetCellData,
	_fnSplitObjNotation: _fnSplitObjNotation,
	_fnGetObjectDataFn: _fnGetObjectDataFn,
	_fnSetObjectDataFn: _fnSetObjectDataFn,
	_fnGetDataMaster: _fnGetDataMaster,
	_fnClearTable: _fnClearTable,
	_fnDeleteIndex: _fnDeleteIndex,
	_fnInvalidate: _fnInvalidate,
	_fnGetRowElements: _fnGetRowElements,
	_fnCreateTr: _fnCreateTr,
	_fnBuildHead: _fnBuildHead,
	_fnDrawHead: _fnDrawHead,
	_fnDraw: _fnDraw,
	_fnReDraw: _fnReDraw,
	_fnAddOptionsHtml: _fnAddOptionsHtml,
	_fnDetectHeader: _fnDetectHeader,
	_fnGetUniqueThs: _fnGetUniqueThs,
	_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
	_fnFilterComplete: _fnFilterComplete,
	_fnFilterCustom: _fnFilterCustom,
	_fnFilterColumn: _fnFilterColumn,
	_fnFilter: _fnFilter,
	_fnFilterCreateSearch: _fnFilterCreateSearch,
	_fnEscapeRegex: _fnEscapeRegex,
	_fnFilterData: _fnFilterData,
	_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
	_fnUpdateInfo: _fnUpdateInfo,
	_fnInfoMacros: _fnInfoMacros,
	_fnInitialise: _fnInitialise,
	_fnInitComplete: _fnInitComplete,
	_fnLengthChange: _fnLengthChange,
	_fnFeatureHtmlLength: _fnFeatureHtmlLength,
	_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
	_fnPageChange: _fnPageChange,
	_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
	_fnProcessingDisplay: _fnProcessingDisplay,
	_fnFeatureHtmlTable: _fnFeatureHtmlTable,
	_fnScrollDraw: _fnScrollDraw,
	_fnApplyToChildren: _fnApplyToChildren,
	_fnCalculateColumnWidths: _fnCalculateColumnWidths,
	_fnThrottle: _fnThrottle,
	_fnConvertToWidth: _fnConvertToWidth,
	_fnGetWidestNode: _fnGetWidestNode,
	_fnGetMaxLenString: _fnGetMaxLenString,
	_fnStringToCss: _fnStringToCss,
	_fnSortFlatten: _fnSortFlatten,
	_fnSort: _fnSort,
	_fnSortAria: _fnSortAria,
	_fnSortListener: _fnSortListener,
	_fnSortAttachListener: _fnSortAttachListener,
	_fnSortingClasses: _fnSortingClasses,
	_fnSortData: _fnSortData,
	_fnSaveState: _fnSaveState,
	_fnLoadState: _fnLoadState,
	_fnImplementState: _fnImplementState,
	_fnSettingsFromNode: _fnSettingsFromNode,
	_fnLog: _fnLog,
	_fnMap: _fnMap,
	_fnBindAction: _fnBindAction,
	_fnCallbackReg: _fnCallbackReg,
	_fnCallbackFire: _fnCallbackFire,
	_fnLengthOverflow: _fnLengthOverflow,
	_fnRenderer: _fnRenderer,
	_fnDataSource: _fnDataSource,
	_fnRowAttributes: _fnRowAttributes,
	_fnExtend: _fnExtend,
	_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
	                                // in 1.10, so this dead-end function is
	                                // added to prevent errors
} );


// jQuery access
$.fn.dataTable = DataTable;

// Provide access to the host jQuery object (circular reference)
DataTable.$ = $;

// Legacy aliases
$.fn.dataTableSettings = DataTable.settings;
$.fn.dataTableExt = DataTable.ext;

// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$.fn.DataTable = function ( opts ) {
	return $(this).dataTable( opts ).api();
};

// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$.each( DataTable, function ( prop, val ) {
	$.fn.DataTable[ prop ] = val;
} );

/* harmony default export */ __webpack_exports__["default"] = (DataTable);


/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-package.9e64a19.png";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(793)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1917),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(776)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1892),
  /* scopeId */
  "data-v-6dc17366",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1866),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1870),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1926),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginForm_vue__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoginForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Correct_vue__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Correct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Correct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CorrectPassword_vue__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CorrectPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CorrectPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NewPassword_vue__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NewPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NewPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RestorePassword_vue__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RestorePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_RestorePassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PasswordConfirm_vue__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PasswordConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PasswordConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CreateAccount_vue__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CreateAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_CreateAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_404_vue__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Dashboard_vue__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Tables_vue__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Tables_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_Tables_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Tasks_vue__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Tasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_Tasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Setting_vue__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Setting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_Setting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Access_vue__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Access_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_Access_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Server_vue__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Server_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_Server_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Repos_vue__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Repos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_Repos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_OrderTable_vue__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_OrderTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_OrderTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_WarehouseTable_vue__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_WarehouseTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_WarehouseTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_WarehouseTable2_vue__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_WarehouseTable2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_WarehouseTable2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_CategorysTable_vue__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_CategorysTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_CategorysTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_SubpartidaTable_vue__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_SubpartidaTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_SubpartidaTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_purchase_order_show_view_vue__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_purchase_order_show_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_purchase_order_show_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_package_show_view_vue__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_package_show_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_package_show_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_tracking_order_show_view_vue__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_tracking_order_show_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_tracking_order_show_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_template_view_vue__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_template_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_template_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_shipment_list_view_vue__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_shipment_list_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_shipment_list_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_shipment_create_view_vue__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_shipment_create_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_shipment_create_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_shipment_show_view_vue__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_shipment_show_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_shipment_show_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_shipment_evaluatePackage_view_vue__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_shipment_evaluatePackage_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_shipment_evaluatePackage_view_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_userListView_vue__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_userListView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_userListView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_ProfileAdmin_vue__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_ProfileAdmin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_views_ProfileAdmin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_UtilsAdmin_vue__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_UtilsAdmin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_views_UtilsAdmin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_TableRebate_vue__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_TableRebate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_views_TableRebate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_EditRebate_vue__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_EditRebate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_views_EditRebate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_LoginSelection_vue__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_LoginSelection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_LoginSelection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__middleware_auth__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__middleware_noAuth__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__middleware_correctRole__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__middleware_noRecieverOperator__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__middleware_noClient__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__middleware_usersDashboardPermission__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__middleware_createBoardingPermission__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__middleware_manageBoardingPermission__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__middleware_evaluateBoardingPermission__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_User_vue__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_User_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_views_User_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Cotizaciones_vue__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Cotizaciones_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_views_Cotizaciones_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_views_Reclamaciones_vue__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_views_Reclamaciones_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_views_Reclamaciones_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_views_ReclamoDetails_vue__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_views_ReclamoDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_views_ReclamoDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_views_CredencialesView_vue__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_views_CredencialesView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_views_CredencialesView_vue__);

























































var routes = [{
    path: '/welcome',
    name: 'login-selection',
    component: __WEBPACK_IMPORTED_MODULE_35__components_LoginSelection_vue___default.a,
    meta: {
        description: 'Login selection',
        middleware: [__WEBPACK_IMPORTED_MODULE_37__middleware_noAuth__["a" /* default */]]
    }
}, {
    path: '/login/:id',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a,
    children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_2__components_LoginForm_vue___default.a,
        meta: {
            description: 'Login usuario',
            middleware: [__WEBPACK_IMPORTED_MODULE_37__middleware_noAuth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38__middleware_correctRole__["a" /* default */]]
        }
    }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_8__components_CreateAccount_vue___default.a,
        meta: {
            description: 'Crear cuenta de cliente',
            middleware: [__WEBPACK_IMPORTED_MODULE_37__middleware_noAuth__["a" /* default */]]
        }
    }, {
        path: 'correct',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Correct_vue___default.a,
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_37__middleware_noAuth__["a" /* default */]]
        }
    }, {
        path: 'changepassword',
        component: __WEBPACK_IMPORTED_MODULE_5__components_NewPassword_vue___default.a,
        name: 'NewPassword',
        meta: {
            description: 'Restablecer contraseña',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'correctpass',
        component: __WEBPACK_IMPORTED_MODULE_4__components_CorrectPassword_vue___default.a
    }, {
        path: 'restorepassword',
        component: __WEBPACK_IMPORTED_MODULE_6__components_RestorePassword_vue___default.a
    }, {
        path: 'confirmpass',
        component: __WEBPACK_IMPORTED_MODULE_7__components_PasswordConfirm_vue___default.a
    }],
    meta: { requiresAuth: false }
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
    children: [{
        path: 'dashboard',
        alias: '',
        component: __WEBPACK_IMPORTED_MODULE_10__components_views_Dashboard_vue___default.a,
        name: 'Dashboard',
        meta: {
            description: 'Overview of environment',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'tables',
        component: __WEBPACK_IMPORTED_MODULE_11__components_views_Tables_vue___default.a,
        name: 'Tables',
        meta: {
            description: 'Simple and advance table in CoPilot',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'orders',
        component: __WEBPACK_IMPORTED_MODULE_17__components_views_OrderTable_vue___default.a,
        name: 'Orders',
        meta: {
            description: 'Tabla de órdenes de compra',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__middleware_noRecieverOperator__["a" /* default */]]
        }
    }, {
        path: 'warehouse',
        component: __WEBPACK_IMPORTED_MODULE_18__components_views_WarehouseTable_vue___default.a,
        name: 'Warehouse',
        meta: {
            description: 'Tabla de Warehuose',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__middleware_noRecieverOperator__["a" /* default */]]
        }
    }, {
        path: 'warehouse2',
        component: __WEBPACK_IMPORTED_MODULE_19__components_views_WarehouseTable2_vue___default.a,
        name: 'Warehouse2',
        meta: {
            description: 'Tabla de Warehuose',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__middleware_noRecieverOperator__["a" /* default */]]
        }
    }, {
        path: 'categorys',
        component: __WEBPACK_IMPORTED_MODULE_20__components_views_CategorysTable_vue___default.a,
        name: 'Categorys',
        meta: {
            description: 'Tabla de Categorias',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__middleware_noRecieverOperator__["a" /* default */]]
        }
    }, {
        path: 'subpartida',
        component: __WEBPACK_IMPORTED_MODULE_21__components_views_SubpartidaTable_vue___default.a,
        name: 'Subpartida',
        meta: {
            description: 'Tabla de Categorias',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__middleware_noRecieverOperator__["a" /* default */]]
        }
    }, {
        path: 'users',
        component: __WEBPACK_IMPORTED_MODULE_30__components_views_userListView_vue___default.a,
        name: 'Users',
        meta: {
            description: 'Tabla de usuarios',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__middleware_usersDashboardPermission__["a" /* default */]]
        }
    }, {
        path: 'profile',
        component: __WEBPACK_IMPORTED_MODULE_31__components_views_ProfileAdmin_vue___default.a,
        name: 'Profile',
        meta: {
            description: 'Perfil del administrador',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'user-detail/:idUser',
        component: __WEBPACK_IMPORTED_MODULE_45__components_views_User_vue___default.a,
        name: 'UserDetail',
        meta: {
            description: 'Perfil del usuario',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'cotizaciones',
        component: __WEBPACK_IMPORTED_MODULE_46__components_views_Cotizaciones_vue___default.a,
        name: 'Cotizaciones',
        meta: {
            description: 'Tabla de cotizaciones del usuario',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'reclamaciones',
        component: __WEBPACK_IMPORTED_MODULE_47__components_views_Reclamaciones_vue___default.a,
        name: 'Reclamaciones',
        meta: {
            description: 'Tabla de reclamos',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'reclamo/:id',
        component: __WEBPACK_IMPORTED_MODULE_48__components_views_ReclamoDetails_vue___default.a,
        name: 'ReclamoDetails',
        meta: {
            description: 'Detalles de un reclamo',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'utils',
        component: __WEBPACK_IMPORTED_MODULE_32__components_views_UtilsAdmin_vue___default.a,
        name: 'Utils',
        meta: {
            description: 'Herramientas para productos de Mercado Libre',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__middleware_usersDashboardPermission__["a" /* default */]]
        }
    }, {
        path: 'editRebate/:id/Show',
        component: __WEBPACK_IMPORTED_MODULE_34__components_views_EditRebate_vue___default.a,
        name: 'EditRebate',
        props: true,
        meta: {
            description: 'Editar Rebate',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__middleware_usersDashboardPermission__["a" /* default */]]
        }
    }, {
        path: 'tableRebate',
        component: __WEBPACK_IMPORTED_MODULE_33__components_views_TableRebate_vue___default.a,
        name: 'TableRebate',
        meta: {
            description: 'Herramientas para productos de Mercado Libre',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__middleware_usersDashboardPermission__["a" /* default */]]
        }
    }, {
        path: 'tasks',
        name: 'add-purchase-order',
        component: __WEBPACK_IMPORTED_MODULE_12__components_views_Tasks_vue___default.a,
        props: true,
        meta: {
            description: 'Tasks page in the form of a timeline',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'template',
        name: 'template',
        component: __WEBPACK_IMPORTED_MODULE_25__components_views_template_view_vue___default.a,
        props: true,
        meta: {
            description: 'Tracking page in the form of a timeline',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'shipments',
        name: 'shipments-list',
        component: __WEBPACK_IMPORTED_MODULE_26__components_views_shipment_list_view_vue___default.a,

        meta: {
            description: 'List shipments table',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_40__middleware_noClient__["a" /* default */]]
        }
    }, {
        path: 'shipments/create',
        name: 'shipments-create',
        component: __WEBPACK_IMPORTED_MODULE_27__components_views_shipment_create_view_vue___default.a,
        props: true,
        meta: {
            description: 'Create shipment section',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_42__middleware_createBoardingPermission__["a" /* default */]]
        }
    }, {
        path: 'shipments/:id/edit',
        name: 'shipments-edit',
        component: __WEBPACK_IMPORTED_MODULE_27__components_views_shipment_create_view_vue___default.a,
        props: true,
        meta: {
            description: 'Management shipment section',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_43__middleware_manageBoardingPermission__["a" /* default */]]
        }
    }, {
        path: 'shipments/:id/show',
        name: 'shipments-show',
        component: __WEBPACK_IMPORTED_MODULE_28__components_views_shipment_show_view_vue___default.a,
        props: true,
        meta: {
            description: 'Show shipment section',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'shipments/:id/show/evaluation',
        name: 'shipments-evaluate-package',
        component: __WEBPACK_IMPORTED_MODULE_29__components_views_shipment_evaluatePackage_view_vue___default.a,
        props: true,
        meta: {
            description: 'evaluate package on shipment section',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_44__middleware_evaluateBoardingPermission__["a" /* default */]]
        }
    }, {
        path: 'purchaseOrder/:id/Show',
        name: 'show-purchase-order',
        component: __WEBPACK_IMPORTED_MODULE_22__components_views_purchase_order_show_view_vue___default.a,
        props: true,
        meta: {
            description: 'Show data from purchase order',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'package/:id/Show',
        name: 'show-package',
        component: __WEBPACK_IMPORTED_MODULE_23__components_views_package_show_view_vue___default.a,
        props: true,
        meta: {
            description: 'Show data from purchase order',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'trackingOrder/:id/Show',
        name: 'show-tracking-order',
        component: __WEBPACK_IMPORTED_MODULE_24__components_views_tracking_order_show_view_vue___default.a,
        props: true,
        meta: {
            description: 'Show data from tracking order',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'users',
        name: 'user-list',
        component: __WEBPACK_IMPORTED_MODULE_30__components_views_userListView_vue___default.a,
        props: true,
        meta: {
            description: 'list of users',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'setting',
        component: __WEBPACK_IMPORTED_MODULE_13__components_views_Setting_vue___default.a,
        name: 'Settings',
        meta: {
            description: 'User settings page',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'credenciales',
        component: __WEBPACK_IMPORTED_MODULE_49__components_views_CredencialesView_vue___default.a,
        name: 'Credenciales',
        meta: {
            description: 'Credenciales API KEY',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'access',
        component: __WEBPACK_IMPORTED_MODULE_14__components_views_Access_vue___default.a,
        name: 'Access',
        meta: {
            description: 'Example of using maps',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'server',
        component: __WEBPACK_IMPORTED_MODULE_15__components_views_Server_vue___default.a,
        name: 'Servers',
        meta: {
            description: 'List of our servers',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }, {
        path: 'repos',
        component: __WEBPACK_IMPORTED_MODULE_16__components_views_Repos_vue___default.a,
        name: 'Repository',
        meta: {
            description: 'List of popular javascript repos',
            middleware: [__WEBPACK_IMPORTED_MODULE_36__middleware_auth__["a" /* default */]]
        }
    }],
    meta: { requiresAuth: true }
}, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_9__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(785)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1904),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        width: { type: String, default: '238px' },
        readonly: { type: Boolean, default: false },
        value: { type: String, default: '' },
        format: { type: String, default: 'YYYY-MM-DD' }
    },
    data: function data() {
        return {
            show: false,
            days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            date: [],
            now: new Date()
        };
    },

    watch: {
        now: function now() {
            this.update();
        },
        show: function show() {
            this.update();
        }
    },
    methods: {
        close: function close() {
            this.show = false;
        },
        update: function update() {
            var arr = [];
            var time = new Date(this.now);
            time.setMonth(time.getMonth(), 1);
            var curFirstDay = time.getDay();
            curFirstDay === 0 && (curFirstDay = 7);
            time.setDate(0);
            var lastDayCount = time.getDate();
            for (var i = curFirstDay; i > 0; i--) {
                arr.push({
                    text: lastDayCount - i + 1,
                    time: new Date(time.getFullYear(), time.getMonth(), lastDayCount - i + 1),
                    status: 'date-pass'
                });
            }

            time.setMonth(time.getMonth() + 2, 0);
            var curDayCount = time.getDate();
            time.setDate(1);
            var value = this.value || this.stringify(new Date());
            for (var _i = 0; _i < curDayCount; _i++) {
                var tmpTime = new Date(time.getFullYear(), time.getMonth(), _i + 1);
                var status = '';
                this.stringify(tmpTime) === value && (status = 'date-active');
                arr.push({
                    text: _i + 1,
                    time: tmpTime,
                    status: status
                });
            }

            var j = 1;
            while (arr.length < 42) {
                arr.push({
                    text: j,
                    time: new Date(time.getFullYear(), time.getMonth() + 1, j),
                    status: 'date-future'
                });
                j++;
            }
            this.date = arr;
        },
        yearClick: function yearClick(flag) {
            this.now.setFullYear(this.now.getFullYear() + flag);
            this.now = new Date(this.now);
        },
        monthClick: function monthClick(flag) {
            this.now.setMonth(this.now.getMonth() + flag);
            this.now = new Date(this.now);
        },
        pickDate: function pickDate(index) {
            this.show = false;
            this.now = new Date(this.date[index].time);
            this.value = this.stringify();
        },
        parse: function parse(str) {
            var time = new Date(str);
            return isNaN(time.getTime()) ? null : time;
        },
        stringify: function stringify() {
            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.now;
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.format;

            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var date = time.getDate();
            var monthName = this.months[time.getMonth()];

            var map = {
                YYYY: year,
                MMM: monthName,
                MM: ('0' + month).slice(-2),
                M: month,
                DD: ('0' + date).slice(-2),
                D: date
            };
            return format.replace(/Y+|M+|D+/g, function (str) {
                return map[str];
            });
        },
        leave: function leave(e) {
            if (!this.$el.contains(e.target)) {
                this.close();
            }
        }
    },
    ready: function ready() {
        this.now = this.parse(this.value) || new Date();
        document.addEventListener('click', this.leave, false);
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('click', this.leave, false);
    }
});

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_loaderFullScreen_vue__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_loaderFullScreen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_loaderFullScreen_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  components: {
    loaderFull: __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_loaderFullScreen_vue___default.a
  },
  data: function data() {
    return {
      section: 'Head',
      loading: false
    };
  },

  methods: {}
});

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Correct'
});

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CorrectPassword'
});

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateAccount',
  data: function data(router) {
    return {
      section: 'Create',
      loading: '',
      name: '',
      validateName: '',
      responseName: '',
      lastname: '',
      validateLast: '',
      responseLast: '',
      username: '',
      validateUser: '',
      responseUser: '',
      password: '',
      validatePass: '',
      responsePass: '',
      response2Pass: '',
      response: '',
      checkPassword: '',
      validateCheck: '',
      responseCheck: '',
      telephone: '',
      validatePhone: '',
      responsePhone: '',
      sexo: 0,
      validateGenre: '',
      responseGenre: '',
      date: '',
      validateDate: '',
      responseDate: ''
    };
  },

  methods: {
    checkServer: function checkServer() {
      var self = this;
      var url = '';
      this.toggleLoading();
      this.$store.commit('TOGGLE_LOADING');
      this.resetResponse();
      if (this.validateForm()) {
        this.resetResponse();
        url = "https://backendbutiko.com" + '/api/client/create-client';
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          name: this.name,
          surnames: this.lastname,
          country_code: '+51',
          cellphone: this.telephone,
          gender: this.sexo === 1 ? 'M' : 'F',
          birthdate: this.date,
          email: this.username,
          password: this.password
        }).then(function (response) {
          self.toggleLoading();
          console.log('success');
          console.log(response.data);
          if (response.data.status) {
            self.$router.push('/correct');
          }
        }).catch(function (error) {
          var responseMessage = void 0;
          var errorFlag = void 0;
          if (error.response) {
            if (error.response.status === 400) {
              self.response = 'Error 400';
            } else if (error.response.status === 404) {
              self.response = 'Error 404';
            } else if (error.response.status === 422 || error.response.status === 401) {
              console.log('entro');

              if (error.response.data.errors.hasOwnProperty('email')) {
                responseMessage = error.response.data.errors.email[0];
                console.log(responseMessage);
                errorFlag = parseInt(responseMessage.substr(0, responseMessage.indexOf('.')));
                if (errorFlag === 1) {
                  self.validateUsername('emailInc');
                }
              } else if (error.response.data.errors.password[0].slice(0, 1).toString() === '2') {
                var passInc = 'passInc';
                self.validateUser(passInc);
              }
            } else if (error.response.status === 500) {
              self.response = 'Error de servidor. Inténtelo más tarde.';
            } else {
              self.response = 'Error inesperado';
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config);
        });
      }
      this.validation = null;
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.validateName = '';
      this.responseName = '';
      this.validateLast = '';
      this.responseLast = '';
      this.validateUser = '';
      this.responseUser = '';
      this.validatePass = '';
      this.responsePass = '';
      this.response2Pass = '';
      this.validateCheck = '';
      this.responseCheck = '';
      this.validatePhone = '';
      this.responsePhone = '';
      this.validateGenre = '';
      this.responseGenre = '';
      this.validateDate = '';
      this.responseDate = '';
    },
    validateForm: function validateForm() {
      console.log(this.name, this.lastname, this.username, this.password, this.checkPassword, this.telephone, this.sexo, this.date);
      var name = 'name';
      var last = 'last';
      var pass = 'pass';
      var check = 'check';
      var names = this.validateNames(name);
      var surnames = this.validateNames(last);
      var user = this.validateUsername();
      var phone = this.validateNumber();
      var genre = this.validateSex();
      var birthdate = this.validateBday();
      var pass1 = this.validatePassword(pass);
      var pass2 = this.validatePassword(check);
      var checkPass = this.validate2Password();
      return names && surnames && user && phone && genre && birthdate && pass1 && pass2 && checkPass;
    },
    validateNames: function validateNames(atr) {
      if (atr === 'name') {
        this.validateName = this.name.length < 1 || this.name.length > 50 ? 'incorrect' : 'correct';
        this.responseName = this.name.length < 1 || this.name.length > 50 ? 'Nombres debe contener entre 1 y 50 carácteres.' : '';
        return !(this.name.length < 1 || this.name.length > 50);
      } else if (atr === 'last') {
        this.validateLast = this.lastname.length < 1 || this.lastname.length > 100 ? 'incorrect' : 'correct';
        this.responseLast = this.lastname.length < 1 || this.lastname.length > 100 ? 'Apellidos deben contener entre 1 y 100 carácteres.' : '';
        return !(this.lastname.length < 1 || this.lastname.length > 100);
      }
    },
    validateUsername: function validateUsername() {
      var atr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (atr === null) {
        var aux = new RegExp('[\\w+\\-\\.]+\\@[a-z]+\\.[a-z]{2,}');
        this.validateUser = aux.test(this.username) ? 'correct' : 'incorrect';
        this.responseUser = aux.test(this.username) ? '' : 'Ingresa un correo válido. Ex: ejemplo@abc.com';
        return aux.test(this.username);
      } else if (atr === 'emailInc') {
        this.validateUser = 'incorrect';
        this.responseUser = 'Correo ya registrado';
      }
    },
    validateNumber: function validateNumber() {
      var validated = this.telephone.length === 9;
      this.validatePhone = validated ? 'correct' : 'incorrect';
      this.responsePhone = validated ? '' : 'El telefono debe tener 9 digitos';
      return validated;
    },
    validateSex: function validateSex() {
      console.log(this.sexo, this.sexo == 0);
      this.validateGenre = !(this.sexo == 0) ? 'correct' : 'incorrect';
      this.responseGenre = !(this.sexo == 0) ? '' : 'Debes seleccionar un género.';
      return !(this.sexo == 0);
    },
    validateBday: function validateBday() {
      console.log(this.date);
      console.log(parseInt(this.date));
      var aux = new Date();
      var date = parseInt(this.date) >= 1900 && aux.getFullYear() - parseInt(this.date) >= 18;
      this.validateDate = date ? 'correct' : 'incorrect';
      this.responseDate = date ? '' : 'Ingrese una fecha correcta.';
      console.log('salio del validateBday');
      return date;
    },
    validatePassword: function validatePassword(atr) {
      if (atr === 'pass') {
        this.validatePass = this.password.length < 8 || this.password.length > 20 ? 'incorrect' : 'correct';
        this.responsePass = this.password.length < 8 || this.password.length > 20 ? 'La contraseña debe tener entre 8 y 20 carácteres.' : '';
        return !(this.password.length < 8 || this.password.length > 20);
      } else if (atr === 'check') {
        this.validateCheck = this.checkPassword.length < 8 || this.checkPassword.length > 20 ? 'incorrect' : 'correct';
        this.responseCheck = this.checkPassword.length < 8 || this.checkPassword.length > 20 ? 'La contraseña debe tener entre 8 y 20 carácteres.' : '';
        return !(this.checkPassword.length < 8 || this.checkPassword.length > 20);
      }
    },
    validate2Password: function validate2Password() {
      var aux = this.password === this.checkPassword;
      console.log('aux', aux);
      this.validatePass = aux ? 'correct' : 'incorrect';
      this.validateCheck = aux ? 'correct' : 'incorrect';
      this.response2Pass = aux ? '' : 'Las contraseñas deben ser iguales. Por favor, intenta de nuevo.';
      return aux;
    }
  }
});

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_faker__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashFooter__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_DashFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_DashHeader__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_DashHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_DashHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_Sidebar__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    DashFooter: __WEBPACK_IMPORTED_MODULE_2__layout_DashFooter___default.a,
    DashHeader: __WEBPACK_IMPORTED_MODULE_3__layout_DashHeader___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__layout_Sidebar___default.a
  },
  data: function data() {
    return {
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].hideLogoOnMobile
      }
    };
  },
  computed: {
    user: function user() {
      return {
        displayName: __WEBPACK_IMPORTED_MODULE_0_faker___default.a.name.findName(),
        avatar: __WEBPACK_IMPORTED_MODULE_0_faker___default.a.image.avatar(),
        roles: [__WEBPACK_IMPORTED_MODULE_0_faker___default.a.name.jobTitle(), __WEBPACK_IMPORTED_MODULE_0_faker___default.a.name.jobTitle()]
      };
    }
  }
});

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      tipologin: '',
      role: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    backPage: function backPage() {
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notification_service__ = __webpack_require__(80);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LoginForm',
    data: function data(router) {
        console.log("entré acá");
        return {
            locale: 'en',
            section: 'Login',
            loading: '',
            username: '',
            password: '',
            response: '',
            validationUser: null,
            validationPass: null,
            responsePass: '',
            responseUser: ''
        };
    },
    created: function created() {
        this.$validator.localize('es', {
            messages: __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es___default.a.messages,
            attributes: {
                foo: 'bar'
            }
        });
        this.$validator.localize('es');
    },

    methods: {
        checkCreds: function checkCreds() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var self, url, first, data, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = _this;
                                url = '';
                                first = 'first';

                                _this.toggleLoading();
                                _this.$store.commit('TOGGLE_LOADING');
                                _this.resetResponse();

                                if (!_this.validateUser(first, _this.$route.params.id)) {
                                    _context.next = 32;
                                    break;
                                }

                                console.log("Validated first step");
                                _this.resetResponse();
                                data = new Object();

                                data.username = _this.username;
                                data.password = _this.password;
                                _context.t0 = _this.$route.params.id;
                                _context.next = _context.t0 === 'admin' ? 15 : _context.t0 === 'oper' ? 17 : _context.t0 === 'client' ? 19 : 21;
                                break;

                            case 15:
                                url = "https://backendbutiko.com" + '/api/admin/login-admin';
                                return _context.abrupt('break', 23);

                            case 17:
                                url = "https://backendbutiko.com" + '/api/operator/login-operator';
                                return _context.abrupt('break', 23);

                            case 19:
                                url = "https://backendbutiko.com" + '/client/login-client';
                                return _context.abrupt('break', 23);

                            case 21:
                                console.log("default on checkCreds");
                                return _context.abrupt('break', 23);

                            case 23:
                                _context.next = 25;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, data).then(function (response) {
                                    _this.toggleLoading();
                                    console.log('success');
                                    console.log(response.data);
                                    if (response.data.status) {

                                        _this.$store.commit('SET_USER', response.data.body);
                                        _this.$store.commit('SET_TOKEN', 'some token');

                                        console.log(response.data.body);

                                        if (window.localStorage) {
                                            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data.body));
                                            window.localStorage.setItem('token', 'some token2');
                                        }
                                        console.log(window.localStorage.getItem('token'));
                                        console.log(window.localStorage.getItem('user'));
                                        return true;
                                    }
                                }).catch(function (error) {
                                    if (error.response) {
                                        var responseMessage = void 0;
                                        var errorFlag = void 0;
                                        if (error.response.status === 400) {
                                            self.response = 'Error 400';
                                        } else if (error.response.status === 404) {
                                            self.response = 'Error 404';
                                        } else if (error.response.status === 422 || error.response.status === 401) {
                                            console.log('entro');

                                            if (error.response.data.errors.hasOwnProperty('username')) {
                                                console.log("Este if");
                                                if (error.response.data.errors.username[0].slice(0, 1).toString() === '1') {
                                                    var userInc = 'userInc';
                                                    console.log("This one");
                                                    self.validateUser(userInc);
                                                }
                                            } else if (error.response.data.errors.hasOwnProperty('email')) {
                                                console.log("segudno if");
                                                responseMessage = error.response.data.errors.email[0];
                                                console.log(responseMessage);
                                                errorFlag = parseInt(responseMessage.substr(0, responseMessage.indexOf('.')));
                                                if (errorFlag === 1) {
                                                    console.log("This other one");
                                                    self.validateUser('userInc');
                                                }
                                            } else if (error.response.data.errors.hasOwnProperty('password')) {
                                                console.log("tercer if");
                                                responseMessage = error.response.data.errors.password[0];
                                                console.log(responseMessage);
                                                errorFlag = parseInt(responseMessage.substr(0, responseMessage.indexOf('.')));
                                                switch (errorFlag) {
                                                    case 1:
                                                        console.log("errorFlag value: ".concat(1));
                                                        self.validateUser('passInc');
                                                        break;
                                                    case 2:
                                                        console.log("errorFlag value: ".concat(2));
                                                        self.validateUser('invalid_password');
                                                        break;
                                                    default:
                                                        console.log("Default case in switch");
                                                        break;
                                                }
                                            }
                                        } else if (error.response.status === 500) {
                                            self.response = 'Error de servidor. Inténtelo más tarde.';
                                        } else {
                                            self.response = 'Error inesperado';
                                        }
                                    } else if (error.request) {
                                        console.log(error.request);
                                    } else {
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                    return false;
                                });

                            case 25:
                                res = _context.sent;


                                console.log("RES");
                                console.log(res);

                                console.log("**********");

                                if (!res) {
                                    _context.next = 32;
                                    break;
                                }

                                _context.next = 32;
                                return __WEBPACK_IMPORTED_MODULE_5__services_notification_service__["a" /* notificationService */].getCurrentNotifications(_this.$store.state.user.attributes.profile.id, _this.logingSuccess);

                            case 32:
                                _this.validation = null;

                            case 33:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        logingSuccess: function logingSuccess(notificationData) {
            console.log("logginSuccess");

            this.$store.commit('SET_NOTIFICATIONS', notificationData);
            this.$router.push('/');
        },
        toggleLoading: function toggleLoading() {
            this.loading = this.loading === '' ? 'loading' : '';
        },
        resetResponse: function resetResponse() {
            this.response = '';
            this.responsePass = '';
            this.responseUser = '';
            this.validationUser = null;
            this.validationPass = null;
        },
        validateUser: function validateUser(atr) {
            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            console.log(role);
            switch (atr) {
                case 'first':
                    var usernameLengthValidationFlag = false;
                    var passwordLengthValidationFlag = false;
                    var usernameResponseMessage = '';
                    if (role === 'admin' || role === 'oper') {
                        usernameLengthValidationFlag = this.username.length < 3 || this.username.length > 20;
                        usernameResponseMessage = 'El username debe tener entre 3 y 20 caracteres';
                    } else {
                        usernameLengthValidationFlag = this.username.length < 5 || this.username.length > 100;
                        usernameResponseMessage = 'El username debe tener entre 5 y 100 caracteres';
                    }
                    this.validationUser = usernameLengthValidationFlag ? 'incorrect' : 'correct';
                    this.responseUser = usernameLengthValidationFlag ? usernameResponseMessage : '';

                    passwordLengthValidationFlag = this.password.length < 8 || this.password.length > 20;

                    this.validationPass = passwordLengthValidationFlag ? 'incorrect' : 'correct';
                    this.responsePass = passwordLengthValidationFlag ? 'La contraseña debe tener entre 8 y 20 caracteres' : '';
                    console.log(!usernameLengthValidationFlag && !passwordLengthValidationFlag);
                    return !usernameLengthValidationFlag && !passwordLengthValidationFlag;
                    break;
                case 'userInc':
                    this.validationUser = 'incorrect';
                    this.responseUser = 'Usuario no existe';
                    break;
                case 'passInc':
                    this.validationPass = 'incorrect';
                    this.responsePass = 'Contraseña incorrecta';
                    break;
                case 'invalid_password':
                    this.validationPass = 'incorrect';
                    this.responsePass = 'Contraseña incorrecta';
                    break;
                default:
                    console.log("Default case for atr in function validateUser");
                    break;
            }
        }
    }
});

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginSelection',
  data: function data() {
    return {};
  },

  methods: {
    toAdminLogin: function toAdminLogin() {
      this.$router.push('/login/admin');
    },
    toOperLogin: function toOperLogin() {
      this.$router.push('/login/oper');
    },
    toClientLogin: function toClientLogin() {
      this.$router.push('/login/client');
    }
  }
});

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewPassword',
  data: function data() {
    return {
      email: ''
    };
  }
});

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordConfirm'
});

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewPassword',
  data: function data() {
    return {
      newpassword: '',
      verifypassword: ''
    };
  }
});

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["idUser"],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getCodigo();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "N° Orden", name: "id", visible: false }, { label: "Descripción", name: "product_info", visible: false }, { label: "Fecha ", name: "fechaCreada", visible: false }, { label: "Estado", name: "state", visible: false }, { label: "Monto", name: "total_cost", visible: false }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      codigoCampa: null,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true,
      form: {
        code: "",
        description: "",
        amount: null,
        active: 1,
        start_date: "",
        end_date: "",
        img: "",
        type: "1",
        max_amount: ""
      }
    };
  },

  methods: {
    handleFileInput: function handleFileInput(e) {
      var _this = this;

      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function (file) {
        _this.form.img = file.target.result;
      };
      reader.readAsDataURL(file);
    },
    createCode: function createCode() {
      var url = "https://backendbutiko.com" + "/api/campaigns/create/" + this.idUser;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, this.form).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al crear código");
      });
    },
    openModal: function openModal(id) {
      var modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      var modal = document.getElementById(id);
      modal.close();
    },
    getCodigo: function getCodigo() {
      var _this2 = this;

      this.is_loading = true;

      var url = "https://backendbutiko.com" + "/api/campaigns/getList/" + this.idUser;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this2.codigoCampa = response.data.body.data;
        _this2.is_loading = false;
        _this2.configPagination(response.data.body);
      }).catch(function () {
        alert("No se obtuvieron resultados");
        _this2.is_loading = false;
        return;
      });
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    }
  },
  computed: {}
});

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["idUser"],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getPedidos();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "", name: "imagen", visible: true }, { label: "Descripción", name: "description", visible: true }, { label: "Url del Producto", name: "urlProduct", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      cotiaciones: null,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1
      },

      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true
    };
  },

  methods: {
    getPedidos: function getPedidos(page) {
      var _this = this;

      this.is_loading = true;

      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/client/getQuotationList/" + this.idUser;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this.cotiaciones = response.data.body.data;
        _this.is_loading = false;
        _this.configPagination(response.data.body);
      }).catch(function () {
        alert("No se obtuvieron resultados");
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;


      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["credential", "idUser"],
  data: function data() {
    return {
      dni: {
        anterior: this.credential.statuAnterior,
        posterior: this.credential.statuPosterior
      },
      inputDisabled: true,

      dniNumber: this.credential.documento
    };
  },

  methods: {
    changeNumberDni: function changeNumberDni() {
      var url = "https://backendbutiko.com" + "/api/admin/changeDni/" + this.idUser;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
        dni: this.dniNumber
      }).then(function () {

        location.reload();
      }).catch(function () {
        alert("Error al cambiar el número del DNI");

        return;
      });
    },
    inputChangeDisabled: function inputChangeDisabled() {
      this.inputDisabled = !this.inputDisabled;
    },
    changeStatusDni: function changeStatusDni(type) {
      var _this = this;

      var answer = null;
      var objDni = new Object();

      if (type === true) {
        answer = window.confirm("Desea cambiar el estado del DNI anterior, al estado " + this.dni.anterior);
        objDni.document_state = this.dni.anterior;
        objDni.side = type;
      } else if (type === false) {
        answer = window.confirm("Desea cambiar el estado del DNI posterior, al estado " + this.dni.posterior);
        objDni.document_state = this.dni.posterior;
        objDni.side = type;
      }

      if (answer) {
        this.is_loading = true;
        var url = "https://backendbutiko.com" + "/api/admin/changeStatusDocument/" + this.idUser;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, objDni).then(function () {
          location.reload();
        }).catch(function () {
          alert("Error al cambiar el estado del DNI");
          _this.is_loading = false;
          return;
        });
      } else {
        this.dni.anterior = this.credential.statuAnterior;
        this.dni.posterior = this.credential.statuPosterior;
      }
    }
  }
});

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["perfil", "credential"],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["idUser"],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getPedidos();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "N° Orden", name: "id", visible: true }, { label: "Descripción", name: "product_info", visible: true }, { label: "Fecha ", name: "fechaCreada", visible: true }, { label: "Estado", name: "state", visible: true }, { label: "Monto", name: "total_cost", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      pedido: null,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true
    };
  },

  methods: {
    getPedidos: function getPedidos(page) {
      var _this = this;

      this.is_loading = true;

      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.idUser + "/list-orders-by-client";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this.pedido = response.data.data;
        _this.is_loading = false;
        _this.configPagination(response.data);
      }).catch(function () {
        alert("No se obtuvieron resultados");
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;


      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["perfil", "direction", "idUser"],
  data: function data() {
    return {};
  },

  methods: {
    getDeleteUser: function getDeleteUser() {
      var _this = this;

      this.is_loading = true;
      var answer = window.confirm("Deseas eliminar al usuario?,se borrara todo vinculado a esta cuenta");
      if (answer) {
        var url = "https://backendbutiko.com" + "/api/client/" + this.idUser + "/delete";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(url, { params: { hard: true } }).then(function () {
          _this.is_loading = false;
          _this.$router.push({
            name: "Users"
          });
        }).catch(function (error) {
          var errorMessage = error.response && error.response.data.title ? error.response.data.title : 'No se pudo eliminar al usuario';
          alert("Error: " + errorMessage);
          _this.is_loading = false;
          return;
        });
      }
    }
  }
});

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["idUser"],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getPedidos();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "N° Operación", name: "operation", visible: true }, { label: "Descripción", name: "description", visible: true }, { label: "Pago", name: "pago", visible: true }, { label: "Fecha ", name: "fecha", visible: true }, { label: "Monto", name: "monto", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      saldo: null,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 20,
        page: 1
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true
    };
  },

  methods: {
    getPedidos: function getPedidos(page) {
      var _this = this;

      this.is_loading = true;

      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/balance/getClientBalance/" + this.idUser;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this.saldo = response.data.data.balance_list;
        _this.is_loading = false;
        _this.configPagination(response.data);
      }).catch(function () {
        alert("No se obtuvieron resultados");
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;


      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["idUser", "travelSquad"],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getViajes();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "Origen", name: "origin", visible: true }, { label: "Destino", name: "destination", visible: true }, { label: "Arrival Date ", name: "arrival_date", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      viajes: null,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true,
      travel_squad: this.travelSquad
    };
  },

  methods: {
    getViajes: function getViajes(page) {
      var _this = this;

      this.is_loading = true;

      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/client/" + this.idUser + "/listTravels";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this.viajes = response.data.body.data;
        _this.is_loading = false;
        _this.configPagination(response.data.body);
      }).catch(function (error) {
        console.log(error, "No se obtuvieron resultados");
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;


      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    activateSquad: function activateSquad() {
      var _this2 = this;

      var URL = "https://backendbutiko.com" + "/api/client/" + this.idUser + "/travelsquad";
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(URL, {
        "from_admin": "1",
        "travel_squad": "1"
      }).then(function (data) {
        if (data.status === 200) {
          _this2.travel_squad = 1;
        }
      }).catch(function (error) {
        console.info(error);
      });
    },
    unactivateSquad: function unactivateSquad() {
      var _this3 = this;

      var URL = "https://backendbutiko.com" + "/api/client/" + this.idUser + "/travelsquad";
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(URL, {
        "from_admin": "1",
        "travel_squad": "0"
      }).then(function (data) {
        if (data.status === 200) {
          _this3.travel_squad = 0;
        }
      }).catch(function (error) {
        console.info(error);
      });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashFooter',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessagesMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TasksMenu__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TasksMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TasksMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationsMenu__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NotificationsMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMenu__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LogOut__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LogOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LogOut__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashHeader',
  components: {
    MessagesMenu: __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default.a,
    NotificationsMenu: __WEBPACK_IMPORTED_MODULE_4__NotificationsMenu___default.a,
    TasksMenu: __WEBPACK_IMPORTED_MODULE_3__TasksMenu___default.a,
    UserMenu: __WEBPACK_IMPORTED_MODULE_5__UserMenu___default.a,
    LogOut: __WEBPACK_IMPORTED_MODULE_6__LogOut___default.a
  },
  props: ['user'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LogOut',
  methods: {
    logout: function logout() {
      console.log('Estoy en logout');

      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login/admin');
    }
  }
});

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageItem',
  props: ['message']
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessageItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessagesMenu',
  components: {
    MessageItem: __WEBPACK_IMPORTED_MODULE_2__MessageItem___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_notification_service__ = __webpack_require__(80);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notification: {
      type: Object,
      required: true
    }
  },

  methods: {
    readNotification: function readNotification() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var redirectTo, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.location.origin;
                redirectTo = '/purchaseOrder/' + _this.notification.data.purchaseorder_id + '/Show';

                if (_this.readFlag) {
                  _context.next = 11;
                  break;
                }

                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__services_notification_service__["a" /* notificationService */].readNotification(_this.notification.id);

              case 5:
                res = _context.sent;

                console.log("notification leida exitosamente");
                _this.$emit('readSuccess', 1);

                if (res) {

                  console.log(redirectTo);

                  window.location.replace(window.location.origin + redirectTo);
                }

                _context.next = 15;
                break;

              case 11:
                console.log("notification ya fue leida");
                console.log(redirectTo);

                window.location.replace("http://www.w3schools.com");
                window.location.href = redirectTo;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    readFlag: function readFlag() {
      return typeof this.notification.read_at != 'undefined' && this.notification.read_at != null;
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotificationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_os__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_os__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_notification_service__ = __webpack_require__(80);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationsMenu',
  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default.a
  },

  data: function data() {

    return {
      tab: 'new'
    };
  },
  mounted: function mounted() {
    console.log('Mounted!');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    notifications: function notifications() {
      return this.userInfo.notifications;
    },
    nextNotificationsUrl: function nextNotificationsUrl() {
      return this.notifications.next_page_url;
    },
    unreadCount: function unreadCount() {
      return this.notifications.unread_count;
    }
  }),
  methods: {
    markAllAsRead: function markAllAsRead() {
      event.stopPropagation();
      this.userInfo.notifications.filter(function (n) {
        return !n.read_at;
      }).forEach(function (notification) {
        notification.read_at = new Date().toUTCString;
      });
    },
    switchTab: function switchTab(event, tab) {
      event.stopPropagation();
      this.tab = tab;
    },
    getMoreNotifications: function getMoreNotifications() {
      console.log("more notifications");

      __WEBPACK_IMPORTED_MODULE_4__services_notification_service__["a" /* notificationService */].getMoreNotifications(this.nextNotificationsUrl, this.updateNotifications);
    },
    updateNotifications: function updateNotifications(notificationPagination) {
      console.log("update notifications");
      console.log(notificationPagination);

      console.log(this.userInfo.notifications);

      this.userInfo.notifications.next_page_url = notificationPagination.next_page_url;
      console.log("array 1");
      console.log(this.userInfo.notifications.data);

      this.userInfo.notifications.data = this.userInfo.notifications.data.concat(notificationPagination.data);

      console.log(this.userInfo.notifications);
    },
    discountReadNotification: function discountReadNotification() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log("en discount read notification");
      console.log(this.userInfo);
      console.log(this.userInfo.notifications.unread_count);

      if (this.userInfo.notifications.unread_count > 0) {
        console.log("vamos a restar");

        this.userInfo.notifications.unread_count = this.userInfo.notifications.unread_count - n;
      }
    }
  }
});

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['user'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var url = "https://backendbutiko.com" + "/api/exchange_rate/list";
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
      return _this.info = response;
    });
  }
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TasksMenu',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      id: this.$store.state.user.id
    };
  },

  name: 'UserMenu',
  props: ['user'],
  methods: {
    logout: function logout() {
      console.log('Estoy en logout');
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);
      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }
      this.$router.push('/welcome');
    },
    perfil: function perfil() {
      this.$router.push({ name: 'Profile' });
    },
    changePaswood: function changePaswood() {
      console.log("Cambiando contraseña");
      console.log(this.$store.state.user.id);
      this.$router.push({ name: 'NewPassword', params: { id: this.id } });
    }
  }
});

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cities_service__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_operators_service__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_shipment_service__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idOperator', 'dataLocal'],
  data: function data() {
    return {
      origin_id: 0,
      city_id: 0,
      dataShipmentCopy: null,
      newCityDestiny: null,
      newDescription: '',
      newDateDeparture: '',
      newHourDeparture: '',
      newDateArrival: '',
      newHourArrival: '',
      newRecieverOperator: null,
      newCreatorOperator: null,
      responseForm1: null,
      listCities: [],
      listOperatorReciever: [],
      listSenderOperators: []
    };
  },
  created: function created() {
    this.$validator.localize('es', {
      messages: __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es___default.a.messages,
      attributes: {
        description_shipment: 'descripción',
        destiny_city: 'ciudad destino',
        creator_operator: 'operador de envío',
        departure_date: 'fecha de salida',
        departure_hour: 'hora de salida',
        arrival_date: 'fecha de llegada',
        arrival_hour: 'hora de llegada',
        reciever_operator: 'operador de recepción'
      }
    });

    this.$validator.localize('es');

    if (!this.dataLocal.dataShipment.status) {
      if (this.currentUserRole == 'Admin') {
        __WEBPACK_IMPORTED_MODULE_3__services_operators_service__["a" /* operatorService */].listSenderOperators(this.getListSenderOperators);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__services_cities_service__["a" /* citiesService */].listDestinationCityToBoardByShipingOperator(this.idOperator, this.getListCities);
      }
    } else {
      console.log('Estamos en editar');

      this.setBoardingDataToShowAndEdit();
    }
  },

  watch: {
    newCreatorOperator: function newCreatorOperator(newSenderOperator) {
      if (!this.dataLocal.dataShipment.status) {
        console.log('Operador de envio elegido:');
        console.log(newSenderOperator);

        this.origin_id = newSenderOperator.attributes.profile.attributes.userable.attributes.city_id;
        __WEBPACK_IMPORTED_MODULE_2__services_cities_service__["a" /* citiesService */].listDestinationCityToBoardByShipingOperator(newSenderOperator.id, this.getListCities);
      }
    },
    newCityDestiny: function newCityDestiny(newValue) {
      console.log(newValue);
      this.newRecieverOperator = null;
      if (newValue != null) {
        __WEBPACK_IMPORTED_MODULE_3__services_operators_service__["a" /* operatorService */].listOperatorsDestination(newValue.id, this.getListOperators);
      }
    }
  },
  methods: {
    validarForm: function validarForm() {
      return 1;
    },
    toNextForm: function toNextForm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$validator.validate().then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                    var verifChange, creatorId;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (result) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt('return', _this.handleValidationErrorAdvanced());

                          case 4:
                            console.log('Formulario Embarque VALIDADO');

                            if (!_this.dataLocal.dataShipment.status) {
                              _context.next = 17;
                              break;
                            }

                            verifChange = false;

                            if (_this.dataShipmentCopy.description != _this.newDescription) {
                              _this.dataShipmentCopy.description = _this.newDescription;
                              verifChange = true;
                            }
                            if (_this.dataShipmentCopy.departure_date != _this.newDateDeparture) {
                              _this.dataShipmentCopy.departure_date = _this.newDateDeparture;
                              verifChange = true;
                            }
                            if (_this.dataShipmentCopy.departure_hour != _this.newHourDeparture) {
                              _this.dataShipmentCopy.departure_hour = _this.newHourDeparture;
                              verifChange = true;
                            }
                            if (_this.dataShipmentCopy.arrival_date != _this.newDateArrival) {
                              _this.dataShipmentCopy.arrival_date = _this.newDateArrival;
                              verifChange = true;
                            }
                            if (_this.dataShipmentCopy.arrival_hour != _this.newHourArrival) {
                              _this.dataShipmentCopy.arrival_hour = _this.newHourArrival;
                              verifChange = true;
                            }
                            if (_this.dataShipmentCopy.destination_id != _this.newCityDestiny.id) {
                              _this.dataShipmentCopy.destination_id = _this.newCityDestiny.id;
                              verifChange = true;
                            }
                            if (_this.dataShipmentCopy.reciever_operator_id != _this.newRecieverOperator.id) {
                              _this.dataShipmentCopy.reciever_operator_id = _this.newRecieverOperator.id;
                              verifChange = true;
                            }
                            if (verifChange) {}
                            _context.next = 42;
                            break;

                          case 17:
                            if (_this.dataLocal.dataShipment.status) {
                              _context.next = 42;
                              break;
                            }

                            console.log('Nuevo form limpio');
                            _this.dataShipmentCopy = new Object();
                            _this.dataShipmentCopy.status = true;
                            _this.dataShipmentCopy.description = _this.newDescription;
                            _this.dataShipmentCopy.origin_id = _this.origin_id;
                            _this.dataShipmentCopy.departure_date = _this.newDateDeparture + ' ' + _this.newHourDeparture;

                            _this.dataShipmentCopy.arrival_date = _this.newDateArrival + ' ' + _this.newHourArrival;

                            _this.dataShipmentCopy.destination_id = _this.newCityDestiny.id;
                            _this.dataShipmentCopy.destination = _this.newCityDestiny;

                            creatorId = _this.currentUserRole == 'Admin' ? _this.newCreatorOperator.id : _this.idOperator;

                            _this.dataShipmentCopy.creator_operator_id = creatorId;
                            _this.dataShipmentCopy.reciever_operator_id = _this.newRecieverOperator.id;
                            _context.next = 32;
                            return __WEBPACK_IMPORTED_MODULE_4__services_shipment_service__["a" /* shipmentService */].shipmentBasicCreate(_this.dataShipmentCopy);

                          case 32:
                            _this.responseForm1 = _context.sent;

                            if (_this.responseForm1) {
                              _context.next = 39;
                              break;
                            }

                            _this.dataShipmentCopy = new Object();
                            _this.dataShipmentCopy.status = false;
                            alert('fallo al crear embarque');
                            _context.next = 42;
                            break;

                          case 39:
                            _this.$emit('saveOK', true);
                            _this.showModalValidation();
                            return _context.abrupt('return');

                          case 42:
                            _this.$emit('toNextForm', _this.dataShipmentCopy, _this.responseForm1);

                          case 43:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getListCities: function getListCities(list) {
      this.listCities = list;
    },
    getListOperators: function getListOperators(list) {
      this.listOperatorReciever = list;
    },
    getListSenderOperators: function getListSenderOperators(list) {
      this.listSenderOperators = list;
    },
    setBoardingDataToShowAndEdit: function setBoardingDataToShowAndEdit() {
      this.dataShipmentCopy = this.dataLocal.dataShipment;


      this.newCityDestiny = this.dataLocal.dataShipment.destination;
      this.newDescription = this.dataLocal.dataShipment.description;
      this.newDateDeparture = this.dataLocal.dataShipment.departure_date;
      this.newHourDeparture = this.dataLocal.dataShipment.departure_hour;
      this.newDateArrival = this.dataLocal.dataShipment.arrival_date;
      this.newHourArrival = this.dataLocal.dataShipment.arrival_hour;
      this.newRecieverOperator = this.dataLocal.dataShipment.reciever_operator;
      this.newCreatorOperator = this.dataLocal.dataShipment.creator_operator;
    },
    hideModalValidation: function hideModalValidation() {
      this.$refs.validacionmodal.hide();
      this.$emit('toNextForm', this.dataShipmentCopy, this.responseForm1);
    },
    showModalValidation: function showModalValidation() {
      this.$refs.validacionmodal.show();
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return this.$store.state.user.type;
    }
  }
});

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_add_luggage_vue__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_add_luggage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_add_luggage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_weightUnit_service__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_luggage_service__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    cardAddLuggage: __WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_add_luggage_vue___default.a
  },
  props: ['id', 'dataLocal'],
  data: function data() {
    var luggageTypeTitle = {
      1: 'Maleta',
      2: 'Carry on',
      3: 'Mochila',
      4: 'Box'
    };
    return {
      luggageTypeTitle: luggageTypeTitle,
      dataLuggageCopy: null,

      typeLuggage: null,
      weightLuggage: '',
      weightUnitLuggage: null,
      descriptionLuggage: '',

      responseForm2: null,
      listWeightUnit: [],
      listLuggageType: []
    };
  },
  created: function created() {
    this.$validator.localize('es', {
      messages: __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es___default.a.messages,
      attributes: {
        type_luggage: 'tipo de equipaje',
        weight_luggage: 'peso',
        weight_unit: 'unidad de peso',
        description_luggage: 'descripción'
      }
    });

    this.$validator.localize('es');

    this.inicialiceDataLocal();
    __WEBPACK_IMPORTED_MODULE_3__services_weightUnit_service__["a" /* weightUnitService */].listAllWeightUnit(this.getListWeightUnit);
    __WEBPACK_IMPORTED_MODULE_4__services_luggage_service__["a" /* luggageService */].listAllLuggageType(this.getListLuggageType);
  },

  methods: {
    toNextForm: function toNextForm() {
      this.$emit('toNextForm', this.dataLuggageCopy);
    },
    deleteFromLuggageList: function deleteFromLuggageList(numeration, boardingId) {
      console.log('Estamos en el metodo del emit deleteFromLuggageList');
      console.log(numeration);
      console.log(boardingId);
      console.log(this.dataLuggageCopy.luggage_items[0]);
      console.log(this.dataLuggageCopy.luggage_items[1]);

      var index = this.findIndexLuggageByIds(numeration, boardingId);
      console.log('El index es ' + index);

      this.dataLuggageCopy.luggage_items.splice(index, 1);
      console.log('Terminamos de eliminar');
    },
    findIndexLuggageByIds: function findIndexLuggageByIds(numeration, boardingId) {
      return this.dataLuggageCopy.luggage_items.findIndex(function (luggage) {
        return luggage.numeration == numeration && luggage.boarding_id == boardingId;
      });
    },
    inicialiceDataLocal: function inicialiceDataLocal() {
      this.dataLuggageCopy = this.dataLocal.dataLuggage;
    },
    getListWeightUnit: function getListWeightUnit(list) {
      var _this = this;

      this.listWeightUnit = list;
      this.listWeightUnit.forEach(function (unit) {
        if (unit.attributes.key_name == 'lb') {
          _this.weightUnitLuggage = unit;
        }
      });
    },
    getListLuggageType: function getListLuggageType(list) {
      this.listLuggageType = list;
    },
    addNewLuggage: function addNewLuggage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$validator.validate().then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                    var dataObject;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (result) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt('return', _this2.handleValidationErrorAdvanced());

                          case 4:
                            console.log("paso");

                            dataObject = new Object();

                            dataObject.description = _this2.descriptionLuggage;
                            dataObject.weight = _this2.weightLuggage;
                            dataObject.weight_unit_id = _this2.weightUnitLuggage.id;
                            dataObject.luggage_type_id = _this2.typeLuggage.id;

                            _context.next = 12;
                            return __WEBPACK_IMPORTED_MODULE_4__services_luggage_service__["a" /* luggageService */].addLuggageToShipment(_this2.id, dataObject);

                          case 12:
                            _this2.responseForm2 = _context.sent;

                            _this2.hideModalSuitcase();

                            if (_this2.responseForm2) {
                              _this2.$emit('updateListLuggage', _this2.responseForm2);

                              setTimeout(function () {
                                this.inicialiceDataLocal();
                              }.bind(_this2), 2000);
                            }

                          case 15:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    validarForm: function validarForm() {
      return 1;
    },
    hideModalSuitcase: function hideModalSuitcase() {
      this.$refs.modalSuitcase.hide();
    },
    showModalSuitcase: function showModalSuitcase() {
      this.$refs.modalSuitcase.show();
    }
  },
  computed: {
    totalWeight: function totalWeight() {
      var subTotal = 0;
      if (this.dataLuggageCopy.luggage_items != null) {
        for (var i = 0; i < this.dataLuggageCopy.luggage_items.length; i++) {
          subTotal += this.dataLuggageCopy.luggage_items[i].attributes.weight;
        }
      }
      return subTotal;
    }
  }
});

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_list_orders_vue__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_list_orders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_list_orders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prefab_items_card_delete_orders_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prefab_items_card_delete_orders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_prefab_items_card_delete_orders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_orders_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_shipment_service__ = __webpack_require__(71);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'dataLocal'],
  components: {
    cardListOrders: __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_list_orders_vue___default.a,
    cardDeleteOrders: __WEBPACK_IMPORTED_MODULE_5__components_prefab_items_card_delete_orders_vue___default.a
  },
  data: function data() {
    return {
      resultado: '',
      equipaje: '',
      enumeration: '',
      creatorId: '',
      destinationId: '',
      dataOrderCopy: null,
      availableOrders: [],
      packagesToSave: [],
      isShowAll: false,
      filterValue: ''
    };
  },
  created: function created() {
    this.fetchData();
    this.findAvailableOrdersById();
  },

  methods: {
    form4: function form4() {
      this.$emit('go-toForm4');
    },
    openAcordion: function openAcordion() {
      this.isShowAll = !this.isShowAll;
    },
    inicialiceDataLocal: function inicialiceDataLocal() {
      this.dataOrderCopy = this.dataLocal.dataOrder;
    },
    savePackages: function savePackages() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, pasarArray, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('Estamos en save packages');

                formData = new Object();


                _this.packagesToSave.forEach(function (pack) {
                  delete pack.order_info;
                });

                formData = _this.pasarEmbarque;
                pasarArray = { "packages_to_save": __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(formData) };

                console.log('paso 1');
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_7__services_shipment_service__["a" /* shipmentService */].savePackages(_this.id, pasarArray);

              case 8:
                response = _context.sent;

                console.log(response);

                console.log('paso 2');

                _this.$emit('packages-saved');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    callbackTest: function callbackTest(value) {
      console.log('estamos en el callback de prueba');
      return;
    },
    getAvailableOrders: function getAvailableOrders(retrievedOrders) {
      console.log(retrievedOrders);
      this.availableOrders = retrievedOrders;
      this.availableOrders.forEach(function (order) {
        order.visible = true;
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;

      this.inicialiceDataLocal();
      this.destinationId = this.dataLocal.dataShipment.destination_id;
      this.creatorId = this.dataLocal.dataShipment.creator_operator_id;

      var packagesFromServer = this.dataLocal.dataOrder.packages;
      if (packagesFromServer) {
        packagesFromServer.forEach(function (pack) {
          var packObj = new Object();
          packObj.id = pack.id;
          packObj.number_of_items = pack.attributes.number_of_items;
          packObj.partial_weight = pack.attributes.partial_weight;
          packObj.purchase_order_id = pack.attributes.purchase_order_id;
          packObj.numeration = pack.attributes.numeration;
          packObj.luggageName = pack.attributes.luggageName;
          packObj.realPrice = pack.attributes.purchaseOrder.attributes.real_price;
          packObj.equipaje = pack.attributes.luggageName + ' - ' + pack.attributes.numeration;
          packObj.partial_price = pack.attributes.partial_price;

          var orderInfo = new Object();

          orderInfo.product_info = pack.attributes.purchaseOrder.attributes.product_info;
          orderInfo.product_image_url = pack.attributes.purchaseOrder.attributes.product_image_url;
          orderInfo.product_specimens = pack.attributes.purchaseOrder.attributes.product_specimens;
          orderInfo.order_code = pack.attributes.purchaseOrder.attributes.order_code;
          orderInfo.weight_kg = pack.attributes.purchaseOrder.attributes.weight_kg;
          orderInfo.id = null;
          orderInfo.purchaseOrder = pack.attributes.purchaseOrder;
          packObj.order_info = orderInfo;

          _this2.packagesToSave.push(packObj);
        });
      }

      __WEBPACK_IMPORTED_MODULE_6__services_orders_service__["a" /* ordersService */].listOrdersByCityAndOperator(this.creatorId, this.destinationId, this.getAvailableOrders);
    },
    addPackage: function addPackage(newPackage) {
      console.log(this.packagesToSave, " this.packagesToSave");

      console.log('En add package');
      console.log(newPackage);

      newPackage.number_of_items = parseInt(newPackage.number_of_items);
      newPackage.partial_weight = parseFloat(newPackage.partial_weight);
      var retrievedOrder = this.findAvailableOrdersById(newPackage.order_info.id);

      retrievedOrder.attributes.available_items_to_package = retrievedOrder.attributes.available_items_to_package - newPackage.number_of_items;

      var existOrder = this.packagesToSave.find(function (item) {
        return item.purchase_order_id === newPackage.purchase_order_id && item.equipaje === newPackage.equipaje;
      });

      if (existOrder) {
        existOrder.number_of_items = existOrder.number_of_items + newPackage.number_of_items;
      } else {
        this.packagesToSave.push(newPackage);
      }
    },
    findAvailableOrdersById: function findAvailableOrdersById(keyId) {
      return this.availableOrders.find(function (order) {
        return order.id == keyId;
      });
    },
    quitPackage: function quitPackage(_quitPackage) {

      var purchaseId = _quitPackage.purchase_order_id;

      var order = this.findAvailableOrdersById(purchaseId);

      if (order) {

        order.attributes.available_items_to_package = _quitPackage.number_of_items + order.attributes.available_items_to_package;
      } else {
        var purchaseOrder = _quitPackage.order_info.purchaseOrder;
        purchaseOrder.attributes.available_items_to_package = _quitPackage.number_of_items;
        purchaseOrder.visible = true;
        purchaseOrder.from_existing = true;
        purchaseOrder.number_of_items_prev = _quitPackage.number_of_items;
        purchaseOrder.package_id = _quitPackage.id;
        this.availableOrders.push(purchaseOrder);
      }

      var removeIndex = this.packagesToSave.findIndex(function (item) {
        return item.purchase_order_id === purchaseId && item.equipaje === _quitPackage.equipaje;
      });
      this.packagesToSave.splice(removeIndex, 1);
    }
  },
  computed: {
    items: function items() {
      var _this3 = this;

      return this.availableOrders.filter(function (item) {
        return item.attributes.order_code.toLowerCase().includes(_this3.filterValue.toLowerCase());
      });
    },

    totalWeightKg: function totalWeightKg() {
      var total = 0;

      this.packagesToSave.forEach(function (pack) {
        total = total + pack.partial_weight;
      });

      if (this.dataLocal.dataLuggage.luggage_items) {
        this.dataLocal.dataLuggage.luggage_items.forEach(function (luggage) {
          total = total + luggage.attributes.weight;
        });
      }

      this.$emit('total-weight-updated', total);
      return total;
    },
    sumaTotalPeso: function sumaTotalPeso() {
      var _this4 = this;

      var paquetes = [];

      this.dataLocal.dataLuggage.luggage_items.forEach(function (pack) {
        var suma = 0;
        var equipaje = new Object();
        equipaje.tipo = pack.attributes.luggage_type.attributes.name + ' - ' + pack.numeration;
        equipaje.attributo = [], _this4.packagesToSave.forEach(function (pack2) {
          var articulo = new Object();
          articulo.tipo = pack2.equipaje;
          articulo.peso = pack2.partial_weight;

          if (articulo.tipo === equipaje.tipo) {
            equipaje.attributo.push(articulo);
            suma = suma + articulo.peso;
            equipaje.sumaPeso = suma + pack.attributes.weight;
          }
        });

        paquetes.push(equipaje);
      });

      return paquetes;
    },

    sumaTotalPrecio: function sumaTotalPrecio() {
      var _this5 = this;

      var paquetes2 = [];

      this.dataLocal.dataLuggage.luggage_items.forEach(function (pack) {
        var suma = 0;
        var equipaje = new Object();
        equipaje.tipo = pack.attributes.luggage_type.attributes.name + ' - ' + pack.numeration;
        equipaje.attributo = [], _this5.packagesToSave.forEach(function (pack2) {
          var articulo = new Object();
          articulo.tipo = pack2.equipaje;
          articulo.precio = pack2.realPrice;

          if (articulo.tipo === equipaje.tipo) {
            equipaje.attributo.push(articulo);
            suma = suma + pack2.realPrice;
            equipaje.precio = suma;
          }
        });

        paquetes2.push(equipaje);
      });

      return paquetes2;
    },

    datosListar: function datosListar() {
      console.log("Ingreso a datos listar");
      var datosRecibidos = this.availableOrders;
      var busqueda = datosRecibidos.reduce(function (prev, current) {
        var index = current.id;
        if (!prev[index]) {
          prev[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, current, { purchase_order_id: current.id });
        } else {

          var element = prev[index];
          prev[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element, { attributes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element.attributes, { available_items_to_package: element.attributes.available_items_to_package + current.attributes.available_items_to_package }) });
        }
        return prev;
      }, {});

      return busqueda;
    },

    pasarEmbarque: function pasarEmbarque() {

      var datosRecibidos = this.packagesToSave;
      var busqueda = datosRecibidos.reduce(function (prev, current) {
        var index = current.purchase_order_id + '-' + current.equipaje;

        if (!prev[index]) {
          prev[index] = current;
        } else {
          var element = prev[index];
          prev[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element, { number_of_items: element.number_of_items + current.number_of_items, order_info: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element.order_info) });
        }
        return prev;
      }, {});
      return busqueda;
    }
  }
});

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_items_card_delete_orders_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_items_card_delete_orders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_items_card_delete_orders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_items_card_package_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_items_card_package_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_items_card_package_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_detail_luggage_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_detail_luggage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_detail_luggage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_DataTable_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    cardDeleteOrders: __WEBPACK_IMPORTED_MODULE_0__components_prefab_items_card_delete_orders_vue___default.a,
    cardPackage: __WEBPACK_IMPORTED_MODULE_1__components_prefab_items_card_package_vue___default.a,
    cardDetailLuggage: __WEBPACK_IMPORTED_MODULE_2__components_prefab_items_card_detail_luggage_vue___default.a,
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_views_DataTable_vue___default.a
  },
  props: ['id', 'dataLocal', 'totalWeightLb'],
  data: function data() {
    return {
      totalWeight: 0,
      sort: {
        key: '',
        isAsc: false
      }
    };
  },
  created: function created() {},

  computed: {
    dataPackageList: function dataPackageList() {
      var dataList = [];
      var data = this.dataLocal.dataOrder.packages;
      data.forEach(function (pack) {
        var dataPackage = new Object();
        dataPackage.equipaje = pack.attributes.luggageName.charAt(0).toUpperCase() + pack.attributes.luggageName.slice(1) + " - " + pack.attributes.numeration;
        dataPackage.numeroOrden = pack.attributes.purchaseOrder.attributes.order_code;
        dataPackage.cantidad = pack.attributes.number_of_items;
        if (pack.attributes.partial_price === 0) {
          dataPackage.precioDeclarado = pack.attributes.purchaseOrder.attributes.real_price;
        } else {
          dataPackage.precioDeclarado = pack.attributes.partial_price;
        }
        dataPackage.peso = pack.attributes.partial_weight;
        dataList.push(dataPackage);
      });

      return dataList;
    },
    sortedItems: function sortedItems() {
      var _this = this;

      var list = this.dataPackageList.slice();

      if (!!this.sort.key) {
        list.sort(function (a, b) {
          a = a[_this.sort.key];
          b = b[_this.sort.key];
          return (a === b ? 0 : a > b ? 1 : -1) * (_this.sort.isAsc ? 1 : -1);
        });
      }
      return list;
    }
  },
  methods: {
    toSendForm: function toSendForm() {
      this.$emit('toSendForm', true);
    },
    hideModalConfirmation: function hideModalConfirmation() {
      this.$refs.modalConfirmation.hide();
    },
    showModalConfirmation: function showModalConfirmation() {
      this.$refs.modalConfirmation.show();
    },
    sortedClass: function sortedClass(key) {
      return this.sort.key === key ? "sorted " + (this.sort.isAsc ? 'asc' : 'desc') : '';
    },
    sortBy: function sortBy(key) {
      this.sort.isAsc = this.sort.key === key ? !this.sort.isAsc : false;
      this.sort.key = key;
    }
  }

});

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_orders_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["orderDataShow", "fromDetail", "fromTracking"],
  data: function data() {
    return {
      statusIsPackage: this.orderDataShow.attributes.isPackage,
      trakingStatus: this.orderDataShow.attributes.order_tracking_details[this.orderDataShow.attributes.order_tracking_details.length - 1].attributes.status,
      statusTracking: [{ id: 1, text: "EN REVISIÓN" }, { id: 2, text: "COMPRADO" }, { id: 3, text: "PREPARANDO PARA ENVIAR" }, { id: 4, text: "LISTO PARA ENVIAR" }, { id: 5, text: "ENVIADO" }, { id: 6, text: "LISTO PARA ENTREGAR" }, { id: 7, text: "ENTREGADO" }, { id: 8, text: "SINIESTRADO" }, { id: 9, text: "EN PROCESO DE DEVOLUCIÓN" }, { id: 10, text: "RETORNADO AL PROVEEDOR" }],
      pagosStatus: this.orderDataShow.attributes.payed,
      statusPayment: [{ id: 1, text: "PENDIENTE" }, { id: 2, text: "EN PROCESO" }, { id: 3, text: "CONFIRMADO" }, { id: 10, text: "RECHAZADO" }, { id: 11, text: "RECLAMADO" }, { id: 12, text: "RETORNADO" }],
      packaged: 1,
      description: "",
      costingMethod: this.orderDataShow.attributes.costing_method,
      editPackagedFlag: false,
      editDescriptionFlag: false,
      editCostingMethodFlag: false
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$on("changeFlag", this.changeFlag);
  },

  methods: {
    changeStatusIsPackage: function changeStatusIsPackage() {
      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.orderDataShow.id + "/changeIsPackage";
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, { isPackage: this.statusIsPackage }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Hubo un error");
      });
    },
    changeStatusPayment: function changeStatusPayment(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, text, answer;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(data !== _this.orderDataShow.attributes.payed)) {
                  _context.next = 17;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/purchaseOrder/update-order-no-grabr/" + _this.orderDataShow.id;
                text = "";

                if (data === 1) {
                  text = "desea cambiar el estado a  'PENDIENT'";
                }
                if (data === 2) {
                  text = "desea cambiar el estado a  'SOFT_PAYED'";
                }
                if (data === 3) {
                  text = "desea cambiar el estado a  'HARD_PAYED'";
                }
                if (data === 4) {
                  text = "desea cambiar el estado a  'CONFIRMED'";
                }
                if (data === 10) {
                  text = "desea cambiar el estado a  'REJECTED'";
                }
                if (data === 11) {
                  text = "desea cambiar el estado a  'RECLAIMED'";
                }
                if (data === 12) {
                  text = "desea cambiar el estado a  'RETURNED'";
                }
                answer = window.confirm(text);

                if (!answer) {
                  _context.next = 16;
                  break;
                }

                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, { payed: data, writer_id: _this.$store.state.user.attributes.profile.id }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                  _this.pagosStatus = _this.orderDataShow.attributes.payed;
                });

              case 14:
                _context.next = 17;
                break;

              case 16:
                _this.pagosStatus = _this.orderDataShow.attributes.payed;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    editPackaged: function editPackaged() {
      this.packaged = this.packagedRealValue;
      this.editPackagedFlag = true;
    },
    cancelEditPackaged: function cancelEditPackaged() {
      console.log("cancelEditPackaged");
      this.editPackagedFlag = false;
    },
    updatePackaged: function updatePackaged() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var auxObject, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("updatePackaged");
                auxObject = new Object();

                auxObject.packaged = _this2.packaged == 1 ? null : _this2.packaged == 2 ? 1 : 0;

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__services_orders_service__["a" /* ordersService */].updateBuyingOrderNoGrabr(_this2.orderDataShow.attributes.order_code, auxObject);

              case 5:
                resp = _context2.sent;


                _this2.$emit("inicialize-data");
                _this2.editPackagedFlag = false;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    editDescription: function editDescription() {
      this.description = this.descriptionRealValue;
      this.editDescriptionFlag = true;
    },
    cancelEditDescription: function cancelEditDescription() {
      console.log("cancelEditDescription");
      this.editDescriptionFlag = false;
    },
    updateDescription: function updateDescription() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var auxObject, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("updateDescription");
                auxObject = new Object();

                auxObject.description = _this3.description;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__services_orders_service__["a" /* ordersService */].updateBuyingOrderNoGrabr(_this3.orderDataShow.attributes.order_code, auxObject);

              case 5:
                resp = _context3.sent;

                console.log("cambios en descripcion");
                console.log(auxObject);
                _this3.$emit("inicialize-data");
                _this3.editDescriptionFlag = false;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    editCostingMethod: function editCostingMethod() {
      this.costingMethod = this.costingMethodRealValue;
      this.editCostingMethodFlag = true;
    },
    cancelEditCostingMethod: function cancelEditCostingMethod() {
      this.editCostingMethodFlag = false;
      __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$emit("change-cancel");
    },
    updateCostingMethod: function updateCostingMethod() {
      this.editCostingMethodFlag = false;
      __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$emit("updatePurchaseOrder");
    },
    changeCostingMethod: function changeCostingMethod() {
      __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$emit("costing-method", this.costingMethod);
    },
    changeFlag: function changeFlag() {
      this.editCostingMethodFlag = false;
    }
  },
  computed: {
    packagedRealValue: function packagedRealValue() {
      var packagedAux = this.orderDataShow.attributes.packaged;
      if (packagedAux == null) {
        return 1;
      } else if (packagedAux == 1) {
        return 2;
      } else {
        return 3;
      }
    },

    descriptionRealValue: function descriptionRealValue() {
      var descriptionAux = this.orderDataShow.attributes.description;
      if (descriptionAux == null) {
        return null;
      } else {
        return this.description;
      }
    },

    costingMethodRealValue: function costingMethodRealValue() {
      var costingMethodAux = this.orderDataShow.attributes.costing_method;
      if (costingMethodAux == 1) return 1;else if (costingMethodAux == 2) return 2;else if (costingMethodAux == 3) return 3;
    }
  }
});

$(function () {
  $("#image").on("click", function () {
    $(".details1").addClass("gg");
  });
});

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_orders_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(111);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['orderDataShow'],
  data: function data() {
    return {
      realPrice: '',
      realTax: '',
      realShipping: '',
      fob: '',
      securityCost: '',
      fleteCost: '',
      cif: '',
      adValorem: '',
      igv: '',
      ipm: '',
      customsProcedure: '',
      customsProcedureConstant: 9.44,
      costoTotal: '',
      costingMethodFlag: false,
      costingMethod: ''
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$on('costing-method', this.setData);

    __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$on('updatePurchaseOrder', this.updatePurchaseOrder);
    this.initTableResume();
    __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$on('change-cancel', this.changeCancel);
  },

  methods: {
    initTableResume: function initTableResume() {
      this.realPrice = this.orderDataShow.attributes.real_price;
      this.realTax = this.orderDataShow.attributes.real_tax;
      this.realShipping = this.orderDataShow.attributes.real_shipping;
      this.fob = this.orderDataShow.attributes.fob;
      this.securityCost = this.orderDataShow.attributes.security_cost;
      this.fleteCost = this.orderDataShow.attributes.flete_cost;
      this.cif = this.orderDataShow.attributes.cif;
      this.adValorem = this.orderDataShow.attributes.ad_valorem;
      this.igv = this.orderDataShow.attributes.igv;
      this.ipm = this.orderDataShow.attributes.ipm;
      this.customsProcedure = this.orderDataShow.attributes.customs_procedure;
      this.costoTotal = this.orderDataShow.attributes.cif + (this.orderDataShow.attributes.ad_valorem + this.orderDataShow.attributes.igv + this.orderDataShow.attributes.ipm) + this.orderDataShow.attributes.customs_procedure;
      this.costingMethodFlag = false;
      this.costingMethod = this.orderDataShow.attributes.costing_method;
    },
    setData: function setData(newCostingMethod) {
      if (newCostingMethod == 1) {
        this.costingMethodFlag = false;
        this.costingMethod = newCostingMethod;

        this.securityCost = Number(Math.round(0.0075 * this.fob + 'e2') + 'e-2');
        this.fleteCost = 7 * this.orderDataShow.attributes.weight_kg;
        this.cif = this.fob + this.securityCost + Number(this.fleteCost);
        this.adValorem = Number(Math.round(0.04 * this.cif));
        this.igv = Number(Math.round(0.16 * this.cif + this.adValorem));
        this.ipm = Number(Math.round(0.02 * this.cif + this.adValorem));
        this.customsProcedure = 9.44;
        this.costoTotal = this.cif + (this.adValorem + this.igv + this.ipm) + this.customsProcedure;
      } else if (newCostingMethod == 2 || newCostingMethod == 3) {
        this.costingMethodFlag = true;
        this.costingMethod = newCostingMethod;

        this.securityCost = 0;
        this.fleteCost = 0;
        this.cif = this.fob + this.fleteCost + this.securityCost;
        this.adValorem = 0;
        this.igv = 0;
        this.ipm = 0;
        this.customsProcedure = 0;
        this.costoTotal = this.cif + this.customsProcedure;
      }
    },
    calculated: function calculated() {
      this.cif = this.fob + this.securityCost + Number(this.fleteCost);
      this.costoTotal = this.cif + (this.adValorem + this.igv + this.ipm) + this.customsProcedure;
    },
    updatePurchaseOrder: function updatePurchaseOrder() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var purchaseOrder, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                purchaseOrder = new Object();

                purchaseOrder.costing_method = _this.costingMethod;
                purchaseOrder.security_cost = _this.securityCost;
                purchaseOrder.flete_cost = _this.fleteCost;
                purchaseOrder.customs_procedure = _this.customsProcedure;
                purchaseOrder.adValorem = _this.adValorem;
                purchaseOrder.igv = _this.igv;
                purchaseOrder.ipm = _this.ipm;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_2__services_orders_service__["a" /* ordersService */].updateBuyingOrderNoGrabr(_this.orderDataShow.attributes.order_code, purchaseOrder);

              case 10:
                resp = _context.sent;

                _this.$emit('inicialize-data');
                _this.costingMethodFlag = false;

                __WEBPACK_IMPORTED_MODULE_3__main_js__["eventBus"].$emit('changeFlag');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeCancel: function changeCancel() {
      this.initTableResume();
      this.costingMethodFlag = false;
    }
  }
});

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getUsers();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "Código de cliente", name: "client_code", visible: true }, { label: "Store", name: "store_id", visible: true }, { label: "Documento ", name: "document_number", visible: true }, { label: "Email", name: "email", visible: true }, { label: "Nombres y Apellidos", name: "fullname", visible: true }, { label: "Teléfono", name: "cellphone", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      users: null,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        draw: 1,
        length: 10,
        status: 1,
        orderBy: "email",
        dir: "asc",
        filterBy: "all",
        filterValue: "",
        filterStatusDni: "all",
        page: 1
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true
    };
  },

  methods: {
    getUsers: function getUsers(page) {
      var _this = this;

      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var url = "https://backendbutiko.com" + "/api/client/list";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;

        if (_this.tableData.draw === data.meta.draw) {
          _this.users = data.data.clients_list;
          console.log(_this.users);

          _this.configPagination(data);
          _this.is_loading = false;
        } else {
          console.log("out of sync");
          _this.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors.response);
        alert("No se obtuvieron resultados");
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;


      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getUsers();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getUsers();
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: "Número de documento", name: "document_number", visible: true }, { label: "Username ", name: "username", visible: true }, { label: "Nombres y apellidos", name: "fullname", visible: true }, { label: "Ciudad", name: "city", visible: true }, { label: "Tipo", name: "operator_type", visible: true }, { label: "Número de celular", name: "cellphone", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      users: null,
      columns: columns,
      sortKey: "username",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        draw: 1,
        length: 10,
        status: 1,
        orderBy: "username",
        dir: "asc",
        filterBy: "all",
        filterValue: "",
        operatorType: null,
        page: 1
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true
    };
  },

  methods: {
    getUsers: function getUsers(page) {
      var _this = this;

      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/operator/list";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        console.log(response, "response desde lista d eoperadores");
        var data = response.data;
        if (_this.tableData.draw === data.meta.draw) {
          _this.users = data.data.operators_list;
          _this.configPagination(data);
          _this.is_loading = false;
        } else {
          console.log("out of sync");
          _this.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors.response);
        alert("No se obtuvieron resultados");
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;


      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getUsers();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ["document_number", "username", "fullname", "city"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_0__components_views_DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_1__components_views_Pagination_vue___default.a },
  created: function created() {
    this.getUsers();
  },
  data: function data() {

    var sortOrders = {};
    var columns = [{ label: 'Número de documento', name: 'document_number', visible: true }, { label: 'Username', name: 'username', visible: true }, { label: 'Nombres y apellidos', name: 'fullname', visible: true }, { label: 'Género', name: 'gender', visible: true }, { label: 'Número de celular', name: 'cellphone', visible: true }, { label: 'Fecha de nacimiento', name: 'birthdate', visible: true }, { label: 'Acciones', name: 'action', visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      users: null,
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      filterKey: '',
      tableData: {
        draw: 1,
        length: 10,
        status: 1,
        orderBy: 'username',
        dir: 'asc',
        filterBy: 'all',
        filterValue: '',
        page: 1
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      is_loading: true

    };
  },

  methods: {
    getUsers: function getUsers(page) {
      var _this = this;

      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var url = "https://backendbutiko.com" + '/api/admin/list';

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;

        if (_this.tableData.draw === data.meta.draw) {
          _this.users = data.data.admins_list;
          console.log(_this.users);

          _this.configPagination(data);
          _this.is_loading = false;
        } else {
          console.log('out of sync');
          _this.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors.response);
        alert('No se obtuvieron resultados');
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = '';
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;


      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';

      this.getUsers();
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    editPassword: function editPassword() {
      console.log("Cambiando contraseña");
      console.log(this.$store.state.user.id);
      this.$router.push({ name: 'NewPassword', params: { id: this.id } });
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ['username', 'fullname'];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }

});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_luggage_service__ = __webpack_require__(183);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dataLuggage'],
  data: function data() {
    return {};
  },

  methods: {
    quitLuggageItem: function quitLuggageItem() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var deleteOk;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_luggage_service__["a" /* luggageService */].deleteLuggageItem(_this.dataLuggage.numeration, _this.dataLuggage.boarding_id);

              case 2:
                deleteOk = _context.sent;

                if (deleteOk) {
                  _this.$emit('delete-from-luggage-list', _this.dataLuggage.numeration, _this.dataLuggage.boarding_id);
                } else {
                  console.log('No se pudo eliminar');
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dataOrder'],
  data: function data() {
    return {
      updatePrice: '',
      packagesToSave: []
    };
  },
  created: function created() {},

  methods: {
    alertQuitPackage: function alertQuitPackage() {
      console.log('Click en quit');
      console.log(this.dataOrder);
      this.$emit('quit-package', this.dataOrder);
    },

    updatePrecio: function updatePrecio() {
      return this.dataOrder.partial_price = parseFloat(this.updatePrice);
    },
    onlyNumber: function onlyNumber($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    }
  }

});

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dataLuggage'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_packages_service__ = __webpack_require__(84);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dataPackage', 'fromShipmentFlag'],
  data: function data() {
    return {
      state1: '',
      state2: '',
      state3: '',
      state4: '',
      responseEvaluation: null,
      listIncidents: []

    };
  },
  created: function created() {
    this.dataPackage = this.dataPackage;
  },

  methods: {
    evaluatePackage: function evaluatePackage() {
      this.showModalStatePackages();
    },
    askToSendEvaluation: function askToSendEvaluation() {
      if (!(this.state1 && this.state2 && this.state3 && this.state4)) {
        alert('Ingrese los valores del estado');
        return;
      } else {
        this.showModalConfirmation();
      }
    },
    sendEvaluationData: function sendEvaluationData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new Object();

                data.correct_items_not_wasted = _this.state1;
                data.correct_items_wasted = _this.state2;
                data.incorrect_items_not_wasted = _this.state3;
                data.incorrect_items_wasted = _this.state4;

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__services_packages_service__["a" /* packagesService */].sendStatesPackage(_this.dataPackage.id, data);

              case 7:
                _this.responseEvaluation = _context.sent;


                if (!_this.responseEvaluation) {
                  _this.hideModalConfirmation();
                  _this.hideModalStatePackages();
                } else {
                  _this.$emit('refresh', true);
                  _this.listIncidents = _this.responseEvaluation.attributes.generated_incidents;
                  _this.hideModalConfirmation();
                  _this.hideModalStatePackages();
                  _this.showModalIncidentsPackages();
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    hideMorePackageInfo: function hideMorePackageInfo(packageId) {
      console.log("en hideMorePackageInfo");

      var modalPackageInfoRef = 'modalMorePackageInfo-' + packageId;
      console.log(modalPackageInfoRef);

      this.$refs[modalPackageInfoRef].hide();
    },
    hideModalStatePackages: function hideModalStatePackages() {
      this.$refs.modalStatePackages.hide();
    },
    showModalStatePackages: function showModalStatePackages() {
      this.$refs.modalStatePackages.show();
    },
    hideModalIncidentsPackages: function hideModalIncidentsPackages() {
      this.$refs.modalIncidentsPackages.hide();
    },
    showModalIncidentsPackages: function showModalIncidentsPackages() {
      this.$refs.modalIncidentsPackages.show();
    },
    hideModalConfirmation: function hideModalConfirmation() {
      this.$refs.modalConfirmation.hide();
    },
    showModalConfirmation: function showModalConfirmation() {
      this.$refs.modalConfirmation.show();
    }
  },
  computed: {
    deltaItems: function deltaItems() {
      if (this.state1 != '') {
        var successItems = parseInt(this.state1);
        return this.dataPackage.attributes.number_of_items - successItems;
      }
      return null;
    }
  }
});

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['currentOrder', 'totalWeightKg', 'equipaje', 'stock'],
  data: function data() {
    return {
      added: false,
      counterItems: this.currentOrder.attributes.available_items_to_package
    };
  },

  methods: {
    alertAddPackage: function alertAddPackage() {
      console.log('Click en boton');
      console.log("counterItems", this.counterItems);
      var partialWeight = this.currentOrder.attributes.weight_kg / this.currentOrder.attributes.product_specimens * this.counterItems;

      if (partialWeight + this.totalWeightKg > 1500) {
        alert('No puede mover esta cantidad de items del paquete porque sobrepasa el limite de peso de un embarque');

        return;
      }

      var addedPackage = void 0;
      addedPackage = new Object();

      addedPackage.equipaje = this.equipaje;
      var separarNumeration = this.equipaje.split(" - ", 2);
      addedPackage.numeration = parseInt(separarNumeration[1]);
      addedPackage.luggageName = separarNumeration[0];
      addedPackage.number_of_items = this.counterItems;
      addedPackage.partial_weight = partialWeight;
      addedPackage.partial_price = 0;

      addedPackage.realPrice = this.currentOrder.attributes.real_price;
      addedPackage.partial_weight = Number(Math.round(parseFloat(addedPackage.partial_weight) + 'e2') + 'e-2').toFixed(2);
      addedPackage.purchase_order_id = this.currentOrder.id;

      if (typeof this.currentOrder.package_id !== 'undefined' && this.currentOrder.package_id) {
        addedPackage.id = this.currentOrder.package_id;
      }
      var orderInfo = new Object();
      orderInfo.product_info = this.currentOrder.attributes.product_info;
      orderInfo.product_image_url = this.currentOrder.attributes.product_image_url;
      orderInfo.product_specimens = this.currentOrder.attributes.product_specimens;
      orderInfo.order_code = this.currentOrder.attributes.order_code;
      orderInfo.weight_kg = this.currentOrder.attributes.weight_kg;
      orderInfo.id = this.currentOrder.id;
      addedPackage.order_info = orderInfo;
      this.added = true;
      this.counterItems = this.currentOrder.attributes.available_items_to_package - this.counterItems;
      console.log(this.currentOrder.attributes.available_items_to_package, "this.currentOrder.attributes.available_items_to_package");
      this.$emit('add-package', addedPackage);
    }
  },
  computed: {
    setCounterItems: {
      get: function get() {
        return this.currentOrder.attributes.available_items_to_package;
      },
      set: function set(newValue) {

        this.counterItems = newValue;
      }
    }
  },
  watch: {
    stock: function stock(newVal, oldVal) {
      this.counterItems = newVal;
    }
  }
});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_packages_service__ = __webpack_require__(84);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dataPackage', 'afterSavePackages'],
  data: function data() {
    return {};
  },
  created: function created() {
    this.dataPackage = this.dataPackage;
  }
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_comments_service__ = __webpack_require__(112);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["orderCancelledFlag", "comment", "order"],
  data: function data() {
    return {
      oldContent: this.comment.attributes.content,
      newContent: this.comment.attributes.content,
      editCommentFlag: false
    };
  },
  updated: function updated() {
    console.log("En updated de ");
    console.log(this.comment);

    if (!this.editCommentFlag) {
      this.oldContent = this.comment.attributes.content;
      this.newContent = this.comment.attributes.content;
    }
  },


  methods: {
    editComment: function editComment(commentId) {
      console.log("estamos en editComment");

      this.editCommentFlag = true;
      this.$emit("in-edition", commentId);
    },
    cancelEditComment: function cancelEditComment() {
      this.editCommentFlag = false;
      this.$emit("cancel-edition");
    },
    updateComment: function updateComment(commentId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var commentData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commentData = {};

                console.log("Estamos en update comment");

                if (!(_this.currentContent != "")) {
                  _context.next = 10;
                  break;
                }

                commentData.content = _this.newContent;
                res = false;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__services_comments_service__["a" /* commentsService */].updateComment(commentId, commentData);

              case 7:
                res = _context.sent;

                console.log(res);

                if (res) {
                  _this.editCommentFlag = false;
                  _this.$emit("display-comments");
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deleteComment: function deleteComment(commentId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("Estamos en delete comment");

                res = false;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__services_comments_service__["a" /* commentsService */].deleteComment(commentId);

              case 4:
                res = _context2.sent;

                console.log(res);

                if (res) {
                  _this2.$emit("comment-deleted");
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: {
    ownComment: function ownComment() {
      return this.comment.attributes.writer.attributes.userable.id == this.$store.state.user.id && (this.comment.attributes.cancelled == null || this.comment.attributes.cancelled == 0);
    },
    otherComment: function otherComment() {
      return this.comment.attributes.writer.attributes.userable.id != this.$store.state.user.id && (this.comment.attributes.cancelled == null || this.comment.attributes.cancelled == 0);
    },
    systemComment: function systemComment() {
      return this.comment.attributes.cancelled == 1;
    }
  }
});

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['nameSection', 'listRoutes', 'activeRoute'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['isFullActive'],
  data: function data() {
    return {
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
      _this.loading = true;
      return config;
    }, function (error) {
      _this.loading = false;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
      _this.loading = false;
      return response;
    }, function (error) {
      _this.loading = false;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demo__ = __webpack_require__(182);




var pluginURL = '/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js';
var mapURL = '/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Access',
  data: function data() {
    return {
      stats: __WEBPACK_IMPORTED_MODULE_0__demo__["b" /* stats */]
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.jQuery.getScript(pluginURL, function () {
        window.jQuery.getScript(mapURL, function () {
          window.jQuery('#world-map-markers').vectorMap({
            map: 'world_mill'
          });
        });
      });
    });
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_2__DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_3__Pagination_vue___default.a, breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a },
  data: function data() {
    var statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado"
    };

    var statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado"
    };

    var cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking"
    };
    var sortOrders = {};
    var columns = [{ label: "Producto", name: "product", visible: false }, { label: "Consignatario", name: "consignatario", visible: false }, { label: "Acciones", name: "acciones", visible: false }];

    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      isOrder: true,
      isWr: true,

      warehouseorder: null,

      formCreate: {
        id: null,
        key: null,
        name: null,
        margin: null,
        subpartida: null
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns: columns,
      statusGroupArray: statusGroupArray,
      statusArray: statusArray,
      cancelledReasonFlagArray: cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true
        },
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null,
        order_type: 5,
        store: "all"
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      grabr: {
        id: "1"
      },
      is_loading: true,
      nameSection: "Categorias",
      listRoutes: [{ nameRoute: "Categorias", titleRoute: "Categorias" }],
      subPartidaList: [],
      listCategory: [],
      listTotalCategory: [],
      keyword: ""
    };
  },
  mounted: function mounted() {
    this.getCategorias();
    this.getSubPartidas();
  },

  methods: {
    deleteCategory: function deleteCategory(id) {
      var _this = this;

      var answer = window.confirm("Seguro de eliminar la Categoría:" + id);
      if (answer) {
        this.is_loading = true;

        var url = "https://backendbutiko.com" + "/api/category/deleteCategories/" + id;
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url).then(function () {
          location.reload();
        }).catch(function () {
          alert("Error al eliminar la Categoría");
          _this.is_loading = false;
        });
      }
    },
    createCategory: function createCategory() {
      var _this2 = this;

      this.is_loading = true;

      var url = "https://backendbutiko.com" + "/api/category/createCategories";
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, this.formCreate).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al crear la categoría");
        _this2.is_loading = false;
      });
    },
    updateCategory: function updateCategory() {
      var _this3 = this;

      this.is_loading = true;

      var url = "https://backendbutiko.com" + "/api/category/createCategories";
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, this.formCreate).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al actualizar la categoría");
        _this3.is_loading = false;
      });
    },
    getSubPartidas: function getSubPartidas() {
      var _this4 = this;

      var url = "https://backendbutiko.com" + "/api/subpartida/getSubpartidas";

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function (response) {
        _this4.subPartidaList = response.data.body.data;
      }).catch(function () {
        alert("No se obtuvieron SubPartida");

        return;
      });
    },
    getCategorias: function getCategorias(page) {
      var _this5 = this;

      this.is_loading = true;

      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/category/getCategories";

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this5.listCategory = response.data.body.data;
        _this5.is_loading = false;
        _this5.configPagination(response.data.body);
      }).catch(function () {
        alert("No se obtuvieron Categorias");
        _this5.is_loading = false;
        return;
      });
    },
    getCategoriasWithFilter: function getCategoriasWithFilter(page) {
      var _this6 = this;

      this.is_loading = true;
      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/category/getCategories";
      var params = {
        length: this.tableData.length,
        page: this.tableData.page,
        filter: this.keyword.trim()
      };
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
        params: params
      }).then(function (response) {
        _this6.listCategory = response.data.body.data;
        _this6.is_loading = false;
        _this6.configPagination(response.data.body);
      }).catch(function () {
        alert("No se obtuvieron Categorias");
        _this6.is_loading = false;
        return;
      });
    },
    cambiarEstado: function cambiarEstado() {
      this.valorRadioButton = false;
    },
    toGrabrDetail: function toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      var linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes: function showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last;
      this.pagination.nextPageUrl = data.next;
      this.pagination.prevPageUrl = data.prev;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir);
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    hideModal: function hideModal() {
      this.$refs.formmodal.hide();
    },
    openModal: function openModal(id, data) {
      if (data) {
        this.formCreate.id = data.id;
        this.formCreate.key = data.key;
        this.formCreate.name = data.name;
        this.formCreate.margin = data.margin;
        this.formCreate.subpartida = data.subpartida;
      }
      var modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      this.formCreate.id = null;
      this.formCreate.key = null;
      this.formCreate.name = null;
      this.formCreate.margin = null;
      this.formCreate.subpartida = null;
      var modal = document.getElementById(id);
      modal.close();
    },
    prevSlide: function prevSlide() {
      this.currentSlide === 1 ? this.currentSlide = this.maxSlide : this.currentSlide = this.currentSlide - 1;
    },
    nextSlide: function nextSlide() {
      this.currentSlide === this.maxSlide ? this.currentSlide = 1 : this.currentSlide = this.currentSlide + 1;
    },
    handleSubmit: function handleSubmit() {
      this.getCategoriasWithFilter();
    },
    handleClear: function handleClear() {
      this.keyword = "";
      this.getCategorias();
    },
    exportToExcel: function exportToExcel() {
      var _this7 = this;

      var url = "https://backendbutiko.com" + "/api/category/getCategories";

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
        params: {
          export: true
        }
      }).then(function (response) {
        var excel_base64 = response.data.body.excel_base64;
        _this7.convertToExcel(excel_base64);
      }).catch(function () {
        alert("No se pudo exportar");
        _this7.is_loading = false;
        return;
      });
    },
    convertToExcel: function convertToExcel(data) {
      var base64Data = data;
      var binaryData = atob(base64Data);
      var length = binaryData.length;
      var byteArray = new Uint8Array(length);
      for (var i = 0; i < length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
      }

      var blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      var blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    }
  },
  computed: {
    filterColumns: function filterColumns() {

      var activeFilterColumns = ["product_info", "referent link", "order_code", "client_grabr_id", "destination", "tracking_number"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    },
    statusComputed: function statusComputed() {
      console.log("statuscomputed");
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.tableData.statusFlag.todos, this.tableData.statusFlag.activos, this.tableData.statusFlag.cancelados]);
    }
  }
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


var _components$created$d;




/* harmony default export */ __webpack_exports__["default"] = (_components$created$d = {
  components: { breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default.a },
  created: function created() {},
  data: function data() {
    return {
      cotizaciones: null,
      nameSection: "Cotizaciones",
      listRoutes: [{ nameRoute: "cotizaciones", titleRoute: "Cotizaciones de producto" }],
      tableData: {
        orderBy: "created_at",
        length: 10,
        page: 1
      },
      pagination: {
        lastPage: "5",
        currentPage: 1,
        total: 5,
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "1",
        to: "5"
      },
      is_loading: true
    };
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$created$d, "created", function created() {
  this.getPurchaseOrdersByPage();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$created$d, "methods", {
  getPurchaseOrdersByPage: function getPurchaseOrdersByPage(page) {
    var _this = this;

    this.is_loading = true;

    this.tableData.page = page;

    var url = "https://backendbutiko.com" + "/api/quoatation/list";

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
      console.log(response, "cotizacion");
      _this.cotizaciones = response.data.body.data;
      _this.is_loading = false;
      _this.configPagination(response.data.body);
    }).catch(function (error) {
      console.log(error, "error de la cotización");
      alert("No se obtuvieron resultados");
      _this.is_loading = false;
      return;
    });
  },
  configPagination: function configPagination(data) {
    this.pagination.lastPage = data.last_page;
    this.pagination.currentPage = data.current_page;
    this.pagination.total = data.total;
    this.pagination.lastPageUrl = data.last;
    this.pagination.nextPageUrl = data.next;
    this.pagination.prevPageUrl = data.prev;
    this.pagination.from = data.from;
    this.pagination.to = data.to;
    this.pagination.perPage = this.tableData.length;
  }
}), _components$created$d);

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ApiKeys: [],
      apiObject: {}
    };
  },
  mounted: function mounted() {
    this.getApiKeys();
  },

  methods: {
    updateKeyValue: function updateKeyValue(data, value) {
      var _this = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/ApiKey/updatekey/" + data.attributes.name;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
        name: data.attributes.name,
        key: value
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al Actualizar");
        _this.is_loading = false;
        return;
      });
    },
    getApiKeys: function getApiKeys() {
      var _this2 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/ApiKey/listAll";

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        _this2.ApiKeys = response.data.body;
        _this2.ApiKeys.forEach(function (element) {
          _this2.$set(_this2.apiObject, element.attributes.name, element.attributes.key);
        });

        _this2.is_loading = false;
      }).catch(function () {
        alert("No se obtuvieron resultados");
        _this2.is_loading = false;
        return;
      });
    }
  }
});

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_Alert__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_InfoBox__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_InfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_InfoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_ProcessInfoBox__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_ProcessInfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_ProcessInfoBox__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_1__widgets_Alert___default.a,
    InfoBox: __WEBPACK_IMPORTED_MODULE_2__widgets_InfoBox___default.a,
    ProcessInfoBox: __WEBPACK_IMPORTED_MODULE_3__widgets_ProcessInfoBox___default.a
  },
  data: function data() {
    return {
      generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
        var a = [];
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max);
        }
        return a;
      },

      type: 'danger',
      dismissible:  false ? true : false,
      title: 'este es ei título de la alerta'
    };
  },

  computed: {
    coPilotNumbers: function coPilotNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    personalNumbers: function personalNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  mounted: function mounted() {},

  methods: {
    gotoPage: function gotoPage(val) {
      if (val == 1) {
        this.$router.push({ name: 'Orders' });
      }
      if (val == 2) {
        this.$router.push({ name: 'shipments-list' });
      }
      if (val == 3) {
        this.$router.push({ name: 'Profile' });
      }

      if (val == 4) {
        this.$router.push({ name: 'Users' });
      }
    }
  }
});

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['columns', 'sortKey', 'sortOrders'],
  computed: {
    filteredColumns: function filteredColumns() {
      return this.columns.filter(function (x) {
        return x.visible;
      });
    }
  }
});

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({

  components: { breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default.a },
  created: function created() {
    this.getRebate();
  },
  data: function data() {
    return {
      id: this.$store.state.route.params.id,
      amountRebate: "",
      publicationCode: "",
      price: "",
      title: "",
      datefrom: "",
      dateTo: "",
      active: "",
      nameSection: 'Editar Rebate',
      listRoutes: [{ nameRoute: 'EditRebate', titleRoute: 'Editar Rebate' }]
    };
  },

  methods: {
    getRebate: function getRebate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://backendbutiko.com" + "/api/rebate/" + this.id + "/get").then(function (response) {
        console.log(response);
        var dateFrom = response.data.body.from.split(" ");
        dateFrom = dateFrom[0];
        var dateTo = response.data.body.to.split(" ");
        dateTo = dateTo[0];
        _this.amountRebate = response.data.body.amount;
        _this.publicationCode = response.data.body.publication_code;
        _this.datefrom = dateFrom;
        _this.dateTo = dateTo;
        _this.active = response.data.body.active;
      });
    },
    editRebate: function editRebate() {
      if ($("#date").val() < $("#date2").val()) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://backendbutiko.com" + "/api/rebate/update", {
          "id": this.id,
          "amount": this.amountRebate,
          "publication_code": this.publicationCode,
          "from": this.datefrom,
          "to": this.dateTo
        }).then(function (response) {
          console.log(response);
          if (response.data.status) {
            window.history.go(-1);
          }
        });
      } else {
        alert("La fecha de inicio no puede ser menor que la de fin");
      }
    },
    deleteRebate: function deleteRebate() {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://backendbutiko.com" + "/api/rebate/delete/" + this.id).then(function (response) {
        console.log(response);
        if (response.data.status) {
          window.history.go(-1);
        }
      });
    }
  },
  computed: {}
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_2__DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_3__Pagination_vue___default.a, breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a },
  created: function created() {
    if (!this.$store.state.user.attributes.permissions_keys.includes(6)) {
      this.grabr.id = "2";
    }
    if (this.purchaseOrders == null) {
      this.is_loading = true;
    }
    this.getPurchaseOrders();
  },
  data: function data() {
    var statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado"
    };

    var statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado"
    };

    var cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking"
    };
    var sortOrders = {};
    var columns = [{ label: "Producto", name: "product_info", visible: true }, { label: "Proveedor", name: "referent_link", visible: false }, { label: "Número de orden SB", name: "order_code", visible: false }, { label: "Código de cliente SB", name: "client_grabr_id", visible: false }, { label: "Destino", name: "destination", visible: false }, { label: "Tracking SB", name: "tracking_number", visible: false }, { label: "ID", name: "id", visible: false }, { label: "Código Partner", name: "grabr_code", visible: false }, { label: "Nombre de cliente", name: "client_name", visible: false }, { label: "DNI Cliente", name: "client_dni", visible: false }, { label: "Ruta", name: "route", visible: true }, { label: "Estado", name: "status", visible: true }, { label: "Documentos", name: "documentos", visible: true }, { label: "Fecha de compra", name: "order_create_date", visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      typeEstado: "1",
      valorRadioButton: true,
      purchaseOrders: null,
      columns: columns,
      statusGroupArray: statusGroupArray,
      statusArray: statusArray,
      cancelledReasonFlagArray: cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true
        },
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null,
        order_type: 5,
        store: "all"
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      grabr: {
        id: "1"
      },
      is_loading: true,
      nameSection: "Órdenes de compra",
      listRoutes: [{ nameRoute: "Orders", titleRoute: "Órdenes de compra" }]
    };
  },

  methods: {
    changeEstadoListOrder: function changeEstadoListOrder(type) {
      if (type === "1") {
        this.tableData.statusFlag.todos = true;
        this.tableData.statusFlag.activos = true;
        this.tableData.statusFlag.cancelados = true;
        this.getPurchaseOrdersByPage();
      } else if (type === "2") {
        this.tableData.statusFlag.todos = false;
        this.tableData.statusFlag.activos = true;
        this.tableData.statusFlag.cancelados = false;
        this.getPurchaseOrdersByPage();
      } else if (type === "3") {
        this.tableData.statusFlag.todos = false;
        this.tableData.statusFlag.activos = false;
        this.tableData.statusFlag.cancelados = true;
        this.getPurchaseOrdersByPage();
      }
    },
    getStore: function getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);
        if (separation1[0] !== "https://www") {
          var separation2 = link.split("//", 3);
          var separation3 = separation2[1].split(".", 1);

          return separation3[0];
        }

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado: function cambiarEstado() {
      this.valorRadioButton = false;
    },
    toGrabrDetail: function toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      var linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes: function showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getPurchaseOrders: function getPurchaseOrders() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var fromPagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log("Cargando todas las PurchasOrders");
      this.is_loading = true;
      this.tableData.draw++;
      var permissions = this.$store.state.user.attributes.permissions_keys;
      if (!fromPagination) {
        if (permissions.includes(1)) {
          url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
        } else if (permissions.includes(2)) {
          url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-operator";
        } else if (permissions.includes(3)) {
          url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-client";
        } else {
          alert("El usuario no tiene permisos para ver órdenes de compra");
          return;
        }
      }
      console.log("URL: " + url);
      console.log("Viene de una paginación? : " + fromPagination);
      console.log("Table data : ");
      this.tableData.status = this.statusComputed;
      console.log(this.tableData);

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: fromPagination ? {} : this.tableData }).then(function (response) {
        var data = response.data;
        console.log(data);
        if (_this.tableData.draw === data.meta.draw || fromPagination) {
          console.log("there are sync or if from pagination");
          _this.purchaseOrders = data.data;
          _this.configPagination(data);
          _this.is_loading = false;
        } else {
          console.log("out of sync");
          _this.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this.purchaseOrders = null;
        _this.is_loading = false;
        return;
      });
    },
    getPurchaseOrdersByPage: function getPurchaseOrdersByPage() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var permissions = this.$store.state.user.attributes.permissions_keys;
      var url = "";
      if (permissions.includes(1)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-client";
      } else {
        return;
      }
      this.tableData.status = this.statusComputed;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;

        if (_this2.tableData.draw === data.meta.draw) {
          console.log("RESPONSE:");

          console.log("there are sync");
          console.log("Table data : ");
          console.log(_this2.tableData);
          console.log(data);

          console.log("=======================");

          _this2.purchaseOrders = data.data;
          _this2.configPagination(data);
          _this2.is_loading = false;
          console.log("FIN RESPONSE");
        } else {
          console.log("ERROR:");

          console.log("out of sync");

          console.log(_this2.tableData);
          _this2.is_loading = false;
          console.log("FIN ERROR");
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this2.purchaseOrders = null;
        _this2.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir);
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    hideModal: function hideModal() {
      this.$refs.formmodal.hide();
    }
  },
  computed: {
    diasRestantes: function diasRestantes() {
      var fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach(function (data) {
        var fechaEntrega = data.attributes.promised_delivery_date;
        var fecha = new Date();
        var fechaini = new Date(fechaEntrega);
        var diff = fechaini.getTime() - fecha.getTime();
        var diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns: function filterColumns() {

      var activeFilterColumns = ["product_info", "referent link", "order_code", "client_grabr_id", "destination", "tracking_number"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    },
    statusComputed: function statusComputed() {
      console.log("statuscomputed");
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.tableData.statusFlag.todos, this.tableData.statusFlag.activos, this.tableData.statusFlag.cancelados]);
    }
  }
});

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['pagination'],
  created: function created() {
    console.log('This is pagination component');
    console.log('per page: ' + this.pagination.perPage);
    console.log('current page: ' + this.pagination.currentPage);
    console.log('rows: ' + this.pagination.total);

    this.perPage = this.pagination.perPage;
    this.currentPage = this.pagination.currentPage;
    this.rows = this.pagination.total;
  },
  data: function data() {
    return {
      perPage: this.pagination.perPage,
      currentPage: this.pagination.currentPage,
      rows: this.pagination.total
    };
  },


  watch: {
    currentPage: function currentPage() {
      console.log('cambio');
      console.log(this.currentPage);
      this.$emit('changePagination', this.currentPage);
    }
  }
});

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a },
  data: function data() {
    return {
      selectionUser: 'perfil',

      idUser: this.$store.state.user.id,
      nameUser: this.$store.state.user.attributes.profile.attributes.name,
      lastnameUser: this.$store.state.user.attributes.profile.attributes.surnames,
      genderUser: this.$store.state.user.attributes.profile.attributes.gender,
      codUser: this.$store.state.user.attributes.profile.attributes.country_code,
      celUser: this.$store.state.user.attributes.profile.attributes.cellphone,
      brithUser: this.$store.state.user.attributes.profile.attributes.birthdate,
      typeUser: this.$store.state.user.attributes.profile.attributes.userable_type,

      userName: this.$store.state.user.attributes.username,
      operadorType: this.$store.state.user.attributes.operator_type,
      cityId: this.$store.state.user.attributes.city_id,
      password: this.$store.state.user.attributes.password,
      deleted: this.$store.state.user.attributes.deleted,

      nameSection: 'Perfil',
      listRoutes: [{ nameRoute: 'Perfil', titleRoute: 'Perfil' }]
    };
  },
  created: function created() {},

  methods: {
    editUser: function editUser() {
      var _this = this;

      var objaux = new Object();
      objaux.name = this.nameUser;
      objaux.surnames = this.lastnameUser;
      objaux.country_code = this.codUser;
      objaux.cellphone = this.celUser;
      objaux.birthdate = this.brithUser;
      objaux.gender = this.genderUser;
      objaux.userable_type = this.typeUser;
      console.log(objaux);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put("https://backendbutiko.com" + "/api/admin/update-admin-profile/" + this.idUser, objaux).then(function (response) {
        console.log(response);
        _this.$store.commit('SET_USER', response.data.body);
        _this.$store.commit('SET_TOKEN', 'some token');
        localStorage.removeItem('image');
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.body));
        window.localStorage.setItem('token', 'some token2');
      });
    },
    editOperator: function editOperator() {
      var _this2 = this;

      var operator = new Object();
      operator.name = this.nameUser;
      operator.surnames = this.lastnameUser;
      operator.gender = this.genderUser;
      operator.username = this.userName;
      operator.password = this.password;
      operator.operator_type = this.operadorType;
      operator.city_id = this.cityId;
      console.log(operator);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put("https://backendbutiko.com" + "/api/operator/update-operator/" + this.idUser, operator).then(function (response) {
        console.log(response);
        _this2.$store.commit('SET_USER', response.data.body);
        _this2.$store.commit('SET_TOKEN', 'some token');
        localStorage.removeItem('image');
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.body));
        window.localStorage.setItem('token', 'some token2');
      });
    },
    desactivar: function desactivar() {
      var _this3 = this;

      console.log('Estoy en logout');
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);
      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }
      this.$router.push('/welcome');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://backendbutiko.com" + "/api/operator/delete/" + this.idUser).then(function (response) {
        console.log(response);
        _this3.$store.commit('SET_USER', response.data.body);
        _this3.$store.commit('SET_TOKEN', 'some token');
        localStorage.removeItem('image');
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.body));
        window.localStorage.setItem('token', 'some token2');
      });
    }
  }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


var _components$created$d;




/* harmony default export */ __webpack_exports__["default"] = (_components$created$d = {
  components: { breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default.a },
  created: function created() {},
  data: function data() {
    return {
      reclamos: null,
      nameSection: "Reclamaciones",
      listRoutes: [{ nameRoute: "reclamaciones", titleRoute: "Reclamos de usuarios" }],
      tableData: {
        orderBy: "created_at",
        length: 10,
        page: 1
      },

      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      is_loading: true
    };
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$created$d, "created", function created() {
  this.getPurchaseOrdersByPage();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$created$d, "methods", {
  getPurchaseOrdersByPage: function getPurchaseOrdersByPage(page) {
    var _this = this;

    this.is_loading = true;

    this.tableData.page = page;

    var url = "https://backendbutiko.com" + "/api/view/reclamaciones";

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
      _this.reclamos = response.data.body.data;
      _this.is_loading = false;
      _this.configPagination(response.data.body);
    }).catch(function () {
      alert("No se obtuvieron resultados");
      _this.is_loading = false;
      return;
    });
  },
  configPagination: function configPagination(data) {
    this.pagination.lastPage = data.last_page;
    this.pagination.currentPage = data.current_page;
    this.pagination.total = data.total;
    this.pagination.lastPageUrl = data.last;
    this.pagination.nextPageUrl = data.next;
    this.pagination.prevPageUrl = data.prev;
    this.pagination.from = data.from;
    this.pagination.to = data.to;
    this.pagination.perPage = this.tableData.length;
  }
}), _components$created$d);

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


var _components$created$d;



/* harmony default export */ __webpack_exports__["default"] = (_components$created$d = {
  components: { breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a },
  created: function created() {},
  data: function data() {
    return {
      detalleReclamo: null,
      nameSection: "Detalle del reclamo",
      listRoutes: [{ nameRoute: "Reclamaciones", titleRoute: "Reclamos de usuarios" }],
      is_loading: true,
      idReclamo: this.$route.params.id
    };
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$created$d, "created", function created() {
  this.getDetaileReclamo();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$created$d, "methods", {
  getDetaileReclamo: function getDetaileReclamo() {
    var _this = this;

    this.is_loading = true;
    var url = "https://backendbutiko.com" + "/api/view/reclamo/" + this.idReclamo;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {

      _this.detalleReclamo = response.data.body;
      _this.is_loading = false;
    }).catch(function () {

      alert("No se obtuvieron resultados");
      _this.is_loading = false;
      return;
    });
  }
}), _components$created$d);

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Repository',
  data: function data() {
    return {
      githubUrl: 'https://api.github.com/search/repositories?q=language%3Ajavascript&sort=stars',
      response: null,
      error: null
    };
  },

  methods: {
    callGitHub: function callGitHub() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.githubUrl).then(function (response) {
        console.log('GitHub Response:', response);

        if (response.status !== 200) {
          _this.error = response.statusText;
          return;
        }

        _this.response = response.data.items;
      }).catch(function (error) {
        console.log('error', error.response);
        _this.error = error.response.statusText;
      });
    }
  },
  mounted: function mounted() {
    this.callGitHub();
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demo__ = __webpack_require__(182);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Servers',
  data: function data() {
    return {
      servers: __WEBPACK_IMPORTED_MODULE_0__demo__["a" /* servers */]
    };
  }
});

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);


__webpack_require__(2);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a },
  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  methods: {
    clearInput: function clearInput(vueModel) {
      vueModel = '';
    }
  }
});

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_glide_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_glide_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);



var _components;







/* harmony default export */ __webpack_exports__["default"] = ({
  components: (_components = {
    DataTable: __WEBPACK_IMPORTED_MODULE_4__DataTable_vue___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_5__Pagination_vue___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["Glide"].name, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["Glide"]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["GlideSlide"].name, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["GlideSlide"]), _components),
  data: function data() {
    var statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado"
    };

    var statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado"
    };

    var cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking"
    };
    var sortOrders = {};
    var columns = [{ label: "Producto", name: "product", visible: false }, { label: "Consignatario", name: "consignatario", visible: false }, { label: "Acciones", name: "acciones", visible: false }];

    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      isOrder: true,
      isWr: true,

      warehouseorder: null,

      formCreate: {
        id: null,
        name: null,
        ad_valorem: null,
        isc: null,
        igv: null,
        ipm: null,
        seguro: null,
        sobretasa: null,
        unit: null
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns: columns,
      statusGroupArray: statusGroupArray,
      statusArray: statusArray,
      cancelledReasonFlagArray: cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true
        },
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null,
        order_type: 5,
        store: "all"
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      grabr: {
        id: "1"
      },
      is_loading: true,
      nameSection: "Subpartida",
      listRoutes: [{ nameRoute: "Subpartida", titleRoute: "Subpartida" }],
      subPartidaList: []
    };
  },
  created: function created() {
    this.getSubPartidas();
  },

  methods: {
    deleteSubPartida: function deleteSubPartida(id) {
      var _this = this;

      var answer = window.confirm("Seguro de eliminar la SubPartida:" + id);
      if (answer) {
        this.is_loading = true;

        var url = "https://backendbutiko.com" + "/api/subpartida/deleteSubpartida/" + id;
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(url).then(function () {
          location.reload();
        }).catch(function () {
          alert("Error al eliminar el SubPartida");
          _this.is_loading = false;
        });
      }
    },
    createSubPartida: function createSubPartida() {
      var _this2 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/subpartida/createSubpartidas";
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, this.formCreate).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al crear el SubPartida");
        _this2.is_loading = false;
      });
    },
    EditSubPartida: function EditSubPartida() {
      var _this3 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/subpartida/createSubpartidas";
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, this.formCreate).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al editar  SubPartida");
        _this3.is_loading = false;
      });
    },
    getStore: function getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado: function cambiarEstado() {
      this.valorRadioButton = false;
    },
    toGrabrDetail: function toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      var linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes: function showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getSubPartidas: function getSubPartidas(page) {
      var _this4 = this;

      this.is_loading = true;

      this.tableData.page = page;
      var url = "https://backendbutiko.com" + "/api/subpartida/getSubpartidas";

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        _this4.subPartidaList = response.data.body.data;
        _this4.is_loading = false;
        _this4.configPagination(response.data.body);
      }).catch(function () {
        alert("No se obtuvieron resultados");
        _this4.is_loading = false;
        return;
      });
    },
    getPurchaseOrdersByPage: function getPurchaseOrdersByPage() {
      var _this5 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var permissions = this.$store.state.user.attributes.permissions_keys;
      var url = "";
      if (permissions.includes(1)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-client";
      } else {
        return;
      }
      this.tableData.status = this.statusComputed;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;

        if (_this5.tableData.draw === data.meta.draw) {
          console.log("RESPONSE:");

          console.log("there are sync");
          console.log("Table data : ");
          console.log(_this5.tableData);
          console.log(data);

          console.log("=======================");

          _this5.purchaseOrders = data.data;
          _this5.configPagination(data);
          _this5.is_loading = false;
          console.log("FIN RESPONSE");
        } else {
          console.log("ERROR:");

          console.log("out of sync");

          console.log(_this5.tableData);
          _this5.is_loading = false;
          console.log("FIN ERROR");
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this5.purchaseOrders = null;
        _this5.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last;
      this.pagination.nextPageUrl = data.next;
      this.pagination.prevPageUrl = data.prev;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir);
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    hideModal: function hideModal() {
      this.$refs.formmodal.hide();
    },
    openModal: function openModal(id, data) {
      if (data) {
        this.formCreate.id = data.id;
        this.formCreate.name = data.name;
        this.formCreate.ad_valorem = data.ad_valorem;
        this.formCreate.isc = data.isc;
        this.formCreate.igv = data.igv;
        this.formCreate.ipm = data.ipm;
        this.formCreate.seguro = data.seguro;
        this.formCreate.sobretasa = data.sobretasa;
        this.formCreate.unit = data.unit;
      }

      var modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      var modal = document.getElementById(id);
      modal.close();
      this.formCreate.id = null;
      this.formCreate.name = null;
      this.formCreate.ad_valorem = null;
      this.formCreate.isc = null;
      this.formCreate.igv = null;
      this.formCreate.ipm = null;
      this.formCreate.seguro = null;
      this.formCreate.sobretasa = null;
      this.formCreate.unit = null;
    },
    prevSlide: function prevSlide() {
      this.currentSlide === 1 ? this.currentSlide = this.maxSlide : this.currentSlide = this.currentSlide - 1;
    },
    nextSlide: function nextSlide() {
      this.currentSlide === this.maxSlide ? this.currentSlide = 1 : this.currentSlide = this.currentSlide + 1;
    }
  },
  computed: {
    diasRestantes: function diasRestantes() {
      var fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach(function (data) {
        var fechaEntrega = data.attributes.promised_delivery_date;
        var fecha = new Date();
        var fechaini = new Date(fechaEntrega);
        var diff = fechaini.getTime() - fecha.getTime();
        var diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns: function filterColumns() {

      var activeFilterColumns = ["product_info", "referent link", "order_code", "client_grabr_id", "destination", "tracking_number"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    },
    statusComputed: function statusComputed() {
      console.log("statuscomputed");
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.tableData.statusFlag.todos, this.tableData.statusFlag.activos, this.tableData.statusFlag.cancelados]);
    }
  }
});

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_1__DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default.a, breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default.a },
  created: function created() {
    if (!this.$store.state.user.attributes.permissions_keys.includes(6)) {
      this.grabr.id = '2';
    }
    if (this.rebateOrders == null) {
      this.is_loading = true;
    }
    this.getrebateOrders();
  },
  data: function data() {

    var sortOrders = {};
    var columns = [{ label: 'Title', name: 'title', visible: true }, { label: 'Amount', name: 'amount', visible: true }, { label: 'Publication Code', name: 'publication_code', visible: true }, { label: 'From', name: 'from', visible: true }, { label: 'To', name: 'to', visible: true }, { label: 'Price', name: 'price', visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      rebateOrders: null,
      columns: columns,
      sortKey: 'id',
      sortOrders: sortOrders,
      filterKey: '',
      expanded: false,
      tableData: {
        draw: 0,
        length: 10,
        status: '',
        orderBy: 'id',
        dir: 'desc',
        filterBy: 'all',
        page: 1,
        filterValue: null,
        order_type: 5 },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      grabr: {
        id: '1'
      },
      is_loading: true,
      nameSection: 'Tabla de Rebate',
      listRoutes: [{ nameRoute: 'TableRebate', titleRoute: 'Tabla de Rebate' }]
    };
  },

  methods: {
    gotoPage: function gotoPage(val) {
      if (val == 1) {
        this.$router.push({ name: 'Utils' });
      }
    },
    getrebateOrders: function getrebateOrders() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var fromPagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log('Cargando todas las PurchasOrders');
      this.is_loading = true;
      this.tableData.draw++;
      var permissions = this.$store.state.user.attributes.permissions_keys;
      if (!fromPagination) {
        if (permissions.includes(1)) {
          url = url = "https://backendbutiko.com" + '/api/rebate/list';
        } else {
          alert('El usuario no tiene permisos para ver órdenes de compra');
          return;
        }
      }
      console.log('URL: ' + url);
      console.log('Viene de una paginación? : ' + fromPagination);
      console.log('Table data : ');

      console.log(this.tableData);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: { filterValue: this.tableData.filterValue }
      }).then(function (response) {
        var data = response.data;
        console.log("Ver la data ");
        console.log(data);
        console.log(data.body.data);
        console.log("final");
        _this.rebateOrders = data.body.data;
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log('error');

        _this.rebateOrders = null;

        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = '';
      if (this.tableData.filterBy == 'all') {
        this.getrebateOrders();
      }
    },
    sortBy: function sortBy(key) {
      console.log('entro al sort', key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log('tableData.orderBy', this.tableData.orderBy, 'tableData.dir', this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      console.log('tableData.orderBy', this.tableData.orderBy, 'tableData.dir', this.tableData.dir);
      this.getrebateOrders();
      console.log('paso la peticion api');
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ['title', 'publication_code'];

      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




__webpack_require__(336);
__webpack_require__(742);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable();
    });
  }
});

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_es__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);



var _props$components$dat;






/* harmony default export */ __webpack_exports__["default"] = (_props$components$dat = {
  props: ['grabr', 'oldID', 'client', 'externalClientDni', 'grabrClientId', 'externalClientCellphone', 'externalClientName'],
  components: {
    breadcrumb: __WEBPACK_IMPORTED_MODULE_5__components_prefab_structures_breadcrumb_vue___default.a
  },

  data: function data() {
    return {
      locale: 'en'
    };
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'data', function data() {
  return {
    state1: 1,
    state2: 0,
    state3: 0,
    state4: 0,
    newName: '',
    newLastname: '',
    typeId: '1',
    idClient: '',
    numberId: '',
    numberPhone: '',
    statusForm1: 0,
    newImageProduct: null,
    newImageName: '',
    newNumbOrder: '',
    newInfoProduct: '',
    newDescriptionProduct: '',
    newStockProduct: '1',
    packaged: 1,
    travelNumber: '',
    grabrAccount: '',

    newLinkChat: '',
    newDateOffer: '',
    statusForm2: 0,
    newCost: '',
    newTax: '',
    newCostPost: '',
    newLinkBuying: '',
    newCityIni: '',
    newCityEnd: '',
    newDatePromise: '',
    statusForm3: 0,
    listCityOrigin: [],
    listCityDestiny: [],
    listCityDestinyFilter: [],
    listUnits: [],
    userFinding: '',
    userValidated: null,
    mesageVerifUser: '',
    newImageProductV2: null,
    newInfoProductV2: '',
    newDescriptionProductV2: '',
    newStockProductV2: '1',
    newWeight: '',
    unitWeight: '',
    newCostV2: '',
    newTaxV2: '',
    newCostPostV2: '',
    newLinkBuyingV2: '',

    orderData: {},
    saveOk: false,

    nameSection: 'Crear orden de compra',
    listRoutes: [{ nameRoute: 'Orders', titleRoute: 'Órdenes de compra' }, { nameRoute: 'add-purchase-order', titleRoute: this.grabr.id == 1 ? 'Crear orden de compra Grabr' : 'Crear orden de compra Direct' }]
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'created', function created() {
  window.addEventListener('beforeunload', this.setWindowListener);

  this.$validator.localize('es', {
    messages: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_es___default.a.messages,
    attributes: {
      fullname: 'nombre completo',
      document_number: 'número de documento',
      phone_number: 'número de celular',
      price: 'precio',
      tax: 'impuesto',
      travel_number: 'Número de viaje',
      grabr_account: 'Nombre de usuario de grabr',
      product_image: 'imagen del artículo',
      purchase_order_number: 'número de orden de compra',
      product_information: 'información del producto',
      number_of_items: 'número de ejemplares',

      purchase_chat_link: 'número de chat en Grabr',
      purchase_order_date: 'fecha de asignación al viajero',
      origin_city: 'ciudad de origen',
      destination_city: 'ciudad de destino',
      possible_delivery_date: 'fecha posible de entrega',
      document_number_nograbr: 'número de documento',
      product_information_2: 'información del producto',
      number_of_items_2: 'número de ejemplares',
      order_weight_2: 'peso de la orden',
      weight_units_2: 'unidades de peso',
      shipping_cost: 'costo de envío',
      purchase_link: 'link de compra'
    }
  });

  this.$validator.localize('es');
  if (!this.grabr) {
    this.$router.push('/orders');
    return;
  }
  if (this.oldID != null) {
    console.log('Viene para un reemplazo');

    this.state1 = 0;
    this.state2 = 1;
    if (this.grabr.id == 1) {
      console.log('es de Grabr');
      this.newName = this.externalClientName;
      this.numberPhone = this.externalClientCellphone;
      if (this.externalClientDni != null) {
        this.typeId = 1;
        this.numberId = this.externalClientDni;
      } else {
        this.typeId = 2;
        this.clientId = this.grabrClientId;
      }
    } else {
      console.log('no es de Grabr');
      this.setUserChoosed(this.client);
    }
  } else {
    console.log('No viene para un reemplazo');
  }
  this.listAllCity(1, this.getCityOrigin);
  this.listAllCity(2, this.getCityDestiny);
  this.listUnitWeight(this.getListUnits);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'methods', {
  cleanDocumentNumbers: function cleanDocumentNumbers() {
    if (this.typeId == 1) {
      this.idClient = '';
    } else if (this.typeId == 2) {
      this.numberId = '';
    } else {
      this.numberId = '';
      this.idClient = '';
    }
  },
  setWindowListener: function setWindowListener(event) {
    console.log('Estamos en setWindoesListener');
    event.returnValue = 'Write something';
  },
  setNewTax: function setNewTax() {
    var price = this.grabr.id == 1 ? this.newCost : this.newCostV2;
    var tax = this.grabr.id == 1 ? this.newTax : this.newTaxV2;

    if (isNaN(price) || price === '' || price === null) {
      tax = 0;
    } else {
      tax = Number(Math.round(parseFloat(0.07 * parseFloat(price)) + 'e2') + 'e-2').toFixed(2).toString();
    }
    if (this.grabr.id == 1) {
      this.newCost = price;
      this.newTax = tax;
    } else {
      this.newCostV2 = price;
      this.newTaxV2 = tax;
    }
  },
  changeFormView: function changeFormView(event) {
    if (event === 1) {
      this.state1 = 1;
      this.state2 = 0;
      this.state3 = 0;
      this.state4 = 0;
    } else if (event === 2) {
      this.state1 = 2;
      this.state2 = 1;
      this.state3 = 0;
      this.state4 = 0;
    } else if (event === 3) {
      this.state1 = 2;
      this.state2 = 2;
      this.state3 = 1;
      this.state4 = 0;
    } else if (event === 4) {
      this.state1 = 2;
      this.state2 = 2;
      this.state3 = 2;
      this.state4 = 1;
    }
  },
  handleValidationErrorAdvanced: function handleValidationErrorAdvanced() {
    var firstField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errors.collect())[0];
    if (firstField) {
      var elements = document.getElementsByName(firstField);
      console.log('Failed validation of field: '.concat(firstField));
      elements[0].scrollIntoView();
    } else console.log('Could not find elements with errors.');
  },
  validateFirstFormAdvanced: function validateFirstFormAdvanced() {
    var _this = this;

    this.$validator.validate().then(function (result) {
      if (!result) {
        return _this.handleValidationErrorAdvanced();
      } else {
        _this.statusForm1 = 1;
        if (_this.statusForm1) {
          _this.changeFormView(2);
        }
      }
    });
  },
  validateSecondFormAdvanced: function validateSecondFormAdvanced() {
    var _this2 = this;

    this.$validator.validate().then(function (result) {
      if (!result) {
        return _this2.handleValidationErrorAdvanced();
      } else {
        _this2.statusForm2 = 1;
        if (_this2.statusForm2) {
          _this2.changeFormView(3);
        }
      }
    });
  },
  validateThirdFormAdvanced: function validateThirdFormAdvanced() {
    var _this3 = this;

    this.$validator.validate().then(function (result) {
      if (!result) {
        return _this3.handleValidationErrorAdvanced();
      } else {
        console.log('Passed validations of validateThirdFormAdvanced');
        _this3.statusForm3 = 1;
        if (_this3.statusForm3) {
          _this3.changeFormView(4);
        }
      }
    });
  },
  validateFistFormV2: function validateFistFormV2() {
    var _this4 = this;

    this.$validator.validate().then(function (result) {
      if (!result) {
        return _this4.handleValidationErrorAdvanced();
      } else {
        if (!_this4.userValidated) {
          return _this4.handleValidationErrorAdvanced();
        }
        _this4.statusForm1 = 1;
        if (_this4.statusForm1) {
          _this4.changeFormView(2);
        }
      }
    });
  },
  sendCompleteForm: function sendCompleteForm() {
    if (this.statusForm3 && this.statusForm2 && this.statusForm1) {
      var auxObject = void 0;
      if (this.grabr.id == 1) {
        auxObject = new Object();
        auxObject.external_client_name = this.newName;
        auxObject.external_client_lastname = this.newLastname;
        if (this.typeId == 1) {
          auxObject.external_client_dni = this.numberId;
        }
        if (this.typeId == 2) {
          auxObject.client_grabr_id = this.idClient;
        }
        console.log(this.$store.state.user);

        auxObject.external_client_cellphone = this.numberPhone;
        auxObject.grabr_order_number = this.newNumbOrder;
        auxObject.product_info = this.newInfoProduct;
        auxObject.description = this.newDescriptionProduct;
        auxObject.product_specimens = this.newStockProduct;
        console.log("que pasa");

        auxObject.admin_id = this.$store.state.user.type == 'Admin' ? this.$store.state.user.id : null;
        console.log("prueba");

        auxObject.grabr_chat_link = this.newLinkChat;
        auxObject.grabr_offer_date = this.newDateOffer;
        auxObject.grabr_price = this.newCost;
        auxObject.grabr_tax = this.newTax;
        auxObject.grabr_fee = this.newCostPost;
        auxObject.grabr_purchase_link = this.newLinkBuying;
        auxObject.origin_id = this.newCityIni.id;
        auxObject.destination_id = this.newCityEnd.id;
        auxObject.promised_delivery_date = this.newDatePromise;
        auxObject.product_image = this.newImageProduct;
        auxObject.travel_number = this.travelNumber;
        auxObject.grabr_account = this.grabrAccount;

        auxObject.packaged = this.packaged == 2 ? 1 : this.packaged == 3 ? 0 : null;

        if (this.oldID) {
          auxObject.purchase_order_old_id = this.oldID;
        }
        console.log(auxObject);

        this.createBuyingOrderGrabr(auxObject);
      } else if (this.grabr.id == 2) {
        auxObject = new Object();
        auxObject.product_info = this.newInfoProductV2;
        auxObject.description = this.newDescriptionProductV2;
        auxObject.product_specimens = this.newStockProductV2;
        auxObject.weight = this.newWeight;
        auxObject.weight_unit_id = this.unitWeight.id;
        auxObject.client_id = this.userValidated.id;
        auxObject.origin_id = this.newCityIni.id;
        auxObject.admin_id = this.$store.state.user.type == 'Admin' ? this.$store.state.user.id : null;
        auxObject.destination_id = this.newCityEnd.id;
        auxObject.real_purchase_link = this.newLinkBuyingV2;
        auxObject.real_price = this.newCostV2;
        auxObject.real_tax = this.newTaxV2;
        auxObject.real_shipping = this.newCostPostV2;
        auxObject.product_image = this.newImageProductV2;

        auxObject.packaged = this.packaged == 2 ? 1 : this.packaged == 3 ? 0 : null;

        if (this.oldID) {
          auxObject.purchase_order_old_id = this.oldID;
        }
        this.createBuyingOrderNoGrabr(auxObject);
      }
    }
  },
  listAllCity: function listAllCity(indx, callback) {
    var url = "https://backendbutiko.com" + '/api/city/list?type=' + indx;
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      var data = response.data.body.cities_list;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  },
  listUnitWeight: function listUnitWeight(callback) {
    var url = "https://backendbutiko.com" + '/api/weightUnit/list';
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  },
  createBuyingOrderGrabr: function createBuyingOrderGrabr(data) {
    var _this5 = this;

    var url = "https://backendbutiko.com" + '/api/purchaseOrder/create-purchase-order-grabr';
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, data).then(function (response) {
      if (response.data.status) {
        _this5.orderData = response.data.body;

        _this5.saveOk = true;
        _this5.$refs.validacionmodal.show();
      }
    }).catch(function (error) {
      console.log(error.response.data);
    });
  },
  createBuyingOrderNoGrabr: function createBuyingOrderNoGrabr(data) {
    var _this6 = this;

    var url = "https://backendbutiko.com" + '/api/purchaseOrder/create-purchase-order-no-grabr';
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, data).then(function (response) {
      if (response.data.status) {
        _this6.orderData = response.data.body;
        _this6.saveOk = true;
        _this6.$refs.validacionmodal.show();
      }
    }).catch(function (error) {
      console.log('Error');
      console.log(error.response.data);
      return;
    });
  },
  toNextView: function toNextView() {
    var data = this.orderData;
    this.$router.push({
      name: 'show-purchase-order',
      params: {
        id: data.id,
        orderData: data
      }
    });
  },
  getCityDestiny: function getCityDestiny(data) {
    this.listCityDestiny = data;
  },
  getCityOrigin: function getCityOrigin(data) {
    this.listCityOrigin = data;
  },
  getListUnits: function getListUnits(data) {
    var _this7 = this;

    this.listUnits = data;
    this.listUnits.forEach(function (unit) {
      if (unit.attributes.key_name == 'lb') {
        _this7.originWeightUnit = unit;
      }
    });
  },
  uploadImage: function uploadImage(e) {
    var _this8 = this;

    var image = e.target.files[0];
    var idxDot = image.name.lastIndexOf('.') + 1;
    var extFile = image.name.substr(idxDot, image.name.length).toLowerCase();
    if (extFile == 'jpg' || extFile == 'jpeg' || extFile == 'png') {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      if (this.grabr.id == 1) {
        this.newImageName = image.name;
        reader.onload = function (e) {
          _this8.newImageProduct = e.target.result;
        };
      }
      if (this.grabr.id == 2) {
        this.newImageName = image.name;
        reader.onload = function (e) {
          _this8.newImageProductV2 = e.target.result;
        };
      }
    } else {
      alert('Solo se permite formato PNG, JPG o JPEG');
    }
  },
  hideModal: function hideModal() {
    this.$refs.validacionmodal.hide();
  },
  setUserChoosed: function setUserChoosed(data) {
    this.userValidated = data;
    this.mesageVerifUser = 'Cliente encontrado: ' + this.userValidated.attributes.profile.attributes.name + ' ' + this.userValidated.attributes.profile.attributes.surnames;
  },
  validateUserById: function validateUserById(id, callback) {
    var _this9 = this;

    console.log('Entre a la funcion valdateUserById');
    var url = "https://backendbutiko.com" + '/api/client/getByDocumentNumber/' + id;
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;
      console.log(data);
      callback(data);
    }).catch(function (error) {
      if (error.response) {
        if (error.response.status === 404) {
          _this9.userValidated = null;
          _this9.mesageVerifUser = 'Cliente no existe en el sistema';
          self.response = 'Error 404';
        }
        console.log(error);
      }
    });
  },
  resetImpuesto: function resetImpuesto() {
    console.log('limpiará camps');
    this.newTaxV2 = '';
  },
  filtrar: function filtrar() {
    var _this10 = this;

    this.listCityDestinyFilter = this.listCityDestiny.filter(function (city) {
      return city.attributes.name !== _this10.newCityIni.attributes.name;
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'computed', {
  shortNewLinkBuying: function shortNewLinkBuying() {
    if (this.newLinkBuying != '' && this.newLinkBuying != null) {
      var str = this.newLinkBuying;

      var pos = str.indexOf('.com');
      var result = void 0;
      if (pos == -1) {
        result = str.substring(0, pos + 4);
      } else {
        result = str.substring(0, pos + 4);
      }

      console.log(pos);
    }
    return '';
  },
  shortNewLinkBuyingV2: function shortNewLinkBuyingV2() {
    if (this.newLinkBuyingV2 != '' && this.newLinkBuyingV2 != null) {}
    return '';
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'watch', {
  userFinding: function userFinding(newValue) {
    if (newValue == '') {
      this.mesageVerifUser = '';
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'beforeDestroy', function beforeDestroy() {
  window.removeEventListener('beforeunload', this.setWindowListener);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'beforeRouteLeave', function beforeRouteLeave(to, from, next) {
  var askFlag = true;
  console.log("************************");
  console.log(this.saveOk);

  console.log(document.readyState);

  if (document.readyState == 'loading') {
    askFlag = false;
  } else if (document.readyState == 'complete') {
    askFlag = !this.saveOk;
  }
  console.log(askFlag);

  if (askFlag) {
    var answer = window.confirm('No se han guardado los cambios, ¿está seguro de salir?');
    if (answer) {
      next();
      return;
    } else {
      next(false);
      return;
    }
  }
  next();
}), _props$components$dat);

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_component_user_PerfilComponent_vue__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_component_user_PerfilComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_component_user_PerfilComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_component_user_SaldoComponent_vue__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_component_user_SaldoComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_component_user_SaldoComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_component_user_ViajeComponent_vue__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_component_user_ViajeComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_component_user_ViajeComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_component_user_PedidoComponent_vue__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_component_user_PedidoComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_component_user_PedidoComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_component_user_DirectionComponent_vue__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_component_user_DirectionComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_component_user_DirectionComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_component_user_CredentialComponent_vue__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_component_user_CredentialComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_component_user_CredentialComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_component_user_CotizacionComponent_vue__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_component_user_CotizacionComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_component_user_CotizacionComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_component_user_CodigoComponent_vue__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_component_user_CodigoComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_component_user_CodigoComponent_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PerfilComponent: __WEBPACK_IMPORTED_MODULE_1__components_component_user_PerfilComponent_vue___default.a,
    SaldoComponent: __WEBPACK_IMPORTED_MODULE_2__components_component_user_SaldoComponent_vue___default.a,
    ViajeComponent: __WEBPACK_IMPORTED_MODULE_3__components_component_user_ViajeComponent_vue___default.a,
    PedidoComponent: __WEBPACK_IMPORTED_MODULE_4__components_component_user_PedidoComponent_vue___default.a,
    DirectionComponent: __WEBPACK_IMPORTED_MODULE_5__components_component_user_DirectionComponent_vue___default.a,
    CredentialComponent: __WEBPACK_IMPORTED_MODULE_6__components_component_user_CredentialComponent_vue___default.a,
    CotizacionComponent: __WEBPACK_IMPORTED_MODULE_7__components_component_user_CotizacionComponent_vue___default.a,
    CodigoComponent: __WEBPACK_IMPORTED_MODULE_8__components_component_user_CodigoComponent_vue___default.a
  },
  data: function data() {
    return {
      influencerFlag: null,
      saldo: {
        monto: null,
        title: null,
        description: null
      },
      section: 1,
      perfil: {
        avatar: null,
        nombre: null,
        apellido: null,
        telefono: null,
        store: null
      },
      credential: {
        codigo: null,
        documento: null,
        email: null,
        estado: null,
        dniPosterior: null,
        dniAnterior: null,
        varificado: null,
        statuAnterior: null,
        statuPosterior: null
      },
      direction: {
        direction: null,
        piso: null,
        referencia: null,
        departamento: null,
        provincia: null,
        distrito: null
      },
      travel_squad: null
    };
  },
  mounted: function mounted() {
    this.getUser();
  },

  methods: {
    changeFlagInfluencer: function changeFlagInfluencer(data) {
      var url = "https://backendbutiko.com" + "/api/admin/changeInfluencer/" + this.$route.params.idUser;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
        influencerFlag: data
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        alert("Error al agregar cambiar el estado del influencer");
      });
    },
    addSaldoUser: function addSaldoUser() {
      var url = "https://backendbutiko.com" + "/api/balance/add/" + this.$route.params.idUser;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
        amount: this.saldo.monto,
        titleOper: this.saldo.title,
        descOper: this.saldo.description
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al agregar saldo");
      });
    },
    getUser: function getUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://backendbutiko.com" + "/api/client/getById/" + this.$route.params.idUser).then(function (response) {
        var data = response.data.body.data.attributes;
        _this.travel_squad = data.travel_squad;
        _this.influencerFlag = data.influencer_flag;
        _this.perfil.avatar = data.profile.attributes.userable.attributes.profile_image_url;
        _this.perfil.nombre = data.profile.attributes.name;
        _this.perfil.apellido = data.profile.attributes.surnames;
        _this.perfil.telefono = data.profile.attributes.cellphone;
        _this.perfil.store = data.profile.attributes.userable.attributes.store_id;
        _this.credential.codigo = data.profile.attributes.userable.client_code;
        _this.credential.documento = data.profile.attributes.document_number;
        _this.credential.email = data.profile.attributes.userable.attributes.email;

        _this.credential.varificado = data.profile.attributes.userable.attributes.validation;

        _this.credential.dniPosterior = data.profile.attributes.userable.attributes.document_seal_url;
        _this.credential.dniAnterior = data.profile.attributes.userable.attributes.document_face_url;

        _this.credential.statuPosterior = data.profile.attributes.userable.attributes.document_seal_state;
        _this.credential.statuAnterior = data.profile.attributes.userable.attributes.document_face_state;

        if (data.profile.attributes.userable.attributes.facebook_id) {
          _this.credential.estado = "facebook";
        } else if (data.profile.attributes.userable.attributes.gmail_id) {
          _this.credential.estado = "google";
        } else {
          _this.credential.estado = "formulario";
        }

        if (data.addresses.length !== 0) {
          var dataUser = response.data.body.data;

          _this.direction.direction = dataUser.attributes.addresses[0].attributes.address === null ? "" : dataUser.attributes.addresses[0].attributes.address;

          _this.direction.piso = dataUser.attributes.addresses[0].attributes.inner === null ? "" : dataUser.attributes.addresses[0].attributes.inner;

          _this.direction.referencia = dataUser.attributes.addresses[0].attributes.reference === null ? "" : dataUser.attributes.addresses[0].attributes.reference;

          _this.direction.departamento = dataUser.attributes.addresses[0].attributes.department === null ? "" : dataUser.attributes.addresses[0].attributes.department;

          _this.direction.provincia = dataUser.attributes.addresses[0].attributes.city === null ? "" : dataUser.attributes.addresses[0].attributes.city;

          _this.direction.distrito = dataUser.attributes.addresses[0].attributes.district === null ? "" : dataUser.attributes.addresses[0].attributes.district;
        }
      }).catch(function (error) {
        console.log(error);
        alert("Error al obtener los dato del usuario");
      });
    },
    openModal: function openModal(id) {
      var modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      var modal = document.getElementById(id);
      modal.close();
    }
  }
});

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default.a },
  data: function data() {
    return {
      publicationCode: "",
      producPrice: "",
      producTitle: "",
      dateTo: "",
      datefrom: "",
      montoRebate: 0,
      selectionUser: 'utils',
      nameSection: 'Utils',
      listRoutes: [{ nameRoute: 'Utils', titleRoute: 'Utils' }]
    };
  },
  created: function created() {},

  methods: {
    verifiPubliCode: function verifiPubliCode() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://backendbutiko.com" + "/api/meli/getItemDetails/electro/" + this.publicationCode).then(function (response) {
        _this.producPrice = response.data.body.price;
        _this.producTitle = response.data.body.title;
      });
      var pricePro = document.getElementById('priceProduc');
      var titlePro = document.getElementById('titleProduc');
      pricePro.style.display = 'block';
      titlePro.style.display = 'block';
    },
    rebatePubli: function rebatePubli() {
      if ($("#date").val() < $("#date2").val()) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://backendbutiko.com" + "/api/rebate/create", {
          amount: parseInt(this.montoRebate, 10),
          publication_code: this.publicationCode,
          from: this.datefrom,
          to: this.dateTo,
          active: 1,
          product_title: this.producTitle,
          product_price: this.producPrice

        }).then(function (response) {
          console.log(response);
          if (response.data.status) {
            window.history.go(-1);
          }
        });
      } else {
        alert("La fecha de inicio no puede ser menor que la de fin");
      }
    }
  }
});

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_glide_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_glide_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);



var _components;






/* harmony default export */ __webpack_exports__["default"] = ({
  components: (_components = {
    DataTable: __WEBPACK_IMPORTED_MODULE_4__DataTable_vue___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_5__Pagination_vue___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["Glide"].name, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["Glide"]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["GlideSlide"].name, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["GlideSlide"]), _components),
  data: function data() {
    var statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado"
    };

    var statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado"
    };

    var cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking"
    };
    var sortOrders = {};
    var columns = [{ label: "Producto", name: "product", visible: false }, { label: "Consignatario", name: "consignatario", visible: false }, { label: "Acciones", name: "acciones", visible: false }];

    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      wrFotos: [],

      warehouseorder: null,

      formCreate: {
        purchase_order_id: null,
        consignee: null,
        remitter: null,
        carrier: null,
        tracking: null,
        comment: null,
        unidad: 12,
        weight: null,
        images: []
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns: columns,
      statusGroupArray: statusGroupArray,
      statusArray: statusArray,
      cancelledReasonFlagArray: cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true
        },
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null,
        order_type: 5,
        store: "all"
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      grabr: {
        id: "1"
      },
      is_loading: true,
      nameSection: "Warehouse",
      listRoutes: [{ nameRoute: "Warehouse", titleRoute: "Warehouse" }],
      wrSinAsignar: null
    };
  },
  created: function created() {
    this.getPurchaseOrders();
    this.listWrSinOrden();
  },

  methods: {
    deleteWR: function deleteWR(wr) {
      var answer = window.confirm("Confirmar para eliminar WR con el código:" + wr.attributes.code);

      if (answer) {
        var url = "https://backendbutiko.com" + "/api/warehouse/delete/" + wr.id;
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(url).then(function () {
          window.location.reload();
        }).catch(function () {
          alert("Error al eliminar el WR ");
        });
      }
    },
    liberarWR: function liberarWR(code) {
      var url = "https://backendbutiko.com" + "/api/warehouse/unnasignByCode/" + code;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function () {
        window.location.reload();
      }).catch(function () {
        alert("Error al liberar el WR ");
      });
    },
    copyCodeWr: function copyCodeWr(idCode) {
      navigator.clipboard.writeText(idCode).then(function () {
        alert("Código de WR copiado");
      }).catch(function (error) {
        return console.log(error);
      });
    },
    listWrSinOrden: function listWrSinOrden() {
      var _this = this;

      var url = "https://backendbutiko.com" + "/api/warehouse/list-packages";
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function (response) {
        _this.wrSinAsignar = response.data.data;
      }).catch(function () {
        alert("Error al cambiar el WR sin Asignar");
      });
    },
    limitchangePaquete: function limitchangePaquete(idOrder) {
      var _this2 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/warehouse/changeWarehouseStatus/" + idOrder;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al cambiar el estado");
        _this2.is_loading = false;
      });
    },
    handleFileInput: function handleFileInput(event) {
      var files = event.target.files;
      var images = [];

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        if (!file.type.match("image.*")) {
          continue;
        }
        var reader = new FileReader();

        reader.onload = function (file) {
          return function (event) {
            images.push(event.target.result);
          };
        }(file);
        reader.readAsDataURL(file);
        this.formCreate.images = images;
      }
    },
    createPaquete: function createPaquete() {
      var _this3 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/warehouse/save-package";
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, {
        operator_id: 398,
        purchase_order_id: this.formCreate.purchase_order_id,
        consignee: this.formCreate.consignee,
        remitter: this.formCreate.remitter,
        carrier: this.formCreate.carrier,
        tracking: this.formCreate.tracking,
        comment: this.formCreate.comment,
        weight_unit_id: this.formCreate.unidad,
        weight: this.formCreate.weight,
        images: this.formCreate.images
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al crear el paquete");
        _this3.is_loading = false;
      });
    },
    getStore: function getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado: function cambiarEstado() {
      this.valorRadioButton = false;
    },
    toGrabrDetail: function toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      var linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes: function showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getPurchaseOrders: function getPurchaseOrders(page) {
      var _this4 = this;

      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var fromPagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      console.log("Cargando todas las PurchasOrders");
      this.is_loading = true;
      this.tableData.page = page;
      this.tableData.draw++;
      url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
      this.tableData.status = this.statusComputed;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: fromPagination ? {} : this.tableData }).then(function (response) {
        var data = response.data;
        console.log(data);
        if (_this4.tableData.draw === data.meta.draw || fromPagination) {
          console.log("there are sync or if from pagination");
          _this4.warehouseorder = data.data;
          _this4.configPagination(data);
          _this4.is_loading = false;
        } else {
          console.log("out of sync");
          _this4.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this4.warehouseorder = null;
        _this4.is_loading = false;
        return;
      });
    },
    getPurchaseOrdersByPage: function getPurchaseOrdersByPage() {
      var _this5 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var permissions = this.$store.state.user.attributes.permissions_keys;
      var url = "";
      if (permissions.includes(1)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-client";
      } else {
        return;
      }
      this.tableData.status = this.statusComputed;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;

        if (_this5.tableData.draw === data.meta.draw) {
          console.log("RESPONSE:");

          console.log("there are sync");
          console.log("Table data : ");
          console.log(_this5.tableData);
          console.log(data);

          console.log("=======================");

          _this5.purchaseOrders = data.data;
          _this5.configPagination(data);
          _this5.is_loading = false;
          console.log("FIN RESPONSE");
        } else {
          console.log("ERROR:");

          console.log("out of sync");

          console.log(_this5.tableData);
          _this5.is_loading = false;
          console.log("FIN ERROR");
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this5.purchaseOrders = null;
        _this5.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir);
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    hideModal: function hideModal() {
      this.$refs.formmodal.hide();
    },
    openModal: function openModal(id, idorder, fotos) {
      if (id === "modal-fotos") {
        this.wrFotos = fotos;
      } else {
        this.wrFotos = [];
      }
      var modal = document.getElementById(id);
      this.formCreate.purchase_order_id = idorder ? idorder : null;
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      if (id === "modal-fotos") {
        this.wrFotos = [];
      }
      var modal = document.getElementById(id);
      modal.close();
    }
  },
  computed: {
    diasRestantes: function diasRestantes() {
      var fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach(function (data) {
        var fechaEntrega = data.attributes.promised_delivery_date;
        var fecha = new Date();
        var fechaini = new Date(fechaEntrega);
        var diff = fechaini.getTime() - fecha.getTime();
        var diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns: function filterColumns() {

      var activeFilterColumns = ["product_info", "referent link", "order_code", "client_grabr_id", "destination", "tracking_number"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    },
    statusComputed: function statusComputed() {
      console.log("statuscomputed");
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.tableData.statusFlag.todos, this.tableData.statusFlag.activos, this.tableData.statusFlag.cancelados]);
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_glide_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_glide_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);



var _components;







/* harmony default export */ __webpack_exports__["default"] = ({
  components: (_components = { DataTable: __WEBPACK_IMPORTED_MODULE_4__DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_5__Pagination_vue___default.a, breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["Glide"].name, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["Glide"]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["GlideSlide"].name, __WEBPACK_IMPORTED_MODULE_2_vue_glide_js__["GlideSlide"]), _components),
  data: function data() {
    var statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado"
    };

    var statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado"
    };

    var cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking"
    };
    var sortOrders = {};
    var columns = [{ label: "Producto", name: "product", visible: false }, { label: "Consignatario", name: "consignatario", visible: false }, { label: "Acciones", name: "acciones", visible: false }];

    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      isOrder: true,
      isWr: true,

      warehouseorder: null,

      formCreate: {
        purchase_order_id: null,
        consignee: null,
        carrier: null,
        tracking: null,
        comment: null,
        unidad: 12,
        weight: null,
        images: []
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns: columns,
      statusGroupArray: statusGroupArray,
      statusArray: statusArray,
      cancelledReasonFlagArray: cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true
        },
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null,
        order_type: 5,
        store: "all"
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: ""
      },
      grabr: {
        id: "1"
      },
      is_loading: true,
      nameSection: "Warehouse",
      listRoutes: [{ nameRoute: "Warehouse", titleRoute: "Warehouse" }]
    };
  },
  created: function created() {
    this.getPurchaseOrders();
  },

  methods: {
    limitchangePaquete: function limitchangePaquete(idOrder) {
      var _this = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/warehouse/changeWarehouseStatus/" + idOrder;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al cambiar el estado");
        _this.is_loading = false;
      });
    },
    handleFileInput: function handleFileInput(event) {
      var files = event.target.files;
      var images = [];

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        if (!file.type.match("image.*")) {
          continue;
        }
        var reader = new FileReader();

        reader.onload = function (file) {
          return function (event) {
            images.push(event.target.result);
          };
        }(file);
        reader.readAsDataURL(file);
        this.formCreate.images = images;
      }
    },
    createPaquete: function createPaquete() {
      var _this2 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/warehouse/save-package";
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, {
        purchase_order_id: this.formCreate.purchase_order_id,
        consignee: this.formCreate.consignee,
        carrier: this.formCreate.carrier,
        tracking: this.formCreate.tracking,
        comment: this.formCreate.comment,
        weight_unit_id: this.formCreate.unidad,
        weight: this.formCreate.weight,
        images: this.formCreate.images
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al crear el paquete");
        _this2.is_loading = false;
      });
    },
    getStore: function getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado: function cambiarEstado() {
      this.valorRadioButton = false;
    },
    toGrabrDetail: function toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      var linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes: function showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getPurchaseOrders: function getPurchaseOrders(page) {
      var _this3 = this;

      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var fromPagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      console.log("Cargando todas las PurchasOrders");
      this.is_loading = true;
      this.tableData.page = page;
      this.tableData.draw++;
      url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
      this.tableData.status = this.statusComputed;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: fromPagination ? {} : this.tableData }).then(function (response) {
        var data = response.data;
        console.log(data);
        if (_this3.tableData.draw === data.meta.draw || fromPagination) {
          console.log("there are sync or if from pagination");
          _this3.warehouseorder = data.data;
          _this3.configPagination(data);
          _this3.is_loading = false;
        } else {
          console.log("out of sync");
          _this3.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this3.warehouseorder = null;
        _this3.is_loading = false;
        return;
      });
    },
    getPurchaseOrdersByPage: function getPurchaseOrdersByPage() {
      var _this4 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var permissions = this.$store.state.user.attributes.permissions_keys;
      var url = "";
      if (permissions.includes(1)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + this.$store.state.user.id + "/list-orders-by-client";
      } else {
        return;
      }
      this.tableData.status = this.statusComputed;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;

        if (_this4.tableData.draw === data.meta.draw) {
          console.log("RESPONSE:");

          console.log("there are sync");
          console.log("Table data : ");
          console.log(_this4.tableData);
          console.log(data);

          console.log("=======================");

          _this4.purchaseOrders = data.data;
          _this4.configPagination(data);
          _this4.is_loading = false;
          console.log("FIN RESPONSE");
        } else {
          console.log("ERROR:");

          console.log("out of sync");

          console.log(_this4.tableData);
          _this4.is_loading = false;
          console.log("FIN ERROR");
        }
      }).catch(function (errors) {
        console.log(errors);
        console.log(errors.response);
        console.log("error");

        _this4.purchaseOrders = null;
        _this4.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log("tableData.orderBy", this.tableData.orderBy, "tableData.dir", this.tableData.dir);
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    hideModal: function hideModal() {
      this.$refs.formmodal.hide();
    },
    openModal: function openModal(id, idorder) {
      var modal = document.getElementById(id);
      this.formCreate.purchase_order_id = idorder ? idorder : null;
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      var modal = document.getElementById(id);
      modal.close();
    },
    prevSlide: function prevSlide() {
      this.currentSlide === 1 ? this.currentSlide = this.maxSlide : this.currentSlide = this.currentSlide - 1;
    },
    nextSlide: function nextSlide() {
      this.currentSlide === this.maxSlide ? this.currentSlide = 1 : this.currentSlide = this.currentSlide + 1;
    }
  },
  computed: {
    diasRestantes: function diasRestantes() {
      var fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach(function (data) {
        var fechaEntrega = data.attributes.promised_delivery_date;
        var fecha = new Date();
        var fechaini = new Date(fechaEntrega);
        var diff = fechaini.getTime() - fecha.getTime();
        var diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns: function filterColumns() {

      var activeFilterColumns = ["product_info", "referent link", "order_code", "client_grabr_id", "destination", "tracking_number"];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    },
    statusComputed: function statusComputed() {
      console.log("statuscomputed");
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.tableData.statusFlag.todos, this.tableData.statusFlag.activos, this.tableData.statusFlag.cancelados]);
    }
  }
});

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_packages_service__ = __webpack_require__(84);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {

    breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default.a
  },
  props: ['id'],
  data: function data() {
    return {

      dataPackage: '',
      isLoading: false,
      packageRepositions: [],
      deficitPackageRepositions: [],

      nameSection: 'Visualizar Paquete',
      listRoutes: [{ nameRoute: 'Orders', titleRoute: 'Órdenes de compra' }, { nameRoute: 'show-purchase-order', titleRoute: 'Visualizar orden de compra', idRoute: '' }],
      activeRoute: ''
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__services_packages_service__["a" /* packagesService */].getPackageDetail(this.id, this.setDataPackage);
  },

  methods: {
    setDataPackage: function setDataPackage(packageFromServer) {
      this.dataPackage = packageFromServer;
      this.listRoutes[1].idRoute = this.dataPackage.attributes.purchaseOrder.id;
      this.activeRoute = 'Paquete Nro.#' + this.dataPackage.attributes.package_name;
    },
    setPackageRepositionsDetail: function setPackageRepositionsDetail(packageRepositionsFromServer) {
      this.showModalDetailReposition();
      this.packageRepositions = packageRepositionsFromServer;
      console.log("puso los package repositions");
    },
    setDeficitIncidentPackageRepositionsDetail: function setDeficitIncidentPackageRepositionsDetail(deficitPackageRepositionsFromServer) {
      this.deficitPackageRepositions = deficitPackageRepositionsFromServer;
      console.log("puso los package repositions deficit");
    },
    showRepositionItemsDetail: function showRepositionItemsDetail() {
      console.log("Estamos en show");

      __WEBPACK_IMPORTED_MODULE_1__services_packages_service__["a" /* packagesService */].getPackageRepositionsDetail(this.id, this.setPackageRepositionsDetail);
    },
    showDeficitIncidentItemsDetail: function showDeficitIncidentItemsDetail(deficitIncidentId) {
      console.log("Estamos en show 2");
      console.log(deficitIncidentId);

      __WEBPACK_IMPORTED_MODULE_1__services_packages_service__["a" /* packagesService */].getPackageRepositionsByDeficitIncidentId(deficitIncidentId, this.setDeficitIncidentPackageRepositionsDetail);
      this.showModalDetailItemsFail();
    },
    hideModalDetailItemsFail: function hideModalDetailItemsFail() {
      this.$refs.modalDetailItemsFail.hide();
    },
    showModalDetailItemsFail: function showModalDetailItemsFail() {
      this.$refs.modalDetailItemsFail.show();
    },
    hideModalDetailReposition: function hideModalDetailReposition() {
      this.$refs.modalDetailReposition.hide();
    },
    showModalDetailReposition: function showModalDetailReposition() {
      this.$refs.modalDetailReposition.show();
    },
    backPage: function backPage() {
      this.$router.go(-1);
    }
  },

  computed: {
    deficitItems: function deficitItems() {

      var incidents = this.dataPackage.attributes.incidents;
      var deficitItems = 0;
      incidents.forEach(function (incident) {
        if (incident.attributes.clusterable_type == 'different_quantity' && incident.attributes.clusterable.attributes.delta_type == 1) {
          deficitItems += parseInt(incident.attributes.clusterable.attributes.total_items) - parseInt(incident.attributes.clusterable.attributes.correct_items);
        }
      });

      return deficitItems;
    }
  }

});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_es__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_prefab_elements_resume_purchase_order__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_prefab_elements_resume_purchase_order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_prefab_elements_resume_purchase_order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prefab_items_card_evaluate_orders_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prefab_items_card_evaluate_orders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_prefab_items_card_evaluate_orders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_orders_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_comments_service__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_packages_service__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_prefab_elements_order_important_info__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_prefab_elements_order_important_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_prefab_elements_order_important_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_prefab_items_comment_component__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_prefab_items_comment_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_prefab_items_comment_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    resumePurchaseOrder: __WEBPACK_IMPORTED_MODULE_6__components_prefab_elements_resume_purchase_order___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_prefab_structures_breadcrumb_vue___default.a,
    orderImportantInfo: __WEBPACK_IMPORTED_MODULE_11__components_prefab_elements_order_important_info___default.a,
    commentComponent: __WEBPACK_IMPORTED_MODULE_12__components_prefab_items_comment_component___default.a,
    cardEvaluateOrders: __WEBPACK_IMPORTED_MODULE_7__components_prefab_items_card_evaluate_orders_vue___default.a
  },
  props: ["id", "orderData"],
  data: function data() {
    return {
      formReviewSer: {
        respuesta: null,
        fileformReview: null
      },
      imageManifiesto: "",
      historyUser: null,
      search: {
        dni: null,
        result: null,
        error: false
      },
      resultSearchWr: null,
      searchWR: null,
      listWarehouse: null,
      formCreate: {
        purchase_order_id: null,
        consignee: null,
        remitter: null,
        carrier: null,
        tracking: null,
        comment: null,
        unidad: 12,
        weight: null,
        images: []
      },
      entregaSendiList: [],
      entregaSendi: {
        entrega: "Oficina",
        desciption: "",
        evidencia: ""
      },
      selectTracking: "I",
      localInternacionalTracking: {
        codigo: "",
        type: "1"
      },
      imageComprobante: "",
      codigoTransferencia: "",
      imageVaucher: "",
      dataViajeros: [],
      dataInputViajero: "",
      buscarViajeroCampo: "1",
      dataInternationalShooper: [],
      interShooper: {
        tienda: "",
        enlace: "",
        precio: "",
        cantidad: "",
        peso: "",
        order: "",
        invoice: ""
      },
      statusTracking: [{ id: 1, text: "EN REVISIÓN" }, { id: 2, text: "COMPRADO" }, { id: 3, text: "PREPARANDO PARA ENVIAR" }, { id: 4, text: "LISTO PARA ENVIAR" }, { id: 5, text: "ENVIADO" }, { id: 6, text: "LISTO PARA ENTREGAR" }, { id: 7, text: "ENTREGADO" }, { id: 8, text: "SINIESTRADO" }, { id: 9, text: "EN PROCESO DE DEVOLUCIÓN" }, { id: 10, text: "RETORNADO AL PROVEEDOR" }],

      dataNationalTracking: [],
      dataLocalTracking: [],

      statusPayment: [{ id: 1, text: "PENDIENTE" }, { id: 2, text: "EN PROCESO" }, { id: 3, text: "CONFIRMADO" }, { id: 10, text: "RECHAZADO" }, { id: 11, text: "RECLAMADO" }, { id: 12, text: "RETORNADO" }],
      trackingNumber: "",
      seguimientoTrackin: "",
      locale: "en",
      sendProcessFlag: false,
      currentContent: "",
      orderDataShow: null,
      unitWeight: "",
      weightGrabr: "",
      costGrabr: "",
      taxGrabr: "",
      shippingGrabr: "",
      CostReal: "",
      TaxReal: "",
      shippingReal: "",
      finalBuyingLink: "",
      finalBuyingCode: "",
      numberTracking: "",
      postingDate: "",
      sendingDate: "",
      operatorOrigin: "",
      carrier: "",
      otherCarrierName: "",
      listUnits: [],
      listOperators: [],
      flagFormEvaluetionPurchaseOrder: "toFill",
      controllSwithPurchaseOrder: 1,
      rewardDiscount: "",
      rewardFlag: false,
      packaged: 1,
      otherCarrierFlag: false,
      editPackagedFlag: false,
      packageRepositions: [],
      createCommentFlag: true,
      authorizationOption: null,

      carrier_list: [{ name: "FedEx", url: "https://www.fedex.com/en-us/home.html" }, {
        name: "USPS",
        url: "https://tools.usps.com/go/TrackConfirmAction_input"
      }, { name: "UPS", url: "https://www.ups.com/us/en/Home.page" }, { name: "DHL", url: "https://www.dhl.com/en/express/tracking.html" }, { name: "AMAZON_US", url: "" }],
      nameSection: "Visualizar orden de compra",
      listRoutes: [{ nameRoute: "Orders", titleRoute: "Órdenes de compra" }],
      activeRoute: "",
      comments: [],
      packages: [],

      pagosStatus: null,
      trakingStatus: null,
      switchWR: 1
    };
  },
  created: function created() {
    this.$validator.localize("es", {
      messages: __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_es___default.a.messages,
      attributes: {
        fullname: "nombre completo",
        document_number: "número de documento",
        phone_number: "número de celular",
        price: "precio",
        tax: "impuesto",
        product_image: "imagen del artículo",
        purchase_order_number: "número de orden de compra",
        product_information: "información del producto",
        purchase_order_link: "link de orden de compra",
        purchase_chat_link: "link de chat de compra",
        purchase_order_date: "fecha de asignación al viajero",
        origin_city: "ciudad de origen",
        destination_city: "ciudad de destino",
        possible_delivery_date: "fecha posible de entrega",
        precio_web: "precio de la web",
        impuesto_web: " impuesto de la web",
        costo_envio_web: "costo de envío de la web",
        peso_orden: "peso de la orden",
        unidad_peso: "unidad de peso",
        costo_real: "precio real",
        real_tax: "impuesto real",
        real_delivery_cost: "costo de envío real",
        link_compra_final: "link de compra final",
        codigo_compra: "código de compra",
        numero_tracking: "número de tracking",
        fecha_llegada_origen: "fecha de llegada al origen",
        operador_envio: "operador de envío",
        transportista: "transportista",
        fecha_llegada_cliente: "Entrega prometida"
      }
    });

    this.$validator.localize("es");


    console.log("obtendremos de nuevo la data");
    this.inicializeData(this.id, this.setData);
    this.displayComments();

    this.getInternationalTracking();
    this.getInternationalShooper();
    this.getLocalTracking();
    this.getEntregaSendi();
    this.getWarehouse();
    this.getHistoryUser();
  },


  methods: {
    subirArchivoReview: function subirArchivoReview(e) {
      var _this = this;

      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function (file) {
        _this.formReviewSer.fileformReview = file.target.result;
      };
      reader.readAsDataURL(file);
    },
    RespuestaReview: function RespuestaReview() {
      var url = "https://backendbutiko.com" + "/api/purchaseOrder/new-review/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        review_mensaje: this.formReviewSer.respuesta,
        review_archivo: this.formReviewSer.fileformReview,
        from_admin: "1"
      }).then(function () {
        location.reload();
      }).catch(function (error) {
        if (error) {
          alert("Error al enviar la respuesta ");
        }
      });
    },
    liberarWR: function liberarWR(code) {
      var url = "https://backendbutiko.com" + "/api/warehouse/unnasignByCode/" + code;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function () {
        window.location.reload();
      }).catch(function () {
        alert("Error al liberar el WR ");
      });
    },
    changeSiwtch: function changeSiwtch(id) {
      this.switchWR = id;
    },
    getHistoryUser: function getHistoryUser() {
      var _this2 = this;

      var url = "https://backendbutiko.com" + "/api/admin/list/historialOrder/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        _this2.historyUser = response.data.body;
      }).catch(function () {
        alert("Error al obtener el historial del pedido");
      });
    },
    changeUserOrder: function changeUserOrder() {
      var _this3 = this;

      var answer = window.confirm("¿Desea reasignar orden?");

      if (this.search.dni && this.search.result && answer) {
        var url = "https://backendbutiko.com" + "/api/admin/changeOrder/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
          newIdUser: this.search.result.id,
          oldUser: this.orderDataShow.attributes.client.id
        }).then(function () {
          location.reload();
        }).catch(function () {
          _this3.search.result = null;
          _this3.search.dni = null;
          alert("Error al reasignar orden");
        });
      }
    },
    getUserSearch: function getUserSearch() {
      var _this4 = this;

      var url = "https://backendbutiko.com" + "/api/client/getByClientCode/" + this.search.dni;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        clientCodeOld: this.orderDataShow.attributes.client.attributes.profile.attributes.userable.client_code,
        store: this.orderDataShow.attributes.client.attributes.profile.attributes.userable.attributes.store_id
      }).then(function (response) {
        _this4.search.result = response.data.body;
        _this4.search.error = false;
      }).catch(function () {
        _this4.search.result = null;
        _this4.search.error = true;
        _this4.search.dni = null;
      });
    },
    openModal: function openModal(id) {
      var modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal: function closeModal(id) {
      if (id === "modal-reasignar") {
        this.search.result = null;
        this.search.dni = null;
        this.search.error = false;
      }
      var modal = document.getElementById(id);
      modal.close();
    },
    updatePaquete: function updatePaquete(idWarehouse) {
      var url = "https://backendbutiko.com" + "/api/warehouse/update/" + idWarehouse;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        purchase_order_id: this.id
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error actualizar paquete");
      });
    },
    changeStatusTracking: function changeStatusTracking(data) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var text, answer, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(data !== _this5.orderDataShow.attributes.order_tracking_details[_this5.orderDataShow.attributes.order_tracking_details.length - 1].attributes.status)) {
                  _context.next = 20;
                  break;
                }

                text = "";

                if (data === 1) {
                  text = "Desea agregar el estado 'IN_EVALUATION'";
                }
                if (data === 2) {
                  text = "Desea agregar el estado 'WAITING_EVALUATION_CONFIRMATION'";
                }
                if (data === 3) {
                  text = "Desea agregar el estado 'COMPLETING_PURCHASE_INFO'";
                }
                if (data === 4) {
                  text = "Desea agregar el estado 'READY_TO_BOARDING'";
                }
                if (data === 5) {
                  text = "Desea agregar el estado 'IN_BOARDING'";
                }
                if (data === 6) {
                  text = "Desea agregar el estado 'READY_TO_PICKUP'";
                }
                if (data === 7) {
                  text = "Desea agregar el estado 'DELIVERY_SUCCESS'";
                }
                if (data === 8) {
                  text = "Desea agregar el estado 'SINISTER'";
                }
                if (data === 9) {
                  text = "Desea agregar el estado 'RETURN'";
                }
                if (data === 10) {
                  text = "Desea agregar el estado 'RETURN_TO_SUPPLIER'";
                }

                answer = window.confirm(text);

                if (!answer) {
                  _context.next = 19;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/purchaseOrder/" + _this5.orderDataShow.id + "/addTracking";
                _context.next = 17;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, { status: data, admin: _this5.$store.state.user.id }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                  _this5.trakingStatus = _this5.orderDataShow.attributes.order_tracking_details[_this5.orderDataShow.attributes.order_tracking_details.length - 1].attributes.status;
                });

              case 17:
                _context.next = 20;
                break;

              case 19:
                _this5.trakingStatus = _this5.orderDataShow.attributes.order_tracking_details[_this5.orderDataShow.attributes.order_tracking_details.length - 1].attributes.status;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    getWarehouse: function getWarehouse() {
      var _this6 = this;

      var url = "https://backendbutiko.com" + "/api/warehouse/list-packages-by-order-id/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        _this6.listWarehouse = response.data.data;
      }).catch(function () {
        alert("Error al obtener la lista de WR");
      });
    },
    searchWrehouse: function searchWrehouse() {
      var _this7 = this;

      var url = "https://backendbutiko.com" + "/api/warehouse/getByCode/" + this.searchWR;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        _this7.resultSearchWr = response.data.body;
      }).catch(function () {
        alert("Error al buscar warehouse");
      });
    },
    limitchangePaquete: function limitchangePaquete() {
      var _this8 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/warehouse/changeWarehouseStatus/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al cambiar el estado");
        _this8.is_loading = false;
      });
    },
    handleFileInput: function handleFileInput(event) {
      var files = event.target.files;
      var images = [];

      for (var _i = 0; _i < files.length; _i++) {
        var file = files[_i];

        if (!file.type.match("image.*")) {
          continue;
        }
        var reader = new FileReader();

        reader.onload = function (file) {
          return function (event) {
            images.push(event.target.result);
          };
        }(file);
        reader.readAsDataURL(file);
        this.formCreate.images = images;
      }
    },
    createPaquete: function createPaquete() {
      var _this9 = this;

      this.is_loading = true;
      var url = "https://backendbutiko.com" + "/api/warehouse/save-package";
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        purchase_order_id: this.id,
        consignee: this.formCreate.consignee,
        carrier: this.formCreate.carrier,
        remitter: this.formCreate.remitter,
        tracking: this.formCreate.tracking,
        comment: this.formCreate.comment,
        weight_unit_id: this.formCreate.unidad,
        weight: this.formCreate.weight,
        images: this.formCreate.images
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Error al asignar el paquete");
        _this9.is_loading = false;
      });
    },
    changeStatusPayment: function changeStatusPayment(data) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, text, answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(data !== _this10.orderDataShow.attributes.payed)) {
                  _context2.next = 17;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/purchaseOrder/update-order-no-grabr/" + _this10.orderDataShow.id;
                text = "";

                if (data === 1) {
                  text = "desea cambiar el estado a  'PENDIENT'";
                }
                if (data === 2) {
                  text = "desea cambiar el estado a  'SOFT_PAYED'";
                }
                if (data === 3) {
                  text = "desea cambiar el estado a  'HARD_PAYED'";
                }
                if (data === 4) {
                  text = "desea cambiar el estado a  'CONFIRMED'";
                }
                if (data === 10) {
                  text = "desea cambiar el estado a  'REJECTED'";
                }
                if (data === 11) {
                  text = "desea cambiar el estado a  'RECLAIMED'";
                }
                if (data === 12) {
                  text = "desea cambiar el estado a  'RETURNED'";
                }
                answer = window.confirm(text);

                if (!answer) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, {
                  payed: data,
                  writer_id: _this10.$store.state.user.attributes.profile.id
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                  _this10.pagosStatus = _this10.orderDataShow.attributes.payed;
                });

              case 14:
                _context2.next = 17;
                break;

              case 16:
                _this10.pagosStatus = _this10.orderDataShow.attributes.payed;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },
    deleteEntregaSendi: function deleteEntregaSendi(value) {
      var answer = window.confirm("Desea eliminar");

      if (answer) {
        var url = "https://backendbutiko.com" + "/api/deleteDeliverySendi/" + value + "/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function () {
          location.reload();
        }).catch(function (error) {
          if (error) {
            alert("Sucedió un error");
          }
        });
      }
    },
    getEntregaSendi: function getEntregaSendi() {
      var _this11 = this;

      var url = "https://backendbutiko.com" + "/api/listDeliverySendi/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        _this11.entregaSendiList = response.data.body;
      }).catch(function (error) {
        if (error) {
          alert("Sucedió un error");
        }
      });
    },
    evidenciaSendi: function evidenciaSendi(e) {
      var _this12 = this;

      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function (file) {
        _this12.entregaSendi.evidencia = file.target.result;
      };
      reader.readAsDataURL(file);
    },
    saveEntregaSendi: function saveEntregaSendi(e) {
      var url = "https://backendbutiko.com" + "/api/addDeliverySendi";
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        delivery: this.entregaSendi.entrega,
        description: this.entregaSendi.desciption,
        evidence: this.entregaSendi.evidencia,
        codeOrder: this.id
      }).then(function () {
        location.reload();
      }).catch(function (error) {
        if (error) {
          alert("Sucedió un error");
        }
      });
    },
    fileReturn: function fileReturn(e) {
      var _this13 = this;

      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function (file) {
        _this13.cargarFileReturn(file.target.result);
      };
      reader.readAsDataURL(file);
    },
    cargarFileReturn: function cargarFileReturn(file) {
      var url = "https://backendbutiko.com" + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, {
        serviceReturn: {
          serviceReturn: file,
          isFromAdmin: true
        },
        writer_id: this.$store.state.user.attributes.profile.id
      }).then(function () {
        location.reload();
      }).catch(function () {
        alert("Sucedió un error al cargar file de return");
      });
    },
    deleteFileReturn: function deleteFileReturn(data) {
      var answer = window.confirm("Desea eliminar el documento");
      if (answer) {
        var url = "https://backendbutiko.com" + "/api/purchaseOrder/deleteServiceReturn/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url, {
          data: {
            serviceReturn_path: data.url_return
          }
        }).then(function () {
          location.reload();
        }).catch(function () {
          alert("Sucedió un error");
        });
      }
    },
    deleteInvoice: function deleteInvoice(data, index) {
      var answer = window.confirm("Desea eliminar el invoice - " + index);
      if (answer) {
        var url = "https://backendbutiko.com" + "/api/purchaseOrder/deleteinvoice/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url, {
          data: {
            invoice_path: data
          }
        }).then(function (response) {
          if (response.status === 200) {
            location.reload();
          }
        }).catch(function (error) {
          if (error) {
            alert("Sucedió un error");
          }
        });
      }
    },
    deleteManifiesto: function deleteManifiesto(data, index) {
      var answer = window.confirm("Desea eliminar el Manifiesto - " + index);

      if (answer) {
        var url = "https://backendbutiko.com" + "/api/purchaseOrder/deleteManifest/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url, {
          data: {
            manifest_path: data
          }
        }).then(function (response) {
          if (response.status === 200) {
            location.reload();
          }
        }).catch(function (error) {
          if (error) {
            alert("Sucedió un error");
          }
        });
      }
    },
    statusInvoice: function statusInvoice(data, index, status) {
      var answer = window.confirm(status === 0 ? "cambiar a aprobar el adjunto " + index : "cambiar a sin aprobar el adjunto " + index);
      if (answer) {
        var url = "https://backendbutiko.com" + "/api/purchaseOrder/approveinvoice/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
          params: {
            invoice_path: data
          }
        }).then(function (response) {
          if (response.status === 200) {
            location.reload();
          }
        }).catch(function (error) {
          if (error) {
            alert("Sucedió un error");
          }
        });
      }
    },
    statusManifiesto: function statusManifiesto(data, index, status) {
      var answer = window.confirm(status === 0 ? "cambiar a aprobar el Manifiesto " + index : "cambiar a sin aprobar el Manifiesto " + index);
      if (answer) {
        var url = "https://backendbutiko.com" + "/api/purchaseOrder/approvemanifest/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
          manifest_path: data
        }).then(function (response) {
          if (response.status === 200) {
            location.reload();
          }
        }).catch(function (error) {
          if (error) {
            alert("Sucedió un error");
          }
        });
      }
    },
    invoice: function invoice(e) {
      var file2 = e.target.files[0];
      this.cargarInvoice(file2);
    },
    cargarInvoice: function cargarInvoice(file) {
      var _this14 = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        _this14.interShooper.invoice = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    comprobante: function comprobante(e) {
      var file2 = e.target.files[0];
      this.cargarImagenComprobante(file2);
    },
    cargarImagenComprobante: function cargarImagenComprobante(file) {
      var _this15 = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        _this15.imageComprobante = e.target.result;
        var answer = window.confirm("Desea cambiar el vaucher?");
        if (answer) {
          _this15.sendVaucherComprobante(0);
        } else {
          _this15.$refs.fileuploadComprobante.value = null;
          _this15.codigoTransferencia = "";
          _this15.imageComprobante = "";
        }
      };
      reader.readAsDataURL(file);
    },
    sendVaucherComprobante: function sendVaucherComprobante(type) {
      var _this16 = this;

      var objectVaucher = new Object();
      if (type === 1) {
        objectVaucher.payment_code = this.codigoTransferencia;
      } else if (type === 0) {
        objectVaucher.voucher = { voucher: this.imageComprobante, isFromAdmin: true };
      }
      objectVaucher.writer_id = this.$store.state.user.attributes.profile.id;
      if (type === 1) {
        var answer = window.confirm("Desea cambiar el código?");
      }

      if (type === 0 || type === 1 && answer) {
        var url = "https://backendbutiko.com" + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, objectVaucher).then(function (response) {
          if (response.status === 200) {
            _this16.$refs.fileuploadComprobante.value = null;
            _this16.codigoTransferencia = "";
            _this16.imageComprobante = "";
            location.reload();
          }
        }).catch(function (error) {
          if (error) {
            _this16.codigoTransferencia = "";
            _this16.imageComprobante = "";
            _this16.$refs.fileuploadComprobante.value = null;
            alert("Sucedió un error");
          }
        });
      }
    },
    manifiestoFile: function manifiestoFile(e) {
      var file = e.target.files[0];
      this.cargarManifiesto(file);
    },
    cargarManifiesto: function cargarManifiesto(file) {
      var _this17 = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        _this17.imageManifiesto = e.target.result;
        _this17.sendManifiesto();
      };
      reader.readAsDataURL(file);
    },
    sendManifiesto: function sendManifiesto() {
      var url = "https://backendbutiko.com" + "/api/purchaseOrder/createmanifest/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        from_admin: 1,
        manifest_archivo: this.imageManifiesto
      }).then(function () {
        location.reload();
      }).catch(function (error) {
        if (error) {
          alert("Sucedió un error");
        }
      });
    },
    factura: function factura(e) {
      var file = e.target.files[0];
      this.cargarImagen(file);
    },
    cargarImagen: function cargarImagen(file) {
      var _this18 = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        _this18.imageVaucher = e.target.result;
        _this18.sendVaucher();
      };
      reader.readAsDataURL(file);
    },
    sendVaucher: function sendVaucher() {
      var _this19 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, {
        voucher_usa: this.imageVaucher,
        from_admin: 1,
        writer_id: this.$store.state.user.attributes.profile.id
      }).then(function (response) {
        if (response.status === 200) {
          _this19.$refs.fileupload.value = null;
          _this19.imageVaucher = "";
          location.reload();
        }
      }).catch(function (error) {
        if (error) {
          _this19.imageVaucher = "";
          _this19.$refs.fileupload.value = null;
          alert("Sucedió un error");
        }
      });
    },
    quitarViajero: function quitarViajero() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var answer, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                answer = window.confirm("Desea quitar al viajero de la orden?");

                if (!answer) {
                  _context3.next = 5;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/purchaseOrder/" + _this20.id + "/unassignClientTravel";
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
                  reason: "Administrativo"
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this20);
      }))();
    },
    asignarViajeroOrder: function asignarViajeroOrder(data, user) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var answer, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                answer = window.confirm("Desea Asignar al Viajero con código de usuario : " + user + " a la orden: " + _this21.id + " ?");

                if (!answer) {
                  _context4.next = 5;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/purchaseOrder/" + _this21.id + "/addClientTravel";
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
                  travel_client_id: data
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this21);
      }))();
    },
    buscarViajero: function buscarViajero() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var store, length, orderBy, dir, filterBy, filterValue, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = 2;
                length = 10;
                orderBy = "fullname";
                dir = "asc";
                filterBy = "";

                if (_this22.buscarViajeroCampo === "1") {
                  filterBy = "fullname";
                }
                if (_this22.buscarViajeroCampo === "2") {
                  filterBy = "code";
                }
                filterValue = _this22.dataInputViajero;
                url = "https://backendbutiko.com" + "/api/client/getTravelers?store=" + store + "&length=" + length + "&orderBy=" + orderBy + "&dir=" + dir + "&filterBy=" + filterBy + "&filterValue=" + filterValue + "&orderId=" + _this22.id + "&destination=" + _this22.orderDataShow.attributes.destination.attributes.name;
                _context5.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
                  _this22.dataInputViajero = "";
                  if (response.data.data.travels_list.length != 0) {
                    _this22.dataViajeros = response.data.data.travels_list;
                  } else {
                    alert("No se encontro resultados");
                  }
                }).catch(function () {
                  _this22.dataInputViajero = "";
                  alert("Sucedio un error");
                });

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this22);
      }))();
    },
    deleteInternationalShooper: function deleteInternationalShooper(data) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var url, answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/deleteInternationalShopper/" + data + "/" + _this23.id;
                answer = window.confirm("Desea Eliminarlo?");

                if (!answer) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
                  _this23.dataInternationalShooper = response.data.body === null ? [] : response.data.body;
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this23);
      }))();
    },
    getInternationalShooper: function getInternationalShooper() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/listInternationalShopper/" + _this24.id;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
                  _this24.dataInternationalShooper = response.data.body === null ? [] : response.data.body;
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this24);
      }))();
    },
    addInternationalShooper: function addInternationalShooper() {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var url, answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/createInternationalShopper/" + _this25.id;
                answer = window.confirm("Desea Agregarlo?");

                if (!answer) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
                  tiendaCompra: _this25.interShooper.tienda,
                  enlace: _this25.interShooper.enlace,
                  precio: _this25.interShooper.precio,
                  cantidad: _this25.interShooper.cantidad,
                  peso: _this25.interShooper.peso,
                  orderNumber: _this25.interShooper.order,
                  invoiceDetails: _this25.interShooper.invoice
                }).then(function (response) {
                  _this25.dataInternationalShooper = response.data.body;
                  _this25.interShooper.tienda = "";
                  _this25.interShooper.enlace = "";
                  _this25.interShooper.precio = "";
                  _this25.interShooper.cantidad = "";
                  _this25.interShooper.peso = "";
                  _this25.interShooper.order = "";
                  _this25.interShooper.invoice = "";

                  _this25.$refs.invoice.value = null;
                }).catch(function () {
                  alert("Hubo un error");
                  _this25.$refs.invoice.value = null;
                  _this25.interShooper.tienda = "";
                  _this25.interShooper.enlace = "";
                  _this25.interShooper.precio = "";
                  _this25.interShooper.cantidad = "";
                  _this25.interShooper.peso = "";
                  _this25.interShooper.order = "";
                  _this25.interShooper.invoice = "";
                });

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this25);
      }))();
    },
    changeHidden: function changeHidden(data, type) {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var url, text, typeHidden, answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log(data, "data");
                console.log(type, "type");
                url = "https://backendbutiko.com" + "/api/updateHideTracking/" + data + "/" + _this26.id;
                text = "";
                typeHidden = null;

                if (type === 1 || type === true) {
                  text = "Desea Ocultar el Tracking : " + data;
                  typeHidden = false;
                }
                if (type === 0 || type === false) {
                  text = "Desea Mostrar el Tracking : " + data;
                  typeHidden = true;
                }
                answer = window.confirm(text);

                if (!answer) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, { hide: typeHidden }).then(function (response) {
                  _this26.dataNationalTracking = [];
                  _this26.dataNationalTracking = response.data.body === null ? [] : response.data.body;
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this26);
      }))();
    },
    deleteTackingStatus: function deleteTackingStatus(id, data) {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var answer, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                answer = window.confirm("Desea eliminar el estado de tracking " + data);

                if (!answer) {
                  _context10.next = 5;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/tracking/" + id + "/delete";
                _context10.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this27);
      }))();
    },
    deleteTracking: function deleteTracking(data) {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var answer, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                answer = window.confirm("Desea eliminar el Tracking " + data);

                if (!answer) {
                  _context11.next = 5;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/deleteTrackingForCodePro/" + data + "/" + _this28.id;
                _context11.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function () {
                  _this28.dataNationalTracking = _this28.dataNationalTracking.filter(function (trackingDelete) {
                    return trackingDelete.data.trackings[0].shipment.trackingNumbers[0].tn !== data;
                  });
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this28);
      }))();
    },
    getInternationalTracking: function getInternationalTracking() {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/listTrackingforCodeProd/" + _this29.id;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
                  console.log(response, "international tracking");
                  _this29.dataNationalTracking = response.data.body === null ? [] : response.data.body;
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this29);
      }))();
    },
    createdInternationalTracking: function createdInternationalTracking() {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/addTracking";

                if (!(_this30.localInternacionalTracking.codigo.length !== 0)) {
                  _context13.next = 4;
                  break;
                }

                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
                  numTracking: _this30.localInternacionalTracking.codigo,
                  codeOrder: _this30.id,
                  type: parseInt(_this30.localInternacionalTracking.type),
                  hide: true
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this30);
      }))();
    },
    createdLocalTracking: function createdLocalTracking() {
      var _this31 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/addTrackingLocal";

                if (!(_this31.localInternacionalTracking.codigo.length !== 0)) {
                  _context14.next = 4;
                  break;
                }

                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
                  trackingNumber: _this31.localInternacionalTracking.codigo,
                  codeOrder: _this31.id,
                  type: parseInt(_this31.localInternacionalTracking.type),
                  hide: true
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this31);
      }))();
    },
    getLocalTracking: function getLocalTracking() {
      var _this32 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/listTrackingforCodeProdLocal/" + _this32.id;
                _context15.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
                  _this32.dataLocalTracking = response.data.body === null ? [] : response.data.body;
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this32);
      }))();
    },
    deleteTrackingLocal: function deleteTrackingLocal(data) {
      var _this33 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var answer, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                answer = window.confirm("Desea eliminar el Tracking " + data);

                if (!answer) {
                  _context16.next = 5;
                  break;
                }

                url = "https://backendbutiko.com" + "/api/deleteTrackingForCodeProLocal/" + data + "/" + _this33.id;
                _context16.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this33);
      }))();
    },
    changeHiddenLocal: function changeHiddenLocal(data, type) {
      var _this34 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var url, text, typeHidden, answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/updateHideTrackingLocal/" + data + "/" + _this34.id;
                text = "";
                typeHidden = null;

                if (type === 1 || type === true) {
                  text = "Desea Ocultar el Tracking : " + data;
                  typeHidden = false;
                }
                if (type === 0 || type === false) {
                  text = "Desea Mostrar el Tracking : " + data;
                  typeHidden = true;
                }
                answer = window.confirm(text);

                if (!answer) {
                  _context17.next = 9;
                  break;
                }

                _context17.next = 9;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, { hide: typeHidden }).then(function (response) {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this34);
      }))();
    },
    updateOrderInformation: function updateOrderInformation(type) {
      var _this35 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var url, objUpdateOrder, text, answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/purchaseOrder/update-order-no-grabr/" + _this35.id;
                objUpdateOrder = new Object();
                text = "";

                if (type === "cancelada") {
                  objUpdateOrder.status = 10;
                  text = "Desea cancelar la orden?";
                } else if (type === "activa") {
                  objUpdateOrder.status = 3;
                  text = "Desea activar la orden?";
                } else if (type === "A") {
                  objUpdateOrder.channel = "A";
                  text = "Desea cambiar el canal verde?";
                } else if (type === "B") {
                  objUpdateOrder.channel = "B";
                  text = "Desea cambiar el canal rojo?";
                } else if (type === "aduana") {
                  objUpdateOrder.courier_type = 1;
                  text = "Desea cambiar el método a aduana?";
                } else if (type === "pasajero") {
                  objUpdateOrder.courier_type = 2;
                  text = "Desea cambiar el método a pasajero?";
                }
                objUpdateOrder.writer_id = _this35.$store.state.user.attributes.profile.id;
                answer = window.confirm(text);

                if (!answer) {
                  _context18.next = 9;
                  break;
                }

                _context18.next = 9;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, objUpdateOrder).then(function () {
                  location.reload();
                }).catch(function () {
                  alert("Hubo un error");
                });

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this35);
      }))();
    },
    authorizeReposition: function authorizeReposition() {
      var _this36 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                data = new Object();

                data.authorized = parseInt(_this36.authorizationOption) == 1;

                _context19.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].authorizeReposition(_this36.orderDataShow.id, data);

              case 4:
                _this36.responseEvaluation = _context19.sent;


                _this36.hideModalConfirmationReposition();
                _this36.hideModalAuthorizeReposition();

                if (!_this36.responseEvaluation) {
                  alert("no se pudo enviar la solicitud");
                } else {
                  _this36.inicializeData(_this36.id, _this36.setData);
                }

              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this36);
      }))();
    },
    refreshPackageSection: function refreshPackageSection() {
      var accordionElement = document.getElementById("collapseEight");
      console.log(accordionElement);

      accordionElement.setAttribute("class", "collapse show");
      __WEBPACK_IMPORTED_MODULE_10__services_packages_service__["a" /* packagesService */].getPackagesByOrderId(this.id, this.setPackages);
    },
    disablingEvaluationButton: function disablingEvaluationButton() {
      console.log("Vamos a deshabilitar el botón de evaluar");
    },
    getPackages: function getPackages() {
      console.log("entro");

      var accordionElement = document.getElementById("collapseEight");
      console.log(accordionElement);

      var accordionClass = accordionElement.getAttribute("class");
      var isExpanded = accordionClass == "collapse show";
      if (!isExpanded) {
        console.log("get packages");
        __WEBPACK_IMPORTED_MODULE_10__services_packages_service__["a" /* packagesService */].getPackagesByOrderId(this.id, this.setPackages);
      }
    },
    inicializeDataFromImportantInfo: function inicializeDataFromImportantInfo() {
      this.inicializeData(this.id, this.setData);
    },
    setPackages: function setPackages(retrievedPackages) {
      console.log("set packages");

      this.packages = retrievedPackages;
    },
    disableEditComments: function disableEditComments(exceptId) {
      console.log("No se pueden editar otros comentarios");
      console.log(exceptId);
      this.createCommentFlag = false;

      this.comments.forEach(function (comment) {
        if (comment.id != exceptId) {
          comment.enable = false;
        }
      });
    },
    enableEditComments: function enableEditComments() {
      this.createCommentFlag = true;
      this.comments.forEach(function (comment) {
        comment.enable = true;
      });
    },
    displayComments: function displayComments() {
      console.log("En display comments");

      __WEBPACK_IMPORTED_MODULE_9__services_comments_service__["a" /* commentsService */].listCommentsByOrderId(this.id, this.setComments);
    },
    createComment: function createComment() {
      var _this37 = this;

      var cancelled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var commentData, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                commentData = {};

                if (!(_this37.currentContent != "")) {
                  _context20.next = 12;
                  break;
                }

                commentData.content = _this37.currentContent;
                commentData.purchaseorder_id = parseInt(_this37.id);
                console.log(_this37.$store.state.user);

                commentData.writer_id = _this37.$store.state.user.attributes.profile.id;
                console.log(commentData);
                if (cancelled == 1) commentData.cancelled = 1;

                _context20.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__services_comments_service__["a" /* commentsService */].createComment(commentData);

              case 10:
                res = _context20.sent;


                if (res) {
                  _this37.currentContent = "";
                  _this37.displayComments();
                }

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this37);
      }))();
    },
    setComments: function setComments(comments) {
      console.log("Estamos en set comments");
      console.log(comments);

      comments.forEach(function (comment) {
        comment.enable = true;
      });
      this.comments = comments;
    },
    editPackaged: function editPackaged() {
      this.packaged = this.packagedRealValue;
      this.editPackagedFlag = true;
    },
    cancelEditPackaged: function cancelEditPackaged() {
      console.log("cancelEditPackaged");

      this.editPackagedFlag = false;
    },
    updatePackaged: function updatePackaged() {
      var _this38 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var auxObject, resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                console.log("updatePackaged");
                auxObject = new Object();

                auxObject.packaged = _this38.packaged == 1 ? null : _this38.packaged == 2 ? 1 : 0;

                _context21.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].updateBuyingOrderNoGrabr(_this38.orderDataShow.attributes.order_code, auxObject);

              case 5:
                resp = _context21.sent;

                _this38.inicializeData(_this38.id, _this38.setData);
                _this38.editPackagedFlag = false;

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this38);
      }))();
    },
    showRepositionDetail: function showRepositionDetail() {},
    setTaxGrabr: function setTaxGrabr() {
      console.log("Ok");
      this.taxGrabr = Number(Math.round(parseFloat(0.07 * parseFloat(this.costGrabr)) + "e2") + "e-2").toFixed(2).toString();
      console.log(this.taxGrabr);
    },
    setTaxReal: function setTaxReal() {
      console.log("Ok");
      var rewardDiscount = void 0;
      if (this.rewardDiscount == "") {
        rewardDiscount = 0;
      } else rewardDiscount = this.rewardDiscount;
      this.TaxReal = Number(Math.round(parseFloat(0.07 * parseFloat(this.CostReal - rewardDiscount)) + "e2") + "e-2").toFixed(2).toString();
    },
    reinicialize_variables: function reinicialize_variables() {
      this.unitWeight = "";
      this.weightGrabr = "";
      this.costGrabr = "";
      this.taxGrabr = "";
      this.shippingGrabr = "";
      this.CostReal = "";
      this.TaxReal = "";
      this.shippingReal = "";
      this.finalBuyingLink = "";
      this.finalBuyingCode = "";
      this.numberTracking = "";
      this.postingDate = "";
      this.sendingDate = "";
      this.operatorOrigin = "";
      this.flagFormEvaluetionPurchaseOrder = "toFill";
      this.controllSwithPurchaseOrder = 1;
    },
    inicializeData: function inicializeData(id, callback) {
      var url = "https://backendbutiko.com" + "/api/purchaseOrder/get/" + id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        var data = response.data.body;
        console.log("Estamos en obtener orden de compra: ", data);
        callback(data);
      }).catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            self.response = "Error 404";
          }
          console.log(error);
        }
      });
    },
    listUnitWeight: function listUnitWeight(callback) {
      var url = "https://backendbutiko.com" + "/api/weightUnit/list";
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        var data = response.data.body;
        callback(data);
      }).catch(function (errors) {
        console.log(errors);
      });
    },
    listOperatorOrigin: function listOperatorOrigin(id, callback) {
      var url = "https://backendbutiko.com" + "/api/operator/get-operators-origin/" + id;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        var data = response.data.body;
        console.log(data);
        callback(data);
      }).catch(function (errors) {
        console.log(errors.response);
        return;
      });
    },
    dotracking: function dotracking(trackingNumber) {
      var _this39 = this;

      var url = "https://backendbutiko.com" + "/api/detectCarrier/" + trackingNumber;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url).then(function (response) {
        var respuesta = response.data.data;
        var data3 = response.data;
        if (respuesta === null) {
          _this39.seguimientoTrackin = "";
        } else {
          var data = response.data.data.trackings[0].events;
          _this39.seguimientoTrackin = data;
        }
      });
    },
    handleValidationErrorAdvanced: function handleValidationErrorAdvanced() {
      var firstField = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors.collect())[0];
      if (firstField) {
        var elements = document.getElementsByName(firstField);
        console.log("Failed validation of field: ".concat(firstField));
        elements[0].scrollIntoView();
      } else console.log("Could not find elements with errors");
    },
    modalControllPurchaseOrder: function modalControllPurchaseOrder(state) {
      var _this40 = this;

      if (state == 1) {
        this.$validator.validate().then(function (result) {
          if (!result) {
            return _this40.handleValidationErrorAdvanced();
          } else {
            console.log("PASSED STATE = 1");
            _this40.flagFormEvaluetionPurchaseOrder = "toShow";
            _this40.controllSwithPurchaseOrder = 2;
          }
        });
      }
      if (state == 2) {
        console.log("PASSED STATE = 2");
        if (this.controllSwithPurchaseOrder == 1) {
          this.controllSwithPurchaseOrder = 2;
        } else {
          this.controllSwithPurchaseOrder = 1;
        }
      }
    },
    updateEvaluation: function updateEvaluation() {
      var _this41 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this41.$validator.validate().then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22(result) {
                    var auxObject, resp;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            if (result) {
                              _context22.next = 4;
                              break;
                            }

                            return _context22.abrupt("return", _this41.handleValidationErrorAdvanced());

                          case 4:
                            auxObject = new Object();
                            resp = void 0;

                            auxObject.weight = _this41.weightGrabr;
                            auxObject.weight_unit_id = _this41.unitWeight.id;

                            if (!_this41.orderDataShow.attributes.is_from_grabr_flag) {
                              _context22.next = 17;
                              break;
                            }

                            auxObject.grabr_price_rechecked = _this41.costGrabr;
                            auxObject.grabr_tax_rechecked = _this41.taxGrabr;
                            auxObject.grabr_shipping_web = _this41.shippingGrabr;
                            _context22.next = 14;
                            return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].updateBuyingOrder(_this41.orderDataShow.attributes.order_code, auxObject);

                          case 14:
                            resp = _context22.sent;
                            _context22.next = 33;
                            break;

                          case 17:
                            if (!_this41.orderDataShow.attributes.is_from_linio_flag) {
                              _context22.next = 26;
                              break;
                            }

                            auxObject.linio_price_rechecked = _this41.costGrabr;
                            auxObject.linio_tax_rechecked = _this41.taxGrabr;
                            auxObject.linio_shipping_web = _this41.shippingGrabr;
                            _context22.next = 23;
                            return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].updateBuyingLinioOrder(_this41.orderDataShow.attributes.order_code, auxObject);

                          case 23:
                            resp = _context22.sent;
                            _context22.next = 33;
                            break;

                          case 26:
                            if (!_this41.orderDataShow.attributes.is_from_meli_flag) {
                              _context22.next = 33;
                              break;
                            }

                            auxObject.meli_price_rechecked = _this41.costGrabr;
                            auxObject.meli_tax_rechecked = _this41.taxGrabr;
                            auxObject.meli_shipping_web = _this41.shippingGrabr;
                            _context22.next = 32;
                            return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].updateBuyingMeliOrder(_this41.orderDataShow.attributes.order_code, auxObject);

                          case 32:
                            resp = _context22.sent;

                          case 33:
                            _this41.hideModalReevaluetion();
                            console.log("Resp:");
                            console.log(resp);

                            if (resp) {
                              console.log("Resp 2:");
                              console.log(resp);

                              _this41.inicializeData(_this41.id, _this41.setData);
                            }

                          case 37:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22, _this41);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this41);
      }))();
    },
    updateIncompleOrderData: function updateIncompleOrderData() {
      var _this42 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this42.$validator.validate().then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24(result) {
                    var auxObject, resp;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            if (result) {
                              _context24.next = 4;
                              break;
                            }

                            return _context24.abrupt("return", _this42.handleValidationErrorAdvanced());

                          case 4:
                            auxObject = new Object();

                            console.log("está validado");
                            if (_this42.finalBuyingLink != "") auxObject.real_purchase_link = _this42.finalBuyingLink;
                            if (_this42.finalBuyingCode != "") auxObject.shopping_order_number = _this42.finalBuyingCode;

                            if (_this42.otherCarrierName != "") {
                              auxObject.carrier_name = _this42.otherCarrierName;
                              auxObject.carrier_url = "";
                            } else {
                              if (_this42.carrier != "") {
                                auxObject.carrier_name = _this42.carrier_list[_this42.carrier].name;
                                auxObject.carrier_url = _this42.carrier_list[_this42.carrier].url;
                              }
                            }
                            if (_this42.numberTracking != "") auxObject.tracking_number = _this42.numberTracking;

                            if (_this42.postingDate != "" && !_this42.orderDataShow.attributes.is_from_grabr_flag) auxObject.promised_origin_arrival_date = _this42.postingDate;

                            if (_this42.operatorOrigin != "") auxObject.sender_operator_id = _this42.operatorOrigin;

                            if (_this42.sendingDate != "" && !_this42.orderDataShow.attributes.is_from_grabr_flag) auxObject.promised_delivery_date = _this42.sendingDate;

                            console.log("DAta:");
                            console.log(auxObject);
                            console.log(_this42.orderDataShow.attributes.order_code);

                            _context24.next = 18;
                            return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].updateBuyingOrderNoGrabr(_this42.orderDataShow.attributes.order_code, auxObject);

                          case 18:
                            resp = _context24.sent;

                            _this42.hideModalReevaluetion();
                            console.log("Resp:");
                            console.log(resp);

                            if (resp) {
                              if (_this42.orderDataShow.attributes.is_from_grabr_flag) {
                                _this42.$refs.modalProcess.hide();
                              } else {
                                _this42.$refs.modalProcessNoGrabr.hide();
                              }

                              _this42.inicializeData(_this42.id, _this42.setData);
                            }

                          case 23:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24, _this42);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this42);
      }))();
    },
    sendEvaluation: function sendEvaluation(id) {
      var _this43 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this43.$validator.validate().then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26(result) {
                    var auxObject, resp;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
                      while (1) {
                        switch (_context26.prev = _context26.next) {
                          case 0:
                            if (result) {
                              _context26.next = 4;
                              break;
                            }

                            return _context26.abrupt("return", _this43.handleValidationErrorAdvanced());

                          case 4:
                            console.log("PASSED VALIDATIONS OF SEND EVALUATION WITH ID: ".concat(id));
                            auxObject = new Object();

                            if (_this43.orderDataShow.attributes.is_from_grabr_flag) {
                              auxObject.grabr_price_rechecked = _this43.costGrabr;
                              auxObject.grabr_tax_rechecked = _this43.taxGrabr;
                              auxObject.grabr_shipping_web = _this43.shippingGrabr;
                            } else if (_this43.orderDataShow.attributes.is_from_linio_flag) {
                              auxObject.linio_price_rechecked = _this43.costGrabr;
                              auxObject.linio_tax_rechecked = _this43.taxGrabr;
                              auxObject.linio_shipping_web = _this43.shippingGrabr;
                            } else if (_this43.orderDataShow.attributes.is_from_meli_flag) {
                              auxObject.meli_price_rechecked = _this43.costGrabr;
                              auxObject.meli_tax_rechecked = _this43.taxGrabr;
                              auxObject.meli_shipping_web = _this43.shippingGrabr;
                            }

                            auxObject.weight = _this43.weightGrabr;
                            auxObject.weight_unit_id = _this43.unitWeight.id;
                            auxObject.real_price = _this43.CostReal;
                            auxObject.real_tax = _this43.TaxReal;
                            auxObject.real_shipping = _this43.shippingReal;
                            auxObject.real_purchase_link = _this43.finalBuyingLink;
                            if (_this43.rewardDiscount != "") {
                              auxObject.reward_discount = _this43.rewardDiscount;
                            }
                            console.log(auxObject);

                            resp = void 0;

                            if (!_this43.orderDataShow.attributes.is_from_grabr_flag) {
                              _context26.next = 23;
                              break;
                            }

                            console.log("grabr");
                            _context26.next = 20;
                            return _this43.registerCostBuyingOrder(_this43.id, auxObject);

                          case 20:
                            resp = _context26.sent;
                            _context26.next = 35;
                            break;

                          case 23:
                            if (!_this43.orderDataShow.attributes.is_from_linio_flag) {
                              _context26.next = 30;
                              break;
                            }

                            console.log("linio");
                            _context26.next = 27;
                            return _this43.registerCostBuyingLinioOrder(_this43.id, auxObject);

                          case 27:
                            resp = _context26.sent;
                            _context26.next = 35;
                            break;

                          case 30:
                            if (!_this43.orderDataShow.attributes.is_from_meli_flag) {
                              _context26.next = 35;
                              break;
                            }

                            console.log("meli");
                            _context26.next = 34;
                            return _this43.registerCostBuyingMeliOrder(_this43.id, auxObject);

                          case 34:
                            resp = _context26.sent;

                          case 35:

                            if (resp) {
                              console.log("OK");

                              _this43.hideModalReevaluetion();
                              _this43.inicializeData(_this43.id, _this43.setData);
                            } else {
                              console.log("Error al registrar la data de evaluación");
                            }

                          case 36:
                          case "end":
                            return _context26.stop();
                        }
                      }
                    }, _callee26, _this43);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this43);
      }))();
    },
    ProcessService: function ProcessService(id) {
      console.log("process service");
      if (this.orderDataShow.attributes.is_from_grabr_flag && this.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag === 0) {
        console.log("Es una orden GRABR");
        this.confirmApprovedPurchaseOrder(id);
      } else if (this.orderDataShow.attributes.is_from_linio_flag && this.orderDataShow.attributes.linioOrder.attributes.confirmation_flag === 0) {
        console.log("Es una orden LINIOO");
        this.confirmApprovedLinioPurchaseOrder(id);
      } else if (this.orderDataShow.attributes.is_from_meli_flag && this.orderDataShow.attributes.meliOrder.attributes.confirmation_flag === 0) {
        console.log("Es una orden Meli");
        this.confirmApprovedMeliPurchaseOrder(id);
      }

      if (this.orderDataShow.attributes.is_from_grabr_flag && (this.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag === 1 || this.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag === 2) || !this.orderDataShow.attributes.is_from_grabr_flag && this.orderDataShow.attributes.status === 3) {
        console.log("Es una orden DIRECT");
        var idOrigin = this.orderDataShow.attributes.origin.id;
        this.listOperatorOrigin(idOrigin, this.getListOperators);
        if (this.orderDataShow.attributes.is_from_grabr_flag) {
          this.showNodalProcess();
        } else {
          this.showNodalProcessNoGrabr();
        }
      } else if (this.orderDataShow.attributes.is_from_linio_flag && (this.orderDataShow.attributes.linioOrder.attributes.confirmation_flag === 1 || this.orderDataShow.attributes.linioOrder.attributes.confirmation_flag === 2) || !this.orderDataShow.attributes.is_from_linio_flag && this.orderDataShow.attributes.status === 3) {
        var _idOrigin = this.orderDataShow.attributes.origin.id;
        this.listOperatorOrigin(_idOrigin, this.getListOperators);
        if (this.orderDataShow.attributes.is_from_linio_flag) {
          this.showNodalProcess();
        } else {
          this.showNodalProcessNoGrabr();
        }
      } else if (this.orderDataShow.attributes.is_from_meli_flag && (this.orderDataShow.attributes.meliOrder.attributes.confirmation_flag === 1 || this.orderDataShow.attributes.meliOrder.attributes.confirmation_flag === 2) || !this.orderDataShow.attributes.is_from_meli_flag && this.orderDataShow.attributes.status === 3) {
        var _idOrigin2 = this.orderDataShow.attributes.origin.id;
        this.listOperatorOrigin(_idOrigin2, this.getListOperators);
        if (this.orderDataShow.attributes.is_from_meli_flag) {
          this.showNodalProcess();
        } else {
          this.showNodalProcessNoGrabr();
        }
      }
    },
    sendProcess: function sendProcess(id) {
      var _this44 = this;

      this.sendProcessFlag = true;
      this.$validator.validate().then(function (result) {
        if (!result) {
          console.log("baaaad");

          return _this44.handleValidationErrorAdvanced();
        } else {
          console.log("PASSED VALIDATIONS FROM SENDPROCESS WITH ID: ".concat(id));

          if (_this44.orderDataShow.attributes.is_from_grabr_flag || _this44.orderDataShow.attributes.is_from_linio_flag || _this44.orderDataShow.attributes.is_from_meli_flag) {
            _this44.hideModalProcess();
          } else {
            _this44.hideModalProcessNoGrabr();
          }
          var auxObject = new Object();
          auxObject.shopping_order_number = _this44.finalBuyingCode;
          auxObject.tracking_number = _this44.numberTracking;
          auxObject.promised_origin_arrival_date = _this44.postingDate;
          auxObject.operator_id = _this44.operatorOrigin;
          if (_this44.otherCarrierName != "") {
            auxObject.carrier_name = _this44.otherCarrierName;
          } else {
            auxObject.carrier_name = _this44.carrier_list[_this44.carrier].name;
            auxObject.carrier_url = _this44.carrier_list[_this44.carrier].url;
          }

          if (_this44.orderDataShow.attributes.is_from_grabr_flag || _this44.orderDataShow.attributes.is_from_linio_flag || _this44.orderDataShow.attributes.is_from_meli_flag) {
            auxObject.real_purchase_link = _this44.finalBuyingLink;
          } else {
            auxObject.promised_delivery_date = _this44.sendingDate;
          }

          if (_this44.orderDataShow.attributes.is_from_grabr_flag) {
            _this44.completeDataToGrabrPurchaseOrder(_this44.id, auxObject);
          } else if (_this44.orderDataShow.attributes.is_from_linio_flag) {
            console.log("linio");
            _this44.completeDataToLinioPurchaseOrder(_this44.id, auxObject);
          } else if (_this44.orderDataShow.attributes.is_from_meli_flag) {
            console.log("meli");
            _this44.completeDataToMeliPurchaseOrder(_this44.id, auxObject);
          } else {
            _this44.completeDataToDirectPurchaseOrder(_this44.id, auxObject);
          }

          _this44.reinicialize_variables();
          _this44.inicializeData(_this44.id, _this44.setData);
        }
      });
    },
    setData: function setData(data) {
      var _this45 = this;

      console.log("set data oficial");
      console.log(data);

      this.orderDataShow = data;

      this.dotracking(this.orderDataShow.attributes.tracking_number);
      if (this.orderDataShow.attributes.is_from_grabr_flag && this.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked != null) {
        this.costGrabr = this.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked;
        console.log(this.costGrabr);
      } else if (this.orderDataShow.attributes.is_from_linio_flag && this.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked != null) {
        this.costGrabr = this.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked;
        console.log(this.costGrabr);
      } else if (this.orderDataShow.attributes.is_from_meli_flag && this.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked != null) {
        this.costGrabr = this.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked;
        console.log(this.costGrabr);
      }
      console.log("PASAMOS -1");

      if (this.orderDataShow.attributes.is_from_grabr_flag && this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked != null) {
        this.taxGrabr = parseFloat(this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked).toFixed(2);
        console.log(this.taxGrabr);
      } else if (this.orderDataShow.attributes.is_from_linio_flag && this.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked != null) {
        this.taxGrabr = parseFloat(this.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked).toFixed(2);
        console.log(this.taxGrabr);
      } else if (this.orderDataShow.attributes.is_from_meli_flag && this.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked != null) {
        this.taxGrabr = parseFloat(this.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked).toFixed(2);
        console.log(this.taxGrabr);
      }
      console.log("PASAMOS 0");

      if (this.orderDataShow.attributes.is_from_grabr_flag && this.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web != null) {
        this.shippingGrabr = this.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web;
        console.log(this.grabr_shipping_web);
      } else if (this.orderDataShow.attributes.is_from_linio_flag && this.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web != null) {
        this.shippingGrabr = this.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web;
        console.log(this.linio_shipping_web);
      } else if (this.orderDataShow.attributes.is_from_meli_flag && this.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web != null) {
        this.shippingGrabr = this.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web;
        console.log(this.meli_shipping_web);
      }
      console.log("PASAMOS 1");

      if (this.orderDataShow.attributes.real_price != null) {
        this.CostReal = this.orderDataShow.attributes.real_price;
      }
      if (this.orderDataShow.attributes.real_tax != null) {
        this.TaxReal = this.orderDataShow.attributes.real_tax;
      }
      if (this.orderDataShow.attributes.real_shipping != null) {
        this.shippingReal = this.orderDataShow.attributes.real_shipping;
      }

      if (this.orderDataShow.attributes.is_from_grabr_flag && this.orderDataShow.attributes.grabrOrder.attributes.reward_discount != null) {
        this.rewardFlag = true;
        this.rewardDiscount = this.orderDataShow.attributes.grabrOrder.attributes.reward_discount;
      } else if (this.orderDataShow.attributes.is_from_linio_flag && this.orderDataShow.attributes.linioOrder.attributes.reward_discount != null) {
        this.rewardFlag = true;
        this.rewardDiscount = this.orderDataShow.attributes.linioOrder.attributes.reward_discount;
      } else if (this.orderDataShow.attributes.is_from_meli_flag && this.orderDataShow.attributes.meliOrder.attributes.reward_discount != null) {
        this.rewardFlag = true;
        this.rewardDiscount = this.orderDataShow.attributes.meliOrder.attributes.reward_discount;
      }

      if (this.orderDataShow.attributes.weight != null) {
        this.weightGrabr = this.orderDataShow.attributes.weight;
      }

      if (this.orderDataShow.attributes.weight_unit_id != null) {
        this.unitWeight = this.orderDataShow.attributes.weight_unit;
      }

      if (this.orderDataShow.attributes.real_purchase_link != null) {
        this.finalBuyingLink = this.orderDataShow.attributes.real_purchase_link;
      }

      if (this.orderDataShow.attributes.promised_delivery_date != null) {
        this.sendingDate = this.orderDataShow.attributes.promised_delivery_date;
      }

      if (this.orderDataShow.attributes.shopping_order_number != null) {
        this.finalBuyingCode = this.orderDataShow.attributes.shopping_order_number;
      }
      if (this.orderDataShow.attributes.tracking_number != null) {
        this.numberTracking = this.orderDataShow.attributes.tracking_number;
      }
      if (this.orderDataShow.attributes.promised_origin_arrival_date != null) {
        this.postingDate = this.orderDataShow.attributes.promised_origin_arrival_date;
      }

      if (this.orderDataShow.attributes.sender_operator_id != null) {
        this.operatorOrigin = this.orderDataShow.attributes.sender_operator_id;
      }
      console.log("PASAMOS 2");

      if (this.orderDataShow.attributes.carrier_name != null) {
        var taken = false;
        this.carrier_list.forEach(function (carrier, index) {
          if (carrier.name == _this45.orderDataShow.attributes.carrier_name) {
            _this45.otherCarrierFlag = false;
            _this45.carrier = index;
            taken = true;
          }
        });

        if (!taken) {
          console.log("no taken");
          console.log(this.orderDataShow.attributes.carrier_name);

          this.otherCarrierFlag = true;
          this.otherCarrierName = this.orderDataShow.attributes.carrier_name;
          console.log(this.otherCarrierName);
        }
      }

      console.log("PASAMOS 3");
      this.calculateSkuUrl();
      try {
        this.packageRepositions = this.orderDataShow.attributes.reposition.attributes.package_repositions;
      } catch (error) {
        this.packageRepositions = [];
      }
      this.listUnitWeight(this.getListUnits);
      this.listOperatorOrigin(this.orderDataShow.attributes.origin.id, this.getListOperators);
      this.activeRoute = "Orden Nro.# " + this.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number;
      console.log("NUMBER TRACKING");
      console.log(this.numberTracking);
    },
    confirmPendientOrder: function confirmPendientOrder() {
      var _this46 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                console.log("Vamos a confirmar el pago");

                _context28.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_orders_service__["a" /* ordersService */].updateBuyingOrderNoGrabr(_this46.orderDataShow.attributes.order_code, { payed: 3 });

              case 3:
                response = _context28.sent;

                console.log(response);
                if (response) {
                  _this46.inicializeData(_this46.id, _this46.setData);
                } else {
                  alert("Service fail");
                }

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this46);
      }))();
    },
    getListUnits: function getListUnits(data) {
      this.listUnits = data;
      console.log(this.listUnits, "listUnits");

      this.listUnits.forEach(function (unit) {});
    },
    getListOperators: function getListOperators(data) {
      this.listOperators = data;
    },
    backPage: function backPage() {
      this.$router.go(-1);
    },
    hideModalValidation: function hideModalValidation() {
      this.$refs.validacionmodal.hide();
    },
    hideCancelValidation: function hideCancelValidation() {
      this.$refs.cancelOrdermodal.hide();
    },
    hideModalAuthorizeReposition: function hideModalAuthorizeReposition() {
      this.$refs.modalAuthorizeReposition.hide();
    },
    hideModalReevaluetion: function hideModalReevaluetion() {
      this.$refs.modalReevaluation.hide();
    },
    hideModalProcess: function hideModalProcess() {
      this.$refs.modalProcess.hide();
    },
    hideModalProcessNoGrabr: function hideModalProcessNoGrabr() {
      this.$refs.modalProcessNoGrabr.hide();
    },
    hideModalConfirmationReposition: function hideModalConfirmationReposition() {
      this.$refs.modalConfirmationReposition.hide();
    },
    showNodalProcess: function showNodalProcess() {
      this.$refs.modalProcess.show();
    },
    showNodalProcessNoGrabr: function showNodalProcessNoGrabr() {
      this.$refs.modalProcessNoGrabr.show();
    },
    hideModalConfirmation: function hideModalConfirmation() {
      this.$refs.modalConfirmation.hide();
    },
    showModalConfirmation: function showModalConfirmation() {
      this.$refs.modalConfirmation.show();
    },
    showModalConfirmationDelete: function showModalConfirmationDelete() {
      this.$refs.modalConfirmationDelete.show();
    },
    hideModalConfirmationDelete: function hideModalConfirmationDelete() {
      this.$refs.modalConfirmationDelete.hide();
    },
    registerCostBuyingOrder: function registerCostBuyingOrder(id, data) {
      var _this47 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
        var url, resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/register-cost-grabr-info";
                _context29.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
                  if (response.data.status) {
                    _this47.orderDataShow = response.data.body;
                    _this47.$refs.validacionmodal.show();
                    return true;
                  } else {
                    console.log("Algo raro paso");
                    return false;
                  }
                }).catch(function (error) {
                  console.log(error.response);
                  return false;
                });

              case 3:
                resp = _context29.sent;
                return _context29.abrupt("return", resp);

              case 5:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this47);
      }))();
    },
    registerCostBuyingLinioOrder: function registerCostBuyingLinioOrder(id, data) {
      var _this48 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30() {
        var url, resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/register-cost-linio-info";

                console.log(url);
                console.log(data);
                _context30.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
                  if (response.data.status) {
                    console.log("Exito");
                    console.log(response.data);

                    _this48.$refs.validacionmodal.show();
                    return true;
                  } else {
                    console.log("Algo raro paso");
                    return false;
                  }
                }).catch(function (error) {
                  console.log(error.response);
                  return false;
                });

              case 5:
                resp = _context30.sent;
                return _context30.abrupt("return", resp);

              case 7:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this48);
      }))();
    },
    registerCostBuyingMeliOrder: function registerCostBuyingMeliOrder(id, data) {
      var _this49 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31() {
        var url, resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/register-cost-meli-info";

                console.log(url);
                console.log(data);
                _context31.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
                  if (response.data.status) {
                    console.log("Exito");
                    console.log(response.data);

                    _this49.$refs.validacionmodal.show();
                    return true;
                  } else {
                    console.log("Algo raro paso");
                    return false;
                  }
                }).catch(function (error) {
                  console.log(error.response);
                  return false;
                });

              case 5:
                resp = _context31.sent;
                return _context31.abrupt("return", resp);

              case 7:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this49);
      }))();
    },
    completeDataToDirectPurchaseOrder: function completeDataToDirectPurchaseOrder(id, data) {
      var _this50 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/complete-final-info-no-grabr";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          console.log("success");
          console.log(response.data.body);
          console.log("-----------------------");

          _this50.orderDataShow = response.data.body;
          _this50.$refs.validacionmodal.show();
          console.log(_this50.orderDataShow);
          console.log("validacion modal");
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
      });
    },
    completeDataToGrabrPurchaseOrder: function completeDataToGrabrPurchaseOrder(id, data) {
      var _this51 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/complete-final-info-grabr";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          _this51.orderDataShow = response.data.body;
          _this51.$refs.validacionmodal.show();
          console.log(_this51.orderDataShow);
          console.log("validacion modal");
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
      });
    },
    completeDataToLinioPurchaseOrder: function completeDataToLinioPurchaseOrder(id, data) {
      var _this52 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/complete-final-info-linio";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          _this52.orderDataShow = response.data.body;
          _this52.$refs.validacionmodal.show();
          console.log(_this52.orderDataShow);
          console.log("validacion modal");
          _this52.hideModalProcessNoGrabr();
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
      });
    },
    completeDataToMeliPurchaseOrder: function completeDataToMeliPurchaseOrder(id, data) {
      var _this53 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/complete-final-info-meli";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          _this53.orderDataShow = response.data.body;
          _this53.calculateSkuUrl();
          _this53.$refs.validacionmodal.show();
          console.log(_this53.orderDataShow);
          console.log("validacion modal");
          _this53.hideModalProcessNoGrabr();
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
      });
    },
    confirmApprovedPurchaseOrder: function confirmApprovedPurchaseOrder(id) {
      var _this54 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/confirm-approved-flag";
      var data = new Object();
      data.confirmation_flag = 1;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          console.log("ok");
          console.log(response.data);

          _this54.orderDataShow = response.data.body;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    confirmApprovedLinioPurchaseOrder: function confirmApprovedLinioPurchaseOrder(id) {
      var _this55 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/confirm-linio-approved-flag";
      var data = new Object();
      data.confirmation_flag = 1;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          console.log("ok");
          console.log(response.data);
          _this55.orderDataShow = response.data.body;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    confirmApprovedMeliPurchaseOrder: function confirmApprovedMeliPurchaseOrder(id) {
      var _this56 = this;

      var url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/confirm-meli-approved-flag";
      var data = new Object();
      data.confirmation_flag = 1;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          console.log("ok");
          _this56.orderDataShow = response.data.body;
          _this56.calculateSkuUrl();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    cancelatePurchaseOrder: function cancelatePurchaseOrder(id) {
      var _this57 = this;

      this.hideModalConfirmation();
      var status = this.orderDataShow.attributes.status;
      var url = void 0,
          data = void 0;
      if (status == 2) {
        console.log("Va a cancelar desconfirmando el confirmed approved flag");

        url = "https://backendbutiko.com" + "/api/purchaseOrder/" + id + "/confirm-approved-flag";
        data = new Object();
        data.confirmation_flag = 2;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, data).then(function (response) {
          if (response.data.status) {
            console.log(response.data);

            _this57.$refs.cancelOrdermodal.show();
            _this57.inicializeData(_this57.id, _this57.setData);
          }
        }).catch(function (error) {
          console.log(error);
          console.log(error.response);
          console.log(error.response.data);
        });
      } else if (status <= 7 && status != 2) {
        console.log("Va a cancelar directo");

        url = "https://backendbutiko.com" + "/api/purchaseOrder/cancel/" + id;
        data = new Object();
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, data).then(function (response) {
          if (response.data.status) {
            console.log(response.data);

            _this57.$refs.cancelOrdermodal.show();
            _this57.inicializeData(_this57.id, _this57.setData);
          }
        }).catch(function (error) {
          console.log(error);
          console.log(error.response);
        });
      } else {
        alert("Esta en un estado en el que no debería poder cancelar");
        return;
      }

      this.cancellationComment();
    },
    deletePurchaseOrder: function deletePurchaseOrder(id) {
      var _this58 = this;

      var url = "";
      var hardStatus = 1;
      url = "https://backendbutiko.com" + "/api/purchaseOrder/delete/" + id + "?hard=1";
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url).then(function (response) {
        console.log("orden elimnada");
        _this58.$router.push("/orders");
      }).catch(function (error) {
        console.log("Error al eliminar");
      });
    },
    cancellationComment: function cancellationComment() {

      this.currentContent = "Orden cancelada por " + this.$store.state.user.attributes.profile.attributes.name + " " + this.$store.state.user.attributes.profile.attributes.surnames + " (" + (this.$store.state.user.attributes.profile.attributes.userable_type == "admin" ? "Administrador general" : this.$store.state.user.attributes.profile.attributes.userable_type == "client" ? "Cliente" : this.$store.state.user.attributes.operator_type == 1 ? "Operador de envío" : "Operador de recepción") + ") con fecha y hora ";

      console.log(this.currentContent);

      var currentDateTime = new Date();
      console.log(currentDateTime);

      this.currentContent = this.currentContent + __WEBPACK_IMPORTED_MODULE_13_moment___default()(String(currentDateTime)).format("DD/MM/YYYY - HH:mm");
      console.log(this.currentContent);
      this.createComment(1);
    },
    toTrackingView: function toTrackingView(data) {
      console.log(data);
      this.$router.push({
        name: "show-tracking-order",
        params: {
          id: data.id,
          orderData: data
        }
      });
    },
    validar: function validar() {
      console.log(this.postingDate);
      console.log(this.sendingDate);
      if (this.postingDate == this.sendingDate || this.postingDate > this.sendingDate) {
        console.log("Son fechas iguales");
      }
    },
    resetImpuestoWeb: function resetImpuestoWeb() {
      this.taxGrabr = "";
    },
    resetImpuestoReal: function resetImpuestoReal() {
      this.TaxReal = "";
    },
    cambiarReward: function cambiarReward() {
      if (this.rewardFlag) {
        this.rewardDiscount = "";
        this.TaxReal = Number(Math.round(parseFloat(0.07 * parseFloat(this.CostReal)) + "e2") + "e-2").toFixed(2).toString();
      }
    },
    calculateSkuUrl: function calculateSkuUrl() {
      var sku = "";
      var publication_code_link = "";
      var hasshipping = true;
      if (this.orderDataShow.attributes.is_from_meli_flag) {
        sku = this.orderDataShow.attributes.meliOrder.attributes.seller_sku;
        var pub = this.orderDataShow.attributes.meliOrder.attributes.publication_code;
        publication_code_link = "https://articulo.mercadolibre.com.pe/" + pub.substr(0, 3) + "-" + pub.substr(3) + "-_JM";
        this.orderDataShow.attributes.meliOrder.attributes.publication_code_link = publication_code_link;
        if (this.orderDataShow.attributes.meliOrder.attributes.shipping_id == null) {
          hasshipping = false;
        }
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        sku = this.orderDataShow.attributes.linioOrder.attributes.seller_sku;
      } else {
        sku = null;
      }
      this.orderDataShow.attributes.sku = sku;
      this.orderDataShow.attributes.hasshipping = hasshipping;
      if (sku != null) {
        if (sku.search("DELETED") != -1) {
          sku = sku.split("_")[0];
          this.orderDataShow.attributes.linksku = "#";
        } else if (sku.search("Z-") == 0) {
          this.orderDataShow.attributes.linksku = "https://www.zappos.com/product/" + sku.split("-")[1];
        } else if (sku.search("-REG") != -1 || sku.search("-GREY") != -1 || sku.search("-USA") != -1) {
          this.orderDataShow.attributes.linksku = "https://www.bhphotovideo.com/c/product/" + sku;
        } else if (sku.length == 7) {
          this.orderDataShow.attributes.linksku = "https://www.6pm.com/product/" + sku;
        } else if (sku.length == 10) {
          this.orderDataShow.attributes.linksku = "https://www.amazon.com/dp/" + sku;
        } else if (sku.length == 12) {
          this.orderDataShow.attributes.linksku = "https://www.ebay.com/itm/" + sku;
        } else {
          var letters = "abcdefghyjklmnñopqrstuvwxyz";
          var found;
          for (i = 0; i < sku.length; i++) {
            if (letters.indexOf(sku.charAt(i), 0) != -1) found = true;
          }
          this.orderDataShow.attributes.linksku = found ? "https://www.nike.com/t/" + sku : "https://www.footlocker.com/product/~/" + sku;
        }
      }
    }
  },
  computed: {
    servicioReturn: function servicioReturn() {
      var foundReturn = this.orderDataShow.attributes.services.find(function (element) {
        return element.name === "Return";
      });
      if (foundReturn) {
        return true;
      } else {
        return false;
      }
    },
    servicioReview: function servicioReview() {
      var foundReview = this.orderDataShow.attributes.services.find(function (element) {
        return element.name === "Review";
      });
      if (foundReview) {
        return true;
      } else {
        return false;
      }
    },
    servicioCheckup: function servicioCheckup() {
      var foundCheckup = this.orderDataShow.attributes.services.find(function (element) {
        return element.name === "Checkup";
      });
      if (foundCheckup) {
        return true;
      } else {
        return false;
      }
    },
    noGravado: function noGravado() {
      var precioProducto = this.orderDataShow.attributes.real_price * this.orderDataShow.attributes.product_specimens;
      var shipping = this.orderDataShow.attributes.real_shipping;
      var tax = this.orderDataShow.attributes.real_tax;
      var warehouse = this.orderDataShow.attributes.warehouse;
      var flete = this.orderDataShow.attributes.flete_cost;
      var valorem = this.orderDataShow.attributes.ad_valorem;
      var igv = this.orderDataShow.attributes.igv;
      var ipm = this.orderDataShow.attributes.ipm;

      if (this.orderDataShow.attributes.direct_type === 2) {
        var rstlNogravado1 = 0.0;
        if (this.orderDataShow.attributes.services.length === 0) {
          rstlNogravado1 = precioProducto + shipping + tax + warehouse + flete + valorem + igv + ipm;
        } else {
          var totalServices = 0.0;

          this.orderDataShow.attributes.services.forEach(function (data) {
            totalServices = totalServices + data.pivot.amount;
          });

          rstlNogravado1 = precioProducto + shipping + tax + warehouse + flete + valorem + igv + ipm + totalServices;
        }

        rstlNogravado1 = Math.ceil(100 * rstlNogravado1) / 100;
        return rstlNogravado1;
      } else {
        var rstlNogravado2 = warehouse + flete + valorem + igv + ipm;
        rstlNogravado2 = Math.ceil(100 * rstlNogravado2) / 100;
        return rstlNogravado2;
      }
    },
    gravado: function gravado() {
      var tramiteAduanero = this.orderDataShow.attributes.tramite_aduanero;
      var envio = this.orderDataShow.attributes.national_shipping;
      if (this.orderDataShow.attributes.coupon_discount !== null) {
        var rstlgravado = (tramiteAduanero + envio + this.orderDataShow.attributes.coupon_discount) / 1.18;
        rstlgravado = Math.ceil(100 * rstlgravado) / 100;
        return rstlgravado;
      } else {
        var rstlgravado2 = (tramiteAduanero + envio) / 1.18;
        rstlgravado2 = Math.ceil(100 * rstlgravado2) / 100;
        return rstlgravado2;
      }
    },
    totalIgv: function totalIgv() {
      var tramiteAduanero = this.orderDataShow.attributes.tramite_aduanero;
      var envio = this.orderDataShow.attributes.national_shipping;
      if (this.orderDataShow.attributes.coupon_discount !== null) {
        var rsligv = tramiteAduanero + envio + this.orderDataShow.attributes.coupon_discount - this.gravado;
        rsligv = Math.ceil(100 * rsligv) / 100;
        return rsligv;
      } else {
        var rsligv2 = tramiteAduanero + envio - this.gravado;
        rsligv2 = Math.ceil(100 * rsligv2) / 100;
        return rsligv2;
      }
    },
    totalPrice: function totalPrice() {
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        return this.orderDataShow.attributes.grabrOrder.attributes.grabr_price + this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + this.orderDataShow.attributes.grabrOrder.attributes.grabr_fee;
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        return this.orderDataShow.attributes.linioOrder.attributes.linio_price;
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        return this.orderDataShow.attributes.meliOrder.attributes.meli_price;
      } else {
        return this.orderDataShow.attributes.client_flete_cost + this.orderDataShow.attributes.client_arancel_cost + this.orderDataShow.attributes.real_price * this.orderDataShow.attributes.product_specimens + this.orderDataShow.attributes.payment_method_cost;
      }
    },
    isDirect: function isDirect() {
      return !this.orderDataShow.attributes.is_from_grabr_flag && !this.orderDataShow.attributes.is_from_linio_flag && !this.orderDataShow.attributes.is_from_meli_flag;
    },
    readyToSaveIncompleteData: function readyToSaveIncompleteData() {
      if (this.finalBuyingLink != "" || this.finalBuyingCode != "" || this.otherCarrierName != "" || this.carrier != "" || this.numberTracking != "" || this.postingDate != "" || this.operatorOrigin != "" || !this.orderDataShow.attributes.is_from_grabr_flag && this.sendingDate != "") {
        return true;
      }
      return false;
    },
    readyToProcessIncompleteData: function readyToProcessIncompleteData() {
      console.log(this.otherCarrierName != "" || this.carrier != "");

      if (this.orderDataShow.attributes.is_from_grabr_flag && this.finalBuyingLink != "" && this.finalBuyingCode != "" && (this.otherCarrierName != "" || this.carrier !== "") && this.numberTracking != "" && this.postingDate != "" && this.operatorOrigin != "" || !this.orderDataShow.attributes.is_from_grabr_flag && this.sendingDate != "" && this.finalBuyingCode != "" && (this.otherCarrierName !== "" || this.carrier !== "") && this.numberTracking != "" && this.postingDate != "" && this.operatorOrigin != "") {
        return true;
      }
      return false;
    },
    debitCalculated: function debitCalculated() {
      console.log("Estamos en calculate debit");
      var costGrabr = void 0,
          taxGrabr = void 0,
          shippingGrabr = void 0;
      if (this.costGrabr == "") costGrabr = 0;else costGrabr = parseFloat(this.costGrabr);

      if (this.taxGrabr == "") taxGrabr = 0;else taxGrabr = parseFloat(this.taxGrabr);

      if (this.shippingGrabr == "") shippingGrabr = 0;else shippingGrabr = parseFloat(this.shippingGrabr);

      console.log("Precio de la web: ");
      console.log(costGrabr);
      console.log("Impuesto de la web: ");
      console.log(taxGrabr);
      console.log("Costo de envío de la web");
      console.log(shippingGrabr);

      var subtotal1 = void 0,
          subtotal2 = void 0;
      subtotal1 = 0;
      subtotal2 = 0;
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        console.log("Precio Grabr");
        console.log(this.orderDataShow.attributes.grabrOrder.attributes.grabr_price);

        console.log("Impuesto Grabr");
        console.log(this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax);

        subtotal1 = this.orderDataShow.attributes.grabrOrder.attributes.grabr_price <= costGrabr ? costGrabr - this.orderDataShow.attributes.grabrOrder.attributes.grabr_price : 0;
        console.log(subtotal1);

        subtotal2 = this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax <= taxGrabr ? taxGrabr - this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax : 0;
        console.log(subtotal2);
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        console.log("Precio Linio");
        console.log(this.orderDataShow.attributes.linioOrder.attributes.linio_price);

        subtotal1 = this.orderDataShow.attributes.linioOrder.attributes.linio_price <= costGrabr ? costGrabr - this.orderDataShow.attributes.linioOrder.attributes.linio_price : 0;
        console.log(subtotal1);

        subtotal2 = taxGrabr;
        console.log(subtotal2);
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        console.log("Precio meli");
        console.log(this.orderDataShow.attributes.meliOrder.attributes.meli_price);

        subtotal1 = this.orderDataShow.attributes.meliOrder.attributes.meli_price <= costGrabr ? costGrabr - this.orderDataShow.attributes.meliOrder.attributes.meli_price : 0;
        console.log(subtotal1);

        subtotal2 = taxGrabr;
        console.log(subtotal2);
      }

      return parseFloat(subtotal1) + parseFloat(subtotal2) + parseFloat(shippingGrabr);
    },
    formatPostingDate: function formatPostingDate() {
      if (!this.postingDate) return "2000-01-01";
      var postingDate2 = new Date(this.postingDate);
      console.log("Habia postingDate: ".concat(postingDate2));
      var formatted_month = ("0" + (postingDate2.getMonth() + 1)).slice(-2);
      var formatted_day = ("0" + (postingDate2.getDate() + 1)).slice(-2);
      var formatted_date = postingDate2.getFullYear() + "-" + formatted_month + "-" + formatted_day;
      console.log("Formatted date: ".concat(formatted_date));
      return formatted_date;
    },
    formatSendingDate: function formatSendingDate() {
      if (!this.sendingDate) return "2000-01-01";
      var sendingDate2 = new Date(this.sendingDate);
      console.log("Habia postingDate: ".concat(sendingDate2));
      var formatted_month = ("0" + (sendingDate2.getMonth() + 1)).slice(-2);
      var formatted_day = ("0" + (sendingDate2.getDate() + 1)).slice(-2);
      var formatted_date = sendingDate2.getFullYear() + "-" + formatted_month + "-" + formatted_day;
      console.log("Formatted date: ".concat(formatted_date));
      return formatted_date;
    },

    packagedRealValue: function packagedRealValue() {
      var packagedAux = this.orderDataShow.attributes.packaged;
      console.log("estoy en computed");

      if (packagedAux == null) {
        return 1;
      } else if (packagedAux == 1) {
        return 2;
      } else {
        return 3;
      }
    },

    repositionAuthorizedFlag: function repositionAuthorizedFlag() {
      try {
        return this.orderDataShow.attributes.reposition.attributes.authorized;
      } catch (error) {
        return null;
      }
    },

    noEvaluationFlag: function noEvaluationFlag() {
      var flag = false;
      if (this.orderDataShow.attributes.status != 1) return false;
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        flag = this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax == null || this.orderDataShow.attributes.grabrOrder.attributes.grabr_fee == null || this.orderDataShow.attributes.origin_id == null || this.orderDataShow.attributes.destination_id == null;
      } else if (this.orderDataShow.attributes.is_from_linio_flag || this.orderDataShow.attributes.is_from_meli_flag) {
        flag = this.orderDataShow.attributes.origin_id == null || this.orderDataShow.attributes.destination_id == null;
      }
      return flag;
    },

    totalMeli: function totalMeli() {
      return this.totalPrice + this.orderDataShow.attributes.meliOrder.attributes.rebate;
    },
    totalCommissions: function totalCommissions() {
      return 0.09 * this.totalPrice + 0.09 * this.orderDataShow.attributes.meliOrder.attributes.rebate;
    },
    totalNeto: function totalNeto() {
      return this.totalMeli - this.totalCommissions;
    }
  },
  watch: {
    orderDataShow: function orderDataShow(newval) {
      this.pagosStatus = newval.attributes.payed;
      this.trakingStatus = newval.attributes.order_tracking_details[this.orderDataShow.attributes.order_tracking_details.length - 1].attributes.status;
    },

    otherCarrierFlag: function otherCarrierFlag(newFlag) {
      console.log("estamos cambiando de valor");
      if (!newFlag) this.otherCarrierName = "";
      if (newFlag) this.carrier = "";
    }
  }
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_form_1_create_shipment__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_form_1_create_shipment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_form_1_create_shipment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_form_2_create_shipment__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_form_2_create_shipment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_form_2_create_shipment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_form_3_create_shipment__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_form_3_create_shipment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_form_3_create_shipment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prefab_elements_form_4_create_shipment__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prefab_elements_form_4_create_shipment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_prefab_elements_form_4_create_shipment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_shipment_service__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_prefab_structures_breadcrumb_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    form1: __WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_form_1_create_shipment___default.a,
    form2: __WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_form_2_create_shipment___default.a,
    form3: __WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_form_3_create_shipment___default.a,
    form4: __WEBPACK_IMPORTED_MODULE_5__components_prefab_elements_form_4_create_shipment___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_7__components_prefab_structures_breadcrumb_vue___default.a
  },
  props: ['idShipment'],
  data: function data() {
    return {
      state1: 1,
      state2: 0,
      state3: 0,
      state4: 0,
      saveOk: false,
      totalWeightLb: null,
      idOperator: '',
      dataOriginal: null,
      dataLocal: {
        dataShipment: {
          status: false,
          description: 'qwerty',
          departure_date: '2019-05-12',
          arrival_date: '2019-06-15',
          destination_id: 22,
          creator_operator_id: 52,
          reciever_operator_id: 202
        },
        dataLuggage: { status: true },
        dataOrder: { status: true }
      },

      nameSection: 'Crear embarque',
      listRoutes: [{ nameRoute: 'shipments-list', titleRoute: 'Embarques' }, { nameRoute: 'shipments-create', titleRoute: 'Crear embarque' }]
    };
  },
  created: function created() {
    window.addEventListener('beforeunload', this.setWindowListener);
    this.fetchData();
  },

  methods: {
    setSaveOk: function setSaveOk(flag) {
      this.saveOk = flag;
    },
    setWindowListener: function setWindowListener(event) {
      console.log('Estamos en setWindoesListener');
      if (this.onCreateBasicBoarding) {

        event.returnValue = 'Write something';
      }
    },
    fetchData: function fetchData() {
      this.idOperator = this.$store.state.user.id;

      if (this.idShipment) {
        this.state1 = 1;
        this.state2 = 0;
        this.state3 = 0;
        this.state4 = 0;

        __WEBPACK_IMPORTED_MODULE_6__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(parseInt(this.idShipment), this.getDataOriginal);
      } else {
        this.parseDataOriginal();
      }
    },
    changeFormView: function changeFormView(event) {
      if (event == 1) {
        this.state1 = 1;
        this.state2 = 0;
        this.state3 = 0;
        this.state4 = 0;
      } else if (event == 2) {
        this.state1 = 2;
        this.state2 = 1;
        this.state3 = 0;
        this.state4 = 0;
      } else if (event == 3) {
        this.state1 = 2;
        this.state2 = 2;
        this.state3 = 1;
        this.state4 = 0;
      } else if (event == 4) {
        this.state1 = 2;
        this.state2 = 2;
        this.state3 = 2;
        this.state4 = 1;
      }
    },
    toSecondForm: function toSecondForm(dataCopy, dataOriginal) {
      if (dataCopy.status) {
        this.dataLocal.dataShipment = dataCopy;
        if (dataOriginal) {
          this.dataOriginal = dataOriginal;
        }

        this.$router.push({
          name: 'shipments-edit',
          params: { id: dataOriginal.id }
        });
        __WEBPACK_IMPORTED_MODULE_6__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(parseInt(dataOriginal.id), this.getDataOriginal);
      }
    },
    toThirdForm: function toThirdForm(dataCopy) {
      if (dataCopy.status) {
        this.dataLocal.dataLuggage = dataCopy;
        this.changeFormView(3);
      }
    },
    toSendForm: function toSendForm(flag) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id, aux;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _this.idShipment;

                if (!id) {
                  id = _this.dataOriginal.id;
                }

                if (!flag) {
                  _context.next = 11;
                  break;
                }

                aux = void 0;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_shipment_service__["a" /* shipmentService */].changeStateShipment(id, 'true');

              case 6:
                aux = _context.sent;

                if (aux) {
                  _context.next = 10;
                  break;
                }

                alert('error al cambiar de estado');
                return _context.abrupt('return');

              case 10:
                if (aux.attributes.status == 2) {
                  _this.$router.push({ name: 'shipments-show', params: { id: id } });
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateTotalWeight: function updateTotalWeight(total) {
      this.totalWeightLb = total;
    },
    updateListLuggage: function updateListLuggage(itemLuggage) {
      if (itemLuggage) {
        this.dataOriginal.attributes.luggage_items.push(itemLuggage);
        this.parseDataOriginal();
      }
    },
    getDataOriginal: function getDataOriginal(data) {
      console.log('Método: getDataOriginal y obtuvimos estos datos del embarque');
      console.log(data);
      this.dataOriginal = data;
      this.parseDataOriginal();
    },
    gotoForm4: function gotoForm4() {
      this.changeFormView(4);
    },
    packagesSaved: function packagesSaved() {
      console.log('Se guardaron los paquetes refrescamos todo el componente');
      this.fetchData();

      this.changeFormView(3);
    },
    parseDataOriginal: function parseDataOriginal() {
      var _this2 = this;

      if (this.dataOriginal) {
        this.dataLocal = new Object();
        this.dataLocal.dataShipment = new Object();
        this.dataLocal.dataShipment.status = true;
        this.dataLocal.dataShipment.description = this.dataOriginal.attributes.description;
        this.dataLocal.dataShipment.departure_date = this.dataOriginal.attributes.departure_date;
        this.dataLocal.dataShipment.arrival_date = this.dataOriginal.attributes.arrival_date;
        this.dataLocal.dataShipment.destination_id = this.dataOriginal.attributes.destination_id;
        this.dataLocal.dataShipment.destination = this.dataOriginal.attributes.destination;
        this.dataLocal.dataShipment.creator_operator_id = this.dataOriginal.attributes.creator_operator_id;
        this.dataLocal.dataShipment.creator_operator = this.dataOriginal.attributes.creator_operator;
        this.dataLocal.dataShipment.reciever_operator_id = this.dataOriginal.attributes.reciever_operator_id;
        this.dataLocal.dataShipment.reciever_operator = this.dataOriginal.attributes.reciever_operator;

        if (this.dataOriginal.attributes.luggage_items != null && this.dataOriginal.attributes.luggage_items.length) {
          this.dataLocal.dataLuggage = new Object();
          this.dataLocal.dataLuggage.status = true;
          this.dataLocal.dataLuggage.luggage_items = this.dataOriginal.attributes.luggage_items;
        } else {
          this.dataLocal.dataLuggage = new Object();
          this.dataLocal.dataLuggage.status = false;
          this.dataLocal.dataLuggage.luggage_items = [];
        }

        if (this.dataOriginal.attributes.packages != null && this.dataOriginal.attributes.packages.length) {
          this.dataLocal.dataOrder = new Object();
          this.dataLocal.dataOrder.status = true;
          this.dataLocal.dataOrder.packages = this.dataOriginal.attributes.packages;
          console.log(this.dataLocal.dataOrder.packages);
          this.totalWeightLb = 0;
          this.dataLocal.dataOrder.packages.forEach(function (pack) {
            console.log(pack.attributes.partial_weigth);
            _this2.totalWeightLb += pack.attributes.partial_weight;
          });
          this.dataLocal.dataLuggage.luggage_items.forEach(function (pack) {
            console.log(pack.attributes.weight);
            _this2.totalWeightLb += pack.attributes.weight;
          });

          console.log(this.totalWeightLb);
          console.log("***************************");
        } else {
          this.dataLocal.dataOrder = new Object();
          this.dataLocal.dataOrder.status = false;
          this.dataLocal.dataOrder.packages = [];
        }
      } else {
        this.dataOriginal = 'waiting';
        this.dataLocal = {
          dataShipment: {
            status: false,
            creator_operator_id: this.idOperator
          },
          dataLuggage: {
            status: false
          },
          dataOrder: {
            status: false
          }
        };
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('beforeunload', this.setWindowListener);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var askFlag = true;
    if (document.readyState == 'loading') {
      askFlag = false;
    } else if (document.readyState == 'complete') {
      askFlag = !this.saveOk;
    }

    if (askFlag && this.onCreateBasicBoarding) {
      var answer = window.confirm('No se han guardado los cambios, ¿está seguro de salir?');
      if (answer) {
        next();
        return;
      } else {
        next(false);
        return;
      }
    }
    next();
  },

  computed: {
    onCreateBasicBoarding: function onCreateBasicBoarding() {
      return !this.dataLocal.dataShipment.status && this.state1 == 1 && this.state2 == 0 && this.state3 == 0 && this.state4 == 0;
    }
  }
});

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_evaluate_orders_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_evaluate_orders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_evaluate_orders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__ = __webpack_require__(71);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    cardDetailLuggage: __WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue___default.a,
    cardEvaluateOrders: __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_evaluate_orders_vue___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue___default.a
  },
  props: ['id'],
  data: function data() {
    return {
      dataShipment: null,
      dataLuggageCopy: [],
      dataOrderCopy: [],

      nameSection: 'Visualizar embarque',
      listRoutes: [{ nameRoute: 'shipments-list', titleRoute: 'Embarques' }, { nameRoute: 'shipments-evaluate-package', titleRoute: 'Evaluación de embarque' }]
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(this.id, this.getDataShipment);
  },

  methods: {
    getDataShipment: function getDataShipment(data) {
      this.dataShipment = data;
      this.dataLuggageCopy = this.dataShipment.attributes.luggage_items;
      this.dataOrderCopy = this.dataShipment.attributes.packages;
    },
    endEvaluationPackages: function endEvaluationPackages() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var aux;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aux = void 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].changeStateShipment(_this.id, 'true');

              case 3:
                aux = _context.sent;

                if (aux) {
                  _context.next = 9;
                  break;
                }

                alert("error al cambiar de estado");
                return _context.abrupt("return");

              case 9:
                _this.$router.push({ name: 'shipments-show', params: { id: _this.id } });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateData: function updateData(state) {
      if (state) {
        __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(this.id, this.getDataShipment);
      }
    },
    hideModalConfirmation: function hideModalConfirmation() {
      this.$refs.modalConfirmation.hide();
    },
    showModalConfirmation: function showModalConfirmation() {
      this.$refs.modalConfirmation.show();
    }
  },
  computed: {
    readyToFinish: function readyToFinish() {
      var flag = true;
      if (this.dataShipment.attributes.status == 6) {
        for (var i = 0; i < this.dataOrderCopy.length; i++) {
          flag = flag && this.dataOrderCopy[i].attributes.evaluated == 1;
          if (!flag) break;
        }
      } else {
        flag = false;
      }

      return flag;
    }
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_1__DataTable_vue___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_2__Pagination_vue___default.a, breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_prefab_structures_breadcrumb_vue___default.a },
  created: function created() {
    if (this.purchaseOrders == null) {
      this.is_loading = true;
    }
    this.getBoardings();
  },
  data: function data() {
    var statusGroupArray = {
      1: 'Todos',
      10: 'Procesamiento en origen',
      20: 'Procesamiento en destino',
      30: 'Stand-by'
    };
    var boardingStatusArray = {
      1: 'En dirección origen',
      2: 'Camino a aeropuerto',
      3: 'Vuelo al destino en curso',
      4: 'Stand-by',
      5: 'En aeropuerto del destino',
      6: 'En evaluación',
      7: 'Evaluación finalizada'
    };

    var sortOrders = {};
    var columns = [{ label: 'ID Embarque', name: 'id', visible: true }, { label: 'Destino', name: 'destination', visible: true }, { label: 'Fecha de salida', name: 'departure_date', visible: true }, { label: 'Fecha de llegada', name: 'arrival_date', visible: true }, { label: 'Estado', name: 'status', visible: true }, {
      label: 'Última actualización',
      name: 'updated_at',
      visible: true
    }, { label: 'Detalles', name: 'detail', visible: true }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });
    return {
      boardings: null,
      columns: columns,
      statusGroupArray: statusGroupArray,
      boardingStatusArray: boardingStatusArray,

      sortKey: 'updated_at',
      sortOrders: sortOrders,
      filterKey: '',
      tableData: {
        draw: 0,
        length: 10,
        status: 1,
        orderBy: 'updated_at',
        dir: 'desc',
        filterBy: 'all',
        filterValue: null,
        page: 1
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      is_loading: true,

      nameSection: 'Embarques',
      listRoutes: [{ nameRoute: 'shipments-list', titleRoute: 'Embarques' }]
    };
  },

  methods: {
    getBoardings: function getBoardings() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log('getBoardings');
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      var permissions = this.$store.state.user.attributes.permissions_keys;
      var url = void 0;
      if (permissions.includes(9)) {
        url = "https://backendbutiko.com" + '/api/boarding/list-all';
      } else if (permissions.includes(10)) {
        url = "https://backendbutiko.com" + '/api/boarding/' + this.$store.state.user.id + '/list-all-by-sender';
      } else if (permissions.includes(11)) {
        url = "https://backendbutiko.com" + '/api/boarding/' + this.$store.state.user.id + '/list-all-by-reciever';
      } else {
        alert('El usuario no tiene permisos para ver órdenes de compra');
        return;
      }

      console.log('=======================');
      console.log('URL: ' + url);
      console.log('Datos de la tabla : ');
      console.log(this.tableData);
      console.log('=======================');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData }).then(function (response) {
        var data = response.data;
        console.log(data);

        if (_this.tableData.draw === data.meta.draw) {
          _this.boardings = data.data;
          _this.configPagination(data);
          _this.is_loading = false;
        } else {
          console.log('out of sync');
          _this.is_loading = false;
        }
      }).catch(function (errors) {
        console.log(errors.response);
        alert('No se obtuvieron resultados');
        _this.is_loading = false;
        return;
      });
    },
    cleanInput: function cleanInput() {
      this.tableData.filterValue = '';
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy: function sortBy(key) {
      console.log('entro al sort', key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;

      console.log('tableData.orderBy', this.tableData.orderBy, 'tableData.dir', this.tableData.dir, this.sortOrders[key]);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      console.log('tableData.orderBy', this.tableData.orderBy, 'tableData.dir', this.tableData.dir);
      this.getBoardings();
      console.log('paso la peticion api');
    },
    getIndex: function getIndex(array, key, value) {
      return array.findIndex(function (i) {
        return i[key] === value;
      });
    },
    hideModal: function hideModal() {
      this.$refs.formmodal.hide();
    },
    toEditShipmentView: function toEditShipmentView(id, state) {
      console.log('Selected ID Embarque: ' + id + ', status: ' + state);
      if (state == 1 && this.$store.state.user.attributes.permissions_keys.includes(19)) {
        this.$router.push({
          name: 'shipments-edit',
          params: { idShipment: id }
        });
        return;
      }

      if (state == 6 && this.$store.state.user.attributes.permissions_keys.includes(18)) {
        console.log('evaluate');

        this.$router.push({
          name: 'shipments-evaluate-package',
          params: { id: id }
        });
        return;
      } else {
        this.$router.push({ name: 'shipments-show', params: { id: id } });
      }

      if (state != 1 && state != 6) {
        this.$router.push({ name: 'shipments-show', params: { id: id } });
      }
    }
  },
  computed: {
    filterColumns: function filterColumns() {
      var activeFilterColumns = ['id', 'destination'];
      return this.columns.filter(function (i) {
        return activeFilterColumns.indexOf(i.name) > -1;
      });
    }
  }
});

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_package_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_package_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_package_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__ = __webpack_require__(71);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    cardDetailLuggage: __WEBPACK_IMPORTED_MODULE_3__components_prefab_items_card_detail_luggage_vue___default.a,
    cardPackage: __WEBPACK_IMPORTED_MODULE_4__components_prefab_items_card_package_vue___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_prefab_structures_breadcrumb_vue___default.a
  },
  props: ['id'],
  data: function data() {
    return {
      newDateDeparture: '',
      newHourDeparture: '',
      newDateArrival: '',
      newHourArrival: '',

      dataShipment: null,
      dataLuggageCopy: [],
      dataOrderCopy: [],

      nameSection: 'Visualizar embarque',
      listRoutes: [{ nameRoute: 'shipments-list', titleRoute: 'Embarques' }, { nameRoute: 'shipments-show', titleRoute: 'Ver embarque' }],

      isLoading: false
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(this.id, this.getDataShipment);
  },

  methods: {
    getDataShipment: function getDataShipment(data) {
      this.dataShipment = data;
      this.dataLuggageCopy = this.dataShipment.attributes.luggage_items;
      this.dataOrderCopy = this.dataShipment.attributes.packages;
      this.isLoading = false;
    },
    confirmDepartureShipment: function confirmDepartureShipment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var aux;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                aux = void 0;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].changeStateShipment(_this.id, 'true');

              case 4:
                aux = _context.sent;

                if (aux) {
                  _context.next = 8;
                  break;
                }

                alert("error al cambiar de estado");
                return _context.abrupt("return");

              case 8:
                ;
                __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(_this.id, _this.getDataShipment);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reprogramateShipment: function reprogramateShipment() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dataObject, aux;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.newDateDeparture && _this2.newHourDeparture && _this2.newDateArrival && _this2.newHourArrival) {
                  _context2.next = 3;
                  break;
                }

                alert("Ingrese todos los datos");
                return _context2.abrupt("return");

              case 3:

                _this2.isLoading = true;
                dataObject = new Object();

                dataObject.departure_date = _this2.newDateDeparture + ' ' + _this2.newHourDeparture;
                dataObject.arrival_date = _this2.newDateArrival + ' ' + _this2.newHourArrival;

                aux = void 0;
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].reprogramationShipmentState(_this2.id, dataObject);

              case 10:
                aux = _context2.sent;

                console.log(aux);

                if (aux) {
                  _context2.next = 15;
                  break;
                }

                alert("error al cambiar de estado");
                return _context2.abrupt("return");

              case 15:
                ;
                console.log("dasfasfsafasfsafasgsgasgasgags");

                __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(_this2.id, _this2.getDataShipment);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    confirmArrivalShipment: function confirmArrivalShipment() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var aux;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoading = true;
                aux = void 0;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].changeStateShipment(_this3.id, 'false');

              case 4:
                aux = _context3.sent;

                if (aux) {
                  _context3.next = 8;
                  break;
                }

                alert("error al cambiar de estado");
                return _context3.abrupt("return");

              case 8:
                ;
                __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].getShipmentDetail(_this3.id, _this3.getDataShipment);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    beginEvaluationPackages: function beginEvaluationPackages() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var aux;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoading = true;
                aux = void 0;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_shipment_service__["a" /* shipmentService */].changeStateShipment(_this4.id, 'true');

              case 4:
                aux = _context4.sent;

                if (aux) {
                  _context4.next = 10;
                  break;
                }

                alert("error al cambiar de estado");
                return _context4.abrupt("return");

              case 10:
                _this4.$router.push({ name: 'shipments-evaluate-package', params: { id: _this4.id } });

              case 11:
                _this4.isLoading = false;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    hideModalReprogramation: function hideModalReprogramation() {
      this.$refs.modalReprogramation.hide();
    },
    showModalReprogramation: function showModalReprogramation() {
      this.$refs.modalReprogramation.show();
    }
  }
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prefab_elements_resume_purchase_order__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prefab_elements_resume_purchase_order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_prefab_elements_resume_purchase_order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_prefab_elements_order_important_info__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_prefab_elements_order_important_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_prefab_elements_order_important_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_prefab_items_comment_component__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_prefab_items_comment_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_prefab_items_comment_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_comments_service__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);





var _methods;










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    resumePurchaseOrder: __WEBPACK_IMPORTED_MODULE_7__components_prefab_elements_resume_purchase_order___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components_prefab_structures_breadcrumb_vue___default.a,
    orderImportantInfo: __WEBPACK_IMPORTED_MODULE_8__components_prefab_elements_order_important_info___default.a,
    commentComponent: __WEBPACK_IMPORTED_MODULE_9__components_prefab_items_comment_component___default.a
  },
  props: ['id', 'orderData'],
  data: function data() {
    return {
      seguimientoTrackin: '',
      locale: 'en',
      orderDataShow: null,
      realDateArrive: new Date().toISOString().split('T')[0],
      weightOrder: '',
      newOrderNumber: '',
      currentContent: '',
      oldOrderNumber: false,
      storeType: 1,
      replacementType: 1,
      descriptionIncidence: '',
      controlNumber: '',
      orderNumber: '',
      trackingNumber: '',
      purchaseLink: '',
      dateArriveOrigin: '',
      dateArriveClient: '',
      originWeightUnit: '',
      mountNew: '',
      refundDate: '',
      confirmForm: '',
      auxData: null,
      listUnits: [],


      nameSection: 'Gestión del tracking',
      listRoutes: [{ nameRoute: 'Orders', titleRoute: 'Órdenes de compra' }],
      activeRoute: '',

      modalReplacement_flag: false,
      modalTypeReplacement_flag: false,
      modalNewTracking_flag: false,
      comments: [],

      newRealPrice: '',
      newRealTax: '',
      newRealShipping: ''
    };
  },
  created: function created() {
    this.$validator.localize('es', {
      messages: __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_es___default.a.messages,
      attributes: {
        real_arrival_date: 'fecha real de llegada',
        origin_order_weight: 'peso de la orden en el origen',
        weight_units: 'unidades de peso',
        tracking_number: 'número de tracking',
        control_number: 'número de control',
        incidence_description: 'descripción',
        order_number: 'número de orden',
        tracking_number_replacement: 'número de tracking',
        purchase_link_replacement: 'link de compra',
        arrival_date_replacement: 'fecha de llegada al origen',
        arrival_date_client_replacement: 'Entrega prometida',
        new_real_price: 'precio real',
        new_real_tax: 'impuesto real',
        new_real_shipping: 'costo de envío real'
      }
    });

    this.$validator.localize('es');

    this.orderDataShow = this.orderData;

    if (!this.orderDataShow) {
      this.inicializeData(this.id, this.setData);
    } else {
      console.log("heeeeeeeeeeeeeeeeeeeeeeeeeeeeeey");

      if (this.orderDataShow.attributes.real_origin_arrival_date != null) {
        this.realDateArrive = this.orderDataShow.attributes.real_origin_arrival_date;
      }
      if (this.orderDataShow.attributes.origin_weight != null) {
        this.weightOrder = this.orderDataShow.attributes.origin_weight;
      }
      if (this.orderDataShow.attributes.origin_weight_unit != null) {
        this.originWeightUnit = this.orderDataShow.attributes.origin_weight_unit;
      }
      console.log("heeeeeeeeeeeeeeeeeeeeeeeeeeeeeey2");
      if (this.orderDataShow.attributes.status == 4) {
        this.newOrderNumber = this.orderDataShow.attributes.tracking_number;
      } else if (this.orderDataShow.attributes.status == 5) {
        this.newOrderNumber = this.orderDataShow.attributes.final_tracking_number;
      }
      if (this.orderDataShow.attributes.control_number != null) {
        this.controlNumber = this.orderDataShow.attributes.control_number;
      }
      if (this.orderDataShow.attributes.trackingIncident != null && this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident != null) {
        if (this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.amount) {
          this.mountNew = this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.amount;
        }

        if (this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.refund_date) {
          this.refundDate = this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.refund_date;
        }
      }
      console.log("heeeeeeeeeeeeeeeeeeeeeeeeeeeeeey3");

      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        this.activeRoute = 'Orden Nro.#' + this.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number;
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        this.activeRoute = 'Orden Nro.#' + this.orderDataShow.attributes.linioOrder.attributes.linio_order_number;
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        this.activeRoute = 'Orden Nro.#' + this.orderDataShow.attributes.meliOrder.attributes.meli_order_id;
      }
    }
    this.displayComments();
    this.listUnitWeight(this.getListUnits);
  },

  methods: (_methods = {
    dotracking: function dotracking(trackingNumber) {
      var _this = this;

      var url = "https://backendbutiko.com" + '/api/detectCarrier/' + trackingNumber;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url).then(function (response) {
        var respuesta = response.data.data;
        var data3 = response.data;
        if (respuesta === null) {
          _this.seguimientoTrackin = '';
        } else {
          var _data = response.data.data.trackings[0].events;
          _this.seguimientoTrackin = _data;
        }
      });
    },
    cancellationComment: function cancellationComment() {
      var sinceTracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


      if (sinceTracking) {
        this.currentContent = "Orden cancelada por generación de incidencia en tacking hecha por ";
      } else {
        this.currentContent = "Orden cancelada por ";
      }
      this.currentContent = this.currentContent + this.$store.state.user.attributes.profile.attributes.name + " " + this.$store.state.user.attributes.profile.attributes.surnames + " (" + (this.$store.state.user.attributes.profile.attributes.userable_type == 'admin' ? 'Administrador general' : this.$store.state.user.attributes.profile.attributes.userable_type == 'client' ? 'Cliente' : this.$store.state.user.attributes.operator_type == 1 ? 'Operador de envío' : 'Operador de recepción') + ") con fecha y hora ";

      console.log(this.currentContent);

      var currentDateTime = new Date();
      console.log(currentDateTime);

      this.currentContent = this.currentContent + __WEBPACK_IMPORTED_MODULE_11_moment___default()(String(currentDateTime)).format('DD/MM/YYYY - HH:mm');
      console.log(this.currentContent);
      this.createComment(1);
    },
    disableEditComments: function disableEditComments(exceptId) {
      console.log('No se pueden editar otros comentarios');
      console.log(exceptId);

      this.comments.forEach(function (comment) {
        if (comment.id != exceptId) {
          comment.enable = false;
        }
      });
    },
    enableEditComments: function enableEditComments() {
      this.comments.forEach(function (comment) {
        comment.enable = true;
      });
    },
    displayComments: function displayComments() {
      console.log('En display comments');

      __WEBPACK_IMPORTED_MODULE_10__services_comments_service__["a" /* commentsService */].listCommentsByOrderId(this.id, this.setComments);
    },
    createComment: function createComment() {
      var _this2 = this;

      var cancelled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var commentData, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commentData = {};

                if (!(_this2.currentContent != '')) {
                  _context.next = 12;
                  break;
                }

                commentData.content = _this2.currentContent;
                commentData.purchaseorder_id = parseInt(_this2.id);
                console.log(_this2.$store.state.user);

                commentData.writer_id = _this2.$store.state.user.attributes.profile.id;
                console.log(commentData);
                if (cancelled == 1) commentData.cancelled = 1;

                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_10__services_comments_service__["a" /* commentsService */].createComment(commentData);

              case 10:
                res = _context.sent;


                if (res) {
                  _this2.currentContent = '';
                  _this2.displayComments();
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setComments: function setComments(comments) {
      console.log('Estamos en set comments');
      console.log(comments);

      comments.forEach(function (comment) {
        comment.enable = true;
      });
      this.comments = comments;
    },

    activate_modalReplacement_flag: function activate_modalReplacement_flag(event) {
      this.modalReplacement_flag = true;
      this.modalTypeReplacement_flag = false;
      this.modalNewTracking_flag = false;
      console.log('Se activo el flag modalReplacement_flag');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'createComment', function createComment() {
    var _this3 = this;

    var cancelled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commentData, res;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commentData = {};

              if (!(_this3.currentContent != '')) {
                _context2.next = 12;
                break;
              }

              commentData.content = _this3.currentContent;
              commentData.purchaseorder_id = parseInt(_this3.id);
              console.log(_this3.$store.state.user);

              commentData.writer_id = _this3.$store.state.user.attributes.profile.id;
              console.log(commentData);
              if (cancelled == 1) commentData.cancelled = 1;

              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_10__services_comments_service__["a" /* commentsService */].createComment(commentData);

            case 10:
              res = _context2.sent;


              if (res) {
                _this3.currentContent = '';
                _this3.displayComments();
              }

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'activate_modalTypeReplacement_flag', function activate_modalTypeReplacement_flag(event) {
    this.modalTypeReplacement_flag = true;
    this.modalNewTracking_flag = false;
    this.modalReplacement_flag = false;
    console.log('Se activo el flag modalTypeReplacement_flag y se desactivo modalNewTracking_flag');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'activate_modalNewTracking_flag', function activate_modalNewTracking_flag(event) {
    this.modalNewTracking_flag = true;
    this.modalTypeReplacement_flag = false;
    this.modalReplacement_flag = false;
    console.log('Se activo el flag modalNewTracking_flag y se desactivo modalTypeReplacement_flag');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'reinicialize_variables', function reinicialize_variables() {
    this.realDateArrive = '';
    this.weightOrder = '';
    this.newOrderNumber = '';
    this.oldOrderNumber = false;
    this.orderNumber = '';
    this.trackingNumber = '';
    this.purchaseLink = '';
    this.dateArriveOrigin = '';
    this.dateArriveClient = '';
    this.storeType = 1;
    this.descriptionIncidence = '';
    this.replacementType = 1;
    this.mountNew = '';
    this.refundDate = '';
    this.confirmForm = '';
    this.auxData = null;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'inicializeData', function inicializeData(id, callback) {
    var _this4 = this;

    var url = "https://backendbutiko.com" + '/api/purchaseOrder/get/' + id;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function (response) {
      console.log('De nuevo aqui');

      var purchaseOrder = response.data.body;
      console.log(purchaseOrder);

      if (purchaseOrder.attributes.real_origin_arrival_date != null) {
        _this4.realDateArrive = purchaseOrder.attributes.real_origin_arrival_date;
      }
      if (purchaseOrder.attributes.origin_weight != null) {
        _this4.weightOrder = purchaseOrder.attributes.origin_weight;
      }
      if (purchaseOrder.attributes.origin_weight_unit != null) {
        _this4.originWeightUnit = purchaseOrder.attributes.origin_weight_unit;
      }
      if (purchaseOrder.attributes.status == 4) {
        _this4.newOrderNumber = purchaseOrder.attributes.tracking_number;
      } else if (purchaseOrder.attributes.status == 5) {
        _this4.newOrderNumber = purchaseOrder.attributes.final_tracking_number;
      }

      console.log('esta es data');
      console.log(purchaseOrder);

      callback(purchaseOrder);
    }).catch(function (error) {
      if (error.response) {
        if (error.response.status === 404) {
          self.response = 'Error 404';
        }
        console.log(error);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setData', function setData(data) {
    console.log('En set data');

    this.orderDataShow = data;
    this.dotracking(this.orderDataShow.attributes.tracking_number);
    console.log(this.orderDataShow);

    if (this.orderDataShow.attributes.trackingIncident != null && this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident != null) {
      if (this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.amount) {
        this.mountNew = this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.amount;
      }

      if (this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.refund_date) {
        this.refundDate = this.orderDataShow.attributes.trackingIncident.attributes.refundTrackingIncident.attributes.refund_date;
      }
    }
    this.activeRoute = 'Orden Nro.#' + this.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getListUnits', function getListUnits(data) {
    var _this5 = this;

    this.listUnits = data;
    this.listUnits.forEach(function (unit) {
      if (unit.attributes.key_name == 'lb') {
        _this5.originWeightUnit = unit;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'backToDetail', function backToDetail() {
    this.$router.push({
      name: 'show-purchase-order',
      params: { id: this.id }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalValidation', function hideModalValidation() {
    this.$refs.validacionmodal.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideCancelValidation', function hideCancelValidation() {
    this.$refs.cancelOrdermodal.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalValidation', function showModalValidation() {
    this.$refs.validacionmodal.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalNewTracking', function hideModalNewTracking() {
    this.$refs.modalNewTracking.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalNewTracking', function showModalNewTracking() {
    this.$refs.modalNewTracking.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalTypeReplacement', function hideModalTypeReplacement() {
    this.$refs.modalTypeReplacement.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalTypeReplacement', function showModalTypeReplacement() {
    this.$refs.modalTypeReplacement.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalReplacement', function hideModalReplacement() {
    this.$refs.modalReplacement.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalReplacement', function showModalReplacement() {
    this.$refs.modalReplacement.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalConfirmation', function hideModalConfirmation() {
    this.$refs.modalConfirmation.hide();
    this.reinicialize_variables();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalConfirmation', function showModalConfirmation() {
    this.$refs.modalConfirmation.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalConfirmationV2', function hideModalConfirmationV2() {
    this.$refs.modalConfirmationV2.hide();
    this.reinicialize_variables();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalConfirmationV2', function showModalConfirmationV2() {
    this.$refs.modalConfirmationV2.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalRefund', function hideModalRefund() {
    this.$refs.modalRefund.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalRefund', function showModalRefund() {
    this.$refs.modalRefund.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showModalConfirmationDelete', function showModalConfirmationDelete() {
    this.$refs.modalConfirmationDelete.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'hideModalConfirmationDelete', function hideModalConfirmationDelete() {
    this.$refs.modalConfirmationDelete.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleValidationErrorAdvanced', function handleValidationErrorAdvanced() {
    var firstField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errors.collect())[0];
    if (firstField) {
      var elements = document.getElementsByName(firstField);
      console.log('Failed validation of field: '.concat(firstField));
      elements[0].scrollIntoView();
    } else console.log('Could not find elements with errors.');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'purchaseOrderEvaluation', function purchaseOrderEvaluation(id) {
    var _this6 = this;

    this.$validator.validate().then(function (result) {
      if (!result) {
        return _this6.handleValidationErrorAdvanced();
      } else {
        console.log('Passed validations of purchaseOrderEvaluation with ID: '.concat(id));

        if (_this6.oldOrderNumber) {
          if (_this6.orderDataShow.attributes.is_from_grabr_flag == true) {
            _this6.newOrderNumber = _this6.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number;
          }
          if (_this6.orderDataShow.attributes.is_from_grabr_flag == false) {
            _this6.newOrderNumber = _this6.orderDataShow.attributes.order_code;
          }
        }

        var auxObject = new Object();
        auxObject.real_origin_arrival_date = _this6.realDateArrive;
        auxObject.origin_weight = _this6.weightOrder;
        auxObject.origin_weight_unit_id = _this6.originWeightUnit.id;
        auxObject.final_tracking_number = _this6.newOrderNumber;
        auxObject.control_number = _this6.controlNumber;

        _this6.hideModalNewTracking();
        _this6.postDataToCorrectReceptionPurchaseOrder(id, auxObject);

        return $router.push({ name: 'show-tracking-order', params: { id: data.id, orderData: data } });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'generateIncidence', function generateIncidence(id) {
    var _this7 = this;

    this.$validator.validate().then(function (result) {
      console.log("Estamos en validar");

      console.log(result);

      if (!result) {
        return _this7.handleValidationErrorAdvanced();
      } else {
        console.log('Passed validations of generateIncidence with ID: '.concat(id));
        _this7.hideModalTypeReplacement();
        var auxObject = new Object();
        auxObject.type = _this7.storeType;
        auxObject.description = _this7.descriptionIncidence;
        if (_this7.storeType == 2) {
          auxObject.replacement_type = _this7.replacementType;
        }

        _this7.showModalConfirmation();
        _this7.auxData = auxObject;
        _this7.confirmForm = 'generateIncidence';
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'generateReplacement', function generateReplacement() {
    var _this8 = this;

    this.$validator.validate().then(function (result) {
      if (!result) {

        return _this8.handleValidationErrorAdvanced();
      } else {

        console.log('Passed validations of generateReplacement');
        _this8.modalReplacement_flag = false;
        _this8.hideModalReplacement();
        var auxObject = new Object();
        auxObject.shopping_order_number = _this8.orderNumber;
        auxObject.tracking_number = _this8.trackingNumber;
        auxObject.real_purchase_link = _this8.purchaseLink;
        auxObject.promised_origin_arrival_date = _this8.dateArriveOrigin;
        auxObject.promised_delivery_date = _this8.dateArriveClient;
        auxObject.real_price = _this8.newRealPrice;
        auxObject.real_tax = _this8.newRealTax;
        auxObject.real_shipping = _this8.newRealShipping;
        console.log(auxObject);
        console.log("---------------------------------");
        _this8.showModalConfirmation();
        _this8.auxData = auxObject;
        console.log("aux data:");
        console.log(_this8.auxData);

        _this8.confirmForm = 'generateReplacement';
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'completeRefund', function completeRefund() {
    if (this.mountNew == null || this.mountNew == '' || this.mountNew.length == 0 || /^\s+$/.test(this.mountNew)) {
      alert('Ingrese un monto');
      return;
    }
    if (this.refundDate == null || this.refundDate == '' || /^\s+$/.test(this.refundDate)) {
      alert('Ingrese la fecha de reembolso');
      return;
    }

    if (this.originWeightUnit == null || this.originWeightUnit == '') {
      alert('Seleccione la unidad de medida del peso');

      return;
    }

    this.hideModalRefund();

    var id = this.orderDataShow.attributes.trackingIncident.id;
    var auxObject = new Object();
    auxObject.amount = this.mountNew;
    auxObject.refund_date = this.refundDate;

    this.updateDataRefundByTrakingIncidentID(id, auxObject);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'postDataToCorrectReceptionPurchaseOrder', function postDataToCorrectReceptionPurchaseOrder(id, data) {
    var _this9 = this;

    var url = "https://backendbutiko.com" + '/api/purchaseOrder/' + id + '/complete-reception-info';
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, data).then(function (response) {
      if (response.data.status) {
        _this9.orderDataShow = response.data.body;
        _this9.realDateArrive = _this9.orderDataShow.attributes.real_origin_arrival_date;
        _this9.weightOrder = _this9.orderDataShow.attributes.origin_weight;
        _this9.originWeightUnit = _this9.orderDataShow.attributes.origin_weight_unit;
        _this9.newOrderNumber = _this9.orderDataShow.attributes.final_tracking_number;
        _this9.controlNumber = _this9.orderDataShow.attributes.control_number;

        _this9.showModalValidation();
      }
    }).catch(function (error) {
      console.log(error);
      console.log(error.response);

      return;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'confirmArrivalPurchaseOrderToOrigin', function confirmArrivalPurchaseOrderToOrigin(id) {
    var _this10 = this;

    var url = "https://backendbutiko.com" + '/api/purchaseOrder/' + id + '/reception-ok';
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url).then(function (response) {
      if (response.data.status) {
        _this10.orderDataShow = response.data.body;
        _this10.showModalValidation();
      }
    }).catch(function (error) {
      console.log(error);
      console.log(error.response);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'generateIncidenceOfTrackingInitial', function generateIncidenceOfTrackingInitial(id, data) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, resp;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/purchaseOrder/' + id + '/generate-tracking-incident';

              console.log(url);

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, data).then(function (response) {
                if (response.data.status) {
                  _this11.inicializeData(_this11.id, _this11.setData);
                  return true;
                }
                return false;
              }).catch(function (error) {

                console.log(error);
                console.log(error.response);
                return false;
              });

            case 4:
              resp = _context3.sent;
              return _context3.abrupt('return', resp);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this11);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'createPurchaseOrderToReplacementToIncideceSameShop', function createPurchaseOrderToReplacementToIncideceSameShop(id, data) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var url, resp;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/purchaseOrder/' + id + '/create-replacement-purchase-order';
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, data).then(function (response) {
                if (response.data.status) {
                  console.log(response.data.body);

                  _this12.inicializeData(_this12.id, _this12.setData);
                  return true;
                }
                return false;
              }).catch(function (error) {
                console.log(error);
                console.log(error.response);

                return false;
              });

            case 3:
              resp = _context4.sent;
              return _context4.abrupt('return', resp);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this12);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'updateDataRefundByTrakingIncidentID', function updateDataRefundByTrakingIncidentID(id, data) {
    var _this13 = this;

    var url = "https://backendbutiko.com" + '/api/trackingIncident/' + id + '/update-refund-data';
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, data).then(function (response) {
      if (response.data.status) {
        _this13.showModalValidation();
        _this13.inicializeData(_this13.id, _this13.setData);
      }
    }).catch(function (error) {
      console.log(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deletePurchaseOrder', function deletePurchaseOrder(id) {
    var _this14 = this;

    var url = "";
    url = "https://backendbutiko.com" + '/api/purchaseOrder/delete/' + id;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(url, {
      hard: 1
    }).then(function (response) {
      console.log("orden elimnada");
      _this14.$router.push('/orders');
    }).catch(function (error) {
      console.log("Error al eliminar");
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'endRefundByTrakingIncidentID', function endRefundByTrakingIncidentID(id) {
    var _this15 = this;

    this.hideModalRefund();

    var url = "https://backendbutiko.com" + '/api/trackingIncident/' + id + '/finish-refund';
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url).then(function (response) {
      if (response.data.status) {
        _this15.showModalValidation();
        _this15.inicializeData(_this15.id, _this15.setData);
      }
    }).catch(function (error) {
      console.log(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'cancelatePurchaseOrder', function cancelatePurchaseOrder(id) {
    var _this16 = this;

    var status = this.orderDataShow.attributes.status;
    var url = void 0,
        data = void 0;
    if (status == 2) {
      console.log('Va a cancilar desconfirmando el confirmed approved flag');

      url = "https://backendbutiko.com" + '/api/purchaseOrder/' + id + '/confirm-approved-flag';
      data = new Object();
      data.confirmation_flag = 0;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status) {
          console.log(response.data);

          _this16.$refs.cancelOrdermodal.show();
          _this16.inicializeData(_this16.id, _this16.setData);
        }
      }).catch(function (error) {
        console.log(error);
      });
    } else if (status <= 7 && status != 2) {
      console.log('Va a cancelar directo');

      url = "https://backendbutiko.com" + '/api/purchaseOrder/cancel/' + id;
      data = new Object();
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, data).then(function (response) {
        if (response.data.status) {
          console.log(response.data);

          _this16.$refs.cancelOrdermodal.show();
          _this16.inicializeData(_this16.id, _this16.setData);
        }
      }).catch(function (error) {
        console.log(error);
      });
    } else {
      alert('Esta en un estado en el que no debería poder cancelar');
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'redirectToCreatePurchaseOrder', function redirectToCreatePurchaseOrder() {
    var auxId = void 0,
        client = void 0,
        externalClientDni = void 0,
        grabrClientId = void 0,
        externalClientName = void 0,
        externalClientCellphone = void 0;

    if (this.orderDataShow.attributes.is_from_grabr_flag) {
      auxId = '1';
      externalClientDni = grabrClientId = null;
      if (this.orderDataShow.attributes.external_client_dni != null) {
        externalClientDni = this.orderDataShow.attributes.external_client_dni;
      } else {
        grabrClientId = this.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id;
      }
      externalClientName = this.orderDataShow.attributes.external_client_name;
      externalClientCellphone = this.orderDataShow.attributes.external_client_cellphone;
    } else {
      auxId = '2';
      client = this.orderDataShow.attributes.client;
    }
    var grabr = {
      id: auxId
    };
    var oldID = this.id;

    this.$router.push({
      name: 'add-purchase-order',
      params: {
        grabr: grabr,
        oldID: oldID,
        client: client,
        externalClientDni: externalClientDni,
        grabrClientId: grabrClientId,
        externalClientName: externalClientName,
        externalClientCellphone: externalClientCellphone
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'inicialiceModalReplacement', function inicialiceModalReplacement() {
    console.log('Esta pasando esto');
    this.modalReplacement_flag = true;
    this.modalTypeReplacement_flag = false;
    this.modalNewTracking_flag = false;
    if (this.orderDataShow.attributes.promised_origin_arrival_date) {
      this.dateArriveOrigin = this.orderDataShow.attributes.promised_origin_arrival_date;
    }
    if (this.orderDataShow.attributes.promised_delivery_date) {
      this.dateArriveClient = this.orderDataShow.attributes.promised_delivery_date;
    }
    if (this.orderDataShow.attributes.real_purchase_link) {
      this.purchaseLink = this.orderDataShow.attributes.real_purchase_link;
    }
    if (this.orderDataShow.attributes.shopping_order_number) {
      this.orderNumber = this.orderDataShow.attributes.shopping_order_number;
    }
    if (this.orderDataShow.attributes.tracking_number) {
      this.trackingNumber = this.orderDataShow.attributes.tracking_number;
    }
    if (this.orderDataShow.attributes.real_price) {
      this.newRealPrice = this.orderDataShow.attributes.real_price;
    }
    if (this.orderDataShow.attributes.real_tax) {
      this.newRealTax = this.orderDataShow.attributes.real_tax;
    }
    if (this.orderDataShow.attributes.real_shipping) {
      this.newRealShipping = this.orderDataShow.attributes.real_shipping;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'referenceToNewPurchaseOrder', function referenceToNewPurchaseOrder() {
    this.$router.push({
      name: 'show-purchase-order',
      params: {
        id: this.orderDataShow.attributes.replacementPurchaseOrder.id,
        orderData: this.orderDataShow.attributes.replacementPurchaseOrder
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'confirmFormModal', function confirmFormModal() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var resp, _resp;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              console.log(_this17.auxData);

              if (!(_this17.confirmForm == 'generateIncidence')) {
                _context5.next = 7;
                break;
              }

              _context5.next = 4;
              return _this17.generateIncidenceOfTrackingInitial(_this17.id, _this17.auxData);

            case 4:
              resp = _context5.sent;

              _this17.hideModalConfirmation();
              if (resp) {
                _this17.cancellationComment(true);
                _this17.showModalValidation();
              } else {
                alert("Error al generar la incidencia de tracking");
              }

            case 7:
              if (!(_this17.confirmForm == 'generateReplacement')) {
                _context5.next = 14;
                break;
              }

              console.log(_this17.auxData);

              _context5.next = 11;
              return _this17.createPurchaseOrderToReplacementToIncideceSameShop(_this17.id, _this17.auxData);

            case 11:
              _resp = _context5.sent;

              _this17.hideModalConfirmation();
              if (_resp) {
                _this17.showModalValidation();
              } else {
                alert("Error al generar el reemplazo");
              }

            case 14:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this17);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'listUnitWeight', function listUnitWeight(callback) {
    var url = "https://backendbutiko.com" + '/api/weightUnit/list';
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  }), _methods),
  computed: {
    totalPrice: function totalPrice() {
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        return this.orderDataShow.attributes.grabrOrder.attributes.grabr_price + this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + this.orderDataShow.attributes.grabrOrder.attributes.grabr_fee;
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        return this.orderDataShow.attributes.linioOrder.attributes.linio_price;
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        return this.orderDataShow.attributes.meliOrder.attributes.meli_price;
      } else {
        return this.orderDataShow.attributes.client_flete_cost + this.orderDataShow.attributes.client_arancel_cost + this.orderDataShow.attributes.real_price * this.orderDataShow.attributes.product_specimens + this.orderDataShow.attributes.payment_method_cost;
      }
    },
    isDirect: function isDirect() {
      return !this.orderDataShow.attributes.is_from_grabr_flag && !this.orderDataShow.attributes.is_from_linio_flag && !this.orderDataShow.attributes.is_from_meli_flag;
    },
    readyToSaveIncompleteData: function readyToSaveIncompleteData() {
      if (this.finalBuyingLink != '' || this.finalBuyingCode != '' || this.otherCarrierName != '' || this.carrier != '' || this.numberTracking != '' || this.postingDate != '' || this.operatorOrigin != '' || !this.orderDataShow.attributes.is_from_grabr_flag && this.sendingDate != '') {
        return true;
      }
      return false;
    },
    readyToProcessIncompleteData: function readyToProcessIncompleteData() {
      console.log(this.otherCarrierName != '' || this.carrier != '');

      if (this.orderDataShow.attributes.is_from_grabr_flag && this.finalBuyingLink != '' && this.finalBuyingCode != '' && (this.otherCarrierName != '' || this.carrier !== '') && this.numberTracking != '' && this.postingDate != '' && this.operatorOrigin != '' || !this.orderDataShow.attributes.is_from_grabr_flag && this.sendingDate != '' && this.finalBuyingCode != '' && (this.otherCarrierName !== '' || this.carrier !== '') && this.numberTracking != '' && this.postingDate != '' && this.operatorOrigin != '') {
        return true;
      }
      return false;
    },
    debitCalculated: function debitCalculated() {
      console.log('Estamos en calculate debit');
      var costGrabr = void 0,
          taxGrabr = void 0,
          shippingGrabr = void 0;
      if (this.costGrabr == '') costGrabr = 0;else costGrabr = parseFloat(this.costGrabr);

      if (this.taxGrabr == '') taxGrabr = 0;else taxGrabr = parseFloat(this.taxGrabr);

      if (this.shippingGrabr == '') shippingGrabr = 0;else shippingGrabr = parseFloat(this.shippingGrabr);

      console.log("Precio de la web: ");
      console.log(costGrabr);
      console.log("Impuesto de la web: ");
      console.log(taxGrabr);
      console.log("Costo de envío de la web");
      console.log(shippingGrabr);

      var subtotal1 = void 0,
          subtotal2 = void 0;
      subtotal1 = 0;
      subtotal2 = 0;
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        console.log("Precio Grabr");
        console.log(this.orderDataShow.attributes.grabrOrder.attributes.grabr_price);

        console.log("Impuesto Grabr");
        console.log(this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax);

        subtotal1 = this.orderDataShow.attributes.grabrOrder.attributes.grabr_price <= costGrabr ? costGrabr - this.orderDataShow.attributes.grabrOrder.attributes.grabr_price : 0;
        console.log(subtotal1);

        subtotal2 = this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax <= taxGrabr ? taxGrabr - this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax : 0;
        console.log(subtotal2);
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        console.log("Precio Linio");
        console.log(this.orderDataShow.attributes.linioOrder.attributes.linio_price);

        subtotal1 = this.orderDataShow.attributes.linioOrder.attributes.linio_price <= costGrabr ? costGrabr - this.orderDataShow.attributes.linioOrder.attributes.linio_price : 0;
        console.log(subtotal1);

        subtotal2 = taxGrabr;
        console.log(subtotal2);
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        console.log("Precio meli");
        console.log(this.orderDataShow.attributes.meliOrder.attributes.meli_price);

        subtotal1 = this.orderDataShow.attributes.meliOrder.attributes.meli_price <= costGrabr ? costGrabr - this.orderDataShow.attributes.meliOrder.attributes.meli_price : 0;
        console.log(subtotal1);

        subtotal2 = taxGrabr;
        console.log(subtotal2);
      }

      return parseFloat(subtotal1) + parseFloat(subtotal2) + parseFloat(shippingGrabr);
    },
    formatPostingDate: function formatPostingDate() {
      if (!this.postingDate) return '2000-01-01';
      var postingDate2 = new Date(this.postingDate);
      console.log('Habia postingDate: '.concat(postingDate2));
      var formatted_month = ('0' + (postingDate2.getMonth() + 1)).slice(-2);
      var formatted_day = ('0' + (postingDate2.getDate() + 1)).slice(-2);
      var formatted_date = postingDate2.getFullYear() + '-' + formatted_month + '-' + formatted_day;
      console.log('Formatted date: '.concat(formatted_date));
      return formatted_date;
    },
    formatSendingDate: function formatSendingDate() {
      if (!this.sendingDate) return '2000-01-01';
      var sendingDate2 = new Date(this.sendingDate);
      console.log('Habia postingDate: '.concat(sendingDate2));
      var formatted_month = ('0' + (sendingDate2.getMonth() + 1)).slice(-2);
      var formatted_day = ('0' + (sendingDate2.getDate() + 1)).slice(-2);
      var formatted_date = sendingDate2.getFullYear() + '-' + formatted_month + '-' + formatted_day;
      console.log('Formatted date: '.concat(formatted_date));
      return formatted_date;
    },

    packagedRealValue: function packagedRealValue() {
      var packagedAux = this.orderDataShow.attributes.packaged;
      console.log('estoy en computed');

      if (packagedAux == null) {
        return 1;
      } else if (packagedAux == 1) {
        return 2;
      } else {
        return 3;
      }
    },

    repositionAuthorizedFlag: function repositionAuthorizedFlag() {
      try {
        return this.orderDataShow.attributes.reposition.attributes.authorized;
      } catch (error) {
        return null;
      }
    },
    noEvaluationFlag: function noEvaluationFlag() {
      var flag = false;
      if (this.orderDataShow.attributes.status != 1) return false;
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        flag = this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax == null || this.orderDataShow.attributes.grabrOrder.attributes.grabr_fee == null || this.orderDataShow.attributes.origin_id == null || this.orderDataShow.attributes.destination_id == null;
      } else if (this.orderDataShow.attributes.is_from_linio_flag || this.orderDataShow.attributes.is_from_meli_flag) {
        flag = this.orderDataShow.attributes.origin_id == null || this.orderDataShow.attributes.destination_id == null;
      }
      return flag;
    },
    totalMeli: function totalMeli() {
      return this.totalPrice + this.orderDataShow.attributes.meliOrder.attributes.rebate;
    },
    totalCommissions: function totalCommissions() {
      return 0.09 * this.totalPrice + 0.09 * this.orderDataShow.attributes.meliOrder.attributes.rebate;
    },
    totalNeto: function totalNeto() {
      return this.totalMeli - this.totalCommissions;
    }
  },
  watch: {
    otherCarrierFlag: function otherCarrierFlag(newFlag) {
      console.log('estamos cambiando de valor');
      if (!newFlag) this.otherCarrierName = '';
      if (newFlag) this.carrier = '';
    }
  }

});

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_user_chart1_list_vue__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_user_chart1_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_user_chart1_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_user_chart2_list_vue__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_user_chart2_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_user_chart2_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_user_chart3_list_vue__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_user_chart3_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_user_chart3_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { chart1: __WEBPACK_IMPORTED_MODULE_2__components_prefab_elements_user_chart1_list_vue___default.a, chart2: __WEBPACK_IMPORTED_MODULE_3__components_prefab_elements_user_chart2_list_vue___default.a, chart3: __WEBPACK_IMPORTED_MODULE_4__components_prefab_elements_user_chart3_list_vue___default.a, breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_prefab_structures_breadcrumb_vue___default.a },
  data: function data() {
    var _ref;

    return _ref = {
      responseCheck: '',
      validatePass: '',
      responsePass: '',
      response2Pass: '',
      validateDate: '',
      responseDate: '',
      validateGenre: '',
      responseGenre: '',
      responsePhone: '',
      validatePhone: '',
      validateUser: '',
      validateUserName: '',
      responseUserName: '',
      responseUser: '',
      responseName: '',
      responseLast: '',
      name: '',
      lastname: '',
      username: '',
      telephone: '',
      dni: '',
      sexo: 0,
      date: '',
      password: '',
      checkPassword: '',
      typeUser: '',
      email: ''
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'username', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'operator_type', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'city_id', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'country_code', '+51'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectionUser', 'clientes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listCountry', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nameSection', 'Usuarios'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listRoutes', [{ nameRoute: 'user-list', titleRoute: 'Usuarios' }]), _ref;
  },
  created: function created() {
    var _this = this;

    var url = '';
    url = "https://backendbutiko.com" + '/api/countryCodes';
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
      _this.listCountry = response.data;
    }).catch(function (error) {
      if (error) {
        _this.listCountry = 'No hay datos';
      }
    });
  },

  methods: {
    onlyNumber: function onlyNumber($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    resetInput: function resetInput(typeUser) {
      if (typeUser === 'cliente') {
        this.name = '';
        this.lastname = '';
        this.email = '';
        this.dni = '';
        this.telephone = '';
        this.sexo = '';
        this.date = '';
        this.password = '';
        this.checkPassword = '';
      }
      if (typeUser === 'administrador') {
        this.name = '';
        this.lastname = '';
        this.username = '';
        this.dni = '';
        this.telephone = '';
        this.sexo = '';
        this.date = '';
        this.password = '';
        this.checkPassword = '';
      }
      if (typeUser === 'operador') {
        this.name = '';
        this.lastname = '';
        this.username = '';
        this.dni = '';
        this.telephone = '';
        this.sexo = '';
        this.date = '';
        this.password = '';
        this.checkPassword = '';
        this.operator_type = '';
        this.city_id = '';
      }
    },
    hideModalReevaluetion: function hideModalReevaluetion() {
      this.$refs.modalReevaluation.hide();
    },
    checkServer: function checkServer(typeUser) {
      var _this2 = this;

      if (typeUser === 'cliente') {
        var self = this;
        var url = '';
        this.toggleLoading();
        this.$store.commit('TOGGLE_LOADING');
        this.resetResponse();
        if (this.validateForm() && this.validateFormClient()) {
          this.resetResponse();
          url = "https://backendbutiko.com" + '/api/client/create-client';
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
            name: this.name,
            surnames: this.lastname,
            country_code: this.country_code,
            cellphone: this.telephone,
            gender: this.sexo === '1' ? 'M' : 'F',
            birthdate: this.date,
            email: this.email,
            password: this.password,
            document_number: this.dni
          }).then(function (response) {
            self.toggleLoading();
            console.log('success');
            console.log(response.data);
            _this2.resetInput(typeUser);
            _this2.typeUser = '';
            _this2.$refs.modalReevaluation.hide();
            location.reload();
          }).catch(function (error) {
            var responseMessage = void 0;
            var errorFlag = void 0;
            if (error.response) {
              if (error.response.status === 400) {
                self.response = 'Error 400';
              } else if (error.response.status === 404) {
                self.response = 'Error 404';
              } else if (error.response.status === 422 || error.response.status === 401) {
                console.log('entro');

                if (error.response.data.errors.hasOwnProperty('email')) {
                  responseMessage = error.response.data.errors.email[0];
                  console.log(responseMessage);
                  errorFlag = parseInt(responseMessage.substr(0, responseMessage.indexOf('.')));
                  if (errorFlag === 1) {
                    self.validateEmail('emailInc');
                  }
                } else if (error.response.data.errors.password[0].slice(0, 1).toString() === '2') {
                  var passInc = 'passInc';
                  self.validateUser(passInc);
                }
              } else if (error.response.status === 500) {
                self.response = 'Error de servidor. Inténtelo más tarde.';
              } else {
                self.response = 'Error inesperado';
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
        }
      }
      if (typeUser === 'administrador') {
        var _self = this;
        var _url = '';
        this.toggleLoading();
        this.$store.commit('TOGGLE_LOADING');
        this.resetResponse();
        if (this.validateForm() && this.validateFormAdmin()) {
          this.resetResponse();
          _url = "https://backendbutiko.com" + '/api/admin/create-admin';
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_url, {
            name: this.name,
            surnames: this.lastname,
            country_code: this.country_code,
            cellphone: this.telephone,
            gender: this.sexo === '1' ? 'M' : 'F',
            birthdate: this.date,
            username: this.username,
            password: this.password,
            document_number: this.dni
          }).then(function (response) {
            _self.toggleLoading();
            console.log('success');
            console.log(response.data);
            _this2.resetInput(typeUser);
            _this2.typeUser = '';
            _this2.$refs.modalReevaluation.hide();
            location.reload();
          }).catch(function (error) {
            var responseMessage = void 0;
            var errorFlag = void 0;
            if (error.response) {
              if (error.response.status === 400) {
                _self.response = 'Error 400';
              } else if (error.response.status === 404) {
                _self.response = 'Error 404';
              } else if (error.response.status === 422 || error.response.status === 401) {
                console.log('entro');

                if (error.response.data.errors.hasOwnProperty('username')) {
                  responseMessage = error.response.data.errors.username[0];
                  console.log(responseMessage);
                  _self.validateUsername('userNameInc');
                } else if (error.response.data.errors.password[0].slice(0, 1).toString() === '2') {
                  var passInc = 'passInc';
                  _self.validateUser(passInc);
                }
              } else if (error.response.status === 500) {
                _self.response = 'Error de servidor. Inténtelo más tarde.';
              } else {
                _self.response = 'Error inesperado';
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
        }
      }
      if (typeUser === 'operador') {
        var _self2 = this;
        var _url2 = '';
        this.toggleLoading();
        this.$store.commit('TOGGLE_LOADING');
        if (this.validateForm() && this.validateFormAdmin()) {
          _url2 = "https://backendbutiko.com" + '/api/operator/create-operator';
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_url2, {
            name: this.name,
            surnames: this.lastname,
            country_code: this.country_code,
            cellphone: this.telephone,
            gender: this.sexo === '1' ? 'M' : 'F',
            birthdate: this.date,
            username: this.username,
            password: this.password,
            document_number: this.dni,
            operator_type: this.operator_type,
            city_id: this.city_id
          }).then(function (response) {
            _self2.toggleLoading();
            console.log('success');
            console.log(response.data);
            _this2.resetInput(typeUser);
            _this2.typeUser = '';
            _this2.$refs.modalReevaluation.hide();
            location.reload();
          }).catch(function (error) {
            var responseMessage = void 0;
            var errorFlag = void 0;
            if (error.response) {
              if (error.response.status === 400) {
                _self2.response = 'Error 400';
              } else if (error.response.status === 404) {
                _self2.response = 'Error 404';
              } else if (error.response.status === 422 || error.response.status === 401) {
                console.log('entro');

                if (error.response.data.errors.hasOwnProperty('username')) {
                  responseMessage = error.response.data.errors.username[0];
                  console.log(responseMessage);
                  _self2.validateUsername('userNameInc');
                } else if (error.response.data.errors.password[0].slice(0, 1).toString() === '2') {
                  var passInc = 'passInc';
                  _self2.validateUser(passInc);
                }
              } else if (error.response.status === 500) {
                _self2.response = 'Error de servidor. Inténtelo más tarde.';
              } else {
                _self2.response = 'Error inesperado';
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
        }
      }
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.validateName = '';
      this.validateUserName = '';
      this.responseName = '';
      this.validateLast = '';
      this.responseLast = '';
      this.validateUser = '';
      this.responseUser = '';
      this.validateUserName = '';
      this.responseUserName = '';
      this.validatePass = '';
      this.responsePass = '';
      this.response2Pass = '';
      this.validateCheck = '';
      this.responseCheck = '';
      this.validatePhone = '';
      this.responsePhone = '';
      this.validateGenre = '';
      this.responseGenre = '';
      this.validateDate = '';
      this.responseDate = '';
    },
    validateForm: function validateForm() {
      console.log(this.name, this.lastname, this.email, this.password, this.checkPassword, this.telephone, this.sexo, this.date, this.country_code);
      var name = 'name';
      var last = 'last';
      var pass = 'pass';
      var check = 'check';
      var names = this.validateNames(name);
      var surnames = this.validateNames(last);
      var phone = this.validateNumber();
      var genre = this.validateSex();
      var birthdate = this.validateBday();
      var pass1 = this.validatePassword(pass);
      var pass2 = this.validatePassword(check);
      var checkPass = this.validate2Password();
      return names && surnames && phone && genre && birthdate && pass1 && pass2 && checkPass;
    },
    validateFormClient: function validateFormClient() {
      console.log('Solo clientes', this.email);
      var user = this.validateEmail();
      return user;
    },
    validateFormAdmin: function validateFormAdmin() {
      console.log(this.username);
      var userName2 = this.validateUsername();
      console.log('userName2', userName2);
      return userName2;
    },
    validateFormOperator: function validateFormOperator() {
      console.log(this.username);
      var userName2 = this.validateUsername();
      console.log('userName2', userName2);
      return userName2;
    },
    validateUsername: function validateUsername() {
      var atr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (atr === null) {
        this.responseUserName = this.username.length < 1 || this.username.length > 20 ? 'Nombres debe contener entre 1 y 20 carácteres.' : '';
        return !(this.username < 1 || this.username.length > 20);
      } else if (atr === 'userNameInc') {
        console.log('Ingreso al duplicado del userName');
        this.validateUserName = 'incorrect';
        this.responseUserName = 'UserName ya registrado';
      }
    },
    validateNames: function validateNames(atr) {
      if (atr === 'name') {
        this.validateName = this.name.length < 1 || this.name.length > 50 ? 'incorrect' : 'correct';
        this.responseName = this.name.length < 1 || this.name.length > 50 ? 'Nombres debe contener entre 1 y 50 carácteres.' : '';
        return !(this.name.length < 1 || this.name.length > 50);
      } else if (atr === 'last') {
        this.validateLast = this.lastname.length < 1 || this.lastname.length > 100 ? 'incorrect' : 'correct';
        this.responseLast = this.lastname.length < 1 || this.lastname.length > 100 ? 'Apellidos deben contener entre 1 y 100 carácteres.' : '';
        return !(this.lastname.length < 1 || this.lastname.length > 100);
      }
    },
    validateEmail: function validateEmail() {
      var atr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (atr === null) {
        var aux = new RegExp('[\\w+\\-\\.]+\\@[a-z]+\\.[a-z]{2,}');
        this.validateUser = aux.test(this.email) ? 'correct' : 'incorrect';
        this.responseUser = aux.test(this.email) ? '' : 'Ingresa un correo válido. Ex: ejemplo@grupocasza.com';
        return aux.test(this.email);
      } else if (atr === 'emailInc') {
        this.validateUser = 'incorrect';
        this.responseUser = 'Correo ya registrado';
      }
    },
    validateNumber: function validateNumber() {
      var validated = this.telephone.length === 9;
      this.validatePhone = validated ? 'correct' : 'incorrect';
      this.responsePhone = validated ? '' : 'El telefono debe tener 9 digitos';
      return validated;
    },
    validateSex: function validateSex() {
      console.log(this.sexo, this.sexo == 0);
      this.validateGenre = !(this.sexo == 0) ? 'correct' : 'incorrect';
      this.responseGenre = !(this.sexo == 0) ? '' : 'Debes seleccionar un género.';
      return !(this.sexo == 0);
    },
    validateBday: function validateBday() {
      console.log(this.date);
      console.log(parseInt(this.date));
      var aux = new Date();
      var date = parseInt(this.date) >= 1900 && aux.getFullYear() - parseInt(this.date) >= 18;
      this.validateDate = date ? 'correct' : 'incorrect';
      this.responseDate = date ? '' : 'Ingrese una fecha correcta.';
      console.log('salio del validateBday');
      return date;
    },
    validatePassword: function validatePassword(atr) {
      if (atr === 'pass') {
        this.validatePass = this.password.length < 8 || this.password.length > 20 ? 'incorrect' : 'correct';
        this.responsePass = this.password.length < 8 || this.password.length > 20 ? 'La contraseña debe tener entre 8 y 20 carácteres.' : '';
        return !(this.password.length < 8 || this.password.length > 20);
      } else if (atr === 'check') {
        this.validateCheck = this.checkPassword.length < 8 || this.checkPassword.length > 20 ? 'incorrect' : 'correct';
        this.responseCheck = this.checkPassword.length < 8 || this.checkPassword.length > 20 ? 'La contraseña debe tener entre 8 y 20 carácteres.' : '';
        return !(this.checkPassword.length < 8 || this.checkPassword.length > 20);
      }
    },
    validate2Password: function validate2Password() {
      var aux = this.password === this.checkPassword;
      console.log('aux', aux);
      this.validatePass = aux ? 'correct' : 'incorrect';
      this.validateCheck = aux ? 'correct' : 'incorrect';
      this.response2Pass = aux ? '' : 'Las contraseñas deben ser iguales. Por favor, intenta de nuevo.';
      return aux;
    }
  }
});

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Alert',
  props: {
    dismissible: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'info'
    },
    iconClasses: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoBox',
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    iconClasses: {
      type: Array,
      default: []
    },
    colorClass: {
      type: String,
      default: 'bg-default'
    }
  }
});

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoBox',
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    progress: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    description: {
      type: String,
      default: ''
    },
    iconClasses: {
      type: Array,
      default: []
    },
    colorClass: {
      type: String,
      default: 'bg-default'
    }
  }
});

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = auth;
function auth(_ref) {
  var next = _ref.next,
      router = _ref.router;

  console.log(router.app.$store.state);
  if (!router.app.$store.state.token || router.app.$store.state.token === 'null') {
    window.console.log('Not authenticated');
    next({
      path: '/welcome'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = correctRole;
function correctRole(_ref) {
  var to = _ref.to,
      next = _ref.next,
      router = _ref.router;

  var path = to.path;

  var basePath = '/login/';
  var role = path.substr(basePath.length, path.length);

  if (role !== 'admin' && role !== 'oper' && role !== 'client') {
    next({
      path: '/login/admin'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBoardingPermission;
function createBoardingPermission(_ref) {
  var next = _ref.next,
      router = _ref.router;


  if (!router.app.$store.state.user.attributes.permissions_keys.includes(15)) {
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = evaluateBoardingPermission;
function evaluateBoardingPermission(_ref) {
  var next = _ref.next,
      router = _ref.router;


  if (!router.app.$store.state.user.attributes.permissions_keys.includes(18)) {
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = manageBoardingPermission;
function manageBoardingPermission(_ref) {
  var next = _ref.next,
      router = _ref.router;


  if (!router.app.$store.state.user.attributes.permissions_keys.includes(19)) {
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noAuth;
function noAuth(_ref) {
  var next = _ref.next,
      router = _ref.router;

  if (router.app.$store.state.token !== null) {
    window.console.log('It is already authenticated');
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noClient;
function noClient(_ref) {
  var next = _ref.next,
      router = _ref.router;

  if (router.app.$store.state.user.type === 'Client') {
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noRecieverOperator;
function noRecieverOperator(_ref) {
  var next = _ref.next,
      router = _ref.router;

  if (router.app.$store.state.user.attributes.operator_type === 2) {
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usersDashboardPermission;
function usersDashboardPermission(_ref) {
  var next = _ref.next,
      router = _ref.router;

  console.log("...................................");
  console.log(router.app.$store.state.user.attributes.permissions_keys);

  if (!router.app.$store.state.user.attributes.permissions_keys.includes(14)) {
    next({
      path: '/'
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return citiesService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var citiesService = {
  listAllCity: function listAllCity(indx, callback) {
    var url = "https://backendbutiko.com" + '/api/city/list?type=' + indx;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
      var data = response.data.body.cities_list;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  },
  listDestinationCityToBoardByShipingOperator: function listDestinationCityToBoardByShipingOperator(idOperator, callback) {
    var url = "https://backendbutiko.com" + '/api/city/' + idOperator + '/list-available-to-boarding';

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
      var data = response.data.body.cities_list;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  }
};

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return operatorService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var operatorService = {
  listOperatorsDestination: function listOperatorsDestination(id, callback) {
    var url = "https://backendbutiko.com" + '/api/operator/' + id + '/get-operators-destination';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  },
  listSenderOperators: function listSenderOperators(callback) {
    var url = "https://backendbutiko.com" + '/api/operator/list-senders';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  }
};

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return weightUnitService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var weightUnitService = {
  listAllWeightUnit: function listAllWeightUnit(callback) {
    var url = "https://backendbutiko.com" + '/api/weightUnit/list';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;
      callback(data);
    }).catch(function (errors) {
      console.log(errors);
    });
  }
};

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NOTIFICATIONS: function SET_NOTIFICATIONS(state, notifications) {
    state.userInfo.notifications = notifications;
  }
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{
      id: 1,
      title: 'Support Team',
      body: 'Why not consider this a test message?',
      createdAt: '17 min ago'
    }],
    notifications: [],
    tasks: []
  }
});

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shipmentService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var shipmentService = {
  shipmentBasicCreate: function shipmentBasicCreate(dataObject) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/boarding/basic-creation';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, dataObject).then(function (response) {
                var aux = new Object();
                aux = response.data.body;

                console.log(aux);

                return aux;
              }).catch(function (error) {
                console.log(error);
                console.log(error.response);
                console.log(error.response.status);

                alert('error al enviar formulario');
              });

            case 3:
              res = _context.sent;
              return _context.abrupt('return', res);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  getShipmentDetail: function getShipmentDetail(id, callback) {
    var url = "https://backendbutiko.com" + '/api/boarding/get/' + id;


    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      var data = response.data.body;


      callback(data);
    }).catch(function (error) {
      console.log(error);
      console.log(error.response);
    });
  },
  savePackages: function savePackages(id, dataObject) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var contenido, url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              contenido = dataObject.packages_to_save;


              contenido.forEach(function (pack) {
                if (typeof pack.partial_price === 'undefined') {
                  pack.partial_price = 0;
                } else if (isNaN(pack.partial_price)) {
                  pack.partial_price = 0;
                }
                delete pack['id'];
              });
              console.log("-----------------------TEST- Datos a Guardar-------------------------------------");
              console.log(contenido);
              console.log("------------------------TEST- Datos a Guardar-------------------------------------");

              url = "https://backendbutiko.com" + '/api/boarding/' + id + '/save-packages';
              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, dataObject).then(function (response) {
                console.log('success');
                return response.data.body;
              }).catch(function (error) {
                console.log('fail');
                console.log(error.response);
                console.log(error.response.data);
              });

            case 8:
              res = _context2.sent;
              return _context2.abrupt('return', res);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  changeStateShipment: function changeStateShipment(id, state) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/boarding/update-status/' + id + '?nextStep=' + state;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url).then(function (response) {
                var data = response.data.body;
                return data;
              }).catch(function (error) {
                console.log(error);
                console.log(error.response);
              });

            case 3:
              res = _context3.sent;
              return _context3.abrupt('return', res);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  reprogramationShipmentState: function reprogramationShipmentState(id, dataObject) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/boarding/' + id + '/reschedule';
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, dataObject).then(function (response) {
                var data = response.data.body;
                return true;
              }).catch(function (error) {
                console.log(error);
                console.log(error.response);
                return false;
              });

            case 3:
              res = _context4.sent;
              return _context4.abrupt('return', res);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
};

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 775:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 778:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 779:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 780:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 781:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 782:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 783:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 788:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 789:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 792:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 793:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 797:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notificationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(176);




var notificationService = {
  getCurrentNotifications: function getCurrentNotifications(profileId, callback) {
    var url = "https://backendbutiko.com" + '/api/notifications/' + profileId + '/get-current-notifications';
    console.log(url);
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      if (callback != null) {
        callback(response.data.current_notifications);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('SET_NOTIFICATIONS', response.data.current_notifications);
      }
    }).catch(function (errors) {
      console.log(errors);
      console.log(errors.response);
    });
  },
  getMoreNotifications: function getMoreNotifications(url, callback) {
    console.log('----------------');
    console.log(url);
    console.log("--------");

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      callback(response.data.current_notifications);
    }).catch(function (errors) {
      console.log(errors);
      alert("Error al traer más notificaciones");
    });
  },
  readNotification: function readNotification(notificationID) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/notifications/' + notificationID + '/read';

              console.log(url);

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, {}).then(function (response) {
                if (response.data.status) {
                  var readNotification = response.data;
                  console.log(readNotification);
                  console.log("notification leida 0");

                  return true;
                } else {
                  alert('Error de servicio');
                  return false;
                }
              }).catch(function (errors) {
                console.log(errors);
                console.log(errors.response);
                alert('Error de conexión al servidor');
                return false;
              });

            case 4:
              res = _context.sent;
              return _context.abrupt('return', res);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ordersService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var ordersService = {
    listOrdersByCityAndOperator: function listOrdersByCityAndOperator(senderOperatorId, destinationId, callback) {
        var url = "https://backendbutiko.com" + '/api/purchaseOrder/list-orders-destination/' + senderOperatorId + '?idCity=' + destinationId;
        console.log(url);
        console.log("-------------------------------------------");

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
            console.log(response.data);

            var ordersList = response.data.body;
            callback(ordersList);
        }).catch(function (errors) {
            console.log(errors);
            console.log(errors.response);

            return;
        });
    },
    updateBuyingOrder: function updateBuyingOrder(id, data) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var url, res;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = "https://backendbutiko.com" + '/api/purchaseOrder/update-order-grabr/' + id;

                            console.log(url);
                            console.log(data);
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, data).then(function (response) {
                                if (response.data.status) {
                                    var dataResponse = response.data.body;
                                    return dataResponse;
                                } else {
                                    console.log('Algo raro paso');
                                    alert('no se pudo actualizar los datos');
                                }
                            }).catch(function (error) {
                                console.log(error.response);
                                return;
                            });

                        case 5:
                            res = _context.sent;
                            return _context.abrupt('return', res);

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    authorizeReposition: function authorizeReposition(id, dataObject) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var url, res;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            console.log('Estamos en service');

                            url = "https://backendbutiko.com" + '/api/purchaseOrder/' + id + '/authorize-reposition';

                            console.log(url);

                            _context2.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, dataObject).then(function (response) {
                                console.log('Exito');

                                console.log(response.data);

                                return true;
                            }).catch(function (errors) {
                                console.log('Error');
                                console.log(errors.response.data);

                                return false;
                            });

                        case 5:
                            res = _context2.sent;
                            return _context2.abrupt('return', res);

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    updateBuyingLinioOrder: function updateBuyingLinioOrder(id, data) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var url, res;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            url = "https://backendbutiko.com" + '/api/purchaseOrder/update-order-linio/' + id;

                            console.log(url);
                            console.log(data);
                            _context3.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, data).then(function (response) {
                                if (response.data.status) {
                                    var dataResponse = response.data.body;
                                    return dataResponse;
                                } else {
                                    console.log('Algo raro paso');
                                    alert('no se pudo actualizar los datos');
                                }
                            }).catch(function (error) {
                                console.log(error.response);
                                return;
                            });

                        case 5:
                            res = _context3.sent;
                            return _context3.abrupt('return', res);

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    updateBuyingMeliOrder: function updateBuyingMeliOrder(id, data) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var url, res;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            url = "https://backendbutiko.com" + '/api/purchaseOrder/update-order-meli/' + id;

                            console.log(url);
                            console.log(data);
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, data).then(function (response) {
                                if (response.data.status) {
                                    var dataResponse = response.data.body;
                                    return dataResponse;
                                } else {
                                    console.log('Algo raro paso');
                                    alert('no se pudo actualizar los datos');
                                }
                            }).catch(function (error) {
                                console.log(error.response);
                                return;
                            });

                        case 5:
                            res = _context4.sent;
                            return _context4.abrupt('return', res);

                        case 7:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    updateBuyingOrderNoGrabr: function updateBuyingOrderNoGrabr(id, data) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var url, res;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            url = "https://backendbutiko.com" + '/api/purchaseOrder/update-order-no-grabr/' + id;

                            console.log(url);
                            console.log(data);

                            _context5.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, data).then(function (response) {
                                if (response.data.status) {
                                    var dataResponse = response.data.body;
                                    return dataResponse;
                                } else {
                                    console.log('Algo raro paso');
                                    alert('no se pudo actualizar los datos');
                                }
                            }).catch(function (error) {
                                console.log(error.response);
                                return null;
                            });

                        case 5:
                            res = _context5.sent;
                            return _context5.abrupt('return', res);

                        case 7:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
};

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return packagesService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var packagesService = {
  sendStatesPackage: function sendStatesPackage(id, dataObject) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "https://backendbutiko.com" + '/api/package/' + id + '/evaluate';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, dataObject).then(function (response) {
                var aux = new Object();
                aux = response.data.body;
                return aux;
              }).catch(function (errors) {
                console.log(errors.response.data);
                var errorResponse = errors.response.data;
                if (typeof errorResponse.errors != "undefined") {
                  console.log("error de validacion de campos");
                  if (typeof errorResponse.errors.correct_items_not_wasted != "undefined") {
                    console.log("es un error en el campo 'correct_items_not_waster'");
                    var errorMessage = errorResponse.errors.correct_items_not_wasted[0];
                    console.log(errorMessage);

                    var code = parseInt(errorMessage.substring(0, errorMessage.indexOf('.')));
                    console.log("Codigo: " + code);

                    switch (code) {
                      case 1:
                        alert("Algunos items defectuosos o ausentes ya llegaron a su máxima cantidad de reposiciones, no puede continuar a menos que aumente la cantidad de items correctos.");
                        break;

                      default:
                        alert("Error no identificado para 'correct_items_not_waster'");
                    }
                  }

                  return;
                }
                console.log("es un error de otro tipo");

                return;
              });

            case 3:
              res = _context.sent;
              return _context.abrupt('return', res);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  authorizeReposition: function authorizeReposition(id, dataObject) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('Estamos en service');

              url = "https://backendbutiko.com" + '/api/package/' + id + '/authorize-reposition';

              console.log(url);

              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, dataObject).then(function (response) {
                console.log('Exito');

                console.log(response.data);

                return true;
              }).catch(function (errors) {
                console.log('Error');
                console.log(errors.response.data);

                return false;
              });

            case 5:
              res = _context2.sent;
              return _context2.abrupt('return', res);

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getPackagesByOrderId: function getPackagesByOrderId(orderId, callback) {
    console.log('Estamos en service');

    var url = "https://backendbutiko.com" + '/api/package/' + orderId + '/list-packages-by-order';
    console.log(url);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      console.log('Exito');

      console.log(response.data);
      var retrievedPackages = response.data.body;

      callback(retrievedPackages);
    }).catch(function (errors) {
      console.log('Error');
      console.log(errors.response.data);
    });
  },
  getPackageDetail: function getPackageDetail(packageId, callback) {
    console.log('Estamos en service');

    var url = "https://backendbutiko.com" + '/api/package/' + packageId + '/get';
    console.log(url);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      console.log('Exito');

      console.log(response.data);
      var retrievedPackage = response.data.body;

      callback(retrievedPackage);
    }).catch(function (errors) {
      console.log('Error');
      console.log(errors.response.data);
    });
  },
  getPackageRepositionsDetail: function getPackageRepositionsDetail(packageId, callback) {
    console.log('Estamos en service');

    var url = "https://backendbutiko.com" + '/api/package/' + packageId + '/list-package-repositions';
    console.log(url);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      console.log('Exito');

      console.log(response.data);
      var retreivedPackageRepositions = response.data.body;

      callback(retreivedPackageRepositions);
    }).catch(function (errors) {
      console.log('Error');
      console.log(errors.response.data);
    });
  },
  getPackageRepositionsByDeficitIncidentId: function getPackageRepositionsByDeficitIncidentId(deficitIncidentId, callback) {
    console.log('Estamos en service');

    var url = "https://backendbutiko.com" + '/api/packageIncident/' + deficitIncidentId + '/list-package-repositions-by-deficit-type-id';
    console.log(url);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
      console.log('Exito');

      console.log(response.data);
      var retreivedPackageRepositions = response.data.body;

      callback(retreivedPackageRepositions);
    }).catch(function (errors) {
      console.log('Error');
      console.log(errors.response.data);
    });
  }
};

/***/ })

},[111]);


// WEBPACK FOOTER //
// static/js/app.55b1b740be1efcdfe86f.js